import * as React from 'react';
import React__default, { useContext, useRef, createElement, useState as useState$1, useMemo, useEffect as useEffect$1, forwardRef, createContext } from 'react';
import require$$1$1 from 'react-dom';

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace$1(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime$1 = {exports: {}};

var reactJsxRuntime_production_min$1 = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$5 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

function toObject$1(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative$1() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

shouldUseNative$1() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$1(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$5) {
			symbols = getOwnPropertySymbols$5(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable$1.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$2=React__default,g$3=60103;reactJsxRuntime_production_min$1.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h$2=Symbol.for;g$3=h$2("react.element");reactJsxRuntime_production_min$1.Fragment=h$2("react.fragment");}var m$2=f$2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$2=Object.prototype.hasOwnProperty,p$2={key:!0,ref:!0,__self:!0,__source:!0};
function q$3(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n$2.call(a,b)&&!p$2.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g$3,type:c,key:e,ref:l,props:d,_owner:m$2.current}}reactJsxRuntime_production_min$1.jsx=q$3;reactJsxRuntime_production_min$1.jsxs=q$3;

{
  jsxRuntime$1.exports = reactJsxRuntime_production_min$1;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

function getLocalResources() {
  return {
    ComponentName: "ForgotVifp",
    FieldsLabels: {
      FirstName: "First Name",
      LastName: "Last Name",
      DateOfBirth: "Date of birth",
      DayAriaLabel: "Select your day of birthday",
      MonthAriaLabel: "Select your month of birthday",
      YearAriaLabel: "Select your year of birthday",
      StateOfResidency: "State Of Residency",
      Ship: "Ship Sailed On",
      Day: "Day",
      Month: "Month",
      Year: "Year",
      OrDividerLabel: "OR",
      StateOfResidencyAriaLabel: "Select your state of residency",
      ShipAriaLabel: "Select the ship you sailed on",
      ShipPlaceholder: "Ship Name",
      NamePlaceholder: "Enter your name",
      LastNamePlaceholder: "Enter your Last Name"
    },
    Modal: {
      Heading: "FORGOT YOUR VIFP CLUB NUMBER",
      CloseAriaLabel: "Close Forgot your Vifp Modal"
    },
    Form: {
      Heading: "Please provide the information below so that we may find your VIFP Club Number.",
      Join: "Join VIFP Club to get special offers.",
      Button: "SEARCH",
      CreateAccount: "Create Account"
    },
    Error: {
      UnexpectedError: "We apologize, an unexpected error occurred",
      FirtNameRequired: "Please enter your first name.",
      LastNameRequired: "Please enter your last name.",
      MonthRequired: "Select your Month of birthday",
      DayRequired: "Select your day of birthday",
      YearRequired: "Select your year of birthday",
      DateRequired: "Please select your date of birthday",
      NamePatternInvalid: "Only letters and hyphen allowed",
      MultipleMatches: "Multiple matches found. Help us narrow down your search by providing additional information.",
      NotFound: "Sorry we have not been able to find your VIFP number",
      ShipOrStateOfResidencyRequired: "The state of residency or the ship are required"
    }
  };
}
function getLocalResourcesAU() {
  var resources = getLocalResources();
  return resources;
}

var styledBreakpoints$2 = {};

var styledBreakpoints$1 = {};

const createInvariantWithPrefix$3 =
  (errorPrefix = '[prefix]: ') =>
  (condition, message = 'Invariant failed') => {
    if (!condition) {
      throw new Error(errorPrefix + message);
    }
  };

const memoize$4 = (fn, map = new Map()) => {
  return (...args) => {
    const key = JSON.stringify(args);

    if (!map.has(key)) {
      map.set(key, fn(...args));
    }

    return map.get(key);
  };
};

const get$5 = (o, path, defaultValue) => {
  const [head, ...tail] =
    typeof path === 'string'
      ? path.replace(/\[(\d+)]/g, '.$1').split('.')
      : path;

  if (!o[head]) return defaultValue;

  return !tail.length ? o[head] : get$5(o[head], tail, defaultValue);
};

var library$1 = {
  createInvariantWithPrefix: createInvariantWithPrefix$3,
  memoize: memoize$4,
  get: get$5,
};

const { get: get$4, memoize: memoize$3, createInvariantWithPrefix: createInvariantWithPrefix$2 } = library$1;

var library = {
  get: get$4,
  memoize: memoize$3,
  createInvariantWithPrefix: createInvariantWithPrefix$2,
};

var core = {};

var breakpoints = {};

const { createInvariantWithPrefix: createInvariantWithPrefix$1, memoize: memoize$2 } = library;

const DEFAULT_BREAKPOINTS = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

const ERROR_PREFIX = '[breakpoints]: ';

const defaultOptions$2 = {
  breakpoints: DEFAULT_BREAKPOINTS,
  errorPrefix: ERROR_PREFIX,
};

breakpoints.DEFAULT_BREAKPOINTS = DEFAULT_BREAKPOINTS;
breakpoints.ERROR_PREFIX = ERROR_PREFIX;

breakpoints.createBreakpoints = memoize$2(
  ({ breakpoints, errorPrefix } = defaultOptions$2) => {
    const names = Object.keys(breakpoints);
    const validation = createValidation({
      names,
      breakpoints,
      errorPrefix,
    });

    const getValueByName = memoize$2((name) => {
      validation.checkIsValidName(name);
      validation.checkIsFirstName(name);

      return breakpoints[name];
    });

    const getNextName = (name) => {
      const nextIndex = names.indexOf(name) + 1;

      return names[nextIndex];
    };

    const getNextValueByName = (name) => {
      validation.checkIsValidName(name);
      validation.checkIsLastName(name);

      return breakpoints[getNextName(name)];
    };

    // Maximum breakpoint width. Null for the largest (last) breakpoint.
    // The maximum value is calculated as the minimum of the next one less 0.02px
    // to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
    // See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
    // Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
    // See https://bugs.webkit.org/show_bug.cgi?id=178261
    const calcMaxWidth = memoize$2((name) => {
      const nextValue = getNextValueByName(name);

      return `${parseFloat(nextValue) - 0.02}px`;
    });

    const between = (min, max) => ({
      min: getValueByName(min),
      max: calcMaxWidth(max),
    });

    return {
      up: getValueByName,
      down: calcMaxWidth,
      between,
      only: (name) => between(name, name),
    };
  }
);

function createValidation({ names, breakpoints, errorPrefix }) {
  const invariant = createInvariantWithPrefix$1(errorPrefix);

  return {
    checkIsValidName: (name) => {
      invariant(
        breakpoints[name],
        `breakpoint \`${name}\` not found in ${names.join(', ')}.`
      );
    },
    checkIsFirstName: (name) => {
      const value = breakpoints[name];
      const isNotZero = parseFloat(value) !== 0;

      invariant(
        isNotZero,
        `\`${name}: ${value}\` cannot be assigned as minimum breakpoint.`
      );
    },
    checkIsLastName: (name) => {
      const currentIndex = names.indexOf(name);
      const nextIndex = currentIndex + 1;
      const isNotLast = names.length !== nextIndex;
      const validName = names[names.length - 2];

      invariant(
        isNotLast,
        `\`${name}\` doesn't have a maximum width. Use \`${validName}\`. See https://github.com/mg901/styled-breakpoints/issues/4 .`
      );
    },
  };
}

const { createBreakpoints: createBreakpoints$1 } = breakpoints;

core.createBreakpoints = createBreakpoints$1;

const { get: get$3, createInvariantWithPrefix, memoize: memoize$1 } = library;
const { createBreakpoints } = core;

const defaultOptions$1 = {
  errorPrefix: '[styled-breakpoints]: ',
  pathToMediaQueries: 'breakpoints',
  defaultBreakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
};

styledBreakpoints$1.createStyledBreakpoints = (options = defaultOptions$1) => {
  const invariant = createInvariantWithPrefix(options.errorPrefix);

  const checkAllValuesHasPixels = memoize$1((breakpoints) => {
    const invalidBreakpoints = Object.entries(breakpoints).reduce(
      (acc, [key, value]) => {
        const hasPx = /^\d+px$/;

        if (!hasPx.test(value)) {
          acc += `${key}: ${value}, `;
        }

        return acc;
      },
      ''
    );

    invariant(
      invalidBreakpoints.length === 0,
      `Check your theme. \`${invalidBreakpoints.trimEnd()}\` are invalid breakpoints. Use only pixels.`
    );
  });

  const getMediaQueriesFromTheme = ({ theme = {} }) => {
    const memoizedGet = memoize$1(get$3);

    const memoizedMediaQueries = memoizedGet(
      theme,
      options.pathToMediaQueries,
      options.defaultBreakpoints
    );

    checkAllValuesHasPixels(memoizedMediaQueries);

    return memoizedMediaQueries;
  };

  const withBreakpoints = (fn) => (props) => {
    const mediaQueriesFromTheme = getMediaQueriesFromTheme(props);

    const breakpoints = createBreakpoints({
      breakpoints: mediaQueriesFromTheme,
      errorPrefix: options.errorPrefix,
    });

    return fn(breakpoints);
  };

  const checkIsValidOrientation = (x) => {
    const validOrientations = x === 'portrait' || x === 'landscape';

    invariant(
      validOrientations,
      `\`${x}\` is invalid orientation. Use \`landscape\` or \`portrait\`.`
    );
  };

  const withOrientation = (mediaQuery, orientation) => {
    checkIsValidOrientation(orientation);

    return `${mediaQuery} and (orientation: ${orientation})`;
  };

  const withOrientationOrNot = memoize$1((orientation, result) =>
    orientation ? withOrientation(result, orientation) : result
  );

  const withMinAndMaxMedia = ({ min, max }) =>
    `@media (min-width: ${min}) and (max-width: ${max})`;

  return {
    up: (name, orientation) =>
      withBreakpoints(({ up }) =>
        withOrientationOrNot(orientation, `@media (min-width: ${up(name)})`)
      ),
    down: (name, orientation) =>
      withBreakpoints(({ down }) =>
        withOrientationOrNot(orientation, `@media (max-width: ${down(name)})`)
      ),

    between: (min, max, orientation) =>
      withBreakpoints(({ between }) =>
        withOrientationOrNot(orientation, withMinAndMaxMedia(between(min, max)))
      ),

    only: (name, orientation) =>
      withBreakpoints(({ only }) =>
        withOrientationOrNot(orientation, withMinAndMaxMedia(only(name)))
      ),
  };
};

const { createStyledBreakpoints: createStyledBreakpoints$1 } = styledBreakpoints$1;

styledBreakpoints$2.createStyledBreakpoints = createStyledBreakpoints$1;

const { createStyledBreakpoints } = styledBreakpoints$2;

var styledBreakpoints = createStyledBreakpoints();

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c=b$1?Symbol.for("react.element"):60103,d=b$1?Symbol.for("react.portal"):60106,e=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$2=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$2=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m$1:case e:case g$2:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t:case r:case h$1:return a;default:return u}}case d:return u}}}function A$1(a){return z$1(a)===m$1}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$1;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$1;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g$2;reactIs_production_min.StrictMode=f$1;reactIs_production_min.Suspense=p$1;reactIs_production_min.isAsyncMode=function(a){return A$1(a)||z$1(a)===l};reactIs_production_min.isConcurrentMode=A$1;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h$1};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n$1};reactIs_production_min.isFragment=function(a){return z$1(a)===e};reactIs_production_min.isLazy=function(a){return z$1(a)===t};
reactIs_production_min.isMemo=function(a){return z$1(a)===r};reactIs_production_min.isPortal=function(a){return z$1(a)===d};reactIs_production_min.isProfiler=function(a){return z$1(a)===g$2};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f$1};reactIs_production_min.isSuspense=function(a){return z$1(a)===p$1};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$1||a===g$2||a===f$1||a===p$1||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min.typeOf=z$1;

{
  reactIs$1.exports = reactIs_production_min;
}

//

var shallowequal = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames$4 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$4 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$4(sourceComponent);

    if (getOwnPropertySymbols$4) {
      keys = keys.concat(getOwnPropertySymbols$4(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$4(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function y(){return (y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g$1=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs$1.exports.typeOf(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return "function"==typeof e}function b(e){return e.displayName||e.name||"Component"}function _$1(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.5",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),P={};function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):""))}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return T.set(e,t),x.set(t,e),t},z=function(e){return x.get(e)},B=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e);},M="style["+N+'][data-styled-version="5.3.5"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y=function(){return "undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},q$1=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.5");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q$1(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q$1(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return (K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_$1(n))return !1}return !0}var re=te("5.3.5"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic=(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h;else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f;}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_min(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=React__default.createContext(),ue=ce.Consumer,le=React__default.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return useContext(ce)||de}function fe(){return useContext(le)||he}function me(e){var t=useState$1(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=useMemo((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=useMemo((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return useEffect$1((function(){shallowequal(n,e.stylisPlugins)||s(e.stylisPlugins);}),[e.stylisPlugins]),React__default.createElement(ce.Provider,{value:u},React__default.createElement(le.Provider,{value:l},e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return "-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return "";if(_$1(e))return "."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return _e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g$1(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g$1(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g$1(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return "string"==typeof e&&("production"==="production")}var ke=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];ke(t)&&ke(r)?Be(r,t):e[n]=t;}function Be(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&ze(e,i[a],a);}return e}var Me=React__default.createContext(),Ge=Me.Consumer;function Le(e){var t=useContext(Me),n=useMemo((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return n}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?React__default.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_$1(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.5"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,v=void 0===p?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):p,g=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||h,N=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new oe(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;var m=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Oe(t,useContext(Me),a)||w,t,o),v=m[0],g=m[1],S=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return i}(i,r,v),b=n,_=g.$as||t.$as||g.as||t.as||p,N=xe(_),A=g!==t?y({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,isPropValid,_):!N||isPropValid(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=y({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=b,createElement(_,C)}(C,e,t,P)};return O.displayName=v,(C=React__default.forwardRef(O)).attrs=N,C.componentStyle=I,C.displayName=v,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:N,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Be({},e.defaultProps,t):t;}}),C.toString=function(){return "."+C.styledComponentId},i&&hoistNonReactStatics_cjs(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!reactIs$1.exports.isValidElementType(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e);}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1);}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o);},t.removeStyles=function(e,t){t.clearRules(this.componentId+e);},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r);},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function l(e){var t=pe(),n=fe(),o=useContext(Me),u=useRef(t.allocateGSInstance(a)).current;return t.server&&d(u,e,t,o,n),null}function d(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else {var s=y({},t,{theme:Oe(t,r,l.defaultProps)});u.renderStyles(e,s,n,o);}}return React__default.memo(l)}function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=/^\s*<\/[a-z]/i,Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return "";var n=Y();return "<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.5"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.5",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[React__default.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0;},this.instance=new X({isServer:!0}),this.sealed=!1;}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):React__default.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){if(C)return D(3);if(this.sealed)return D(2);this.seal();var t=require("stream"),n=(t.Readable,t.Transform),r=e,o=this.instance,s=this._emitSheetCSS,i=new n({transform:function(e,t,n){var r=e.toString(),i=s();if(o.clearTag(),Ue.test(r)){var a=r.indexOf(">")+1,c=r.slice(0,a),u=r.slice(a);this.push(c+i+u);}else this.push(i+r);n();}});return r.on("error",(function(e){i.emit("error",e);})),r.pipe(i)},e}(),Xe=function(e){var t=React__default.forwardRef((function(t,n){var o=useContext(Me),i=e.defaultProps,a=Oe(t,o,i);return React__default.createElement(e,y({},t,{theme:a,ref:n}))}));return hoistNonReactStatics_cjs(t,e),t.displayName="WithTheme("+b(e)+")",t},Ze=function(){return useContext(Me)},Ke={StyleSheet:X,masterSheet:de};var styled = qe;

var styledComponents_esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': styled,
	ServerStyleSheet: Je,
	StyleSheetConsumer: ue,
	StyleSheetContext: ce,
	StyleSheetManager: me,
	ThemeConsumer: Ge,
	ThemeContext: Me,
	ThemeProvider: Le,
	__PRIVATE__: Ke,
	createGlobalStyle: $e,
	css: Ae,
	isStyledComponent: _$1,
	keyframes: We,
	useTheme: Ze,
	version: A,
	withTheme: Xe
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace$1(styledComponents_esm);

var useBreakpoint$1 = {};

const { useState, useEffect } = React__default;

useBreakpoint$1.createUseBreakpoint =
  ({ theme: useTheme }) =>
  (breakpoint) => {
    // Get the media query to match
    const query = breakpoint({
      theme: useTheme(),
    }).replace(/^@media\s*/, '');
    const [isBreak, setIsBreak] = useState(null);

    useEffect(() => {
      const mq = window.matchMedia(query);
      const handleChange = (event) => {
        setIsBreak(event.matches);
      };

      setIsBreak(mq.matches);

      // Safari < 14 can't use addEventListener on a MediaQueryList
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#Browser_compatibility
      if (!mq.addEventListener) {
        // Update the state whenever the media query match state changes
        mq.addListener(handleChange);

        // Clean up on unmount and if the query changes
        return () => {
          mq.removeListener(handleChange);
        };
      }
      mq.addEventListener('change', handleChange);

      return () => {
        mq.removeEventListener('change', handleChange);
      };
    }, [query]);

    return isBreak;
  };

const { useTheme } = require$$0;

const { createUseBreakpoint } = useBreakpoint$1;

var useBreakpoint = createUseBreakpoint({ theme: useTheme });

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var require$$1 = propTypes.exports;

var useBreakpoints = function () {
    var isXs = useBreakpoint(styledBreakpoints.down("xs"));
    var isSm = useBreakpoint(styledBreakpoints.only("sm"));
    var isMd = useBreakpoint(styledBreakpoints.only("md"));
    var isLg = useBreakpoint(styledBreakpoints.only("lg"));
    var isXl = useBreakpoint(styledBreakpoints.only("xl"));
    var isXXl = useBreakpoint(styledBreakpoints.up("xxl"));
    var isMobile = useBreakpoint(styledBreakpoints.down("xs"));
    var isTablet = useBreakpoint(styledBreakpoints.between("sm", "md"));
    var isDesktop = useBreakpoint(styledBreakpoints.up("lg"));
    return {
        isXs: isXs,
        isSm: isSm,
        isMd: isMd,
        isLg: isLg,
        isXl: isXl,
        isXXl: isXXl,
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
    };
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ValignTextMiddle = Ae(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
Ae(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansNormalTundora12px = Ae(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #464646;\n"], ["\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #464646;\n"])));
var OpensansNormalTundora14px = Ae(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalSonicSilver14px = Ae(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalWhite18 = Ae(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldTundora16px = Ae(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora12px = Ae(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-20);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-20);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 600;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 600;\n  font-style: normal;\n"])));
Ae(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_16$4 || (templateObject_16$4 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalTundora16px = Ae(templateObject_17$3 || (templateObject_17$3 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldTundora32px = Ae(templateObject_18$3 || (templateObject_18$3 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-32);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-32);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_19$3 || (templateObject_19$3 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-40);\n  font-weight: 700;\n  font-style: normal;\n  line-height: 44px\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-40);\n  font-weight: 700;\n  font-style: normal;\n  line-height: 44px\n"])));
var OpensansBoldTundora14px = Ae(templateObject_20$3 || (templateObject_20$3 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_21$2 || (templateObject_21$2 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
var Border1pxOutlineStructuresoutlineGr = Ae(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject(["\n  border: 1px solid var(--gray);\n"], ["\n  border: 1px solid var(--gray);\n"])));
Ae(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject(["\n  border: 1px solid var(--tory-blue);\n"], ["\n  border: 1px solid var(--tory-blue);\n"])));
var TempostdHeavycondensedNormalToryBlu = Ae(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-20);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-20);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  border: 0.8px solid var(--gray);\n"], ["\n  border: 0.8px solid var(--gray);\n"])));
var Border1pxGray = Ae(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  border: 1px solid var(--gray);\n"], ["\n  border: 1px solid var(--gray);\n"])));
var Border1pxDimGray = Ae(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  border: 1px solid var(--dim-gray);\n"], ["\n  border: 1px solid var(--dim-gray);\n"])));
Ae(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalSonicSilver12px = Ae(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  border: 1px solid var(--black-2);\n"], ["\n  border: 1px solid var(--black-2);\n"])));
Ae(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldToryBlue14px = Ae(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var PlainButtonStyle = Ae(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  cursor: pointer;\n  border: 0;\n  appearance: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  cursor: pointer;\n  border: 0;\n  appearance: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n"])));
Ae(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 600;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 600;\n  font-style: normal;\n"])));
Ae(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  border: 2px solid var(--tory-blue);\n"], ["\n  border: 2px solid var(--tory-blue);\n"])));
Ae(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  border: 2.1px solid var(--tory-blue);\n"], ["\n  border: 2.1px solid var(--tory-blue);\n"])));
Ae(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-24);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-24);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-22);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-22);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
Ae(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldFunBlue14px = Ae(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  color: var(--fun-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--fun-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldCrimson14px = Ae(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansHeavyCrimson12px = Ae(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
Ae(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    box-sizing: content-box;\n    width: 8px;\n    height: 8px;\n    pointer-events: none;\n    content: \" \";\n    border-right: 3px solid var(", ");\n    border-bottom: 3px solid var(", ");\n    transform: ", ";\n    transition: transform .2s ease-in-out;\n"], ["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    box-sizing: content-box;\n    width: 8px;\n    height: 8px;\n    pointer-events: none;\n    content: \" \";\n    border-right: 3px solid var(", ");\n    border-bottom: 3px solid var(", ");\n    transform: ", ";\n    transition: transform .2s ease-in-out;\n"])), function (props) { return props.$hasError ? '--crimson' : '--tory-blue'; }, function (props) { return props.$hasError ? '--crimson' : '--tory-blue'; }, function (props) { return props.$isExpanded ? "rotate(225deg) translateY(-5px) translateX(-3px)" : "rotate(45deg)"; });
var CustomSelect = Ae(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    ", "\n    border: none;\n    display: flex;\n    width: 100%;\n    text-overflow: \"\"; \n    appearance: none;\n    background-color: transparent;\n"], ["\n    ", "\n    border: none;\n    display: flex;\n    width: 100%;\n    text-overflow: \"\"; \n    appearance: none;\n    background-color: transparent;\n"])), OpensansNormalTundora14px);
Ae(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n    box-shadow: 0 0 0 3px var(--bondi-blue); \n"], ["\n    box-shadow: 0 0 0 3px var(--bondi-blue); \n"])));
Ae(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    height: 48px;\n    border-radius: var(--border-radius-s);\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\"; \n    font-size: var(--font-size-14);\n    font-weight: 700;\n    padding: var(--spacing_token_s);\n"], ["\n    ", "\n    width: 100%;\n    height: 48px;\n    border-radius: var(--border-radius-s);\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\"; \n    font-size: var(--font-size-14);\n    font-weight: 700;\n    padding: var(--spacing_token_s);\n"])), Border1pxGray);
var Error$1 = Ae(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  ", "\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n  padding: var(--spacing_token_xxs) 0;\n"], ["\n  ", "\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n  padding: var(--spacing_token_xxs) 0;\n"])), ValignTextMiddle, OpensansHeavyCrimson12px);
var CustomBorderErrorStyle$1 = Ae(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) { return props.$hasError && "\n    border: solid 1px var(--crimson);\n  "; });
var CustomColorErrorStyle$1 = Ae(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) { return props.$hasError && "\n    color: var(--crimson);\n  "; });
var IconContainer = styled.div(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n  min-height: var(--spacing_token_s);\n  min-width: var(--spacing_token_s); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  min-height: var(--spacing_token_s);\n  min-width: var(--spacing_token_s); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$y, templateObject_2$u, templateObject_3$p, templateObject_4$n, templateObject_5$h, templateObject_6$g, templateObject_7$e, templateObject_8$b, templateObject_9$a, templateObject_10$8, templateObject_11$5, templateObject_12$5, templateObject_13$4, templateObject_14$4, templateObject_15$4, templateObject_16$4, templateObject_17$3, templateObject_18$3, templateObject_19$3, templateObject_20$3, templateObject_21$2, templateObject_22$1, templateObject_23$1, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$2) {
			symbols = getOwnPropertySymbols$2(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}

var _path$g;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgChevronCaretsDown = function SvgChevronCaretsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 12.062 1.22 5.989a.75.75 0 0 1 0-1.061l.708-.708a.75.75 0 0 1 1.06-.002l4.835 4.814 4.836-4.814a.75.75 0 0 1 1.06.002l.708.708a.75.75 0 0 1 0 1.06l-6.073 6.074a.75.75 0 0 1-1.061 0Z",
    fill: "#10559A"
  })));
};

styled.button(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  height: 18px;   \n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  ", "\n  padding-right: var(--spacing_token_xxs);\n  ", " { \n    height: 16px;   \n  }\n"], ["\n  height: 18px;   \n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  ", "\n  padding-right: var(--spacing_token_xxs);\n  ", " { \n    height: 16px;   \n  }\n"])), PlainButtonStyle, styledBreakpoints.up("sm"));
styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n    ", "\n    line-height: 18px;\n    letter-spacing: 0;\n    color: ", ";\n    font-size: ", ";\n    \n    ", " {  \n      ", "\n      line-height: 16px;\n      color: ", ";\n  }\n"], ["\n    ", "\n    line-height: 18px;\n    letter-spacing: 0;\n    color: ", ";\n    font-size: ", ";\n    \n    ", " {  \n      ", "\n      line-height: 16px;\n      color: ", ";\n  }\n"])), OpensansBoldTundora14px, function (props) { return props.color; }, function (props) { return props.fontSize; }, styledBreakpoints.up("sm"), OpensansBoldTundora12px, function (props) { return props.color; });
styled.img(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n  src: ", ";\n"], ["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n  src: ", ";\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; }, function (props) { return props.src; });
styled(SvgChevronCaretsDown)(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n"], ["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; });
var templateObject_1$x, templateObject_2$t, templateObject_3$o, templateObject_4$m;

var _path$f;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgCloseModalIcon24 = function SvgCloseModalIcon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "m15.57 12 8.079-8.079a1.198 1.198 0 0 0 0-1.693L21.77.35a1.198 1.198 0 0 0-1.693 0L12 8.43 3.92.351a1.198 1.198 0 0 0-1.693 0L.35 2.228a1.198 1.198 0 0 0 0 1.693L8.43 12 .35 20.079a1.198 1.198 0 0 0 0 1.693l1.878 1.878a1.198 1.198 0 0 0 1.693 0L12 15.57l8.079 8.079a1.198 1.198 0 0 0 1.693 0l1.878-1.877a1.198 1.198 0 0 0 0-1.694L15.57 12Z",
    fill: "#10559A"
  })));
};

var HeadingWrapper$3 = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  height : fit-content;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  height : fit-content;\n"])));
var Heading = styled.h1(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  font-family: ", ";\n  color:  ", ";\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  font-size: var(--font-size-24);\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {    \n    font-size: ", "; \n    line-height: 38px;\n  }\n\n"], ["\n  font-family: ", ";\n  color:  ", ";\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  font-size: var(--font-size-24);\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {    \n    font-size: ", "; \n    line-height: 38px;\n  }\n\n"])), function (props) { return props.$isDefault ? 'var(--font-family-tempo_std-heavycondensed)' : 'var(--font-family-open_sans)'; }, function (props) { return props.$isDefault ? 'var(--tory-blue)' : 'var(--tundora)'; }, styledBreakpoints.up('sm'), function (props) { return props.$isDefault ? 'var(--font-size-34)' : 'var(--font-size-24)'; });
var CloseIcon$1 = styled.img(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n"], ["\n  min-width: 16px;\n  height: 16px;\n"])));
var CloseButton$4 = styled.button(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n  display: flex;\n  ", " \n"], ["\n  display: flex;\n  ", " \n"])), PlainButtonStyle);
var ContentWrapper$4 = styled.div(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DefaultCloseModalIcon$1 = styled(SvgCloseModalIcon24)(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n\n  ", " {\n      width: 24px;\n      height: 24px;\n  }"], ["\n  width: 16px;\n  height: 16px;\n\n  ", " {\n      width: 24px;\n      height: 24px;\n  }"])), styledBreakpoints.up("sm"));
var ContentContainer$3 = styled.div(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1$w, templateObject_2$s, templateObject_3$n, templateObject_4$l, templateObject_5$g, templateObject_6$f, templateObject_7$d;

var lib = {exports: {}};

var Modal$2 = {};

var ModalPortal = {exports: {}};

var focusManager = {};

var tabbable = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];
}(tabbable, tabbable.exports));

Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault$4(_tabbable);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$4() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log$4() {
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var scopeTab = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
}(scopeTab, scopeTab.exports));

var ariaAppHider$1 = {};

var warning = function() {};

var warning_1 = warning;

var safeHTMLElement = {};

var exenv = {exports: {}};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
}(exenv));

Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = undefined;

var _exenv = exenv.exports;

var _exenv2 = _interopRequireDefault$3(_exenv);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

safeHTMLElement.canUseDOM = EE.canUseDOM;

safeHTMLElement.default = SafeHTMLElement;

Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = warning_1;

var _warning2 = _interopRequireDefault$2(_warning);

var _safeHTMLElement$1 = safeHTMLElement;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log$3() {
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var classList = {};

Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log$2() {
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

var portalOpenInstances$1 = {};

Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck$1(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

portalOpenInstances$1.default = portalOpenInstances;

var bodyTrap$1 = {};

Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault$1(_portalOpenInstances);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _propTypes = require$$1;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = focusManager;

var focusManager$1 = _interopRequireWildcard(_focusManager);

var _scopeTab = scopeTab.exports;

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = classList;

var classList$1 = _interopRequireWildcard(_classList);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
}(ModalPortal, ModalPortal.exports));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    polyfill: polyfill
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

Object.defineProperty(Modal$2, "__esModule", {
  value: true
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = undefined;

var _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _reactDom = require$$1$1;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require$$1;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = ModalPortal.exports;

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = require$$6;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = Modal$2.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal$1 = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$f({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$f({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal$1.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal$1);

Modal$2.default = Modal$1;

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = Modal$2;

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
}(lib, lib.exports));

var Modal = /*@__PURE__*/getDefaultExportFromCjs(lib.exports);

function handleNetworkError$1() {
    const error = { code: 'NetworkError', message: 'There is a network issue and your request could not be processed.' };
    throw error;
}
function isJSONResponse$1(response) {
    if (!response) {
        return false;
    }
    return response.headers.has('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1;
}
function handleResponseStatus$1(response) {
    const isJSON = isJSONResponse$1(response);
    if (response.ok) {
        return isJSON ? response.json() : response.text();
    }
    if (isJSON) {
        return response.json().then((apiError) => {
            throw apiError;
        });
    }
    const error = { code: 'ServerError', message: 'We couldn\'t process your request. Please try again or call us at 1.800.764.7419.', response: response };
    throw error;
}
function cclFetch$1(input, init) {
    const credentials = 'include';
    const initWithCredentials = Object.assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError$1)
        .then((response) => handleResponseStatus$1(response));
}

// Brought from https://github.com/js-cookie/js-cookie
// and modified to play nice with typescript and webpack
function set$1(key, value, attributes) {
    if (typeof document === 'undefined' || !key || !value) {
        return undefined;
    }
    attributes = Object.assign({ path: '/' }, attributes);
    if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(new Date().getTime() + attributes.expires * 864e+5);
    }
    // We're using "expires" because "max-age" is not supported by IE
    attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
    try {
        const result = JSON.stringify(value);
        if (/^[\{\[]/.test(result)) {
            value = result;
        }
        // tslint:disable-next-line:no-empty
    }
    catch (e) { }
    value =
        encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
    key = encodeURIComponent(String(key))
        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
        .replace(/[\(\)]/g, escape);
    let stringifiedAttributes = '';
    for (const attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += '; ' + attributeName;
        if (attributes[attributeName] === true) {
            continue;
        }
        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return (document.cookie = key + '=' + value + stringifiedAttributes);
}
function get$1(key) {
    return getHelper(key, false /* read as raw */);
}
function getJSON(key) {
    return getHelper(key, true /* read as json */);
}
function remove(key, attributes) {
    let value = CookieService.get(key);
    CookieService.set(key, value ? value : '_', Object.assign({}, attributes, { expires: -1 }));
}
function decode(s) {
    return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}
function getHelper(key, json) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    const jar = {};
    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    let i = 0;
    for (; i < cookies.length; i++) {
        const parts = cookies[i].split('=');
        let cookie = parts.slice(1).join('=');
        if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
        }
        try {
            const name = decode(parts[0]);
            cookie = decode(cookie);
            if (json) {
                try {
                    cookie = JSON.parse(cookie);
                    // tslint:disable-next-line:no-empty
                }
                catch (e) { }
            }
            jar[name] = cookie;
            if (key === name) {
                break;
            }
            // tslint:disable-next-line:no-empty
        }
        catch (e) { }
    }
    return key ? jar[key] : jar;
}
/**
 * Returns the domain to be used when handling cookies.
 * @param {string} host - optional, will use window.location.host by default.
 * @returns {string} The domain to be used when handling cookies.
 */
function getCookieDomain(host) {
    if (!host) {
        host = window.location.host;
    }
    const parts = host.split('.');
    if (parts.length <= 2) {
        return host;
    }
    return parts.splice(1).join('.');
}
const CookieService = {
    set: set$1,
    get: get$1,
    getJSON,
    remove,
    getCookieDomain
};

const isSupported = checkBrowserSupport$1();
function get$2(key) {
    if (hasError(key)) {
        return null;
    }
    try {
        let result = window.localStorage.getItem(key);
        return result !== null ? JSON.parse(result) : null;
    }
    catch (e) {
        return null;
    }
}
function set$2(key, value) {
    if (hasError(key) || !value) {
        return false;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
}
function hasError(key) {
    return !isSupported || !key;
}
function checkBrowserSupport$1() {
    let supported;
    try {
        supported = window.localStorage !== null;
        if (supported) {
            const key = '__testbrowsersupport';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
        }
        return supported;
    }
    catch (e) {
        supported = false;
    }
    return supported;
}
const LocalStorageService = {
    get: get$2,
    set: set$2,
    isSupported
};

let locality;
let currencies;
var LocalityEnum$1;
(function (LocalityEnum) {
    LocalityEnum["US"] = "1";
    LocalityEnum["UK"] = "3";
    LocalityEnum["AU"] = "7";
})(LocalityEnum$1 || (LocalityEnum$1 = {}));
var CurrencySourceEnum$1;
(function (CurrencySourceEnum) {
    CurrencySourceEnum["URL"] = "Url";
    CurrencySourceEnum["LOCAL_STORAGE"] = "LocalStorage";
    CurrencySourceEnum["COOKIE"] = "Cookie";
    CurrencySourceEnum["SERVER"] = "Server";
})(CurrencySourceEnum$1 || (CurrencySourceEnum$1 = {}));
const CURRENCY_KEY = 'SelectedCurrency';
const LOCALITY_KEY = 'SelectedLocality';
function initialize(data) {
    if (!data) {
        return;
    }
    locality = data.locality;
    currencies = data.currencies;
}
function getLocality() {
    return getLocalityFromUrl() || getLocalityFromLocalStorage() || getLocalityFromInitialData();
}
function setLocality(locality) {
    if (!locality) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(LOCALITY_KEY, locality);
    }
    else {
        CookieService.set(LOCALITY_KEY, locality, {
            path: '/'
        });
    }
}
function getLocalityFromInitialData() {
    if (!locality) {
        return null;
    }
    setLocality(locality);
    return getEnumLocalityValue(locality);
}
function getLocalityFromUrl() {
    const urlLocality = getUrlParameter('locality');
    if (!urlLocality) {
        return null;
    }
    return getEnumLocalityValue(urlLocality);
}
function getLocalityFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const storedLocality = LocalStorageService.get(LOCALITY_KEY);
    if (!storedLocality) {
        return null;
    }
    return getEnumLocalityValue(storedLocality);
}
function getEnumLocalityValue(locality) {
    for (let idx in LocalityEnum$1) {
        if (LocalityEnum$1[idx] == locality) {
            return LocalityEnum$1[idx];
        }
    }
    return null;
}
function getCurrency() {
    return getCurrencyFromUrl() || getCurrencyFromLocalStorage() || getCurrencyFromCookie() || getCurrencyFromInitialData();
}
function setCurrency(currencyCode) {
    if (!currencyCode) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(CURRENCY_KEY, currencyCode);
    }
    else {
        CookieService.set(CURRENCY_KEY, currencyCode, {
            path: '/'
        });
    }
}
function getCurrencyFromUrl() {
    const urlCurrency = getUrlParameter('currency');
    if (!urlCurrency) {
        return null;
    }
    const currencyCode = currencies.find(currency => currency.toLowerCase() === urlCurrency.toLowerCase());
    if (!currencyCode) {
        return null;
    }
    setCurrency(currencyCode);
    return {
        code: currencyCode,
        source: CurrencySourceEnum$1.URL
    };
}
function getCurrencyFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const currencyCode = LocalStorageService.get(CURRENCY_KEY);
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum$1.LOCAL_STORAGE
    };
}
function getCurrencyFromCookie() {
    const currencyCode = CookieService.getJSON(CURRENCY_KEY) || null;
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum$1.COOKIE
    };
}
function getCurrencyFromInitialData() {
    if (!currencies || !currencies.length) {
        return null;
    }
    const currencyCode = currencies[0];
    setCurrency(currencyCode);
    return {
        code: currencies[0],
        source: CurrencySourceEnum$1.SERVER
    };
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
const LocalityService = {
    initialize,
    getLocality,
    setLocality,
    getCurrency,
    setCurrency,
    LocalityEnum: LocalityEnum$1
};

String.format = function (s, ...args) {
    if (!s) {
        return '';
    }
    return s.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};

function fetchApi(input, init) {
    var proxy = 'false';
    var token = '';
    var cypress = 'false';
    if (typeof process !== 'undefined') {
        if (process !== undefined && process !== null) {
            proxy = process.env.REACT_APP_PROXY_TO_UAT;
            token = process.env.REACT_APP_UAT_TOKEN_PARAM;
            cypress = process.env.REACT_APP_CYPRESS;
        }
    }
    if (proxy === 'true' && typeof input === 'string' && !cypress) {
        if (input.indexOf('?') > -1) {
            input += "&".concat(token);
        }
        else {
            input += "/?".concat(token);
        }
    }
    return cclFetch$1(input, init);
}

function loadJS(src, cb) {
    var ref = document.getElementsByTagName("script")[0];
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    if (ref.parentNode) {
        ref.parentNode.insertBefore(script, ref);
        if (cb && typeof cb === "function") {
            script.onload = cb;
        }
        return script;
    }
}
function initAndOpenLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    if (window["LoginRegisterApp"]) {
        openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
    }
    else {
        loadJS("/profilemanagement/cclr-login-register-app/static/js/main.js", function () {
            loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
        });
    }
}
function loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    if (window["LoginRegisterApp"]) {
        openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
    }
    else {
        setTimeout(function () {
            loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
        }, 500);
    }
}
function openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    var _a;
    var defaultAppElement = (_a = document.getElementById("__next")) !== null && _a !== void 0 ? _a : document.getElementById("root");
    var options = {
        mode: "modal",
        initialRoute: route,
        mainContent: appElement !== null && appElement !== void 0 ? appElement : defaultAppElement,
        onLogin: fnCallBack !== null && fnCallBack !== void 0 ? fnCallBack : ssoOnLogin,
        enrollMethod: "",
        onAfterClose: onAfterClose,
        onAfterOpen: onAfterOpen
    };
    window["LoginRegisterApp"].open(options);
}
function ssoOnLogin(token, hasBookings) {
    window.location.reload();
}

var BASE_API_URL$1 = '/profilemanagement/api/v1.0';
var API_URLS$1 = {
    States: "".concat(BASE_API_URL$1, "/states/states"),
    GetProfile: "".concat(BASE_API_URL$1, "/Profiles"),
    TERMS_AND_CONDITIONS_API: '/tnc-api/api/tncshopping/merchandising',
};

var profileApiResponseMock = {
    "title": '',
    "username": "maria_90@hotmail.com",
    "sex": "M",
    "dateOfBirth": new Date("1992-05-09T04:00:00Z"),
    "emailPreference": "OUT",
    "email": "maria_90@hotmail.com",
    "lastName": "Rodriguez",
    "middleName": '',
    "firstName": "Maria",
    "personNumber": 999999009966224,
    "loyaltyNumber": 9012459651,
    "yearFirstSailed": 0,
    "sendToMail": true,
    "sendToEmail": false,
    "totalCruisesSinceFirstSailed": 3,
    "tier": {
        "activationDate": "2020-05-07T00:00:00Z",
        "adjustedDayPoints": 0,
        "totalCruiseDays": 0,
        "totalEarnedCruiseDays": 0,
        "totalVifpPoints": 0,
        "cruiseDaysToNextTier": 1,
        "tierCode": "00",
        "tierTitle": "BLUE"
    },
    "household": {
        "address1": '',
        "address2": '',
        "city": '',
        "stateCode": '',
        "countryCode": "CA",
        "zipCode": ''
    },
    "phone": {
        "type": "DAY",
        "countryCode": "1",
        "areaCode": "123",
        "number": "4567890",
        "ext": ''
    },
    "bookings": [],
    "nextTier": {
        "tierCode": "01",
        "tierName": "RED"
    }
};

function getProfileApiResponseMock(isUserAuthenticated) {
    return new Promise(function (resolve, reject) {
        if (isUserAuthenticated) {
            resolve(profileApiResponseMock);
        }
        else {
            reject({
                status: 401,
                message: 'Unauthorized'
            });
        }
    });
}

var CCL_USER_COOKIE_NAME = "cclUser";
var CCL_SESSION_COOKIE_NAME = "cclSession";
function getCclUserFromCookie() {
    return CookieService.getJSON(CCL_USER_COOKIE_NAME);
}
function isUserAuthenticated() {
    var cclSession = CookieService.getJSON(CCL_SESSION_COOKIE_NAME);
    return !!cclSession && cclSession.IsAuthenticated;
}
function getProfile(shouldFetchRemote) {
    var opts = {
        method: 'GET',
        headers: new Headers({ 'Accept': 'application/json', 'Content-Type': 'application/json' })
    };
    var shouldMockCall = shouldFetchRemote === undefined || shouldFetchRemote === null ?
        typeof process !== "undefined" &&
            process !== undefined &&
            process !== null &&
            process.env.REACT_APP_CYPRESS :
        !shouldFetchRemote();
    return shouldMockCall ?
        getProfileApiResponseMock(isUserAuthenticated()) : cclFetch$1(API_URLS$1.GetProfile, opts).then(function (res) { return res; });
}
var ProfileService = {
    isUserAuthenticated: isUserAuthenticated,
    getCclUserFromCookie: getCclUserFromCookie,
    getProfile: getProfile
};

var sugarCore$1 = {exports: {}};

/*
 *  Sugar v2.0.6
 *
 *  Freely distributable and licensed under the MIT-style license.
 *  Copyright (c) Andrew Plummer
 *  https://sugarjs.com/
 *
 * ---------------------------- */

(function (module) {
(function() {

  /***
   * @module Core
   * @description Core functionality including the ability to define methods and
   *              extend onto natives.
   *
   ***/

  // The global to export.
  var Sugar;

  // The name of Sugar in the global namespace.
  var SUGAR_GLOBAL = 'Sugar';

  // Natives available on initialization. Letting Object go first to ensure its
  // global is set by the time the rest are checking for chainable Object methods.
  var NATIVE_NAMES = 'Object Number String Array Date RegExp Function';

  // Static method flag
  var STATIC   = 0x1;

  // Instance method flag
  var INSTANCE = 0x2;

  // IE8 has a broken defineProperty but no defineProperties so this saves a try/catch.
  var PROPERTY_DESCRIPTOR_SUPPORT = !!(Object.defineProperty && Object.defineProperties);

  var globalContext = getGlobal();

  // Whether object instance methods can be mapped to the prototype.
  var allowObjectPrototype = false;

  // A map from Array to SugarArray.
  var namespacesByName = {};

  // A map from [object Object] to namespace.
  var namespacesByClassString = {};

  // Defining properties.
  // istanbul ignore next
  var defineProperty = PROPERTY_DESCRIPTOR_SUPPORT ?  Object.defineProperty : definePropertyShim;

  // A default chainable class for unknown types.
  var DefaultChainable = getNewChainableClass('Chainable');


  // Global methods

  function getGlobal() {
    // Get global context by keyword here to avoid issues with libraries
    // that can potentially alter this script's context object.
    return testGlobal(typeof commonjsGlobal !== 'undefined' && commonjsGlobal) ||
           testGlobal(typeof window !== 'undefined' && window);
  }

  function testGlobal(obj) {
    // Note that Rhino uses a different "global" keyword so perform an
    // extra check here to ensure that it's actually the global object.
    return obj && obj.Object === Object ? obj : null;
  }

  function setupGlobal() {
    Sugar = globalContext[SUGAR_GLOBAL];
    // istanbul ignore if
    if (Sugar) {
      // Reuse already defined Sugar global object.
      return;
    }
    Sugar = function(arg) {
      forEachProperty(Sugar, function(sugarNamespace, name) {
        // Although only the only enumerable properties on the global
        // object are Sugar namespaces, environments that can't set
        // non-enumerable properties will step through the utility methods
        // as well here, so use this check to only allow true namespaces.
        if (hasOwn(namespacesByName, name)) {
          sugarNamespace.extend(arg);
        }
      });
      return Sugar;
    };
    // istanbul ignore else
    if (module.exports) {
      // Node or webpack environment
      module.exports = Sugar;
    } else {
      // Unwrapped browser environment
      try {
        globalContext[SUGAR_GLOBAL] = Sugar;
      } catch (e) {
        // Contexts such as QML have a read-only global context.
      }
    }
    forEachProperty(NATIVE_NAMES.split(' '), function(name) {
      createNamespace(name);
    });
    setGlobalProperties();
  }

  /***
   * @method createNamespace(name)
   * @returns SugarNamespace
   * @namespace Sugar
   * @short Creates a new Sugar namespace.
   * @extra This method is for plugin developers who want to define methods to be
   *        used with natives that Sugar does not handle by default. The new
   *        namespace will appear on the `Sugar` global with all the methods of
   *        normal namespaces, including the ability to define new methods. When
   *        extended, any defined methods will be mapped to `name` in the global
   *        context.
   *
   * @example
   *
   *   Sugar.createNamespace('Boolean');
   *
   * @param {string} name - The namespace name.
   *
   ***/
  function createNamespace(name) {

    // Is the current namespace Object?
    var isObject = name === 'Object';

    // A Sugar namespace is also a chainable class: Sugar.Array, etc.
    var sugarNamespace = getNewChainableClass(name);

    /***
     * @method extend([opts])
     * @returns Sugar
     * @namespace Sugar
     * @short Extends Sugar defined methods onto natives.
     * @extra This method can be called on individual namespaces like
     *        `Sugar.Array` or on the `Sugar` global itself, in which case
     *        [opts] will be forwarded to each `extend` call. For more,
     *        see `extending`.
     *
     * @options
     *
     *   methods           An array of method names to explicitly extend.
     *
     *   except            An array of method names or global namespaces (`Array`,
     *                     `String`) to explicitly exclude. Namespaces should be the
     *                     actual global objects, not strings.
     *
     *   namespaces        An array of global namespaces (`Array`, `String`) to
     *                     explicitly extend. Namespaces should be the actual
     *                     global objects, not strings.
     *
     *   enhance           A shortcut to disallow all "enhance" flags at once
     *                     (flags listed below). For more, see `enhanced methods`.
     *                     Default is `true`.
     *
     *   enhanceString     A boolean allowing String enhancements. Default is `true`.
     *
     *   enhanceArray      A boolean allowing Array enhancements. Default is `true`.
     *
     *   objectPrototype   A boolean allowing Sugar to extend Object.prototype
     *                     with instance methods. This option is off by default
     *                     and should generally not be used except with caution.
     *                     For more, see `object methods`.
     *
     * @example
     *
     *   Sugar.Array.extend();
     *   Sugar.extend();
     *
     * @option {Array<string>} [methods]
     * @option {Array<string|NativeConstructor>} [except]
     * @option {Array<NativeConstructor>} [namespaces]
     * @option {boolean} [enhance]
     * @option {boolean} [enhanceString]
     * @option {boolean} [enhanceArray]
     * @option {boolean} [objectPrototype]
     * @param {ExtendOptions} [opts]
     *
     ***
     * @method extend([opts])
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Extends Sugar defined methods for a specific namespace onto natives.
     * @param {ExtendOptions} [opts]
     *
     ***/
    var extend = function (opts) {

      var nativeClass = globalContext[name], nativeProto = nativeClass.prototype;
      var staticMethods = {}, instanceMethods = {}, methodsByName;

      function objectRestricted(name, target) {
        return isObject && target === nativeProto &&
               (!allowObjectPrototype || name === 'get' || name === 'set');
      }

      function arrayOptionExists(field, val) {
        var arr = opts[field];
        if (arr) {
          for (var i = 0, el; el = arr[i]; i++) {
            if (el === val) {
              return true;
            }
          }
        }
        return false;
      }

      function arrayOptionExcludes(field, val) {
        return opts[field] && !arrayOptionExists(field, val);
      }

      function disallowedByFlags(methodName, target, flags) {
        // Disallowing methods by flag currently only applies if methods already
        // exist to avoid enhancing native methods, as aliases should still be
        // extended (i.e. Array#all should still be extended even if Array#every
        // is being disallowed by a flag).
        if (!target[methodName] || !flags) {
          return false;
        }
        for (var i = 0; i < flags.length; i++) {
          if (opts[flags[i]] === false) {
            return true;
          }
        }
      }

      function namespaceIsExcepted() {
        return arrayOptionExists('except', nativeClass) ||
               arrayOptionExcludes('namespaces', nativeClass);
      }

      function methodIsExcepted(methodName) {
        return arrayOptionExists('except', methodName);
      }

      function canExtend(methodName, method, target) {
        return !objectRestricted(methodName, target) &&
               !disallowedByFlags(methodName, target, method.flags) &&
               !methodIsExcepted(methodName);
      }

      opts = opts || {};
      methodsByName = opts.methods;

      if (namespaceIsExcepted()) {
        return;
      } else if (isObject && typeof opts.objectPrototype === 'boolean') {
        // Store "objectPrototype" flag for future reference.
        allowObjectPrototype = opts.objectPrototype;
      }

      forEachProperty(methodsByName || sugarNamespace, function(method, methodName) {
        if (methodsByName) {
          // If we have method names passed in an array,
          // then we need to flip the key and value here
          // and find the method in the Sugar namespace.
          methodName = method;
          method = sugarNamespace[methodName];
        }
        if (hasOwn(method, 'instance') && canExtend(methodName, method, nativeProto)) {
          instanceMethods[methodName] = method.instance;
        }
        if(hasOwn(method, 'static') && canExtend(methodName, method, nativeClass)) {
          staticMethods[methodName] = method;
        }
      });

      // Accessing the extend target each time instead of holding a reference as
      // it may have been overwritten (for example Date by Sinon). Also need to
      // access through the global to allow extension of user-defined namespaces.
      extendNative(nativeClass, staticMethods);
      extendNative(nativeProto, instanceMethods);

      if (!methodsByName) {
        // If there are no method names passed, then
        // all methods in the namespace will be extended
        // to the native. This includes all future defined
        // methods, so add a flag here to check later.
        setProperty(sugarNamespace, 'active', true);
      }
      return sugarNamespace;
    };

    function defineWithOptionCollect(methodName, instance, args) {
      setProperty(sugarNamespace, methodName, function(arg1, arg2, arg3) {
        var opts = collectDefineOptions(arg1, arg2, arg3);
        defineMethods(sugarNamespace, opts.methods, instance, args, opts.last);
        return sugarNamespace;
      });
    }

    /***
     * @method defineStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods on the namespace that can later be extended
     *        onto the native globals.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. If `extend` was previously called
     *        with no arguments, the method will be immediately mapped to its
     *        native when defined.
     *
     * @example
     *
     *   Sugar.Number.defineStatic({
     *     isOdd: function (num) {
     *       return num % 2 === 1;
     *     }
     *   });
     *
     * @signature defineStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStatic', STATIC);

    /***
     * @method defineInstance(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines methods on the namespace that can later be extended as
     *        instance methods onto the native prototype.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. All functions should accept the
     *        native for which they are mapped as their first argument, and should
     *        never refer to `this`. If `extend` was previously called with no
     *        arguments, the method will be immediately mapped to its native when
     *        defined.
     *
     *        Methods cannot accept more than 4 arguments in addition to the
     *        native (5 arguments total). Any additional arguments will not be
     *        mapped. If the method needs to accept unlimited arguments, use
     *        `defineInstanceWithArguments`. Otherwise if more options are
     *        required, use an options object instead.
     *
     * @example
     *
     *   Sugar.Number.defineInstance({
     *     square: function (num) {
     *       return num * num;
     *     }
     *   });
     *
     * @signature defineInstance(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstance', INSTANCE);

    /***
     * @method defineInstanceAndStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short A shortcut to define both static and instance methods on the namespace.
     * @extra This method is intended for use with `Object` instance methods. Sugar
     *        will not map any methods to `Object.prototype` by default, so defining
     *        instance methods as static helps facilitate their proper use.
     *
     * @example
     *
     *   Sugar.Object.defineInstanceAndStatic({
     *     isAwesome: function (obj) {
     *       // check if obj is awesome!
     *     }
     *   });
     *
     * @signature defineInstanceAndStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceAndStatic', INSTANCE | STATIC);


    /***
     * @method defineStaticWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that collect arguments.
     * @extra This method is identical to `defineStatic`, except that when defined
     *        methods are called, they will collect any arguments past `n - 1`,
     *        where `n` is the number of arguments that the method accepts.
     *        Collected arguments will be passed to the method in an array
     *        as the last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineStaticWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineStaticWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStaticWithArguments', STATIC, true);

    /***
     * @method defineInstanceWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that collect arguments.
     * @extra This method is identical to `defineInstance`, except that when
     *        defined methods are called, they will collect any arguments past
     *        `n - 1`, where `n` is the number of arguments that the method
     *        accepts. Collected arguments will be passed to the method as the
     *        last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineInstanceWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineInstanceWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceWithArguments', INSTANCE, true);

    /***
     * @method defineStaticPolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that are mapped onto the native if they do
     *        not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. Note that polyfill methods will
     *        be immediately mapped onto their native prototype regardless of the
     *        use of `extend`.
     *
     * @example
     *
     *   Sugar.Object.defineStaticPolyfill({
     *     keys: function (obj) {
     *       // get keys!
     *     }
     *   });
     *
     * @signature defineStaticPolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineStaticPolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name], opts.methods, true, opts.last);
      return sugarNamespace;
    });

    /***
     * @method defineInstancePolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that are mapped onto the native prototype
     *        if they do not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. This method differs from
     *        `defineInstance` as there is no static signature (as the method
     *        is mapped as-is to the native), so it should refer to its `this`
     *        object. Note that polyfill methods will be immediately mapped onto
     *        their native prototype regardless of the use of `extend`.
     *
     * @example
     *
     *   Sugar.Array.defineInstancePolyfill({
     *     indexOf: function (arr, el) {
     *       // index finding code here!
     *     }
     *   });
     *
     * @signature defineInstancePolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineInstancePolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name].prototype, opts.methods, true, opts.last);
      // Map instance polyfills to chainable as well.
      forEachProperty(opts.methods, function(fn, methodName) {
        defineChainableMethod(sugarNamespace, methodName, fn);
      });
      return sugarNamespace;
    });

    /***
     * @method alias(toName, from)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Aliases one Sugar method to another.
     *
     * @example
     *
     *   Sugar.Array.alias('all', 'every');
     *
     * @signature alias(toName, fn)
     * @param {string} toName - Name for new method.
     * @param {string|Function} from - Method to alias, or string shortcut.
     ***/
    setProperty(sugarNamespace, 'alias', function(name, source) {
      var method = typeof source === 'string' ? sugarNamespace[source] : source;
      setMethod(sugarNamespace, name, method);
      return sugarNamespace;
    });

    // Each namespace can extend only itself through its .extend method.
    setProperty(sugarNamespace, 'extend', extend);

    // Cache the class to namespace relationship for later use.
    namespacesByName[name] = sugarNamespace;
    namespacesByClassString['[object ' + name + ']'] = sugarNamespace;

    mapNativeToChainable(name);
    mapObjectChainablesToNamespace(sugarNamespace);


    // Export
    return Sugar[name] = sugarNamespace;
  }

  function setGlobalProperties() {
    setProperty(Sugar, 'VERSION', '2.0.6');
    setProperty(Sugar, 'extend', Sugar);
    setProperty(Sugar, 'toString', toString);
    setProperty(Sugar, 'createNamespace', createNamespace);

    setProperty(Sugar, 'util', {
      'hasOwn': hasOwn,
      'getOwn': getOwn,
      'setProperty': setProperty,
      'classToString': classToString,
      'defineProperty': defineProperty,
      'forEachProperty': forEachProperty,
      'mapNativeToChainable': mapNativeToChainable
    });
  }

  function toString() {
    return SUGAR_GLOBAL;
  }


  // Defining Methods

  function defineMethods(sugarNamespace, methods, type, args, flags) {
    forEachProperty(methods, function(method, methodName) {
      var instanceMethod, staticMethod = method;
      if (args) {
        staticMethod = wrapMethodWithArguments(method);
      }
      if (flags) {
        staticMethod.flags = flags;
      }

      // A method may define its own custom implementation, so
      // make sure that's not the case before creating one.
      if (type & INSTANCE && !method.instance) {
        instanceMethod = wrapInstanceMethod(method, args);
        setProperty(staticMethod, 'instance', instanceMethod);
      }

      if (type & STATIC) {
        setProperty(staticMethod, 'static', true);
      }

      setMethod(sugarNamespace, methodName, staticMethod);

      if (sugarNamespace.active) {
        // If the namespace has been activated (.extend has been called),
        // then map this method as well.
        sugarNamespace.extend(methodName);
      }
    });
  }

  function collectDefineOptions(arg1, arg2, arg3) {
    var methods, last;
    if (typeof arg1 === 'string') {
      methods = {};
      methods[arg1] = arg2;
      last = arg3;
    } else {
      methods = arg1;
      last = arg2;
    }
    return {
      last: last,
      methods: methods
    };
  }

  function wrapInstanceMethod(fn, args) {
    return args ? wrapMethodWithArguments(fn, true) : wrapInstanceMethodFixed(fn);
  }

  function wrapMethodWithArguments(fn, instance) {
    // Functions accepting enumerated arguments will always have "args" as the
    // last argument, so subtract one from the function length to get the point
    // at which to start collecting arguments. If this is an instance method on
    // a prototype, then "this" will be pushed into the arguments array so start
    // collecting 1 argument earlier.
    var startCollect = fn.length - 1 - (instance ? 1 : 0);
    return function() {
      var args = [], collectedArgs = [], len;
      if (instance) {
        args.push(this);
      }
      len = Math.max(arguments.length, startCollect);
      // Optimized: no leaking arguments
      for (var i = 0; i < len; i++) {
        if (i < startCollect) {
          args.push(arguments[i]);
        } else {
          collectedArgs.push(arguments[i]);
        }
      }
      args.push(collectedArgs);
      return fn.apply(this, args);
    };
  }

  function wrapInstanceMethodFixed(fn) {
    switch(fn.length) {
      // Wrapped instance methods will always be passed the instance
      // as the first argument, but requiring the argument to be defined
      // may cause confusion here, so return the same wrapped function regardless.
      case 0:
      case 1:
        return function() {
          return fn(this);
        };
      case 2:
        return function(a) {
          return fn(this, a);
        };
      case 3:
        return function(a, b) {
          return fn(this, a, b);
        };
      case 4:
        return function(a, b, c) {
          return fn(this, a, b, c);
        };
      case 5:
        return function(a, b, c, d) {
          return fn(this, a, b, c, d);
        };
    }
  }

  // Method helpers

  function extendNative(target, source, polyfill, override) {
    forEachProperty(source, function(method, name) {
      if (polyfill && !override && target[name]) {
        // Method exists, so bail.
        return;
      }
      setProperty(target, name, method);
    });
  }

  function setMethod(sugarNamespace, methodName, method) {
    sugarNamespace[methodName] = method;
    if (method.instance) {
      defineChainableMethod(sugarNamespace, methodName, method.instance);
    }
  }


  // Chainables

  function getNewChainableClass(name) {
    var fn = function SugarChainable(obj, arg) {
      if (!(this instanceof fn)) {
        return new fn(obj, arg);
      }
      if (this.constructor !== fn) {
        // Allow modules to define their own constructors.
        obj = this.constructor.apply(obj, arguments);
      }
      this.raw = obj;
    };
    setProperty(fn, 'toString', function() {
      return SUGAR_GLOBAL + name;
    });
    setProperty(fn.prototype, 'valueOf', function() {
      return this.raw;
    });
    return fn;
  }

  function defineChainableMethod(sugarNamespace, methodName, fn) {
    var wrapped = wrapWithChainableResult(fn), existing, collision, dcp;
    dcp = DefaultChainable.prototype;
    existing = dcp[methodName];

    // If the method was previously defined on the default chainable, then a
    // collision exists, so set the method to a disambiguation function that will
    // lazily evaluate the object and find it's associated chainable. An extra
    // check is required to avoid false positives from Object inherited methods.
    collision = existing && existing !== Object.prototype[methodName];

    // The disambiguation function is only required once.
    if (!existing || !existing.disambiguate) {
      dcp[methodName] = collision ? disambiguateMethod(methodName) : wrapped;
    }

    // The target chainable always receives the wrapped method. Additionally,
    // if the target chainable is Sugar.Object, then map the wrapped method
    // to all other namespaces as well if they do not define their own method
    // of the same name. This way, a Sugar.Number will have methods like
    // isEqual that can be called on any object without having to traverse up
    // the prototype chain and perform disambiguation, which costs cycles.
    // Note that the "if" block below actually does nothing on init as Object
    // goes first and no other namespaces exist yet. However it needs to be
    // here as Object instance methods defined later also need to be mapped
    // back onto existing namespaces.
    sugarNamespace.prototype[methodName] = wrapped;
    if (sugarNamespace === Sugar.Object) {
      mapObjectChainableToAllNamespaces(methodName, wrapped);
    }
  }

  function mapObjectChainablesToNamespace(sugarNamespace) {
    forEachProperty(Sugar.Object && Sugar.Object.prototype, function(val, methodName) {
      if (typeof val === 'function') {
        setObjectChainableOnNamespace(sugarNamespace, methodName, val);
      }
    });
  }

  function mapObjectChainableToAllNamespaces(methodName, fn) {
    forEachProperty(namespacesByName, function(sugarNamespace) {
      setObjectChainableOnNamespace(sugarNamespace, methodName, fn);
    });
  }

  function setObjectChainableOnNamespace(sugarNamespace, methodName, fn) {
    var proto = sugarNamespace.prototype;
    if (!hasOwn(proto, methodName)) {
      proto[methodName] = fn;
    }
  }

  function wrapWithChainableResult(fn) {
    return function() {
      return new DefaultChainable(fn.apply(this.raw, arguments));
    };
  }

  function disambiguateMethod(methodName) {
    var fn = function() {
      var raw = this.raw, sugarNamespace;
      if (raw != null) {
        // Find the Sugar namespace for this unknown.
        sugarNamespace = namespacesByClassString[classToString(raw)];
      }
      if (!sugarNamespace) {
        // If no sugarNamespace can be resolved, then default
        // back to Sugar.Object so that undefined and other
        // non-supported types can still have basic object
        // methods called on them, such as type checks.
        sugarNamespace = Sugar.Object;
      }

      return new sugarNamespace(raw)[methodName].apply(this, arguments);
    };
    fn.disambiguate = true;
    return fn;
  }

  function mapNativeToChainable(name, methodNames) {
    var sugarNamespace = namespacesByName[name],
        nativeProto = globalContext[name].prototype;

    if (!methodNames && ownPropertyNames) {
      methodNames = ownPropertyNames(nativeProto);
    }

    forEachProperty(methodNames, function(methodName) {
      if (nativeMethodProhibited(methodName)) {
        // Sugar chainables have their own constructors as well as "valueOf"
        // methods, so exclude them here. The __proto__ argument should be trapped
        // by the function check below, however simply accessing this property on
        // Object.prototype causes QML to segfault, so pre-emptively excluding it.
        return;
      }
      try {
        var fn = nativeProto[methodName];
        if (typeof fn !== 'function') {
          // Bail on anything not a function.
          return;
        }
      } catch (e) {
        // Function.prototype has properties that
        // will throw errors when accessed.
        return;
      }
      defineChainableMethod(sugarNamespace, methodName, fn);
    });
  }

  function nativeMethodProhibited(methodName) {
    return methodName === 'constructor' ||
           methodName === 'valueOf' ||
           methodName === '__proto__';
  }


  // Util

  // Internal references
  var ownPropertyNames = Object.getOwnPropertyNames,
      internalToString = Object.prototype.toString,
      internalHasOwnProperty = Object.prototype.hasOwnProperty;

  // Defining this as a variable here as the ES5 module
  // overwrites it to patch DONTENUM.
  var forEachProperty = function (obj, fn) {
    for(var key in obj) {
      if (!hasOwn(obj, key)) continue;
      if (fn.call(obj, obj[key], key, obj) === false) break;
    }
  };

  // istanbul ignore next
  function definePropertyShim(obj, prop, descriptor) {
    obj[prop] = descriptor.value;
  }

  function setProperty(target, name, value, enumerable) {
    defineProperty(target, name, {
      value: value,
      enumerable: !!enumerable,
      configurable: true,
      writable: true
    });
  }

  // PERF: Attempts to speed this method up get very Heisenbergy. Quickly
  // returning based on typeof works for primitives, but slows down object
  // types. Even === checks on null and undefined (no typeof) will end up
  // basically breaking even. This seems to be as fast as it can go.
  function classToString(obj) {
    return internalToString.call(obj);
  }

  function hasOwn(obj, prop) {
    return !!obj && internalHasOwnProperty.call(obj, prop);
  }

  function getOwn(obj, prop) {
    if (hasOwn(obj, prop)) {
      return obj[prop];
    }
  }

  setupGlobal();

  // For type checking, etc. Excludes object as this is more nuanced.
  var NATIVE_TYPES = 'Boolean Number String Date RegExp Function Array Error Set Map';

  // Do strings have no keys?
  var NO_KEYS_IN_STRING_OBJECTS = !('0' in Object('a'));

  // WhiteSpace/LineTerminator as defined in ES5.1 plus Unicode characters in the Space, Separator category.
  var TRIM_CHARS = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

  // Common chars
  var HALF_WIDTH_ZERO = 0x30,
      FULL_WIDTH_ZERO = 0xff10,
      HALF_WIDTH_PERIOD   = '.',
      FULL_WIDTH_PERIOD   = '．',
      HALF_WIDTH_COMMA    = ',';

  // Namespace aliases
  var sugarObject   = Sugar.Object,
      sugarArray    = Sugar.Array,
      sugarDate     = Sugar.Date,
      sugarString   = Sugar.String;
      Sugar.Number;
      var sugarFunction = Sugar.Function;
      Sugar.RegExp;

  // Class checks
  var isString,
      isFunction,
      isArray;

  function buildClassChecks() {

    function addCoreTypes() {

      var names = spaceSplit(NATIVE_TYPES);

      buildPrimitiveClassCheck(names[0]);
      buildPrimitiveClassCheck(names[1]);
      isString  = buildPrimitiveClassCheck(names[2]);

      buildClassCheck(names[3]);
      buildClassCheck(names[4]);

      // Wanted to enhance performance here by using simply "typeof"
      // but Firefox has two major issues that make this impossible,
      // one fixed, the other not, so perform a full class check here.
      //
      // 1. Regexes can be typeof "function" in FF < 3
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
      //
      // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
      isFunction = buildClassCheck(names[5]);

      // istanbul ignore next
      isArray = Array.isArray || buildClassCheck(names[6]);
      buildClassCheck(names[7]);

      buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
      buildClassCheck(names[9], typeof Map !== 'undefined' && Map);
      addKnownType(names[0]);
      addKnownType(names[1]);
      addKnownType(names[2]);
      addKnownType(names[3]);
      addKnownType(names[4]);
      addKnownType(names[6]);

    }

    function addArrayTypes() {
      var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
      forEach(spaceSplit(types), function(str) {
      });
    }

    function addKnownType(className) {
    }

    function buildClassCheck(className, globalObject) {
      // istanbul ignore if
      if (globalObject && isClass(new globalObject, 'Object')) {
        return getConstructorClassCheck(globalObject);
      } else {
        return getToStringClassCheck(className);
      }
    }

    // Map and Set may be [object Object] in certain IE environments.
    // In this case we need to perform a check using the constructor
    // instead of Object.prototype.toString.
    // istanbul ignore next
    function getConstructorClassCheck(obj) {
      var ctorStr = String(obj);
      return function(obj) {
        return String(obj.constructor) === ctorStr;
      };
    }

    function getToStringClassCheck(className) {
      return function(obj, str) {
        // perf: Returning up front on instanceof appears to be slower.
        return isClass(obj, className, str);
      };
    }

    function buildPrimitiveClassCheck(className) {
      var type = className.toLowerCase();
      return function(obj) {
        var t = typeof obj;
        return t === type || t === 'object' && isClass(obj, className);
      };
    }

    addCoreTypes();
    addArrayTypes();

  }

  function isClass(obj, className, str) {
    if (!str) {
      str = classToString(obj);
    }
    return str === '[object '+ className +']';
  }

  // Wrapping the core's "define" methods to
  // save a few bytes in the minified script.
  function wrapNamespace(method) {
    return function(sugarNamespace, arg1, arg2) {
      sugarNamespace[method](arg1, arg2);
    };
  }

  // Method define aliases
  var defineStaticPolyfill        = wrapNamespace('defineStaticPolyfill'),
      defineInstancePolyfill      = wrapNamespace('defineInstancePolyfill');

  function assertCallable(obj) {
    if (!isFunction(obj)) {
      throw new TypeError('Function is not callable');
    }
  }


  // General helpers

  function isDefined(o) {
    return o !== undefined;
  }

  function isPrimitive(obj, type) {
    type = type || typeof obj;
    return obj == null || type === 'string' || type === 'number' || type === 'boolean';
  }

  // Make primtives types like strings into objects.
  function coercePrimitiveToObject(obj) {
    if (isPrimitive(obj)) {
      obj = Object(obj);
    }
    // istanbul ignore next
    if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) {
      forceStringCoercion(obj);
    }
    return obj;
  }

  // Force strings to have their indexes set in
  // environments that don't do this automatically.
  // istanbul ignore next
  function forceStringCoercion(obj) {
    var i = 0, chr;
    while (chr = obj.charAt(i)) {
      obj[i++] = chr;
    }
  }


  // Array helpers

  function isArrayIndex(n) {
    return n >>> 0 == n && n != 0xFFFFFFFF;
  }

  function iterateOverSparseArray(arr, fn, fromIndex, loop) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
    for (var i = 0, len = indexes.length; i < len; i++) {
      index = indexes[i];
      fn.call(arr, arr[index], index, arr);
    }
    return arr;
  }

  // It's unclear whether or not sparse arrays qualify as "simple enumerables".
  // If they are not, however, the wrapping function will be deoptimized, so
  // isolate here (also to share between es5 and array modules).
  function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
    var indexes = [], i;
    for (i in arr) {
      // istanbul ignore next
      if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
        indexes.push(+i);
      }
    }
    indexes.sort(function(a, b) {
      var aLoop = a > fromIndex;
      var bLoop = b > fromIndex;
      // This block cannot be reached unless ES5 methods are being shimmed.
      // istanbul ignore if
      if (aLoop !== bLoop) {
        return aLoop ? -1 : 1;
      }
      return a - b;
    });
    return indexes;
  }

  function spaceSplit(str) {
    return str.split(' ');
  }

  function forEach(arr, fn) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (!(i in arr)) {
        return iterateOverSparseArray(arr, fn, i);
      }
      fn(arr[i], i);
    }
  }

  // Number helpers

  // istanbul ignore next
  var trunc = Math.trunc || function(n) {
    if (n === 0 || !isFinite(n)) return n;
    return n < 0 ? ceil(n) : floor(n);
  };

  function padNumber(num, place, sign, base, replacement) {
    var str = abs(num).toString(base || 10);
    str = repeatString(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
    if (sign || num < 0) {
      str = (num < 0 ? '-' : '+') + str;
    }
    return str;
  }

  // Fullwidth number helpers
  var fullWidthNumberMap;

  function buildFullWidthNumber() {
    var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA;
    fullWidthNumberMap = {};
    for (var i = 0, digit; i <= 9; i++) {
      digit = chr(i + FULL_WIDTH_ZERO);
      fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
    }
    fullWidthNumberMap[hwc] = '';
    fullWidthNumberMap[fwp] = hwp;
    // Mapping this to itself to capture it easily
    // in stringToNumber to detect decimals later.
    fullWidthNumberMap[hwp] = hwp;
  }

  // Math aliases
  var abs   = Math.abs,
      ceil  = Math.ceil,
      floor = Math.floor;


  // String helpers

  var chr = String.fromCharCode;

  function repeatString(str, num) {
    var result = '';
    str = str.toString();
    while (num > 0) {
      if (num & 1) {
        result += str;
      }
      if (num >>= 1) {
        str += str;
      }
    }
    return result;
  }

  buildClassChecks();
  buildFullWidthNumber();

  /***
   * @module ES5
   * @description Functions and polyfill methods that fix ES5 functionality. This
   *              module is excluded from default builds, and can be included if
   *              you need legacy browser support (IE8 and below).
   *
   ***/

  // Non-enumerable properties on Object.prototype. In early JScript implementations
  // (< IE9) these will shadow object properties and break for..in loops.
  var DONT_ENUM_PROPS = [
    'valueOf',
    'toString',
    'constructor',
    'isPrototypeOf',
    'hasOwnProperty',
    'toLocaleString',
    'propertyIsEnumerable'
  ];

  /***
   * @fix
   * @short Fixes DontEnum bug for iteration methods in < IE9.
   ***/
  function buildDontEnumFix() {
    if (!({toString:1}).propertyIsEnumerable('toString')) {
      var forEachEnumerableProperty = forEachProperty;
      forEachProperty = function(obj, fn) {
        forEachEnumerableProperty(obj, fn);
        for (var i = 0, key; key = DONT_ENUM_PROPS[i]; i++) {
          if (hasOwn(obj, key)) {
            if(fn.call(obj, obj[key], key, obj) === false) break;
          }
        }
      };
    }
  }

  /***
   * @fix
   * @short Adds native methods to chainables in < IE9.
   ***/
  function buildChainableNativeMethodsFix() {
    if (!Object.getOwnPropertyNames) {
      defineNativeMethodsOnChainable();
    }
  }

  // Polyfilled methods will automatically be added to the chainable prototype.
  // However, Object.getOwnPropertyNames cannot be shimmed for non-enumerable
  // properties, so if it does not exist, then the only way to access native
  // methods previous to ES5 is to provide them as a list of tokens here.
  function defineNativeMethodsOnChainable() {

    var nativeTokens = {
      'Function': 'apply,call',
      'RegExp':   'compile,exec,test',
      'Number':   'toExponential,toFixed,toLocaleString,toPrecision',
      'Object':   'hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString',
      'Array':    'concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift',
      'Date':     'getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString',
      'String':   'anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase'
    };

    var dateTokens = 'FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds'.split(',');

    function addDateTokens(prefix, arr) {
      for (var i = 0; i < dateTokens.length; i++) {
        arr.push(prefix + dateTokens[i]);
      }
    }

    forEachProperty(nativeTokens, function(str, name) {
      var tokens = str.split(',');
      if (name === 'Date') {
        addDateTokens('get', tokens);
        addDateTokens('set', tokens);
        addDateTokens('getUTC', tokens);
        addDateTokens('setUTC', tokens);
      }
      tokens.push('toString');
      mapNativeToChainable(name, tokens);
    });

  }


  buildDontEnumFix();
  buildChainableNativeMethodsFix();


  /*** @namespace Object ***/

  function assertNonNull(obj) {
    if (obj == null) {
      throw new TypeError('Object required');
    }
  }

  defineStaticPolyfill(sugarObject, {

    'keys': function(obj) {
      var keys = [];
      assertNonNull(obj);
      forEachProperty(coercePrimitiveToObject(obj), function(val, key) {
        keys.push(key);
      });
      return keys;
    }

  });


  /*** @namespace Array ***/

  function arrayIndexOf(arr, search, fromIndex, fromRight) {
    var length = arr.length, defaultFromIndex, index, increment;

    increment = fromRight ? -1 : 1;
    defaultFromIndex = fromRight ? length - 1 : 0;
    fromIndex = trunc(fromIndex);
    if (!fromIndex && fromIndex !== 0) {
      fromIndex = defaultFromIndex;
    }
    if (fromIndex < 0) {
      fromIndex = length + fromIndex;
    }
    if ((!fromRight && fromIndex < 0) || (fromRight && fromIndex >= length)) {
      fromIndex = defaultFromIndex;
    }

    index = fromIndex;

    while((fromRight && index >= 0) || (!fromRight && index < length)) {
      if (!(index in arr)) {
        return sparseIndexOf(arr, search, fromIndex, fromRight);
      }
      if (isArrayIndex(index) && arr[index] === search) {
        return index;
      }
      index += increment;
    }
    return -1;
  }

  function sparseIndexOf(arr, search, fromIndex, fromRight) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, false, fromRight), index;
    indexes.sort(function(a, b) {
      return fromRight ? b - a : a - b;
    });
    while ((index = indexes.shift()) !== undefined) {
      if (arr[index] === search) {
        return +index;
      }
    }
    return -1;
  }

  function arrayReduce(arr, fn, initialValue, fromRight) {
    var length = arr.length, count = 0, defined = isDefined(initialValue), result, index;
    assertCallable(fn);
    if (length == 0 && !defined) {
      throw new TypeError('Reduce called on empty array with no initial value');
    } else if (defined) {
      result = initialValue;
    } else {
      result = arr[fromRight ? length - 1 : count];
      count++;
    }
    while(count < length) {
      index = fromRight ? length - count - 1 : count;
      if (index in arr) {
        result = fn(result, arr[index], index, arr);
      }
      count++;
    }
    return result;
  }

  defineStaticPolyfill(sugarArray, {

    /***
     *
     * @method isArray(obj)
     * @returns Boolean
     * @polyfill ES5
     * @static
     * @short Returns true if `obj` is an Array.
     *
     * @example
     *
     *   Array.isArray(3)        -> false
     *   Array.isArray(true)     -> false
     *   Array.isArray('wasabi') -> false
     *   Array.isArray([1,2,3])  -> true
     *
     ***/
    'isArray': function(obj) {
      return isArray(obj);
    }

  });

  defineInstancePolyfill(sugarArray, {

    'every': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && !fn.call(context, this[index], index, this)) {
          return false;
        }
        index++;
      }
      return true;
    },

    'some': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          return true;
        }
        index++;
      }
      return false;
    },

    'map': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = new Array(length);
      assertCallable(fn);
      while(index < length) {
        if (index in this) {
          result[index] = fn.call(context, this[index], index, this);
        }
        index++;
      }
      return result;
    },

    'filter': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = [];
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          result.push(this[index]);
        }
        index++;
      }
      return result;
    },

    /***
     * @method indexOf(search, [fromIndex] = 0)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array and returns the first index where `search` occurs,
     *        or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This
     *        method performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *        For such functionality, use the `findIndex` method instead.
     *
     * @example
     *
     *   [1,2,3].indexOf(3) -> 1
     *   [1,2,3].indexOf(7) -> -1
     *
     ***/
    'indexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.indexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex);
    },

    /***
     * @method lastIndexOf(search, [fromIndex] = array.length - 1)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array from the end and returns the first index where
     *        `search` occurs, or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This method
     *        performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *
     * @example
     *
     *   [1,2,1].lastIndexOf(1) -> 2
     *   [1,2,1].lastIndexOf(7) -> -1
     *
     ***/
    'lastIndexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.lastIndexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex, true);
    },

    /***
     * @method forEach([eachFn], [context])
     * @polyfill ES5
     * @short Iterates over the array, calling [eachFn] on each loop.
     * @extra [context] becomes the `this` object.
     *
     * @callback eachFn
     *
     *   el   The element of the current iteration.
     *   i    The index of the current iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   ['a','b','c'].forEach(function(a) {
     *     // Called 3 times: 'a','b','c'
     *   });
     *
     ***/
    'forEach': function(eachFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(eachFn);
      while(index < length) {
        if (index in this) {
          eachFn.call(context, this[index], index, this);
        }
        index++;
      }
    },

    /***
     * @method reduce(reduceFn, [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Reduces the array to a single result.
     * @extra This operation is sometimes called "accumulation", as it takes the
     *        result of the last iteration of `reduceFn` and passes it as the first
     *        argument to the next iteration, "accumulating" that value as it goes.
     *        The return value of this method will be the return value of the final
     *        iteration of `reduceFn`. If [init] is passed, it will be the initial
     *        "accumulator" (the first argument). If [init] is not passed, then it
     *        will take the first element in the array, and `reduceFn` will not be
     *        called for that element.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator". Either [init], the result of the last iteration
     *        of `reduceFn`, or the first element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 1 - 2 - 3
     *   });
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 100 - 1 - 2 - 3
     *   }, 100);
     *
     ***/
    'reduce': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context);
    },

    /***
     * @method reduceRight([reduceFn], [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Similar to `Array#reduce`, but operates on the elements in reverse.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator", either [init], the result of the last iteration
     *        of `reduceFn`, or the last element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 3 - 2 - 1
     *   });
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 100 - 3 - 2 - 1
     *   }, 100);
     *
     *
     ***/
    'reduceRight': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context, true);
    }

  });


  /*** @namespace String ***/

  var TRIM_REG = RegExp('^[' + TRIM_CHARS + ']+|['+ TRIM_CHARS +']+$', 'g');

  defineInstancePolyfill(sugarString, {
    /***
     * @method trim()
     * @returns String
     * @polyfill ES5
     * @short Removes leading and trailing whitespace from the string.
     * @extra Whitespace is defined as line breaks, tabs, and any character in the
     *        "Space, Separator" Unicode category, conforming to the the ES5 spec.
     *
     * @example
     *
     *   '   wasabi   '.trim()      -> 'wasabi'
     *   '   wasabi   '.trimLeft()  -> 'wasabi   '
     *   '   wasabi   '.trimRight() -> '   wasabi'
     *
     ***/
    'trim': function() {
      return this.toString().replace(TRIM_REG, '');
    }
  });


  /*** @namespace Function ***/

  defineInstancePolyfill(sugarFunction, {

     /***
     * @method bind(context, [arg1], ...)
     * @returns Function
     * @polyfill ES5
     * @short Binds `context` as the `this` object for the function when it is
     *        called. Also allows currying an unlimited number of parameters.
     * @extra "currying" means setting parameters ([arg1], [arg2], etc.) ahead of
     *        time so that they are passed when the function is called later. If
     *        you pass additional parameters when the function is actually called,
     *        they will be added to the end of the curried parameters.
     *
     * @example
     *
     *   logThis.bind('woof')()   -> logs 'woof' as its this object
     *   addArgs.bind(1, 2, 3)()  -> returns 5 with 1 as the this object
     *   addArgs.bind(1)(2, 3, 4) -> returns 9
     *
     ***/
    'bind': function(context) {
      // Optimized: no leaking arguments
      var boundArgs = []; for(var $i = 1, $len = arguments.length; $i < $len; $i++) boundArgs.push(arguments[$i]);
      var fn = this, bound;
      assertCallable(this);
      bound = function() {
        // Optimized: no leaking arguments
        var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
        return fn.apply(fn.prototype && this instanceof fn ? this : context, boundArgs.concat(args));
      };
      bound.prototype = this.prototype;
      return bound;
    }

  });


  /*** @namespace Date ***/

  defineStaticPolyfill(sugarDate, {

     /***
     * @method now()
     * @returns String
     * @polyfill ES5
     * @static
     * @short Returns the current time as a Unix timestamp.
     * @extra The number of milliseconds since January 1st, 1970 00:00:00 (UTC).
     *
     * @example
     *
     *   Date.now() -> ex. 1311938296231
     *
     ***/
    'now': function() {
      return new Date().getTime();
    }

  });

  function hasISOSupport() {
    var d = new Date(Date.UTC(2000, 0));
    return !!d.toISOString && d.toISOString() === '2000-01-01T00:00:00.000Z';
  }

  defineInstancePolyfill(sugarDate, {

     /***
     * @method toISOString()
     * @returns String
     * @polyfill ES5
     * @short Formats the string to ISO8601 format.
     * @extra This will always format as UTC time.
     *
     * @example
     *
     *   Date.create().toISOString() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toISOString': function() {
      return padNumber(this.getUTCFullYear(), 4) + '-' +
             padNumber(this.getUTCMonth() + 1, 2) + '-' +
             padNumber(this.getUTCDate(), 2) + 'T' +
             padNumber(this.getUTCHours(), 2) + ':' +
             padNumber(this.getUTCMinutes(), 2) + ':' +
             padNumber(this.getUTCSeconds(), 2) + '.' +
             padNumber(this.getUTCMilliseconds(), 3) + 'Z';
    },

     /***
     * @method toJSON([key])
     * @returns String
     * @polyfill ES5
     * @short Returns a JSON representation of the date.
     * @extra This is effectively an alias for `toISOString`. Will always return
     *        the date in UTC time. [key] is ignored.
     *
     * @example
     *
     *   Date.create().toJSON() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toJSON': function(key) {
      return this.toISOString(key);
    }

  }, !hasISOSupport());

}).call(commonjsGlobal);
}(sugarCore$1));

function isArrayIndex$2$1(n) {
  return n >>> 0 == n && n != 0xFFFFFFFF;
}

var isArrayIndex_1$1 = isArrayIndex$2$1;

var isArrayIndex$1$1 = isArrayIndex_1$1;

function getSparseArrayIndexes$1$1(arr, fromIndex, loop, fromRight) {
  var indexes = [], i;
  for (i in arr) {
    // istanbul ignore next
    if (isArrayIndex$1$1(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
      indexes.push(+i);
    }
  }
  indexes.sort(function(a, b) {
    var aLoop = a > fromIndex;
    var bLoop = b > fromIndex;
    // This block cannot be reached unless ES5 methods are being shimmed.
    // istanbul ignore if
    if (aLoop !== bLoop) {
      return aLoop ? -1 : 1;
    }
    return a - b;
  });
  return indexes;
}

var getSparseArrayIndexes_1$1 = getSparseArrayIndexes$1$1;

var getSparseArrayIndexes$2 = getSparseArrayIndexes_1$1;

function iterateOverSparseArray$1$1(arr, fn, fromIndex, loop) {
  var indexes = getSparseArrayIndexes$2(arr, fromIndex, loop), index;
  for (var i = 0, len = indexes.length; i < len; i++) {
    index = indexes[i];
    fn.call(arr, arr[index], index, arr);
  }
  return arr;
}

var iterateOverSparseArray_1$1 = iterateOverSparseArray$1$1;

var iterateOverSparseArray$2 = iterateOverSparseArray_1$1;

function forEach$j$1(arr, fn) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (!(i in arr)) {
      return iterateOverSparseArray$2(arr, fn, i);
    }
    fn(arr[i], i);
  }
}

var forEach_1$1 = forEach$j$1;

var NATIVE_TYPES$2$1 = 'Boolean Number String Date RegExp Function Array Error Set Map';

var Sugar$6b$1 = sugarCore$1.exports;

var coreUtilityAliases$M$1 = {
  hasOwn: Sugar$6b$1.util.hasOwn,
  getOwn: Sugar$6b$1.util.getOwn,
  setProperty: Sugar$6b$1.util.setProperty,
  classToString: Sugar$6b$1.util.classToString,
  defineProperty: Sugar$6b$1.util.defineProperty,
  forEachProperty: Sugar$6b$1.util.forEachProperty,
  mapNativeToChainable: Sugar$6b$1.util.mapNativeToChainable
};

var coreUtilityAliases$L$1 = coreUtilityAliases$M$1;

var classToString$5$1 = coreUtilityAliases$L$1.classToString;

function isClass$2$1(obj, className, str) {
  if (!str) {
    str = classToString$5$1(obj);
  }
  return str === '[object '+ className +']';
}

var isClass_1$1 = isClass$2$1;

function spaceSplit$6$1(str) {
  return str.split(' ');
}

var spaceSplit_1$1 = spaceSplit$6$1;

function isObjectType$e$1(obj, type) {
  return !!obj && (type || typeof obj) === 'object';
}

var isObjectType_1$1 = isObjectType$e$1;

var coreUtilityAliases$K$1 = coreUtilityAliases$M$1;

var hasOwn$c$1 = coreUtilityAliases$K$1.hasOwn;

function hasOwnEnumeratedProperties$1$1(obj) {
  // Plain objects are generally defined as having enumerated properties
  // all their own, however in early IE environments without defineProperty,
  // there may also be enumerated methods in the prototype chain, so check
  // for both of these cases.
  var objectProto = Object.prototype;
  for (var key in obj) {
    var val = obj[key];
    if (!hasOwn$c$1(obj, key) && val !== objectProto[key]) {
      return false;
    }
  }
  return true;
}

var hasOwnEnumeratedProperties_1$1 = hasOwnEnumeratedProperties$1$1;

var coreUtilityAliases$J$1 = coreUtilityAliases$M$1;

var hasOwn$b$1 = coreUtilityAliases$J$1.hasOwn;

function hasValidPlainObjectPrototype$1$1(obj) {
  var hasToString = 'toString' in obj;
  var hasConstructor = 'constructor' in obj;
  // An object created with Object.create(null) has no methods in the
  // prototype chain, so check if any are missing. The additional hasToString
  // check is for false positives on some host objects in old IE which have
  // toString but no constructor. If the object has an inherited constructor,
  // then check if it is Object (the "isPrototypeOf" tapdance here is a more
  // robust way of ensuring this if the global has been hijacked). Note that
  // accessing the constructor directly (without "in" or "hasOwnProperty")
  // will throw a permissions error in IE8 on cross-domain windows.
  return (!hasConstructor && !hasToString) ||
          (hasConstructor && !hasOwn$b$1(obj, 'constructor') &&
           hasOwn$b$1(obj.constructor.prototype, 'isPrototypeOf'));
}

var hasValidPlainObjectPrototype_1$1 = hasValidPlainObjectPrototype$1$1;

var isClass$1$1 = isClass_1$1,
    isObjectType$d$1 = isObjectType_1$1,
    hasOwnEnumeratedProperties$2 = hasOwnEnumeratedProperties_1$1,
    hasValidPlainObjectPrototype$2 = hasValidPlainObjectPrototype_1$1;

function isPlainObject$4$1(obj, className) {
  return isObjectType$d$1(obj) &&
         isClass$1$1(obj, 'Object', className) &&
         hasValidPlainObjectPrototype$2(obj) &&
         hasOwnEnumeratedProperties$2(obj);
}

var isPlainObject_1$1 = isPlainObject$4$1;

var NATIVE_TYPES$1$1 = NATIVE_TYPES$2$1,
    forEach$i$1 = forEach_1$1,
    isClass$3 = isClass_1$1,
    spaceSplit$5$1 = spaceSplit_1$1,
    isPlainObject$3$1 = isPlainObject_1$1;

var isSerializable$2$1,
    isBoolean$5$1, isNumber$d$1, isString$k$1,
    isDate$a$1, isRegExp$7$1, isFunction$d$1,
    isArray$f$1, isSet$2$1, isMap$2$1, isError$2$1;

function buildClassChecks$1() {

  var knownTypes = {};

  function addCoreTypes() {

    var names = spaceSplit$5$1(NATIVE_TYPES$1$1);

    isBoolean$5$1 = buildPrimitiveClassCheck(names[0]);
    isNumber$d$1  = buildPrimitiveClassCheck(names[1]);
    isString$k$1  = buildPrimitiveClassCheck(names[2]);

    isDate$a$1   = buildClassCheck(names[3]);
    isRegExp$7$1 = buildClassCheck(names[4]);

    // Wanted to enhance performance here by using simply "typeof"
    // but Firefox has two major issues that make this impossible,
    // one fixed, the other not, so perform a full class check here.
    //
    // 1. Regexes can be typeof "function" in FF < 3
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
    //
    // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
    isFunction$d$1 = buildClassCheck(names[5]);

    // istanbul ignore next
    isArray$f$1 = Array.isArray || buildClassCheck(names[6]);
    isError$2$1 = buildClassCheck(names[7]);

    isSet$2$1 = buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
    isMap$2$1 = buildClassCheck(names[9], typeof Map !== 'undefined' && Map);

    // Add core types as known so that they can be checked by value below,
    // notably excluding Functions and adding Arguments and Error.
    addKnownType('Arguments');
    addKnownType(names[0]);
    addKnownType(names[1]);
    addKnownType(names[2]);
    addKnownType(names[3]);
    addKnownType(names[4]);
    addKnownType(names[6]);

  }

  function addArrayTypes() {
    var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
    forEach$i$1(spaceSplit$5$1(types), function(str) {
      addKnownType(str + 'Array');
    });
  }

  function addKnownType(className) {
    var str = '[object '+ className +']';
    knownTypes[str] = true;
  }

  function isKnownType(className) {
    return knownTypes[className];
  }

  function buildClassCheck(className, globalObject) {
    // istanbul ignore if
    if (globalObject && isClass$3(new globalObject, 'Object')) {
      return getConstructorClassCheck(globalObject);
    } else {
      return getToStringClassCheck(className);
    }
  }

  // Map and Set may be [object Object] in certain IE environments.
  // In this case we need to perform a check using the constructor
  // instead of Object.prototype.toString.
  // istanbul ignore next
  function getConstructorClassCheck(obj) {
    var ctorStr = String(obj);
    return function(obj) {
      return String(obj.constructor) === ctorStr;
    };
  }

  function getToStringClassCheck(className) {
    return function(obj, str) {
      // perf: Returning up front on instanceof appears to be slower.
      return isClass$3(obj, className, str);
    };
  }

  function buildPrimitiveClassCheck(className) {
    var type = className.toLowerCase();
    return function(obj) {
      var t = typeof obj;
      return t === type || t === 'object' && isClass$3(obj, className);
    };
  }

  addCoreTypes();
  addArrayTypes();

  isSerializable$2$1 = function(obj, className) {
    // Only known objects can be serialized. This notably excludes functions,
    // host objects, Symbols (which are matched by reference), and instances
    // of classes. The latter can arguably be matched by value, but
    // distinguishing between these and host objects -- which should never be
    // compared by value -- is very tricky so not dealing with it here.
    return isKnownType(className) || isPlainObject$3$1(obj, className);
  };

}

buildClassChecks$1();

var classChecks$Z$1 = {
  isSerializable: isSerializable$2$1,
  isBoolean: isBoolean$5$1,
  isNumber: isNumber$d$1,
  isString: isString$k$1,
  isDate: isDate$a$1,
  isRegExp: isRegExp$7$1,
  isFunction: isFunction$d$1,
  isArray: isArray$f$1,
  isSet: isSet$2$1,
  isMap: isMap$2$1,
  isError: isError$2$1
};

function getNormalizedIndex$2$1(index, length, loop) {
  if (index && loop) {
    index = index % length;
  }
  if (index < 0) index = length + index;
  return index;
}

var getNormalizedIndex_1$1 = getNormalizedIndex$2$1;

var getNormalizedIndex$1$1 = getNormalizedIndex_1$1;

function entryAtIndex$1$1(obj, index, length, loop, isString) {
  index = getNormalizedIndex$1$1(index, length, loop);
  return isString ? obj.charAt(index) : obj[index];
}

var entryAtIndex_1$1 = entryAtIndex$1$1;

var forEach$h$1 = forEach_1$1,
    classChecks$Y$1 = classChecks$Z$1,
    entryAtIndex$2 = entryAtIndex_1$1;

var isArray$e$1 = classChecks$Y$1.isArray;

function getEntriesForIndexes$2$1(obj, find, loop, isString) {
  var result, length = obj.length;
  if (!isArray$e$1(find)) {
    return entryAtIndex$2(obj, find, length, loop, isString);
  }
  result = new Array(find.length);
  forEach$h$1(find, function(index, i) {
    result[i] = entryAtIndex$2(obj, index, length, loop, isString);
  });
  return result;
}

var getEntriesForIndexes_1$1 = getEntriesForIndexes$2$1;

var Sugar$6a$1 = sugarCore$1.exports,
    getEntriesForIndexes$1$1 = getEntriesForIndexes_1$1;

Sugar$6a$1.String.defineInstance({

  'at': function(str, index, loop) {
    return getEntriesForIndexes$1$1(str, index, loop, true);
  }

});

Sugar$6a$1.String.at;

var CAMELIZE_REG$1$1 = /(^|_)([^_]+)/g;

var Inflections$4$1 = {};

var Inflections$3$1 = Inflections$4$1;

function getAcronym$2$1(str) {
  // istanbul ignore next
  return Inflections$3$1.acronyms && Inflections$3$1.acronyms.find(str);
}

var getAcronym_1$1 = getAcronym$2$1;

var Inflections$2$1 = Inflections$4$1;

function stringUnderscore$4$1(str) {
  var areg = Inflections$2$1.acronyms && Inflections$2$1.acronyms.reg;
  // istanbul ignore if
  if (areg) {
    str = str.replace(areg, function(acronym, index) {
      return (index > 0 ? '_' : '') + acronym.toLowerCase();
    });
  }
  return str
    .replace(/[-\s]+/g, '_')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g,'$1_$2')
    .replace(/([a-z\d])([A-Z])/g,'$1_$2')
    .toLowerCase();
}

var stringUnderscore_1$1 = stringUnderscore$4$1;

var CAPITALIZE_REG$1$1 = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;

function simpleCapitalize$4$1(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var simpleCapitalize_1$1 = simpleCapitalize$4$1;

var CAPITALIZE_REG$2 = CAPITALIZE_REG$1$1,
    simpleCapitalize$3$1 = simpleCapitalize_1$1;

function stringCapitalize$3$1(str, downcase, all) {
  if (downcase) {
    str = str.toLowerCase();
  }
  return all ? str.replace(CAPITALIZE_REG$2, simpleCapitalize$3$1) : simpleCapitalize$3$1(str);
}

var stringCapitalize_1$1 = stringCapitalize$3$1;

var CAMELIZE_REG$2 = CAMELIZE_REG$1$1,
    getAcronym$1$1 = getAcronym_1$1,
    stringUnderscore$3$1 = stringUnderscore_1$1,
    stringCapitalize$2$1 = stringCapitalize_1$1;

function stringCamelize$1$1(str, upper) {
  str = stringUnderscore$3$1(str);
  return str.replace(CAMELIZE_REG$2, function(match, pre, word, index) {
    var cap = upper !== false || index > 0, acronym;
    acronym = getAcronym$1$1(word);
    // istanbul ignore if
    if (acronym && cap) {
      return acronym;
    }
    return cap ? stringCapitalize$2$1(word, true) : word;
  });
}

var stringCamelize_1$1 = stringCamelize$1$1;

var Sugar$69$1 = sugarCore$1.exports,
    stringCamelize$2 = stringCamelize_1$1;

Sugar$69$1.String.defineInstance({

  'camelize': function(str, upper) {
    return stringCamelize$2(str, upper);
  }

});

Sugar$69$1.String.camelize;

var Sugar$68$1 = sugarCore$1.exports,
    stringCapitalize$1$1 = stringCapitalize_1$1;

Sugar$68$1.String.defineInstance({

  'capitalize': function(str, lower, all) {
    return stringCapitalize$1$1(str, lower, all);
  }

});

Sugar$68$1.String.capitalize;

function isDefined$j$1(o) {
  return o !== undefined;
}

var isDefined_1$1 = isDefined$j$1;

var classChecks$X$1 = classChecks$Z$1;

var isString$j$1 = classChecks$X$1.isString;

function escapeRegExp$6$1(str) {
  if (!isString$j$1(str)) str = String(str);
  return str.replace(/([\\/'*+?|()[\]{}.^$-])/g,'\\$1');
}

var escapeRegExp_1$1 = escapeRegExp$6$1;

function getRegExpFlags$6$1(reg, add) {
  var flags = '';
  add = add || '';
  function checkFlag(prop, flag) {
    if (prop || add.indexOf(flag) > -1) {
      flags += flag;
    }
  }
  checkFlag(reg.global, 'g');
  checkFlag(reg.ignoreCase, 'i');
  checkFlag(reg.multiline, 'm');
  checkFlag(reg.sticky, 'y');
  return flags;
}

var getRegExpFlags_1$1 = getRegExpFlags$6$1;

function runGlobalMatch$1$1(str, reg) {
  var result = [], match, lastLastIndex;
  while ((match = reg.exec(str)) != null) {
    if (reg.lastIndex === lastLastIndex) {
      reg.lastIndex += 1;
    } else {
      result.push(match[0]);
    }
    lastLastIndex = reg.lastIndex;
  }
  return result;
}

var runGlobalMatch_1$1 = runGlobalMatch$1$1;

var isDefined$i$1 = isDefined_1$1,
    classChecks$W$1 = classChecks$Z$1,
    escapeRegExp$5$1 = escapeRegExp_1$1,
    getRegExpFlags$5$1 = getRegExpFlags_1$1,
    runGlobalMatch$2 = runGlobalMatch_1$1;

var isString$i$1 = classChecks$W$1.isString,
    isRegExp$6$1 = classChecks$W$1.isRegExp,
    isFunction$c$1 = classChecks$W$1.isFunction;

function stringEach$5$1(str, search, fn) {
  var chunks, chunk, reg, result = [];
  if (isFunction$c$1(search)) {
    fn = search;
    reg = /[\s\S]/g;
  } else if (!search) {
    reg = /[\s\S]/g;
  } else if (isString$i$1(search)) {
    reg = RegExp(escapeRegExp$5$1(search), 'gi');
  } else if (isRegExp$6$1(search)) {
    reg = RegExp(search.source, getRegExpFlags$5$1(search, 'g'));
  }
  // Getting the entire array of chunks up front as we need to
  // pass this into the callback function as an argument.
  chunks = runGlobalMatch$2(str, reg);

  if (chunks) {
    for(var i = 0, len = chunks.length, r; i < len; i++) {
      chunk = chunks[i];
      result[i] = chunk;
      if (fn) {
        r = fn.call(str, chunk, i, chunks);
        if (r === false) {
          break;
        } else if (isDefined$i$1(r)) {
          result[i] = r;
        }
      }
    }
  }
  return result;
}

var stringEach_1$1 = stringEach$5$1;

var Sugar$67$1 = sugarCore$1.exports,
    stringEach$4$1 = stringEach_1$1;

Sugar$67$1.String.defineInstance({

  'chars': function(str, search, eachCharFn) {
    return stringEach$4$1(str, search, eachCharFn);
  }

});

Sugar$67$1.String.chars;

function stringCodes$2$1(str, fn) {
  var codes = new Array(str.length), i, len;
  for(i = 0, len = str.length; i < len; i++) {
    var code = str.charCodeAt(i);
    codes[i] = code;
    if (fn) {
      fn.call(str, code, i, str);
    }
  }
  return codes;
}

var stringCodes_1$1 = stringCodes$2$1;

var Sugar$66$1 = sugarCore$1.exports,
    stringCodes$1$1 = stringCodes_1$1;

Sugar$66$1.String.defineInstance({

  'codes': function(str, eachCodeFn) {
    return stringCodes$1$1(str, eachCodeFn);
  }

});

Sugar$66$1.String.codes;

function trim$6$1(str) {
  return str.trim();
}

var trim_1$1 = trim$6$1;

var Sugar$65$1 = sugarCore$1.exports,
    trim$5$1 = trim_1$1;

Sugar$65$1.String.defineInstance({

  'compact': function(str) {
    return trim$5$1(str).replace(/([\r\n\s　])+/g, function(match, whitespace) {
      return whitespace === '　' ? whitespace : ' ';
    });
  }

});

Sugar$65$1.String.compact;

var Sugar$64$1 = sugarCore$1.exports,
    stringUnderscore$2$1 = stringUnderscore_1$1;

Sugar$64$1.String.defineInstance({

  'dasherize': function(str) {
    return stringUnderscore$2$1(str).replace(/_/g, '-');
  }

});

Sugar$64$1.String.dasherize;

var chr$6$1 = String.fromCharCode;

var chr$5$1 = chr$6$1;

var encodeBase64$1$1, decodeBase64$1$1;

function buildBase64$1() {
  var encodeAscii, decodeAscii;

  // istanbul ignore next
  function catchEncodingError(fn) {
    return function(str) {
      try {
        return fn(str);
      } catch(e) {
        return '';
      }
    };
  }

  // istanbul ignore if
  if (typeof Buffer !== 'undefined') {
    encodeBase64$1$1 = function(str) {
      return Buffer.from(str).toString('base64');
    };
    decodeBase64$1$1 = function(str) {
      return Buffer.from(str, 'base64').toString('utf8');
    };
    return;
  }

  // istanbul ignore if
  if (typeof btoa !== 'undefined') {
    encodeAscii = catchEncodingError(btoa);
    decodeAscii = catchEncodingError(atob);
  } else {
    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var base64reg = /[^A-Za-z0-9\+\/\=]/g;
    encodeAscii = function(str) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      do {
        chr1 = str.charCodeAt(i++);
        chr2 = str.charCodeAt(i++);
        chr3 = str.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output += key.charAt(enc1);
        output += key.charAt(enc2);
        output += key.charAt(enc3);
        output += key.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < str.length);
      return output;
    };
    decodeAscii = function(input) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      if (input.match(base64reg)) {
        return '';
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      do {
        enc1 = key.indexOf(input.charAt(i++));
        enc2 = key.indexOf(input.charAt(i++));
        enc3 = key.indexOf(input.charAt(i++));
        enc4 = key.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + chr$5$1(chr1);
        if (enc3 != 64) {
          output = output + chr$5$1(chr2);
        }
        if (enc4 != 64) {
          output = output + chr$5$1(chr3);
        }
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);
      return output;
    };
  }
  encodeBase64$1$1 = function(str) {
    return encodeAscii(unescape(encodeURIComponent(str)));
  };
  decodeBase64$1$1 = function(str) {
    return decodeURIComponent(escape(decodeAscii(str)));
  };
}

buildBase64$1();

var base64$2$1 = {
  encodeBase64: encodeBase64$1$1,
  decodeBase64: decodeBase64$1$1
};

var Sugar$63$1 = sugarCore$1.exports,
    base64$1$1 = base64$2$1;

var decodeBase64$2 = base64$1$1.decodeBase64;

Sugar$63$1.String.defineInstance({

  'decodeBase64': function(str) {
    return decodeBase64$2(str);
  }

});

Sugar$63$1.String.decodeBase64;

var Sugar$62$1 = sugarCore$1.exports,
    base64$3 = base64$2$1;

var encodeBase64$2 = base64$3.encodeBase64;

Sugar$62$1.String.defineInstance({

  'encodeBase64': function(str) {
    return encodeBase64$2(str);
  }

});

Sugar$62$1.String.encodeBase64;

var HTML_ESCAPE_REG$1$1 = /[&<>]/g;

var HTMLFromEntityMap$2$1 = {
  'lt':    '<',
  'gt':    '>',
  'amp':   '&',
  'nbsp':  ' ',
  'quot':  '"',
  'apos':  "'"
};

var HTMLFromEntityMap_1$1 = HTMLFromEntityMap$2$1;

var HTMLFromEntityMap$1$1 = HTMLFromEntityMap_1$1,
    coreUtilityAliases$I$1 = coreUtilityAliases$M$1;

var forEachProperty$n$1 = coreUtilityAliases$I$1.forEachProperty;

var HTMLToEntityMap$1$1;

function buildEntities$1() {
  HTMLToEntityMap$1$1 = {};
  forEachProperty$n$1(HTMLFromEntityMap$1$1, function(val, key) {
    HTMLToEntityMap$1$1[val] = '&' + key + ';';
  });
}

buildEntities$1();

var HTMLToEntityMap_1$1 = HTMLToEntityMap$1$1;

var Sugar$61$1 = sugarCore$1.exports,
    HTML_ESCAPE_REG$2 = HTML_ESCAPE_REG$1$1,
    HTMLToEntityMap$2 = HTMLToEntityMap_1$1,
    coreUtilityAliases$H$1 = coreUtilityAliases$M$1;

var getOwn$c$1 = coreUtilityAliases$H$1.getOwn;

Sugar$61$1.String.defineInstance({

  'escapeHTML': function(str) {
    return str.replace(HTML_ESCAPE_REG$2, function(chr) {
      return getOwn$c$1(HTMLToEntityMap$2, chr);
    });
  }

});

Sugar$61$1.String.escapeHTML;

var Sugar$60$1 = sugarCore$1.exports;

Sugar$60$1.String.defineInstance({

  'escapeURL': function(str, param) {
    return param ? encodeURIComponent(str) : encodeURI(str);
  }

});

Sugar$60$1.String.escapeURL;

function isUndefined$l$1(o) {
  return o === undefined;
}

var isUndefined_1$1 = isUndefined$l$1;

var Sugar$5$$1 = sugarCore$1.exports,
    isUndefined$k$1 = isUndefined_1$1;

Sugar$5$$1.String.defineInstance({

  'first': function(str, num) {
    if (isUndefined$k$1(num)) num = 1;
    return str.substr(0, num);
  }

});

Sugar$5$$1.String.first;

var Sugar$5_$1 = sugarCore$1.exports,
    stringEach$3$1 = stringEach_1$1;

Sugar$5_$1.String.defineInstance({

  'forEach': function(str, search, eachFn) {
    return stringEach$3$1(str, search, eachFn);
  }

});

Sugar$5_$1.String.forEach;

var PROPERTY_RANGE_REG$1$1 = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;

var CommonChars$8$1 = {
  HALF_WIDTH_ZERO: 0x30,
  FULL_WIDTH_ZERO: 0xff10,
  HALF_WIDTH_PERIOD: '.',
  FULL_WIDTH_PERIOD: '．',
  HALF_WIDTH_COMMA: ',',
  OPEN_BRACE: '{',
  CLOSE_BRACE: '}'
};

function map$7$1(arr, fn) {
  // perf: Not using fixed array len here as it may be sparse.
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr) {
      result.push(fn(arr[i], i));
    }
  }
  return result;
}

var map_1$1 = map$7$1;

var CommonChars$7$1 = CommonChars$8$1;

var HALF_WIDTH_PERIOD$4$1 = CommonChars$7$1.HALF_WIDTH_PERIOD;

function periodSplit$3$1(str) {
  return str.split(HALF_WIDTH_PERIOD$4$1);
}

var periodSplit_1$1 = periodSplit$3$1;

var classChecks$V$1 = classChecks$Z$1;

var isArray$d$1 = classChecks$V$1.isArray;

function assertArray$1$1(obj) {
  if (!isArray$d$1(obj)) {
    throw new TypeError('Array required');
  }
}

var assertArray_1$1 = assertArray$1$1;

function isPrimitive$7$1(obj, type) {
  type = type || typeof obj;
  return obj == null || type === 'string' || type === 'number' || type === 'boolean';
}

var isPrimitive_1$1 = isPrimitive$7$1;

var isPrimitive$6$1 = isPrimitive_1$1;

function assertWritable$1$1(obj) {
  if (isPrimitive$6$1(obj)) {
    // If strict mode is active then primitives will throw an
    // error when attempting to write properties. We can't be
    // sure if strict mode is available, so pre-emptively
    // throw an error here to ensure consistent behavior.
    throw new TypeError('Property cannot be written');
  }
}

var assertWritable_1$1 = assertWritable$1$1;

var PROPERTY_RANGE_REG$2 = PROPERTY_RANGE_REG$1$1,
    CommonChars$6$1 = CommonChars$8$1,
    map$6$1 = map_1$1,
    isDefined$h$1 = isDefined_1$1,
    classChecks$U$1 = classChecks$Z$1,
    periodSplit$2$1 = periodSplit_1$1,
    assertArray$2 = assertArray_1$1,
    isObjectType$c$1 = isObjectType_1$1,
    assertWritable$2 = assertWritable_1$1,
    coreUtilityAliases$G$1 = coreUtilityAliases$M$1;

var isString$h$1 = classChecks$U$1.isString,
    hasOwn$a$1 = coreUtilityAliases$G$1.hasOwn,
    HALF_WIDTH_PERIOD$3$1 = CommonChars$6$1.HALF_WIDTH_PERIOD;

function handleDeepProperty$3$1(obj, key, any, has, fill, fillLast, val) {
  var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
  ns = obj;
  if (key == null) return;

  if (isObjectType$c$1(key)) {
    // Allow array and array-like accessors
    bs = [key];
  } else {
    key = String(key);
    if (key.indexOf('..') !== -1) {
      return handleArrayIndexRange$1(obj, key, any, val);
    }
    bs = key.split('[');
  }

  set = isDefined$h$1(val);

  for (var i = 0, blen = bs.length; i < blen; i++) {
    ps = bs[i];

    if (isString$h$1(ps)) {
      ps = periodSplit$2$1(ps);
    }

    for (var j = 0, plen = ps.length; j < plen; j++) {
      key = ps[j];

      // Is this the last key?
      isLast = i === blen - 1 && j === plen - 1;

      // Index of the closing ]
      cbi = key.indexOf(']');

      // Is the key an array index?
      isIndex = cbi !== -1;

      // Is this array push syntax "[]"?
      isPush = set && cbi === 0;

      // If the bracket split was successful and this is the last element
      // in the dot split, then we know the next key will be an array index.
      nextIsIndex = blen > 1 && j === plen - 1;

      if (isPush) {
        // Set the index to the end of the array
        key = ns.length;
      } else if (isIndex) {
        // Remove the closing ]
        key = key.slice(0, -1);
      }

      // If the array index is less than 0, then
      // add its length to allow negative indexes.
      if (isIndex && key < 0) {
        key = +key + ns.length;
      }

      // Bracket keys may look like users[5] or just [5], so the leading
      // characters are optional. We can enter the namespace if this is the
      // 2nd part, if there is only 1 part, or if there is an explicit key.
      if (i || key || blen === 1) {

        // TODO: need to be sure this check handles ''.length when
        // we refactor.
        exists = any ? key in Object(ns) : hasOwn$a$1(ns, key);

        // Non-existent namespaces are only filled if they are intermediate
        // (not at the end) or explicitly filling the last.
        if (fill && (!isLast || fillLast) && !exists) {
          // For our purposes, last only needs to be an array.
          ns = ns[key] = nextIsIndex || (fillLast && isLast) ? [] : {};
          continue;
        }

        if (has) {
          if (isLast || !exists) {
            return exists;
          }
        } else if (set && isLast) {
          assertWritable$2(ns);
          ns[key] = val;
        }

        ns = exists ? ns[key] : undefined;
      }

    }
  }
  return ns;
}

function handleArrayIndexRange$1(obj, key, any, val) {
  var match, start, end, leading, trailing, arr, set;
  match = key.match(PROPERTY_RANGE_REG$2);
  if (!match) {
    return;
  }

  set = isDefined$h$1(val);
  leading = match[1];

  if (leading) {
    arr = handleDeepProperty$3$1(obj, leading, any, false, set ? true : false, true);
  } else {
    arr = obj;
  }

  assertArray$2(arr);

  trailing = match[4];
  start    = match[2] ? +match[2] : 0;
  end      = match[3] ? +match[3] : arr.length;

  // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
  // pushes the index from -1 to 0, then set it to the full length of the
  // array, otherwise it will return nothing.
  end = end === -1 ? arr.length : end + 1;

  if (set) {
    for (var i = start; i < end; i++) {
      handleDeepProperty$3$1(arr, i + trailing, any, false, true, false, val);
    }
  } else {
    arr = arr.slice(start, end);

    // If there are trailing properties, then they need to be mapped for each
    // element in the array.
    if (trailing) {
      if (trailing.charAt(0) === HALF_WIDTH_PERIOD$3$1) {
        // Need to chomp the period if one is trailing after the range. We
        // can't do this at the regex level because it will be required if
        // we're setting the value as it needs to be concatentated together
        // with the array index to be set.
        trailing = trailing.slice(1);
      }
      return map$6$1(arr, function(el) {
        return handleDeepProperty$3$1(el, trailing);
      });
    }
  }
  return arr;
}

var handleDeepProperty_1$1 = handleDeepProperty$3$1;

var handleDeepProperty$2$1 = handleDeepProperty_1$1;

function deepGetProperty$4$1(obj, key, any) {
  return handleDeepProperty$2$1(obj, key, any, false);
}

var deepGetProperty_1$1 = deepGetProperty$4$1;

var STRING_FORMAT_REG$1$1 = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;

var INTERNAL_MEMOIZE_LIMIT$1$1 = 1000;

var INTERNAL_MEMOIZE_LIMIT$2 = INTERNAL_MEMOIZE_LIMIT$1$1,
    coreUtilityAliases$F$1 = coreUtilityAliases$M$1;

var hasOwn$9$1 = coreUtilityAliases$F$1.hasOwn;

function memoizeFunction$1$1(fn) {
  var memo = {}, counter = 0;

  return function(key) {
    if (hasOwn$9$1(memo, key)) {
      return memo[key];
    }
    // istanbul ignore if
    if (counter === INTERNAL_MEMOIZE_LIMIT$2) {
      memo = {};
      counter = 0;
    }
    counter++;
    return memo[key] = fn(key);
  };
}

var memoizeFunction_1$1 = memoizeFunction$1$1;

var STRING_FORMAT_REG$2 = STRING_FORMAT_REG$1$1,
    CommonChars$5$1 = CommonChars$8$1,
    memoizeFunction$2 = memoizeFunction_1$1;

var OPEN_BRACE$1 = CommonChars$5$1.OPEN_BRACE,
    CLOSE_BRACE$1 = CommonChars$5$1.CLOSE_BRACE;

function createFormatMatcher$2$1(bracketMatcher, percentMatcher, precheck) {

  var reg = STRING_FORMAT_REG$2;
  var compileMemoized = memoizeFunction$2(compile);

  function getToken(format, match) {
    var get, token, literal, fn;
    var bKey = match[2];
    var pLit = match[3];
    var pKey = match[5];
    if (match[4] && percentMatcher) {
      token = pKey;
      get = percentMatcher;
    } else if (bKey) {
      token = bKey;
      get = bracketMatcher;
    } else if (pLit && percentMatcher) {
      literal = pLit;
    } else {
      literal = match[1] || match[0];
    }
    if (get) {
      assertPassesPrecheck(precheck, bKey, pKey);
      fn = function(obj, opt) {
        return get(obj, token, opt);
      };
    }
    format.push(fn || getLiteral(literal));
  }

  function getSubstring(format, str, start, end) {
    if (end > start) {
      var sub = str.slice(start, end);
      assertNoUnmatched(sub, OPEN_BRACE$1);
      assertNoUnmatched(sub, CLOSE_BRACE$1);
      format.push(function() {
        return sub;
      });
    }
  }

  function getLiteral(str) {
    return function() {
      return str;
    };
  }

  function assertPassesPrecheck(precheck, bt, pt) {
    if (precheck && !precheck(bt, pt)) {
      throw new TypeError('Invalid token '+ (bt || pt) +' in format string');
    }
  }

  function assertNoUnmatched(str, chr) {
    if (str.indexOf(chr) !== -1) {
      throw new TypeError('Unmatched '+ chr +' in format string');
    }
  }

  function compile(str) {
    var format = [], lastIndex = 0, match;
    reg.lastIndex = 0;
    while(match = reg.exec(str)) {
      getSubstring(format, str, lastIndex, match.index);
      getToken(format, match);
      lastIndex = reg.lastIndex;
    }
    getSubstring(format, str, lastIndex, str.length);
    return format;
  }

  return function(str, obj, opt) {
    var format = compileMemoized(str), result = '';
    for (var i = 0; i < format.length; i++) {
      result += format[i](obj, opt);
    }
    return result;
  };
}

var createFormatMatcher_1$1 = createFormatMatcher$2$1;

var deepGetProperty$3$1 = deepGetProperty_1$1,
    createFormatMatcher$1$1 = createFormatMatcher_1$1;

var stringFormatMatcher$1$1 = createFormatMatcher$1$1(deepGetProperty$3$1);

var Sugar$5Z$1 = sugarCore$1.exports,
    isObjectType$b$1 = isObjectType_1$1,
    stringFormatMatcher$2 = stringFormatMatcher$1$1;

Sugar$5Z$1.String.defineInstanceWithArguments({

  'format': function(str, args) {
    var arg1 = args[0] && args[0].valueOf();
    // Unwrap if a single object is passed in.
    if (args.length === 1 && isObjectType$b$1(arg1)) {
      args = arg1;
    }
    return stringFormatMatcher$2(str, args);
  }

});

Sugar$5Z$1.String.format;

var classChecks$T$1 = classChecks$Z$1;

var isString$g$1 = classChecks$T$1.isString;

function numberOrIndex$2$1(str, n, from) {
  if (isString$g$1(n)) {
    n = str.indexOf(n);
    if (n === -1) {
      n = from ? str.length : 0;
    }
  }
  return n;
}

var numberOrIndex_1$1 = numberOrIndex$2$1;

var Sugar$5Y$1 = sugarCore$1.exports,
    numberOrIndex$1$1 = numberOrIndex_1$1;

Sugar$5Y$1.String.defineInstance({

  'from': function(str, from) {
    return str.slice(numberOrIndex$1$1(str, from, true));
  }

});

Sugar$5Y$1.String.from;

var ENHANCEMENTS_FLAG$7$1 = 'enhance';

var STRING_ENHANCEMENTS_FLAG$1$1 = 'enhanceString';

function fixArgumentLength$9$1(fn) {
  var staticFn = function(a) {
    var args = arguments;
    return fn(a, args[1], args[2], args.length - 1);
  };
  staticFn.instance = function(b) {
    var args = arguments;
    return fn(this, b, args[1], args.length);
  };
  return staticFn;
}

var fixArgumentLength_1$1 = fixArgumentLength$9$1;

var nativeIncludes$1$1 = String.prototype.includes;

var classChecks$S$1 = classChecks$Z$1,
    nativeIncludes$2 = nativeIncludes$1$1;

var isRegExp$5$1 = classChecks$S$1.isRegExp;

function callIncludesWithRegexSupport$1$1(str, search, position) {
  if (!isRegExp$5$1(search)) {
    return nativeIncludes$2.call(str, search, position);
  }
  if (position) {
    str = str.slice(position);
  }
  return search.test(str);
}

var callIncludesWithRegexSupport_1$1 = callIncludesWithRegexSupport$1$1;

var Sugar$5X$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$6$1 = ENHANCEMENTS_FLAG$7$1,
    STRING_ENHANCEMENTS_FLAG$2 = STRING_ENHANCEMENTS_FLAG$1$1,
    fixArgumentLength$8$1 = fixArgumentLength_1$1,
    callIncludesWithRegexSupport$2 = callIncludesWithRegexSupport_1$1;

Sugar$5X$1.String.defineInstance({

  'includes': fixArgumentLength$8$1(callIncludesWithRegexSupport$2)

}, [ENHANCEMENTS_FLAG$6$1, STRING_ENHANCEMENTS_FLAG$2]);

Sugar$5X$1.String.includes;

var Sugar$5W$1 = sugarCore$1.exports,
    isUndefined$j$1 = isUndefined_1$1;

Sugar$5W$1.String.defineInstance({

  'insert': function(str, substr, index) {
    index = isUndefined$j$1(index) ? str.length : index;
    return str.slice(0, index) + substr + str.slice(index);
  }

});

Sugar$5W$1.String.insert;

var Sugar$5V$1 = sugarCore$1.exports,
    trim$4$1 = trim_1$1;

Sugar$5V$1.String.defineInstance({

  'isBlank': function(str) {
    return trim$4$1(str).length === 0;
  }

});

Sugar$5V$1.String.isBlank;

var Sugar$5U$1 = sugarCore$1.exports;

Sugar$5U$1.String.defineInstance({

  'isEmpty': function(str) {
    return str.length === 0;
  }

});

Sugar$5U$1.String.isEmpty;

var Sugar$5T$1 = sugarCore$1.exports,
    isUndefined$i$1 = isUndefined_1$1;

Sugar$5T$1.String.defineInstance({

  'last': function(str, num) {
    if (isUndefined$i$1(num)) num = 1;
    var start = str.length - num < 0 ? 0 : str.length - num;
    return str.substr(start);
  }

});

Sugar$5T$1.String.last;

var Sugar$5S$1 = sugarCore$1.exports,
    trim$3$1 = trim_1$1,
    stringEach$2$1 = stringEach_1$1;

Sugar$5S$1.String.defineInstance({

  'lines': function(str, eachLineFn) {
    return stringEach$2$1(trim$3$1(str), /^.*$/gm, eachLineFn);
  }

});

Sugar$5S$1.String.lines;

function repeatString$3$1(str, num) {
  var result = '';
  str = str.toString();
  while (num > 0) {
    if (num & 1) {
      result += str;
    }
    if (num >>= 1) {
      str += str;
    }
  }
  return result;
}

var repeatString_1$1 = repeatString$3$1;

var isDefined$g$1 = isDefined_1$1,
    repeatString$2$1 = repeatString_1$1;

function padString$3$1(num, padding) {
  return repeatString$2$1(isDefined$g$1(padding) ? padding : ' ', num);
}

var padString_1$1 = padString$3$1;

var mathAliases$z$1 = {
  abs: Math.abs,
  pow: Math.pow,
  min: Math.min,
  max: Math.max,
  ceil: Math.ceil,
  floor: Math.floor,
  round: Math.round
};

var mathAliases$y$1 = mathAliases$z$1;

var ceil$8$1 = mathAliases$y$1.ceil,
    floor$5$1 = mathAliases$y$1.floor;

var trunc$c$1 = Math.trunc || function(n) {
  if (n === 0 || !isFinite(n)) return n;
  return n < 0 ? ceil$8$1(n) : floor$5$1(n);
};

var trunc_1$1 = trunc$c$1;

var trunc$b$1 = trunc_1$1,
    classChecks$R$1 = classChecks$Z$1;

var isNumber$c$1 = classChecks$R$1.isNumber;

function coercePositiveInteger$6$1(n) {
  n = +n || 0;
  if (n < 0 || !isNumber$c$1(n) || !isFinite(n)) {
    throw new RangeError('Invalid number');
  }
  return trunc$b$1(n);
}

var coercePositiveInteger_1$1 = coercePositiveInteger$6$1;

var Sugar$5R$1 = sugarCore$1.exports,
    padString$2$1 = padString_1$1,
    mathAliases$x$1 = mathAliases$z$1,
    coercePositiveInteger$5$1 = coercePositiveInteger_1$1;

var max$a$1 = mathAliases$x$1.max,
    ceil$7$1 = mathAliases$x$1.ceil,
    floor$4$1 = mathAliases$x$1.floor;

Sugar$5R$1.String.defineInstance({

  'pad': function(str, num, padding) {
    var half, front, back;
    num   = coercePositiveInteger$5$1(num);
    half  = max$a$1(0, num - str.length) / 2;
    front = floor$4$1(half);
    back  = ceil$7$1(half);
    return padString$2$1(front, padding) + str + padString$2$1(back, padding);
  }

});

Sugar$5R$1.String.pad;

var Sugar$5Q$1 = sugarCore$1.exports,
    padString$1$1 = padString_1$1,
    mathAliases$w$1 = mathAliases$z$1,
    coercePositiveInteger$4$1 = coercePositiveInteger_1$1;

var max$9$1 = mathAliases$w$1.max;

Sugar$5Q$1.String.defineInstance({

  'padLeft': function(str, num, padding) {
    num = coercePositiveInteger$4$1(num);
    return padString$1$1(max$9$1(0, num - str.length), padding) + str;
  }

});

Sugar$5Q$1.String.padLeft;

var Sugar$5P$1 = sugarCore$1.exports,
    padString$4 = padString_1$1,
    mathAliases$v$1 = mathAliases$z$1,
    coercePositiveInteger$3$1 = coercePositiveInteger_1$1;

var max$8$1 = mathAliases$v$1.max;

Sugar$5P$1.String.defineInstance({

  'padRight': function(str, num, padding) {
    num = coercePositiveInteger$3$1(num);
    return str + padString$4(max$8$1(0, num - str.length), padding);
  }

});

Sugar$5P$1.String.padRight;

var escapeRegExp$4$1 = escapeRegExp_1$1;

function stringParameterize$1$1(str, separator) {
  if (separator === undefined) separator = '-';
  str = str.replace(/[^a-z0-9\-_]+/gi, separator);
  if (separator) {
    var reg = RegExp('^{s}+|{s}+$|({s}){s}+'.split('{s}').join(escapeRegExp$4$1(separator)), 'g');
    str = str.replace(reg, '$1');
  }
  return encodeURI(str.toLowerCase());
}

var stringParameterize_1$1 = stringParameterize$1$1;

var Sugar$5O$1 = sugarCore$1.exports,
    stringParameterize$2 = stringParameterize_1$1;

Sugar$5O$1.String.defineInstance({

  'parameterize': function(str, separator) {
    return stringParameterize$2(str, separator);
  }

});

Sugar$5O$1.String.parameterize;

var Sugar$5N$1 = sugarCore$1.exports;

Sugar$5N$1.String.defineInstance({

  'remove': function(str, f) {
    return str.replace(f, '');
  }

});

Sugar$5N$1.String.remove;

var classChecks$Q$1 = classChecks$Z$1,
    escapeRegExp$3$1 = escapeRegExp_1$1,
    getRegExpFlags$4$1 = getRegExpFlags_1$1;

var isString$f$1 = classChecks$Q$1.isString;

function stringReplaceAll$2$1(str, f, replace) {
  var i = 0, tokens;
  if (isString$f$1(f)) {
    f = RegExp(escapeRegExp$3$1(f), 'g');
  } else if (f && !f.global) {
    f = RegExp(f.source, getRegExpFlags$4$1(f, 'g'));
  }
  if (!replace) {
    replace = '';
  } else {
    tokens = replace;
    replace = function() {
      var t = tokens[i++];
      return t != null ? t : '';
    };
  }
  return str.replace(f, replace);
}

var stringReplaceAll_1$1 = stringReplaceAll$2$1;

var Sugar$5M$1 = sugarCore$1.exports,
    stringReplaceAll$1$1 = stringReplaceAll_1$1;

Sugar$5M$1.String.defineInstance({

  'removeAll': function(str, f) {
    return stringReplaceAll$1$1(str, f);
  }

});

Sugar$5M$1.String.removeAll;

var HTML_VOID_ELEMENTS$1$1 = [
  'area','base','br','col','command','embed','hr','img',
  'input','keygen','link','meta','param','source','track','wbr'
];

var HTML_VOID_ELEMENTS_1$1 = HTML_VOID_ELEMENTS$1$1;

function indexOf$3$1(arr, el) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr && arr[i] === el) return i;
  }
  return -1;
}

var indexOf_1$1 = indexOf$3$1;

var HTML_VOID_ELEMENTS$2 = HTML_VOID_ELEMENTS_1$1,
    indexOf$2$1 = indexOf_1$1;

function tagIsVoid$1$1(tag) {
  return indexOf$2$1(HTML_VOID_ELEMENTS$2, tag.toLowerCase()) !== -1;
}

var tagIsVoid_1$1 = tagIsVoid$1$1;

var tagIsVoid$2 = tagIsVoid_1$1,
    classChecks$P$1 = classChecks$Z$1;

var isString$e$1 = classChecks$P$1.isString;

function runTagReplacements$1$1(str, reg, strip, replacement, fullString) {

  var match;
  var result = '';
  var currentIndex = 0;
  var openTagName;
  var openTagAttributes;
  var openTagCount = 0;

  function processTag(index, tagName, attributes, tagLength, isVoid) {
    var content = str.slice(currentIndex, index), s = '', r = '';
    if (isString$e$1(replacement)) {
      r = replacement;
    } else if (replacement) {
      r = replacement.call(fullString, tagName, content, attributes, fullString) || '';
    }
    if (strip) {
      s = r;
    } else {
      content = r;
    }
    if (content) {
      content = runTagReplacements$1$1(content, reg, strip, replacement, fullString);
    }
    result += s + content + (isVoid ? '' : s);
    currentIndex = index + (tagLength || 0);
  }

  fullString = fullString || str;
  reg = RegExp(reg.source, 'gi');

  while(match = reg.exec(str)) {

    var tagName         = match[2];
    var attributes      = (match[3]|| '').slice(1);
    var isClosingTag    = !!match[1];
    var isSelfClosing   = !!match[4];
    var tagLength       = match[0].length;
    var isVoid          = tagIsVoid$2(tagName);
    var isOpeningTag    = !isClosingTag && !isSelfClosing && !isVoid;
    var isSameAsCurrent = tagName === openTagName;

    if (!openTagName) {
      result += str.slice(currentIndex, match.index);
      currentIndex = match.index;
    }

    if (isOpeningTag) {
      if (!openTagName) {
        openTagName = tagName;
        openTagAttributes = attributes;
        openTagCount++;
        currentIndex += tagLength;
      } else if (isSameAsCurrent) {
        openTagCount++;
      }
    } else if (isClosingTag && isSameAsCurrent) {
      openTagCount--;
      if (openTagCount === 0) {
        processTag(match.index, openTagName, openTagAttributes, tagLength, isVoid);
        openTagName       = null;
        openTagAttributes = null;
      }
    } else if (!openTagName) {
      processTag(match.index, tagName, attributes, tagLength, isVoid);
    }
  }
  if (openTagName) {
    processTag(str.length, openTagName, openTagAttributes);
  }
  result += str.slice(currentIndex);
  return result;
}

var runTagReplacements_1$1 = runTagReplacements$1$1;

var map$5$1 = map_1$1,
    classChecks$O$1 = classChecks$Z$1,
    escapeRegExp$2$1 = escapeRegExp_1$1,
    runTagReplacements$2 = runTagReplacements_1$1;

var isString$d$1 = classChecks$O$1.isString;

function replaceTags$2$1(str, find, replacement, strip) {
  var tags = isString$d$1(find) ? [find] : find, reg, src;
  tags = map$5$1(tags || [], function(t) {
    return escapeRegExp$2$1(t);
  }).join('|');
  src = tags.replace('all', '') || '[^\\s>]+';
  src = '<(\\/)?(' + src + ')(\\s+[^<>]*?)?\\s*(\\/)?>';
  reg = RegExp(src, 'gi');
  return runTagReplacements$2(str.toString(), reg, strip, replacement);
}

var replaceTags_1$1 = replaceTags$2$1;

var Sugar$5L$1 = sugarCore$1.exports,
    replaceTags$1$1 = replaceTags_1$1;

Sugar$5L$1.String.defineInstance({

  'removeTags': function(str, tag, replace) {
    return replaceTags$1$1(str, tag, replace, false);
  }

});

Sugar$5L$1.String.removeTags;

var Sugar$5K$1 = sugarCore$1.exports,
    stringReplaceAll$3 = stringReplaceAll_1$1;

Sugar$5K$1.String.defineInstanceWithArguments({

  'replaceAll': function(str, f, args) {
    return stringReplaceAll$3(str, f, args);
  }

});

Sugar$5K$1.String.replaceAll;

function reverseString$2$1(str) {
  return str.split('').reverse().join('');
}

var reverseString_1$1 = reverseString$2$1;

var Sugar$5J$1 = sugarCore$1.exports,
    reverseString$1$1 = reverseString_1$1;

Sugar$5J$1.String.defineInstance({

  'reverse': function(str) {
    return reverseString$1$1(str);
  }

});

Sugar$5J$1.String.reverse;

var Sugar$5I$1 = sugarCore$1.exports,
    chr$4$1 = chr$6$1,
    stringCodes$3 = stringCodes_1$1;

Sugar$5I$1.String.defineInstance({

  'shift': function(str, n) {
    var result = '';
    n = n || 0;
    stringCodes$3(str, function(c) {
      result += chr$4$1(c + n);
    });
    return result;
  }

});

Sugar$5I$1.String.shift;

var stringUnderscore$1$1 = stringUnderscore_1$1;

function stringSpacify$2$1(str) {
  return stringUnderscore$1$1(str).replace(/_/g, ' ');
}

var stringSpacify_1$1 = stringSpacify$2$1;

var Sugar$5H$1 = sugarCore$1.exports,
    stringSpacify$1$1 = stringSpacify_1$1;

Sugar$5H$1.String.defineInstance({

  'spacify': function(str) {
    return stringSpacify$1$1(str);
  }

});

Sugar$5H$1.String.spacify;

var Sugar$5G$1 = sugarCore$1.exports,
    replaceTags$3 = replaceTags_1$1;

Sugar$5G$1.String.defineInstance({

  'stripTags': function(str, tag, replace) {
    return replaceTags$3(str, tag, replace, true);
  }

});

Sugar$5G$1.String.stripTags;

var DOWNCASED_WORDS$1$1 = [
  'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at',
  'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over',
  'with', 'for'
];

var DOWNCASED_WORDS_1$1 = DOWNCASED_WORDS$1$1;

var trim$2$1 = trim_1$1,
    stringEach$1$1 = stringEach_1$1;

function eachWord$1$1(str, fn) {
  return stringEach$1$1(trim$2$1(str), /\S+/g, fn);
}

var eachWord_1$1 = eachWord$1$1;

var Inflections$1$1 = Inflections$4$1;

function getHumanWord$1$1(str) {
  // istanbul ignore next
  return Inflections$1$1.human && Inflections$1$1.human.find(str);
}

var getHumanWord_1$1 = getHumanWord$1$1;

var Inflections$5 = Inflections$4$1;

function runHumanRules$1$1(str) {
  // istanbul ignore next
  return Inflections$5.human && Inflections$5.human.runRules(str) || str;
}

var runHumanRules_1$1 = runHumanRules$1$1;

var DOWNCASED_WORDS$2 = DOWNCASED_WORDS_1$1,
    indexOf$1$1 = indexOf_1$1,
    eachWord$2 = eachWord_1$1,
    getAcronym$3 = getAcronym_1$1,
    getHumanWord$2 = getHumanWord_1$1,
    runHumanRules$2 = runHumanRules_1$1,
    stringSpacify$3 = stringSpacify_1$1,
    stringCapitalize$4 = stringCapitalize_1$1;

function stringTitleize$1$1(str) {
  var fullStopPunctuation = /[.:;!]$/, lastHadPunctuation;
  str = runHumanRules$2(str);
  str = stringSpacify$3(str);
  return eachWord$2(str, function(word, index, words) {
    word = getHumanWord$2(word) || word;
    word = getAcronym$3(word) || word;
    var hasPunctuation, isFirstOrLast;
    var first = index == 0, last = index == words.length - 1;
    hasPunctuation = fullStopPunctuation.test(word);
    isFirstOrLast = first || last || hasPunctuation || lastHadPunctuation;
    lastHadPunctuation = hasPunctuation;
    if (isFirstOrLast || indexOf$1$1(DOWNCASED_WORDS$2, word) === -1) {
      return stringCapitalize$4(word, false, true);
    } else {
      return word;
    }
  }).join(' ');
}

var stringTitleize_1$1 = stringTitleize$1$1;

var Sugar$5F$1 = sugarCore$1.exports,
    stringTitleize$2 = stringTitleize_1$1;

Sugar$5F$1.String.defineInstance({

  'titleize': function(str) {
    return stringTitleize$2(str);
  }

});

Sugar$5F$1.String.titleize;

var Sugar$5E$1 = sugarCore$1.exports,
    isUndefined$h$1 = isUndefined_1$1,
    numberOrIndex$3 = numberOrIndex_1$1;

Sugar$5E$1.String.defineInstance({

  'to': function(str, to) {
    if (isUndefined$h$1(to)) to = str.length;
    return str.slice(0, numberOrIndex$3(str, to));
  }

});

Sugar$5E$1.String.to;

function allCharsReg$2$1(src) {
  return RegExp('[' + src + ']', 'g');
}

var allCharsReg_1$1 = allCharsReg$2$1;

var CommonChars$4$1 = CommonChars$8$1,
    chr$3$1 = chr$6$1,
    allCharsReg$1$1 = allCharsReg_1$1;

var HALF_WIDTH_ZERO$1$1 = CommonChars$4$1.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO$1$1 = CommonChars$4$1.FULL_WIDTH_ZERO,
    HALF_WIDTH_PERIOD$2$1 = CommonChars$4$1.HALF_WIDTH_PERIOD,
    FULL_WIDTH_PERIOD$1 = CommonChars$4$1.FULL_WIDTH_PERIOD,
    HALF_WIDTH_COMMA$2$1 = CommonChars$4$1.HALF_WIDTH_COMMA;

var fullWidthNumberReg$1$1, fullWidthNumberMap$2$1, fullWidthNumbers$1$1;

function buildFullWidthNumber$1() {
  var fwp = FULL_WIDTH_PERIOD$1, hwp = HALF_WIDTH_PERIOD$2$1, hwc = HALF_WIDTH_COMMA$2$1, fwn = '';
  fullWidthNumberMap$2$1 = {};
  for (var i = 0, digit; i <= 9; i++) {
    digit = chr$3$1(i + FULL_WIDTH_ZERO$1$1);
    fwn += digit;
    fullWidthNumberMap$2$1[digit] = chr$3$1(i + HALF_WIDTH_ZERO$1$1);
  }
  fullWidthNumberMap$2$1[hwc] = '';
  fullWidthNumberMap$2$1[fwp] = hwp;
  // Mapping this to itself to capture it easily
  // in stringToNumber to detect decimals later.
  fullWidthNumberMap$2$1[hwp] = hwp;
  fullWidthNumberReg$1$1 = allCharsReg$1$1(fwn + fwp + hwc + hwp);
  fullWidthNumbers$1$1 = fwn;
}

buildFullWidthNumber$1();

var fullwidthNumberHelpers$2$1 = {
  fullWidthNumberReg: fullWidthNumberReg$1$1,
  fullWidthNumberMap: fullWidthNumberMap$2$1,
  fullWidthNumbers: fullWidthNumbers$1$1
};

var CommonChars$3$1 = CommonChars$8$1,
    coreUtilityAliases$E$1 = coreUtilityAliases$M$1,
    fullwidthNumberHelpers$1$1 = fullwidthNumberHelpers$2$1;

var fullWidthNumberReg$2 = fullwidthNumberHelpers$1$1.fullWidthNumberReg,
    fullWidthNumberMap$1$1 = fullwidthNumberHelpers$1$1.fullWidthNumberMap,
    getOwn$b$1 = coreUtilityAliases$E$1.getOwn,
    HALF_WIDTH_PERIOD$1$1 = CommonChars$3$1.HALF_WIDTH_PERIOD;

function stringToNumber$2$1(str, base) {
  var sanitized, isDecimal;
  sanitized = str.replace(fullWidthNumberReg$2, function(chr) {
    var replacement = getOwn$b$1(fullWidthNumberMap$1$1, chr);
    if (replacement === HALF_WIDTH_PERIOD$1$1) {
      isDecimal = true;
    }
    return replacement;
  });
  return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
}

var stringToNumber_1$1 = stringToNumber$2$1;

var Sugar$5D$1 = sugarCore$1.exports,
    stringToNumber$1$1 = stringToNumber_1$1;

Sugar$5D$1.String.defineInstance({

  'toNumber': function(str, base) {
    return stringToNumber$1$1(str, base);
  }

});

Sugar$5D$1.String.toNumber;

var TRIM_CHARS$3$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

var TRIM_CHARS$2$1 = TRIM_CHARS$3$1;

var LEFT_TRIM_REG$1$1 = RegExp('^['+ TRIM_CHARS$2$1 +']+');

var Sugar$5C$1 = sugarCore$1.exports,
    LEFT_TRIM_REG$2 = LEFT_TRIM_REG$1$1;

Sugar$5C$1.String.defineInstance({

  'trimLeft': function(str) {
    return str.replace(LEFT_TRIM_REG$2, '');
  }

});

Sugar$5C$1.String.trimLeft;

var TRIM_CHARS$1$1 = TRIM_CHARS$3$1;

var RIGHT_TRIM_REG$1$1 = RegExp('['+ TRIM_CHARS$1$1 +']+$');

var Sugar$5B$1 = sugarCore$1.exports,
    RIGHT_TRIM_REG$2 = RIGHT_TRIM_REG$1$1;

Sugar$5B$1.String.defineInstance({

  'trimRight': function(str) {
    return str.replace(RIGHT_TRIM_REG$2, '');
  }

});

Sugar$5B$1.String.trimRight;

var TRIM_CHARS$4 = TRIM_CHARS$3$1;

var TRUNC_REG$1$1 = RegExp('(?=[' + TRIM_CHARS$4 + '])');

function filter$3$1(arr, fn) {
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    var el = arr[i];
    if (i in arr && fn(el, i)) {
      result.push(el);
    }
  }
  return result;
}

var filter_1$1 = filter$3$1;

var TRUNC_REG$2 = TRUNC_REG$1$1,
    filter$2$1 = filter_1$1,
    reverseString$3 = reverseString_1$1;

function truncateOnWord$1$1(str, limit, fromLeft) {
  if (fromLeft) {
    return reverseString$3(truncateOnWord$1$1(reverseString$3(str), limit));
  }
  var words = str.split(TRUNC_REG$2);
  var count = 0;
  return filter$2$1(words, function(word) {
    count += word.length;
    return count <= limit;
  }).join('');
}

var truncateOnWord_1$1 = truncateOnWord$1$1;

var isUndefined$g$1 = isUndefined_1$1,
    mathAliases$u$1 = mathAliases$z$1,
    truncateOnWord$2 = truncateOnWord_1$1;

var ceil$6$1 = mathAliases$u$1.ceil,
    floor$3$1 = mathAliases$u$1.floor;

function truncateString$2$1(str, length, from, ellipsis, split) {
  var str1, str2, len1, len2;
  if (str.length <= length) {
    return str.toString();
  }
  ellipsis = isUndefined$g$1(ellipsis) ? '...' : ellipsis;
  switch(from) {
    case 'left':
      str2 = split ? truncateOnWord$2(str, length, true) : str.slice(str.length - length);
      return ellipsis + str2;
    case 'middle':
      len1 = ceil$6$1(length / 2);
      len2 = floor$3$1(length / 2);
      str1 = split ? truncateOnWord$2(str, len1) : str.slice(0, len1);
      str2 = split ? truncateOnWord$2(str, len2, true) : str.slice(str.length - len2);
      return str1 + ellipsis + str2;
    default:
      str1 = split ? truncateOnWord$2(str, length) : str.slice(0, length);
      return str1 + ellipsis;
  }
}

var truncateString_1$1 = truncateString$2$1;

var Sugar$5A$1 = sugarCore$1.exports,
    truncateString$1$1 = truncateString_1$1;

Sugar$5A$1.String.defineInstance({

  'truncate': function(str, length, from, ellipsis) {
    return truncateString$1$1(str, length, from, ellipsis);
  }

});

Sugar$5A$1.String.truncate;

var Sugar$5z$1 = sugarCore$1.exports,
    truncateString$3 = truncateString_1$1;

Sugar$5z$1.String.defineInstance({

  'truncateOnWord': function(str, length, from, ellipsis) {
    return truncateString$3(str, length, from, ellipsis, true);
  }

});

Sugar$5z$1.String.truncateOnWord;

var Sugar$5y$1 = sugarCore$1.exports,
    stringUnderscore$5 = stringUnderscore_1$1;

Sugar$5y$1.String.defineInstance({

  'underscore': function(str) {
    return stringUnderscore$5(str);
  }

});

Sugar$5y$1.String.underscore;

var HTML_ENTITY_REG$1$1 = /&#?(x)?([\w\d]{0,5});/gi;

var HTML_ENTITY_REG$2 = HTML_ENTITY_REG$1$1,
    HTMLFromEntityMap$3 = HTMLFromEntityMap_1$1,
    chr$2$1 = chr$6$1;

function unescapeHTML$1$1(str) {
  return str.replace(HTML_ENTITY_REG$2, function(full, hex, code) {
    var special = HTMLFromEntityMap$3[code];
    return special || chr$2$1(hex ? parseInt(code, 16) : +code);
  });
}

var unescapeHTML_1$1 = unescapeHTML$1$1;

var Sugar$5x$1 = sugarCore$1.exports,
    unescapeHTML$2 = unescapeHTML_1$1;

Sugar$5x$1.String.defineInstance({

  'unescapeHTML': function(str) {
    return unescapeHTML$2(str);
  }

});

Sugar$5x$1.String.unescapeHTML;

var Sugar$5w$1 = sugarCore$1.exports;

Sugar$5w$1.String.defineInstance({

  'unescapeURL': function(str, param) {
    return param ? decodeURI(str) : decodeURIComponent(str);
  }

});

Sugar$5w$1.String.unescapeURL;

var Sugar$5v$1 = sugarCore$1.exports,
    trim$1$1 = trim_1$1,
    stringEach$6 = stringEach_1$1;

Sugar$5v$1.String.defineInstance({

  'words': function(str, eachWordFn) {
    return stringEach$6(trim$1$1(str), /\S+/g, eachWordFn);
  }

});

Sugar$5v$1.String.words;

var Sugar$5u$1 = sugarCore$1.exports,
    trunc$a$1 = trunc_1$1,
    mathAliases$t$1 = mathAliases$z$1,
    isUndefined$f$1 = isUndefined_1$1;

var min$6$1 = mathAliases$t$1.min,
    max$7$1 = mathAliases$t$1.max;

Sugar$5u$1.Number.defineStatic({

  'random': function(n1, n2) {
    var minNum, maxNum;
    if (arguments.length == 1) n2 = n1, n1 = 0;
    minNum = min$6$1(n1 || 0, isUndefined$f$1(n2) ? 1 : n2);
    maxNum = max$7$1(n1 || 0, isUndefined$f$1(n2) ? 1 : n2) + 1;
    return trunc$a$1((Math.random() * (maxNum - minNum)) + minNum);
  }

});

Sugar$5u$1.Number.random;

var AbbreviationUnits$3$1 = {
  BASIC_UNITS: '|kmbt',
  MEMORY_UNITS: '|KMGTPE',
  MEMORY_BINARY_UNITS: '|,Ki,Mi,Gi,Ti,Pi,Ei',
  METRIC_UNITS_SHORT: 'nμm|k',
  METRIC_UNITS_FULL: 'yzafpnμm|KMGTPEZY'
};

var CommonChars$2$1 = CommonChars$8$1;

var HALF_WIDTH_COMMA$1$1 = CommonChars$2$1.HALF_WIDTH_COMMA;

function commaSplit$2$1(str) {
  return str.split(HALF_WIDTH_COMMA$1$1);
}

var commaSplit_1$1 = commaSplit$2$1;

var mathAliases$s$1 = mathAliases$z$1;

var abs$9$1 = mathAliases$s$1.abs,
    pow$2$1 = mathAliases$s$1.pow,
    round$4$1 = mathAliases$s$1.round;

function withPrecision$5$1(val, precision, fn) {
  var multiplier = pow$2$1(10, abs$9$1(precision || 0));
  fn = fn || round$4$1;
  if (precision < 0) multiplier = 1 / multiplier;
  return fn(val * multiplier) / multiplier;
}

var withPrecision_1$1 = withPrecision$5$1;

var CommonChars$1$1 = CommonChars$8$1;

var HALF_WIDTH_PERIOD$5 = CommonChars$1$1.HALF_WIDTH_PERIOD,
    HALF_WIDTH_COMMA$3 = CommonChars$1$1.HALF_WIDTH_COMMA;

var NUMBER_OPTIONS$1$1 = {
  'decimal': HALF_WIDTH_PERIOD$5,
  'thousands': HALF_WIDTH_COMMA$3
};

var NUMBER_OPTIONS_1$1 = NUMBER_OPTIONS$1$1;

var Sugar$5t$1 = sugarCore$1.exports;

var namespaceAliases$e$1 = {
  sugarObject: Sugar$5t$1.Object,
  sugarArray: Sugar$5t$1.Array,
  sugarDate: Sugar$5t$1.Date,
  sugarString: Sugar$5t$1.String,
  sugarNumber: Sugar$5t$1.Number,
  sugarFunction: Sugar$5t$1.Function,
  sugarRegExp: Sugar$5t$1.RegExp
};

var coreUtilityAliases$D$1 = coreUtilityAliases$M$1;

var forEachProperty$m$1 = coreUtilityAliases$D$1.forEachProperty;

function simpleMerge$4$1(target, source) {
  forEachProperty$m$1(source, function(val, key) {
    target[key] = val;
  });
  return target;
}

var simpleMerge_1$1 = simpleMerge$4$1;

var simpleMerge$3$1 = simpleMerge_1$1;

function simpleClone$4$1(obj) {
  return simpleMerge$3$1({}, obj);
}

var simpleClone_1$1 = simpleClone$4$1;

var coreUtilityAliases$C$1 = coreUtilityAliases$M$1;

var setProperty$1$1 = coreUtilityAliases$C$1.setProperty;

function defineAccessor$1$1(namespace, name, fn) {
  setProperty$1$1(namespace, name, fn);
}

var defineAccessor_1$1 = defineAccessor$1$1;

var simpleClone$3$1 = simpleClone_1$1,
    defineAccessor$2 = defineAccessor_1$1,
    coreUtilityAliases$B$1 = coreUtilityAliases$M$1;

var forEachProperty$l$1 = coreUtilityAliases$B$1.forEachProperty;

function defineOptionsAccessor$3$1(namespace, defaults) {
  var obj = simpleClone$3$1(defaults);

  function getOption(name) {
    return obj[name];
  }

  function setOption(arg1, arg2) {
    var options;
    if (arguments.length === 1) {
      options = arg1;
    } else {
      options = {};
      options[arg1] = arg2;
    }
    forEachProperty$l$1(options, function(val, name) {
      if (val === null) {
        val = defaults[name];
      }
      obj[name] = val;
    });
  }

  defineAccessor$2(namespace, 'getOption', getOption);
  defineAccessor$2(namespace, 'setOption', setOption);
  return getOption;
}

var defineOptionsAccessor_1$1 = defineOptionsAccessor$3$1;

var NUMBER_OPTIONS$2 = NUMBER_OPTIONS_1$1,
    namespaceAliases$d$1 = namespaceAliases$e$1,
    defineOptionsAccessor$2$1 = defineOptionsAccessor_1$1;

var sugarNumber$2$1 = namespaceAliases$d$1.sugarNumber;

var _numberOptions$1$1 = defineOptionsAccessor$2$1(sugarNumber$2$1, NUMBER_OPTIONS$2);

var classChecks$N$1 = classChecks$Z$1,
    mathAliases$r$1 = mathAliases$z$1,
    periodSplit$1$1 = periodSplit_1$1,
    repeatString$1$1 = repeatString_1$1,
    withPrecision$4$1 = withPrecision_1$1,
    _numberOptions$2 = _numberOptions$1$1;

var isNumber$b$1 = classChecks$N$1.isNumber,
    max$6$1 = mathAliases$r$1.max;

function numberFormat$2$1(num, place) {
  var result = '', thousands, decimal, fraction, integer, split, str;

  decimal   = _numberOptions$2('decimal');
  thousands = _numberOptions$2('thousands');

  if (isNumber$b$1(place)) {
    str = withPrecision$4$1(num, place || 0).toFixed(max$6$1(place, 0));
  } else {
    str = num.toString();
  }

  str = str.replace(/^-/, '');
  split    = periodSplit$1$1(str);
  integer  = split[0];
  fraction = split[1];
  if (/e/.test(str)) {
    result = str;
  } else {
    for(var i = integer.length; i > 0; i -= 3) {
      if (i < integer.length) {
        result = thousands + result;
      }
      result = integer.slice(max$6$1(0, i - 3), i) + result;
    }
  }
  if (fraction) {
    result += decimal + repeatString$1$1('0', (place || 0) - fraction.length) + fraction;
  }
  return (num < 0 ? '-' : '') + result;
}

var numberFormat_1$1 = numberFormat$2$1;

var commaSplit$1$1 = commaSplit_1$1,
    mathAliases$q$1 = mathAliases$z$1,
    numberFormat$1$1 = numberFormat_1$1,
    withPrecision$3$1 = withPrecision_1$1;

var abs$8$1 = mathAliases$q$1.abs,
    pow$1$1 = mathAliases$q$1.pow,
    min$5$1 = mathAliases$q$1.min,
    max$5$1 = mathAliases$q$1.max,
    floor$2$1 = mathAliases$q$1.floor;

function abbreviateNumber$3$1(num, precision, ustr, bytes) {
  var fixed        = num.toFixed(20),
      decimalPlace = fixed.search(/\./),
      numeralPlace = fixed.search(/[1-9]/),
      significant  = decimalPlace - numeralPlace,
      units, unit, mid, i, divisor;
  if (significant > 0) {
    significant -= 1;
  }
  units = commaSplit$1$1(ustr);
  if (units.length === 1) {
    units = ustr.split('');
  }
  mid = units.indexOf('|');
  if (mid === -1) {
    // Skipping the placeholder means the units should start from zero,
    // otherwise assume they end at zero.
    mid = units[0] === '_' ? 0 : units.length;
  }
  i = max$5$1(min$5$1(floor$2$1(significant / 3), units.length - mid - 1), -mid);
  unit = units[i + mid];
  while (unit === '_') {
    i += i < 0 ? -1 : 1;
    unit = units[i + mid];
  }
  if (unit === '|') {
    unit = '';
  }
  if (significant < -9) {
    precision = abs$8$1(significant) - 9;
  }
  divisor = bytes ? pow$1$1(2, 10 * i) : pow$1$1(10, i * 3);
  return numberFormat$1$1(withPrecision$3$1(num / divisor, precision || 0)) + unit;
}

var abbreviateNumber_1$1 = abbreviateNumber$3$1;

var Sugar$5s$1 = sugarCore$1.exports,
    AbbreviationUnits$2$1 = AbbreviationUnits$3$1,
    abbreviateNumber$2$1 = abbreviateNumber_1$1;

var BASIC_UNITS$1 = AbbreviationUnits$2$1.BASIC_UNITS;

Sugar$5s$1.Number.defineInstance({

  'abbr': function(n, precision) {
    return abbreviateNumber$2$1(n, precision, BASIC_UNITS$1);
  }

});

Sugar$5s$1.Number.abbr;

function wrapNamespace$1$1(method) {
  return function(sugarNamespace, arg1, arg2) {
    sugarNamespace[method](arg1, arg2);
  };
}

var wrapNamespace_1$1 = wrapNamespace$1$1;

var wrapNamespace$2 = wrapNamespace_1$1;

var methodDefineAliases$3$1 = {
  alias: wrapNamespace$2('alias'),
  defineStatic: wrapNamespace$2('defineStatic'),
  defineInstance: wrapNamespace$2('defineInstance'),
  defineStaticPolyfill: wrapNamespace$2('defineStaticPolyfill'),
  defineInstancePolyfill: wrapNamespace$2('defineInstancePolyfill'),
  defineInstanceAndStatic: wrapNamespace$2('defineInstanceAndStatic'),
  defineInstanceWithArguments: wrapNamespace$2('defineInstanceWithArguments')
};

var forEach$g$1 = forEach_1$1,
    spaceSplit$4$1 = spaceSplit_1$1,
    classChecks$M$1 = classChecks$Z$1;

var isString$c$1 = classChecks$M$1.isString;

function collectSimilarMethods$2$1(set, fn) {
  var methods = {};
  if (isString$c$1(set)) {
    set = spaceSplit$4$1(set);
  }
  forEach$g$1(set, function(el, i) {
    fn(methods, el, i);
  });
  return methods;
}

var collectSimilarMethods_1$1 = collectSimilarMethods$2$1;

var methodDefineAliases$2$1 = methodDefineAliases$3$1,
    collectSimilarMethods$1$1 = collectSimilarMethods_1$1;

var defineInstance$1 = methodDefineAliases$2$1.defineInstance;

function defineInstanceSimilar$5$1(sugarNamespace, set, fn, flags) {
  defineInstance$1(sugarNamespace, collectSimilarMethods$1$1(set, fn), flags);
}

var defineInstanceSimilar_1$1 = defineInstanceSimilar$5$1;

var namespaceAliases$c$1 = namespaceAliases$e$1,
    defineInstanceSimilar$4$1 = defineInstanceSimilar_1$1;

var sugarNumber$1$1 = namespaceAliases$c$1.sugarNumber;

function buildMathAliases$1$1() {
  defineInstanceSimilar$4$1(sugarNumber$1$1, 'abs pow sin asin cos acos tan atan exp pow sqrt', function(methods, name) {
    methods[name] = function(n, arg) {
      // Note that .valueOf() here is only required due to a
      // very strange bug in iOS7 that only occurs occasionally
      // in which Math.abs() called on non-primitive numbers
      // returns a completely different number (Issue #400)
      return Math[name](n.valueOf(), arg);
    };
  });
}

var buildMathAliases_1$1 = buildMathAliases$1$1;

var buildMathAliases$2 = buildMathAliases_1$1;

buildMathAliases$2();

var Sugar$5r$1 = sugarCore$1.exports;



Sugar$5r$1.Number.abs;

var Sugar$5q$1 = sugarCore$1.exports;



Sugar$5q$1.Number.acos;

var Sugar$5p$1 = sugarCore$1.exports;



Sugar$5p$1.Number.asin;

var Sugar$5o$1 = sugarCore$1.exports;



Sugar$5o$1.Number.atan;

var Sugar$5n$1 = sugarCore$1.exports,
    AbbreviationUnits$1$1 = AbbreviationUnits$3$1,
    abbreviateNumber$1$1 = abbreviateNumber_1$1;

var MEMORY_UNITS$1 = AbbreviationUnits$1$1.MEMORY_UNITS,
    MEMORY_BINARY_UNITS$1 = AbbreviationUnits$1$1.MEMORY_BINARY_UNITS;

Sugar$5n$1.Number.defineInstance({

  'bytes': function(n, precision, binary, units) {
    if (units === 'binary' || (!units && binary)) {
      units = MEMORY_BINARY_UNITS$1;
    } else if(units === 'si' || !units) {
      units = MEMORY_UNITS$1;
    }
    return abbreviateNumber$1$1(n, precision, units, binary) + 'B';
  }

});

Sugar$5n$1.Number.bytes;

var withPrecision$2$1 = withPrecision_1$1;

function createRoundingFunction$3$1(fn) {
  return function(n, precision) {
    return precision ? withPrecision$2$1(n, precision, fn) : fn(n);
  };
}

var createRoundingFunction_1$1 = createRoundingFunction$3$1;

var Sugar$5m$1 = sugarCore$1.exports,
    mathAliases$p$1 = mathAliases$z$1,
    createRoundingFunction$2$1 = createRoundingFunction_1$1;

var ceil$5$1 = mathAliases$p$1.ceil;

Sugar$5m$1.Number.defineInstance({

  'ceil': createRoundingFunction$2$1(ceil$5$1)

});

Sugar$5m$1.Number.ceil;

var Sugar$5l$1 = sugarCore$1.exports,
    chr$1$1 = chr$6$1;

Sugar$5l$1.Number.defineInstance({

  'chr': function(n) {
    return chr$1$1(n);
  }

});

Sugar$5l$1.Number.chr;

var Sugar$5k$1 = sugarCore$1.exports;



Sugar$5k$1.Number.cos;

var Sugar$5j$1 = sugarCore$1.exports;



Sugar$5j$1.Number.exp;

var Sugar$5i$1 = sugarCore$1.exports,
    mathAliases$o$1 = mathAliases$z$1,
    createRoundingFunction$1$1 = createRoundingFunction_1$1;

var floor$1$1 = mathAliases$o$1.floor;

Sugar$5i$1.Number.defineInstance({

  'floor': createRoundingFunction$1$1(floor$1$1)

});

Sugar$5i$1.Number.floor;

var Sugar$5h$1 = sugarCore$1.exports,
    numberFormat$3 = numberFormat_1$1;

Sugar$5h$1.Number.defineInstance({

  'format': function(n, place) {
    return numberFormat$3(n, place);
  }

});

Sugar$5h$1.Number.format;

var mathAliases$n$1 = mathAliases$z$1,
    repeatString$4 = repeatString_1$1;

var abs$7$1 = mathAliases$n$1.abs;

function padNumber$5$1(num, place, sign, base, replacement) {
  var str = abs$7$1(num).toString(base || 10);
  str = repeatString$4(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
  if (sign || num < 0) {
    str = (num < 0 ? '-' : '+') + str;
  }
  return str;
}

var padNumber_1$1 = padNumber$5$1;

var Sugar$5g$1 = sugarCore$1.exports,
    padNumber$4$1 = padNumber_1$1;

Sugar$5g$1.Number.defineInstance({

  'hex': function(n, pad) {
    return padNumber$4$1(n, pad || 1, false, 16);
  }

});

Sugar$5g$1.Number.hex;

function isMultipleOf$3$1(n1, n2) {
  return n1 % n2 === 0;
}

var isMultipleOf_1$1 = isMultipleOf$3$1;

var Sugar$5f$1 = sugarCore$1.exports,
    isMultipleOf$2$1 = isMultipleOf_1$1;

Sugar$5f$1.Number.defineInstance({

  'isEven': function(n) {
    return isMultipleOf$2$1(n, 2);
  }

});

Sugar$5f$1.Number.isEven;

function isInteger$2$1(n) {
  return n % 1 === 0;
}

var isInteger_1$1 = isInteger$2$1;

var Sugar$5e$1 = sugarCore$1.exports,
    isInteger$1$1 = isInteger_1$1;

Sugar$5e$1.Number.defineInstance({

  'isInteger': function(n) {
    return isInteger$1$1(n);
  }

});

Sugar$5e$1.Number.isInteger;

var Sugar$5d$1 = sugarCore$1.exports,
    isMultipleOf$1$1 = isMultipleOf_1$1;

Sugar$5d$1.Number.defineInstance({

  'isMultipleOf': function(n, num) {
    return isMultipleOf$1$1(n, num);
  }

});

Sugar$5d$1.Number.isMultipleOf;

var Sugar$5c$1 = sugarCore$1.exports,
    isInteger$3 = isInteger_1$1,
    isMultipleOf$4 = isMultipleOf_1$1;

Sugar$5c$1.Number.defineInstance({

  'isOdd': function(n) {
    return isInteger$3(n) && !isMultipleOf$4(n, 2);
  }

});

Sugar$5c$1.Number.isOdd;

var Sugar$5b$1 = sugarCore$1.exports;

Sugar$5b$1.Number.defineInstance({

  'log': function(n, base) {
    return Math.log(n) / (base ? Math.log(base) : 1);
  }

});

Sugar$5b$1.Number.log;

var Sugar$5a$1 = sugarCore$1.exports,
    AbbreviationUnits$4 = AbbreviationUnits$3$1,
    abbreviateNumber$4 = abbreviateNumber_1$1;

var METRIC_UNITS_SHORT$1 = AbbreviationUnits$4.METRIC_UNITS_SHORT,
    METRIC_UNITS_FULL$1 = AbbreviationUnits$4.METRIC_UNITS_FULL;

Sugar$5a$1.Number.defineInstance({

  'metric': function(n, precision, units) {
    if (units === 'all') {
      units = METRIC_UNITS_FULL$1;
    } else if (!units) {
      units = METRIC_UNITS_SHORT$1;
    }
    return abbreviateNumber$4(n, precision, units);
  }

});

Sugar$5a$1.Number.metric;

function getOrdinalSuffix$2$1(num) {
  if (num >= 11 && num <= 13) {
    return 'th';
  } else {
    switch(num % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  }
}

var getOrdinalSuffix_1$1 = getOrdinalSuffix$2$1;

var Sugar$59$1 = sugarCore$1.exports,
    mathAliases$m$1 = mathAliases$z$1,
    getOrdinalSuffix$1$1 = getOrdinalSuffix_1$1;

var abs$6$1 = mathAliases$m$1.abs;

Sugar$59$1.Number.defineInstance({

  'ordinalize': function(n) {
    var num = abs$6$1(n), last = +num.toString().slice(-2);
    return n + getOrdinalSuffix$1$1(last);
  }

});

Sugar$59$1.Number.ordinalize;

var Sugar$58$1 = sugarCore$1.exports,
    padNumber$3$1 = padNumber_1$1;

Sugar$58$1.Number.defineInstance({

  'pad': function(n, place, sign, base) {
    return padNumber$3$1(n, place, sign, base);
  }

});

Sugar$58$1.Number.pad;

var Sugar$57$1 = sugarCore$1.exports;



Sugar$57$1.Number.pow;

var Sugar$56$1 = sugarCore$1.exports,
    mathAliases$l$1 = mathAliases$z$1,
    createRoundingFunction$4 = createRoundingFunction_1$1;

var round$3$1 = mathAliases$l$1.round;

Sugar$56$1.Number.defineInstance({

  'round': createRoundingFunction$4(round$3$1)

});

Sugar$56$1.Number.round;

var Sugar$55$1 = sugarCore$1.exports;



Sugar$55$1.Number.sin;

var Sugar$54$1 = sugarCore$1.exports;



Sugar$54$1.Number.sqrt;

var Sugar$53$1 = sugarCore$1.exports;



Sugar$53$1.Number.tan;

var Sugar$52$1 = sugarCore$1.exports,
    isDefined$f$1 = isDefined_1$1;

Sugar$52$1.Number.defineInstance({

  'times': function(n, indexMapFn) {
    var arr, result;
    for(var i = 0; i < n; i++) {
      result = indexMapFn.call(n, i);
      if (isDefined$f$1(result)) {
        if (!arr) {
          arr = [];
        }
        arr.push(result);
      }
    }
    return arr;
  }

});

Sugar$52$1.Number.times;

var Sugar$51$1 = sugarCore$1.exports;

Sugar$51$1.Number.defineInstance({

  'toNumber': function(n) {
    return n.valueOf();
  }

});

Sugar$51$1.Number.toNumber;

var Sugar$50$1 = sugarCore$1.exports;

Sugar$50$1.Number.getOption;

var Sugar$4$$1 = sugarCore$1.exports;

Sugar$4$$1.Number.setOption;

var Sugar$4_$1 = sugarCore$1.exports,
    coercePositiveInteger$2$1 = coercePositiveInteger_1$1;

Sugar$4_$1.Array.defineStatic({

  'construct': function(n, indexMapFn) {
    n = coercePositiveInteger$2$1(n);
    return Array.from(new Array(n), function(el, i) {
      return indexMapFn && indexMapFn(i);
    });
  }

});

Sugar$4_$1.Array.construct;

var forEach$f$1 = forEach_1$1;

function arrayClone$6$1(arr) {
  var clone = new Array(arr.length);
  forEach$f$1(arr, function(el, i) {
    clone[i] = el;
  });
  return clone;
}

var arrayClone_1$1 = arrayClone$6$1;

var classChecks$L$1 = classChecks$Z$1;

var isArray$c$1 = classChecks$L$1.isArray;

function isArrayOrInherited$1$1(obj) {
  return obj && obj.constructor && isArray$c$1(obj.constructor.prototype);
}

var isArrayOrInherited_1$1 = isArrayOrInherited$1$1;

var isDefined$e$1 = isDefined_1$1,
    arrayClone$5$1 = arrayClone_1$1,
    classChecks$K$1 = classChecks$Z$1,
    isObjectType$a$1 = isObjectType_1$1,
    isArrayOrInherited$2 = isArrayOrInherited_1$1;

var isString$b$1 = classChecks$K$1.isString;

function arrayCreate$2$1(obj, clone) {
  var arr;
  if (isArrayOrInherited$2(obj)) {
    arr = clone ? arrayClone$5$1(obj) : obj;
  } else if (isObjectType$a$1(obj) || isString$b$1(obj)) {
    arr = Array.from(obj);
  } else if (isDefined$e$1(obj)) {
    arr = [obj];
  }
  return arr || [];
}

var arrayCreate_1$1 = arrayCreate$2$1;

function setChainableConstructor$2$1(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

var setChainableConstructor_1$1 = setChainableConstructor$2$1;

var arrayCreate$1$1 = arrayCreate_1$1,
    namespaceAliases$b$1 = namespaceAliases$e$1,
    setChainableConstructor$1$1 = setChainableConstructor_1$1;

var sugarArray$2$1 = namespaceAliases$b$1.sugarArray;

function setArrayChainableConstructor$1$1() {
  setChainableConstructor$1$1(sugarArray$2$1, arrayCreate$1$1);
}

var setArrayChainableConstructor_1$1 = setArrayChainableConstructor$1$1;

var setArrayChainableConstructor$2 = setArrayChainableConstructor_1$1;

setArrayChainableConstructor$2();

var Sugar$4Z$1 = sugarCore$1.exports,
    arrayCreate$3 = arrayCreate_1$1;



Sugar$4Z$1.Array.defineStatic({

  'create': function(obj, clone) {
    return arrayCreate$3(obj, clone);
  }

});

Sugar$4Z$1.Array.create;

var isDefined$d$1 = isDefined_1$1;

function arrayAppend$2$1(arr, el, index) {
  var spliceArgs;
  index = +index;
  if (isNaN(index)) {
    index = arr.length;
  }
  spliceArgs = [index, 0];
  if (isDefined$d$1(el)) {
    spliceArgs = spliceArgs.concat(el);
  }
  arr.splice.apply(arr, spliceArgs);
  return arr;
}

var arrayAppend_1$1 = arrayAppend$2$1;

var Sugar$4Y$1 = sugarCore$1.exports,
    arrayClone$4$1 = arrayClone_1$1,
    arrayAppend$1$1 = arrayAppend_1$1;

Sugar$4Y$1.Array.defineInstance({

  'add': function(arr, item, index) {
    return arrayAppend$1$1(arrayClone$4$1(arr), item, index);
  }

});

Sugar$4Y$1.Array.add;

var Sugar$4X$1 = sugarCore$1.exports,
    arrayAppend$3 = arrayAppend_1$1;

Sugar$4X$1.Array.defineInstance({

  'append': function(arr, item, index) {
    return arrayAppend$3(arr, item, index);
  }

});

Sugar$4X$1.Array.append;

var Sugar$4W$1 = sugarCore$1.exports,
    getEntriesForIndexes$3 = getEntriesForIndexes_1$1;

Sugar$4W$1.Array.defineInstance({

  'at': function(arr, index, loop) {
    return getEntriesForIndexes$3(arr, index, loop);
  }

});

Sugar$4W$1.Array.at;

var Sugar$4V$1 = sugarCore$1.exports,
    arrayClone$3$1 = arrayClone_1$1;

Sugar$4V$1.Array.defineInstance({

  'clone': function(arr) {
    return arrayClone$3$1(arr);
  }

});

Sugar$4V$1.Array.clone;

var filter$1$1 = filter_1$1;

function arrayCompact$1$1(arr, all) {
  return filter$1$1(arr, function(el) {
    return el || (!all && el != null && el.valueOf() === el.valueOf());
  });
}

var arrayCompact_1$1 = arrayCompact$1$1;

var Sugar$4U$1 = sugarCore$1.exports,
    arrayCompact$2 = arrayCompact_1$1;

Sugar$4U$1.Array.defineInstance({

  'compact': function(arr, all) {
    return arrayCompact$2(arr, all);
  }

});

Sugar$4U$1.Array.compact;

function dateMatcher$1$1(d) {
  var ms = d.getTime();
  return function(el) {
    return !!(el && el.getTime) && el.getTime() === ms;
  };
}

var dateMatcher_1$1 = dateMatcher$1$1;

function regexMatcher$1$1(reg) {
  reg = RegExp(reg);
  return function(el) {
    return reg.test(el);
  };
}

var regexMatcher_1$1 = regexMatcher$1$1;

function getKeys$6$1(obj) {
  return Object.keys(obj);
}

var getKeys_1$1 = getKeys$6$1;

function setToArray$1$1(set) {
  var arr = new Array(set.size), i = 0;
  set.forEach(function(val) {
    arr[i++] = val;
  });
  return arr;
}

var setToArray_1$1 = setToArray$1$1;

function mapToArray$1$1(map) {
  var arr = new Array(map.size), i = 0;
  map.forEach(function(val, key) {
    arr[i++] = [key, val];
  });
  return arr;
}

var mapToArray_1$1 = mapToArray$1$1;

var getKeys$5$1 = getKeys_1$1,
    coreUtilityAliases$A$1 = coreUtilityAliases$M$1;

var forEachProperty$k$1 = coreUtilityAliases$A$1.forEachProperty;

function iterateWithCyclicCheck$2$1(obj, sortedKeys, stack, fn) {

  function next(val, key) {
    var cyc = false;

    // Allowing a step into the structure before triggering this check to save
    // cycles on standard JSON structures and also to try as hard as possible to
    // catch basic properties that may have been modified.
    if (stack.length > 1) {
      var i = stack.length;
      while (i--) {
        if (stack[i] === val) {
          cyc = true;
        }
      }
    }

    stack.push(val);
    fn(key, val, cyc, stack);
    stack.pop();
  }

  function iterateWithSortedKeys() {
    // Sorted keys is required for serialization, where object order
    // does not matter but stringified order does.
    var arr = getKeys$5$1(obj).sort(), key;
    for (var i = 0; i < arr.length; i++) {
      key = arr[i];
      next(obj[key], arr[i]);
    }
  }

  // This method for checking for cyclic structures was egregiously stolen from
  // the ingenious method by @kitcambridge from the Underscore script:
  // https://github.com/documentcloud/underscore/issues/240
  if (!stack) {
    stack = [];
  }

  if (sortedKeys) {
    iterateWithSortedKeys();
  } else {
    forEachProperty$k$1(obj, next);
  }
}

var iterateWithCyclicCheck_1$1 = iterateWithCyclicCheck$2$1;

var getKeys$4$1 = getKeys_1$1,
    setToArray$2 = setToArray_1$1,
    mapToArray$2 = mapToArray_1$1,
    classChecks$J$1 = classChecks$Z$1,
    isObjectType$9$1 = isObjectType_1$1,
    coreUtilityAliases$z$1 = coreUtilityAliases$M$1,
    iterateWithCyclicCheck$1$1 = iterateWithCyclicCheck_1$1;

var classToString$4$1 = coreUtilityAliases$z$1.classToString,
    isSerializable$1$1 = classChecks$J$1.isSerializable,
    isSet$1$1 = classChecks$J$1.isSet,
    isMap$1$1 = classChecks$J$1.isMap,
    isError$1$1 = classChecks$J$1.isError;

function isEqual$4$1(a, b, stack) {
  var aClass, bClass;
  if (a === b) {
    // Return quickly up front when matched by reference,
    // but be careful about 0 !== -0.
    return a !== 0 || 1 / a === 1 / b;
  }
  aClass = classToString$4$1(a);
  bClass = classToString$4$1(b);
  if (aClass !== bClass) {
    return false;
  }

  if (isSerializable$1$1(a, aClass) && isSerializable$1$1(b, bClass)) {
    return objectIsEqual$1(a, b, aClass, stack);
  } else if (isSet$1$1(a, aClass) && isSet$1$1(b, bClass)) {
    return a.size === b.size && isEqual$4$1(setToArray$2(a), setToArray$2(b), stack);
  } else if (isMap$1$1(a, aClass) && isMap$1$1(b, bClass)) {
    return a.size === b.size && isEqual$4$1(mapToArray$2(a), mapToArray$2(b), stack);
  } else if (isError$1$1(a, aClass) && isError$1$1(b, bClass)) {
    return a.toString() === b.toString();
  }

  return false;
}

function objectIsEqual$1(a, b, aClass, stack) {
  var aType = typeof a, bType = typeof b, propsEqual, count;
  if (aType !== bType) {
    return false;
  }
  if (isObjectType$9$1(a.valueOf())) {
    if (a.length !== b.length) {
      // perf: Quickly returning up front for arrays.
      return false;
    }
    count = 0;
    propsEqual = true;
    iterateWithCyclicCheck$1$1(a, false, stack, function(key, val, cyc, stack) {
      if (!cyc && (!(key in b) || !isEqual$4$1(val, b[key], stack))) {
        propsEqual = false;
      }
      count++;
      return propsEqual;
    });
    if (!propsEqual || count !== getKeys$4$1(b).length) {
      return false;
    }
  }
  // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
  return a.valueOf().toString() === b.valueOf().toString();
}

var isEqual_1$1 = isEqual$4$1;

var isEqual$3$1 = isEqual_1$1;

function defaultMatcher$1$1(f) {
  return function(el) {
    return isEqual$3$1(el, f);
  };
}

var defaultMatcher_1$1 = defaultMatcher$1$1;

function functionMatcher$1$1(fn) {
  return function(el, i, arr) {
    // Return true up front if match by reference
    return el === fn || fn.call(arr, el, i, arr);
  };
}

var functionMatcher_1$1 = functionMatcher$1$1;

var isPrimitive$5$1 = isPrimitive_1$1,
    classChecks$I$1 = classChecks$Z$1,
    dateMatcher$2 = dateMatcher_1$1,
    regexMatcher$2 = regexMatcher_1$1,
    isObjectType$8$1 = isObjectType_1$1,
    isPlainObject$2$1 = isPlainObject_1$1,
    defaultMatcher$2 = defaultMatcher_1$1,
    functionMatcher$2 = functionMatcher_1$1,
    coreUtilityAliases$y$1 = coreUtilityAliases$M$1;

var getOwn$a$1 = coreUtilityAliases$y$1.getOwn,
    classToString$3$1 = coreUtilityAliases$y$1.classToString,
    forEachProperty$j$1 = coreUtilityAliases$y$1.forEachProperty,
    isDate$9$1 = classChecks$I$1.isDate,
    isRegExp$4$1 = classChecks$I$1.isRegExp,
    isFunction$b$1 = classChecks$I$1.isFunction;

function getMatcher$8$1(f) {
  if (!isPrimitive$5$1(f)) {
    var className = classToString$3$1(f);
    if (isRegExp$4$1(f, className)) {
      return regexMatcher$2(f);
    } else if (isDate$9$1(f, className)) {
      return dateMatcher$2(f);
    } else if (isFunction$b$1(f, className)) {
      return functionMatcher$2(f);
    } else if (isPlainObject$2$1(f, className)) {
      return fuzzyMatcher$1(f);
    }
  }
  // Default is standard isEqual
  return defaultMatcher$2(f);
}

function fuzzyMatcher$1(obj) {
  var matchers = {};
  return function(el, i, arr) {
    var matched = true;
    if (!isObjectType$8$1(el)) {
      return false;
    }
    forEachProperty$j$1(obj, function(val, key) {
      matchers[key] = getOwn$a$1(matchers, key) || getMatcher$8$1(val);
      if (matchers[key].call(arr, el[key], i, arr) === false) {
        matched = false;
      }
      return matched;
    });
    return matched;
  };
}

var getMatcher_1$1 = getMatcher$8$1;

var getMatcher$7$1 = getMatcher_1$1;

function arrayExclude$1$1(arr, f) {
  var result = [], matcher = getMatcher$7$1(f);
  for (var i = 0; i < arr.length; i++) {
    if (!matcher(arr[i], i, arr)) {
      result.push(arr[i]);
    }
  }
  return result;
}

var arrayExclude_1$1 = arrayExclude$1$1;

var Sugar$4T$1 = sugarCore$1.exports,
    arrayExclude$2 = arrayExclude_1$1;

Sugar$4T$1.Array.defineInstance({

  'exclude': function(arr, f) {
    return arrayExclude$2(arr, f);
  }

});

Sugar$4T$1.Array.exclude;

var Sugar$4S$1 = sugarCore$1.exports,
    isUndefined$e$1 = isUndefined_1$1;

Sugar$4S$1.Array.defineInstance({

  'first': function(arr, num) {
    if (isUndefined$e$1(num)) return arr[0];
    if (num < 0) num = 0;
    return arr.slice(0, num);
  }

});

Sugar$4S$1.Array.first;

var forEach$e$1 = forEach_1$1,
    classChecks$H$1 = classChecks$Z$1;

var isArray$b$1 = classChecks$H$1.isArray;

function arrayFlatten$1$1(arr, level, current) {
  var result = [];
  level = level || Infinity;
  current = current || 0;
  forEach$e$1(arr, function(el) {
    if (isArray$b$1(el) && current < level) {
      result = result.concat(arrayFlatten$1$1(el, level, current + 1));
    } else {
      result.push(el);
    }
  });
  return result;
}

var arrayFlatten_1$1 = arrayFlatten$1$1;

var Sugar$4R$1 = sugarCore$1.exports,
    arrayFlatten$2 = arrayFlatten_1$1;

Sugar$4R$1.Array.defineInstance({

  'flatten': function(arr, limit) {
    return arrayFlatten$2(arr, limit);
  }

});

Sugar$4R$1.Array.flatten;

var Sugar$4Q$1 = sugarCore$1.exports;

Sugar$4Q$1.Array.defineInstance({

  'from': function(arr, num) {
    return arr.slice(num);
  }

});

Sugar$4Q$1.Array.from;

var map$4$1 = map_1$1,
    classChecks$G$1 = classChecks$Z$1,
    deepGetProperty$2$1 = deepGetProperty_1$1;

var isFunction$a$1 = classChecks$G$1.isFunction,
    isArray$a$1 = classChecks$G$1.isArray;

function mapWithShortcuts$6$1(el, f, context, mapArgs) {
  if (!f) {
    return el;
  } else if (f.apply) {
    return f.apply(context, mapArgs);
  } else if (isArray$a$1(f)) {
    return map$4$1(f, function(m) {
      return mapWithShortcuts$6$1(el, m, context, mapArgs);
    });
  } else if (isFunction$a$1(el[f])) {
    return el[f].call(el);
  } else {
    return deepGetProperty$2$1(el, f, true);
  }
}

var mapWithShortcuts_1$1 = mapWithShortcuts$6$1;

var forEach$d$1 = forEach_1$1,
    mapWithShortcuts$5$1 = mapWithShortcuts_1$1,
    coreUtilityAliases$x$1 = coreUtilityAliases$M$1;

var hasOwn$8$1 = coreUtilityAliases$x$1.hasOwn,
    forEachProperty$i$1 = coreUtilityAliases$x$1.forEachProperty;

function arrayGroupBy$1$1(arr, map, fn) {
  var result = {}, key;
  forEach$d$1(arr, function(el, i) {
    key = mapWithShortcuts$5$1(el, map, arr, [el, i, arr]);
    if (!hasOwn$8$1(result, key)) {
      result[key] = [];
    }
    result[key].push(el);
  });
  if (fn) {
    forEachProperty$i$1(result, fn);
  }
  return result;
}

var arrayGroupBy_1$1 = arrayGroupBy$1$1;

var Sugar$4P$1 = sugarCore$1.exports,
    arrayGroupBy$2 = arrayGroupBy_1$1;

Sugar$4P$1.Array.defineInstance({

  'groupBy': function(arr, map, groupFn) {
    return arrayGroupBy$2(arr, map, groupFn);
  }

});

Sugar$4P$1.Array.groupBy;

function simpleRepeat$2$1(n, fn) {
  for (var i = 0; i < n; i++) {
    fn(i);
  }
}

var simpleRepeat_1$1 = simpleRepeat$2$1;

var Sugar$4O$1 = sugarCore$1.exports,
    isDefined$c$1 = isDefined_1$1,
    mathAliases$k$1 = mathAliases$z$1,
    simpleRepeat$1$1 = simpleRepeat_1$1;

var ceil$4$1 = mathAliases$k$1.ceil;

Sugar$4O$1.Array.defineInstance({

  'inGroups': function(arr, num, padding) {
    var pad = isDefined$c$1(padding);
    var result = new Array(num);
    var divisor = ceil$4$1(arr.length / num);
    simpleRepeat$1$1(num, function(i) {
      var index = i * divisor;
      var group = arr.slice(index, index + divisor);
      if (pad && group.length < divisor) {
        simpleRepeat$1$1(divisor - group.length, function() {
          group.push(padding);
        });
      }
      result[i] = group;
    });
    return result;
  }

});

Sugar$4O$1.Array.inGroups;

var Sugar$4N$1 = sugarCore$1.exports,
    isUndefined$d$1 = isUndefined_1$1,
    mathAliases$j$1 = mathAliases$z$1,
    simpleRepeat$3 = simpleRepeat_1$1;

var ceil$3$1 = mathAliases$j$1.ceil;

Sugar$4N$1.Array.defineInstance({

  'inGroupsOf': function(arr, num, padding) {
    var result = [], len = arr.length, group;
    if (len === 0 || num === 0) return arr;
    if (isUndefined$d$1(num)) num = 1;
    if (isUndefined$d$1(padding)) padding = null;
    simpleRepeat$3(ceil$3$1(len / num), function(i) {
      group = arr.slice(num * i, num * i + num);
      while(group.length < num) {
        group.push(padding);
      }
      result.push(group);
    });
    return result;
  }

});

Sugar$4N$1.Array.inGroupsOf;

function arrayWrap$1$1(obj) {
  var arr = [];
  arr.push(obj);
  return arr;
}

var arrayWrap_1$1 = arrayWrap$1$1;

function isRealNaN$1$1(obj) {
  // This is only true of NaN
  return obj != null && obj !== obj;
}

var isRealNaN_1$1 = isRealNaN$1$1;

var indexOf$4 = indexOf_1$1,
    isRealNaN$2 = isRealNaN_1$1,
    isPrimitive$4$1 = isPrimitive_1$1,
    classChecks$F$1 = classChecks$Z$1,
    isObjectType$7$1 = isObjectType_1$1,
    coreUtilityAliases$w$1 = coreUtilityAliases$M$1,
    iterateWithCyclicCheck$3 = iterateWithCyclicCheck_1$1;

var classToString$2$1 = coreUtilityAliases$w$1.classToString,
    isSerializable$3 = classChecks$F$1.isSerializable;

function serializeInternal$4$1(obj, refs, stack) {
  var type = typeof obj, sign = '', className, value, ref;

  // Return up front on
  if (1 / obj === -Infinity) {
    sign = '-';
  }

  // Return quickly for primitives to save cycles
  if (isPrimitive$4$1(obj, type) && !isRealNaN$2(obj)) {
    return type + sign + obj;
  }

  className = classToString$2$1(obj);

  if (!isSerializable$3(obj, className)) {
    ref = indexOf$4(refs, obj);
    if (ref === -1) {
      ref = refs.length;
      refs.push(obj);
    }
    return ref;
  } else if (isObjectType$7$1(obj)) {
    value = serializeDeep$1(obj, refs, stack) + obj.toString();
  } else if (obj.valueOf) {
    value = obj.valueOf();
  }
  return type + className + sign + value;
}

function serializeDeep$1(obj, refs, stack) {
  var result = '';
  iterateWithCyclicCheck$3(obj, true, stack, function(key, val, cyc, stack) {
    result += cyc ? 'CYC' : key + serializeInternal$4$1(val, refs, stack);
  });
  return result;
}

var serializeInternal_1$1 = serializeInternal$4$1;

var forEach$c$1 = forEach_1$1,
    arrayWrap$2 = arrayWrap_1$1,
    classChecks$E$1 = classChecks$Z$1,
    serializeInternal$3$1 = serializeInternal_1$1,
    coreUtilityAliases$v$1 = coreUtilityAliases$M$1;

var isArray$9$1 = classChecks$E$1.isArray,
    hasOwn$7$1 = coreUtilityAliases$v$1.hasOwn;

function arrayIntersectOrSubtract$2$1(arr1, arr2, subtract) {
  var result = [], obj = {}, refs = [];
  if (!isArray$9$1(arr2)) {
    arr2 = arrayWrap$2(arr2);
  }
  forEach$c$1(arr2, function(el) {
    obj[serializeInternal$3$1(el, refs)] = true;
  });
  forEach$c$1(arr1, function(el) {
    var key = serializeInternal$3$1(el, refs);
    if (hasOwn$7$1(obj, key) !== subtract) {
      delete obj[key];
      result.push(el);
    }
  });
  return result;
}

var arrayIntersectOrSubtract_1$1 = arrayIntersectOrSubtract$2$1;

var Sugar$4M$1 = sugarCore$1.exports,
    arrayIntersectOrSubtract$1$1 = arrayIntersectOrSubtract_1$1;

Sugar$4M$1.Array.defineInstance({

  'intersect': function(arr1, arr2) {
    return arrayIntersectOrSubtract$1$1(arr1, arr2, false);
  }

});

Sugar$4M$1.Array.intersect;

var Sugar$4L$1 = sugarCore$1.exports;

Sugar$4L$1.Array.defineInstance({

  'isEmpty': function(arr) {
    return arr.length === 0;
  }

});

Sugar$4L$1.Array.isEmpty;

var Sugar$4K$1 = sugarCore$1.exports,
    isEqual$2$1 = isEqual_1$1;

Sugar$4K$1.Array.defineInstance({

  'isEqual': function(a, b) {
    return isEqual$2$1(a, b);
  }

});

Sugar$4K$1.Array.isEqual;

var Sugar$4J$1 = sugarCore$1.exports,
    isUndefined$c$1 = isUndefined_1$1;

Sugar$4J$1.Array.defineInstance({

  'last': function(arr, num) {
    if (isUndefined$c$1(num)) return arr[arr.length - 1];
    var start = arr.length - num < 0 ? 0 : arr.length - num;
    return arr.slice(start);
  }

});

Sugar$4J$1.Array.last;

var getMatcher$6$1 = getMatcher_1$1;

function arrayRemove$1$1(arr, f) {
  var matcher = getMatcher$6$1(f), i = 0;
  while(i < arr.length) {
    if (matcher(arr[i], i, arr)) {
      arr.splice(i, 1);
    } else {
      i++;
    }
  }
  return arr;
}

var arrayRemove_1$1 = arrayRemove$1$1;

var Sugar$4I$1 = sugarCore$1.exports,
    arrayRemove$2 = arrayRemove_1$1;

Sugar$4I$1.Array.defineInstance({

  'remove': function(arr, f) {
    return arrayRemove$2(arr, f);
  }

});

Sugar$4I$1.Array.remove;

var Sugar$4H$1 = sugarCore$1.exports,
    isUndefined$b$1 = isUndefined_1$1;

Sugar$4H$1.Array.defineInstance({

  'removeAt': function(arr, start, end) {
    if (isUndefined$b$1(start)) return arr;
    if (isUndefined$b$1(end))   end = start;
    arr.splice(start, end - start + 1);
    return arr;
  }

});

Sugar$4H$1.Array.removeAt;

var Sugar$4G$1 = sugarCore$1.exports,
    trunc$9$1 = trunc_1$1,
    arrayClone$2$1 = arrayClone_1$1,
    classChecks$D$1 = classChecks$Z$1,
    isUndefined$a$1 = isUndefined_1$1,
    mathAliases$i$1 = mathAliases$z$1;

var isBoolean$4$1 = classChecks$D$1.isBoolean,
    min$4$1 = mathAliases$i$1.min;

Sugar$4G$1.Array.defineInstance({

  'sample': function(arr, arg1, arg2) {
    var result = [], num, remove, single;
    if (isBoolean$4$1(arg1)) {
      remove = arg1;
    } else {
      num = arg1;
      remove = arg2;
    }
    if (isUndefined$a$1(num)) {
      num = 1;
      single = true;
    }
    if (!remove) {
      arr = arrayClone$2$1(arr);
    }
    num = min$4$1(num, arr.length);
    for (var i = 0, index; i < num; i++) {
      index = trunc$9$1(Math.random() * arr.length);
      result.push(arr[index]);
      arr.splice(index, 1);
    }
    return single ? result[0] : result;
  }

});

Sugar$4G$1.Array.sample;

var arrayClone$1$1 = arrayClone_1$1;

function arrayShuffle$1$1(arr) {
  arr = arrayClone$1$1(arr);
  var i = arr.length, j, x;
  while(i) {
    j = (Math.random() * i) | 0;
    x = arr[--i];
    arr[i] = arr[j];
    arr[j] = x;
  }
  return arr;
}

var arrayShuffle_1$1 = arrayShuffle$1$1;

var Sugar$4F$1 = sugarCore$1.exports,
    arrayShuffle$2 = arrayShuffle_1$1;

Sugar$4F$1.Array.defineInstance({

  'shuffle': function(arr) {
    return arrayShuffle$2(arr);
  }

});

Sugar$4F$1.Array.shuffle;

var map$3$1 = map_1$1;

function getSortOrder$1$1() {
  var order = 'AÁÀÂÃĄBCĆČÇDĎÐEÉÈĚÊËĘFGĞHıIÍÌİÎÏJKLŁMNŃŇÑOÓÒÔPQRŘSŚŠŞTŤUÚÙŮÛÜVWXYÝZŹŻŽÞÆŒØÕÅÄÖ';
  return map$3$1(order.split(''), function(str) {
    return str + str.toLowerCase();
  }).join('');
}

var getSortOrder_1$1 = getSortOrder$1$1;

var HALF_WIDTH_NINE$1$1 = 0x39;

var FULL_WIDTH_NINE$1$1 = 0xff19;

var HALF_WIDTH_NINE$2 = HALF_WIDTH_NINE$1$1,
    FULL_WIDTH_NINE$2 = FULL_WIDTH_NINE$1$1,
    CommonChars$9 = CommonChars$8$1;

var HALF_WIDTH_ZERO$2 = CommonChars$9.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO$2 = CommonChars$9.FULL_WIDTH_ZERO;

function codeIsNumeral$1$1(code) {
  return (code >= HALF_WIDTH_ZERO$2 && code <= HALF_WIDTH_NINE$2) ||
         (code >= FULL_WIDTH_ZERO$2 && code <= FULL_WIDTH_NINE$2);
}

var codeIsNumeral_1$1 = codeIsNumeral$1$1;

function getSortOrderIndex$1$1(chr, sortOrder) {
  if (!chr) {
    return null;
  } else {
    return sortOrder.indexOf(chr);
  }
}

var getSortOrderIndex_1$1 = getSortOrderIndex$1$1;

var forEach$b$1 = forEach_1$1,
    spaceSplit$3$1 = spaceSplit_1$1;

function getSortEquivalents$1$1() {
  var equivalents = {};
  forEach$b$1(spaceSplit$3$1('AÁÀÂÃÄ CÇ EÉÈÊË IÍÌİÎÏ OÓÒÔÕÖ Sß UÚÙÛÜ'), function(set) {
    var first = set.charAt(0);
    forEach$b$1(set.slice(1).split(''), function(chr) {
      equivalents[chr] = first;
      equivalents[chr.toLowerCase()] = first.toLowerCase();
    });
  });
  return equivalents;
}

var getSortEquivalents_1$1 = getSortEquivalents$1$1;

var coreUtilityAliases$u$1 = coreUtilityAliases$M$1;

var getOwn$9$1 = coreUtilityAliases$u$1.getOwn;

function getCollationCharacter$1$1(str, index, sortEquivalents) {
  var chr = str.charAt(index);
  return getOwn$9$1(sortEquivalents, chr) || chr;
}

var getCollationCharacter_1$1 = getCollationCharacter$1$1;

function getCollationReadyString$1$1(str, sortIgnore, sortIgnoreCase) {
  if (sortIgnoreCase) {
    str = str.toLowerCase();
  }
  if (sortIgnore) {
    str = str.replace(sortIgnore, '');
  }
  return str;
}

var getCollationReadyString_1$1 = getCollationReadyString$1$1;

var getSortOrder$2 = getSortOrder_1$1,
    codeIsNumeral$2 = codeIsNumeral_1$1,
    stringToNumber$3 = stringToNumber_1$1,
    namespaceAliases$a$1 = namespaceAliases$e$1,
    getSortOrderIndex$2 = getSortOrderIndex_1$1,
    getSortEquivalents$2 = getSortEquivalents_1$1,
    defineOptionsAccessor$1$1 = defineOptionsAccessor_1$1,
    getCollationCharacter$2 = getCollationCharacter_1$1,
    getCollationReadyString$2 = getCollationReadyString_1$1;

var sugarArray$1$1 = namespaceAliases$a$1.sugarArray;

var ARRAY_OPTIONS$1$1 = {
  'sortIgnore':      null,
  'sortNatural':     true,
  'sortIgnoreCase':  true,
  'sortOrder':       getSortOrder$2(),
  'sortCollate':     collateStrings$1,
  'sortEquivalents': getSortEquivalents$2()
};

var _arrayOptions$1$1 = defineOptionsAccessor$1$1(sugarArray$1$1, ARRAY_OPTIONS$1$1);

function collateStrings$1(a, b) {
  var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;

  var sortOrder       = _arrayOptions$1$1('sortOrder');
  var sortIgnore      = _arrayOptions$1$1('sortIgnore');
  var sortNatural     = _arrayOptions$1$1('sortNatural');
  var sortIgnoreCase  = _arrayOptions$1$1('sortIgnoreCase');
  var sortEquivalents = _arrayOptions$1$1('sortEquivalents');

  a = getCollationReadyString$2(a, sortIgnore, sortIgnoreCase);
  b = getCollationReadyString$2(b, sortIgnore, sortIgnoreCase);

  do {

    aChar  = getCollationCharacter$2(a, index, sortEquivalents);
    bChar  = getCollationCharacter$2(b, index, sortEquivalents);
    aValue = getSortOrderIndex$2(aChar, sortOrder);
    bValue = getSortOrderIndex$2(bChar, sortOrder);

    if (aValue === -1 || bValue === -1) {
      aValue = a.charCodeAt(index) || null;
      bValue = b.charCodeAt(index) || null;
      if (sortNatural && codeIsNumeral$2(aValue) && codeIsNumeral$2(bValue)) {
        aValue = stringToNumber$3(a.slice(index));
        bValue = stringToNumber$3(b.slice(index));
      }
    } else {
      aEquiv = aChar !== a.charAt(index);
      bEquiv = bChar !== b.charAt(index);
      if (aEquiv !== bEquiv && tiebreaker === 0) {
        tiebreaker = aEquiv - bEquiv;
      }
    }
    index += 1;
  } while(aValue != null && bValue != null && aValue === bValue);
  if (aValue === bValue) return tiebreaker;
  return aValue - bValue;
}

var ARRAY_OPTIONS_1$1 = {
  ARRAY_OPTIONS: ARRAY_OPTIONS$1$1,
  _arrayOptions: _arrayOptions$1$1
};

var ARRAY_OPTIONS$2 = ARRAY_OPTIONS_1$1,
    classChecks$C$1 = classChecks$Z$1;

var isString$a$1 = classChecks$C$1.isString,
    isArray$8$1 = classChecks$C$1.isArray,
    _arrayOptions$2 = ARRAY_OPTIONS$2._arrayOptions;

function compareValue$1$1(aVal, bVal) {
  var cmp, i, collate;
  if (isString$a$1(aVal) && isString$a$1(bVal)) {
    collate = _arrayOptions$2('sortCollate');
    return collate(aVal, bVal);
  } else if (isArray$8$1(aVal) && isArray$8$1(bVal)) {
    if (aVal.length < bVal.length) {
      return -1;
    } else if (aVal.length > bVal.length) {
      return 1;
    } else {
      for(i = 0; i < aVal.length; i++) {
        cmp = compareValue$1$1(aVal[i], bVal[i]);
        if (cmp !== 0) {
          return cmp;
        }
      }
      return 0;
    }
  }
  return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}

var compareValue_1$1 = compareValue$1$1;

var Sugar$4E$1 = sugarCore$1.exports,
    compareValue$2 = compareValue_1$1,
    mapWithShortcuts$4$1 = mapWithShortcuts_1$1;

Sugar$4E$1.Array.defineInstance({

  'sortBy': function(arr, map, desc) {
    arr.sort(function(a, b) {
      var aProperty = mapWithShortcuts$4$1(a, map, arr, [a]);
      var bProperty = mapWithShortcuts$4$1(b, map, arr, [b]);
      return compareValue$2(aProperty, bProperty) * (desc ? -1 : 1);
    });
    return arr;
  }

});

Sugar$4E$1.Array.sortBy;

var Sugar$4D$1 = sugarCore$1.exports,
    arrayIntersectOrSubtract$3 = arrayIntersectOrSubtract_1$1;

Sugar$4D$1.Array.defineInstance({

  'subtract': function(arr, item) {
    return arrayIntersectOrSubtract$3(arr, item, true);
  }

});

Sugar$4D$1.Array.subtract;

var Sugar$4C$1 = sugarCore$1.exports,
    isUndefined$9$1 = isUndefined_1$1;

Sugar$4C$1.Array.defineInstance({

  'to': function(arr, num) {
    if (isUndefined$9$1(num)) num = arr.length;
    return arr.slice(0, num);
  }

});

Sugar$4C$1.Array.to;

var forEach$a$1 = forEach_1$1,
    mapWithShortcuts$3$1 = mapWithShortcuts_1$1,
    serializeInternal$2$1 = serializeInternal_1$1,
    coreUtilityAliases$t$1 = coreUtilityAliases$M$1;

var hasOwn$6$1 = coreUtilityAliases$t$1.hasOwn;

function arrayUnique$2$1(arr, map) {
  var result = [], obj = {}, refs = [];
  forEach$a$1(arr, function(el, i) {
    var transformed = map ? mapWithShortcuts$3$1(el, map, arr, [el, i, arr]) : el;
    var key = serializeInternal$2$1(transformed, refs);
    if (!hasOwn$6$1(obj, key)) {
      result.push(el);
      obj[key] = true;
    }
  });
  return result;
}

var arrayUnique_1$1 = arrayUnique$2$1;

var HAS_CONCAT_BUG$1$1 = !('0' in [].concat(undefined).concat());

var forEach$9$1 = forEach_1$1,
    arrayClone$7 = arrayClone_1$1,
    classChecks$B$1 = classChecks$Z$1;

var isArray$7$1 = classChecks$B$1.isArray;

function arraySafeConcat$1$1(arr, arg) {
  var result = arrayClone$7(arr), len = result.length, arr2;
  arr2 = isArray$7$1(arg) ? arg : [arg];
  result.length += arr2.length;
  forEach$9$1(arr2, function(el, i) {
    result[len + i] = el;
  });
  return result;
}

var arraySafeConcat_1$1 = arraySafeConcat$1$1;

var HAS_CONCAT_BUG$2 = HAS_CONCAT_BUG$1$1,
    arraySafeConcat$2 = arraySafeConcat_1$1;

function arrayConcat$1$1(arr1, arr2) {
  // istanbul ignore if
  if (HAS_CONCAT_BUG$2) {
    return arraySafeConcat$2(arr1, arr2);
  }
  return arr1.concat(arr2);
}

var arrayConcat_1$1 = arrayConcat$1$1;

var Sugar$4B$1 = sugarCore$1.exports,
    arrayUnique$1$1 = arrayUnique_1$1,
    arrayConcat$2 = arrayConcat_1$1;

Sugar$4B$1.Array.defineInstance({

  'union': function(arr1, arr2) {
    return arrayUnique$1$1(arrayConcat$2(arr1, arr2));
  }

});

Sugar$4B$1.Array.union;

var Sugar$4A$1 = sugarCore$1.exports,
    arrayUnique$3 = arrayUnique_1$1;

Sugar$4A$1.Array.defineInstance({

  'unique': function(arr, map) {
    return arrayUnique$3(arr, map);
  }

});

Sugar$4A$1.Array.unique;

var Sugar$4z$1 = sugarCore$1.exports,
    map$2$1 = map_1$1;

Sugar$4z$1.Array.defineInstanceWithArguments({

  'zip': function(arr, args) {
    return map$2$1(arr, function(el, i) {
      return [el].concat(map$2$1(args, function(k) {
        return (i in k) ? k[i] : null;
      }));
    });
  }

});

Sugar$4z$1.Array.zip;

var Sugar$4y$1 = sugarCore$1.exports;

Sugar$4y$1.Array.alias('insert', 'append');

Sugar$4y$1.Array.insert;

var Sugar$4x$1 = sugarCore$1.exports;

Sugar$4x$1.Array.getOption;

var Sugar$4w$1 = sugarCore$1.exports;

Sugar$4w$1.Array.setOption;

var classChecks$A$1 = classChecks$Z$1,
    isArrayIndex$3 = isArrayIndex_1$1,
    mapWithShortcuts$2$1 = mapWithShortcuts_1$1,
    coreUtilityAliases$s$1 = coreUtilityAliases$M$1;

var isArray$6$1 = classChecks$A$1.isArray,
    forEachProperty$h$1 = coreUtilityAliases$s$1.forEachProperty;

function enumerateWithMapping$5$1(obj, map, fn) {
  var arrayIndexes = isArray$6$1(obj);
  forEachProperty$h$1(obj, function(val, key) {
    if (arrayIndexes) {
      if (!isArrayIndex$3(key)) {
        return;
      }
      key = +key;
    }
    var mapped = mapWithShortcuts$2$1(val, map, obj, [val, key, obj]);
    fn(mapped, key);
  });
}

var enumerateWithMapping_1$1 = enumerateWithMapping$5$1;

var enumerateWithMapping$4$1 = enumerateWithMapping_1$1;

function average$2$1(obj, map) {
  var sum = 0, count = 0;
  enumerateWithMapping$4$1(obj, map, function(val) {
    sum += val;
    count++;
  });
  // Prevent divide by 0
  return sum / (count || 1);
}

var average_1$1 = average$2$1;

var Sugar$4v$1 = sugarCore$1.exports,
    average$1$1 = average_1$1;

Sugar$4v$1.Object.defineInstanceAndStatic({

  'average': function(obj, map) {
    return average$1$1(obj, map);
  }

});

Sugar$4v$1.Object.average;

var getMatcher$5$1 = getMatcher_1$1,
    coreUtilityAliases$r$1 = coreUtilityAliases$M$1;

var forEachProperty$g$1 = coreUtilityAliases$r$1.forEachProperty;

function objectCount$1$1(obj, f) {
  var matcher = getMatcher$5$1(f), count = 0;
  forEachProperty$g$1(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      count++;
    }
  });
  return count;
}

var objectCount_1$1 = objectCount$1$1;

var Sugar$4u$1 = sugarCore$1.exports,
    objectCount$2 = objectCount_1$1;

Sugar$4u$1.Object.defineInstanceAndStatic({

  'count': function(obj, f) {
    return objectCount$2(obj, f);
  }

});

Sugar$4u$1.Object.count;

var getKeys$3$1 = getKeys_1$1,
    getMatcher$4$1 = getMatcher_1$1;

function wrapObjectMatcher$1$1(name) {
  var nativeFn = Array.prototype[name];
  return function(obj, f) {
    var matcher = getMatcher$4$1(f);
    return nativeFn.call(getKeys$3$1(obj), function(key) {
      return matcher(obj[key], key, obj);
    });
  };
}

var wrapObjectMatcher_1$1 = wrapObjectMatcher$1$1;

var wrapObjectMatcher$2 = wrapObjectMatcher_1$1;

var objectMatchers$4$1 = {
  objectSome: wrapObjectMatcher$2('some'),
  objectFind: wrapObjectMatcher$2('find'),
  objectEvery: wrapObjectMatcher$2('every')
};

var Sugar$4t$1 = sugarCore$1.exports,
    objectMatchers$3$1 = objectMatchers$4$1;

var objectEvery$1 = objectMatchers$3$1.objectEvery;

Sugar$4t$1.Object.defineInstanceAndStatic({

  'every': objectEvery$1

});

Sugar$4t$1.Object.every;

var getMatcher$3$1 = getMatcher_1$1,
    coreUtilityAliases$q$1 = coreUtilityAliases$M$1;

var forEachProperty$f$1 = coreUtilityAliases$q$1.forEachProperty;

function objectFilter$1$1(obj, f) {
  var matcher = getMatcher$3$1(f), result = {};
  forEachProperty$f$1(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectFilter_1$1 = objectFilter$1$1;

var Sugar$4s$1 = sugarCore$1.exports,
    objectFilter$2 = objectFilter_1$1;

Sugar$4s$1.Object.defineInstanceAndStatic({

  'filter': function(obj, f) {
    return objectFilter$2(obj, f);
  }

});

Sugar$4s$1.Object.filter;

var Sugar$4r$1 = sugarCore$1.exports,
    objectMatchers$2$1 = objectMatchers$4$1;

var objectFind$1 = objectMatchers$2$1.objectFind;

Sugar$4r$1.Object.defineInstanceAndStatic({

  'find': objectFind$1

});

Sugar$4r$1.Object.find;

var classChecks$z$1 = classChecks$Z$1;

var isFunction$9$1 = classChecks$z$1.isFunction;

function assertCallable$1$1(obj) {
  if (!isFunction$9$1(obj)) {
    throw new TypeError('Function is not callable');
  }
}

var assertCallable_1$1 = assertCallable$1$1;

var assertCallable$2 = assertCallable_1$1,
    coreUtilityAliases$p$1 = coreUtilityAliases$M$1;

var forEachProperty$e$1 = coreUtilityAliases$p$1.forEachProperty;

function objectForEach$1$1(obj, fn) {
  assertCallable$2(fn);
  forEachProperty$e$1(obj, function(val, key) {
    fn(val, key, obj);
  });
  return obj;
}

var objectForEach_1$1 = objectForEach$1$1;

var Sugar$4q$1 = sugarCore$1.exports,
    objectForEach$2 = objectForEach_1$1;

Sugar$4q$1.Object.defineInstanceAndStatic({

  'forEach': function(obj, eachFn) {
    return objectForEach$2(obj, eachFn);
  }

});

Sugar$4q$1.Object.forEach;

function getReducedMinMaxResult$2$1(result, obj, all, asObject) {
  if (asObject && all) {
    // The method has returned an array of keys so use this array
    // to build up the resulting object in the form we want it in.
    return result.reduce(function(o, key) {
      o[key] = obj[key];
      return o;
    }, {});
  } else if (result && !all) {
    result = result[0];
  }
  return result;
}

var getReducedMinMaxResult_1$1 = getReducedMinMaxResult$2$1;

var classChecks$y$1 = classChecks$Z$1,
    isUndefined$8$1 = isUndefined_1$1,
    enumerateWithMapping$3$1 = enumerateWithMapping_1$1,
    getReducedMinMaxResult$1$1 = getReducedMinMaxResult_1$1;

var isBoolean$3$1 = classChecks$y$1.isBoolean;

function getMinOrMax$5$1(obj, arg1, arg2, max, asObject) {
  var result = [], pushVal, edge, all, map;
  if (isBoolean$3$1(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$3$1(obj, map, function(val, key) {
    if (isUndefined$8$1(val)) {
      throw new TypeError('Cannot compare with undefined');
    }
    pushVal = asObject ? key : obj[key];
    if (val === edge) {
      result.push(pushVal);
    } else if (isUndefined$8$1(edge) || (max && val > edge) || (!max && val < edge)) {
      result = [pushVal];
      edge = val;
    }
  });
  return getReducedMinMaxResult$1$1(result, obj, all, asObject);
}

var getMinOrMax_1$1 = getMinOrMax$5$1;

var classChecks$x$1 = classChecks$Z$1,
    getMinOrMax$4$1 = getMinOrMax_1$1,
    serializeInternal$1$1 = serializeInternal_1$1,
    coreUtilityAliases$o$1 = coreUtilityAliases$M$1,
    enumerateWithMapping$2$1 = enumerateWithMapping_1$1,
    getReducedMinMaxResult$3 = getReducedMinMaxResult_1$1;

var isBoolean$2$1 = classChecks$x$1.isBoolean,
    getOwn$8$1 = coreUtilityAliases$o$1.getOwn,
    forEachProperty$d$1 = coreUtilityAliases$o$1.forEachProperty;

function getLeastOrMost$4$1(obj, arg1, arg2, most, asObject) {
  var group = {}, refs = [], minMaxResult, result, all, map;
  if (isBoolean$2$1(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$2$1(obj, map, function(val, key) {
    var groupKey = serializeInternal$1$1(val, refs);
    var arr = getOwn$8$1(group, groupKey) || [];
    arr.push(asObject ? key : obj[key]);
    group[groupKey] = arr;
  });
  minMaxResult = getMinOrMax$4$1(group, !!all, 'length', most, true);
  if (all) {
    result = [];
    // Flatten result
    forEachProperty$d$1(minMaxResult, function(val) {
      result = result.concat(val);
    });
  } else {
    result = getOwn$8$1(group, minMaxResult);
  }
  return getReducedMinMaxResult$3(result, obj, all, asObject);
}

var getLeastOrMost_1$1 = getLeastOrMost$4$1;

var Sugar$4p$1 = sugarCore$1.exports,
    getLeastOrMost$3$1 = getLeastOrMost_1$1;

Sugar$4p$1.Object.defineInstanceAndStatic({

  'least': function(obj, all, map) {
    return getLeastOrMost$3$1(obj, all, map, false, true);
  }

});

Sugar$4p$1.Object.least;

var mapWithShortcuts$1$1 = mapWithShortcuts_1$1,
    coreUtilityAliases$n$1 = coreUtilityAliases$M$1;

var forEachProperty$c$1 = coreUtilityAliases$n$1.forEachProperty;

function objectMap$1$1(obj, map) {
  var result = {};
  forEachProperty$c$1(obj, function(val, key) {
    result[key] = mapWithShortcuts$1$1(val, map, obj, [val, key, obj]);
  });
  return result;
}

var objectMap_1$1 = objectMap$1$1;

var Sugar$4o$1 = sugarCore$1.exports,
    objectMap$2 = objectMap_1$1;

Sugar$4o$1.Object.defineInstanceAndStatic({

  'map': function(obj, map) {
    return objectMap$2(obj, map);
  }

});

Sugar$4o$1.Object.map;

var Sugar$4n$1 = sugarCore$1.exports,
    getMinOrMax$3$1 = getMinOrMax_1$1;

Sugar$4n$1.Object.defineInstanceAndStatic({

  'max': function(obj, all, map) {
    return getMinOrMax$3$1(obj, all, map, true, true);
  }

});

Sugar$4n$1.Object.max;

var trunc$8$1 = trunc_1$1,
    enumerateWithMapping$1$1 = enumerateWithMapping_1$1;

function median$2$1(obj, map) {
  var result = [], middle, len;
  enumerateWithMapping$1$1(obj, map, function(val) {
    result.push(val);
  });
  len = result.length;
  if (!len) return 0;
  result.sort(function(a, b) {
    // IE7 will throw errors on non-numbers!
    return (a || 0) - (b || 0);
  });
  middle = trunc$8$1(len / 2);
  return len % 2 ? result[middle] : (result[middle - 1] + result[middle]) / 2;
}

var median_1$1 = median$2$1;

var Sugar$4m$1 = sugarCore$1.exports,
    median$1$1 = median_1$1;

Sugar$4m$1.Object.defineInstanceAndStatic({

  'median': function(obj, map) {
    return median$1$1(obj, map);
  }

});

Sugar$4m$1.Object.median;

var Sugar$4l$1 = sugarCore$1.exports,
    getMinOrMax$2$1 = getMinOrMax_1$1;

Sugar$4l$1.Object.defineInstanceAndStatic({

  'min': function(obj, all, map) {
    return getMinOrMax$2$1(obj, all, map, false, true);
  }

});

Sugar$4l$1.Object.min;

var Sugar$4k$1 = sugarCore$1.exports,
    getLeastOrMost$2$1 = getLeastOrMost_1$1;

Sugar$4k$1.Object.defineInstanceAndStatic({

  'most': function(obj, all, map) {
    return getLeastOrMost$2$1(obj, all, map, true, true);
  }

});

Sugar$4k$1.Object.most;

var objectMatchers$1$1 = objectMatchers$4$1;

var objectSome$1$1 = objectMatchers$1$1.objectSome;

function objectNone$1$1(obj, f) {
  return !objectSome$1$1(obj, f);
}

var objectNone_1$1 = objectNone$1$1;

var Sugar$4j$1 = sugarCore$1.exports,
    objectNone$2 = objectNone_1$1;

Sugar$4j$1.Object.defineInstanceAndStatic({

  'none': function(obj, f) {
    return objectNone$2(obj, f);
  }

});

Sugar$4j$1.Object.none;

var isDefined$b$1 = isDefined_1$1,
    coreUtilityAliases$m$1 = coreUtilityAliases$M$1;

var forEachProperty$b$1 = coreUtilityAliases$m$1.forEachProperty;

function objectReduce$1$1(obj, fn, acc) {
  var init = isDefined$b$1(acc);
  forEachProperty$b$1(obj, function(val, key) {
    if (!init) {
      acc = val;
      init = true;
      return;
    }
    acc = fn(acc, val, key, obj);
  });
  return acc;
}

var objectReduce_1$1 = objectReduce$1$1;

var Sugar$4i$1 = sugarCore$1.exports,
    objectReduce$2 = objectReduce_1$1;

Sugar$4i$1.Object.defineInstanceAndStatic({

  'reduce': function(obj, fn, init) {
    return objectReduce$2(obj, fn, init);
  }

});

Sugar$4i$1.Object.reduce;

var Sugar$4h$1 = sugarCore$1.exports,
    objectMatchers$5 = objectMatchers$4$1;

var objectSome$2 = objectMatchers$5.objectSome;

Sugar$4h$1.Object.defineInstanceAndStatic({

  'some': objectSome$2

});

Sugar$4h$1.Object.some;

var enumerateWithMapping$6 = enumerateWithMapping_1$1;

function sum$2$1(obj, map) {
  var sum = 0;
  enumerateWithMapping$6(obj, map, function(val) {
    sum += val;
  });
  return sum;
}

var sum_1$1 = sum$2$1;

var Sugar$4g$1 = sugarCore$1.exports,
    sum$1$1 = sum_1$1;

Sugar$4g$1.Object.defineInstanceAndStatic({

  'sum': function(obj, map) {
    return sum$1$1(obj, map);
  }

});

Sugar$4g$1.Object.sum;

var Sugar$4f$1 = sugarCore$1.exports,
    average$3 = average_1$1;

Sugar$4f$1.Array.defineInstance({

  'average': function(arr, map) {
    return average$3(arr, map);
  }

});

Sugar$4f$1.Array.average;

var getMatcher$2$1 = getMatcher_1$1,
    classChecks$w$1 = classChecks$Z$1;

var isFunction$8$1 = classChecks$w$1.isFunction;

function enhancedMatching$2$1(f) {
  var matcher;
  if (isFunction$8$1(f)) {
    return f;
  }
  matcher = getMatcher$2$1(f);
  return function(el, i, arr) {
    return matcher(el, i, arr);
  };
}

var enhancedMatching_1$1 = enhancedMatching$2$1;

function assertArgument$2$1(exists) {
  if (!exists) {
    throw new TypeError('Argument required');
  }
}

var assertArgument_1$1 = assertArgument$2$1;

var assertArgument$1$1 = assertArgument_1$1;

function wrapNativeArrayMethod$2$1(methodName, wrapper) {
  var nativeFn = Array.prototype[methodName];
  return function(arr, f, context, argsLen) {
    var args = new Array(2);
    assertArgument$1$1(argsLen > 0);
    args[0] = wrapper(f, context);
    args[1] = context;
    return nativeFn.apply(arr, args);
  };
}

var wrapNativeArrayMethod_1$1 = wrapNativeArrayMethod$2$1;

var enhancedMatching$1$1 = enhancedMatching_1$1,
    wrapNativeArrayMethod$1$1 = wrapNativeArrayMethod_1$1;

function buildEnhancedMatching$1$1(name) {
  return wrapNativeArrayMethod$1$1(name, enhancedMatching$1$1);
}

var buildEnhancedMatching_1$1 = buildEnhancedMatching$1$1;

var buildEnhancedMatching$2 = buildEnhancedMatching_1$1;

var enhancedMatcherMethods$7$1 = {
  enhancedFind: buildEnhancedMatching$2('find'),
  enhancedSome: buildEnhancedMatching$2('some'),
  enhancedEvery: buildEnhancedMatching$2('every'),
  enhancedFilter: buildEnhancedMatching$2('filter'),
  enhancedFindIndex: buildEnhancedMatching$2('findIndex')
};

var isUndefined$7$1 = isUndefined_1$1,
    enhancedMatcherMethods$6$1 = enhancedMatcherMethods$7$1;

var enhancedFilter$1$1 = enhancedMatcherMethods$6$1.enhancedFilter;

function arrayCount$1$1(arr, f) {
  if (isUndefined$7$1(f)) {
    return arr.length;
  }
  return enhancedFilter$1$1.apply(this, arguments).length;
}

var arrayCount_1$1 = arrayCount$1$1;

var Sugar$4e$1 = sugarCore$1.exports,
    arrayCount$2 = arrayCount_1$1,
    fixArgumentLength$7$1 = fixArgumentLength_1$1;

Sugar$4e$1.Array.defineInstance({

  'count': fixArgumentLength$7$1(arrayCount$2)

});

Sugar$4e$1.Array.count;

var ARRAY_ENHANCEMENTS_FLAG$6$1 = 'enhanceArray';

var Sugar$4d$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$5$1 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$5$1 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    fixArgumentLength$6$1 = fixArgumentLength_1$1,
    enhancedMatcherMethods$5$1 = enhancedMatcherMethods$7$1;

var enhancedEvery$1 = enhancedMatcherMethods$5$1.enhancedEvery;

Sugar$4d$1.Array.defineInstance({

  'every': fixArgumentLength$6$1(enhancedEvery$1)

}, [ENHANCEMENTS_FLAG$5$1, ARRAY_ENHANCEMENTS_FLAG$5$1]);

Sugar$4d$1.Array.every;

var classChecks$v$1 = classChecks$Z$1,
    mapWithShortcuts$7 = mapWithShortcuts_1$1;

var isFunction$7$1 = classChecks$v$1.isFunction;

function enhancedMapping$2$1(map, context) {
  if (isFunction$7$1(map)) {
    return map;
  } else if (map) {
    return function(el, i, arr) {
      return mapWithShortcuts$7(el, map, context, [el, i, arr]);
    };
  }
}

var enhancedMapping_1$1 = enhancedMapping$2$1;

var forEach$8$1 = forEach_1$1,
    spaceSplit$2$1 = spaceSplit_1$1,
    classChecks$u$1 = classChecks$Z$1,
    mathAliases$h$1 = mathAliases$z$1,
    assertArgument$3 = assertArgument_1$1,
    enhancedMapping$1$1 = enhancedMapping_1$1,
    namespaceAliases$9$1 = namespaceAliases$e$1,
    enhancedMatching$3 = enhancedMatching_1$1,
    getNormalizedIndex$3 = getNormalizedIndex_1$1,
    coreUtilityAliases$l$1 = coreUtilityAliases$M$1,
    methodDefineAliases$1$1 = methodDefineAliases$3$1;

var forEachProperty$a$1 = coreUtilityAliases$l$1.forEachProperty,
    defineInstanceWithArguments$1 = methodDefineAliases$1$1.defineInstanceWithArguments,
    sugarArray$3 = namespaceAliases$9$1.sugarArray,
    min$3$1 = mathAliases$h$1.min,
    max$4$1 = mathAliases$h$1.max,
    isBoolean$1$1 = classChecks$u$1.isBoolean;

function buildFromIndexMethods$1$1() {

  var methods = {
    'forEach': {
      base: forEachAsNative
    },
    'map': {
      wrapper: enhancedMapping$1$1
    },
    'some every': {
      wrapper: enhancedMatching$3
    },
    'findIndex': {
      wrapper: enhancedMatching$3,
      result: indexResult
    },
    'reduce': {
      apply: applyReduce
    },
    'filter find': {
      wrapper: enhancedMatching$3
    },
    'reduceRight': {
      apply: applyReduce,
      slice: sliceArrayFromRight,
      clamp: clampStartIndexFromRight
    }
  };

  forEachProperty$a$1(methods, function(opts, key) {
    forEach$8$1(spaceSplit$2$1(key), function(baseName) {
      var methodName = baseName + 'FromIndex';
      var fn = createFromIndexWithOptions(baseName, opts);
      defineInstanceWithArguments$1(sugarArray$3, methodName, fn);
    });
  });

  function forEachAsNative(fn) {
    forEach$8$1(this, fn);
  }

  // Methods like filter and find have a direct association between the value
  // returned by the callback and the element of the current iteration. This
  // means that when looping, array elements must match the actual index for
  // which they are being called, so the array must be sliced. This is not the
  // case for methods like forEach and map, which either do not use return
  // values or use them in a way that simply getting the element at a shifted
  // index will not affect the final return value. However, these methods will
  // still fail on sparse arrays, so always slicing them here. For example, if
  // "forEachFromIndex" were to be called on [1,,2] from index 1, although the
  // actual index 1 would itself would be skipped, when the array loops back to
  // index 0, shifting it by adding 1 would result in the element for that
  // iteration being undefined. For shifting to work, all gaps in the array
  // between the actual index and the shifted index would have to be accounted
  // for. This is infeasible and is easily solved by simply slicing the actual
  // array instead so that gaps align. Note also that in the case of forEach,
  // we are using the internal function which handles sparse arrays in a way
  // that does not increment the index, and so is highly optimized compared to
  // the others here, which are simply going through the native implementation.
  function sliceArrayFromLeft(arr, startIndex, loop) {
    var result = arr;
    if (startIndex) {
      result = arr.slice(startIndex);
      if (loop) {
        result = result.concat(arr.slice(0, startIndex));
      }
    }
    return result;
  }

  // When iterating from the right, indexes are effectively shifted by 1.
  // For example, iterating from the right from index 2 in an array of 3
  // should also include the last element in the array. This matches the
  // "lastIndexOf" method which also iterates from the right.
  function sliceArrayFromRight(arr, startIndex, loop) {
    if (!loop) {
      startIndex += 1;
      arr = arr.slice(0, max$4$1(0, startIndex));
    }
    return arr;
  }

  function clampStartIndex(startIndex, len) {
    return min$3$1(len, max$4$1(0, startIndex));
  }

  // As indexes are shifted by 1 when starting from the right, clamping has to
  // go down to -1 to accommodate the full range of the sliced array.
  function clampStartIndexFromRight(startIndex, len) {
    return min$3$1(len, max$4$1(-1, startIndex));
  }

  function applyReduce(arr, startIndex, fn, context, len, loop) {
    return function(acc, val, i) {
      i = getNormalizedIndex$3(i + startIndex, len, loop);
      return fn.call(arr, acc, val, i, arr);
    };
  }

  function applyEach(arr, startIndex, fn, context, len, loop) {
    return function(el, i) {
      i = getNormalizedIndex$3(i + startIndex, len, loop);
      return fn.call(context, arr[i], i, arr);
    };
  }

  function indexResult(result, startIndex, len) {
    if (result !== -1) {
      result = (result + startIndex) % len;
    }
    return result;
  }

  function createFromIndexWithOptions(methodName, opts) {

    var baseFn = opts.base || Array.prototype[methodName],
        applyCallback = opts.apply || applyEach,
        sliceArray = opts.slice || sliceArrayFromLeft,
        clampIndex = opts.clamp || clampStartIndex,
        getResult = opts.result,
        wrapper = opts.wrapper;

    return function(arr, startIndex, args) {
      var callArgs = [], argIndex = 0, lastArg, result, len, loop, fn;
      len = arr.length;
      if (isBoolean$1$1(args[0])) {
        loop = args[argIndex++];
      }
      fn = args[argIndex++];
      lastArg = args[argIndex];
      if (startIndex < 0) {
        startIndex += len;
      }
      startIndex = clampIndex(startIndex, len);
      assertArgument$3(args.length);
      fn = wrapper ? wrapper(fn, lastArg) : fn;
      callArgs.push(applyCallback(arr, startIndex, fn, lastArg, len, loop));
      if (lastArg) {
        callArgs.push(lastArg);
      }
      result = baseFn.apply(sliceArray(arr, startIndex, loop), callArgs);
      if (getResult) {
        result = getResult(result, startIndex, len);
      }
      return result;
    };
  }
}

var buildFromIndexMethods_1$1 = buildFromIndexMethods$1$1;

var buildFromIndexMethods$2 = buildFromIndexMethods_1$1;

buildFromIndexMethods$2();

var Sugar$4c$1 = sugarCore$1.exports;



Sugar$4c$1.Array.everyFromIndex;

var Sugar$4b$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$4$1 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$4$1 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    fixArgumentLength$5$1 = fixArgumentLength_1$1,
    enhancedMatcherMethods$4$1 = enhancedMatcherMethods$7$1;

var enhancedFilter$2 = enhancedMatcherMethods$4$1.enhancedFilter;

Sugar$4b$1.Array.defineInstance({

  'filter': fixArgumentLength$5$1(enhancedFilter$2)

}, [ENHANCEMENTS_FLAG$4$1, ARRAY_ENHANCEMENTS_FLAG$4$1]);

Sugar$4b$1.Array.filter;

var Sugar$4a$1 = sugarCore$1.exports;



Sugar$4a$1.Array.filterFromIndex;

var Sugar$49$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$3$1 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$3$1 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    fixArgumentLength$4$1 = fixArgumentLength_1$1,
    enhancedMatcherMethods$3$1 = enhancedMatcherMethods$7$1;

var enhancedFind$1 = enhancedMatcherMethods$3$1.enhancedFind;

Sugar$49$1.Array.defineInstance({

  'find': fixArgumentLength$4$1(enhancedFind$1)

}, [ENHANCEMENTS_FLAG$3$1, ARRAY_ENHANCEMENTS_FLAG$3$1]);

Sugar$49$1.Array.find;

var Sugar$48$1 = sugarCore$1.exports;



Sugar$48$1.Array.findFromIndex;

var Sugar$47$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$2$1 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$2$1 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    fixArgumentLength$3$1 = fixArgumentLength_1$1,
    enhancedMatcherMethods$2$1 = enhancedMatcherMethods$7$1;

var enhancedFindIndex$1 = enhancedMatcherMethods$2$1.enhancedFindIndex;

Sugar$47$1.Array.defineInstance({

  'findIndex': fixArgumentLength$3$1(enhancedFindIndex$1)

}, [ENHANCEMENTS_FLAG$2$1, ARRAY_ENHANCEMENTS_FLAG$2$1]);

Sugar$47$1.Array.findIndex;

var Sugar$46$1 = sugarCore$1.exports;



Sugar$46$1.Array.findIndexFromIndex;

var Sugar$45$1 = sugarCore$1.exports;



Sugar$45$1.Array.forEachFromIndex;

var Sugar$44$1 = sugarCore$1.exports,
    getLeastOrMost$1$1 = getLeastOrMost_1$1;

Sugar$44$1.Array.defineInstance({

  'least': function(arr, all, map) {
    return getLeastOrMost$1$1(arr, all, map);
  }

});

Sugar$44$1.Array.least;

var enhancedMapping$3 = enhancedMapping_1$1,
    wrapNativeArrayMethod$3 = wrapNativeArrayMethod_1$1;

function buildEnhancedMapping$1$1(name) {
  return wrapNativeArrayMethod$3(name, enhancedMapping$3);
}

var buildEnhancedMapping_1$1 = buildEnhancedMapping$1$1;

var buildEnhancedMapping$2 = buildEnhancedMapping_1$1;

var enhancedMap$1$1 = buildEnhancedMapping$2('map');

var Sugar$43$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$1$1 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$1$1 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    enhancedMap$2 = enhancedMap$1$1,
    fixArgumentLength$2$1 = fixArgumentLength_1$1;

Sugar$43$1.Array.defineInstance({

  'map': fixArgumentLength$2$1(enhancedMap$2)

}, [ENHANCEMENTS_FLAG$1$1, ARRAY_ENHANCEMENTS_FLAG$1$1]);

Sugar$43$1.Array.map;

var Sugar$42$1 = sugarCore$1.exports;



Sugar$42$1.Array.mapFromIndex;

var Sugar$41$1 = sugarCore$1.exports,
    getMinOrMax$1$1 = getMinOrMax_1$1;

Sugar$41$1.Array.defineInstance({

  'max': function(arr, all, map) {
    return getMinOrMax$1$1(arr, all, map, true);
  }

});

Sugar$41$1.Array.max;

var Sugar$40$1 = sugarCore$1.exports,
    median$3 = median_1$1;

Sugar$40$1.Array.defineInstance({

  'median': function(arr, map) {
    return median$3(arr, map);
  }

});

Sugar$40$1.Array.median;

var Sugar$3$$1 = sugarCore$1.exports,
    getMinOrMax$6 = getMinOrMax_1$1;

Sugar$3$$1.Array.defineInstance({

  'min': function(arr, all, map) {
    return getMinOrMax$6(arr, all, map);
  }

});

Sugar$3$$1.Array.min;

var Sugar$3_$1 = sugarCore$1.exports,
    getLeastOrMost$5 = getLeastOrMost_1$1;

Sugar$3_$1.Array.defineInstance({

  'most': function(arr, all, map) {
    return getLeastOrMost$5(arr, all, map, true);
  }

});

Sugar$3_$1.Array.most;

var enhancedMatcherMethods$1$1 = enhancedMatcherMethods$7$1;

var enhancedSome$1$1 = enhancedMatcherMethods$1$1.enhancedSome;

function arrayNone$1$1() {
  return !enhancedSome$1$1.apply(this, arguments);
}

var arrayNone_1$1 = arrayNone$1$1;

var Sugar$3Z$1 = sugarCore$1.exports,
    arrayNone$2 = arrayNone_1$1,
    fixArgumentLength$1$1 = fixArgumentLength_1$1;

Sugar$3Z$1.Array.defineInstance({

  'none': fixArgumentLength$1$1(arrayNone$2)

});

Sugar$3Z$1.Array.none;

var Sugar$3Y$1 = sugarCore$1.exports;



Sugar$3Y$1.Array.reduceFromIndex;

var Sugar$3X$1 = sugarCore$1.exports;



Sugar$3X$1.Array.reduceRightFromIndex;

var Sugar$3W$1 = sugarCore$1.exports,
    ENHANCEMENTS_FLAG$8 = ENHANCEMENTS_FLAG$7$1,
    ARRAY_ENHANCEMENTS_FLAG$7 = ARRAY_ENHANCEMENTS_FLAG$6$1,
    fixArgumentLength$a = fixArgumentLength_1$1,
    enhancedMatcherMethods$8 = enhancedMatcherMethods$7$1;

var enhancedSome$2 = enhancedMatcherMethods$8.enhancedSome;

Sugar$3W$1.Array.defineInstance({

  'some': fixArgumentLength$a(enhancedSome$2)

}, [ENHANCEMENTS_FLAG$8, ARRAY_ENHANCEMENTS_FLAG$7]);

Sugar$3W$1.Array.some;

var Sugar$3V$1 = sugarCore$1.exports;



Sugar$3V$1.Array.someFromIndex;

var Sugar$3U$1 = sugarCore$1.exports,
    sum$3 = sum_1$1;

Sugar$3U$1.Array.defineInstance({

  'sum': function(arr, map) {
    return sum$3(arr, map);
  }

});

Sugar$3U$1.Array.sum;

var getOwnPropertyNames$2$1 = Object.getOwnPropertyNames;

var classChecks$t$1 = classChecks$Z$1,
    isPrimitive$3$1 = isPrimitive_1$1,
    isPlainObject$1$1 = isPlainObject_1$1,
    getRegExpFlags$3$1 = getRegExpFlags_1$1,
    coreUtilityAliases$k$1 = coreUtilityAliases$M$1;

var classToString$1$1 = coreUtilityAliases$k$1.classToString,
    isDate$8$1 = classChecks$t$1.isDate,
    isRegExp$3$1 = classChecks$t$1.isRegExp,
    isArray$5$1 = classChecks$t$1.isArray;

function getNewObjectForMerge$2$1(source) {
  var klass = classToString$1$1(source);
  // Primitive types, dates, and regexes have no "empty" state. If they exist
  // at all, then they have an associated value. As we are only creating new
  // objects when they don't exist in the target, these values can come alone
  // for the ride when created.
  if (isArray$5$1(source, klass)) {
    return [];
  } else if (isPlainObject$1$1(source, klass)) {
    return {};
  } else if (isDate$8$1(source, klass)) {
    return new Date(source.getTime());
  } else if (isRegExp$3$1(source, klass)) {
    return RegExp(source.source, getRegExpFlags$3$1(source));
  } else if (isPrimitive$3$1(source && source.valueOf())) {
    return source;
  }
  // If the object is not of a known type, then simply merging its
  // properties into a plain object will result in something different
  // (it will not respond to instanceof operator etc). Similarly we don't
  // want to call a constructor here as we can't know for sure what the
  // original constructor was called with (Events etc), so throw an
  // error here instead. Non-standard types can be handled if either they
  // already exist and simply have their properties merged, if the merge
  // is not deep so their references will simply be copied over, or if a
  // resolve function is used to assist the merge.
  throw new TypeError('Must be a basic data type');
}

var getNewObjectForMerge_1$1 = getNewObjectForMerge$2$1;

var getOwnPropertyDescriptor$2$1 = Object.getOwnPropertyDescriptor;

var getOwnPropertyDescriptor$1$1 = getOwnPropertyDescriptor$2$1;

function iterateOverKeys$1$1(getFn, obj, fn, hidden) {
  var keys = getFn(obj), desc;
  for (var i = 0, key; key = keys[i]; i++) {
    desc = getOwnPropertyDescriptor$1$1(obj, key);
    if (desc.enumerable || hidden) {
      fn(obj[key], key);
    }
  }
}

var iterateOverKeys_1$1 = iterateOverKeys$1$1;

var getOwnPropertySymbols$1$1 = Object.getOwnPropertySymbols;

var iterateOverKeys$2 = iterateOverKeys_1$1,
    coreUtilityAliases$j$1 = coreUtilityAliases$M$1,
    getOwnPropertyNames$1$1 = getOwnPropertyNames$2$1,
    getOwnPropertySymbols$3 = getOwnPropertySymbols$1$1;

var forEachProperty$9$1 = coreUtilityAliases$j$1.forEachProperty;

function iterateOverProperties$1$1(hidden, obj, fn) {
  if (getOwnPropertyNames$1$1 && hidden) {
    iterateOverKeys$2(getOwnPropertyNames$1$1, obj, fn, hidden);
  } else {
    forEachProperty$9$1(obj, fn);
  }
  if (getOwnPropertySymbols$3) {
    iterateOverKeys$2(getOwnPropertySymbols$3, obj, fn, hidden);
  }
}

var iterateOverProperties_1$1 = iterateOverProperties$1$1;

var NO_KEYS_IN_STRING_OBJECTS$1$1 = !('0' in Object('a'));

function forceStringCoercion$1$1(obj) {
  var i = 0, chr;
  while (chr = obj.charAt(i)) {
    obj[i++] = chr;
  }
}

var forceStringCoercion_1$1 = forceStringCoercion$1$1;

var NO_KEYS_IN_STRING_OBJECTS$2 = NO_KEYS_IN_STRING_OBJECTS$1$1,
    isPrimitive$2$1 = isPrimitive_1$1,
    classChecks$s$1 = classChecks$Z$1,
    forceStringCoercion$2 = forceStringCoercion_1$1;

var isString$9$1 = classChecks$s$1.isString;

function coercePrimitiveToObject$3$1(obj) {
  if (isPrimitive$2$1(obj)) {
    obj = Object(obj);
  }
  // istanbul ignore next
  if (NO_KEYS_IN_STRING_OBJECTS$2 && isString$9$1(obj)) {
    forceStringCoercion$2(obj);
  }
  return obj;
}

var coercePrimitiveToObject_1$1 = coercePrimitiveToObject$3$1;

var isDefined$a$1 = isDefined_1$1,
    coreUtilityAliases$i$1 = coreUtilityAliases$M$1,
    getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor$2$1;

var defineProperty$1 = coreUtilityAliases$i$1.defineProperty;

function mergeByPropertyDescriptor$1$1(target, source, prop, sourceVal) {
  var descriptor = getOwnPropertyDescriptor$3(source, prop);
  if (isDefined$a$1(descriptor.value)) {
    descriptor.value = sourceVal;
  }
  defineProperty$1(target, prop, descriptor);
}

var mergeByPropertyDescriptor_1$1 = mergeByPropertyDescriptor$1$1;

var Sugar$3T$1 = sugarCore$1.exports,
    isDefined$9$1 = isDefined_1$1,
    classChecks$r$1 = classChecks$Z$1,
    isPrimitive$1$1 = isPrimitive_1$1,
    isUndefined$6$1 = isUndefined_1$1,
    isObjectType$6$1 = isObjectType_1$1,
    coreUtilityAliases$h$1 = coreUtilityAliases$M$1,
    getOwnPropertyNames$3 = getOwnPropertyNames$2$1,
    getNewObjectForMerge$1$1 = getNewObjectForMerge_1$1,
    iterateOverProperties$2 = iterateOverProperties_1$1,
    coercePrimitiveToObject$2$1 = coercePrimitiveToObject_1$1,
    mergeByPropertyDescriptor$2 = mergeByPropertyDescriptor_1$1;

var isDate$7$1 = classChecks$r$1.isDate,
    isRegExp$2$1 = classChecks$r$1.isRegExp,
    isFunction$6$1 = classChecks$r$1.isFunction,
    getOwn$7$1 = coreUtilityAliases$h$1.getOwn;

function objectMerge$3$1(target, source, deep, resolve, hidden, descriptor) {
  var resolveByFunction = isFunction$6$1(resolve), resolveConflicts = resolve !== false;

  if (isUndefined$6$1(target)) {
    target = getNewObjectForMerge$1$1(source);
  } else if (resolveConflicts && isDate$7$1(target) && isDate$7$1(source)) {
    // A date's timestamp is a property that can only be reached through its
    // methods, so actively set it up front if both are dates.
    target.setTime(source.getTime());
  }

  if (isPrimitive$1$1(target)) {
    // Will not merge into a primitive type, so simply override.
    return source;
  }

  // If the source object is a primitive
  // type then coerce it into an object.
  if (isPrimitive$1$1(source)) {
    source = coercePrimitiveToObject$2$1(source);
  }

  iterateOverProperties$2(hidden, source, function(val, key) {
    var sourceVal, targetVal, resolved, goDeep, result;

    sourceVal = source[key];

    // We are iterating over properties of the source, so hasOwnProperty on
    // it is guaranteed to always be true. However, the target may happen to
    // have properties in its prototype chain that should not be considered
    // as conflicts.
    targetVal = getOwn$7$1(target, key);

    if (resolveByFunction) {
      result = resolve(key, targetVal, sourceVal, target, source);
      if (isUndefined$6$1(result)) {
        // Result is undefined so do not merge this property.
        return;
      } else if (isDefined$9$1(result) && result !== Sugar$3T$1) {
        // If the source returns anything except undefined, then the conflict
        // has been resolved, so don't continue traversing into the object. If
        // the returned value is the Sugar global object, then allowing Sugar
        // to resolve the conflict, so continue on.
        sourceVal = result;
        resolved = true;
      }
    } else if (isUndefined$6$1(sourceVal)) {
      // Will not merge undefined.
      return;
    }

    // Regex properties are read-only, so intentionally disallowing deep
    // merging for now. Instead merge by reference even if deep.
    goDeep = !resolved && deep && isObjectType$6$1(sourceVal) && !isRegExp$2$1(sourceVal);

    if (!goDeep && !resolveConflicts && isDefined$9$1(targetVal)) {
      return;
    }

    if (goDeep) {
      sourceVal = objectMerge$3$1(targetVal, sourceVal, deep, resolve, hidden, descriptor);
    }

    // getOwnPropertyNames is standing in as
    // a test for property descriptor support
    if (getOwnPropertyNames$3 && descriptor) {
      mergeByPropertyDescriptor$2(target, source, key, sourceVal);
    } else {
      target[key] = sourceVal;
    }

  });
  return target;
}

var objectMerge_1$1 = objectMerge$3$1;

var objectMerge$2$1 = objectMerge_1$1,
    getNewObjectForMerge$3 = getNewObjectForMerge_1$1;

function clone$3$1(source, deep) {
  var target = getNewObjectForMerge$3(source);
  return objectMerge$2$1(target, source, deep, true, true, true);
}

var clone_1$1 = clone$3$1;

var objectMerge$1$1 = objectMerge_1$1;

function mergeWithOptions$3$1(target, source, opts) {
  opts = opts || {};
  return objectMerge$1$1(target, source, opts.deep, opts.resolve, opts.hidden, opts.descriptor);
}

var mergeWithOptions_1$1 = mergeWithOptions$3$1;

var Sugar$3S$1 = sugarCore$1.exports,
    clone$2$1 = clone_1$1,
    mergeWithOptions$2$1 = mergeWithOptions_1$1;

Sugar$3S$1.Object.defineInstanceAndStatic({

  'add': function(obj1, obj2, opts) {
    return mergeWithOptions$2$1(clone$2$1(obj1), obj2, opts);
  }

});

Sugar$3S$1.Object.add;

var forEach$7$1 = forEach_1$1,
    classChecks$q$1 = classChecks$Z$1,
    mergeWithOptions$1$1 = mergeWithOptions_1$1;

var isArray$4$1 = classChecks$q$1.isArray;

function mergeAll$3$1(target, sources, opts) {
  if (!isArray$4$1(sources)) {
    sources = [sources];
  }
  forEach$7$1(sources, function(source) {
    return mergeWithOptions$1$1(target, source, opts);
  });
  return target;
}

var mergeAll_1$1 = mergeAll$3$1;

var Sugar$3R$1 = sugarCore$1.exports,
    clone$1$1 = clone_1$1,
    mergeAll$2$1 = mergeAll_1$1;

Sugar$3R$1.Object.defineInstanceAndStatic({

  'addAll': function(obj, sources, opts) {
    return mergeAll$2$1(clone$1$1(obj), sources, opts);
  }

});

Sugar$3R$1.Object.addAll;

var Sugar$3Q$1 = sugarCore$1.exports,
    clone$4 = clone_1$1;

Sugar$3Q$1.Object.defineInstanceAndStatic({

  'clone': function(obj, deep) {
    return clone$4(obj, deep);
  }

});

Sugar$3Q$1.Object.clone;

var mergeAll$1$1 = mergeAll_1$1;

function defaults$1$1(target, sources, opts) {
  opts = opts || {};
  opts.resolve = opts.resolve || false;
  return mergeAll$1$1(target, sources, opts);
}

var defaults_1$1 = defaults$1$1;

var Sugar$3P$1 = sugarCore$1.exports,
    defaults$2 = defaults_1$1;

Sugar$3P$1.Object.defineInstanceAndStatic({

  'defaults': function(target, sources, opts) {
    return defaults$2(target, sources, opts);
  }

});

Sugar$3P$1.Object.defaults;

var getMatcher$1$1 = getMatcher_1$1,
    coreUtilityAliases$g$1 = coreUtilityAliases$M$1;

var forEachProperty$8$1 = coreUtilityAliases$g$1.forEachProperty;

function objectExclude$1$1(obj, f) {
  var result = {};
  var matcher = getMatcher$1$1(f);
  forEachProperty$8$1(obj, function(val, key) {
    if (!matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectExclude_1$1 = objectExclude$1$1;

var Sugar$3O$1 = sugarCore$1.exports,
    objectExclude$2 = objectExclude_1$1;

Sugar$3O$1.Object.defineInstanceAndStatic({

  'exclude': function(obj, f) {
    return objectExclude$2(obj, f);
  }

});

Sugar$3O$1.Object.exclude;

var DEEP_QUERY_STRING_REG$1$1 = /^(.+?)(\[.*\])$/;

var NON_DECIMAL_REG$1$1 = /[^\d.-]/;

var NON_DECIMAL_REG$2 = NON_DECIMAL_REG$1$1;

function stringIsDecimal$1$1(str) {
  return str !== '' && !NON_DECIMAL_REG$2.test(str);
}

var stringIsDecimal_1$1 = stringIsDecimal$1$1;

var classChecks$p$1 = classChecks$Z$1,
    stringIsDecimal$2 = stringIsDecimal_1$1,
    coreUtilityAliases$f$1 = coreUtilityAliases$M$1;

var getOwn$6$1 = coreUtilityAliases$f$1.getOwn,
    isArray$3$1 = classChecks$p$1.isArray;

function getQueryValueAuto$1$1(obj, key, val) {
  if (!val) {
    return null;
  } else if (val === 'true') {
    return true;
  } else if (val === 'false') {
    return false;
  }
  var num = +val;
  if (!isNaN(num) && stringIsDecimal$2(val)) {
    return num;
  }
  var existing = getOwn$6$1(obj, key);
  if (val && existing) {
    return isArray$3$1(existing) ? existing.concat(val) : [existing, val];
  }
  return val;
}

var getQueryValueAuto_1$1 = getQueryValueAuto$1$1;

var isDefined$8$1 = isDefined_1$1,
    getQueryValueAuto$2 = getQueryValueAuto_1$1;

function setQueryProperty$2$1(obj, key, val, auto, transform) {
  var fnValue;
  if (transform) {
    fnValue = transform(val, key, obj);
  }
  if (isDefined$8$1(fnValue)) {
    val = fnValue;
  } else if (auto) {
    val = getQueryValueAuto$2(obj, key, val);
  }
  obj[key] = val;
}

var setQueryProperty_1$1 = setQueryProperty$2$1;

function mapQuerySeparatorToKeys$1$1(key, separator) {
  var split = key.split(separator), result = split[0];
  for (var i = 1, len = split.length; i < len; i++) {
    result += '[' + split[i] + ']';
  }
  return result;
}

var mapQuerySeparatorToKeys_1$1 = mapQuerySeparatorToKeys$1$1;

var forEach$6$1 = forEach_1$1,
    setQueryProperty$1$1 = setQueryProperty_1$1,
    coreUtilityAliases$e$1 = coreUtilityAliases$M$1;

var hasOwn$5$1 = coreUtilityAliases$e$1.hasOwn,
    getOwn$5$1 = coreUtilityAliases$e$1.getOwn;

function parseDeepQueryComponent$1$1(obj, match, val, deep, auto, separator, transform) {
  var key = match[1];
  var inner = match[2].slice(1, -1).split('][');
  forEach$6$1(inner, function(k) {
    if (!hasOwn$5$1(obj, key)) {
      obj[key] = k ? {} : [];
    }
    obj = getOwn$5$1(obj, key);
    key = k ? k : obj.length.toString();
  });
  setQueryProperty$1$1(obj, key, val, auto, transform);
}

var parseDeepQueryComponent_1$1 = parseDeepQueryComponent$1$1;

var DEEP_QUERY_STRING_REG$2 = DEEP_QUERY_STRING_REG$1$1,
    setQueryProperty$3 = setQueryProperty_1$1,
    mapQuerySeparatorToKeys$2 = mapQuerySeparatorToKeys_1$1,
    parseDeepQueryComponent$2 = parseDeepQueryComponent_1$1;

function parseQueryComponent$1$1(obj, key, val, deep, auto, separator, transform) {
  var match;
  if (separator) {
    key = mapQuerySeparatorToKeys$2(key, separator);
    deep = true;
  }
  if (deep === true && (match = key.match(DEEP_QUERY_STRING_REG$2))) {
    parseDeepQueryComponent$2(obj, match, val, deep, auto, separator, transform);
  } else {
    setQueryProperty$3(obj, key, val, auto, transform);
  }
}

var parseQueryComponent_1$1 = parseQueryComponent$1$1;

var forEach$5$1 = forEach_1$1,
    parseQueryComponent$2 = parseQueryComponent_1$1;

function fromQueryStringWithOptions$1$1(obj, opts) {
  var str = String(obj || '').replace(/^.*?\?/, ''), result = {}, auto;
  opts = opts || {};
  if (str) {
    forEach$5$1(str.split('&'), function(p) {
      var split = p.split('=');
      var key = decodeURIComponent(split[0]);
      var val = split.length === 2 ? decodeURIComponent(split[1]) : '';
      auto = opts.auto !== false;
      parseQueryComponent$2(result, key, val, opts.deep, auto, opts.separator, opts.transform);
    });
  }
  return result;
}

var fromQueryStringWithOptions_1$1 = fromQueryStringWithOptions$1$1;

var Sugar$3N$1 = sugarCore$1.exports,
    fromQueryStringWithOptions$2 = fromQueryStringWithOptions_1$1;

Sugar$3N$1.Object.defineStatic({

  'fromQueryString': function(obj, options) {
    return fromQueryStringWithOptions$2(obj, options);
  }

});

Sugar$3N$1.Object.fromQueryString;

var Sugar$3M$1 = sugarCore$1.exports,
    deepGetProperty$1$1 = deepGetProperty_1$1;

Sugar$3M$1.Object.defineInstanceAndStatic({

  'get': function(obj, key, any) {
    return deepGetProperty$1$1(obj, key, any);
  }

});

Sugar$3M$1.Object.get;

var handleDeepProperty$1$1 = handleDeepProperty_1$1;

function deepHasProperty$1$1(obj, key, any) {
  return handleDeepProperty$1$1(obj, key, any, true);
}

var deepHasProperty_1$1 = deepHasProperty$1$1;

var Sugar$3L$1 = sugarCore$1.exports,
    deepHasProperty$2 = deepHasProperty_1$1;

Sugar$3L$1.Object.defineInstanceAndStatic({

  'has': function(obj, key, any) {
    return deepHasProperty$2(obj, key, any);
  }

});

Sugar$3L$1.Object.has;

var isEqual$1$1 = isEqual_1$1,
    objectMerge$4 = objectMerge_1$1,
    isObjectType$5$1 = isObjectType_1$1,
    coercePrimitiveToObject$1$1 = coercePrimitiveToObject_1$1;

function objectIntersectOrSubtract$2$1(obj1, obj2, subtract) {
  if (!isObjectType$5$1(obj1)) {
    return subtract ? obj1 : {};
  }
  obj2 = coercePrimitiveToObject$1$1(obj2);
  function resolve(key, val, val1) {
    var exists = key in obj2 && isEqual$1$1(val1, obj2[key]);
    if (exists !== subtract) {
      return val1;
    }
  }
  return objectMerge$4({}, obj1, false, resolve);
}

var objectIntersectOrSubtract_1$1 = objectIntersectOrSubtract$2$1;

var Sugar$3K$1 = sugarCore$1.exports,
    objectIntersectOrSubtract$1$1 = objectIntersectOrSubtract_1$1;

Sugar$3K$1.Object.defineInstanceAndStatic({

  'intersect': function(obj1, obj2) {
    return objectIntersectOrSubtract$1$1(obj1, obj2, false);
  }

});

Sugar$3K$1.Object.intersect;

var Sugar$3J$1 = sugarCore$1.exports,
    coreUtilityAliases$d$1 = coreUtilityAliases$M$1;

var hasOwn$4$1 = coreUtilityAliases$d$1.hasOwn,
    forEachProperty$7$1 = coreUtilityAliases$d$1.forEachProperty;

Sugar$3J$1.Object.defineInstanceAndStatic({

  'invert': function(obj, multi) {
    var result = {};
    multi = multi === true;
    forEachProperty$7$1(obj, function(val, key) {
      if (hasOwn$4$1(result, val) && multi) {
        result[val].push(key);
      } else if (multi) {
        result[val] = [key];
      } else {
        result[val] = key;
      }
    });
    return result;
  }

});

Sugar$3J$1.Object.invert;

var isPrimitive$9 = isPrimitive_1$1;

function hasProperty$1$1(obj, prop) {
  return !isPrimitive$9(obj) && prop in obj;
}

var hasProperty_1$1 = hasProperty$1$1;

var hasProperty$2 = hasProperty_1$1,
    coreUtilityAliases$c$1 = coreUtilityAliases$M$1;

var classToString$6 = coreUtilityAliases$c$1.classToString;

function isArguments$1$1(obj, className) {
  className = className || classToString$6(obj);
  // .callee exists on Arguments objects in < IE8
  return hasProperty$2(obj, 'length') && (className === '[object Arguments]' || !!obj.callee);
}

var isArguments_1$1 = isArguments$1$1;

var Sugar$3I$1 = sugarCore$1.exports,
    isArguments$2 = isArguments_1$1;

Sugar$3I$1.Object.defineInstanceAndStatic({

  'isArguments': function(obj) {
    return isArguments$2(obj);
  }

});

Sugar$3I$1.Object.isArguments;

var methodDefineAliases$4 = methodDefineAliases$3$1,
    collectSimilarMethods$3 = collectSimilarMethods_1$1;

var defineInstanceAndStatic$1 = methodDefineAliases$4.defineInstanceAndStatic;

function defineInstanceAndStaticSimilar$1$1(sugarNamespace, set, fn, flags) {
  defineInstanceAndStatic$1(sugarNamespace, collectSimilarMethods$3(set, fn), flags);
}

var defineInstanceAndStaticSimilar_1$1 = defineInstanceAndStaticSimilar$1$1;

var NATIVE_TYPES$3 = NATIVE_TYPES$2$1,
    classChecks$o$1 = classChecks$Z$1,
    namespaceAliases$8$1 = namespaceAliases$e$1,
    defineInstanceAndStaticSimilar$2 = defineInstanceAndStaticSimilar_1$1;

var isBoolean$7 = classChecks$o$1.isBoolean,
    isNumber$a$1 = classChecks$o$1.isNumber,
    isString$8$1 = classChecks$o$1.isString,
    isDate$6$1 = classChecks$o$1.isDate,
    isRegExp$1$1 = classChecks$o$1.isRegExp,
    isFunction$5$1 = classChecks$o$1.isFunction,
    isArray$2$1 = classChecks$o$1.isArray,
    isSet$3 = classChecks$o$1.isSet,
    isMap$3 = classChecks$o$1.isMap,
    isError$3 = classChecks$o$1.isError,
    sugarObject$1 = namespaceAliases$8$1.sugarObject;

function buildClassCheckMethods$1$1() {
  var checks = [isBoolean$7, isNumber$a$1, isString$8$1, isDate$6$1, isRegExp$1$1, isFunction$5$1, isArray$2$1, isError$3, isSet$3, isMap$3];
  defineInstanceAndStaticSimilar$2(sugarObject$1, NATIVE_TYPES$3, function(methods, name, i) {
    methods['is' + name] = checks[i];
  });
}

var buildClassCheckMethods_1$1 = buildClassCheckMethods$1$1;

var buildClassCheckMethods$2 = buildClassCheckMethods_1$1;

buildClassCheckMethods$2();

var Sugar$3H$1 = sugarCore$1.exports;



Sugar$3H$1.Object.isArray;

var Sugar$3G$1 = sugarCore$1.exports;



Sugar$3G$1.Object.isBoolean;

var Sugar$3F$1 = sugarCore$1.exports;



Sugar$3F$1.Object.isDate;

var getKeys$2$1 = getKeys_1$1,
    coercePrimitiveToObject$4 = coercePrimitiveToObject_1$1;

function getKeysWithObjectCoercion$1$1(obj) {
  return getKeys$2$1(coercePrimitiveToObject$4(obj));
}

var getKeysWithObjectCoercion_1$1 = getKeysWithObjectCoercion$1$1;

var getKeysWithObjectCoercion$2 = getKeysWithObjectCoercion_1$1;

function objectSize$2$1(obj) {
  return getKeysWithObjectCoercion$2(obj).length;
}

var objectSize_1$1 = objectSize$2$1;

var Sugar$3E$1 = sugarCore$1.exports,
    objectSize$1$1 = objectSize_1$1;

Sugar$3E$1.Object.defineInstanceAndStatic({

  'isEmpty': function(obj) {
    return objectSize$1$1(obj) === 0;
  }

});

Sugar$3E$1.Object.isEmpty;

var Sugar$3D$1 = sugarCore$1.exports,
    isEqual$5 = isEqual_1$1;

Sugar$3D$1.Object.defineInstanceAndStatic({

  'isEqual': function(obj1, obj2) {
    return isEqual$5(obj1, obj2);
  }

});

Sugar$3D$1.Object.isEqual;

var Sugar$3C$1 = sugarCore$1.exports;



Sugar$3C$1.Object.isError;

var Sugar$3B$1 = sugarCore$1.exports;



Sugar$3B$1.Object.isFunction;

var Sugar$3A$1 = sugarCore$1.exports;



Sugar$3A$1.Object.isMap;

var Sugar$3z$1 = sugarCore$1.exports;



Sugar$3z$1.Object.isNumber;

var Sugar$3y$1 = sugarCore$1.exports,
    isPlainObject$5 = isPlainObject_1$1;

Sugar$3y$1.Object.defineInstanceAndStatic({

  'isObject': function(obj) {
    return isPlainObject$5(obj);
  }

});

Sugar$3y$1.Object.isObject;

var Sugar$3x$1 = sugarCore$1.exports;



Sugar$3x$1.Object.isRegExp;

var Sugar$3w$1 = sugarCore$1.exports;



Sugar$3w$1.Object.isSet;

var Sugar$3v$1 = sugarCore$1.exports;



Sugar$3v$1.Object.isString;

var Sugar$3u$1 = sugarCore$1.exports,
    mergeWithOptions$4 = mergeWithOptions_1$1;

Sugar$3u$1.Object.defineInstanceAndStatic({

  'merge': function(target, source, opts) {
    return mergeWithOptions$4(target, source, opts);
  }

});

Sugar$3u$1.Object.merge;

var Sugar$3t$1 = sugarCore$1.exports,
    mergeAll$4 = mergeAll_1$1;

Sugar$3t$1.Object.defineInstanceAndStatic({

  'mergeAll': function(target, sources, opts) {
    return mergeAll$4(target, sources, opts);
  }

});

Sugar$3t$1.Object.mergeAll;

var classChecks$n$1 = classChecks$Z$1,
    isObjectType$4$1 = isObjectType_1$1;

var isRegExp$8 = classChecks$n$1.isRegExp;

function matchInObject$1$1(match, key) {
  if (isRegExp$8(match)) {
    return match.test(key);
  } else if (isObjectType$4$1(match)) {
    return key in match;
  } else {
    return key === String(match);
  }
}

var matchInObject_1$1 = matchInObject$1$1;

var matchInObject$2 = matchInObject_1$1,
    coreUtilityAliases$b$1 = coreUtilityAliases$M$1;

var forEachProperty$6$1 = coreUtilityAliases$b$1.forEachProperty;

function selectFromObject$2$1(obj, f, select) {
  var match, result = {};
  f = [].concat(f);
  forEachProperty$6$1(obj, function(val, key) {
    match = false;
    for (var i = 0; i < f.length; i++) {
      if (matchInObject$2(f[i], key)) {
        match = true;
      }
    }
    if (match === select) {
      result[key] = val;
    }
  });
  return result;
}

var selectFromObject_1$1 = selectFromObject$2$1;

var selectFromObject$1$1 = selectFromObject_1$1;

function objectReject$1$1(obj, f) {
  return selectFromObject$1$1(obj, f, false);
}

var objectReject_1$1 = objectReject$1$1;

var Sugar$3s$1 = sugarCore$1.exports,
    objectReject$2 = objectReject_1$1;

Sugar$3s$1.Object.defineInstanceAndStatic({

  'reject': function(obj, f) {
    return objectReject$2(obj, f);
  }

});

Sugar$3s$1.Object.reject;

var getMatcher$9 = getMatcher_1$1,
    coreUtilityAliases$a$1 = coreUtilityAliases$M$1;

var forEachProperty$5$1 = coreUtilityAliases$a$1.forEachProperty;

function objectRemove$1$1(obj, f) {
  var matcher = getMatcher$9(f);
  forEachProperty$5$1(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      delete obj[key];
    }
  });
  return obj;
}

var objectRemove_1$1 = objectRemove$1$1;

var Sugar$3r$1 = sugarCore$1.exports,
    objectRemove$2 = objectRemove_1$1;

Sugar$3r$1.Object.defineInstanceAndStatic({

  'remove': function(obj, f) {
    return objectRemove$2(obj, f);
  }

});

Sugar$3r$1.Object.remove;

var selectFromObject$3 = selectFromObject_1$1;

function objectSelect$1$1(obj, f) {
  return selectFromObject$3(obj, f, true);
}

var objectSelect_1$1 = objectSelect$1$1;

var Sugar$3q$1 = sugarCore$1.exports,
    objectSelect$2 = objectSelect_1$1;

Sugar$3q$1.Object.defineInstanceAndStatic({

  'select': function(obj, f) {
    return objectSelect$2(obj, f);
  }

});

Sugar$3q$1.Object.select;

var handleDeepProperty$4 = handleDeepProperty_1$1;

function deepSetProperty$1$1(obj, key, val) {
  handleDeepProperty$4(obj, key, false, false, true, false, val);
  return obj;
}

var deepSetProperty_1$1 = deepSetProperty$1$1;

var Sugar$3p$1 = sugarCore$1.exports,
    deepSetProperty$2 = deepSetProperty_1$1;

Sugar$3p$1.Object.defineInstanceAndStatic({

  'set': function(obj, key, val) {
    return deepSetProperty$2(obj, key, val);
  }

});

Sugar$3p$1.Object.set;

var Sugar$3o$1 = sugarCore$1.exports,
    objectSize$3 = objectSize_1$1;

Sugar$3o$1.Object.defineInstanceAndStatic({

  'size': function(obj) {
    return objectSize$3(obj);
  }

});

Sugar$3o$1.Object.size;

var Sugar$3n$1 = sugarCore$1.exports,
    objectIntersectOrSubtract$3 = objectIntersectOrSubtract_1$1;

Sugar$3n$1.Object.defineInstanceAndStatic({

  'subtract': function(obj1, obj2) {
    return objectIntersectOrSubtract$3(obj1, obj2, true);
  }

});

Sugar$3n$1.Object.subtract;

var classChecks$m$1 = classChecks$Z$1;

var isFunction$4$1 = classChecks$m$1.isFunction;

function tap$1$1(obj, arg) {
  var fn = arg;
  if (!isFunction$4$1(arg)) {
    fn = function() {
      if (arg) obj[arg]();
    };
  }
  fn.call(obj, obj);
  return obj;
}

var tap_1$1 = tap$1$1;

var Sugar$3m$1 = sugarCore$1.exports,
    tap$2 = tap_1$1;

Sugar$3m$1.Object.defineInstanceAndStatic({

  'tap': function(obj, arg) {
    return tap$2(obj, arg);
  }

});

Sugar$3m$1.Object.tap;

var internalToString$1$1 = Object.prototype.toString;

function sanitizeURIComponent$2$1(obj) {
  // undefined, null, and NaN are represented as a blank string,
  // while false and 0 are stringified.
  return !obj && obj !== false && obj !== 0 ? '' : encodeURIComponent(obj);
}

var sanitizeURIComponent_1$1 = sanitizeURIComponent$2$1;

var classChecks$l$1 = classChecks$Z$1,
    sanitizeURIComponent$1$1 = sanitizeURIComponent_1$1;

var isDate$5$1 = classChecks$l$1.isDate;

function getURIComponentValue$1$1(obj, prefix, transform) {
  var value;
  if (transform) {
    value = transform(obj, prefix);
  } else if (isDate$5$1(obj)) {
    value = obj.getTime();
  } else {
    value = obj;
  }
  return sanitizeURIComponent$1$1(prefix) + '=' + sanitizeURIComponent$1$1(value);
}

var getURIComponentValue_1$1 = getURIComponentValue$1$1;

var classChecks$k$1 = classChecks$Z$1,
    isObjectType$3$1 = isObjectType_1$1,
    internalToString$2 = internalToString$1$1,
    coreUtilityAliases$9$1 = coreUtilityAliases$M$1,
    getURIComponentValue$2 = getURIComponentValue_1$1,
    sanitizeURIComponent$3 = sanitizeURIComponent_1$1;

var isArray$1$1 = classChecks$k$1.isArray,
    forEachProperty$4$1 = coreUtilityAliases$9$1.forEachProperty;

function toQueryString$1$1(obj, deep, transform, prefix, separator) {
  if (isArray$1$1(obj)) {
    return collectArrayAsQueryString$1(obj, deep, transform, prefix, separator);
  } else if (isObjectType$3$1(obj) && obj.toString === internalToString$2) {
    return collectObjectAsQueryString$1(obj, deep, transform, prefix, separator);
  } else if (prefix) {
    return getURIComponentValue$2(obj, prefix, transform);
  }
  return '';
}

function collectArrayAsQueryString$1(arr, deep, transform, prefix, separator) {
  var el, qc, key, result = [];
  // Intentionally treating sparse arrays as dense here by avoiding map,
  // otherwise indexes will shift during the process of serialization.
  for (var i = 0, len = arr.length; i < len; i++) {
    el = arr[i];
    key = prefix + (prefix && deep ? '[]' : '');
    if (!key && !isObjectType$3$1(el)) {
      // If there is no key, then the values of the array should be
      // considered as null keys, so use them instead;
      qc = sanitizeURIComponent$3(el);
    } else {
      qc = toQueryString$1$1(el, deep, transform, key, separator);
    }
    result.push(qc);
  }
  return result.join('&');
}

function collectObjectAsQueryString$1(obj, deep, transform, prefix, separator) {
  var result = [];
  forEachProperty$4$1(obj, function(val, key) {
    var fullKey;
    if (prefix && deep) {
      fullKey = prefix + '[' + key + ']';
    } else if (prefix) {
      fullKey = prefix + separator + key;
    } else {
      fullKey = key;
    }
    result.push(toQueryString$1$1(val, deep, transform, fullKey, separator));
  });
  return result.join('&');
}

var toQueryString_1$1 = toQueryString$1$1;

var isUndefined$5$1 = isUndefined_1$1,
    toQueryString$2 = toQueryString_1$1;

function toQueryStringWithOptions$1$1(obj, opts) {
  opts = opts || {};
  if (isUndefined$5$1(opts.separator)) {
    opts.separator = '_';
  }
  return toQueryString$2(obj, opts.deep, opts.transform, opts.prefix || '', opts.separator);
}

var toQueryStringWithOptions_1$1 = toQueryStringWithOptions$1$1;

var Sugar$3l$1 = sugarCore$1.exports,
    toQueryStringWithOptions$2 = toQueryStringWithOptions_1$1;

Sugar$3l$1.Object.defineInstanceAndStatic({

  'toQueryString': function(obj, options) {
    return toQueryStringWithOptions$2(obj, options);
  }

});

Sugar$3l$1.Object.toQueryString;

var coreUtilityAliases$8$1 = coreUtilityAliases$M$1;

var forEachProperty$3$1 = coreUtilityAliases$8$1.forEachProperty;

function getValues$1$1(obj) {
  var values = [];
  forEachProperty$3$1(obj, function(val) {
    values.push(val);
  });
  return values;
}

var getValues_1$1 = getValues$1$1;

var Sugar$3k$1 = sugarCore$1.exports,
    getValues$2 = getValues_1$1;

Sugar$3k$1.Object.defineInstanceAndStatic({

  'values': function(obj) {
    return getValues$2(obj);
  }

});

Sugar$3k$1.Object.values;

var Sugar$3j$1 = sugarCore$1.exports,
    getKeys$1$1 = getKeys_1$1;

Sugar$3j$1.Object.defineInstance({

  'keys': function(obj) {
    return getKeys$1$1(obj);
  }

});

Sugar$3j$1.Object.keys;

var EnglishLocaleBaseDefinition$1$1 = {
  'code': 'en',
  'plural': true,
  'timeMarkers': 'at',
  'ampm': 'AM|A.M.|a,PM|P.M.|p',
  'units': 'millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s',
  'months': 'Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|',
  'weekdays': 'Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend',
  'numerals': 'zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th',
  'articles': 'a,an,the',
  'tokens': 'the,st|nd|rd|th,of|in,a|an,on',
  'time': '{H}:{mm}',
  'past': '{num} {unit} {sign}',
  'future': '{num} {unit} {sign}',
  'duration': '{num} {unit}',
  'modifiers': [
    { 'name': 'half',   'src': 'half', 'value': .5 },
    { 'name': 'midday', 'src': 'noon', 'value': 12 },
    { 'name': 'midday', 'src': 'midnight', 'value': 24 },
    { 'name': 'day',    'src': 'yesterday', 'value': -1 },
    { 'name': 'day',    'src': 'today|tonight', 'value': 0 },
    { 'name': 'day',    'src': 'tomorrow', 'value': 1 },
    { 'name': 'sign',   'src': 'ago|before', 'value': -1 },
    { 'name': 'sign',   'src': 'from now|after|from|in|later', 'value': 1 },
    { 'name': 'edge',   'src': 'first day|first|beginning', 'value': -2 },
    { 'name': 'edge',   'src': 'last day', 'value': 1 },
    { 'name': 'edge',   'src': 'end|last', 'value': 2 },
    { 'name': 'shift',  'src': 'last', 'value': -1 },
    { 'name': 'shift',  'src': 'the|this', 'value': 0 },
    { 'name': 'shift',  'src': 'next', 'value': 1 }
  ],
  'parse': [
    '(?:just)? now',
    '{shift} {unit:5-7}',
    '{months?} {year}',
    '{midday} {4?} {day|weekday}',
    '{months},?[-.\\/\\s]?{year?}',
    '{edge} of (?:day)? {day|weekday}',
    '{0} {num}{1?} {weekday} {2} {months},? {year?}',
    '{shift?} {day?} {weekday?} (?:at)? {midday}',
    '{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}',
    '{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}'
  ],
  'timeParse': [
    '{day|weekday}',
    '{shift} {unit:5?} {weekday}',
    '{0?} {date}{1?} {2?} {months?}',
    '{weekday} {2?} {shift} {unit:5}',
    '{0?} {num} {2?} {months}\\.?,? {year?}',
    '{num?} {unit:4-5} {sign} {day|weekday}',
    '{0|months} {date?}{1?} of {shift} {unit:6-7}',
    '{0?} {num}{1?} {weekday} of {shift} {unit:6}',
    '{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}',
    '{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?',
    '{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}',
    '{weekday?}\\.?,? {date} {months} {year}'
  ],
  'timeFrontParse': [
    '{sign} {num} {unit}',
    '{num} {unit} {sign}',
    '{4?} {day|weekday}'
  ]
};

var EnglishLocaleBaseDefinition_1$1 = EnglishLocaleBaseDefinition$1$1;

var EnglishLocaleBaseDefinition$2 = EnglishLocaleBaseDefinition_1$1,
    simpleMerge$2$1 = simpleMerge_1$1,
    simpleClone$2$1 = simpleClone_1$1;

function getEnglishVariant$3$1(v) {
  return simpleMerge$2$1(simpleClone$2$1(EnglishLocaleBaseDefinition$2), v);
}

var getEnglishVariant_1$1 = getEnglishVariant$3$1;

var getEnglishVariant$2$1 = getEnglishVariant_1$1;

var BritishEnglishDefinition$1$1 = getEnglishVariant$2$1({
  'short':  '{dd}/{MM}/{yyyy}',
  'medium': '{d} {Month} {yyyy}',
  'long':   '{d} {Month} {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var BritishEnglishDefinition_1$1 = BritishEnglishDefinition$1$1;

var getEnglishVariant$1$1 = getEnglishVariant_1$1;

var AmericanEnglishDefinition$2$1 = getEnglishVariant$1$1({
  'mdy': true,
  'firstDayOfWeek': 0,
  'firstDayOfWeekYear': 1,
  'short':  '{MM}/{dd}/{yyyy}',
  'medium': '{Month} {d}, {yyyy}',
  'long':   '{Month} {d}, {yyyy} {time}',
  'full':   '{Weekday}, {Month} {d}, {yyyy} {time}',
  'stamp':  '{Dow} {Mon} {d} {yyyy} {time}',
  'time':   '{h}:{mm} {TT}'
});

var AmericanEnglishDefinition_1$1 = AmericanEnglishDefinition$2$1;

var getEnglishVariant$4 = getEnglishVariant_1$1;

var CanadianEnglishDefinition$1$1 = getEnglishVariant$4({
  'short':  '{yyyy}-{MM}-{dd}',
  'medium': '{d} {Month}, {yyyy}',
  'long':   '{d} {Month}, {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var CanadianEnglishDefinition_1$1 = CanadianEnglishDefinition$1$1;

var BritishEnglishDefinition$2 = BritishEnglishDefinition_1$1,
    AmericanEnglishDefinition$1$1 = AmericanEnglishDefinition_1$1,
    CanadianEnglishDefinition$2 = CanadianEnglishDefinition_1$1;

var LazyLoadedLocales$1$1 = {
  'en-US': AmericanEnglishDefinition$1$1,
  'en-GB': BritishEnglishDefinition$2,
  'en-AU': BritishEnglishDefinition$2,
  'en-CA': CanadianEnglishDefinition$2
};

var LazyLoadedLocales_1$1 = LazyLoadedLocales$1$1;

var LOCALE_ARRAY_FIELDS$1$1 = [
  'months', 'weekdays', 'units', 'numerals', 'placeholders',
  'articles', 'tokens', 'timeMarkers', 'ampm', 'timeSuffixes',
  'parse', 'timeParse', 'timeFrontParse', 'modifiers'
];

var LOCALE_ARRAY_FIELDS_1$1 = LOCALE_ARRAY_FIELDS$1$1;

var ISODefaults$3$1 = {
  ISO_FIRST_DAY_OF_WEEK: 1,
  ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};

var CoreParsingTokens$1$1 = {
  'yyyy': {
    param: 'year',
    src: '[-−+]?\\d{4,6}'
  },
  'yy': {
    param: 'year',
    src: '\\d{2}'
  },
  'y': {
    param: 'year',
    src: '\\d'
  },
  'ayy': {
    param: 'year',
    src: '\'\\d{2}'
  },
  'MM': {
    param: 'month',
    src: '(?:1[012]|0?[1-9])'
  },
  'dd': {
    param: 'date',
    src: '(?:3[01]|[12][0-9]|0?[1-9])'
  },
  'hh': {
    param: 'hour',
    src: '(?:2[0-4]|[01]?[0-9])'
  },
  'mm': {
    param: 'minute',
    src: '[0-5]\\d'
  },
  'ss': {
    param: 'second',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'tzHour': {
    src: '[-−+](?:2[0-4]|[01]?[0-9])'
  },
  'tzMinute': {
    src: '[0-5]\\d'
  },
  'iyyyy': {
    param: 'year',
    src: '(?:[-−+]?\\d{4}|[-−+]\\d{5,6})'
  },
  'ihh': {
    param: 'hour',
    src: '(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?'
  },
  'imm': {
    param: 'minute',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'GMT': {
    param: 'utc',
    src: 'GMT'
  },
  'Z': {
    param: 'utc',
    src: 'Z'
  },
  'timestamp': {
    src: '\\d+'
  }
};

var CoreParsingTokens_1$1 = CoreParsingTokens$1$1;

var CoreParsingFormats$1$1 = [
  {
    // 12-1978
    // 08-1978 (MDY)
    src: '{MM}[-.\\/]{yyyy}'
  },
  {
    // 12/08/1978
    // 08/12/1978 (MDY)
    time: true,
    src: '{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?',
    mdy: '{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?'
  },
  {
    // 12.08.1978
    // 08.12.1978 (MDY)
    time: true,
    src: '{dd}\\.{MM}(?:\\.{yyyy|yy|y})?',
    mdy: '{MM}\\.{dd}(?:\\.{yyyy|yy|y})?',
    localeCheck: function(loc) {
      // Do not allow this format if the locale
      // uses a period as a time separator.
      return loc.timeSeparator !== '.';
    }
  },
  {
    // 1975-08-25
    time: true,
    src: '{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?'
  },
  {
    // .NET JSON
    src: '\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/'
  },
  {
    // ISO-8601
    src: '{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}'
  }
];

var CoreParsingFormats_1$1 = CoreParsingFormats$1$1;

var LocalizedParsingTokens$2$1 = {
  'year': {
    base: 'yyyy|ayy',
    requiresSuffix: true
  },
  'month': {
    base: 'MM',
    requiresSuffix: true
  },
  'date': {
    base: 'dd',
    requiresSuffix: true
  },
  'hour': {
    base: 'hh',
    requiresSuffixOr: ':'
  },
  'minute': {
    base: 'mm'
  },
  'second': {
    base: 'ss'
  },
  'num': {
    src: '\\d+',
    requiresNumerals: true
  }
};

var LocalizedParsingTokens_1$1 = LocalizedParsingTokens$2$1;

function getArrayWithOffset$1$1(arr, n, alternate, offset) {
  var val;
  if (alternate > 1) {
    val = arr[n + (alternate - 1) * offset];
  }
  return val || arr[n];
}

var getArrayWithOffset_1$1 = getArrayWithOffset$1$1;

function getRegNonCapturing$2$1(src, opt) {
  if (src.length > 1) {
    src = '(?:' + src + ')';
  }
  if (opt) {
    src += '?';
  }
  return src;
}

var getRegNonCapturing_1$1 = getRegNonCapturing$2$1;

var PRIVATE_PROP_PREFIX$1$1 = '_sugar_';

var PRIVATE_PROP_PREFIX$2 = PRIVATE_PROP_PREFIX$1$1,
    coreUtilityAliases$7$1 = coreUtilityAliases$M$1;

var setProperty$2 = coreUtilityAliases$7$1.setProperty;

function privatePropertyAccessor$5$1(key) {
  var privateKey = PRIVATE_PROP_PREFIX$2 + key;
  return function(obj, val) {
    if (arguments.length > 1) {
      setProperty$2(obj, privateKey, val);
      return obj;
    }
    return obj[privateKey];
  };
}

var privatePropertyAccessor_1$1 = privatePropertyAccessor$5$1;

var privatePropertyAccessor$4$1 = privatePropertyAccessor_1$1;

var _utc$8$1 = privatePropertyAccessor$4$1('utc');

var _utc$7$1 = _utc$8$1;

function callDateGet$a$1(d, method) {
  return d['get' + (_utc$7$1(d) ? 'UTC' : '') + method]();
}

var callDateGet_1$1 = callDateGet$a$1;

var callDateGet$9$1 = callDateGet_1$1;

function getYear$8(d) {
  return callDateGet$9$1(d, 'FullYear');
}

var getYear_1$1 = getYear$8;

var callDateGet$8$1 = callDateGet_1$1;

function getMonth$7$1(d) {
  return callDateGet$8$1(d, 'Month');
}

var getMonth_1$1 = getMonth$7$1;

var getYear$7$1 = getYear_1$1,
    getMonth$6$1 = getMonth_1$1,
    callDateGet$7$1 = callDateGet_1$1;

function getDaysInMonth$2$1(d) {
  return 32 - callDateGet$7$1(new Date(getYear$7$1(d), getMonth$6$1(d), 32), 'Date');
}

var getDaysInMonth_1$1 = getDaysInMonth$2$1;

var getDaysInMonth$1$1 = getDaysInMonth_1$1;

var DateUnits$7$1 = [
  {
    name: 'millisecond',
    method: 'Milliseconds',
    multiplier: 1,
    start: 0,
    end: 999
  },
  {
    name: 'second',
    method: 'Seconds',
    multiplier: 1000,
    start: 0,
    end: 59
  },
  {
    name: 'minute',
    method: 'Minutes',
    multiplier: 60 * 1000,
    start: 0,
    end: 59
  },
  {
    name: 'hour',
    method: 'Hours',
    multiplier: 60 * 60 * 1000,
    start: 0,
    end: 23
  },
  {
    name: 'day',
    alias: 'date',
    method: 'Date',
    ambiguous: true,
    multiplier: 24 * 60 * 60 * 1000,
    start: 1,
    end: function(d) {
      return getDaysInMonth$1$1(d);
    }
  },
  {
    name: 'week',
    method: 'ISOWeek',
    ambiguous: true,
    multiplier: 7 * 24 * 60 * 60 * 1000
  },
  {
    name: 'month',
    method: 'Month',
    ambiguous: true,
    multiplier: 30.4375 * 24 * 60 * 60 * 1000,
    start: 0,
    end: 11
  },
  {
    name: 'year',
    method: 'FullYear',
    ambiguous: true,
    multiplier: 365.25 * 24 * 60 * 60 * 1000,
    start: 0
  }
];

var DateUnits_1$1 = DateUnits$7$1;

var DateUnitIndexes$i$1 = {
  HOURS_INDEX: 3,
  DAY_INDEX: 4,
  WEEK_INDEX: 5,
  MONTH_INDEX: 6,
  YEAR_INDEX: 7
};

var DateUnits$6$1 = DateUnits_1$1,
    DateUnitIndexes$h$1 = DateUnitIndexes$i$1,
    isUndefined$4$1 = isUndefined_1$1;

var YEAR_INDEX$4$1 = DateUnitIndexes$h$1.YEAR_INDEX;

function iterateOverDateUnits$3$1(fn, startIndex, endIndex) {
  endIndex = endIndex || 0;
  if (isUndefined$4$1(startIndex)) {
    startIndex = YEAR_INDEX$4$1;
  }
  for (var index = startIndex; index >= endIndex; index--) {
    if (fn(DateUnits$6$1[index], index) === false) {
      break;
    }
  }
}

var iterateOverDateUnits_1$1 = iterateOverDateUnits$3$1;

var map$1$1 = map_1$1,
    escapeRegExp$1$1 = escapeRegExp_1$1;

function arrayToRegAlternates$1$1(arr) {
  var joined = arr.join('');
  if (!arr || !arr.length) {
    return '';
  }
  if (joined.length === arr.length) {
    return '[' + joined + ']';
  }
  // map handles sparse arrays so no need to compact the array here.
  return map$1$1(arr, escapeRegExp$1$1).join('|');
}

var arrayToRegAlternates_1$1 = arrayToRegAlternates$1$1;

var mathAliases$g$1 = mathAliases$z$1,
    iterateOverDateUnits$2$1 = iterateOverDateUnits_1$1;

var abs$5$1 = mathAliases$g$1.abs;

function getAdjustedUnit$2$1(ms, fn) {
  var unitIndex = 0, value = 0;
  iterateOverDateUnits$2$1(function(unit, i) {
    value = abs$5$1(fn(unit));
    if (value >= 1) {
      unitIndex = i;
      return false;
    }
  });
  return [value, unitIndex, ms];
}

var getAdjustedUnit_1$1 = getAdjustedUnit$2$1;

var trunc$7$1 = trunc_1$1,
    withPrecision$1$1 = withPrecision_1$1,
    getAdjustedUnit$1$1 = getAdjustedUnit_1$1;

function getAdjustedUnitForNumber$1$1(ms) {
  return getAdjustedUnit$1$1(ms, function(unit) {
    return trunc$7$1(withPrecision$1$1(ms / unit.multiplier, 1));
  });
}

var getAdjustedUnitForNumber_1$1 = getAdjustedUnitForNumber$1$1;

var LocalizedParsingTokens$1$1 = LocalizedParsingTokens_1$1,
    getRegNonCapturing$1$1 = getRegNonCapturing_1$1;

function getParsingTokenWithSuffix$1$1(field, src, suffix) {
  var token = LocalizedParsingTokens$1$1[field];
  if (token.requiresSuffix) {
    src = getRegNonCapturing$1$1(src + getRegNonCapturing$1$1(suffix));
  } else if (token.requiresSuffixOr) {
    src += getRegNonCapturing$1$1(token.requiresSuffixOr + '|' + suffix);
  } else {
    src += getRegNonCapturing$1$1(suffix, true);
  }
  return src;
}

var getParsingTokenWithSuffix_1$1 = getParsingTokenWithSuffix$1$1;

var LOCALE_ARRAY_FIELDS$2 = LOCALE_ARRAY_FIELDS_1$1,
    ISODefaults$2$1 = ISODefaults$3$1,
    CoreParsingTokens$2 = CoreParsingTokens_1$1,
    CoreParsingFormats$2 = CoreParsingFormats_1$1,
    LocalizedParsingTokens$3 = LocalizedParsingTokens_1$1,
    map$8 = map_1$1,
    filter$4 = filter_1$1,
    forEach$4$1 = forEach_1$1,
    isDefined$7$1 = isDefined_1$1,
    commaSplit$3 = commaSplit_1$1,
    classChecks$j$1 = classChecks$Z$1,
    mathAliases$f$1 = mathAliases$z$1,
    isUndefined$3$1 = isUndefined_1$1,
    simpleMerge$1$1 = simpleMerge_1$1,
    getOrdinalSuffix$3 = getOrdinalSuffix_1$1,
    getArrayWithOffset$2 = getArrayWithOffset_1$1,
    getRegNonCapturing$3 = getRegNonCapturing_1$1,
    coreUtilityAliases$6$1 = coreUtilityAliases$M$1,
    iterateOverDateUnits$1$1 = iterateOverDateUnits_1$1,
    arrayToRegAlternates$2 = arrayToRegAlternates_1$1,
    fullwidthNumberHelpers$3 = fullwidthNumberHelpers$2$1,
    getAdjustedUnitForNumber$2 = getAdjustedUnitForNumber_1$1,
    getParsingTokenWithSuffix$2 = getParsingTokenWithSuffix_1$1;

var hasOwn$3$1 = coreUtilityAliases$6$1.hasOwn,
    getOwn$4$1 = coreUtilityAliases$6$1.getOwn,
    forEachProperty$2$1 = coreUtilityAliases$6$1.forEachProperty,
    fullWidthNumberMap$3 = fullwidthNumberHelpers$3.fullWidthNumberMap,
    fullWidthNumbers$2 = fullwidthNumberHelpers$3.fullWidthNumbers,
    pow$3 = mathAliases$f$1.pow,
    max$3$1 = mathAliases$f$1.max,
    ISO_FIRST_DAY_OF_WEEK$2$1 = ISODefaults$2$1.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$2$1 = ISODefaults$2$1.ISO_FIRST_DAY_OF_WEEK_YEAR,
    isString$7$1 = classChecks$j$1.isString,
    isFunction$3$1 = classChecks$j$1.isFunction;

function getNewLocale$1$1(def) {

  function Locale(def) {
    this.init(def);
  }

  Locale.prototype = {

    getMonthName: function(n, alternate) {
      if (this.monthSuffix) {
        return (n + 1) + this.monthSuffix;
      }
      return getArrayWithOffset$2(this.months, n, alternate, 12);
    },

    getWeekdayName: function(n, alternate) {
      return getArrayWithOffset$2(this.weekdays, n, alternate, 7);
    },

    // TODO: rename to parse in next major version
    parseValue: function(str, param) {
      var map = this[param + 'Map'];
      if (hasOwn$3$1(map, str)) {
        return map[str];
      }
      return this.parseNumber(str, param);
    },

    // TODO: analyze performance of parsing first vs checking
    // numeralMap first.
    parseNumber: function(str, param) {
      var val;

      // Simple numerals such as "one" are mapped directly in
      // the numeral map so catch up front if there is a match.
      if (hasOwn$3$1(this.numeralMap, str)) {
        val = this.numeralMap[str];
      }

      // TODO: perf test isNaN vs other methods
      if (isNaN(val)) {
        val = this.parseRegularNumerals(str);
      }

      if (isNaN(val)) {
        val = this.parseIrregularNumerals(str);
      }

      if (param === 'month') {
        // Months are the only numeric date field
        // whose value is not the same as its number.
        val -= 1;
      }

      return val;
    },

    // TODO: perf test returning up front if no regular decimals exist
    parseRegularNumerals: function(str) {
      // Allow decimals as commas and the minus-sign as per ISO-8601.
      str = str.replace(/^−/, '-').replace(/,/, '.');

      // The unary plus operator here shows better performance and handles
      // every format that parseFloat does with the exception of trailing
      // characters, which are guaranteed not to be in our string at this point.
      return +str;
    },

    parseIrregularNumerals: function(str) {
      var place = 1, num = 0, lastWasPlace, isPlace, numeral, digit, arr;

      // Note that "numerals" that need to be converted through this method are
      // all considered to be single characters in order to handle CJK. This
      // method is by no means unique to CJK, but the complexity of handling
      // inflections in non-CJK languages adds too much overhead for not enough
      // value, so avoiding for now.
      arr = str.split('');
      for (var i = arr.length - 1; numeral = arr[i]; i--) {
        digit = getOwn$4$1(this.numeralMap, numeral);
        if (isUndefined$3$1(digit)) {
          digit = getOwn$4$1(fullWidthNumberMap$3, numeral) || 0;
        }
        isPlace = digit > 0 && digit % 10 === 0;
        if (isPlace) {
          if (lastWasPlace) {
            num += place;
          }
          if (i) {
            place = digit;
          } else {
            num += digit;
          }
        } else {
          num += digit * place;
          place *= 10;
        }
        lastWasPlace = isPlace;
      }
      return num;
    },

    getOrdinal: function(n) {
      var suffix = this.ordinalSuffix;
      return suffix || getOrdinalSuffix$3(n);
    },

    getRelativeFormat: function(adu, type) {
      return this.convertAdjustedToFormat(adu, type);
    },

    getDuration: function(ms) {
      return this.convertAdjustedToFormat(getAdjustedUnitForNumber$2(max$3$1(0, ms)), 'duration');
    },

    getFirstDayOfWeek: function() {
      var val = this.firstDayOfWeek;
      return isDefined$7$1(val) ? val : ISO_FIRST_DAY_OF_WEEK$2$1;
    },

    getFirstDayOfWeekYear: function() {
      return this.firstDayOfWeekYear || ISO_FIRST_DAY_OF_WEEK_YEAR$2$1;
    },

    convertAdjustedToFormat: function(adu, type) {
      var sign, unit, mult,
          num    = adu[0],
          u      = adu[1],
          ms     = adu[2],
          format = this[type] || this.relative;
      if (isFunction$3$1(format)) {
        return format.call(this, num, u, ms, type);
      }
      mult = !this.plural || num === 1 ? 0 : 1;
      unit = this.units[mult * 8 + u] || this.units[u];
      sign = this[ms > 0 ? 'fromNow' : 'ago'];
      return format.replace(/\{(.*?)\}/g, function(full, match) {
        switch(match) {
          case 'num': return num;
          case 'unit': return unit;
          case 'sign': return sign;
        }
      });
    },

    cacheFormat: function(dif, i) {
      this.compiledFormats.splice(i, 1);
      this.compiledFormats.unshift(dif);
    },

    addFormat: function(format) {
      var loc = this, src, to;

      function getTokenSrc(token) {
        var suffix, src, tmp,
            opt   = token.match(/\?$/),
            nc    = token.match(/^(\d+)\??$/),
            slice = token.match(/(\d)(?:-(\d))?/),
            param = token.replace(/[^a-z]+$/i, '');

        // Allowing alias tokens such as {time}
        if (tmp = getOwn$4$1(loc.parsingAliases, param)) {
          src = formatToSrc(tmp);
          if (opt) {
            src = getRegNonCapturing$3(src, true);
          }
          return src;
        }

        if (nc) {
          src = loc.tokens[nc[1]];
        } else if (tmp = getOwn$4$1(CoreParsingTokens$2, param)) {
          src = tmp.src;
          param = tmp.param || param;
        } else {
          tmp = getOwn$4$1(loc.parsingTokens, param) || getOwn$4$1(loc, param);

          // Both the "months" array and the "month" parsing token can be accessed
          // by either {month} or {months}, falling back as necessary, however
          // regardless of whether or not a fallback occurs, the final field to
          // be passed to addRawFormat must be normalized as singular.
          param = param.replace(/s$/, '');

          if (!tmp) {
            tmp = getOwn$4$1(loc.parsingTokens, param) || getOwn$4$1(loc, param + 's');
          }

          if (isString$7$1(tmp)) {
            src = tmp;
            suffix = loc[param + 'Suffix'];
          } else {

            // This is a hack to temporarily disallow parsing of single character
            // weekdays until the format can be changed to allow for this.
            if (param === 'weekday' && loc.code === 'ko') {
              tmp = filter$4(tmp, function(str) {
                return str.length > 1;
              });
            }

            if (slice) {
              tmp = filter$4(tmp, function(m, i) {
                var mod = i % (loc.units ? 8 : tmp.length);
                return mod >= slice[1] && mod <= (slice[2] || slice[1]);
              });
            }
            src = arrayToRegAlternates$2(tmp);
          }
        }
        if (!src) {
          return '';
        }
        if (nc) {
          // Non-capturing tokens like {0}
          src = getRegNonCapturing$3(src);
        } else {
          // Capturing group and add to parsed tokens
          to.push(param);
          src = '(' + src + ')';
        }
        if (suffix) {
          // Date/time suffixes such as those in CJK
          src = getParsingTokenWithSuffix$2(param, src, suffix);
        }
        if (opt) {
          src += '?';
        }
        return src;
      }

      function formatToSrc(str) {

        // Make spaces optional
        str = str.replace(/ /g, ' ?');

        str = str.replace(/\{([^,]+?)\}/g, function(match, token) {
          var tokens = token.split('|');
          if (tokens.length > 1) {
            return getRegNonCapturing$3(map$8(tokens, getTokenSrc).join('|'));
          } else {
            return getTokenSrc(token);
          }
        });

        return str;
      }

      function parseInputFormat() {
        to = [];
        src = formatToSrc(format);
      }

      parseInputFormat();
      loc.addRawFormat(src, to);
    },

    addRawFormat: function(format, to) {
      this.compiledFormats.unshift({
        reg: RegExp('^ *' + format + ' *$', 'i'),
        to: to
      });
    },

    init: function(def) {
      var loc = this;

      // -- Initialization helpers

      function initFormats() {
        loc.compiledFormats = [];
        loc.parsingAliases = {};
        loc.parsingTokens = {};
      }

      function initDefinition() {
        simpleMerge$1$1(loc, def);
      }

      function initArrayFields() {
        forEach$4$1(LOCALE_ARRAY_FIELDS$2, function(name) {
          var val = loc[name];
          if (isString$7$1(val)) {
            loc[name] = commaSplit$3(val);
          } else if (!val) {
            loc[name] = [];
          }
        });
      }

      // -- Value array build helpers

      function buildValueArray(name, mod, map, fn) {
        var field = name, all = [], setMap;
        if (!loc[field]) {
          field += 's';
        }
        if (!map) {
          map = {};
          setMap = true;
        }
        forAllAlternates(field, function(alt, j, i) {
          var idx = j * mod + i, val;
          val = fn ? fn(i) : i;
          map[alt] = val;
          map[alt.toLowerCase()] = val;
          all[idx] = alt;
        });
        loc[field] = all;
        if (setMap) {
          loc[name + 'Map'] = map;
        }
      }

      function forAllAlternates(field, fn) {
        forEach$4$1(loc[field], function(str, i) {
          forEachAlternate(str, function(alt, j) {
            fn(alt, j, i);
          });
        });
      }

      function forEachAlternate(str, fn) {
        var arr = map$8(str.split('+'), function(split) {
          return split.replace(/(.+):(.+)$/, function(full, base, suffixes) {
            return map$8(suffixes.split('|'), function(suffix) {
              return base + suffix;
            }).join('|');
          });
        }).join('|');
        forEach$4$1(arr.split('|'), fn);
      }

      function buildNumerals() {
        var map = {};
        buildValueArray('numeral', 10, map);
        buildValueArray('article', 1, map, function() {
          return 1;
        });
        buildValueArray('placeholder', 4, map, function(n) {
          return pow$3(10, n + 1);
        });
        loc.numeralMap = map;
      }

      function buildTimeFormats() {
        loc.parsingAliases['time'] = getTimeFormat();
        loc.parsingAliases['tzOffset'] = getTZOffsetFormat();
      }

      function getTimeFormat(standalone) {
        var src, sep;
        sep = getTimeSeparatorSrc();
        if (loc.ampmFront) {
          // "ampmFront" exists mostly for CJK locales, which also presume that
          // time suffixes exist, allowing this to be a simpler regex.
          src = '{ampm?} {hour} (?:{minute} (?::?{second})?)?';
        } else if(loc.ampm.length) {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})? {ampm?}| {ampm})';
        } else {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})?)';
        }
        return src;
      }

      function getTimeSeparatorSrc() {
        if (loc.timeSeparator) {
          return '[:' + loc.timeSeparator + ']';
        } else {
          return ':';
        }
      }

      function getTZOffsetFormat() {
        return '(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?';
      }

      function buildParsingTokens() {
        forEachProperty$2$1(LocalizedParsingTokens$3, function(token, name) {
          var src = token.base ? getCoreTokensForBase(token.base) : token.src, arr;
          if (token.requiresNumerals || loc.numeralUnits) {
            src += getNumeralSrc();
          }
          arr = loc[name + 's'];
          if (arr && arr.length) {
            src += '|' + arrayToRegAlternates$2(arr);
          }
          loc.parsingTokens[name] = src;
        });
      }

      function getCoreTokensForBase(base) {
        return map$8(base.split('|'), function(key) {
          return CoreParsingTokens$2[key].src;
        }).join('|');
      }

      function getNumeralSrc() {
        var all, src = '';
        all = loc.numerals.concat(loc.placeholders).concat(loc.articles);
        if (loc.allowsFullWidth) {
          all = all.concat(fullWidthNumbers$2.split(''));
        }
        if (all.length) {
          src = '|(?:' + arrayToRegAlternates$2(all) + ')+';
        }
        return src;
      }

      function buildTimeSuffixes() {
        iterateOverDateUnits$1$1(function(unit, i) {
          var token = loc.timeSuffixes[i];
          if (token) {
            loc[(unit.alias || unit.name) + 'Suffix'] = token;
          }
        });
      }

      function buildModifiers() {
        forEach$4$1(loc.modifiers, function(modifier) {
          var name = modifier.name, mapKey = name + 'Map', map;
          map = loc[mapKey] || {};
          forEachAlternate(modifier.src, function(alt, j) {
            var token = getOwn$4$1(loc.parsingTokens, name), val = modifier.value;
            map[alt] = val;
            loc.parsingTokens[name] = token ? token + '|' + alt : alt;
            if (modifier.name === 'sign' && j === 0) {
              // Hooking in here to set the first "fromNow" or "ago" modifier
              // directly on the locale, so that it can be reused in the
              // relative format.
              loc[val === 1 ? 'fromNow' : 'ago'] = alt;
            }
          });
          loc[mapKey] = map;
        });
      }

      // -- Format adding helpers

      function addCoreFormats() {
        forEach$4$1(CoreParsingFormats$2, function(df) {
          var src = df.src;
          if (df.localeCheck && !df.localeCheck(loc)) {
            return;
          }
          if (df.mdy && loc.mdy) {
            // Use the mm/dd/yyyy variant if it
            // exists and the locale requires it
            src = df.mdy;
          }
          if (df.time) {
            // Core formats that allow time require the time
            // reg on both sides, so add both versions here.
            loc.addFormat(getFormatWithTime(src, true));
            loc.addFormat(getFormatWithTime(src));
          } else {
            loc.addFormat(src);
          }
        });
        loc.addFormat('{time}');
      }

      function addLocaleFormats() {
        addFormatSet('parse');
        addFormatSet('timeParse', true);
        addFormatSet('timeFrontParse', true, true);
      }

      function addFormatSet(field, allowTime, timeFront) {
        forEach$4$1(loc[field], function(format) {
          if (allowTime) {
            format = getFormatWithTime(format, timeFront);
          }
          loc.addFormat(format);
        });
      }

      function getFormatWithTime(baseFormat, timeBefore) {
        if (timeBefore) {
          return getTimeBefore() + baseFormat;
        }
        return baseFormat + getTimeAfter();
      }

      function getTimeBefore() {
        return getRegNonCapturing$3('{time}[,\\s\\u3000]', true);
      }

      function getTimeAfter() {
        var markers = ',?[\\s\\u3000]', localized;
        localized = arrayToRegAlternates$2(loc.timeMarkers);
        if (localized) {
          markers += '| (?:' + localized + ') ';
        }
        markers = getRegNonCapturing$3(markers, loc.timeMarkerOptional);
        return getRegNonCapturing$3(markers + '{time}{tzOffset}', true);
      }

      initFormats();
      initDefinition();
      initArrayFields();

      buildValueArray('month', 12);
      buildValueArray('weekday', 7);
      buildValueArray('unit', 8);
      buildValueArray('ampm', 2);

      buildNumerals();
      buildTimeFormats();
      buildParsingTokens();
      buildTimeSuffixes();
      buildModifiers();

      // The order of these formats is important. Order is reversed so formats
      // that are initialized later will take precedence. Generally, this means
      // that more specific formats should come later.
      addCoreFormats();
      addLocaleFormats();

    }

  };

  return new Locale(def);
}

var getNewLocale_1$1 = getNewLocale$1$1;

var LazyLoadedLocales$2 = LazyLoadedLocales_1$1,
    AmericanEnglishDefinition$3 = AmericanEnglishDefinition_1$1,
    getNewLocale$2 = getNewLocale_1$1;

var English$3$1, localeManager$f$1;

function buildLocales$1() {

  function LocaleManager(loc) {
    this.locales = {};
    this.add(loc);
  }

  LocaleManager.prototype = {

    get: function(code, fallback) {
      var loc = this.locales[code];
      if (!loc && LazyLoadedLocales$2[code]) {
        loc = this.add(code, LazyLoadedLocales$2[code]);
      } else if (!loc && code) {
        loc = this.locales[code.slice(0, 2)];
      }
      return loc || fallback === false ? loc : this.current;
    },

    getAll: function() {
      return this.locales;
    },

    set: function(code) {
      var loc = this.get(code, false);
      if (!loc) {
        throw new TypeError('Invalid Locale: ' + code);
      }
      return this.current = loc;
    },

    add: function(code, def) {
      if (!def) {
        def = code;
        code = def.code;
      } else {
        def.code = code;
      }
      var loc = def.compiledFormats ? def : getNewLocale$2(def);
      this.locales[code] = loc;
      if (!this.current) {
        this.current = loc;
      }
      return loc;
    },

    remove: function(code) {
      if (this.current.code === code) {
        this.current = this.get('en');
      }
      return delete this.locales[code];
    }

  };

  // Sorry about this guys...
  English$3$1 = getNewLocale$2(AmericanEnglishDefinition$3);
  localeManager$f$1 = new LocaleManager(English$3$1);
}

buildLocales$1();

var LocaleHelpers$h$1 = {
  English: English$3$1,
  localeManager: localeManager$f$1
};

var Sugar$3i$1 = sugarCore$1.exports,
    LocaleHelpers$g$1 = LocaleHelpers$h$1;

var localeManager$e$1 = LocaleHelpers$g$1.localeManager;

Sugar$3i$1.Date.defineStatic({

  'addLocale': function(code, set) {
    return localeManager$e$1.add(code, set);
  }

});

Sugar$3i$1.Date.addLocale;

var MINUTES$2$1 = 60 * 1000;

var ABBREVIATED_YEAR_REG$1$1 = /^'?(\d{1,2})$/;

function tzOffset$4$1(d) {
  return d.getTimezoneOffset();
}

var tzOffset_1$1 = tzOffset$4$1;

var _utc$6$1 = _utc$8$1,
    callDateGet$6$1 = callDateGet_1$1;

function callDateSet$6$1(d, method, value, safe) {
  // "Safe" denotes not setting the date if the value is the same as what is
  // currently set. In theory this should be a noop, however it will cause
  // timezone shifts when in the middle of a DST fallback. This is unavoidable
  // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
  // November 1st, 2015 in northern hemisphere timezones that follow DST),
  // however when advancing or rewinding dates this can throw off calculations
  // so avoiding this unintentional shifting on an opt-in basis.
  if (safe && value === callDateGet$6$1(d, method)) {
    return;
  }
  d['set' + (_utc$6$1(d) ? 'UTC' : '') + method](value);
}

var callDateSet_1$1 = callDateSet$6$1;

var DateUnitIndexes$g$1 = DateUnitIndexes$i$1;

var HOURS_INDEX$2$1 = DateUnitIndexes$g$1.HOURS_INDEX,
    DAY_INDEX$9$1 = DateUnitIndexes$g$1.DAY_INDEX,
    WEEK_INDEX$4$1 = DateUnitIndexes$g$1.WEEK_INDEX,
    MONTH_INDEX$6$1 = DateUnitIndexes$g$1.MONTH_INDEX;

function getLowerUnitIndex$5$1(index) {
  if (index === MONTH_INDEX$6$1) {
    return DAY_INDEX$9$1;
  } else if (index === WEEK_INDEX$4$1) {
    return HOURS_INDEX$2$1;
  }
  return index - 1;
}

var getLowerUnitIndex_1$1 = getLowerUnitIndex$5$1;

var DateUnits$5$1 = DateUnits_1$1,
    getLowerUnitIndex$4$1 = getLowerUnitIndex_1$1;

function walkUnitDown$2$1(unitIndex, fn) {
  while (unitIndex >= 0) {
    if (fn(DateUnits$5$1[unitIndex], unitIndex) === false) {
      break;
    }
    unitIndex = getLowerUnitIndex$4$1(unitIndex);
  }
}

var walkUnitDown_1$1 = walkUnitDown$2$1;

var isDefined$6$1 = isDefined_1$1,
    classChecks$i$1 = classChecks$Z$1,
    callDateSet$5$1 = callDateSet_1$1,
    walkUnitDown$1$1 = walkUnitDown_1$1;

var isFunction$2$1 = classChecks$i$1.isFunction;

function setUnitAndLowerToEdge$6$1(d, startIndex, stopIndex, end) {
  walkUnitDown$1$1(startIndex, function(unit, i) {
    var val = end ? unit.end : unit.start;
    if (isFunction$2$1(val)) {
      val = val(d);
    }
    callDateSet$5$1(d, unit.method, val);
    return !isDefined$6$1(stopIndex) || i > stopIndex;
  });
  return d;
}

var setUnitAndLowerToEdge_1$1 = setUnitAndLowerToEdge$6$1;

var DateUnitIndexes$f$1 = DateUnitIndexes$i$1,
    setUnitAndLowerToEdge$5$1 = setUnitAndLowerToEdge_1$1;

var HOURS_INDEX$1$1 = DateUnitIndexes$f$1.HOURS_INDEX;

function resetTime$2$1(d) {
  return setUnitAndLowerToEdge$5$1(d, HOURS_INDEX$1$1);
}

var resetTime_1$1 = resetTime$2$1;

function defaultNewDate$1$1() {
  return new Date;
}

var defaultNewDate_1$1 = defaultNewDate$1$1;

var defaultNewDate$2 = defaultNewDate_1$1;

var DATE_OPTIONS$1$1 = {
  'newDateInternal': defaultNewDate$2
};

var DATE_OPTIONS_1$1 = DATE_OPTIONS$1$1;

var DATE_OPTIONS$2 = DATE_OPTIONS_1$1,
    namespaceAliases$7$1 = namespaceAliases$e$1,
    defineOptionsAccessor$4 = defineOptionsAccessor_1$1;

var sugarDate$6$1 = namespaceAliases$7$1.sugarDate;

var _dateOptions$1$1 = defineOptionsAccessor$4(sugarDate$6$1, DATE_OPTIONS$2);

var _dateOptions$2 = _dateOptions$1$1;

function getNewDate$5$1() {
  return _dateOptions$2('newDateInternal')();
}

var getNewDate_1$1 = getNewDate$5$1;

var callDateSet$4$1 = callDateSet_1$1;

function setDate$6$1(d, val) {
  callDateSet$4$1(d, 'Date', val);
}

var setDate_1$1 = setDate$6$1;

var callDateGet$5$1 = callDateGet_1$1;

function getDate$6$1(d) {
  return callDateGet$5$1(d, 'Date');
}

var getDate_1$1 = getDate$6$1;

var callDateGet$4$1 = callDateGet_1$1;

function getWeekday$9$1(d) {
  return callDateGet$4$1(d, 'Day');
}

var getWeekday_1$1 = getWeekday$9$1;

var setDate$5$1 = setDate_1$1,
    getDate$5$1 = getDate_1$1,
    getWeekday$8$1 = getWeekday_1$1,
    classChecks$h$1 = classChecks$Z$1,
    mathAliases$e$1 = mathAliases$z$1;

var isNumber$9$1 = classChecks$h$1.isNumber,
    abs$4$1 = mathAliases$e$1.abs;

function setWeekday$8$1(d, dow, dir) {
  if (!isNumber$9$1(dow)) return;
  var currentWeekday = getWeekday$8$1(d);
  if (dir) {
    // Allow a "direction" parameter to determine whether a weekday can
    // be set beyond the current weekday in either direction.
    var ndir = dir > 0 ? 1 : -1;
    var offset = dow % 7 - currentWeekday;
    if (offset && offset / abs$4$1(offset) !== ndir) {
      dow += 7 * ndir;
    }
  }
  setDate$5$1(d, getDate$5$1(d) + dow - currentWeekday);
  return d.getTime();
}

var setWeekday_1$1 = setWeekday$8$1;

var getLowerUnitIndex$3$1 = getLowerUnitIndex_1$1,
    setUnitAndLowerToEdge$4$1 = setUnitAndLowerToEdge_1$1;

function resetLowerUnits$1$1(d, unitIndex) {
  return setUnitAndLowerToEdge$4$1(d, getLowerUnitIndex$3$1(unitIndex));
}

var resetLowerUnits_1$1 = resetLowerUnits$1$1;

var DateUnitIndexes$e$1 = DateUnitIndexes$i$1;

var DAY_INDEX$8$1 = DateUnitIndexes$e$1.DAY_INDEX,
    MONTH_INDEX$5$1 = DateUnitIndexes$e$1.MONTH_INDEX;

function getHigherUnitIndex$1$1(index) {
  return index === DAY_INDEX$8$1 ? MONTH_INDEX$5$1 : index + 1;
}

var getHigherUnitIndex_1$1 = getHigherUnitIndex$1$1;

var callDateSet$3$1 = callDateSet_1$1;

function setYear$1$1(d, val) {
  callDateSet$3$1(d, 'FullYear', val);
}

var setYear_1$1 = setYear$1$1;

var callDateSet$2$1 = callDateSet_1$1;

function setMonth$1$1(d, val) {
  callDateSet$2$1(d, 'Month', val);
}

var setMonth_1$1 = setMonth$1$1;

var _utc$5$1 = _utc$8$1;

function cloneDate$6$1(d) {
  // Rhino environments have a bug where new Date(d) truncates
  // milliseconds so need to call getTime() here.
  var clone = new Date(d.getTime());
  _utc$5$1(clone, !!_utc$5$1(d));
  return clone;
}

var cloneDate_1$1 = cloneDate$6$1;

var setWeekday$7$1 = setWeekday_1$1,
    getWeekday$7$1 = getWeekday_1$1,
    mathAliases$d$1 = mathAliases$z$1;

var floor$6 = mathAliases$d$1.floor;

function moveToBeginningOfWeek$3$1(d, firstDayOfWeek) {
  setWeekday$7$1(d, floor$6((getWeekday$7$1(d) - firstDayOfWeek) / 7) * 7 + firstDayOfWeek);
  return d;
}

var moveToBeginningOfWeek_1$1 = moveToBeginningOfWeek$3$1;

var DateUnitIndexes$d$1 = DateUnitIndexes$i$1,
    setDate$4$1 = setDate_1$1,
    setUnitAndLowerToEdge$3$1 = setUnitAndLowerToEdge_1$1,
    moveToBeginningOfWeek$2$1 = moveToBeginningOfWeek_1$1;

var MONTH_INDEX$4$1 = DateUnitIndexes$d$1.MONTH_INDEX;

function moveToFirstDayOfWeekYear$2$1(d, firstDayOfWeek, firstDayOfWeekYear) {
  setUnitAndLowerToEdge$3$1(d, MONTH_INDEX$4$1);
  setDate$4$1(d, firstDayOfWeekYear);
  moveToBeginningOfWeek$2$1(d, firstDayOfWeek);
}

var moveToFirstDayOfWeekYear_1$1 = moveToFirstDayOfWeekYear$2$1;

var ISODefaults$1$1 = ISODefaults$3$1,
    getDate$4$1 = getDate_1$1,
    setDate$3$1 = setDate_1$1,
    setYear$2 = setYear_1$1,
    getYear$6$1 = getYear_1$1,
    getMonth$5$1 = getMonth_1$1,
    setMonth$2 = setMonth_1$1,
    cloneDate$5$1 = cloneDate_1$1,
    getWeekday$6$1 = getWeekday_1$1,
    setWeekday$6$1 = setWeekday_1$1,
    classChecks$g$1 = classChecks$Z$1,
    moveToFirstDayOfWeekYear$1$1 = moveToFirstDayOfWeekYear_1$1;

var isNumber$8$1 = classChecks$g$1.isNumber,
    ISO_FIRST_DAY_OF_WEEK$1$1 = ISODefaults$1$1.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$1$1 = ISODefaults$1$1.ISO_FIRST_DAY_OF_WEEK_YEAR;

function setISOWeekNumber$2$1(d, num) {
  if (isNumber$8$1(num)) {
    // Intentionally avoiding updateDate here to prevent circular dependencies.
    var isoWeek = cloneDate$5$1(d), dow = getWeekday$6$1(d);
    moveToFirstDayOfWeekYear$1$1(isoWeek, ISO_FIRST_DAY_OF_WEEK$1$1, ISO_FIRST_DAY_OF_WEEK_YEAR$1$1);
    setDate$3$1(isoWeek, getDate$4$1(isoWeek) + 7 * (num - 1));
    setYear$2(d, getYear$6$1(isoWeek));
    setMonth$2(d, getMonth$5$1(isoWeek));
    setDate$3$1(d, getDate$4$1(isoWeek));
    setWeekday$6$1(d, dow || 7);
  }
  return d.getTime();
}

var setISOWeekNumber_1$1 = setISOWeekNumber$2$1;

var callDateSet$1$1 = callDateSet_1$1,
    setISOWeekNumber$1$1 = setISOWeekNumber_1$1;

function callDateSetWithWeek$1$1(d, method, value, safe) {
  if (method === 'ISOWeek') {
    setISOWeekNumber$1$1(d, value);
  } else {
    callDateSet$1$1(d, method, value, safe);
  }
}

var callDateSetWithWeek_1$1 = callDateSetWithWeek$1$1;

var coreUtilityAliases$5$1 = coreUtilityAliases$M$1;

var hasOwn$2$1 = coreUtilityAliases$5$1.hasOwn;

function getOwnKey$1$1(obj, key) {
  if (hasOwn$2$1(obj, key)) {
    return key;
  }
}

var getOwnKey_1$1 = getOwnKey$1$1;

var getOwnKey$2 = getOwnKey_1$1;

function getDateParamKey$2$1(params, key) {
  return getOwnKey$2(params, key) ||
         getOwnKey$2(params, key + 's') ||
         (key === 'day' && getOwnKey$2(params, 'date'));
}

var getDateParamKey_1$1 = getDateParamKey$2$1;

var getDateParamKey$1$1 = getDateParamKey_1$1,
    coreUtilityAliases$4$1 = coreUtilityAliases$M$1;

var getOwn$3$1 = coreUtilityAliases$4$1.getOwn;

function getDateParam$1$1(params, key) {
  return getOwn$3$1(params, getDateParamKey$1$1(params, key));
}

var getDateParam_1$1 = getDateParam$1$1;

var DateUnitIndexes$c$1 = DateUnitIndexes$i$1,
    isDefined$5$1 = isDefined_1$1,
    getDateParam$2 = getDateParam_1$1,
    iterateOverDateUnits$4 = iterateOverDateUnits_1$1;

var DAY_INDEX$7$1 = DateUnitIndexes$c$1.DAY_INDEX;

function iterateOverDateParams$4$1(params, fn, startIndex, endIndex) {

  function run(name, unit, i) {
    var val = getDateParam$2(params, name);
    if (isDefined$5$1(val)) {
      fn(name, val, unit, i);
    }
  }

  iterateOverDateUnits$4(function (unit, i) {
    var result = run(unit.name, unit, i);
    if (result !== false && i === DAY_INDEX$7$1) {
      // Check for "weekday", which has a distinct meaning
      // in the context of setting a date, but has the same
      // meaning as "day" as a unit of time.
      result = run('weekday', unit, i);
    }
    return result;
  }, startIndex, endIndex);

}

var iterateOverDateParams_1$1 = iterateOverDateParams$4$1;

var DateUnits$4$1 = DateUnits_1$1,
    DateUnitIndexes$b$1 = DateUnitIndexes$i$1,
    trunc$6$1 = trunc_1$1,
    setDate$2$1 = setDate_1$1,
    getDate$3$1 = getDate_1$1,
    getMonth$4$1 = getMonth_1$1,
    getNewDate$4$1 = getNewDate_1$1,
    setWeekday$5$1 = setWeekday_1$1,
    mathAliases$c$1 = mathAliases$z$1,
    callDateGet$3$1 = callDateGet_1$1,
    classChecks$f$1 = classChecks$Z$1,
    resetLowerUnits$2 = resetLowerUnits_1$1,
    getLowerUnitIndex$2$1 = getLowerUnitIndex_1$1,
    getHigherUnitIndex$2 = getHigherUnitIndex_1$1,
    callDateSetWithWeek$2 = callDateSetWithWeek_1$1,
    iterateOverDateParams$3$1 = iterateOverDateParams_1$1;

var DAY_INDEX$6$1 = DateUnitIndexes$b$1.DAY_INDEX,
    WEEK_INDEX$3$1 = DateUnitIndexes$b$1.WEEK_INDEX,
    MONTH_INDEX$3$1 = DateUnitIndexes$b$1.MONTH_INDEX,
    YEAR_INDEX$3$1 = DateUnitIndexes$b$1.YEAR_INDEX,
    round$2$1 = mathAliases$c$1.round,
    isNumber$7$1 = classChecks$f$1.isNumber;

function updateDate$4$1(d, params, reset, advance, prefer, weekdayDir, contextDate) {
  var upperUnitIndex;

  function setUpperUnit(unitName, unitIndex) {
    if (prefer && !upperUnitIndex) {
      if (unitName === 'weekday') {
        upperUnitIndex = WEEK_INDEX$3$1;
      } else {
        upperUnitIndex = getHigherUnitIndex$2(unitIndex);
      }
    }
  }

  function setSpecificity(unitIndex) {
    // Other functions may preemptively set the specificity before arriving
    // here so concede to them if they have already set more specific units.
    if (unitIndex > params.specificity) {
      return;
    }
    params.specificity = unitIndex;
  }

  function canDisambiguate() {
    if (!upperUnitIndex || upperUnitIndex > YEAR_INDEX$3$1) {
      return;
    }

    switch(prefer) {
      case -1: return d >= (contextDate || getNewDate$4$1());
      case  1: return d <= (contextDate || getNewDate$4$1());
    }
  }

  function disambiguateHigherUnit() {
    var unit = DateUnits$4$1[upperUnitIndex];
    advance = prefer;
    setUnit(unit.name, 1, unit, upperUnitIndex);
  }

  function handleFraction(unit, unitIndex, fraction) {
    if (unitIndex) {
      var lowerUnit = DateUnits$4$1[getLowerUnitIndex$2$1(unitIndex)];
      var val = round$2$1(unit.multiplier / lowerUnit.multiplier * fraction);
      params[lowerUnit.name] = val;
    }
  }

  function monthHasShifted(d, targetMonth) {
    if (targetMonth < 0) {
      targetMonth = targetMonth % 12 + 12;
    }
    return targetMonth % 12 !== getMonth$4$1(d);
  }

  function setUnit(unitName, value, unit, unitIndex) {
    var method = unit.method, checkMonth, fraction;

    setUpperUnit(unitName, unitIndex);
    setSpecificity(unitIndex);

    fraction = value % 1;
    if (fraction) {
      handleFraction(unit, unitIndex, fraction);
      value = trunc$6$1(value);
    }

    if (unitName === 'weekday') {
      if (!advance) {
        // Weekdays are always considered absolute units so simply set them
        // here even if it is an "advance" operation. This is to help avoid
        // ambiguous meanings in "advance" as well as to neatly allow formats
        // like "Wednesday of next week" without more complex logic.
        setWeekday$5$1(d, value, weekdayDir);
      }
      return;
    }
    checkMonth = unitIndex === MONTH_INDEX$3$1 && getDate$3$1(d) > 28;

    // If we are advancing or rewinding, then we need we need to set the
    // absolute time if the unit is "hours" or less. This is due to the fact
    // that setting by method is ambiguous during DST shifts. For example,
    // 1:00am on November 1st 2015 occurs twice in North American timezones
    // with DST, the second time being after the clocks are rolled back at
    // 2:00am. When springing forward this is automatically handled as there
    // is no 2:00am so the date automatically jumps to 3:00am. However, when
    // rolling back, setHours(2) will always choose the first "2am" even if
    // the date is currently set to the second, causing unintended jumps.
    // This ambiguity is unavoidable when setting dates as the notation is
    // ambiguous. However when advancing, we clearly want the resulting date
    // to be an acutal hour ahead, which can only be accomplished by setting
    // the absolute time. Conversely, any unit higher than "hours" MUST use
    // the internal set methods, as they are ambiguous as absolute units of
    // time. Years may be 365 or 366 days depending on leap years, months are
    // all over the place, and even days may be 23-25 hours depending on DST
    // shifts. Finally, note that the kind of jumping described above will
    // occur when calling ANY "set" method on the date and will occur even if
    // the value being set is identical to the one currently set (i.e.
    // setHours(2) on a date at 2am may not be a noop). This is precarious,
    // so avoiding this situation in callDateSet by checking up front that
    // the value is not the same before setting.
    if (advance && !unit.ambiguous) {
      d.setTime(d.getTime() + (value * advance * unit.multiplier));
      return;
    } else if (advance) {
      if (unitIndex === WEEK_INDEX$3$1) {
        value *= 7;
        method = DateUnits$4$1[DAY_INDEX$6$1].method;
      }
      value = (value * advance) + callDateGet$3$1(d, method);
    }
    callDateSetWithWeek$2(d, method, value, advance);
    if (checkMonth && monthHasShifted(d, value)) {
      // As we are setting the units in reverse order, there is a chance that
      // our date may accidentally traverse into a new month, such as setting
      // { month: 1, date 15 } on January 31st. Check for this here and reset
      // the date to the last day of the previous month if this has happened.
      setDate$2$1(d, 0);
    }
  }

  if (isNumber$7$1(params) && advance) {
    // If param is a number and advancing, the number is in milliseconds.
    params = { millisecond: params };
  } else if (isNumber$7$1(params)) {
    // Otherwise just set the timestamp and return.
    d.setTime(params);
    return d;
  }

  iterateOverDateParams$3$1(params, setUnit);

  if (reset && params.specificity) {
    resetLowerUnits$2(d, params.specificity);
  }

  // If past or future is preferred, then the process of "disambiguation" will
  // ensure that an ambiguous time/date ("4pm", "thursday", "June", etc.) will
  // be in the past or future. Weeks are only considered ambiguous if there is
  // a weekday, i.e. "thursday" is an ambiguous week, but "the 4th" is an
  // ambiguous month.
  if (canDisambiguate()) {
    disambiguateHigherUnit();
  }
  return d;
}

var updateDate_1$1 = updateDate$4$1;

var updateDate$3$1 = updateDate_1$1;

function advanceDate$5$1(d, unit, num, reset) {
  var set = {};
  set[unit] = num;
  return updateDate$3$1(d, set, reset, 1);
}

var advanceDate_1$1 = advanceDate$5$1;

function dateIsValid$5$1(d) {
  return !isNaN(d.getTime());
}

var dateIsValid_1$1 = dateIsValid$5$1;

var setWeekday$4$1 = setWeekday_1$1,
    getWeekday$5$1 = getWeekday_1$1,
    mathAliases$b$1 = mathAliases$z$1;

var ceil$2$1 = mathAliases$b$1.ceil;

function moveToEndOfWeek$2$1(d, firstDayOfWeek) {
  var target = firstDayOfWeek - 1;
  setWeekday$4$1(d, ceil$2$1((getWeekday$5$1(d) - target) / 7) * 7 + target);
  return d;
}

var moveToEndOfWeek_1$1 = moveToEndOfWeek$2$1;

var LocaleHelpers$f$1 = LocaleHelpers$h$1,
    DateUnitIndexes$a$1 = DateUnitIndexes$i$1,
    moveToEndOfWeek$1$1 = moveToEndOfWeek_1$1,
    getLowerUnitIndex$1$1 = getLowerUnitIndex_1$1,
    setUnitAndLowerToEdge$2$1 = setUnitAndLowerToEdge_1$1;

var WEEK_INDEX$2$1 = DateUnitIndexes$a$1.WEEK_INDEX,
    localeManager$d$1 = LocaleHelpers$f$1.localeManager;

function moveToEndOfUnit$4$1(d, unitIndex, localeCode, stopIndex) {
  if (unitIndex === WEEK_INDEX$2$1) {
    moveToEndOfWeek$1$1(d, localeManager$d$1.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$2$1(d, getLowerUnitIndex$1$1(unitIndex), stopIndex, true);
}

var moveToEndOfUnit_1$1 = moveToEndOfUnit$4$1;

var getDateParamKey$3 = getDateParamKey_1$1;

function deleteDateParam$1$1(params, key) {
  delete params[getDateParamKey$3(params, key)];
}

var deleteDateParam_1$1 = deleteDateParam$1$1;

var LocaleHelpers$e$1 = LocaleHelpers$h$1,
    DateUnitIndexes$9$1 = DateUnitIndexes$i$1,
    getLowerUnitIndex$6 = getLowerUnitIndex_1$1,
    moveToBeginningOfWeek$1$1 = moveToBeginningOfWeek_1$1,
    setUnitAndLowerToEdge$1$1 = setUnitAndLowerToEdge_1$1;

var WEEK_INDEX$1$1 = DateUnitIndexes$9$1.WEEK_INDEX,
    localeManager$c$1 = LocaleHelpers$e$1.localeManager;

function moveToBeginningOfUnit$4$1(d, unitIndex, localeCode) {
  if (unitIndex === WEEK_INDEX$1$1) {
    moveToBeginningOfWeek$1$1(d, localeManager$c$1.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$1$1(d, getLowerUnitIndex$6(unitIndex));
}

var moveToBeginningOfUnit_1$1 = moveToBeginningOfUnit$4$1;

var getYear$5$1 = getYear_1$1,
    mathAliases$a$1 = mathAliases$z$1;

var abs$3$1 = mathAliases$a$1.abs;

function getYearFromAbbreviation$1$1(str, d, prefer) {
  // Following IETF here, adding 1900 or 2000 depending on the last two digits.
  // Note that this makes no accordance for what should happen after 2050, but
  // intentionally ignoring this for now. https://www.ietf.org/rfc/rfc2822.txt
  var val = +str, delta;
  val += val < 50 ? 2000 : 1900;
  if (prefer) {
    delta = val - getYear$5$1(d);
    if (delta / abs$3$1(delta) !== prefer) {
      val += prefer * 100;
    }
  }
  return val;
}

var getYearFromAbbreviation_1$1 = getYearFromAbbreviation$1$1;

var DateUnitIndexes$8$1 = DateUnitIndexes$i$1,
    iterateOverDateParams$2$1 = iterateOverDateParams_1$1;

var DAY_INDEX$5$1 = DateUnitIndexes$8$1.DAY_INDEX,
    YEAR_INDEX$2$1 = DateUnitIndexes$8$1.YEAR_INDEX;

function iterateOverHigherDateParams$1$1(params, fn) {
  iterateOverDateParams$2$1(params, fn, YEAR_INDEX$2$1, DAY_INDEX$5$1);
}

var iterateOverHigherDateParams_1$1 = iterateOverHigherDateParams$1$1;

var MINUTES$1$1 = MINUTES$2$1,
    ABBREVIATED_YEAR_REG$2 = ABBREVIATED_YEAR_REG$1$1,
    LocaleHelpers$d$1 = LocaleHelpers$h$1,
    DateUnitIndexes$7$1 = DateUnitIndexes$i$1,
    _utc$4$1 = _utc$8$1,
    trunc$5$1 = trunc_1$1,
    forEach$3$1 = forEach_1$1,
    tzOffset$3$1 = tzOffset_1$1,
    isDefined$4$1 = isDefined_1$1,
    resetTime$1$1 = resetTime_1$1,
    getNewDate$3$1 = getNewDate_1$1,
    updateDate$2$1 = updateDate_1$1,
    setWeekday$3$1 = setWeekday_1$1,
    simpleMerge$5 = simpleMerge_1$1,
    advanceDate$4$1 = advanceDate_1$1,
    isUndefined$2$1 = isUndefined_1$1,
    classChecks$e$1 = classChecks$Z$1,
    dateIsValid$4$1 = dateIsValid_1$1,
    simpleClone$1$1 = simpleClone_1$1,
    isObjectType$2$1 = isObjectType_1$1,
    moveToEndOfUnit$3$1 = moveToEndOfUnit_1$1,
    deleteDateParam$2 = deleteDateParam_1$1,
    coreUtilityAliases$3$1 = coreUtilityAliases$M$1,
    moveToBeginningOfUnit$3$1 = moveToBeginningOfUnit_1$1,
    iterateOverDateParams$1$1 = iterateOverDateParams_1$1,
    getYearFromAbbreviation$2 = getYearFromAbbreviation_1$1,
    iterateOverHigherDateParams$2 = iterateOverHigherDateParams_1$1;

var isNumber$6$1 = classChecks$e$1.isNumber,
    isString$6$1 = classChecks$e$1.isString,
    isDate$4$1 = classChecks$e$1.isDate,
    getOwn$2$1 = coreUtilityAliases$3$1.getOwn,
    English$2$1 = LocaleHelpers$d$1.English,
    localeManager$b$1 = LocaleHelpers$d$1.localeManager,
    DAY_INDEX$4$1 = DateUnitIndexes$7$1.DAY_INDEX,
    WEEK_INDEX$5 = DateUnitIndexes$7$1.WEEK_INDEX,
    MONTH_INDEX$2$1 = DateUnitIndexes$7$1.MONTH_INDEX,
    YEAR_INDEX$1$1 = DateUnitIndexes$7$1.YEAR_INDEX;

function getExtendedDate$3$1(contextDate, d, opt, forceClone) {

  // Locals
  var date, set, loc, afterCallbacks, relative, weekdayDir;

  // Options
  var optPrefer, optLocale, optFromUTC, optSetUTC, optParams, optClone;

  afterCallbacks = [];

  setupOptions(opt);

  function setupOptions(opt) {
    opt = isString$6$1(opt) ? { locale: opt } : opt || {};
    optPrefer  = +!!getOwn$2$1(opt, 'future') - +!!getOwn$2$1(opt, 'past');
    optLocale  = getOwn$2$1(opt, 'locale');
    optFromUTC = getOwn$2$1(opt, 'fromUTC');
    optSetUTC  = getOwn$2$1(opt, 'setUTC');
    optParams  = getOwn$2$1(opt, 'params');
    optClone   = getOwn$2$1(opt, 'clone');
  }

  function parseFormatValues(match, dif) {
    var set = optParams || {};
    forEach$3$1(dif.to, function(param, i) {
      var str = match[i + 1], val;
      if (!str) return;

      val = parseIrregular(str, param);

      if (isUndefined$2$1(val)) {
        val = loc.parseValue(str, param);
      }

      set[param] = val;
    });
    return set;
  }

  function parseIrregular(str, param) {
    if (param === 'utc') {
      return 1;
    } else if (param === 'year') {
      var match = str.match(ABBREVIATED_YEAR_REG$2);
      if (match) {
        return getYearFromAbbreviation$2(match[1], date, optPrefer);
      }
    }
  }

  // Force the UTC flags to be true if the source date
  // date is UTC, as they will be overwritten later.
  function cloneDateByFlag(d, clone) {
    if (_utc$4$1(d) && !isDefined$4$1(optFromUTC)) {
      optFromUTC = true;
    }
    if (_utc$4$1(d) && !isDefined$4$1(optSetUTC)) {
      optSetUTC = true;
    }
    if (clone) {
      d = new Date(d.getTime());
    }
    return d;
  }

  function afterDateSet(fn) {
    afterCallbacks.push(fn);
  }

  function fireCallbacks() {
    forEach$3$1(afterCallbacks, function(fn) {
      fn.call();
    });
  }

  function parseStringDate(str) {

    str = str.toLowerCase();

    // The act of getting the locale will initialize
    // if it is missing and add the required formats.
    loc = localeManager$b$1.get(optLocale);

    for (var i = 0, dif, match; dif = loc.compiledFormats[i]; i++) {
      match = str.match(dif.reg);
      if (match) {

        // Note that caching the format will modify the compiledFormats array
        // which is not a good idea to do inside its for loop, however we
        // know at this point that we have a matched format and that we will
        // break out below, so simpler to do it here.
        loc.cacheFormat(dif, i);

        set = parseFormatValues(match, dif);

        if (isDefined$4$1(set.timestamp)) {
          date.setTime(set.timestamp);
          break;
        }

        if (isDefined$4$1(set.ampm)) {
          handleAmpm(set.ampm);
        }

        if (set.utc || isDefined$4$1(set.tzHour)) {
          handleTimezoneOffset(set.tzHour, set.tzMinute);
        }

        if (isDefined$4$1(set.shift) && isUndefined$2$1(set.unit)) {
          // "next january", "next monday", etc
          handleUnitlessShift();
        }

        if (isDefined$4$1(set.num) && isUndefined$2$1(set.unit)) {
          // "the second of January", etc
          handleUnitlessNum(set.num);
        }

        if (set.midday) {
          // "noon" and "midnight"
          handleMidday(set.midday);
        }

        if (isDefined$4$1(set.day)) {
          // Relative day localizations such as "today" and "tomorrow".
          handleRelativeDay(set.day);
        }

        if (isDefined$4$1(set.unit)) {
          // "3 days ago", etc
          handleRelativeUnit(set.unit);
        }

        if (set.edge) {
          // "the end of January", etc
          handleEdge(set.edge, set);
        }

        break;
      }
    }

    if (!set) {
      // TODO: remove in next major version
      // Fall back to native parsing
      date = new Date(str);
      if (optFromUTC && dateIsValid$4$1(date)) {
        // Falling back to system date here which cannot be parsed as UTC,
        // so if we're forcing UTC then simply add the offset.
        date.setTime(date.getTime() + (tzOffset$3$1(date) * MINUTES$1$1));
      }
    } else if (relative) {
      updateDate$2$1(date, set, false, 1);
    } else {
      updateDate$2$1(date, set, true, 0, optPrefer, weekdayDir, contextDate);
    }
    fireCallbacks();
    return date;
  }

  function handleAmpm(ampm) {
    if (ampm === 1 && set.hour < 12) {
      // If the time is 1pm-11pm advance the time by 12 hours.
      set.hour += 12;
    } else if (ampm === 0 && set.hour === 12) {
      // If it is 12:00am then set the hour to 0.
      set.hour = 0;
    }
  }

  function handleTimezoneOffset(tzHour, tzMinute) {
    // Adjust for timezone offset
    _utc$4$1(date, true);

    // Sign is parsed as part of the hour, so flip
    // the minutes if it's negative.

    if (tzHour < 0) {
      tzMinute *= -1;
    }

    var offset = tzHour * 60 + (tzMinute || 0);
    if (offset) {
      set.minute = (set.minute || 0) - offset;
    }
  }

  function handleUnitlessShift() {
    if (isDefined$4$1(set.month)) {
      // "next January"
      set.unit = YEAR_INDEX$1$1;
    } else if (isDefined$4$1(set.weekday)) {
      // "next Monday"
      set.unit = WEEK_INDEX$5;
    }
  }

  function handleUnitlessNum(num) {
    if (isDefined$4$1(set.weekday)) {
      // "The second Tuesday of March"
      setOrdinalWeekday(num);
    } else if (isDefined$4$1(set.month)) {
      // "The second of March"
      set.date = set.num;
    }
  }

  function handleMidday(hour) {
    set.hour = hour % 24;
    if (hour > 23) {
      // If the date has hours past 24, we need to prevent it from traversing
      // into a new day as that would make it being part of a new week in
      // ambiguous dates such as "Monday".
      afterDateSet(function() {
        advanceDate$4$1(date, 'date', trunc$5$1(hour / 24));
      });
    }
  }

  function handleRelativeDay() {
    resetTime$1$1(date);
    if (isUndefined$2$1(set.unit)) {
      set.unit = DAY_INDEX$4$1;
      set.num  = set.day;
      delete set.day;
    }
  }

  function handleRelativeUnit(unitIndex) {
    var num;

    if (isDefined$4$1(set.num)) {
      num = set.num;
    } else if (isDefined$4$1(set.edge) && isUndefined$2$1(set.shift)) {
      num = 0;
    } else {
      num = 1;
    }

    // If a weekday is defined, there are 3 possible formats being applied:
    //
    // 1. "the day after monday": unit is days
    // 2. "next monday": short for "next week monday", unit is weeks
    // 3. "the 2nd monday of next month": unit is months
    //
    // In the first case, we need to set the weekday up front, as the day is
    // relative to it. The second case also needs to be handled up front for
    // formats like "next monday at midnight" which will have its weekday reset
    // if not set up front. The last case will set up the params necessary to
    // shift the weekday and allow separateAbsoluteUnits below to handle setting
    // it after the date has been shifted.
    if(isDefined$4$1(set.weekday)) {
      if(unitIndex === MONTH_INDEX$2$1) {
        setOrdinalWeekday(num);
        num = 1;
      } else {
        updateDate$2$1(date, { weekday: set.weekday }, true);
        delete set.weekday;
      }
    }

    if (set.half) {
      // Allow localized "half" as a standalone colloquialism. Purposely avoiding
      // the locale number system to reduce complexity. The units "month" and
      // "week" are purposely excluded in the English date formats below, as
      // "half a week" and "half a month" are meaningless as exact dates.
      num *= set.half;
    }

    if (isDefined$4$1(set.shift)) {
      // Shift and unit, ie "next month", "last week", etc.
      num *= set.shift;
    } else if (set.sign) {
      // Unit and sign, ie "months ago", "weeks from now", etc.
      num *= set.sign;
    }

    if (isDefined$4$1(set.day)) {
      // "the day after tomorrow"
      num += set.day;
      delete set.day;
    }

    // Formats like "the 15th of last month" or "6:30pm of next week"
    // contain absolute units in addition to relative ones, so separate
    // them here, remove them from the params, and set up a callback to
    // set them after the relative ones have been set.
    separateAbsoluteUnits(unitIndex);

    // Finally shift the unit.
    set[English$2$1.units[unitIndex]] = num;
    relative = true;
  }

  function handleEdge(edge, params) {
    var edgeIndex = params.unit, weekdayOfMonth;
    if (!edgeIndex) {
      // If we have "the end of January", then we need to find the unit index.
      iterateOverHigherDateParams$2(params, function(unitName, val, unit, i) {
        if (unitName === 'weekday' && isDefined$4$1(params.month)) {
          // If both a month and weekday exist, then we have a format like
          // "the last tuesday in November, 2012", where the "last" is still
          // relative to the end of the month, so prevent the unit "weekday"
          // from taking over.
          return;
        }
        edgeIndex = i;
      });
    }
    if (edgeIndex === MONTH_INDEX$2$1 && isDefined$4$1(params.weekday)) {
      // If a weekday in a month exists (as described above),
      // then set it up to be set after the date has been shifted.
      weekdayOfMonth = params.weekday;
      delete params.weekday;
    }
    afterDateSet(function() {
      var stopIndex;
      // "edge" values that are at the very edge are "2" so the beginning of the
      // year is -2 and the end of the year is 2. Conversely, the "last day" is
      // actually 00:00am so it is 1. -1 is reserved but unused for now.
      if (edge < 0) {
        moveToBeginningOfUnit$3$1(date, edgeIndex, optLocale);
      } else if (edge > 0) {
        if (edge === 1) {
          stopIndex = DAY_INDEX$4$1;
          moveToBeginningOfUnit$3$1(date, DAY_INDEX$4$1);
        }
        moveToEndOfUnit$3$1(date, edgeIndex, optLocale, stopIndex);
      }
      if (isDefined$4$1(weekdayOfMonth)) {
        setWeekday$3$1(date, weekdayOfMonth, -edge);
        resetTime$1$1(date);
      }
    });
    if (edgeIndex === MONTH_INDEX$2$1) {
      params.specificity = DAY_INDEX$4$1;
    } else {
      params.specificity = edgeIndex - 1;
    }
  }

  function setOrdinalWeekday(num) {
    // If we have "the 2nd Tuesday of June", then pass the "weekdayDir"
    // flag along to updateDate so that the date does not accidentally traverse
    // into the previous month. This needs to be independent of the "prefer"
    // flag because we are only ensuring that the weekday is in the future, not
    // the entire date.
    set.weekday = 7 * (num - 1) + set.weekday;
    set.date = 1;
    weekdayDir = 1;
  }

  function separateAbsoluteUnits(unitIndex) {
    var params;

    iterateOverDateParams$1$1(set, function(name, val, unit, i) {
      // If there is a time unit set that is more specific than
      // the matched unit we have a string like "5:30am in 2 minutes",
      // which is meaningless, so invalidate the date...
      if (i >= unitIndex) {
        date.setTime(NaN);
        return false;
      } else if (i < unitIndex) {
        // ...otherwise set the params to set the absolute date
        // as a callback after the relative date has been set.
        params = params || {};
        params[name] = val;
        deleteDateParam$2(set, name);
      }
    });
    if (params) {
      afterDateSet(function() {
        updateDate$2$1(date, params, true, 0, false, weekdayDir);
        if (optParams) {
          simpleMerge$5(optParams, params);
        }
      });
      if (set.edge) {
        // "the end of March of next year"
        handleEdge(set.edge, params);
        delete set.edge;
      }
    }
  }

  if (contextDate && d) {
    // If a context date is passed ("get" and "unitsFromNow"),
    // then use it as the starting point.
    date = cloneDateByFlag(contextDate, true);
  } else {
    date = getNewDate$3$1();
  }

  _utc$4$1(date, optFromUTC);

  if (isString$6$1(d)) {
    date = parseStringDate(d);
  } else if (isDate$4$1(d)) {
    date = cloneDateByFlag(d, optClone || forceClone);
  } else if (isObjectType$2$1(d)) {
    set = simpleClone$1$1(d);
    updateDate$2$1(date, set, true);
  } else if (isNumber$6$1(d) || d === null) {
    date.setTime(d);
  }
  // A date created by parsing a string presumes that the format *itself* is
  // UTC, but not that the date, once created, should be manipulated as such. In
  // other words, if you are creating a date object from a server time
  // "2012-11-15T12:00:00Z", in the majority of cases you are using it to create
  // a date that will, after creation, be manipulated as local, so reset the utc
  // flag here unless "setUTC" is also set.
  _utc$4$1(date, !!optSetUTC);
  return {
    set: set,
    date: date
  };
}

var getExtendedDate_1$1 = getExtendedDate$3$1;

var getExtendedDate$2$1 = getExtendedDate_1$1;

function createDate$8$1(d, options, forceClone) {
  return getExtendedDate$2$1(null, d, options, forceClone).date;
}

var createDate_1$1 = createDate$8$1;

var createDate$7$1 = createDate_1$1,
    namespaceAliases$6$1 = namespaceAliases$e$1,
    setChainableConstructor$3 = setChainableConstructor_1$1;

var sugarDate$5$1 = namespaceAliases$6$1.sugarDate;

function setDateChainableConstructor$1$1() {
  setChainableConstructor$3(sugarDate$5$1, createDate$7$1);
}

var setDateChainableConstructor_1$1 = setDateChainableConstructor$1$1;

var setDateChainableConstructor$2 = setDateChainableConstructor_1$1;

setDateChainableConstructor$2();

var Sugar$3h$1 = sugarCore$1.exports,
    createDate$6$1 = createDate_1$1;



Sugar$3h$1.Date.defineStatic({

  'create': function(d, options) {
    return createDate$6$1(d, options);
  }

});

Sugar$3h$1.Date.create;

var Sugar$3g$1 = sugarCore$1.exports,
    LocaleHelpers$c$1 = LocaleHelpers$h$1,
    getKeys$7 = getKeys_1$1;

var localeManager$a$1 = LocaleHelpers$c$1.localeManager;

Sugar$3g$1.Date.defineStatic({

  'getAllLocaleCodes': function() {
    return getKeys$7(localeManager$a$1.getAll());
  }

});

Sugar$3g$1.Date.getAllLocaleCodes;

var Sugar$3f$1 = sugarCore$1.exports,
    LocaleHelpers$b$1 = LocaleHelpers$h$1;

var localeManager$9$1 = LocaleHelpers$b$1.localeManager;

Sugar$3f$1.Date.defineStatic({

  'getAllLocales': function() {
    return localeManager$9$1.getAll();
  }

});

Sugar$3f$1.Date.getAllLocales;

var Sugar$3e$1 = sugarCore$1.exports,
    LocaleHelpers$a$1 = LocaleHelpers$h$1;

var localeManager$8$1 = LocaleHelpers$a$1.localeManager;

Sugar$3e$1.Date.defineStatic({

  'getLocale': function(code) {
    return localeManager$8$1.get(code, !code);
  }

});

Sugar$3e$1.Date.getLocale;

var Sugar$3d$1 = sugarCore$1.exports,
    LocaleHelpers$9$1 = LocaleHelpers$h$1;

var localeManager$7$1 = LocaleHelpers$9$1.localeManager;

Sugar$3d$1.Date.defineStatic({

  'removeLocale': function(code) {
    return localeManager$7$1.remove(code);
  }

});

Sugar$3d$1.Date.removeLocale;

var Sugar$3c$1 = sugarCore$1.exports,
    LocaleHelpers$8$1 = LocaleHelpers$h$1;

var localeManager$6$1 = LocaleHelpers$8$1.localeManager;

Sugar$3c$1.Date.defineStatic({

  'setLocale': function(code) {
    return localeManager$6$1.set(code);
  }

});

Sugar$3c$1.Date.setLocale;

var DateUnits$3$1 = DateUnits_1$1,
    createDate$5$1 = createDate_1$1,
    mathAliases$9$1 = mathAliases$z$1,
    advanceDate$3$1 = advanceDate_1$1,
    namespaceAliases$5$1 = namespaceAliases$e$1,
    defineInstanceSimilar$3$1 = defineInstanceSimilar_1$1;

var sugarNumber$3 = namespaceAliases$5$1.sugarNumber,
    round$1$1 = mathAliases$9$1.round;

function buildNumberUnitMethods$1$1() {
  defineInstanceSimilar$3$1(sugarNumber$3, DateUnits$3$1, function(methods, unit) {
    var name = unit.name, base, after, before;
    base = function(n) {
      return round$1$1(n * unit.multiplier);
    };
    after = function(n, d, options) {
      return advanceDate$3$1(createDate$5$1(d, options, true), name, n);
    };
    before = function(n, d, options) {
      return advanceDate$3$1(createDate$5$1(d, options, true), name, -n);
    };
    methods[name] = base;
    methods[name + 's'] = base;
    methods[name + 'Before'] = before;
    methods[name + 'sBefore'] = before;
    methods[name + 'Ago'] = before;
    methods[name + 'sAgo'] = before;
    methods[name + 'After'] = after;
    methods[name + 'sAfter'] = after;
    methods[name + 'FromNow'] = after;
    methods[name + 'sFromNow'] = after;
  });
}

var buildNumberUnitMethods_1$1 = buildNumberUnitMethods$1$1;

var buildNumberUnitMethods$2 = buildNumberUnitMethods_1$1;

buildNumberUnitMethods$2();

var Sugar$3b$1 = sugarCore$1.exports;



Sugar$3b$1.Number.day;

var Sugar$3a$1 = sugarCore$1.exports;



Sugar$3a$1.Number.dayAfter;

var Sugar$39$1 = sugarCore$1.exports;



Sugar$39$1.Number.dayAgo;

var Sugar$38$1 = sugarCore$1.exports;



Sugar$38$1.Number.dayBefore;

var Sugar$37$1 = sugarCore$1.exports;



Sugar$37$1.Number.dayFromNow;

var Sugar$36$1 = sugarCore$1.exports;



Sugar$36$1.Number.days;

var Sugar$35$1 = sugarCore$1.exports;



Sugar$35$1.Number.daysAfter;

var Sugar$34$1 = sugarCore$1.exports;



Sugar$34$1.Number.daysAgo;

var Sugar$33$1 = sugarCore$1.exports;



Sugar$33$1.Number.daysBefore;

var Sugar$32$1 = sugarCore$1.exports;



Sugar$32$1.Number.daysFromNow;

var Sugar$31$1 = sugarCore$1.exports,
    LocaleHelpers$7$1 = LocaleHelpers$h$1;

var localeManager$5$1 = LocaleHelpers$7$1.localeManager;

Sugar$31$1.Number.defineInstance({

  'duration': function(n, localeCode) {
    return localeManager$5$1.get(localeCode).getDuration(n);
  }

});

Sugar$31$1.Number.duration;

var Sugar$30$1 = sugarCore$1.exports;



Sugar$30$1.Number.hour;

var Sugar$2$$1 = sugarCore$1.exports;



Sugar$2$$1.Number.hourAfter;

var Sugar$2_$1 = sugarCore$1.exports;



Sugar$2_$1.Number.hourAgo;

var Sugar$2Z$1 = sugarCore$1.exports;



Sugar$2Z$1.Number.hourBefore;

var Sugar$2Y$1 = sugarCore$1.exports;



Sugar$2Y$1.Number.hourFromNow;

var Sugar$2X$1 = sugarCore$1.exports;



Sugar$2X$1.Number.hours;

var Sugar$2W$1 = sugarCore$1.exports;



Sugar$2W$1.Number.hoursAfter;

var Sugar$2V$1 = sugarCore$1.exports;



Sugar$2V$1.Number.hoursAgo;

var Sugar$2U$1 = sugarCore$1.exports;



Sugar$2U$1.Number.hoursBefore;

var Sugar$2T$1 = sugarCore$1.exports;



Sugar$2T$1.Number.hoursFromNow;

var Sugar$2S$1 = sugarCore$1.exports;



Sugar$2S$1.Number.millisecond;

var Sugar$2R$1 = sugarCore$1.exports;



Sugar$2R$1.Number.millisecondAfter;

var Sugar$2Q$1 = sugarCore$1.exports;



Sugar$2Q$1.Number.millisecondAgo;

var Sugar$2P$1 = sugarCore$1.exports;



Sugar$2P$1.Number.millisecondBefore;

var Sugar$2O$1 = sugarCore$1.exports;



Sugar$2O$1.Number.millisecondFromNow;

var Sugar$2N$1 = sugarCore$1.exports;



Sugar$2N$1.Number.milliseconds;

var Sugar$2M$1 = sugarCore$1.exports;



Sugar$2M$1.Number.millisecondsAfter;

var Sugar$2L$1 = sugarCore$1.exports;



Sugar$2L$1.Number.millisecondsAgo;

var Sugar$2K$1 = sugarCore$1.exports;



Sugar$2K$1.Number.millisecondsBefore;

var Sugar$2J$1 = sugarCore$1.exports;



Sugar$2J$1.Number.millisecondsFromNow;

var Sugar$2I$1 = sugarCore$1.exports;



Sugar$2I$1.Number.minute;

var Sugar$2H$1 = sugarCore$1.exports;



Sugar$2H$1.Number.minuteAfter;

var Sugar$2G$1 = sugarCore$1.exports;



Sugar$2G$1.Number.minuteAgo;

var Sugar$2F$1 = sugarCore$1.exports;



Sugar$2F$1.Number.minuteBefore;

var Sugar$2E$1 = sugarCore$1.exports;



Sugar$2E$1.Number.minuteFromNow;

var Sugar$2D$1 = sugarCore$1.exports;



Sugar$2D$1.Number.minutes;

var Sugar$2C$1 = sugarCore$1.exports;



Sugar$2C$1.Number.minutesAfter;

var Sugar$2B$1 = sugarCore$1.exports;



Sugar$2B$1.Number.minutesAgo;

var Sugar$2A$1 = sugarCore$1.exports;



Sugar$2A$1.Number.minutesBefore;

var Sugar$2z$1 = sugarCore$1.exports;



Sugar$2z$1.Number.minutesFromNow;

var Sugar$2y$1 = sugarCore$1.exports;



Sugar$2y$1.Number.month;

var Sugar$2x$1 = sugarCore$1.exports;



Sugar$2x$1.Number.monthAfter;

var Sugar$2w$1 = sugarCore$1.exports;



Sugar$2w$1.Number.monthAgo;

var Sugar$2v$1 = sugarCore$1.exports;



Sugar$2v$1.Number.monthBefore;

var Sugar$2u$1 = sugarCore$1.exports;



Sugar$2u$1.Number.monthFromNow;

var Sugar$2t$1 = sugarCore$1.exports;



Sugar$2t$1.Number.months;

var Sugar$2s$1 = sugarCore$1.exports;



Sugar$2s$1.Number.monthsAfter;

var Sugar$2r$1 = sugarCore$1.exports;



Sugar$2r$1.Number.monthsAgo;

var Sugar$2q$1 = sugarCore$1.exports;



Sugar$2q$1.Number.monthsBefore;

var Sugar$2p$1 = sugarCore$1.exports;



Sugar$2p$1.Number.monthsFromNow;

var Sugar$2o$1 = sugarCore$1.exports;



Sugar$2o$1.Number.second;

var Sugar$2n$1 = sugarCore$1.exports;



Sugar$2n$1.Number.secondAfter;

var Sugar$2m$1 = sugarCore$1.exports;



Sugar$2m$1.Number.secondAgo;

var Sugar$2l$1 = sugarCore$1.exports;



Sugar$2l$1.Number.secondBefore;

var Sugar$2k$1 = sugarCore$1.exports;



Sugar$2k$1.Number.secondFromNow;

var Sugar$2j$1 = sugarCore$1.exports;



Sugar$2j$1.Number.seconds;

var Sugar$2i$1 = sugarCore$1.exports;



Sugar$2i$1.Number.secondsAfter;

var Sugar$2h$1 = sugarCore$1.exports;



Sugar$2h$1.Number.secondsAgo;

var Sugar$2g$1 = sugarCore$1.exports;



Sugar$2g$1.Number.secondsBefore;

var Sugar$2f$1 = sugarCore$1.exports;



Sugar$2f$1.Number.secondsFromNow;

var Sugar$2e$1 = sugarCore$1.exports;



Sugar$2e$1.Number.week;

var Sugar$2d$1 = sugarCore$1.exports;



Sugar$2d$1.Number.weekAfter;

var Sugar$2c$1 = sugarCore$1.exports;



Sugar$2c$1.Number.weekAgo;

var Sugar$2b$1 = sugarCore$1.exports;



Sugar$2b$1.Number.weekBefore;

var Sugar$2a$1 = sugarCore$1.exports;



Sugar$2a$1.Number.weekFromNow;

var Sugar$29$1 = sugarCore$1.exports;



Sugar$29$1.Number.weeks;

var Sugar$28$1 = sugarCore$1.exports;



Sugar$28$1.Number.weeksAfter;

var Sugar$27$1 = sugarCore$1.exports;



Sugar$27$1.Number.weeksAgo;

var Sugar$26$1 = sugarCore$1.exports;



Sugar$26$1.Number.weeksBefore;

var Sugar$25$1 = sugarCore$1.exports;



Sugar$25$1.Number.weeksFromNow;

var Sugar$24$1 = sugarCore$1.exports;



Sugar$24$1.Number.year;

var Sugar$23$1 = sugarCore$1.exports;



Sugar$23$1.Number.yearAfter;

var Sugar$22$1 = sugarCore$1.exports;



Sugar$22$1.Number.yearAgo;

var Sugar$21$1 = sugarCore$1.exports;



Sugar$21$1.Number.yearBefore;

var Sugar$20$1 = sugarCore$1.exports;



Sugar$20$1.Number.yearFromNow;

var Sugar$1$$1 = sugarCore$1.exports;



Sugar$1$$1.Number.years;

var Sugar$1_$1 = sugarCore$1.exports;



Sugar$1_$1.Number.yearsAfter;

var Sugar$1Z$1 = sugarCore$1.exports;



Sugar$1Z$1.Number.yearsAgo;

var Sugar$1Y$1 = sugarCore$1.exports;



Sugar$1Y$1.Number.yearsBefore;

var Sugar$1X$1 = sugarCore$1.exports;



Sugar$1X$1.Number.yearsFromNow;

var MINUTES$3 = MINUTES$2$1,
    DateUnits$2$1 = DateUnits_1$1,
    DateUnitIndexes$6$1 = DateUnitIndexes$i$1,
    _utc$3$1 = _utc$8$1,
    tzOffset$2$1 = tzOffset_1$1,
    cloneDate$4$1 = cloneDate_1$1,
    isDefined$3$1 = isDefined_1$1,
    advanceDate$2$1 = advanceDate_1$1,
    dateIsValid$3$1 = dateIsValid_1$1,
    moveToEndOfUnit$2$1 = moveToEndOfUnit_1$1,
    getExtendedDate$1$1 = getExtendedDate_1$1,
    moveToBeginningOfUnit$2$1 = moveToBeginningOfUnit_1$1;

var MONTH_INDEX$1$1 = DateUnitIndexes$6$1.MONTH_INDEX;

function compareDate$2$1(date, d, margin, localeCode, options) {
  var loMargin = 0, hiMargin = 0, timezoneShift, compareEdges, override, min, max, p, t;

  function getTimezoneShift() {
    // If there is any specificity in the date then we're implicitly not
    // checking absolute time, so ignore timezone shifts.
    if (p.set && p.set.specificity) {
      return 0;
    }
    return (tzOffset$2$1(p.date) - tzOffset$2$1(date)) * MINUTES$3;
  }

  function addSpecificUnit() {
    var unit = DateUnits$2$1[p.set.specificity];
    return advanceDate$2$1(cloneDate$4$1(p.date), unit.name, 1).getTime() - 1;
  }

  if (_utc$3$1(date)) {
    options = options || {};
    options.fromUTC = true;
    options.setUTC = true;
  }

  p = getExtendedDate$1$1(null, d, options, true);

  if (margin > 0) {
    loMargin = hiMargin = margin;
    override = true;
  }
  if (!dateIsValid$3$1(p.date)) return false;
  if (p.set && p.set.specificity) {
    if (isDefined$3$1(p.set.edge) || isDefined$3$1(p.set.shift)) {
      compareEdges = true;
      moveToBeginningOfUnit$2$1(p.date, p.set.specificity, localeCode);
    }
    if (compareEdges || p.set.specificity === MONTH_INDEX$1$1) {
      max = moveToEndOfUnit$2$1(cloneDate$4$1(p.date), p.set.specificity, localeCode).getTime();
    } else {
      max = addSpecificUnit();
    }
    if (!override && isDefined$3$1(p.set.sign) && p.set.specificity) {
      // If the time is relative, there can occasionally be an disparity between
      // the relative date and "now", which it is being compared to, so set an
      // extra margin to account for this.
      loMargin = 50;
      hiMargin = -50;
    }
  }
  t   = date.getTime();
  min = p.date.getTime();
  max = max || min;
  timezoneShift = getTimezoneShift();
  // istanbul ignore if
  if (timezoneShift) {
    min -= timezoneShift;
    max -= timezoneShift;
  }
  return t >= (min - loMargin) && t <= (max + hiMargin);
}

var compareDate_1$1 = compareDate$2$1;

var trunc$4$1 = trunc_1$1,
    cloneDate$3$1 = cloneDate_1$1,
    advanceDate$1$1 = advanceDate_1$1;

function getTimeDistanceForUnit$3$1(d1, d2, unit) {
  var fwd = d2 > d1, num, tmp;
  if (!fwd) {
    tmp = d2;
    d2  = d1;
    d1  = tmp;
  }
  num = d2 - d1;
  if (unit.multiplier > 1) {
    num = trunc$4$1(num / unit.multiplier);
  }
  // For higher order with potential ambiguity, use the numeric calculation
  // as a starting point, then iterate until we pass the target date. Decrement
  // starting point by 1 to prevent overshooting the date due to inconsistencies
  // in ambiguous units numerically. For example, calculating the number of days
  // from the beginning of the year to August 5th at 11:59:59 by doing a simple
  // d2 - d1 will produce different results depending on whether or not a
  // timezone shift was encountered due to DST, however that should not have an
  // effect on our calculation here, so subtract by 1 to ensure that the
  // starting point has not already overshot our target date.
  if (unit.ambiguous) {
    d1 = cloneDate$3$1(d1);
    if (num) {
      num -= 1;
      advanceDate$1$1(d1, unit.name, num);
    }
    while (d1 < d2) {
      advanceDate$1$1(d1, unit.name, 1);
      if (d1 > d2) {
        break;
      }
      num += 1;
    }
  }
  return fwd ? -num : num;
}

var getTimeDistanceForUnit_1$1 = getTimeDistanceForUnit$3$1;

var DateUnits$1$1 = DateUnits_1$1,
    DateUnitIndexes$5$1 = DateUnitIndexes$i$1,
    forEach$2$1 = forEach_1$1,
    createDate$4$1 = createDate_1$1,
    compareDate$1$1 = compareDate_1$1,
    advanceDate$6 = advanceDate_1$1,
    moveToEndOfUnit$1$1 = moveToEndOfUnit_1$1,
    namespaceAliases$4$1 = namespaceAliases$e$1,
    simpleCapitalize$2$1 = simpleCapitalize_1$1,
    moveToBeginningOfUnit$1$1 = moveToBeginningOfUnit_1$1,
    defineInstanceSimilar$2$1 = defineInstanceSimilar_1$1,
    getTimeDistanceForUnit$2$1 = getTimeDistanceForUnit_1$1;

var sugarDate$4$1 = namespaceAliases$4$1.sugarDate,
    HOURS_INDEX$3 = DateUnitIndexes$5$1.HOURS_INDEX,
    DAY_INDEX$3$1 = DateUnitIndexes$5$1.DAY_INDEX;

function buildDateUnitMethods$1$1() {

  defineInstanceSimilar$2$1(sugarDate$4$1, DateUnits$1$1, function(methods, unit, index) {
    var name = unit.name, caps = simpleCapitalize$2$1(name);

    if (index > DAY_INDEX$3$1) {
      forEach$2$1(['Last','This','Next'], function(shift) {
        methods['is' + shift + caps] = function(d, localeCode) {
          return compareDate$1$1(d, shift + ' ' + name, 0, localeCode, { locale: 'en' });
        };
      });
    }
    if (index > HOURS_INDEX$3) {
      methods['beginningOf' + caps] = function(d, localeCode) {
        return moveToBeginningOfUnit$1$1(d, index, localeCode);
      };
      methods['endOf' + caps] = function(d, localeCode) {
        return moveToEndOfUnit$1$1(d, index, localeCode);
      };
    }

    methods['add' + caps + 's'] = function(d, num, reset) {
      return advanceDate$6(d, name, num, reset);
    };

    var since = function(date, d, options) {
      return getTimeDistanceForUnit$2$1(date, createDate$4$1(d, options, true), unit);
    };
    var until = function(date, d, options) {
      return getTimeDistanceForUnit$2$1(createDate$4$1(d, options, true), date, unit);
    };

    methods[name + 'sAgo']   = methods[name + 'sUntil']   = until;
    methods[name + 'sSince'] = methods[name + 'sFromNow'] = since;

  });

}

var buildDateUnitMethods_1$1 = buildDateUnitMethods$1$1;

var buildDateUnitMethods$2 = buildDateUnitMethods_1$1;

buildDateUnitMethods$2();

var Sugar$1W$1 = sugarCore$1.exports;



Sugar$1W$1.Date.addDays;

var Sugar$1V$1 = sugarCore$1.exports;



Sugar$1V$1.Date.addHours;

var Sugar$1U$1 = sugarCore$1.exports;



Sugar$1U$1.Date.addMilliseconds;

var Sugar$1T$1 = sugarCore$1.exports;



Sugar$1T$1.Date.addMinutes;

var Sugar$1S$1 = sugarCore$1.exports;



Sugar$1S$1.Date.addMonths;

var Sugar$1R$1 = sugarCore$1.exports;



Sugar$1R$1.Date.addSeconds;

var Sugar$1Q$1 = sugarCore$1.exports;



Sugar$1Q$1.Date.addWeeks;

var Sugar$1P$1 = sugarCore$1.exports;



Sugar$1P$1.Date.addYears;

var isUndefined$1$1 = isUndefined_1$1;

function getDateParamsFromString$1$1(str) {
  var match, num, params = {};
  match = str.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i);
  if (match) {
    if (isUndefined$1$1(num)) {
      num = match[1] ? +match[1] : 1;
    }
    params[match[2].toLowerCase()] = num;
  }
  return params;
}

var getDateParamsFromString_1$1 = getDateParamsFromString$1$1;

var DateUnitIndexes$4$1 = DateUnitIndexes$i$1,
    isDefined$2$1 = isDefined_1$1,
    walkUnitDown$3 = walkUnitDown_1$1;

var YEAR_INDEX$5 = DateUnitIndexes$4$1.YEAR_INDEX;

function collectDateParamsFromArguments$1$1(args) {
  var params = {}, index = 0;
  walkUnitDown$3(YEAR_INDEX$5, function(unit) {
    var arg = args[index++];
    if (isDefined$2$1(arg)) {
      params[unit.name] = arg;
    }
  });
  return params;
}

var collectDateParamsFromArguments_1$1 = collectDateParamsFromArguments$1$1;

var classChecks$d$1 = classChecks$Z$1,
    simpleClone$5 = simpleClone_1$1,
    isObjectType$1$1 = isObjectType_1$1,
    getDateParamsFromString$2 = getDateParamsFromString_1$1,
    collectDateParamsFromArguments$2 = collectDateParamsFromArguments_1$1;

var isNumber$5$1 = classChecks$d$1.isNumber,
    isString$5$1 = classChecks$d$1.isString;

function collectUpdateDateArguments$2$1(args, allowDuration) {
  var arg1 = args[0], arg2 = args[1], params, reset;
  if (allowDuration && isString$5$1(arg1)) {
    params = getDateParamsFromString$2(arg1);
    reset  = arg2;
  } else if (isNumber$5$1(arg1) && isNumber$5$1(arg2)) {
    params = collectDateParamsFromArguments$2(args);
  } else {
    params = isObjectType$1$1(arg1) ? simpleClone$5(arg1) : arg1;
    reset  = arg2;
  }
  return [params, reset];
}

var collectUpdateDateArguments_1$1 = collectUpdateDateArguments$2$1;

var updateDate$1$1 = updateDate_1$1,
    collectUpdateDateArguments$1$1 = collectUpdateDateArguments_1$1;

function advanceDateWithArgs$2$1(d, args, dir) {
  args = collectUpdateDateArguments$1$1(args, true);
  return updateDate$1$1(d, args[0], args[1], dir);
}

var advanceDateWithArgs_1$1 = advanceDateWithArgs$2$1;

var Sugar$1O$1 = sugarCore$1.exports,
    advanceDateWithArgs$1$1 = advanceDateWithArgs_1$1;

Sugar$1O$1.Date.defineInstanceWithArguments({

  'advance': function(d, args) {
    return advanceDateWithArgs$1$1(d, args, 1);
  }

});

Sugar$1O$1.Date.advance;

var Sugar$1N$1 = sugarCore$1.exports;



Sugar$1N$1.Date.beginningOfDay;

var Sugar$1M$1 = sugarCore$1.exports,
    resetTime$3 = resetTime_1$1,
    getWeekday$4$1 = getWeekday_1$1,
    setWeekday$2$1 = setWeekday_1$1;

Sugar$1M$1.Date.defineInstance({

  'beginningOfISOWeek': function(date) {
    var day = getWeekday$4$1(date);
    if (day === 0) {
      day = -6;
    } else if (day !== 1) {
      day = 1;
    }
    setWeekday$2$1(date, day);
    return resetTime$3(date);
  }

});

Sugar$1M$1.Date.beginningOfISOWeek;

var Sugar$1L$1 = sugarCore$1.exports;



Sugar$1L$1.Date.beginningOfMonth;

var Sugar$1K$1 = sugarCore$1.exports;



Sugar$1K$1.Date.beginningOfWeek;

var Sugar$1J$1 = sugarCore$1.exports;



Sugar$1J$1.Date.beginningOfYear;

var Sugar$1I$1 = sugarCore$1.exports,
    cloneDate$2$1 = cloneDate_1$1;

Sugar$1I$1.Date.defineInstance({

  'clone': function(date) {
    return cloneDate$2$1(date);
  }

});

Sugar$1I$1.Date.clone;

var Sugar$1H$1 = sugarCore$1.exports;



Sugar$1H$1.Date.daysAgo;

var Sugar$1G$1 = sugarCore$1.exports;



Sugar$1G$1.Date.daysFromNow;

var Sugar$1F$1 = sugarCore$1.exports,
    getDaysInMonth$3 = getDaysInMonth_1$1;

Sugar$1F$1.Date.defineInstance({

  'daysInMonth': function(date) {
    return getDaysInMonth$3(date);
  }

});

Sugar$1F$1.Date.daysInMonth;

var Sugar$1E$1 = sugarCore$1.exports;



Sugar$1E$1.Date.daysSince;

var Sugar$1D$1 = sugarCore$1.exports;



Sugar$1D$1.Date.daysUntil;

var Sugar$1C$1 = sugarCore$1.exports;



Sugar$1C$1.Date.endOfDay;

var Sugar$1B$1 = sugarCore$1.exports,
    DateUnitIndexes$3$1 = DateUnitIndexes$i$1,
    getWeekday$3$1 = getWeekday_1$1,
    setWeekday$1$1 = setWeekday_1$1,
    moveToEndOfUnit$5 = moveToEndOfUnit_1$1;

var DAY_INDEX$2$1 = DateUnitIndexes$3$1.DAY_INDEX;

Sugar$1B$1.Date.defineInstance({

  'endOfISOWeek': function(date) {
    if (getWeekday$3$1(date) !== 0) {
      setWeekday$1$1(date, 7);
    }
    return moveToEndOfUnit$5(date, DAY_INDEX$2$1);
  }

});

Sugar$1B$1.Date.endOfISOWeek;

var Sugar$1A$1 = sugarCore$1.exports;



Sugar$1A$1.Date.endOfMonth;

var Sugar$1z$1 = sugarCore$1.exports;



Sugar$1z$1.Date.endOfWeek;

var Sugar$1y$1 = sugarCore$1.exports;



Sugar$1y$1.Date.endOfYear;

var CoreOutputFormats$2$1 = {
  'ISO8601': '{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}',
  'RFC1123': '{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}',
  'RFC1036': '{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}'
};

var CoreOutputFormats_1$1 = CoreOutputFormats$2$1;

var TIMEZONE_ABBREVIATION_REG$1$1 = /\(([-+]\d{2,4}|\w{3,5})\)$/;

var callDateGet$2$1 = callDateGet_1$1;

function getHours$2$1(d) {
  return callDateGet$2$1(d, 'Hours');
}

var getHours_1$1 = getHours$2$1;

var ISODefaults$4 = ISODefaults$3$1,
    setDate$1$1 = setDate_1$1,
    getDate$2$1 = getDate_1$1,
    cloneDate$1$1 = cloneDate_1$1,
    isUndefined$n = isUndefined_1$1,
    moveToEndOfWeek$3 = moveToEndOfWeek_1$1,
    moveToBeginningOfWeek$4 = moveToBeginningOfWeek_1$1,
    moveToFirstDayOfWeekYear$3 = moveToFirstDayOfWeekYear_1$1;

var ISO_FIRST_DAY_OF_WEEK$3 = ISODefaults$4.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$3 = ISODefaults$4.ISO_FIRST_DAY_OF_WEEK_YEAR;

function getWeekNumber$3$1(d, allowPrevious, firstDayOfWeek, firstDayOfWeekYear) {
  var isoWeek, n = 0;
  if (isUndefined$n(firstDayOfWeek)) {
    firstDayOfWeek = ISO_FIRST_DAY_OF_WEEK$3;
  }
  if (isUndefined$n(firstDayOfWeekYear)) {
    firstDayOfWeekYear = ISO_FIRST_DAY_OF_WEEK_YEAR$3;
  }
  // Moving to the end of the week allows for forward year traversal, ie
  // Dec 29 2014 is actually week 01 of 2015.
  isoWeek = moveToEndOfWeek$3(cloneDate$1$1(d), firstDayOfWeek);
  moveToFirstDayOfWeekYear$3(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  if (allowPrevious && d < isoWeek) {
    // If the date is still before the start of the year, then it should be
    // the last week of the previous year, ie Jan 1 2016 is actually week 53
    // of 2015, so move to the beginning of the week to traverse the year.
    isoWeek = moveToBeginningOfWeek$4(cloneDate$1$1(d), firstDayOfWeek);
    moveToFirstDayOfWeekYear$3(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  }
  while (isoWeek <= d) {
    // Doing a very simple walk to get the week number.
    setDate$1$1(isoWeek, getDate$2$1(isoWeek) + 7);
    n++;
  }
  return n;
}

var getWeekNumber_1$1 = getWeekNumber$3$1;

var LocaleHelpers$6$1 = LocaleHelpers$h$1,
    getYear$4$1 = getYear_1$1,
    getMonth$3$1 = getMonth_1$1,
    getWeekNumber$2$1 = getWeekNumber_1$1;

var localeManager$4$1 = LocaleHelpers$6$1.localeManager;

function getWeekYear$1$1(d, localeCode, iso) {
  var year, month, firstDayOfWeek, firstDayOfWeekYear, week, loc;
  year = getYear$4$1(d);
  month = getMonth$3$1(d);
  if (month === 0 || month === 11) {
    if (!iso) {
      loc = localeManager$4$1.get(localeCode);
      firstDayOfWeek = loc.getFirstDayOfWeek(localeCode);
      firstDayOfWeekYear = loc.getFirstDayOfWeekYear(localeCode);
    }
    week = getWeekNumber$2$1(d, false, firstDayOfWeek, firstDayOfWeekYear);
    if (month === 0 && week === 0) {
      year -= 1;
    } else if (month === 11 && week === 1) {
      year += 1;
    }
  }
  return year;
}

var getWeekYear_1$1 = getWeekYear$1$1;

var _utc$2$1 = _utc$8$1,
    trunc$3$1 = trunc_1$1,
    tzOffset$1$1 = tzOffset_1$1,
    padNumber$2$1 = padNumber_1$1,
    mathAliases$8$1 = mathAliases$z$1;

var abs$2$1 = mathAliases$8$1.abs;

function getUTCOffset$2$1(d, iso) {
  var offset = _utc$2$1(d) ? 0 : tzOffset$1$1(d), hours, mins, colon;
  colon  = iso === true ? ':' : '';
  if (!offset && iso) return 'Z';
  hours = padNumber$2$1(trunc$3$1(-offset / 60), 2, true);
  mins = padNumber$2$1(abs$2$1(offset % 60), 2);
  return  hours + colon + mins;
}

var getUTCOffset_1$1 = getUTCOffset$2$1;

var DateUnits$8 = DateUnits_1$1,
    DateUnitIndexes$2$1 = DateUnitIndexes$i$1,
    getTimeDistanceForUnit$1$1 = getTimeDistanceForUnit_1$1;

var DAY_INDEX$1$1 = DateUnitIndexes$2$1.DAY_INDEX;

function getDaysSince$1$1(d1, d2) {
  return getTimeDistanceForUnit$1$1(d1, d2, DateUnits$8[DAY_INDEX$1$1]);
}

var getDaysSince_1$1 = getDaysSince$1$1;

var LocaleHelpers$5$1 = LocaleHelpers$h$1,
    trunc$2$1 = trunc_1$1,
    getHours$1$1 = getHours_1$1;

var localeManager$3$1 = LocaleHelpers$5$1.localeManager;

function getMeridiemToken$1$1(d, localeCode) {
  var hours = getHours$1$1(d);
  return localeManager$3$1.get(localeCode).ampm[trunc$2$1(hours / 12)] || '';
}

var getMeridiemToken_1$1 = getMeridiemToken$1$1;

var TIMEZONE_ABBREVIATION_REG$2 = TIMEZONE_ABBREVIATION_REG$1$1,
    LocaleHelpers$4$1 = LocaleHelpers$h$1,
    DateUnitIndexes$1$1 = DateUnitIndexes$i$1,
    trunc$1$1 = trunc_1$1,
    getDate$1$1 = getDate_1$1,
    getYear$3$1 = getYear_1$1,
    getHours$3 = getHours_1$1,
    getMonth$2$1 = getMonth_1$1,
    cloneDate$7 = cloneDate_1$1,
    padNumber$1$1 = padNumber_1$1,
    getWeekday$2$1 = getWeekday_1$1,
    callDateGet$1$1 = callDateGet_1$1,
    mathAliases$7$1 = mathAliases$z$1,
    getWeekYear$2 = getWeekYear_1$1,
    getUTCOffset$1$1 = getUTCOffset_1$1,
    getDaysSince$2 = getDaysSince_1$1,
    getWeekNumber$1$1 = getWeekNumber_1$1,
    getMeridiemToken$2 = getMeridiemToken_1$1,
    setUnitAndLowerToEdge$7 = setUnitAndLowerToEdge_1$1;

var localeManager$2$1 = LocaleHelpers$4$1.localeManager,
    MONTH_INDEX$7 = DateUnitIndexes$1$1.MONTH_INDEX,
    ceil$1$1 = mathAliases$7$1.ceil;

var FormatTokensBase$1$1 = [
  {
    ldml: 'Dow',
    strf: 'a',
    lowerToken: 'dow',
    get: function(d, localeCode) {
      return localeManager$2$1.get(localeCode).getWeekdayName(getWeekday$2$1(d), 2);
    }
  },
  {
    ldml: 'Weekday',
    strf: 'A',
    lowerToken: 'weekday',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2$1.get(localeCode).getWeekdayName(getWeekday$2$1(d), alternate);
    }
  },
  {
    ldml: 'Mon',
    strf: 'b h',
    lowerToken: 'mon',
    get: function(d, localeCode) {
      return localeManager$2$1.get(localeCode).getMonthName(getMonth$2$1(d), 2);
    }
  },
  {
    ldml: 'Month',
    strf: 'B',
    lowerToken: 'month',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2$1.get(localeCode).getMonthName(getMonth$2$1(d), alternate);
    }
  },
  {
    strf: 'C',
    get: function(d) {
      return getYear$3$1(d).toString().slice(0, 2);
    }
  },
  {
    ldml: 'd date day',
    strf: 'd',
    strfPadding: 2,
    ldmlPaddedToken: 'dd',
    ordinalToken: 'do',
    get: function(d) {
      return getDate$1$1(d);
    }
  },
  {
    strf: 'e',
    get: function(d) {
      return padNumber$1$1(getDate$1$1(d), 2, false, 10, ' ');
    }
  },
  {
    ldml: 'H 24hr',
    strf: 'H',
    strfPadding: 2,
    ldmlPaddedToken: 'HH',
    get: function(d) {
      return getHours$3(d);
    }
  },
  {
    ldml: 'h hours 12hr',
    strf: 'I',
    strfPadding: 2,
    ldmlPaddedToken: 'hh',
    get: function(d) {
      return getHours$3(d) % 12 || 12;
    }
  },
  {
    ldml: 'D',
    strf: 'j',
    strfPadding: 3,
    ldmlPaddedToken: 'DDD',
    get: function(d) {
      var s = setUnitAndLowerToEdge$7(cloneDate$7(d), MONTH_INDEX$7);
      return getDaysSince$2(d, s) + 1;
    }
  },
  {
    ldml: 'M',
    strf: 'm',
    strfPadding: 2,
    ordinalToken: 'Mo',
    ldmlPaddedToken: 'MM',
    get: function(d) {
      return getMonth$2$1(d) + 1;
    }
  },
  {
    ldml: 'm minutes',
    strf: 'M',
    strfPadding: 2,
    ldmlPaddedToken: 'mm',
    get: function(d) {
      return callDateGet$1$1(d, 'Minutes');
    }
  },
  {
    ldml: 'Q',
    get: function(d) {
      return ceil$1$1((getMonth$2$1(d) + 1) / 3);
    }
  },
  {
    ldml: 'TT',
    strf: 'p',
    get: function(d, localeCode) {
      return getMeridiemToken$2(d, localeCode);
    }
  },
  {
    ldml: 'tt',
    strf: 'P',
    get: function(d, localeCode) {
      return getMeridiemToken$2(d, localeCode).toLowerCase();
    }
  },
  {
    ldml: 'T',
    lowerToken: 't',
    get: function(d, localeCode) {
      return getMeridiemToken$2(d, localeCode).charAt(0);
    }
  },
  {
    ldml: 's seconds',
    strf: 'S',
    strfPadding: 2,
    ldmlPaddedToken: 'ss',
    get: function(d) {
      return callDateGet$1$1(d, 'Seconds');
    }
  },
  {
    ldml: 'S ms',
    strfPadding: 3,
    ldmlPaddedToken: 'SSS',
    get: function(d) {
      return callDateGet$1$1(d, 'Milliseconds');
    }
  },
  {
    ldml: 'e',
    strf: 'u',
    ordinalToken: 'eo',
    get: function(d) {
      return getWeekday$2$1(d) || 7;
    }
  },
  {
    strf: 'U',
    strfPadding: 2,
    get: function(d) {
      // Sunday first, 0-53
      return getWeekNumber$1$1(d, false, 0);
    }
  },
  {
    ldml: 'W',
    strf: 'V',
    strfPadding: 2,
    ordinalToken: 'Wo',
    ldmlPaddedToken: 'WW',
    get: function(d) {
      // Monday first, 1-53 (ISO8601)
      return getWeekNumber$1$1(d, true);
    }
  },
  {
    strf: 'w',
    get: function(d) {
      return getWeekday$2$1(d);
    }
  },
  {
    ldml: 'w',
    ordinalToken: 'wo',
    ldmlPaddedToken: 'ww',
    get: function(d, localeCode) {
      // Locale dependent, 1-53
      var loc = localeManager$2$1.get(localeCode),
          dow = loc.getFirstDayOfWeek(localeCode),
          doy = loc.getFirstDayOfWeekYear(localeCode);
      return getWeekNumber$1$1(d, true, dow, doy);
    }
  },
  {
    strf: 'W',
    strfPadding: 2,
    get: function(d) {
      // Monday first, 0-53
      return getWeekNumber$1$1(d, false);
    }
  },
  {
    ldmlPaddedToken: 'gggg',
    ldmlTwoDigitToken: 'gg',
    get: function(d, localeCode) {
      return getWeekYear$2(d, localeCode);
    }
  },
  {
    strf: 'G',
    strfPadding: 4,
    strfTwoDigitToken: 'g',
    ldmlPaddedToken: 'GGGG',
    ldmlTwoDigitToken: 'GG',
    get: function(d, localeCode) {
      return getWeekYear$2(d, localeCode, true);
    }
  },
  {
    ldml: 'year',
    ldmlPaddedToken: 'yyyy',
    ldmlTwoDigitToken: 'yy',
    strf: 'Y',
    strfPadding: 4,
    strfTwoDigitToken: 'y',
    get: function(d) {
      return getYear$3$1(d);
    }
  },
  {
    ldml: 'ZZ',
    strf: 'z',
    get: function(d) {
      return getUTCOffset$1$1(d);
    }
  },
  {
    ldml: 'X',
    get: function(d) {
      return trunc$1$1(d.getTime() / 1000);
    }
  },
  {
    ldml: 'x',
    get: function(d) {
      return d.getTime();
    }
  },
  {
    ldml: 'Z',
    get: function(d) {
      return getUTCOffset$1$1(d, true);
    }
  },
  {
    ldml: 'z',
    strf: 'Z',
    get: function(d) {
      // Note that this is not accurate in all browsing environments!
      // https://github.com/moment/moment/issues/162
      // It will continue to be supported for Node and usage with the
      // understanding that it may be blank.
      var match = d.toString().match(TIMEZONE_ABBREVIATION_REG$2);
      // istanbul ignore next
      return match ? match[1] : '';
    }
  },
  {
    strf: 'D',
    alias: '%m/%d/%y'
  },
  {
    strf: 'F',
    alias: '%Y-%m-%d'
  },
  {
    strf: 'r',
    alias: '%I:%M:%S %p'
  },
  {
    strf: 'R',
    alias: '%H:%M'
  },
  {
    strf: 'T',
    alias: '%H:%M:%S'
  },
  {
    strf: 'x',
    alias: '{short}'
  },
  {
    strf: 'X',
    alias: '{time}'
  },
  {
    strf: 'c',
    alias: '{stamp}'
  }
];

var FormatTokensBase_1$1 = FormatTokensBase$1$1;

var LocaleHelpers$3$1 = LocaleHelpers$h$1,
    FormatTokensBase$2 = FormatTokensBase_1$1,
    CoreOutputFormats$1$1 = CoreOutputFormats_1$1,
    forEach$1$1 = forEach_1$1,
    padNumber$6 = padNumber_1$1,
    spaceSplit$1$1 = spaceSplit_1$1,
    namespaceAliases$3$1 = namespaceAliases$e$1,
    coreUtilityAliases$2$1 = coreUtilityAliases$M$1,
    createFormatMatcher$3 = createFormatMatcher_1$1,
    defineInstanceSimilar$1$1 = defineInstanceSimilar_1$1;

var localeManager$1$1 = LocaleHelpers$3$1.localeManager,
    hasOwn$1$1 = coreUtilityAliases$2$1.hasOwn,
    getOwn$1$1 = coreUtilityAliases$2$1.getOwn,
    forEachProperty$1$1 = coreUtilityAliases$2$1.forEachProperty,
    sugarDate$3$1 = namespaceAliases$3$1.sugarDate;

var ldmlTokens$1, strfTokens$1;

function buildDateFormatTokens$1() {

  function addFormats(target, tokens, fn) {
    if (tokens) {
      forEach$1$1(spaceSplit$1$1(tokens), function(token) {
        target[token] = fn;
      });
    }
  }

  function buildLowercase(get) {
    return function(d, localeCode) {
      return get(d, localeCode).toLowerCase();
    };
  }

  function buildOrdinal(get) {
    return function(d, localeCode) {
      var n = get(d, localeCode);
      return n + localeManager$1$1.get(localeCode).getOrdinal(n);
    };
  }

  function buildPadded(get, padding) {
    return function(d, localeCode) {
      return padNumber$6(get(d, localeCode), padding);
    };
  }

  function buildTwoDigits(get) {
    return function(d, localeCode) {
      return get(d, localeCode) % 100;
    };
  }

  function buildAlias(alias) {
    return function(d, localeCode) {
      return dateFormatMatcher$1$1(alias, d, localeCode);
    };
  }

  function buildAlternates(f) {
    for (var n = 1; n <= 5; n++) {
      buildAlternate(f, n);
    }
  }

  function buildAlternate(f, n) {
    var alternate = function(d, localeCode) {
      return f.get(d, localeCode, n);
    };
    addFormats(ldmlTokens$1, f.ldml + n, alternate);
    if (f.lowerToken) {
      ldmlTokens$1[f.lowerToken + n] = buildLowercase(alternate);
    }
  }

  function getIdentityFormat(name) {
    return function(d, localeCode) {
      var loc = localeManager$1$1.get(localeCode);
      return dateFormatMatcher$1$1(loc[name], d, localeCode);
    };
  }

  ldmlTokens$1 = {};
  strfTokens$1 = {};

  forEach$1$1(FormatTokensBase$2, function(f) {
    var get = f.get, getPadded;
    if (f.lowerToken) {
      ldmlTokens$1[f.lowerToken] = buildLowercase(get);
    }
    if (f.ordinalToken) {
      ldmlTokens$1[f.ordinalToken] = buildOrdinal(get);
    }
    if (f.ldmlPaddedToken) {
      ldmlTokens$1[f.ldmlPaddedToken] = buildPadded(get, f.ldmlPaddedToken.length);
    }
    if (f.ldmlTwoDigitToken) {
      ldmlTokens$1[f.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfTwoDigitToken) {
      strfTokens$1[f.strfTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfPadding) {
      getPadded = buildPadded(get, f.strfPadding);
    }
    if (f.alias) {
      get = buildAlias(f.alias);
    }
    if (f.allowAlternates) {
      buildAlternates(f);
    }
    addFormats(ldmlTokens$1, f.ldml, get);
    addFormats(strfTokens$1, f.strf, getPadded || get);
  });

  forEachProperty$1$1(CoreOutputFormats$1$1, function(src, name) {
    addFormats(ldmlTokens$1, name, buildAlias(src));
  });

  defineInstanceSimilar$1$1(sugarDate$3$1, 'short medium long full', function(methods, name) {
    var fn = getIdentityFormat(name);
    addFormats(ldmlTokens$1, name, fn);
    methods[name] = fn;
  });

  addFormats(ldmlTokens$1, 'time', getIdentityFormat('time'));
  addFormats(ldmlTokens$1, 'stamp', getIdentityFormat('stamp'));
}

var dateFormatMatcher$1$1;

function buildDateFormatMatcher$1() {

  function getLdml(d, token, localeCode) {
    return getOwn$1$1(ldmlTokens$1, token)(d, localeCode);
  }

  function getStrf(d, token, localeCode) {
    return getOwn$1$1(strfTokens$1, token)(d, localeCode);
  }

  function checkDateToken(ldml, strf) {
    return hasOwn$1$1(ldmlTokens$1, ldml) || hasOwn$1$1(strfTokens$1, strf);
  }

  // Format matcher for LDML or STRF tokens.
  dateFormatMatcher$1$1 = createFormatMatcher$3(getLdml, getStrf, checkDateToken);
}

buildDateFormatTokens$1();

buildDateFormatMatcher$1();

var formattingTokens$1$1 = {
  ldmlTokens: ldmlTokens$1,
  strfTokens: strfTokens$1,
  dateFormatMatcher: dateFormatMatcher$1$1
};

var dateIsValid$2$1 = dateIsValid_1$1;

function assertDateIsValid$2$1(d) {
  if (!dateIsValid$2$1(d)) {
    throw new TypeError('Date is not valid');
  }
}

var assertDateIsValid_1$1 = assertDateIsValid$2$1;

var CoreOutputFormats$3 = CoreOutputFormats_1$1,
    formattingTokens$2 = formattingTokens$1$1,
    assertDateIsValid$1$1 = assertDateIsValid_1$1;

var dateFormatMatcher$2 = formattingTokens$2.dateFormatMatcher;

function dateFormat$2$1(d, format, localeCode) {
  assertDateIsValid$1$1(d);
  format = CoreOutputFormats$3[format] || format || '{long}';
  return dateFormatMatcher$2(format, d, localeCode);
}

var dateFormat_1$1 = dateFormat$2$1;

var Sugar$1x$1 = sugarCore$1.exports,
    dateFormat$1$1 = dateFormat_1$1;

Sugar$1x$1.Date.defineInstance({

  'format': function(date, f, localeCode) {
    return dateFormat$1$1(date, f, localeCode);
  }

});

Sugar$1x$1.Date.format;

var getExtendedDate$4 = getExtendedDate_1$1;

function createDateWithContext$1$1(contextDate, d, options, forceClone) {
  return getExtendedDate$4(contextDate, d, options, forceClone).date;
}

var createDateWithContext_1$1 = createDateWithContext$1$1;

var Sugar$1w$1 = sugarCore$1.exports,
    createDateWithContext$2 = createDateWithContext_1$1;

Sugar$1w$1.Date.defineInstance({

  'get': function(date, d, options) {
    return createDateWithContext$2(date, d, options);
  }

});

Sugar$1w$1.Date.get;

var Sugar$1v$1 = sugarCore$1.exports,
    getWeekNumber$4 = getWeekNumber_1$1;

Sugar$1v$1.Date.defineInstance({

  'getISOWeek': function(date) {
    return getWeekNumber$4(date, true);
  }

});

Sugar$1v$1.Date.getISOWeek;

var Sugar$1u$1 = sugarCore$1.exports,
    getUTCOffset$3 = getUTCOffset_1$1;

Sugar$1u$1.Date.defineInstance({

  'getUTCOffset': function(date, iso) {
    return getUTCOffset$3(date, iso);
  }

});

Sugar$1u$1.Date.getUTCOffset;

var Sugar$1t$1 = sugarCore$1.exports;

Sugar$1t$1.Date.defineInstance({

  'getUTCWeekday': function(date) {
    return date.getUTCDay();
  }

});

Sugar$1t$1.Date.getUTCWeekday;

var Sugar$1s$1 = sugarCore$1.exports,
    getWeekday$1$1 = getWeekday_1$1;

Sugar$1s$1.Date.defineInstance({

  'getWeekday': function(date) {
    return getWeekday$1$1(date);
  }

});

Sugar$1s$1.Date.getWeekday;

var Sugar$1r$1 = sugarCore$1.exports;



Sugar$1r$1.Date.hoursAgo;

var Sugar$1q$1 = sugarCore$1.exports;



Sugar$1q$1.Date.hoursFromNow;

var Sugar$1p$1 = sugarCore$1.exports;



Sugar$1p$1.Date.hoursSince;

var Sugar$1o$1 = sugarCore$1.exports;



Sugar$1o$1.Date.hoursUntil;

var setDate$7 = setDate_1$1,
    getDate$7 = getDate_1$1,
    getYear$2$1 = getYear_1$1,
    getMonth$1$1 = getMonth_1$1,
    getNewDate$2$1 = getNewDate_1$1;

function compareDay$1$1(d, shift) {
  var comp = getNewDate$2$1();
  if (shift) {
    setDate$7(comp, getDate$7(comp) + shift);
  }
  return getYear$2$1(d) === getYear$2$1(comp) &&
         getMonth$1$1(d) === getMonth$1$1(comp) &&
         getDate$7(d) === getDate$7(comp);
}

var compareDay_1$1 = compareDay$1$1;

var LocaleHelpers$2$1 = LocaleHelpers$h$1,
    trim$7 = trim_1$1,
    getMonth$8 = getMonth_1$1,
    isDefined$1$1 = isDefined_1$1,
    getNewDate$1$1 = getNewDate_1$1,
    compareDay$2 = compareDay_1$1,
    getWeekday$a = getWeekday_1$1,
    dateIsValid$1$1 = dateIsValid_1$1,
    classChecks$c$1 = classChecks$Z$1,
    compareDate$3 = compareDate_1$1;

var isString$4$1 = classChecks$c$1.isString,
    English$1$1 = LocaleHelpers$2$1.English;

function fullCompareDate$2$1(date, d, margin) {
  var tmp;
  if (!dateIsValid$1$1(date)) return;
  if (isString$4$1(d)) {
    d = trim$7(d).toLowerCase();
    switch(true) {
      case d === 'future':    return date.getTime() > getNewDate$1$1().getTime();
      case d === 'past':      return date.getTime() < getNewDate$1$1().getTime();
      case d === 'today':     return compareDay$2(date);
      case d === 'tomorrow':  return compareDay$2(date,  1);
      case d === 'yesterday': return compareDay$2(date, -1);
      case d === 'weekday':   return getWeekday$a(date) > 0 && getWeekday$a(date) < 6;
      case d === 'weekend':   return getWeekday$a(date) === 0 || getWeekday$a(date) === 6;

      case (isDefined$1$1(tmp = English$1$1.weekdayMap[d])):
        return getWeekday$a(date) === tmp;
      case (isDefined$1$1(tmp = English$1$1.monthMap[d])):
        return getMonth$8(date) === tmp;
    }
  }
  return compareDate$3(date, d, margin);
}

var fullCompareDate_1$1 = fullCompareDate$2$1;

var Sugar$1n$1 = sugarCore$1.exports,
    fullCompareDate$1$1 = fullCompareDate_1$1;

Sugar$1n$1.Date.defineInstance({

  'is': function(date, d, margin) {
    return fullCompareDate$1$1(date, d, margin);
  }

});

Sugar$1n$1.Date.is;

var Sugar$1m$1 = sugarCore$1.exports,
    createDate$3$1 = createDate_1$1;

Sugar$1m$1.Date.defineInstance({

  'isAfter': function(date, d, margin) {
    return date.getTime() > createDate$3$1(d).getTime() - (margin || 0);
  }

});

Sugar$1m$1.Date.isAfter;

var Sugar$1l$1 = sugarCore$1.exports,
    createDate$2$1 = createDate_1$1;

Sugar$1l$1.Date.defineInstance({

  'isBefore': function(date, d, margin) {
    return date.getTime() < createDate$2$1(d).getTime() + (margin || 0);
  }

});

Sugar$1l$1.Date.isBefore;

var Sugar$1k$1 = sugarCore$1.exports,
    createDate$1$1 = createDate_1$1,
    mathAliases$6$1 = mathAliases$z$1;

var min$2$1 = mathAliases$6$1.min,
    max$2$1 = mathAliases$6$1.max;

Sugar$1k$1.Date.defineInstance({

  'isBetween': function(date, d1, d2, margin) {
    var t  = date.getTime();
    var t1 = createDate$1$1(d1).getTime();
    var t2 = createDate$1$1(d2).getTime();
    var lo = min$2$1(t1, t2);
    var hi = max$2$1(t1, t2);
    margin = margin || 0;
    return (lo - margin <= t) && (hi + margin >= t);
  }

});

Sugar$1k$1.Date.isBetween;

var LocaleHelpers$1$1 = LocaleHelpers$h$1,
    spaceSplit$7 = spaceSplit_1$1,
    fullCompareDate$3 = fullCompareDate_1$1,
    namespaceAliases$2$1 = namespaceAliases$e$1,
    defineInstanceSimilar$6 = defineInstanceSimilar_1$1;

var English$4 = LocaleHelpers$1$1.English,
    sugarDate$2$1 = namespaceAliases$2$1.sugarDate;

function buildRelativeAliases$1$1() {
  var special  = spaceSplit$7('Today Yesterday Tomorrow Weekday Weekend Future Past');
  var weekdays = English$4.weekdays.slice(0, 7);
  var months   = English$4.months.slice(0, 12);
  var together = special.concat(weekdays).concat(months);
  defineInstanceSimilar$6(sugarDate$2$1, together, function(methods, name) {
    methods['is'+ name] = function(d) {
      return fullCompareDate$3(d, name);
    };
  });
}

var buildRelativeAliases_1$1 = buildRelativeAliases$1$1;

var buildRelativeAliases$2 = buildRelativeAliases_1$1;

buildRelativeAliases$2();

var Sugar$1j$1 = sugarCore$1.exports;



Sugar$1j$1.Date.isFriday;

var Sugar$1i$1 = sugarCore$1.exports;



Sugar$1i$1.Date.isFuture;

var Sugar$1h$1 = sugarCore$1.exports;



Sugar$1h$1.Date.isLastMonth;

var Sugar$1g$1 = sugarCore$1.exports;



Sugar$1g$1.Date.isLastWeek;

var Sugar$1f$1 = sugarCore$1.exports;



Sugar$1f$1.Date.isLastYear;

var Sugar$1e$1 = sugarCore$1.exports,
    getYear$1$1 = getYear_1$1;

Sugar$1e$1.Date.defineInstance({

  'isLeapYear': function(date) {
    var year = getYear$1$1(date);
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

});

Sugar$1e$1.Date.isLeapYear;

var Sugar$1d$1 = sugarCore$1.exports;



Sugar$1d$1.Date.isMonday;

var Sugar$1c$1 = sugarCore$1.exports;



Sugar$1c$1.Date.isNextMonth;

var Sugar$1b$1 = sugarCore$1.exports;



Sugar$1b$1.Date.isNextWeek;

var Sugar$1a$1 = sugarCore$1.exports;



Sugar$1a$1.Date.isNextYear;

var Sugar$19$1 = sugarCore$1.exports;



Sugar$19$1.Date.isPast;

var Sugar$18$1 = sugarCore$1.exports;



Sugar$18$1.Date.isSaturday;

var Sugar$17$1 = sugarCore$1.exports;



Sugar$17$1.Date.isSunday;

var Sugar$16$1 = sugarCore$1.exports;



Sugar$16$1.Date.isThisMonth;

var Sugar$15$1 = sugarCore$1.exports;



Sugar$15$1.Date.isThisWeek;

var Sugar$14$1 = sugarCore$1.exports;



Sugar$14$1.Date.isThisYear;

var Sugar$13$1 = sugarCore$1.exports;



Sugar$13$1.Date.isThursday;

var Sugar$12$1 = sugarCore$1.exports;



Sugar$12$1.Date.isToday;

var Sugar$11$1 = sugarCore$1.exports;



Sugar$11$1.Date.isTomorrow;

var Sugar$10$1 = sugarCore$1.exports;



Sugar$10$1.Date.isTuesday;

var _utc$1$1 = _utc$8$1,
    tzOffset$5 = tzOffset_1$1;

function isUTC$1$1(d) {
  return !!_utc$1$1(d) || tzOffset$5(d) === 0;
}

var isUTC_1$1 = isUTC$1$1;

var Sugar$$$1 = sugarCore$1.exports,
    isUTC$2 = isUTC_1$1;

Sugar$$$1.Date.defineInstance({

  'isUTC': function(date) {
    return isUTC$2(date);
  }

});

Sugar$$$1.Date.isUTC;

var Sugar$_$1 = sugarCore$1.exports,
    dateIsValid$6 = dateIsValid_1$1;

Sugar$_$1.Date.defineInstance({

  'isValid': function(date) {
    return dateIsValid$6(date);
  }

});

Sugar$_$1.Date.isValid;

var Sugar$Z$1 = sugarCore$1.exports;



Sugar$Z$1.Date.isWednesday;

var Sugar$Y$1 = sugarCore$1.exports;



Sugar$Y$1.Date.isWeekday;

var Sugar$X$1 = sugarCore$1.exports;



Sugar$X$1.Date.isWeekend;

var Sugar$W$1 = sugarCore$1.exports;



Sugar$W$1.Date.isYesterday;

var Sugar$V$1 = sugarCore$1.exports;

Sugar$V$1.Date.defineInstance({

  'iso': function(date) {
    return date.toISOString();
  }

});

Sugar$V$1.Date.iso;

var Sugar$U$1 = sugarCore$1.exports;



Sugar$U$1.Date.millisecondsAgo;

var Sugar$T$1 = sugarCore$1.exports;



Sugar$T$1.Date.millisecondsFromNow;

var Sugar$S$1 = sugarCore$1.exports;



Sugar$S$1.Date.millisecondsSince;

var Sugar$R$1 = sugarCore$1.exports;



Sugar$R$1.Date.millisecondsUntil;

var Sugar$Q$1 = sugarCore$1.exports;



Sugar$Q$1.Date.minutesAgo;

var Sugar$P$1 = sugarCore$1.exports;



Sugar$P$1.Date.minutesFromNow;

var Sugar$O$1 = sugarCore$1.exports;



Sugar$O$1.Date.minutesSince;

var Sugar$N$1 = sugarCore$1.exports;



Sugar$N$1.Date.minutesUntil;

var Sugar$M$1 = sugarCore$1.exports;



Sugar$M$1.Date.monthsAgo;

var Sugar$L$1 = sugarCore$1.exports;



Sugar$L$1.Date.monthsFromNow;

var Sugar$K$1 = sugarCore$1.exports;



Sugar$K$1.Date.monthsSince;

var Sugar$J$1 = sugarCore$1.exports;



Sugar$J$1.Date.monthsUntil;

var getNewDate$6 = getNewDate_1$1,
    mathAliases$5$1 = mathAliases$z$1,
    getAdjustedUnit$3 = getAdjustedUnit_1$1,
    getTimeDistanceForUnit$4 = getTimeDistanceForUnit_1$1;

var abs$1$1 = mathAliases$5$1.abs;

function getAdjustedUnitForDate$1$1(d, dRelative) {
  var ms;
  if (!dRelative) {
    dRelative = getNewDate$6();
    if (d > dRelative) {
      // If our date is greater than the one that we got from getNewDate, it
      // means that we are finding the unit for a date that is in the future
      // relative to now. However, often the incoming date was created in
      // the same cycle as our comparison, but our "now" date will have been
      // created an instant after it, creating situations where "5 minutes from
      // now" becomes "4 minutes from now" in the same tick. To prevent this,
      // subtract a buffer of 10ms to compensate.
      dRelative = new Date(dRelative.getTime() - 10);
    }
  }
  ms = d - dRelative;
  return getAdjustedUnit$3(ms, function(u) {
    return abs$1$1(getTimeDistanceForUnit$4(d, dRelative, u));
  });
}

var getAdjustedUnitForDate_1$1 = getAdjustedUnitForDate$1$1;

var LocaleHelpers$i = LocaleHelpers$h$1,
    dateFormat$3 = dateFormat_1$1,
    classChecks$b$1 = classChecks$Z$1,
    assertDateIsValid$3 = assertDateIsValid_1$1,
    getAdjustedUnitForDate$2 = getAdjustedUnitForDate_1$1;

var isFunction$1$1 = classChecks$b$1.isFunction,
    localeManager$g = LocaleHelpers$i.localeManager;

function dateRelative$2$1(d, dRelative, arg1, arg2) {
  var adu, format, type, localeCode, fn;
  assertDateIsValid$3(d);
  if (isFunction$1$1(arg1)) {
    fn = arg1;
  } else {
    localeCode = arg1;
    fn = arg2;
  }
  adu = getAdjustedUnitForDate$2(d, dRelative);
  if (fn) {
    format = fn.apply(d, adu.concat(localeManager$g.get(localeCode)));
    if (format) {
      return dateFormat$3(d, format, localeCode);
    }
  }
  // Adjust up if time is in ms, as this doesn't
  // look very good for a standard relative date.
  if (adu[1] === 0) {
    adu[1] = 1;
    adu[0] = 1;
  }
  if (dRelative) {
    type = 'duration';
  } else if (adu[2] > 0) {
    type = 'future';
  } else {
    type = 'past';
  }
  return localeManager$g.get(localeCode).getRelativeFormat(adu, type);
}

var dateRelative_1$1 = dateRelative$2$1;

var Sugar$I$1 = sugarCore$1.exports,
    dateRelative$1$1 = dateRelative_1$1;

Sugar$I$1.Date.defineInstance({

  'relative': function(date, localeCode, relativeFn) {
    return dateRelative$1$1(date, null, localeCode, relativeFn);
  }

});

Sugar$I$1.Date.relative;

var Sugar$H$1 = sugarCore$1.exports,
    createDate$9 = createDate_1$1,
    dateRelative$3 = dateRelative_1$1;

Sugar$H$1.Date.defineInstance({

  'relativeTo': function(date, d, localeCode) {
    return dateRelative$3(date, createDate$9(d), localeCode);
  }

});

Sugar$H$1.Date.relativeTo;

var iterateOverDateParams$5 = iterateOverDateParams_1$1;

function getUnitIndexForParamName$1$1(name) {
  var params = {}, unitIndex;
  params[name] = 1;
  iterateOverDateParams$5(params, function(name, val, unit, i) {
    unitIndex = i;
    return false;
  });
  return unitIndex;
}

var getUnitIndexForParamName_1$1 = getUnitIndexForParamName$1$1;

var Sugar$G$1 = sugarCore$1.exports,
    DateUnitIndexes$j = DateUnitIndexes$i$1,
    moveToBeginningOfUnit$5 = moveToBeginningOfUnit_1$1,
    getUnitIndexForParamName$2 = getUnitIndexForParamName_1$1;

var DAY_INDEX$a = DateUnitIndexes$j.DAY_INDEX;

Sugar$G$1.Date.defineInstance({

  'reset': function(date, unit, localeCode) {
    var unitIndex = unit ? getUnitIndexForParamName$2(unit) : DAY_INDEX$a;
    moveToBeginningOfUnit$5(date, unitIndex, localeCode);
    return date;
  }

});

Sugar$G$1.Date.reset;

var Sugar$F$1 = sugarCore$1.exports,
    advanceDateWithArgs$3 = advanceDateWithArgs_1$1;

Sugar$F$1.Date.defineInstanceWithArguments({

  'rewind': function(d, args) {
    return advanceDateWithArgs$3(d, args, -1);
  }

});

Sugar$F$1.Date.rewind;

var Sugar$E$1 = sugarCore$1.exports;



Sugar$E$1.Date.secondsAgo;

var Sugar$D$1 = sugarCore$1.exports;



Sugar$D$1.Date.secondsFromNow;

var Sugar$C$1 = sugarCore$1.exports;



Sugar$C$1.Date.secondsSince;

var Sugar$B$1 = sugarCore$1.exports;



Sugar$B$1.Date.secondsUntil;

var Sugar$A$1 = sugarCore$1.exports,
    updateDate$5 = updateDate_1$1,
    collectUpdateDateArguments$3 = collectUpdateDateArguments_1$1;

Sugar$A$1.Date.defineInstanceWithArguments({

  'set': function(d, args) {
    args = collectUpdateDateArguments$3(args);
    return updateDate$5(d, args[0], args[1]);
  }

});

Sugar$A$1.Date.set;

var Sugar$z$1 = sugarCore$1.exports,
    setISOWeekNumber$3 = setISOWeekNumber_1$1;

Sugar$z$1.Date.defineInstance({

  'setISOWeek': function(date, num) {
    return setISOWeekNumber$3(date, num);
  }

});

Sugar$z$1.Date.setISOWeek;

var Sugar$y$1 = sugarCore$1.exports,
    _utc$9 = _utc$8$1;

Sugar$y$1.Date.defineInstance({

  'setUTC': function(date, on) {
    return _utc$9(date, on);
  }

});

Sugar$y$1.Date.setUTC;

var Sugar$x$1 = sugarCore$1.exports,
    setWeekday$9 = setWeekday_1$1;

Sugar$x$1.Date.defineInstance({

  'setWeekday': function(date, dow) {
    return setWeekday$9(date, dow);
  }

});

Sugar$x$1.Date.setWeekday;

var Sugar$w$1 = sugarCore$1.exports;



Sugar$w$1.Date.weeksAgo;

var Sugar$v$1 = sugarCore$1.exports;



Sugar$v$1.Date.weeksFromNow;

var Sugar$u$1 = sugarCore$1.exports;



Sugar$u$1.Date.weeksSince;

var Sugar$t$1 = sugarCore$1.exports;



Sugar$t$1.Date.weeksUntil;

var Sugar$s$1 = sugarCore$1.exports;



Sugar$s$1.Date.yearsAgo;

var Sugar$r$1 = sugarCore$1.exports;



Sugar$r$1.Date.yearsFromNow;

var Sugar$q$1 = sugarCore$1.exports;



Sugar$q$1.Date.yearsSince;

var Sugar$p$1 = sugarCore$1.exports;



Sugar$p$1.Date.yearsUntil;

var Sugar$o$1 = sugarCore$1.exports;

Sugar$o$1.Date.getOption;

var Sugar$n$1 = sugarCore$1.exports;

Sugar$n$1.Date.setOption;

var classChecks$a$1 = classChecks$Z$1;

var isDate$3$1 = classChecks$a$1.isDate;

function getRangeMemberPrimitiveValue$2$1(m) {
  if (m == null) return m;
  return isDate$3$1(m) ? m.getTime() : m.valueOf();
}

var getRangeMemberPrimitiveValue_1$1 = getRangeMemberPrimitiveValue$2$1;

var classChecks$9$1 = classChecks$Z$1,
    getRangeMemberPrimitiveValue$1$1 = getRangeMemberPrimitiveValue_1$1;

var isDate$2$1 = classChecks$9$1.isDate;

function cloneRangeMember$2$1(m) {
  if (isDate$2$1(m)) {
    return new Date(m.getTime());
  } else {
    return getRangeMemberPrimitiveValue$1$1(m);
  }
}

var cloneRangeMember_1$1 = cloneRangeMember$2$1;

var cloneRangeMember$1$1 = cloneRangeMember_1$1;

function Range$h$1(start, end) {
  this.start = cloneRangeMember$1$1(start);
  this.end   = cloneRangeMember$1$1(end);
}

var Range_1$1 = Range$h$1;

var classChecks$8$1 = classChecks$Z$1,
    namespaceAliases$1$1 = namespaceAliases$e$1;

var isDate$1$1 = classChecks$8$1.isDate,
    sugarDate$1$1 = namespaceAliases$1$1.sugarDate;

function getDateForRange$2$1(d) {
  if (isDate$1$1(d)) {
    return d;
  } else if (d == null) {
    return new Date();
  } else if (sugarDate$1$1.create) {
    return sugarDate$1$1.create(d);
  }
  return new Date(d);
}

var getDateForRange_1$1 = getDateForRange$2$1;

var DURATION_UNITS$3$1 = 'year|month|week|day|hour|minute|second|millisecond';

var DURATION_UNITS$2$1 = DURATION_UNITS$3$1;

var FULL_CAPTURED_DURATION$1$1 = '((?:\\d+)?\\s*(?:' + DURATION_UNITS$2$1 + '))s?';

var FULL_CAPTURED_DURATION$2 = FULL_CAPTURED_DURATION$1$1;

var DurationTextFormats$1$1 = {
  RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
  RANGE_REG_REAR_DURATION: RegExp('(.+)\\s*for\\s*' + FULL_CAPTURED_DURATION$2, 'i'),
  RANGE_REG_FRONT_DURATION: RegExp('(?:for)?\\s*'+ FULL_CAPTURED_DURATION$2 +'\\s*(?:starting)?\\s(?:at\\s)?(.+)', 'i')
};

var MULTIPLIERS$2$1 = {
  'Hours': 60 * 60 * 1000,
  'Minutes': 60 * 1000,
  'Seconds': 1000,
  'Milliseconds': 1
};

var MULTIPLIERS_1$1 = MULTIPLIERS$2$1;

var MULTIPLIERS$1$1 = MULTIPLIERS_1$1,
    callDateSet$7 = callDateSet_1$1,
    callDateGet$b = callDateGet_1$1;

function incrementDate$2$1(src, amount, unit) {
  var mult = MULTIPLIERS$1$1[unit], d;
  if (mult) {
    d = new Date(src.getTime() + (amount * mult));
  } else {
    d = new Date(src);
    callDateSet$7(d, unit, callDateGet$b(src, unit) + amount);
  }
  return d;
}

var incrementDate_1$1 = incrementDate$2$1;

var DURATION_UNITS$1$1 = DURATION_UNITS$3$1;

var DURATION_REG$1$1 = RegExp('(\\d+)?\\s*('+ DURATION_UNITS$1$1 +')s?', 'i');

var DURATION_REG$2 = DURATION_REG$1$1,
    classChecks$7$1 = classChecks$Z$1,
    simpleCapitalize$1$1 = simpleCapitalize_1$1;

var isNumber$4$1 = classChecks$7$1.isNumber;

function getDateIncrementObject$2$1(amt) {
  var match, val, unit;
  if (isNumber$4$1(amt)) {
    return [amt, 'Milliseconds'];
  }
  match = amt.match(DURATION_REG$2);
  val = +match[1] || 1;
  unit = simpleCapitalize$1$1(match[2].toLowerCase());
  if (unit.match(/hour|minute|second/i)) {
    unit += 's';
  } else if (unit === 'Year') {
    unit = 'FullYear';
  } else if (unit === 'Week') {
    unit = 'Date';
    val *= 7;
  } else if (unit === 'Day') {
    unit = 'Date';
  }
  return [val, unit];
}

var getDateIncrementObject_1$1 = getDateIncrementObject$2$1;

var Range$g$1 = Range_1$1,
    DurationTextFormats$2 = DurationTextFormats$1$1,
    incrementDate$1$1 = incrementDate_1$1,
    getDateForRange$1$1 = getDateForRange_1$1,
    namespaceAliases$f = namespaceAliases$e$1,
    getDateIncrementObject$1$1 = getDateIncrementObject_1$1;

var sugarDate$7 = namespaceAliases$f.sugarDate,
    RANGE_REG_FROM_TO$1 = DurationTextFormats$2.RANGE_REG_FROM_TO,
    RANGE_REG_REAR_DURATION$1 = DurationTextFormats$2.RANGE_REG_REAR_DURATION,
    RANGE_REG_FRONT_DURATION$1 = DurationTextFormats$2.RANGE_REG_FRONT_DURATION;

function createDateRangeFromString$1$1(str) {
  var match, datetime, duration, dio, start, end;
  if (sugarDate$7.get && (match = str.match(RANGE_REG_FROM_TO$1))) {
    start = getDateForRange$1$1(match[1].replace('from', 'at'));
    end = sugarDate$7.get(start, match[2]);
    return new Range$g$1(start, end);
  }
  if (match = str.match(RANGE_REG_FRONT_DURATION$1)) {
    duration = match[1];
    datetime = match[2];
  }
  if (match = str.match(RANGE_REG_REAR_DURATION$1)) {
    datetime = match[1];
    duration = match[2];
  }
  if (datetime && duration) {
    start = getDateForRange$1$1(datetime);
    dio = getDateIncrementObject$1$1(duration);
    end = incrementDate$1$1(start, dio[0], dio[1]);
  } else {
    start = str;
  }
  return new Range$g$1(getDateForRange$1$1(start), getDateForRange$1$1(end));
}

var createDateRangeFromString_1$1 = createDateRangeFromString$1$1;

var Range$f$1 = Range_1$1,
    classChecks$6$1 = classChecks$Z$1,
    getDateForRange$3 = getDateForRange_1$1,
    createDateRangeFromString$2 = createDateRangeFromString_1$1;

var isString$3$1 = classChecks$6$1.isString;

var DateRangeConstructor$1$1 = function(start, end) {
  if (arguments.length === 1 && isString$3$1(start)) {
    return createDateRangeFromString$2(start);
  }
  return new Range$f$1(getDateForRange$3(start), getDateForRange$3(end));
};

var DateRangeConstructor_1$1 = DateRangeConstructor$1$1;

var Sugar$m$1 = sugarCore$1.exports,
    DateRangeConstructor$2 = DateRangeConstructor_1$1;

Sugar$m$1.Date.defineStatic({

  'range': DateRangeConstructor$2

});

Sugar$m$1.Date.range;

var Range$e$1 = Range_1$1;

var PrimitiveRangeConstructor$2$1 = function(start, end) {
  return new Range$e$1(start, end);
};

var PrimitiveRangeConstructor_1$1 = PrimitiveRangeConstructor$2$1;

var Sugar$l$1 = sugarCore$1.exports,
    PrimitiveRangeConstructor$1$1 = PrimitiveRangeConstructor_1$1;

Sugar$l$1.Number.defineStatic({

  'range': PrimitiveRangeConstructor$1$1

});

Sugar$l$1.Number.range;

var Sugar$k$1 = sugarCore$1.exports,
    PrimitiveRangeConstructor$3 = PrimitiveRangeConstructor_1$1;

Sugar$k$1.String.defineStatic({

  'range': PrimitiveRangeConstructor$3

});

Sugar$k$1.String.range;

var cloneRangeMember$3 = cloneRangeMember_1$1;

function rangeClamp$3$1(range, obj) {
  var clamped,
      start = range.start,
      end = range.end,
      min = end < start ? end : start,
      max = start > end ? start : end;
  if (obj < min) {
    clamped = min;
  } else if (obj > max) {
    clamped = max;
  } else {
    clamped = obj;
  }
  return cloneRangeMember$3(clamped);
}

var rangeClamp_1$1 = rangeClamp$3$1;

var Sugar$j$1 = sugarCore$1.exports,
    Range$d$1 = Range_1$1,
    rangeClamp$2$1 = rangeClamp_1$1;

Sugar$j$1.Number.defineInstance({

  'cap': function(n, max) {
    return rangeClamp$2$1(new Range$d$1(undefined, max), n);
  }

});

Sugar$j$1.Number.cap;

var Sugar$i$1 = sugarCore$1.exports,
    Range$c$1 = Range_1$1,
    rangeClamp$1$1 = rangeClamp_1$1;

Sugar$i$1.Number.defineInstance({

  'clamp': function(n, start, end) {
    return rangeClamp$1$1(new Range$c$1(start, end), n);
  }

});

Sugar$i$1.Number.clamp;

function valueIsNotInfinite$1$1(m) {
  return m !== -Infinity && m !== Infinity;
}

var valueIsNotInfinite_1$1 = valueIsNotInfinite$1$1;

var valueIsNotInfinite$2 = valueIsNotInfinite_1$1,
    getRangeMemberPrimitiveValue$3 = getRangeMemberPrimitiveValue_1$1;

function isValidRangeMember$1$1(m) {
  var val = getRangeMemberPrimitiveValue$3(m);
  return (!!val || val === 0) && valueIsNotInfinite$2(m);
}

var isValidRangeMember_1$1 = isValidRangeMember$1$1;

var isValidRangeMember$2 = isValidRangeMember_1$1;

function rangeIsValid$4$1(range) {
  return isValidRangeMember$2(range.start) &&
         isValidRangeMember$2(range.end) &&
         typeof range.start === typeof range.end;
}

var rangeIsValid_1$1 = rangeIsValid$4$1;

var withPrecision$6 = withPrecision_1$1;

function incrementNumber$1$1(current, amount, precision) {
  return withPrecision$6(current + amount, precision);
}

var incrementNumber_1$1 = incrementNumber$1$1;

var chr$7 = chr$6$1;

function incrementString$1$1(current, amount) {
  return chr$7(current.charCodeAt(0) + amount);
}

var incrementString_1$1 = incrementString$1$1;

var periodSplit$4 = periodSplit_1$1;

function getPrecision$1$1(n) {
  var split = periodSplit$4(n.toString());
  return split[1] ? split[1].length : 0;
}

var getPrecision_1$1 = getPrecision$1$1;

var mathAliases$4$1 = mathAliases$z$1,
    getPrecision$2 = getPrecision_1$1;

var max$1$1 = mathAliases$4$1.max;

function getGreaterPrecision$1$1(n1, n2) {
  return max$1$1(getPrecision$2(n1), getPrecision$2(n2));
}

var getGreaterPrecision_1$1 = getGreaterPrecision$1$1;

var classChecks$5$1 = classChecks$Z$1,
    rangeIsValid$3$1 = rangeIsValid_1$1,
    incrementDate$3 = incrementDate_1$1,
    incrementNumber$2 = incrementNumber_1$1,
    incrementString$2 = incrementString_1$1,
    getGreaterPrecision$2 = getGreaterPrecision_1$1,
    getDateIncrementObject$3 = getDateIncrementObject_1$1;

var isNumber$3$1 = classChecks$5$1.isNumber,
    isString$2$1 = classChecks$5$1.isString,
    isDate$b = classChecks$5$1.isDate,
    isFunction$f = classChecks$5$1.isFunction;

function rangeEvery$4$1(range, step, countOnly, fn) {
  var increment,
      precision,
      dio,
      unit,
      start   = range.start,
      end     = range.end,
      inverse = end < start,
      current = start,
      index   = 0,
      result  = [];

  if (!rangeIsValid$3$1(range)) {
    return countOnly ? NaN : [];
  }
  if (isFunction$f(step)) {
    fn = step;
    step = null;
  }
  step = step || 1;
  if (isNumber$3$1(start)) {
    precision = getGreaterPrecision$2(start, step);
    increment = function() {
      return incrementNumber$2(current, step, precision);
    };
  } else if (isString$2$1(start)) {
    increment = function() {
      return incrementString$2(current, step);
    };
  } else if (isDate$b(start)) {
    dio  = getDateIncrementObject$3(step);
    step = dio[0];
    unit = dio[1];
    increment = function() {
      return incrementDate$3(current, step, unit);
    };
  }
  // Avoiding infinite loops
  if (inverse && step > 0) {
    step *= -1;
  }
  while(inverse ? current >= end : current <= end) {
    if (!countOnly) {
      result.push(current);
    }
    if (fn) {
      fn(current, index, range);
    }
    current = increment();
    index++;
  }
  return countOnly ? index - 1 : result;
}

var rangeEvery_1$1 = rangeEvery$4$1;

var Sugar$h$1 = sugarCore$1.exports,
    Range$b$1 = Range_1$1,
    rangeEvery$3$1 = rangeEvery_1$1;

Sugar$h$1.Number.defineInstance({

  'upto': function(n, num, step, everyFn) {
    return rangeEvery$3$1(new Range$b$1(n, num), step, false, everyFn);
  }

});

Sugar$h$1.Number.upto;

var coreUtilityAliases$1$1 = coreUtilityAliases$M$1;

var forEachProperty$o = coreUtilityAliases$1$1.forEachProperty;

function defineOnPrototype$b$1(ctor, methods) {
  var proto = ctor.prototype;
  forEachProperty$o(methods, function(val, key) {
    proto[key] = val;
  });
}

var defineOnPrototype_1$1 = defineOnPrototype$b$1;

var Range$a$1 = Range_1$1,
    rangeClamp$4 = rangeClamp_1$1,
    defineOnPrototype$a$1 = defineOnPrototype_1$1;

defineOnPrototype$a$1(Range$a$1, {

  'clamp': function(el) {
    return rangeClamp$4(this, el);
  }

});

var Range$9$1 = Range_1$1,
    defineOnPrototype$9$1 = defineOnPrototype_1$1;

defineOnPrototype$9$1(Range$9$1, {

  'clone': function() {
    return new Range$9$1(this.start, this.end);
  }

});

var Range$8$1 = Range_1$1,
    defineOnPrototype$8$1 = defineOnPrototype_1$1;

defineOnPrototype$8$1(Range$8$1, {

  'contains': function(el) {
    if (el == null) return false;
    if (el.start && el.end) {
      return el.start >= this.start && el.start <= this.end &&
             el.end   >= this.start && el.end   <= this.end;
    } else {
      return el >= this.start && el <= this.end;
    }
  }

});

var MULTIPLIERS$3 = MULTIPLIERS_1$1,
    DURATION_UNITS$4 = DURATION_UNITS$3$1,
    Range$7$1 = Range_1$1,
    trunc$d = trunc_1$1,
    forEach$k = forEach_1$1,
    rangeEvery$2$1 = rangeEvery_1$1,
    simpleCapitalize$5 = simpleCapitalize_1$1,
    defineOnPrototype$7$1 = defineOnPrototype_1$1;

function buildDateRangeUnits$1$1() {
  var methods = {};
  forEach$k(DURATION_UNITS$4.split('|'), function(unit, i) {
    var name = unit + 's', mult, fn;
    if (i < 4) {
      fn = function() {
        return rangeEvery$2$1(this, unit, true);
      };
    } else {
      mult = MULTIPLIERS$3[simpleCapitalize$5(name)];
      fn = function() {
        return trunc$d((this.end - this.start) / mult);
      };
    }
    methods[name] = fn;
  });
  defineOnPrototype$7$1(Range$7$1, methods);
}

var buildDateRangeUnits_1$1 = buildDateRangeUnits$1$1;

var buildDateRangeUnits$2 = buildDateRangeUnits_1$1;

buildDateRangeUnits$2();

var Range$6$1 = Range_1$1,
    rangeEvery$1$1 = rangeEvery_1$1,
    defineOnPrototype$6$1 = defineOnPrototype_1$1;

defineOnPrototype$6$1(Range$6$1, {

  'every': function(amount, everyFn) {
    return rangeEvery$1$1(this, amount, false, everyFn);
  }

});

var Range$5$1 = Range_1$1,
    defineOnPrototype$5$1 = defineOnPrototype_1$1;

defineOnPrototype$5$1(Range$5$1, {

  'intersect': function(range) {
    if (range.start > this.end || range.end < this.start) {
      return new Range$5$1(NaN, NaN);
    }
    return new Range$5$1(
      this.start > range.start ? this.start : range.start,
      this.end   < range.end   ? this.end   : range.end
    );
  }

});

var Range$4$1 = Range_1$1,
    rangeIsValid$2$1 = rangeIsValid_1$1,
    defineOnPrototype$4$1 = defineOnPrototype_1$1;

defineOnPrototype$4$1(Range$4$1, {

  'isValid': function() {
    return rangeIsValid$2$1(this);
  }

});

var classChecks$4$1 = classChecks$Z$1;

var isString$1$1 = classChecks$4$1.isString;

function getRangeMemberNumericValue$1$1(m) {
  return isString$1$1(m) ? m.charCodeAt(0) : m;
}

var getRangeMemberNumericValue_1$1 = getRangeMemberNumericValue$1$1;

var Range$3$1 = Range_1$1,
    mathAliases$3$1 = mathAliases$z$1,
    rangeIsValid$1$1 = rangeIsValid_1$1,
    defineOnPrototype$3$1 = defineOnPrototype_1$1,
    getRangeMemberNumericValue$2 = getRangeMemberNumericValue_1$1;

var abs$a = mathAliases$3$1.abs;

defineOnPrototype$3$1(Range$3$1, {

  'span': function() {
    var n = getRangeMemberNumericValue$2(this.end) - getRangeMemberNumericValue$2(this.start);
    return rangeIsValid$1$1(this) ? abs$a(n) + 1 : NaN;
  }

});

var Range$2$1 = Range_1$1,
    rangeEvery$5 = rangeEvery_1$1,
    defineOnPrototype$2$1 = defineOnPrototype_1$1;

defineOnPrototype$2$1(Range$2$1, {

  'toArray': function() {
    return rangeEvery$5(this);
  }

});

var Range$1$1 = Range_1$1,
    rangeIsValid$5 = rangeIsValid_1$1,
    defineOnPrototype$1$1 = defineOnPrototype_1$1;

defineOnPrototype$1$1(Range$1$1, {

  'toString': function() {
    return rangeIsValid$5(this) ? this.start + '..' + this.end : 'Invalid Range';
  }

});

var Range$i = Range_1$1,
    defineOnPrototype$c = defineOnPrototype_1$1;

defineOnPrototype$c(Range$i, {

  'union': function(range) {
    return new Range$i(
      this.start < range.start ? this.start : range.start,
      this.end   > range.end   ? this.end   : range.end
    );
  }

});

var Sugar$g$1 = sugarCore$1.exports;

Sugar$g$1.Number.alias('downto', 'upto');

Sugar$g$1.Number.downto;

var Sugar$f$1 = sugarCore$1.exports,
    coercePositiveInteger$1$1 = coercePositiveInteger_1$1;

Sugar$f$1.Function.defineInstance({

  'after': function(fn, num) {
    var count = 0, collectedArgs = [];
    num = coercePositiveInteger$1$1(num);
    return function() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      collectedArgs.push(args);
      count++;
      if (count >= num) {
        return fn.call(this, collectedArgs);
      }
    };
  }

});

Sugar$f$1.Function.after;

var privatePropertyAccessor$3$1 = privatePropertyAccessor_1$1;

var _timers$2$1 = privatePropertyAccessor$3$1('timers');

var privatePropertyAccessor$2$1 = privatePropertyAccessor_1$1;

var _canceled$2$1 = privatePropertyAccessor$2$1('canceled');

var _timers$1$1 = _timers$2$1,
    _canceled$1$1 = _canceled$2$1,
    classChecks$3$1 = classChecks$Z$1;

var isArray$g = classChecks$3$1.isArray;

function cancelFunction$2$1(fn) {
  var timers = _timers$1$1(fn), timer;
  if (isArray$g(timers)) {
    while(timer = timers.shift()) {
      clearTimeout(timer);
    }
  }
  _canceled$1$1(fn, true);
  return fn;
}

var cancelFunction_1$1 = cancelFunction$2$1;

var Sugar$e$1 = sugarCore$1.exports,
    cancelFunction$1$1 = cancelFunction_1$1;

Sugar$e$1.Function.defineInstance({

  'cancel': function(fn) {
    return cancelFunction$1$1(fn);
  }

});

Sugar$e$1.Function.cancel;

var _timers$3 = _timers$2$1,
    _canceled$3 = _canceled$2$1,
    coercePositiveInteger$7 = coercePositiveInteger_1$1;

function setDelay$4$1(fn, ms, after, scope, args) {
  // Delay of infinity is never called of course...
  ms = coercePositiveInteger$7(ms || 0);
  if (!_timers$3(fn)) {
    _timers$3(fn, []);
  }
  // This is a workaround for <= IE8, which apparently has the
  // ability to call timeouts in the queue on the same tick (ms?)
  // even if functionally they have already been cleared.
  _canceled$3(fn, false);
  _timers$3(fn).push(setTimeout(function() {
    if (!_canceled$3(fn)) {
      after.apply(scope, args || []);
    }
  }, ms));
}

var setDelay_1$1 = setDelay$4$1;

var Sugar$d$1 = sugarCore$1.exports,
    setDelay$3$1 = setDelay_1$1,
    cancelFunction$3 = cancelFunction_1$1;

Sugar$d$1.Function.defineInstance({

  'debounce': function(fn, ms) {
    function debounced() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      cancelFunction$3(debounced);
      setDelay$3$1(debounced, ms, fn, this, args);
    }
    return debounced;
  }

});

Sugar$d$1.Function.debounce;

var Sugar$c$1 = sugarCore$1.exports,
    setDelay$2$1 = setDelay_1$1;

Sugar$c$1.Function.defineInstanceWithArguments({

  'delay': function(fn, ms, args) {
    setDelay$2$1(fn, ms, fn, fn, args);
    return fn;
  }

});

Sugar$c$1.Function.delay;

var Sugar$b$1 = sugarCore$1.exports,
    setDelay$1$1 = setDelay_1$1;

Sugar$b$1.Function.defineInstanceWithArguments({

  'every': function(fn, ms, args) {
    function execute () {
      // Set the delay first here, so that cancel
      // can be called within the executing function.
      setDelay$1$1(fn, ms, execute);
      fn.apply(fn, args);
    }
    setDelay$1$1(fn, ms, execute);
    return fn;
  }

});

Sugar$b$1.Function.every;

var setDelay$5 = setDelay_1$1,
    mathAliases$2$1 = mathAliases$z$1;

var max$b = mathAliases$2$1.max,
    ceil$9 = mathAliases$2$1.ceil,
    round$5 = mathAliases$2$1.round;

function createLazyFunction$2$1(fn, ms, immediate, limit) {
  var queue = [], locked = false, execute, rounded, perExecution, result;
  ms = ms || 1;
  limit = limit || Infinity;
  rounded = ceil$9(ms);
  perExecution = round$5(rounded / ms) || 1;
  execute = function() {
    var queueLength = queue.length, maxPerRound;
    if (queueLength == 0) return;
    // Allow fractions of a millisecond by calling
    // multiple times per actual timeout execution
    maxPerRound = max$b(queueLength - perExecution, 0);
    while(queueLength > maxPerRound) {
      // Getting uber-meta here...
      result = Function.prototype.apply.apply(fn, queue.shift());
      queueLength--;
    }
    setDelay$5(lazy, rounded, function() {
      locked = false;
      execute();
    });
  };
  function lazy() {
    // If the execution has locked and it's immediate, then
    // allow 1 less in the queue as 1 call has already taken place.
    if (queue.length < limit - (locked && immediate ? 1 : 0)) {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      queue.push([this, args]);
    }
    if (!locked) {
      locked = true;
      if (immediate) {
        execute();
      } else {
        setDelay$5(lazy, rounded, execute);
      }
    }
    // Return the memoized result
    return result;
  }
  return lazy;
}

var createLazyFunction_1$1 = createLazyFunction$2$1;

var Sugar$a$1 = sugarCore$1.exports,
    createLazyFunction$1$1 = createLazyFunction_1$1;

Sugar$a$1.Function.defineInstance({

  'lazy': function(fn, ms, immediate, limit) {
    return createLazyFunction$1$1(fn, ms, immediate, limit);
  }

});

Sugar$a$1.Function.lazy;

var privatePropertyAccessor$1$1 = privatePropertyAccessor_1$1;

var _lock$2$1 = privatePropertyAccessor$1$1('lock');

var privatePropertyAccessor$6 = privatePropertyAccessor_1$1;

var _partial$2$1 = privatePropertyAccessor$6('partial');

var Sugar$9$1 = sugarCore$1.exports,
    _lock$1$1 = _lock$2$1,
    _partial$1$1 = _partial$2$1,
    classChecks$2$1 = classChecks$Z$1,
    mathAliases$1$1 = mathAliases$z$1;

var isNumber$2$1 = classChecks$2$1.isNumber,
    min$1$1 = mathAliases$1$1.min;

Sugar$9$1.Function.defineInstance({

  'lock': function(fn, n) {
    var lockedFn;
    if (_partial$1$1(fn)) {
      _lock$1$1(fn, isNumber$2$1(n) ? n : null);
      return fn;
    }
    lockedFn = function() {
      arguments.length = min$1$1(_lock$1$1(lockedFn), arguments.length);
      return fn.apply(this, arguments);
    };
    _lock$1$1(lockedFn, isNumber$2$1(n) ? n : fn.length);
    return lockedFn;
  }

});

Sugar$9$1.Function.lock;

function collectArguments$1$1() {
  var args = arguments, i = args.length, arr = new Array(i);
  while (i--) {
    arr[i] = args[i];
  }
  return arr;
}

var collectArguments_1$1 = collectArguments$1$1;

var serializeInternal$5 = serializeInternal_1$1,
    coreUtilityAliases$N = coreUtilityAliases$M$1;

var hasOwn$d = coreUtilityAliases$N.hasOwn,
    getOwn$d = coreUtilityAliases$N.getOwn;

function createHashedMemoizeFunction$1$1(fn, hashFn, limit) {
  var map = {}, refs = [], counter = 0;
  return function() {
    var hashObj = hashFn.apply(this, arguments);
    var key = serializeInternal$5(hashObj, refs);
    if (hasOwn$d(map, key)) {
      return getOwn$d(map, key);
    }
    if (counter === limit) {
      map = {};
      refs = [];
      counter = 0;
    }
    counter++;
    return map[key] = fn.apply(this, arguments);
  };
}

var createHashedMemoizeFunction_1$1 = createHashedMemoizeFunction$1$1;

var Sugar$8$1 = sugarCore$1.exports,
    classChecks$1$1 = classChecks$Z$1,
    deepGetProperty$5 = deepGetProperty_1$1,
    collectArguments$2 = collectArguments_1$1,
    createHashedMemoizeFunction$2 = createHashedMemoizeFunction_1$1;

var isNumber$1$1 = classChecks$1$1.isNumber,
    isString$m = classChecks$1$1.isString;

Sugar$8$1.Function.defineInstance({

  'memoize': function(fn, arg1, arg2) {
    var hashFn, limit, prop;
    if (isNumber$1$1(arg1)) {
      limit = arg1;
    } else {
      hashFn = arg1;
      limit  = arg2;
    }
    if (isString$m(hashFn)) {
      prop = hashFn;
      hashFn = function(obj) {
        return deepGetProperty$5(obj, prop);
      };
    } else if (!hashFn) {
      hashFn = collectArguments$2;
    }
    return createHashedMemoizeFunction$2(fn, hashFn, limit);
  }

});

Sugar$8$1.Function.memoize;

var Sugar$7$1 = sugarCore$1.exports;

Sugar$7$1.Function.defineInstance({

  'once': function(fn) {
    var called = false, val;
    return function() {
      if (called) {
        return val;
      }
      called = true;
      return val = fn.apply(this, arguments);
    };
  }

});

Sugar$7$1.Function.once;

var createInstanceFromPrototype$1$1 = Object.create || function(prototype) {
  var ctor = function() {};
  ctor.prototype = prototype;
  return new ctor;
};

var createInstanceFromPrototype_1$1 = createInstanceFromPrototype$1$1;

var Sugar$6$1 = sugarCore$1.exports,
    _lock$3 = _lock$2$1,
    _partial$3 = _partial$2$1,
    isDefined$k = isDefined_1$1,
    classChecks$_ = classChecks$Z$1,
    mathAliases$A = mathAliases$z$1,
    isObjectType$g = isObjectType_1$1,
    createInstanceFromPrototype$2 = createInstanceFromPrototype_1$1;

var isNumber$e = classChecks$_.isNumber,
    min$7 = mathAliases$A.min;

Sugar$6$1.Function.defineInstanceWithArguments({

  'partial': function(fn, curriedArgs) {
    var curriedLen = curriedArgs.length;
    var partialFn = function() {
      var argIndex = 0, applyArgs = [], self = this, lock = _lock$3(partialFn), result, i;
      for (i = 0; i < curriedLen; i++) {
        var arg = curriedArgs[i];
        if (isDefined$k(arg)) {
          applyArgs[i] = arg;
        } else {
          applyArgs[i] = arguments[argIndex++];
        }
      }
      for (i = argIndex; i < arguments.length; i++) {
        applyArgs.push(arguments[i]);
      }
      if (lock === null) {
        lock = curriedLen;
      }
      if (isNumber$e(lock)) {
        applyArgs.length = min$7(applyArgs.length, lock);
      }
      // If the bound "this" object is an instance of the partialed
      // function, then "new" was used, so preserve the prototype
      // so that constructor functions can also be partialed.
      if (self instanceof partialFn) {
        self = createInstanceFromPrototype$2(fn.prototype);
        result = fn.apply(self, applyArgs);
        // An explicit return value is allowed from constructors
        // as long as they are of "object" type, so return the
        // correct result here accordingly.
        return isObjectType$g(result) ? result : self;
      }
      return fn.apply(self, applyArgs);
    };
    _partial$3(partialFn, true);
    return partialFn;
  }

});

Sugar$6$1.Function.partial;

var Sugar$5$1 = sugarCore$1.exports,
    createLazyFunction$3 = createLazyFunction_1$1;

Sugar$5$1.Function.defineInstance({

  'throttle': function(fn, ms) {
    return createLazyFunction$3(fn, ms, true, 1);
  }

});

Sugar$5$1.Function.throttle;

var Sugar$4$1 = sugarCore$1.exports,
    escapeRegExp$7 = escapeRegExp_1$1;

Sugar$4$1.RegExp.defineStatic({

  'escape': function(str) {
    return escapeRegExp$7(str);
  }

});

Sugar$4$1.RegExp.escape;

var Sugar$3$1 = sugarCore$1.exports,
    getRegExpFlags$2$1 = getRegExpFlags_1$1;

Sugar$3$1.RegExp.defineInstance({

  'addFlags': function(r, flags) {
    return RegExp(r.source, getRegExpFlags$2$1(r, flags));
  }

});

Sugar$3$1.RegExp.addFlags;

var Sugar$2$1 = sugarCore$1.exports,
    getRegExpFlags$1$1 = getRegExpFlags_1$1;

Sugar$2$1.RegExp.defineInstance({

  'getFlags': function(r) {
    return getRegExpFlags$1$1(r);
  }

});

Sugar$2$1.RegExp.getFlags;

var Sugar$1$1 = sugarCore$1.exports,
    allCharsReg$3 = allCharsReg_1$1,
    getRegExpFlags$7 = getRegExpFlags_1$1;

Sugar$1$1.RegExp.defineInstance({

  'removeFlags': function(r, flags) {
    var reg = allCharsReg$3(flags);
    return RegExp(r.source, getRegExpFlags$7(r).replace(reg, ''));
  }

});

Sugar$1$1.RegExp.removeFlags;

var Sugar$6c = sugarCore$1.exports;

Sugar$6c.RegExp.defineInstance({

  'setFlags': function(r, flags) {
    return RegExp(r.source, flags);
  }

});

Sugar$6c.RegExp.setFlags;

sugarCore$1.exports;

var statesApiResponseMock = {
    "states": [
        {
            "code": "AL",
            "name": "Alabama",
            "countryCode": "US"
        },
        {
            "code": "AK",
            "name": "Alaska",
            "countryCode": "US"
        },
        {
            "code": "AZ",
            "name": "Arizona",
            "countryCode": "US"
        },
        {
            "code": "AR",
            "name": "Arkansas",
            "countryCode": "US"
        },
        {
            "code": "CA",
            "name": "California",
            "countryCode": "US"
        },
        {
            "code": "CO",
            "name": "Colorado",
            "countryCode": "US"
        },
        {
            "code": "CT",
            "name": "Connecticut",
            "countryCode": "US"
        },
        {
            "code": "DE",
            "name": "Delaware",
            "countryCode": "US"
        },
        {
            "code": "DC",
            "name": "Dist of Columbia",
            "countryCode": "US"
        },
        {
            "code": "FL",
            "name": "Florida",
            "countryCode": "US"
        },
        {
            "code": "GA",
            "name": "Georgia",
            "countryCode": "US"
        },
        {
            "code": "HI",
            "name": "Hawaii",
            "countryCode": "US"
        },
        {
            "code": "ID",
            "name": "Idaho",
            "countryCode": "US"
        },
        {
            "code": "IL",
            "name": "Illinois",
            "countryCode": "US"
        },
        {
            "code": "IN",
            "name": "Indiana",
            "countryCode": "US"
        },
        {
            "code": "IA",
            "name": "Iowa",
            "countryCode": "US"
        },
        {
            "code": "KS",
            "name": "Kansas",
            "countryCode": "US"
        },
        {
            "code": "KY",
            "name": "Kentucky",
            "countryCode": "US"
        },
        {
            "code": "LA",
            "name": "Louisiana",
            "countryCode": "US"
        },
        {
            "code": "ME",
            "name": "Maine",
            "countryCode": "US"
        },
        {
            "code": "MD",
            "name": "Maryland",
            "countryCode": "US"
        },
        {
            "code": "MA",
            "name": "Massachusetts",
            "countryCode": "US"
        },
        {
            "code": "MI",
            "name": "Michigan",
            "countryCode": "US"
        },
        {
            "code": "MN",
            "name": "Minnesota",
            "countryCode": "US"
        },
        {
            "code": "MS",
            "name": "Mississippi",
            "countryCode": "US"
        },
        {
            "code": "MO",
            "name": "Missouri",
            "countryCode": "US"
        },
        {
            "code": "MT",
            "name": "Montana",
            "countryCode": "US"
        },
        {
            "code": "NE",
            "name": "Nebraska",
            "countryCode": "US"
        },
        {
            "code": "NV",
            "name": "Nevada",
            "countryCode": "US"
        },
        {
            "code": "NH",
            "name": "New Hampshire",
            "countryCode": "US"
        },
        {
            "code": "NJ",
            "name": "New Jersey",
            "countryCode": "US"
        },
        {
            "code": "NM",
            "name": "New Mexico",
            "countryCode": "US"
        },
        {
            "code": "NY",
            "name": "New York",
            "countryCode": "US"
        },
        {
            "code": "NC",
            "name": "North Carolina",
            "countryCode": "US"
        },
        {
            "code": "ND",
            "name": "North Dakota",
            "countryCode": "US"
        },
        {
            "code": "OH",
            "name": "Ohio",
            "countryCode": "US"
        },
        {
            "code": "OK",
            "name": "Oklahoma",
            "countryCode": "US"
        },
        {
            "code": "OR",
            "name": "Oregon",
            "countryCode": "US"
        },
        {
            "code": "PA",
            "name": "Pennsylvania",
            "countryCode": "US"
        },
        {
            "code": "PR",
            "name": "Puerto Rico",
            "countryCode": "US"
        },
        {
            "code": "RI",
            "name": "Rhode Island",
            "countryCode": "US"
        },
        {
            "code": "SC",
            "name": "South Carolina",
            "countryCode": "US"
        },
        {
            "code": "SD",
            "name": "South Dakota",
            "countryCode": "US"
        },
        {
            "code": "TN",
            "name": "Tennessee",
            "countryCode": "US"
        },
        {
            "code": "TX",
            "name": "Texas",
            "countryCode": "US"
        },
        {
            "code": "UT",
            "name": "Utah",
            "countryCode": "US"
        },
        {
            "code": "VT",
            "name": "Vermont",
            "countryCode": "US"
        },
        {
            "code": "VA",
            "name": "Virginia",
            "countryCode": "US"
        },
        {
            "code": "WA",
            "name": "Washington",
            "countryCode": "US"
        },
        {
            "code": "WV",
            "name": "West Virginia",
            "countryCode": "US"
        },
        {
            "code": "WI",
            "name": "Wisconsin",
            "countryCode": "US"
        },
        {
            "code": "WY",
            "name": "Wyoming",
            "countryCode": "US"
        },
        {
            "code": "XX",
            "name": "Other State",
            "countryCode": "US"
        },
        {
            "code": "AB",
            "name": "Alberta",
            "countryCode": "CA"
        },
        {
            "code": "BC",
            "name": "British Columbia",
            "countryCode": "CA"
        },
        {
            "code": "MB",
            "name": "Manitoba",
            "countryCode": "CA"
        },
        {
            "code": "NB",
            "name": "New Brunswick",
            "countryCode": "CA"
        },
        {
            "code": "NL",
            "name": "Newfoundland",
            "countryCode": "CA"
        },
        {
            "code": "NT",
            "name": "Northwest Territories",
            "countryCode": "CA"
        },
        {
            "code": "NS",
            "name": "Nova Scotia",
            "countryCode": "CA"
        },
        {
            "code": "NU",
            "name": "Nunavut",
            "countryCode": "CA"
        },
        {
            "code": "ON",
            "name": "Ontario",
            "countryCode": "CA"
        },
        {
            "code": "PE",
            "name": "Prince Edward",
            "countryCode": "CA"
        },
        {
            "code": "QC",
            "name": "Quebec",
            "countryCode": "CA"
        },
        {
            "code": "SK",
            "name": "Saskatchewan",
            "countryCode": "CA"
        },
        {
            "code": "YT",
            "name": "Yukon",
            "countryCode": "CA"
        }
    ]
};

var cachedResponse$1;
function getStates() {
    var shouldMockApiCall = (typeof process !== 'undefined' && process !== undefined && process !== null && process.env.REACT_APP_CYPRESS);
    if (shouldMockApiCall) {
        return Promise.resolve(statesApiResponseMock);
    }
    var opts = {
        method: 'GET',
        headers: new Headers({
            'Accept': 'application/json', 'Content-Type': 'application/json',
        })
    };
    if (cachedResponse$1) {
        return cachedResponse$1;
    }
    cachedResponse$1 = cclFetch$1(API_URLS$1.States, opts);
    return cachedResponse$1;
}
var StatesService = {
    getStates: getStates
};

var toggleAriaHidden = function (parentModalId, isEnable) {
    var _a, _b;
    var reactModalElement = (_b = (_a = document.getElementById(parentModalId)) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement;
    if (reactModalElement) {
        isEnable ? reactModalElement.setAttribute('aria-hidden', 'true') : reactModalElement.removeAttribute('aria-hidden');
    }
};

var AriaRole;
(function (AriaRole) {
    AriaRole["Alert"] = "alert";
    AriaRole["AlertDialog"] = "alertdialog";
    AriaRole["Application"] = "application";
    AriaRole["Article"] = "article";
    AriaRole["Banner"] = "banner";
    AriaRole["Button"] = "button";
    AriaRole["Cell"] = "cell";
    AriaRole["Checkbox"] = "checkbox";
    AriaRole["ColumnHeader"] = "columnheader";
    AriaRole["Combobox"] = "combobox";
    AriaRole["Complementary"] = "complementary";
    AriaRole["ContentInfo"] = "contentinfo";
    AriaRole["Definition"] = "definition";
    AriaRole["Dialog"] = "dialog";
    AriaRole["Directory"] = "directory";
    AriaRole["Document"] = "document";
    AriaRole["Feed"] = "feed";
    AriaRole["Figure"] = "figure";
    AriaRole["Form"] = "form";
    AriaRole["Grid"] = "grid";
    AriaRole["Gridcell"] = "gridcell";
    AriaRole["Group"] = "group";
    AriaRole["Heading"] = "heading";
    AriaRole["Img"] = "img";
    AriaRole["Link"] = "link";
    AriaRole["List"] = "list";
    AriaRole["Listbox"] = "listbox";
    AriaRole["Listitem"] = "listitem";
    AriaRole["Log"] = "log";
    AriaRole["Main"] = "main";
    AriaRole["Marquee"] = "marquee";
    AriaRole["Math"] = "math";
    AriaRole["Menu"] = "menu";
    AriaRole["Menubar"] = "menubar";
    AriaRole["Menuitem"] = "menuitem";
    AriaRole["MenuitemCheckbox"] = "menuitemcheckbox";
    AriaRole["MenuitemRadio"] = "menuitemradio";
    AriaRole["Navigation"] = "navigation";
    AriaRole["None"] = "none";
    AriaRole["Note"] = "note";
    AriaRole["Option"] = "option";
    AriaRole["Presentation"] = "presentation";
    AriaRole["Progressbar"] = "progressbar";
    AriaRole["Radio"] = "radio";
    AriaRole["Radiogroup"] = "radiogroup";
    AriaRole["Region"] = "region";
    AriaRole["Row"] = "row";
    AriaRole["Rowgroup"] = "rowgroup";
    AriaRole["Rowheader"] = "rowheader";
    AriaRole["Scrollbar"] = "scrollbar";
    AriaRole["Search"] = "search";
    AriaRole["Searchbox"] = "searchbox";
    AriaRole["Separator"] = "separator";
    AriaRole["Slider"] = "slider";
    AriaRole["Spinbutton"] = "spinbutton";
    AriaRole["Status"] = "status";
    AriaRole["Switch"] = "switch";
    AriaRole["Tab"] = "tab";
    AriaRole["Table"] = "table";
    AriaRole["Tablist"] = "tablist";
    AriaRole["Tabpanel"] = "tabpanel";
    AriaRole["Term"] = "term";
    AriaRole["Textbox"] = "textbox";
    AriaRole["Timer"] = "timer";
    AriaRole["Toolbar"] = "toolbar";
    AriaRole["Tooltip"] = "tooltip";
    AriaRole["Tree"] = "tree";
    AriaRole["Treegrid"] = "treegrid";
    AriaRole["Treeitem"] = "treeitem";
})(AriaRole || (AriaRole = {}));

var SharedModal = function (props) {
    var _a;
    var customStyles = props.customStyles, heading = props.heading, iconCloseSrc = props.iconCloseSrc, iconCloseAlt = props.iconCloseAlt, modalIsOpen = props.modalIsOpen, closeAriaLabel = props.closeAriaLabel, appElement = props.appElement, testId = props.testId, ariaDescribedBy = props.ariaDescribedBy, isDefaultModal = props.isDefaultModal, shouldCloseOnEsc = props.shouldCloseOnEsc, shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, onClose = props.onClose, onAfterOpen = props.onAfterOpen, onAfterClose = props.onAfterClose, contentRef = props.contentRef, overlayRef = props.overlayRef, children = props.children, closeButtonDataTestID = props.closeButtonDataTestID, headingDataTestID = props.headingDataTestID, overlayClassName = props.overlayClassName, bodyClassName = props.bodyClassName, bodyHeadingClassName = props.bodyHeadingClassName, bodyContentClassName = props.bodyContentClassName, closeIconClassName = props.closeIconClassName, modalAriaLabelledBy = props.modalAriaLabelledBy, role = props.role, modalParentId = props.modalParentId, areaRef = props.areaRef;
    var isBrowser = function () { return typeof window !== "undefined"; };
    var defaultAppElement = (_a = document.getElementById("__next")) !== null && _a !== void 0 ? _a : document.getElementById("root");
    var onAfterOpenModal = function () {
        if (modalParentId)
            toggleAriaHidden(modalParentId, true);
        if (onAfterOpen)
            onAfterOpen();
    };
    var onAfterCloseModal = function () {
        if (modalParentId)
            toggleAriaHidden(modalParentId, false);
        if (onAfterClose)
            onAfterClose();
    };
    React.useEffect(function () {
        var handleBackgroundClick = function (event) {
            if (areaRef && areaRef.current && (areaRef.current.contains(event.target))) {
                props.onClose();
            }
        };
        if (modalIsOpen) {
            window.addEventListener('click', handleBackgroundClick);
        }
        return function () {
            window.removeEventListener('click', handleBackgroundClick);
        };
    });
    return (jsxRuntime.exports.jsx(Modal, __assign({ id: props.id, isOpen: modalIsOpen, style: customStyles, appElement: appElement ||
            (isBrowser() ? defaultAppElement : appElement), aria: {
            labelledby: modalAriaLabelledBy !== null && modalAriaLabelledBy !== void 0 ? modalAriaLabelledBy : "heading",
            describedby: ariaDescribedBy,
        }, testId: testId, onRequestClose: onClose, onAfterOpen: onAfterOpenModal, onAfterClose: onAfterCloseModal, contentRef: contentRef, overlayRef: overlayRef, shouldCloseOnEsc: shouldCloseOnEsc !== null && shouldCloseOnEsc !== void 0 ? shouldCloseOnEsc : true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick !== null && shouldCloseOnOverlayClick !== void 0 ? shouldCloseOnOverlayClick : true, overlayClassName: overlayClassName, bodyOpenClassName: bodyClassName, role: role !== null && role !== void 0 ? role : AriaRole.Dialog }, { children: jsxRuntime.exports.jsxs(ContentContainer$3, { children: [(closeAriaLabel || heading) && (jsxRuntime.exports.jsxs(HeadingWrapper$3, __assign({ className: bodyHeadingClassName !== null && bodyHeadingClassName !== void 0 ? bodyHeadingClassName : 'shared-modal-header-container' }, { children: [heading && jsxRuntime.exports.jsx(Heading, __assign({ id: "heading".concat(props.id ? "-".concat(props.id) : ""), "$isDefault": isDefaultModal, "data-testid": headingDataTestID }, { children: heading })), closeAriaLabel && jsxRuntime.exports.jsx(CloseButton$4, __assign({ onClick: onClose, "aria-label": closeAriaLabel, "data-testid": closeButtonDataTestID, className: closeIconClassName !== null && closeIconClassName !== void 0 ? closeIconClassName : 'shared-modal-close-btn' }, { children: iconCloseSrc ? (jsxRuntime.exports.jsx(CloseIcon$1, { src: iconCloseSrc, alt: iconCloseAlt, "aria-hidden": 'true' })) : (jsxRuntime.exports.jsx(DefaultCloseModalIcon$1, { "aria-hidden": 'true' })) }))] }))), jsxRuntime.exports.jsx(ContentWrapper$4, __assign({ id: ariaDescribedBy, className: bodyContentClassName !== null && bodyContentClassName !== void 0 ? bodyContentClassName : 'shared-modal-content-container' }, { children: children }))] }) })));
};

styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n    margin-top: var(--spacing_token_l);\n    margin-bottom: var(--spacing_token_l);\n    width: 100%;\n"], ["\n    margin-top: var(--spacing_token_l);\n    margin-bottom: var(--spacing_token_l);\n    width: 100%;\n"])));
styled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  background-color: var(--silver);\n"], ["\n  width: 100%;\n  height: 1px;\n  background-color: var(--silver);\n"])));
styled.div(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  margin-bottom: var(--spacing_token_l);\n  width: 100%;\n"], ["\n  margin-bottom: var(--spacing_token_l);\n  width: 100%;\n"])));
var templateObject_1$v, templateObject_2$r, templateObject_3$m;

var HeightMap = new Map([
    ['small', '48px'],
    ['medium', '56px'],
    ['large', '60px'],
]);
var BackgroundColorMap = new Map([
    ['primary-blue', 'var(--tory-blue)'],
    ['primary-red', 'var(--crimson)'],
    ['primary-green', 'var(--la-palma)'],
    ['secondary-blue', 'var(--white)'],
    ['primary-white', 'var(--white)'],
    ['secondary-white', 'var(--tory-blue)'],
    ['transparent-blue', 'transparent'],
]);
var ColorMap$1 = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--tory-blue)'],
    ['primary-white', 'var(--tory-blue)'],
    ['secondary-white', 'var(--white)'],
    ['transparent-blue', 'var(--tory-blue)'],
]);
var HoverBackgroundColorMap = new Map([
    ['primary-blue', 'var(--congress-blue)'],
    ['primary-red', 'var(--monza)'],
    ['primary-green', 'var(--bilbao)'],
    ['secondary-blue', 'var(--congress-blue)'],
]);
var HoverColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--white)'],
    ['transparent-blue', 'var(--congress-blue)']
]);
var PressedBackgroundColorMap = new Map([
    ['primary-blue', 'var(--regal-blue)'],
    ['primary-red', 'var(--carmine)'],
    ['primary-green', 'var(--green-house)'],
    ['secondary-blue', 'var(--regal-blue)'],
    ['primary-white', 'var(--tory-blue)'],
    ['secondary-white', 'var(--white)'],
]);
var PressedColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--white)'],
    ['primary-white', 'var(--white)'],
    ['secondary-white', 'var(--tory-blue)'],
]);
var BorderMap$1 = new Map([
    ['primary-blue', '1px solid transparent;'],
    ['primary-red', '1px solid transparent;'],
    ['primary-green', '1px solid transparent;'],
    ['secondary-blue', '1px solid var(--tory-blue)'],
    ['primary-white', '1px solid var(--tory-blue)'],
    ['transparent-blue', 'transparent'],
]);
var FocusBackgroundColorMap = new Map([
    ['primary-blue', 'var(--tory-blue)'],
    ['primary-red', 'var(--crimson)'],
    ['primary-green', 'var( --la-palma)'],
    ['secondary-blue', 'var(--white)'],
]);
var FocusColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--tory-blue)'],
]);
var sharedCss = Ae(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  width: 100%;\n  display: inline-block;\n  ", "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  padding: 0;\n  text-decoration: none;\n  white-space:", " ;\n  vertical-align: middle;\n  user-select: none;\n  -webkit-appearance: none;\n  font-weight: 900;\n  border: ", ";\n  border-radius: var(--border-radius-s);\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor:  ", ";\n\n  ", "\n  \n  &:focus {      \n    background-color: ", ";\n    color: ", ";\n  }\n  \n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "  \n"], ["\n  width: 100%;\n  display: inline-block;\n  ", "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  padding: 0;\n  text-decoration: none;\n  white-space:", " ;\n  vertical-align: middle;\n  user-select: none;\n  -webkit-appearance: none;\n  font-weight: 900;\n  border: ", ";\n  border-radius: var(--border-radius-s);\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor:  ", ";\n\n  ", "\n  \n  &:focus {      \n    background-color: ", ";\n    color: ", ";\n  }\n  \n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "  \n"])), TempostdHeavycondensedNormalToryBlu, function (props) { return props.wrapContent ? 'none' : 'nowrap'; }, function (props) { return BorderMap$1.get(props.buttonType); }, function (props) { return HeightMap.get(props.size); }, function (props) { return props.isPressed ? PressedColorMap.get(props.buttonType) || 'primary-blue' : ColorMap$1.get(props.buttonType); }, function (props) { return props.isPressed ? PressedBackgroundColorMap.get(props.buttonType) || 'primary-blue' : BackgroundColorMap.get(props.buttonType); }, function (props) { return props.disabled ? 'not-allowed' : 'pointer'; }, function (props) {
    return props.isBlock && Ae(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n      display: block;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "], ["\n      display: block;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "])));
}, function (props) { return !props.disabled && FocusBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && FocusColorMap.get(props.buttonType); }, function (props) { return !props.disabled && HoverBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && HoverColorMap.get(props.buttonType); }, function (props) { return !props.disabled && PressedBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && PressedColorMap.get(props.buttonType); }, function (props) {
    return props.disabled && Ae(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n      color: var(--tundora); \n      background-color: var(--cararra);\n      border: none;\n    "], ["\n      color: var(--tundora); \n      background-color: var(--cararra);\n      border: none;\n    "])));
});
var Button$1 = styled.button(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedCss);
styled.a(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), sharedCss, function (props) {
    return props.isBlock && Ae(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n      display: flex;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "], ["\n      display: flex;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "])));
});
var templateObject_1$u, templateObject_2$q, templateObject_3$l, templateObject_4$k, templateObject_5$f, templateObject_6$e;

var _path$e;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 14,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M.938 0h12.06c.835 0 1.252 1.008.662 1.598L7.63 7.631a.94.94 0 0 1-1.326 0L.277 1.598C-.313 1.008.103 0 .937 0Z",
    fill: "#fff"
  })));
};

styled(SvgCaretDown)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  width: 14px;\n  margin-left: var(--spacing_token_xxs);\n"], ["\n  width: 14px;\n  margin-left: var(--spacing_token_xxs);\n"])));
styled(Button$1)(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  border: 1px solid var(--tory-blue);\n  align-items: center;\n  padding: 12px var(--spacing_token_s);\n\n  & svg {\n    margin-left: 9px;\n    transform: ", ";\n  }\n  \n  & svg path { \n    fill: ", ";\n  }  \n\n  &:focus svg path {\n    fill: ", ";\n  }  \n\n  &:hover svg path {\n    fill: ", ";\n  }\n\n  &:active svg path {\n    fill: ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  border: 1px solid var(--tory-blue);\n  align-items: center;\n  padding: 12px var(--spacing_token_s);\n\n  & svg {\n    margin-left: 9px;\n    transform: ", ";\n  }\n  \n  & svg path { \n    fill: ", ";\n  }  \n\n  &:focus svg path {\n    fill: ", ";\n  }  \n\n  &:hover svg path {\n    fill: ", ";\n  }\n\n  &:active svg path {\n    fill: ", ";\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
    var styles;
    switch (props.direction) {
        case "up":
            styles = "rotate(180deg)";
            break;
        case "right":
            styles = "rotate(270deg)";
            break;
        case "left":
            styles = "rotate(90deg)";
            break;
        case "down":
        default:
            styles = "rotate(0deg)";
    }
    return styles;
}, function (props) { return ColorMap$1.get(props.buttonType); }, function (props) { return FocusColorMap.get(props.buttonType); }, function (props) { return HoverColorMap.get(props.buttonType); }, function (props) { return PressedColorMap.get(props.buttonType); }, function (props) {
    return !props.disabled &&
        props.isPressed &&
        Ae(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  & svg path {   \n    fill:"], ["\n  & svg path {   \n    fill:"]))) +
            (PressedColorMap.get(props.buttonType) || "primary-blue") +
            ";\n  ";
}, function (props) {
    return props.disabled && Ae(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n      & svg path {\n        stroke: var(--tundora);\n        fill: var(--tundora);\n      }\n    "], ["\n      & svg path {\n        stroke: var(--tundora);\n        fill: var(--tundora);\n      }\n    "])));
});
var templateObject_1$t, templateObject_2$p, templateObject_3$k, templateObject_4$j;

styled(SvgChevronCaretsDown)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
styled.button(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-decoration: none;\n  width: fit-content;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", " {\n    font-size: 16px;\n    line-height: 20px;\n  }\n"], ["\n  color: var(--tory-blue);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-decoration: none;\n  width: fit-content;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", " {\n    font-size: 16px;\n    line-height: 20px;\n  }\n"])), styledBreakpoints.up("md"));
styled.span(templateObject_3$j || (templateObject_3$j = __makeTemplateObject([""], [""])));
styled.span(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  vertical-align: text-top;\n  margin-left: ", ";\n  display: flex;\n"], ["\n  vertical-align: text-top;\n  margin-left: ", ";\n  display: flex;\n"])), function (props) { var _a; return (_a = props.iconMargin) !== null && _a !== void 0 ? _a : '8px'; });
var templateObject_1$s, templateObject_2$o, templateObject_3$j, templateObject_4$i;

styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject([""], [""])));
styled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  p {\n    margin: 8px 0px;\n  }\n\n  sup {\n    vertical-align: super;\n  }\n"], ["\n  margin-bottom: ", ";\n\n  p {\n    margin: 8px 0px;\n  }\n\n  sup {\n    vertical-align: super;\n  }\n"])), function (props) { var _a; return (_a = props.contentMarginBottom) !== null && _a !== void 0 ? _a : '8px'; });
var templateObject_1$r, templateObject_2$n;

styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n  outline: none;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n  outline: none;\n"])));
var templateObject_1$q;

styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  height: 38px;\n  display: flex;\n"], ["\n  height: 38px;\n  display: flex;\n"])));
styled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  ", "\n  min-height: 16px;\n  min-width: 30px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  ", "\n  min-height: 16px;\n  min-width: 30px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  height: 38px;\n  margin-left: 4px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  height: 38px;\n  margin-left: 4px;\n  display: flex;\n  align-items: flex-start;\n"])));
styled.div(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  ", "\n  width: 10px;\n  min-height: 20px;\n  margin-top: 1px;\n  letter-spacing: 0;\n  line-height: 20px;\n  white-space: nowrap;\n"], ["\n  ", "\n  width: 10px;\n  min-height: 20px;\n  margin-top: 1px;\n  letter-spacing: 0;\n  line-height: 20px;\n  white-space: nowrap;\n"])), OpensansBoldTundora16px);
styled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  ", "\n  min-height: 38px;\n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"], ["\n  ", "\n  min-height: 38px;\n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"])), OpensansBoldTundora32px);
styled.div(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  ", "\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 32px;\n  margin-left: 8px;\n"], ["\n  ", "\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 32px;\n  margin-left: 8px;\n"])), OpensansBoldTundora12px);
styled.p(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])));
styled.div(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n  min-height: 16px;\n  margin-left: 10px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  min-height: 16px;\n  margin-left: 10px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])));
var templateObject_1$p, templateObject_2$m, templateObject_3$i, templateObject_4$h, templateObject_5$e, templateObject_6$d, templateObject_7$c, templateObject_8$a;

var _path$d;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgChevronDownGray = function SvgChevronDownGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "m2.095 5.632.537-.536a.326.326 0 0 1 .461 0l4.909 4.898 4.91-4.898a.326.326 0 0 1 .46 0l.537.536a.326.326 0 0 1 0 .461L8.232 11.77a.326.326 0 0 1-.46 0L2.095 6.093a.326.326 0 0 1 0-.46Z",
    fill: "#464646"
  })));
};

var _path$c;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "m5.455 4.5 2.884-2.884.595-.595a.225.225 0 0 0 0-.318L8.298.066a.225.225 0 0 0-.318 0L4.5 3.546 1.02.066a.225.225 0 0 0-.317 0L.066.702a.225.225 0 0 0 0 .318l3.48 3.48-3.48 3.48a.225.225 0 0 0 0 .318l.636.636c.088.088.23.088.318 0l3.48-3.48L7.385 8.34l.595.595c.087.088.23.088.318 0l.636-.636a.225.225 0 0 0 0-.318L5.454 4.5Z",
    fill: "#464646"
  })));
};

styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject([""], [""])));
var RadiusMap = new Map([
    ['oval', '19px'],
    ['square', '4px'],
]);
var BorderMap = new Map([
    ['oval', '1px solid var(--gray)'],
    ['square', 'none'],
]);
var BorderMapOnPressed = new Map([
    ['oval', '1px solid var(--regal-blue)'],
    ['square', 'none'],
]);
var BorderMapOnHover = new Map([
    ['oval', '1px solid var(--congress-blue)'],
    ['square', 'none'],
]);
var HoverMap = new Map([
    ['oval', 'var(--congress-blue)'],
    ['square', 'var(--congress-blue)'],
]);
var PressedMap = new Map([
    ['oval', 'var(--regal-blue)'],
    ['square', 'var(--regal-blue)'],
]);
var ColorMap = new Map([
    ['oval', 'var(--hint-of-red)'],
    ['square', 'var(--cararra)'],
]);
var BoxShadow = new Map([
    ['oval', 'none'],
    ['square', '0px 4px 6px rgba(0, 0, 0, 0.04)'],
]);
var ChipBase = Ae(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  border: ", ";\n  width: fit-content;\n  text-align: center;\n  text-decoration: none;\n  height: 32px;\n  display: flex;\n  padding: 6px 16px;\n  align-items: flex-start;\n  min-width: 50px;\n  justify-content: center;\n  align-items: center;\n  white-space:", " ;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  ", "\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n\n  &:hover {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n\n  &:active {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n    }  \n  }\n\n"], ["\n  border: ", ";\n  width: fit-content;\n  text-align: center;\n  text-decoration: none;\n  height: 32px;\n  display: flex;\n  padding: 6px 16px;\n  align-items: flex-start;\n  min-width: 50px;\n  justify-content: center;\n  align-items: center;\n  white-space:", " ;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  ", "\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n\n  &:hover {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n\n  &:active {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n    }  \n  }\n\n"])), function (props) { return !props.isExpanded ? BorderMap.get(props.chipForm) : BorderMapOnPressed.get(props.chipForm); }, function (props) { return props.wrapContent ? 'none' : 'nowrap'; }, function (props) { return RadiusMap.get(props.chipForm); }, function (props) { return BoxShadow.get(props.chipForm); }, function (props) { return !props.isExpanded ? 'var(--tundora)' : 'var(--white)'; }, function (props) { return !props.isExpanded ? ColorMap.get(props.chipForm) : 'var(--regal-blue)'; }, OpensansNormalTundora12px, function (props) { return HoverMap.get(props.chipForm); }, function (props) { return BorderMapOnHover.get(props.chipForm); }, function (props) { return PressedMap.get(props.chipForm); }, function (props) { return BorderMapOnPressed.get(props.chipForm); });
styled.button(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ChipBase);
styled.div(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  ", "\n  &:hover button {\n    background-color: var(--congress-blue);\n  }\n  \n  &:active button {\n    background-color: var(--regal-blue);\n  }  \n\n"], ["\n  ", "\n  &:hover button {\n    background-color: var(--congress-blue);\n  }\n  \n  &:active button {\n    background-color: var(--regal-blue);\n  }  \n\n"])), ChipBase);
styled(IconContainer)(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  align-self: center;\n  margin-left: var(--spacing_token_xs);\n"], ["\n  align-self: center;\n  margin-left: var(--spacing_token_xs);\n"])));
styled(SvgChevronDownGray)(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  transition: all .5s ease;\n  transform: ", ";\n \n  & path {\n    fill: ", ";\n  }\n\n"], ["\n  transition: all .5s ease;\n  transform: ", ";\n \n  & path {\n    fill: ", ";\n  }\n\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; }, function (props) { return props.$isExpanded ? 'var(--white)' : 'var(--tundora)'; });
styled(SvgCloseIcon)(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n  align-self: center;\n  transition: all .5s ease;\n"], ["\n  align-self: center;\n  transition: all .5s ease;\n"])));
styled(IconContainer)(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n"], ["\n"])));
styled.button(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n  background-color: var(--cararra);\n  -webkit-appearance: none;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  border: none;\n  margin-left: 12px;\n  padding: 0;\n  \n  &:hover {\n    background-color: var(--tory-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n \n  &:active {\n    background-color: var(--regal-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n\n  &:active:not(:hover) {\n    /* This will prevent the style from being applied\n    when the user presses the space key or enter*/\n    background-color: var(--cararra);\n    & svg path {\n      fill: var(--tundora);\n    }    \n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n"], ["\n  background-color: var(--cararra);\n  -webkit-appearance: none;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  border: none;\n  margin-left: 12px;\n  padding: 0;\n  \n  &:hover {\n    background-color: var(--tory-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n \n  &:active {\n    background-color: var(--regal-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n\n  &:active:not(:hover) {\n    /* This will prevent the style from being applied\n    when the user presses the space key or enter*/\n    background-color: var(--cararra);\n    & svg path {\n      fill: var(--tundora);\n    }    \n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n"])));
var templateObject_1$o, templateObject_2$l, templateObject_3$h, templateObject_4$g, templateObject_5$d, templateObject_6$c, templateObject_7$b, templateObject_8$9, templateObject_9$9;

var _path$b;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgInfoCircle$1 = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7.001 7.001 0 1 0 .002 14.002A7.001 7.001 0 0 0 8 1Zm0 12.645A5.642 5.642 0 0 1 2.355 8 5.643 5.643 0 0 1 8 2.355 5.643 5.643 0 0 1 13.645 8 5.642 5.642 0 0 1 8 13.645Zm1.185-2.935c0 .653-.531 1.185-1.185 1.185a1.187 1.187 0 0 1-1.185-1.185c0-.654.531-1.186 1.185-1.186s1.185.532 1.185 1.186ZM6.89 4.743 7.08 8.58c.009.18.157.322.338.322h1.162c.18 0 .33-.141.338-.322l.192-3.838a.339.339 0 0 0-.338-.356H7.227a.339.339 0 0 0-.338.356Z",
    fill: "#DC1125"
  })));
};

styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  ", "\n  display: grid;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n"], ["\n  ", "\n  display: grid;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-top: 4px;\n\n  :first-child{\n    margin-top: unset;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-top: 4px;\n\n  :first-child{\n    margin-top: unset;\n  }\n"])));
styled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  justify-content: space-between;\n"])));
styled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
styled.div(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  margin-top: 16px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: 16px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n"])));
styled.div(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
styled(SvgInfoCircle$1)(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  cursor: pointer;\n"])));
styled.div(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  text-align: right;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  text-align: right;\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
styled.div(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
styled.div(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"])));
styled.div(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"])));
styled.div(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
styled.div(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
styled.div(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"], ["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"])), TempostdHeavycondensedNormalToryBlu, styledBreakpoints.up("md"));
styled.p(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject(["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject(["\n  flex: 0 0 60%;\n  display: flex;\n"], ["\n  flex: 0 0 60%;\n  display: flex;\n"])));
styled.div(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject(["\n  display: flex;\n  margin-left: auto;\n"], ["\n  display: flex;\n  margin-left: auto;\n"])));
styled.button(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), PlainButtonStyle);
styled.div(templateObject_20$2 || (templateObject_20$2 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
styled.div(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  ", "\n  line-height: 18px;\n"], ["\n  ", "\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
var templateObject_1$n, templateObject_2$k, templateObject_3$g, templateObject_4$f, templateObject_5$c, templateObject_6$b, templateObject_7$a, templateObject_8$8, templateObject_9$8, templateObject_10$7, templateObject_11$4, templateObject_12$4, templateObject_13$3, templateObject_14$3, templateObject_15$3, templateObject_16$3, templateObject_17$2, templateObject_18$2, templateObject_19$2, templateObject_20$2, templateObject_21$1;

var PlainButton$1 = styled.button(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  appearance: none;\n"], ["\n  padding: 0;\n  margin: 0;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  appearance: none;\n"])));
var templateObject_1$m;

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var PlainButton = function (props) {
    var children = props.children, className = props.className, otherProps = __rest(props, ["children", "className"]);
    return (jsxRuntime.exports.jsx(PlainButton$1, __assign({ className: classNames('btn-plain', className) }, otherProps, { children: children })));
};

styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
styled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  & button {\n    font-size: 14px;\n    line-height: 18px;\n  }\n"], ["\n  & button {\n    font-size: 14px;\n    line-height: 18px;\n  }\n"])));
styled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-20);\n  letter-spacing: 0;\n  line-height: 24px;\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-20);\n  letter-spacing: 0;\n  line-height: 24px;\n"])));
styled.p(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: var(--tundora);\n  font-size: var(--font-size-14);\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: var(--tundora);\n  font-size: var(--font-size-14);\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
styled.div(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  height: 18px;\n  margin-top: 4px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  height: 18px;\n  margin-top: 4px;\n  display: flex;\n  align-items: flex-start;\n"])));
styled.div(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  min-height: 18px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tory-blue);\n  font-size: var(--font-size-14);\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  margin-top: 4px;\n"], ["\n  min-height: 18px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tory-blue);\n  font-size: var(--font-size-14);\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  margin-top: 4px;\n"])));
styled(SvgChevronCaretsDown)(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  align-self: center;\n  margin-left: 5px;\n"], ["\n  width: 16px;\n  height: 16px;\n  align-self: center;\n  margin-left: 5px;\n"])));
styled.div(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  color: var(--tundora);\n  position: relative;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  strong {\n    font-weight: bold;\n  }\n  ul {\n    margin-top: 8px;\n    padding-left: 24px;\n    list-style-type: disc;\n  }\n  li {\n    font-size: var(--font-size-14);\n    left: calc(50% - 208.25px/2);\n    top: calc(50% - 13px / 2 - 63px);\n    line-height: 16px;\n  }\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  color: var(--tundora);\n  position: relative;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  strong {\n    font-weight: bold;\n  }\n  ul {\n    margin-top: 8px;\n    padding-left: 24px;\n    list-style-type: disc;\n  }\n  li {\n    font-size: var(--font-size-14);\n    left: calc(50% - 208.25px/2);\n    top: calc(50% - 13px / 2 - 63px);\n    line-height: 16px;\n  }\n"])));
styled.div(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing_token_xxs) var(--spacing_token_s);\n  height: 24px;\n  border: 1px solid var(--gray);\n  border-radius: 16px;\n\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  color: var(--tundora);\n  margin: var(--spacing_token_xxs) 0 var(--spacing_token_xs);\n  text-transform: uppercase;\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing_token_xxs) var(--spacing_token_s);\n  height: 24px;\n  border: 1px solid var(--gray);\n  border-radius: 16px;\n\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  color: var(--tundora);\n  margin: var(--spacing_token_xxs) 0 var(--spacing_token_xs);\n  text-transform: uppercase;\n"])));
var templateObject_1$l, templateObject_2$j, templateObject_3$f, templateObject_4$e, templateObject_5$b, templateObject_6$a, templateObject_7$9, templateObject_8$7, templateObject_9$7;

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
const SvgScissor = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  d: "m14.477 10.15-.241-.921a.87.87 0 0 0-.231-.398.87.87 0 0 0-.399-.231l-8.35-1.928a2.605 2.605 0 0 0-.923-1.12c-.409-.28-.87-.424-1.299-.403-.428.021-.793.205-1.026.518-.232.312-.317.73-.238 1.178.079.447.316.891.668 1.25a2.45 2.45 0 0 0 1.24.695c.447.09.871.017 1.192-.206.32-.223.514-.58.547-1.005l1.683.397 1.345 5.785a.87.87 0 0 0 .231.398.87.87 0 0 0 .399.231l.919.243-1.19-5.674 5.673 1.191ZM2.99 7.577a1.314 1.314 0 0 1-.324-.523.923.923 0 0 1-.016-.545.66.66 0 0 1 .297-.384.798.798 0 0 1 .51-.093c.19.024.382.104.552.229.171.125.313.29.407.474.095.184.139.379.126.56a.707.707 0 0 1-.2.456c-.156.155-.386.224-.64.192a1.26 1.26 0 0 1-.712-.366ZM7.809 6.413l-.23-.996c.424-.033.782-.227 1.005-.547.223-.32.296-.744.206-1.192a2.45 2.45 0 0 0-.696-1.24 2.424 2.424 0 0 0-1.25-.668c-.446-.08-.865.006-1.177.239-.313.232-.497.597-.518 1.025-.021.428.122.89.403 1.3.28.409.679.737 1.12.923l.203.949.934.207ZM6.394 4.175a1.314 1.314 0 0 1-.324-.523.923.923 0 0 1-.016-.546.66.66 0 0 1 .297-.384.798.798 0 0 1 .51-.093c.19.024.381.104.552.23.17.124.312.29.407.473.095.184.138.379.125.56a.707.707 0 0 1-.199.456c-.156.155-.386.224-.64.19a1.258 1.258 0 0 1-.71-.365l-.002.002Z",
  fill: "#DC1125"
})));

styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n", "\nwidth: 194px;\nheight: 32px;\ndisplay: flex;\nbackground-color: var(--hint-of-red);\nmargin-top: 8px;\n\n:first-child {\n  margin-top: unset; \n}\n"], ["\n", "\nwidth: 194px;\nheight: 32px;\ndisplay: flex;\nbackground-color: var(--hint-of-red);\nmargin-top: 8px;\n\n:first-child {\n  margin-top: unset; \n}\n"])), Border1pxGray);
styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\nmargin-top: 8px;\nmargin-left: 12px;\ndisplay: flex;\nalign-items: flex-start;\nmin-width: 172px;\n"], ["\nmargin-top: 8px;\nmargin-left: 12px;\ndisplay: flex;\nalign-items: flex-start;\nmin-width: 172px;\n"])));
styled(SvgScissor)(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\nwidth: 16px;\nheight: 16px;\n"], ["\nwidth: 16px;\nheight: 16px;\n"])));
styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n", "\nmin-height: 16px;\nmargin-left: 5px;\nletter-spacing: 0;\nline-height: 16px;\n"], ["\n", "\nmin-height: 16px;\nmargin-left: 5px;\nletter-spacing: 0;\nline-height: 16px;\n"])), OpensansNormalTundora12px);
var templateObject_1$k, templateObject_2$i, templateObject_3$e, templateObject_4$d;

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  d: "m6.076 12.794-3.9-3.91a.602.602 0 0 1 0-.85l.848-.85a.599.599 0 0 1 .849 0L6.5 9.816l5.627-5.64a.6.6 0 0 1 .849 0l.848.85a.602.602 0 0 1 0 .85l-6.9 6.917a.599.599 0 0 1-.848 0Z",
  fill: "#DC1125"
})));

styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  min-width: 248px;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  min-width: 248px;\n  margin-top: 8px;\n"])));
styled(SvgCheckmark)(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n   flex: 0 0 1em;\n"], ["\n   flex: 0 0 1em;\n"])));
styled(SvgScissor)(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n   flex: 0 0 1em;\n"], ["\n   flex: 0 0 1em;\n"])));
styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  ", "\n  min-height: 16px;\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  min-height: 16px;\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
var templateObject_1$j, templateObject_2$h, templateObject_3$d, templateObject_4$c;

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgVifpOffersAndPromotions = function SvgVifpOffersAndPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.083 11.848V3.875C2.083 2.839 2.958 2 4.036 2h8.306c.518 0 1.015.198 1.381.55l8.621 8.276c.763.732.763 1.92 0 2.651l-8.305 7.974c-.763.732-2 .732-2.762 0l-8.622-8.277a1.838 1.838 0 0 1-.572-1.326ZM6.641 4.5c-1.08 0-1.954.84-1.954 1.875 0 1.036.875 1.875 1.954 1.875 1.078 0 1.953-.84 1.953-1.875 0-1.036-.875-1.875-1.953-1.875Z",
    fill: "#DC1125"
  })));
};

styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n"])));
styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
styled(SvgVifpOffersAndPromotions)(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  margin-left: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-16);\n  letter-spacing: 0;\n  line-height: 20px;\n"], ["\n  margin-left: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-16);\n  letter-spacing: 0;\n  line-height: 20px;\n"])));
styled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  ", "\n  line-height: 18px;\n"], ["\n  ", "\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xs);\n  & button {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"], ["\n  margin-top: var(--spacing_token_xs);\n  & button {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"])));
styled.div(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n"], ["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n"])));
styled.div(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansBoldTundora12px);
styled.div(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])));
styled.div(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n  flex-direction: column;\n"], ["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n  flex-direction: column;\n"])));
styled.div(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansBoldTundora12px);
styled.div(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  flex-direction: column;\n"], ["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  flex-direction: column;\n"])));
styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
styled.p(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
styled(PlainButton)(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n  width: 124px;\n  height: 16px;\n  margin-top: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: #10559a;\n  font-size: var(--font-size-12);\n  letter-spacing: 0.01px;\n  line-height: 16px;\n  text-decoration: underline;\n  white-space: nowrap;\n"], ["\n  width: 124px;\n  height: 16px;\n  margin-top: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: #10559a;\n  font-size: var(--font-size-12);\n  letter-spacing: 0.01px;\n  line-height: 16px;\n  text-decoration: underline;\n  white-space: nowrap;\n"])));
styled.div(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n"], ["\n  width: 24px;\n  height: 24px;\n"])));
styled.div(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"])));
styled.div(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"])));
styled.div(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"], ["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"])), TempostdHeavycondensedNormalToryBlu, styledBreakpoints.up("md"));
styled.p(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  flex: 0 0 60%;\n  display: flex;\n"], ["\n  flex: 0 0 60%;\n  display: flex;\n"])));
styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  display: flex;\n  margin-left: auto;\n"], ["\n  display: flex;\n  margin-left: auto;\n"])));
styled.button(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), PlainButtonStyle);
styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
var templateObject_1$i, templateObject_2$g, templateObject_3$c, templateObject_4$b, templateObject_5$a, templateObject_6$9, templateObject_7$8, templateObject_8$6, templateObject_9$6, templateObject_10$6, templateObject_11$3, templateObject_12$3, templateObject_13$2, templateObject_14$2, templateObject_15$2, templateObject_16$2, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27;

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgRedTag = function SvgRedTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.879V1.5A1.5 1.5 0 0 1 1.5 0h6.379a1.5 1.5 0 0 1 1.06.44l6.622 6.62a1.5 1.5 0 0 1 0 2.122l-6.379 6.379a1.5 1.5 0 0 1-2.121 0L.439 8.939A1.5 1.5 0 0 1 0 7.88ZM3.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#DC1125"
  })));
};

styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  ", "\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n  height: 30px;\n  display: flex;\n  padding: 6px 12px;\n  align-items: flex-start;\n  min-width: 88px;\n  white-space:'nowrap';\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  19px;\n  color:  var(--tundora);\n  background-color: var(--white); \n"], ["\n  ", "\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n  height: 30px;\n  display: flex;\n  padding: 6px 12px;\n  align-items: flex-start;\n  min-width: 88px;\n  white-space:'nowrap';\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  19px;\n  color:  var(--tundora);\n  background-color: var(--white); \n"])), Border1pxOutlineStructuresoutlineGr);
styled(SvgRedTag)(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  align-self: center;\n  margin-right: var(--spacing_token_xxs); \n\n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n"], ["\n  align-self: center;\n  margin-right: var(--spacing_token_xxs); \n\n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n"])), function (props) { return props.$iconColor; }, function (props) { return props.$iconColor; });
var templateObject_1$h, templateObject_2$f;

var _path$6, _path2$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgCircleHeartEmpty = function SvgCircleHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    fill: "#fff"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    className: "circle-heart-empty_svg__heart",
    d: "m28.441 21.566-7.545 7.801c-.494.51-1.302.51-1.796 0l-7.544-7.801c-2.189-2.265-2.068-6.01.36-8.11 2.12-1.835 5.364-1.505 7.315.51l.77.794.768-.794c1.951-2.014 5.196-2.345 7.316-.51 2.427 2.1 2.548 5.845.356 8.11Z",
    fill: "#fff",
    stroke: "#10559A",
    strokeWidth: 2
  })));
};

styled.button(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    margin-left: auto;\n    cursor: pointer;\n    background: none;\n    appearance: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    color: inherit;\n    overflow: visible;\n    \n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n"], ["\n    position: relative;\n    display: flex;\n    margin-left: auto;\n    cursor: pointer;\n    background: none;\n    appearance: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    color: inherit;\n    overflow: visible;\n    \n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n"])));
styled(SvgCircleHeartEmpty)(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  .circle-heart-empty_svg__heart {\n    stroke:", ";\n    fill: ", ";\n  }\n"], ["\n  .circle-heart-empty_svg__heart {\n    stroke:", ";\n    fill: ", ";\n  }\n"])), function (props) { return props.$isSaved && 'var(--tory-blue)'; }, function (props) { return props.$isSaved && 'var(--tory-blue)'; });
var templateObject_1$g, templateObject_2$e;

var ItineraryTitleFontSizeMap$1 = new Map([
    ['small', { sm: 'var(--font-size-16)', upSm: 'var(--font-size-16)' }],
    ['medium', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-20)' }],
    ['large', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-24)' }],
]);
var ItineraryTitleLineHeightMap$1 = new Map([
    ['small', { sm: '20px', upSm: '20px' }],
    ['medium', { sm: '22px', upSm: '24px' }],
    ['large', { sm: '18px', upSm: '28px' }],
]);
var EventFontSizeMap$1 = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var EventLineHeightMap$1 = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var ContentWrapperMinHeightMap$1 = new Map([
    ['small', 'auto'],
    ['medium', 'auto'],
    ['large', '68px'],
]);
var NonWrap$1 = Ae(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
styled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"], ["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"])), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return props.$nonWrapItineraryTitle && NonWrap$1; }, styledBreakpoints.up('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, styledBreakpoints.only('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = EventFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return EventLineHeightMap$1.get(props.$size); }, styledBreakpoints.up('sm'), function (props) { var _a; return (_a = EventFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"], ["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"])));
styled.div(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  min-height: ", " \n  "], ["\n  min-height: ", " \n  "])), function (props) { return ContentWrapperMinHeightMap$1.get(props.$size); });
var templateObject_1$f, templateObject_2$d, templateObject_3$b, templateObject_4$a, templateObject_5$9;

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.486 15.064C3.702 9.58 3 9.016 3 7a5 5 0 1 1 10 0c0 2.016-.702 2.579-4.486 8.064a.625.625 0 0 1-1.028 0ZM8 9.084a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.166Z",
    fill: "#464646"
  })));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgShip = function SvgShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.082 13.7c-.584 0-.837-.202-1.22-.508-.441-.353-.99-.792-2.032-.792-1.04 0-1.59.44-2.031.793-.382.305-.634.507-1.218.507-.583 0-.836-.202-1.217-.507-.441-.354-.99-.793-2.03-.793v1.3c.584 0 .836.202 1.217.507.442.354.99.793 2.03.793 1.04 0 1.589-.44 2.03-.792.383-.306.635-.508 1.22-.508.584 0 .851.213 1.22.508.441.353.99.792 2.031.792 1.04 0 1.59-.44 2.031-.792.369-.295.636-.508 1.221-.508v-1.3c-1.041 0-1.59.44-2.033.792-.382.306-.635.508-1.219.508ZM3.934 6.225l-1.3.325 1.3 5.2h.647c1.04 0 1.589-.44 2.03-.792.383-.306.635-.508 1.22-.508.584 0 .851.213 1.22.508.441.353.99.792 2.031.792h.652l.018-.07.203-.813 1.079-4.317-1.3-.325V3.951a.65.65 0 0 0-.523-.638l-2.727-.545V2h-1.3v.768l-2.727.545a.65.65 0 0 0-.523.638v2.274Zm1.3-1.743 2.6-.52 2.6.52V5.9l-2.6-.65-2.6.65V4.482Z",
    fill: "#464646"
  })));
};

var ItineraryTitleFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-16)', upSm: 'var(--font-size-16)' }],
    ['medium', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-20)' }],
    ['large', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-24)' }],
]);
var ItineraryTitleLineHeightMap = new Map([
    ['small', { sm: '20px', upSm: '20px' }],
    ['medium', { sm: '22px', upSm: '24px' }],
    ['large', { sm: '18px', upSm: '28px' }],
]);
var ShipNameFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var ShipNameLineHeightMap = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var EventFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var EventLineHeightMap = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var ContentWrapperMinHeightMap = new Map([
    ['small', 'auto'],
    ['medium', 'auto'],
    ['large', '68px'],
]);
var NonWrap = Ae(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-family-open_sans);\n"], ["\n  width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-family-open_sans);\n"])));
styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"], ["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"])), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return props.$nonWrapItineraryTitle && NonWrap; }, styledBreakpoints.up('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, styledBreakpoints.only('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return ShipNameLineHeightMap.get(props.$size); }, styledBreakpoints.up('sm'), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = EventFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return EventLineHeightMap.get(props.$size); }, styledBreakpoints.up('sm'), function (props) { var _a; return (_a = EventFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"], ["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"])));
styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  margin-top: var(--spacing_token_xs); \n"], ["\n  display: flex;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  margin-top: var(--spacing_token_xs); \n"])));
styled.div(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-self:center;\n\n  ", " {\n    flex-direction: row;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-self:center;\n\n  ", " {\n    flex-direction: row;\n  }\n"])), styledBreakpoints.up('lg'));
styled.div(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  position: relative;\n  color: var(--tundora);\n"], ["\n  position: relative;\n  color: var(--tundora);\n"])));
styled(SvgLocationPin)(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  "], ["\n  width: 16px;\n  height: 16px;\n  "])));
styled.div(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  font-weight: 700;\n  margin-top: var(--spacing_token_xxs);\n  \n  ", " {\n    border-left: 1px solid #cbc9c9;\n    padding-left: var(--spacing_token_xs);\n    margin-left: var(--spacing_token_xs);\n    margin-top: 0;\n  }\n  "], ["\n  font-weight: 700;\n  margin-top: var(--spacing_token_xxs);\n  \n  ", " {\n    border-left: 1px solid #cbc9c9;\n    padding-left: var(--spacing_token_xs);\n    margin-left: var(--spacing_token_xs);\n    margin-top: 0;\n  }\n  "])), styledBreakpoints.up('lg'));
styled.div(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: var(--spacing_token_xs);\n  margin-left: 64px;\n\n  ", " {\n    margin-top: var(--spacing_token_xxs);\n  }\n\n  ", " {\n    margin-left: 70px;\n  }\n  \n  a {\n    text-decoration: underline;\n    color: var(--tory-blue)\n  }\n"], ["\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: var(--spacing_token_xs);\n  margin-left: 64px;\n\n  ", " {\n    margin-top: var(--spacing_token_xxs);\n  }\n\n  ", " {\n    margin-left: 70px;\n  }\n  \n  a {\n    text-decoration: underline;\n    color: var(--tory-blue)\n  }\n"])), styledBreakpoints.up('md'), styledBreakpoints.up('lg'));
styled.span(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  font-family:  var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: #464646;\n  text-transform: uppercase;\n  padding-right: var(--spacing_token_xxs);\n  "], ["\n  font-family:  var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: #464646;\n  text-transform: uppercase;\n  padding-right: var(--spacing_token_xxs);\n  "])));
styled.span(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: var(--spacing_token_xxs);\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "], ["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: var(--spacing_token_xxs);\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "])));
styled(IconContainer)(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  margin-right: var(--spacing_token_xxs);\n  align-items: baseline;\n  "], ["\n  margin-right: var(--spacing_token_xxs);\n  align-items: baseline;\n  "])));
styled.div(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  min-height: ", " \n  "], ["\n  min-height: ", " \n  "])), function (props) { return ContentWrapperMinHeightMap.get(props.$size); });
styled(SvgShip)(templateObject_17$4 || (templateObject_17$4 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  "], ["\n  width: 16px;\n  height: 16px;\n  "])));
styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return ShipNameLineHeightMap.get(props.$size); }, styledBreakpoints.up('sm'), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  display: flex;\n  margin-top: var(--spacing_token_s); \n"], ["\n  display: flex;\n  margin-top: var(--spacing_token_s); \n"])));
styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: 20px;\n  padding-top: 4px;\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "], ["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: 20px;\n  padding-top: 4px;\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "])));
var templateObject_1$e, templateObject_2$c, templateObject_3$a, templateObject_4$9, templateObject_5$8, templateObject_6$8, templateObject_7$7, templateObject_8$5, templateObject_9$5, templateObject_10$5, templateObject_11$2, templateObject_12$2, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16$1, templateObject_17$4, templateObject_18, templateObject_19, templateObject_20;

var checkMarkStyles = Ae(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 3px;\n  height: 8px;\n  content: \"\";\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);  \n"], ["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 3px;\n  height: 8px;\n  content: \"\";\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);  \n"])));
var CheckboxContainer = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
var StyledCheckbox = styled.input(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 2px;\n  appearance: none;\n  vertical-align: middle;\n\n  ", "\n\n  ", "\n\n", "\n"], ["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 2px;\n  appearance: none;\n  vertical-align: middle;\n\n  ", "\n\n  ", "\n\n", "\n"])), function (props) { return props.checked ? 'var(--tory-blue)' : 'var(--white)'; }, function (props) { return props.checked ? 'none' : '1px solid var(--gray)'; }, function (props) {
    return !props.disabled && Ae(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "], ["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "])));
}, function (props) {
    return props.checked && (!props.disabled ? Ae(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"], ["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"])), checkMarkStyles) : Ae(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "], ["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "])), checkMarkStyles));
}, function (props) {
    return props.disabled && Ae(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject([" \n      background: var(--cararra);\n    "], [" \n      background: var(--cararra);\n    "])));
});
var templateObject_1$d, templateObject_2$b, templateObject_3$9, templateObject_4$8, templateObject_5$7, templateObject_6$7, templateObject_7$6;

React__default.forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: jsxRuntime.exports.jsx(CheckboxContainer, { children: jsxRuntime.exports.jsx(StyledCheckbox, __assign({ checked: props.isChecked, "aria-checked": props.isChecked, type: "checkbox", "aria-label": props.ariaLabel, "data-testid": props.testId, onChange: props.clickHandler, disabled: props.disabled, ref: ref }, props)) }) }));
});

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgDropdownChevron = function SvgDropdownChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.456 11.788 1.226 5.92a.695.695 0 0 1 0-1.025l.726-.684a.804.804 0 0 1 1.087-.001L8 8.861l4.961-4.65a.804.804 0 0 1 1.087.001l.727.684c.3.283.3.742 0 1.025l-6.23 5.867a.804.804 0 0 1-1.09 0Z",
    fill: "#10559A"
  })));
};

var SelectContainer = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var ErrorMessageContainer = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  color: var(--error--red);\n  padding: 0 8px;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  font-family: var(--font-family-open_sans);\n"], ["\n  color: var(--error--red);\n  padding: 0 8px;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  font-family: var(--font-family-open_sans);\n"])));
var Select$1 = styled.select(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject([" \n  ", "\n  ", "  \n  position: absolute;\n  top: 0;\n  color: var(--sonic-silver);\n  padding-top: ", ";\n  padding-left: var(--spacing_token_xs);\n  padding-right: var(--spacing_token_xs);\n  border-radius: var(--border-radius-m);\n  ", "\n  height: ", ";\n  font-weight: ", ";  \n  font-family: var(--font-family-open_sans);\n  &:focus-visible{\n    outline: 1px solid var(--black);\n  }\n  & option{\n    color: var(--dark-gray);\n  }\n  &:has(option:checked:not([value])),\n  &:has(option:checked:not([value=\"\"])) {\n    color: var(--dark-gray);\n  }\n\n  &:has(option:checked:not([value])) option,\n  &:has(option:checked:not([value=\"\"])) option {\n    color: var(--dark-gray);\n  }\n\n"], [" \n  ", "\n  ", "  \n  position: absolute;\n  top: 0;\n  color: var(--sonic-silver);\n  padding-top: ", ";\n  padding-left: var(--spacing_token_xs);\n  padding-right: var(--spacing_token_xs);\n  border-radius: var(--border-radius-m);\n  ", "\n  height: ", ";\n  font-weight: ", ";  \n  font-family: var(--font-family-open_sans);\n  &:focus-visible{\n    outline: 1px solid var(--black);\n  }\n  & option{\n    color: var(--dark-gray);\n  }\n  &:has(option:checked:not([value])),\n  &:has(option:checked:not([value=\"\"])) {\n    color: var(--dark-gray);\n  }\n\n  &:has(option:checked:not([value])) option,\n  &:has(option:checked:not([value=\"\"])) option {\n    color: var(--dark-gray);\n  }\n\n"])), CustomSelect, (function (props) { return !props.$shouldDisplaySecondLabel ? CustomColorErrorStyle$1 : ''; }), (function (props) { return props.$shouldDisplaySecondLabel ? 'var(--spacing_token_s)' : '0'; }), function (props) { return props.selectType === 'transparent' ? Transparent : ''; }, (function (props) { return props.selectSize === 'small' ? '26px' : '46px'; }), function (props) { return props.isOptionPlaceHolder || props.selectType === 'transparent' ? 400 : 600; });
var SelectWrapper$1 = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  ", "\n  ", "\n  border-radius: var(--border-radius-m);\n  width: 100%;\n  position: relative;\n  font-weight: 700;\n\n  height: ", ";\n  background-color: ", " ;\n    \n  svg{\n    path{\n      ", "\n      ", "\n    }\n  }\n"], ["\n  ", "\n  ", "\n  border-radius: var(--border-radius-m);\n  width: 100%;\n  position: relative;\n  font-weight: 700;\n\n  height: ", ";\n  background-color: ", " ;\n    \n  svg{\n    path{\n      ", "\n      ", "\n    }\n  }\n"])), function (props) { return props.selectType !== 'transparent' && Border1pxDimGray; }, CustomBorderErrorStyle$1, (function (props) { return props.selectSize === 'small' ? '28px' : '48px'; }), (function (props) { return props.selectType !== 'transparent' && props.$hasError ? 'var(--soft-pink)' : 'var(--white)'; }), (function (props) { return props.arrowColor === 'tundora' ? 'fill: var(--tundora);' : ''; }), (function (props) { return props.$hasError ? 'fill: var(--crimson);' : ''; }));
var SelectLabel = styled.label(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  ", "\n  ", "\n  position: relative;\n  display: flex;\n  margin: var(--spacing_token_xxs) var(--spacing_token_xs) 0 var(--spacing_token_xs);\n  line-height: 16px;\n"], ["\n  ", "\n  ", "\n  position: relative;\n  display: flex;\n  margin: var(--spacing_token_xxs) var(--spacing_token_xs) 0 var(--spacing_token_xs);\n  line-height: 16px;\n"])), OpensansNormalSonicSilver12px, CustomColorErrorStyle$1);
var Option = styled.option(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n"], ["\n  color: var(--sonic-silver);\n"])));
var OptionPlaceHolder = styled.option(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n ", "\n height: 48px;\n"], ["\n ", "\n height: 48px;\n"])), OpensansNormalSonicSilver14px);
var Transparent = Ae(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  border: none; \n  padding: 0 8px; \n  padding-top: ", ";\n"], ["\n  border: none; \n  padding: 0 8px; \n  padding-top: ", ";\n"])), (function (props) { return props.$shouldDisplaySecondLabel ? 'var(--spacing_token_s)' : '0'; }));
var ChevronIcon = styled(function (props) { return jsxRuntime.exports.jsx(SvgDropdownChevron, __assign({}, props)); })(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  position: absolute;\n  right: 7px;\n  top: ", ";\n  transform: ", ";\n  transition: transform .2s ease-in-out;\n"], ["\n  position: absolute;\n  right: 7px;\n  top: ", ";\n  transform: ", ";\n  transition: transform .2s ease-in-out;\n"])), function (props) { return props.$selectSize === 'small' ? "6px" : '16px'; }, function (props) { return props.$isExpanded ? "rotate(180deg)" : ''; });
var InfoIcon$1 = styled(SvgInfoCircle$1)(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n    height: 16px;\n    margin-right: 4px;\n    min-width: 16px;\n    path{\n        fill: var(--error--red);\n    }\n"], ["\n    height: 16px;\n    margin-right: 4px;\n    min-width: 16px;\n    path{\n        fill: var(--error--red);\n    }\n"])));
var templateObject_1$c, templateObject_2$a, templateObject_3$8, templateObject_4$7, templateObject_5$6, templateObject_6$6, templateObject_7$5, templateObject_8$4, templateObject_9$4, templateObject_10$4;

var Select = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e;
    var _f = __read(React__default.useState(!props.value), 2), isOptionPlaceHolder = _f[0], setIsOptionPlaceHolder = _f[1];
    var _g = __read(React__default.useState(false), 2), isExpanded = _g[0], setIsExpanded = _g[1];
    var placeHolderLabel = props.placeHolderLabel ? props.placeHolderLabel : 'Select';
    var _h = __read(React__default.useState(props.value !== undefined && props.value != null && props.value !== placeHolderLabel && props.selectSize !== 'small'), 2), shouldDisplaySecondLabel = _h[0], setShouldDisplaySecondLabel = _h[1];
    useEffect$1(function () {
        if (props.value && props.value !== props.placeHolderLabel) {
            if (props.selectSize !== 'small') {
                setShouldDisplaySecondLabel(true);
            }
            setIsOptionPlaceHolder(false);
        }
        else if (!props.value || props.value === props.placeHolderLabel) {
            if (props.selectSize !== 'small') {
                setShouldDisplaySecondLabel(false);
            }
            setIsOptionPlaceHolder(true);
        }
    }, [props.value, props.placeHolderLabel, props.selectSize]);
    function handleOnChange(option) {
        if (!option.target.value) {
            setIsOptionPlaceHolder(true);
            if (props.selectSize !== 'small') {
                setShouldDisplaySecondLabel(false);
            }
        }
        else {
            setIsOptionPlaceHolder(false);
            if (props.selectSize !== 'small') {
                setShouldDisplaySecondLabel(true);
            }
        }
        props.onChange(option);
    }
    return (jsxRuntime.exports.jsxs(SelectContainer, __assign({ className: props.className }, { children: [jsxRuntime.exports.jsxs(SelectWrapper$1, __assign({ "$hasError": (_a = props.hasError) !== null && _a !== void 0 ? _a : false, "$isExpanded": isExpanded, selectType: props.selectType, arrowColor: props.arrowColor, selectSize: props.selectSize }, { children: [shouldDisplaySecondLabel &&
                        jsxRuntime.exports.jsx(SelectLabel, __assign({ "$hasError": (_b = props.hasError) !== null && _b !== void 0 ? _b : false, htmlFor: props.id }, { children: placeHolderLabel })), jsxRuntime.exports.jsx(ChevronIcon, { "$isExpanded": isExpanded, "$selectSize": props.selectSize, "aria-hidden": "true" }), jsxRuntime.exports.jsxs(Select$1, __assign({ name: props.name, "$hasError": (_c = props.hasError) !== null && _c !== void 0 ? _c : false, onChange: handleOnChange, isOptionPlaceHolder: isOptionPlaceHolder, id: props.id, ref: ref, disabled: props.disabled, "$isExpanded": isExpanded, onClick: function () { return setIsExpanded(!isExpanded); }, onBlur: function () { return setIsExpanded(false); }, "data-testid": props.testId, "aria-label": props.ariaLabel, "aria-describedby": props.ariaDescribedBy, value: props.value, selectType: (_d = props.selectType) !== null && _d !== void 0 ? _d : 'outline', selectSize: props.selectSize, "aria-required": props.required, "$shouldDisplaySecondLabel": shouldDisplaySecondLabel }, { children: [!props.disablePlaceHolder &&
                                jsxRuntime.exports.jsx(OptionPlaceHolder, __assign({ value: '' }, { children: placeHolderLabel }), "".concat(props.id, "Select")), props.optionsList &&
                                props.optionsList.map(function (s) { return (jsxRuntime.exports.jsx(Option, __assign({ value: s.value, "data-testid": s.optionTestId }, { children: s.label }), "".concat(props.id).concat(s.value))); })] }))] })), props.hasError && !props.hideErrorMessage && jsxRuntime.exports.jsxs(ErrorMessageContainer, __assign({ role: 'alert', "data-testid": props.errorTestId }, (props.errorAriaLabel && { "aria-label": props.errorAriaLabel }), { children: [jsxRuntime.exports.jsx(InfoIcon$1, { "aria-hidden": "true" }), (_e = props.errorMsg) !== null && _e !== void 0 ? _e : 'Field invalid'] }))] })));
});

styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    margin-top: var(--spacing_token_s);\n    margin-left: var(--spacing_token_s);\n    display: inline-grid;\n    grid-template-columns: auto auto;\n    column-gap : 20px;\n    row-gap: 10px;\n\n"], ["\n    margin-top: var(--spacing_token_s);\n    margin-left: var(--spacing_token_s);\n    display: inline-grid;\n    grid-template-columns: auto auto;\n    column-gap : 20px;\n    row-gap: 10px;\n\n"])));
styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n    grid-column: span 2;\n"], ["\n    grid-column: span 2;\n"])));
styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n    grid-column: span 2;\n    text-align: center;\n"], ["\n    grid-column: span 2;\n    text-align: center;\n"])));
var templateObject_1$b, templateObject_2$9, templateObject_3$7, templateObject_4$6;

var monthByNumber = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December'
};
var daysByMonth = {
    0: 31,
    1: 29,
    2: 31,
    3: 30,
    4: 31,
    5: 30,
    6: 31,
    7: 31,
    8: 30,
    9: 31,
    10: 30,
    11: 31
};
var daysByMonthNonZeroIndexFormat = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
};
function populateYearOptions(start, end, reverse) {
    var startYear = start || 1900;
    var endYear = end || new Date().getFullYear();
    var yearOptions = [];
    if (startYear <= endYear) {
        for (var year = startYear; year <= endYear; ++year) {
            yearOptions.push({ value: year.toString(), label: year.toString(), optionTestId: '' });
        }
    }
    else {
        for (var year = endYear; year >= startYear; --year) {
            yearOptions.push({ value: year.toString(), label: year.toString(), optionTestId: '' });
        }
    }
    if (reverse) {
        yearOptions.reverse();
    }
    return yearOptions;
}
function populateMonthOptions(year, useNonZeroIndexMonthValues) {
    var today = new Date();
    var months = [];
    var currentMonth = 11;
    var monthOptions = [];
    if (+year === today.getFullYear()) {
        currentMonth = today.getMonth();
    }
    for (var month = 0; month <= currentMonth; ++month) {
        months.push(monthByNumber[month]);
    }
    months.forEach(function (month, index) {
        monthOptions.push({ value: (useNonZeroIndexMonthValues ? index + 1 : index).toString(), label: month, optionTestId: '' });
    });
    return monthOptions;
}
function populateDayOptions(month, year, usingNonZeroIndexMonthValues) {
    var days = usingNonZeroIndexMonthValues ? daysByMonthNonZeroIndexFormat[+month] : daysByMonth[+month];
    var today = new Date();
    var dayOptions = [];
    if (isNaN(days))
        days = 31;
    if (+year === today.getFullYear() && +month === today.getMonth()) {
        days = today.getDate();
    }
    for (var day = 1; day <= days; ++day) {
        dayOptions.push({ value: day.toString(), label: day.toString(), optionTestId: '' });
    }
    return dayOptions;
}

var YearSelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateYearOptions(props.start, props.end, props.reverse) })));
});

var MonthSelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateMonthOptions(props.year, props.useNonZeroIndexMonthValues) })));
});

var DaySelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateDayOptions(props.month, props.year, props.usingNonZeroIndexMonthValues) })));
});

var ErrorLabel$2 = styled.span(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), Error$1);
var templateObject_1$a;

var StateSelect = forwardRef(function (props, ref) {
    var _a = __read(useState$1(null), 2), states = _a[0], setStates = _a[1];
    var _b = __read(useState$1(null), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var mapAdditionalDataToOptionsList = function (states) {
        return states === null ? [] :
            states.map(function (option) {
                return {
                    value: option.code,
                    label: option.name,
                    optionTestId: ''
                };
            });
    };
    useEffect$1(function () {
        var getStatesData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, StatesService.getStates()
                            .then(function (statesResponse) {
                            setStates(statesResponse.states);
                        })
                            .catch(function () {
                            setErrorMessage(props.errorMessageLabel);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        getStatesData();
    }, [props.errorMessageLabel]);
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(Select, __assign({}, props, { optionsList: mapAdditionalDataToOptionsList(states), ref: ref })), errorMessage && jsxRuntime.exports.jsxs(ErrorLabel$2, __assign({ role: "alert", "data-testid": 'StateApiErrorMessage' }, { children: ["Error: ", errorMessage] }))] }));
});

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgCloseModalIcon = function SvgCloseModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.57 12 8.079-8.079a1.198 1.198 0 0 0 0-1.693L21.77.35a1.198 1.198 0 0 0-1.693 0L12 8.43 3.92.351a1.198 1.198 0 0 0-1.693 0L.35 2.228a1.198 1.198 0 0 0 0 1.693L8.43 12 .35 20.079a1.198 1.198 0 0 0 0 1.693l1.878 1.878a1.198 1.198 0 0 0 1.693 0L12 15.57l8.079 8.079a1.198 1.198 0 0 0 1.693 0l1.878-1.877a1.198 1.198 0 0 0 0-1.694L15.57 12Z",
    fill: "#10559A"
  })));
};

$e(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  // Overlay\n  .", " > div {\n    position: absolute !important;\n    background-color: rgba(0, 0, 0, 0.6) !important;\n    z-index: 1001;\n    display: ", ";\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 16px\n    justify-content: flex-end;\n    height: ", ";\n    left: 0;\n    top: ", ";\n  \n    ", " {\n      height: ", ";\n    }\n\n    ", " {\n      grid-template-columns: repeat(12, 1fr);\n    }\n\n    @media (max-height : 400px) and (orientation : landscape) {\n      top: 0;\n      z-index: 1010;\n      height: 100vh;\n      position: fixed;\n    }\n  }\n\n  // Content\n  .", " *:not(:first-child):focus {\n    outline-color: var(--bondi-blue);\n  }\n  // Content\n  .", " {\n    &:first-of-type:focus,\n    &:first-of-type:focus-visible {\n      outline: 0px; \n    }\n\n    width: 100%;\n    max-width: 688px;\n    inset: auto !important;\n    background-color: var(--white);\n    font-family: var(--font-family-open_sans);\n    color: var(--tundora);\n    padding: var(--spacing_token_s);\n    overflow-y: auto;\n    margin-top: 0;\n    margin-bottom: 50px;\n    justify-self: end;\n    \n    ", " {\n      grid-column: 3 / 8 !important;\n      padding: var(--spacing_token_m);\n      width: 558px;\n    }\n    ", " {\n      grid-column: 7 / auto !important;\n      width: 484px;\n    }\n    ", " {\n      margin-bottom: 66px;\n      width: 588px;\n    }\n    ", " {\n      width: 688px;\n    }\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n"], ["\n  // Overlay\n  .", " > div {\n    position: absolute !important;\n    background-color: rgba(0, 0, 0, 0.6) !important;\n    z-index: 1001;\n    display: ", ";\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 16px\n    justify-content: flex-end;\n    height: ", ";\n    left: 0;\n    top: ", ";\n  \n    ", " {\n      height: ", ";\n    }\n\n    ", " {\n      grid-template-columns: repeat(12, 1fr);\n    }\n\n    @media (max-height : 400px) and (orientation : landscape) {\n      top: 0;\n      z-index: 1010;\n      height: 100vh;\n      position: fixed;\n    }\n  }\n\n  // Content\n  .", " *:not(:first-child):focus {\n    outline-color: var(--bondi-blue);\n  }\n  // Content\n  .", " {\n    &:first-of-type:focus,\n    &:first-of-type:focus-visible {\n      outline: 0px; \n    }\n\n    width: 100%;\n    max-width: 688px;\n    inset: auto !important;\n    background-color: var(--white);\n    font-family: var(--font-family-open_sans);\n    color: var(--tundora);\n    padding: var(--spacing_token_s);\n    overflow-y: auto;\n    margin-top: 0;\n    margin-bottom: 50px;\n    justify-self: end;\n    \n    ", " {\n      grid-column: 3 / 8 !important;\n      padding: var(--spacing_token_m);\n      width: 558px;\n    }\n    ", " {\n      grid-column: 7 / auto !important;\n      width: 484px;\n    }\n    ", " {\n      margin-bottom: 66px;\n      width: 588px;\n    }\n    ", " {\n      width: 688px;\n    }\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n"])), function (props) { return props.$modalClassName; }, function () { return ("grid" ); }, function (props) { return ("calc(100vh - ".concat(props.$diffHeaderHeight, "px) !important")); }, function (props) { return ("".concat(props.$diffTopHeight, "px !important")); }, styledBreakpoints.up("md"), function (props) { return ("calc(100vh - ".concat(props.$diffHeaderHeight, "px) !important")); }, styledBreakpoints.up("lg"), function (props) { return props.$contentClassName; }, function (props) { return props.$contentClassName; }, styledBreakpoints.up("md"), styledBreakpoints.up("lg"), styledBreakpoints.up("xl"), styledBreakpoints.up("xxl"));
styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  color: var(--tundora);\n"], ["\n  color: var(--tundora);\n"])));
styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject([""], [""])));
styled.button(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  display: flex;\n  ", " \n"], ["\n  display: flex;\n  ", " \n"])), PlainButtonStyle);
styled(SvgCloseModalIcon)(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  ", " {\n    width: 16px;\n    height: 16px;\n  }\n"], ["\n  width: 24px;\n  height: 24px;\n  ", " {\n    width: 16px;\n    height: 16px;\n  }\n"])), styledBreakpoints.down("sm"));
styled.div(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n"])));
styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  width: 100%;\n  padding-bottom: 72px\n"], ["\n  width: 100%;\n  padding-bottom: 72px\n"])));
styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n"], ["\n"])));
var templateObject_1$9, templateObject_2$8, templateObject_3$6, templateObject_4$5, templateObject_5$5, templateObject_6$5, templateObject_7$4, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$1, templateObject_12$1;

styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  padding-top: var(--spacing_token_m);\n"], ["\n  padding-top: var(--spacing_token_m);\n"])));
styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: var(--spacing_token_xs);\n"], ["\n  display: flex;\n  margin-bottom: var(--spacing_token_xs);\n"])));
styled.h3(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  margin-right: var(--spacing_token_xxs);\n  margin-bottom: var(--spacing_token_xs);\n  ", "\n  line-height: 20px;\n  font-weight: 700;\n"], ["\n  margin-right: var(--spacing_token_xxs);\n  margin-bottom: var(--spacing_token_xs);\n  ", "\n  line-height: 20px;\n  font-weight: 700;\n"])), OpensansNormalTundora16px);
styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--spacing_token_xs);\n  padding: 0px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--spacing_token_xs);\n  padding: 0px;\n"])));
styled.img(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  border-radius: 8px;\n"], ["\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  border-radius: 8px;\n"])));
styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  ", "\n  line-height: 20px;\n  margin-top: 16px;\n  ul { \n    margin-bottom: 8px;\n    position: relative;\n    margin-left: 5%;\n    list-style-type: disc; \n  }\n  li { \n    margin-bottom: 8px;\n  }  \n  & > ul > li { \n    margin-bottom: 8px;\n  }  \n"], ["\n  ", "\n  line-height: 20px;\n  margin-top: 16px;\n  ul { \n    margin-bottom: 8px;\n    position: relative;\n    margin-left: 5%;\n    list-style-type: disc; \n  }\n  li { \n    margin-bottom: 8px;\n  }  \n  & > ul > li { \n    margin-bottom: 8px;\n  }  \n"])), OpensansNormalTundora14px);
var templateObject_1$8, templateObject_2$7, templateObject_3$5, templateObject_4$4, templateObject_5$4, templateObject_6$4;

var _path$1$1, _path2, _path3;
function _extends$1$1() { _extends$1$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$1.apply(this, arguments); }
const SvgRibbon = props => /*#__PURE__*/React.createElement("svg", _extends$1$1({
  width: 72,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path$1$1 || (_path$1$1 = /*#__PURE__*/React.createElement("path", {
  d: "M4 16H0l4-8-4-8h4v16ZM4 0h64v16H4z",
  fill: "#2E850F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.716 4.68v2.016c.72 0 1.236-.264 1.236-1.032 0-.72-.516-.984-1.236-.984Zm-1.8 7.32V3.144h2.304c1.788 0 2.604.9 2.604 2.196 0 1.08-.48 1.86-1.488 2.076v.024c1.056.144 1.62.936 1.62 2.064 0 .972-.612 2.496-2.424 2.496h-2.616Zm1.8-3.864v2.208c.804 0 1.272-.24 1.272-1.104 0-.864-.468-1.104-1.272-1.104ZM18.693 12V3.144h3.792V4.8h-1.92v1.872h1.644v1.656h-1.644v2.016h2.004V12h-3.876Zm4.46-.3V9.84c.312.312.768.528 1.212.528.636 0 1.116-.408 1.116-.864 0-1.32-2.532-1.8-2.532-3.936 0-1.464.972-2.544 2.46-2.544.456 0 1.032.12 1.524.36v1.812c-.36-.228-.852-.42-1.2-.42-.444 0-.816.168-.816.756 0 1.08 2.58 1.512 2.58 3.972 0 1.716-1.152 2.616-2.808 2.616-.576 0-1.056-.108-1.536-.42Zm9.015-6.9h-1.224V12h-1.872V4.8h-1.224V3.144h4.32V4.8Zm5.507 0v2.808h.204c.732 0 1.152-.504 1.152-1.404 0-.9-.42-1.404-1.152-1.404h-.204Zm0 7.2h-1.872V3.144h2.232c2.04 0 2.916 1.14 2.916 3.06 0 2.052-1.164 3.06-2.988 3.06h-.288V12Zm6 0h-1.872V3.144h2.52c1.68 0 2.544.984 2.544 2.604 0 1.356-.528 2.004-1.356 2.256L47.047 12h-1.992l-1.356-3.888h-.024V12Zm0-7.2v2.352c.792 0 1.272-.324 1.272-1.176 0-.852-.48-1.176-1.272-1.176ZM49.5 12h-1.872V3.144H49.5V12Zm5.277-2.04v1.992c-.384.12-.612.168-1.044.168-1.908 0-3.312-1.824-3.312-4.548s1.404-4.548 3.312-4.548c.432 0 .66.048 1.044.168v1.992a1.12 1.12 0 0 0-.876-.408c-1.068 0-1.512 1.284-1.512 2.796 0 1.512.444 2.796 1.512 2.796.324 0 .624-.12.876-.408Zm.795 2.04V3.144h3.792V4.8h-1.92v1.872h1.644v1.656h-1.644v2.016h2.004V12h-3.876Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M68 0h4l-4 8 4 8h-4V0Z",
  fill: "#2E850F"
})));

styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n\tdisplay: flex;\n\tpadding: 16px;\n\tmargin: 8px auto;\n\talign-items: flex-start;\n\tgap: 10px;\n\talign-self: stretch;\n\tborder-radius: var(--border-radius-s);\n\tborder: 1px solid var(--gray);\n\tbackground: var(--white);\n"], ["\n\tdisplay: flex;\n\tpadding: 16px;\n\tmargin: 8px auto;\n\talign-items: flex-start;\n\tgap: 10px;\n\talign-self: stretch;\n\tborder-radius: var(--border-radius-s);\n\tborder: 1px solid var(--gray);\n\tbackground: var(--white);\n"])));
styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tflex: 1 0 0;\t\n\t", " {\n\t\tgap: 16px;\n\t\tjustify-content: center;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tflex: 1 0 0;\t\n\t", " {\n\t\tgap: 16px;\n\t\tjustify-content: center;\n\t}\n"])), styledBreakpoints.up('xl'));
styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: flex-end;\n\tgap: 16px;\n\tflex: 1 0 0;\n\t", " {\n\t\tflex-direction: column;\n\t\tjustify-content: flex-end;\n\t\talign-items: flex-start;\n\t\tgap: 8px;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: flex-end;\n\tgap: 16px;\n\tflex: 1 0 0;\n\t", " {\n\t\tflex-direction: column;\n\t\tjustify-content: flex-end;\n\t\talign-items: flex-start;\n\t\tgap: 8px;\n\t}\n"])), styledBreakpoints.down('lg'));
styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 2px;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 2px;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"])), styledBreakpoints.down('lg'));
styled(SvgRibbon)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n\twidth: 72px;\n\theight: 16px;\n"], ["\n\twidth: 72px;\n\theight: 16px;\n"])));
styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n\t", ";\n\ttext-align: center;\n\tline-height: 16px;\n"], ["\n\t", ";\n\ttext-align: center;\n\tline-height: 16px;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n\t", ";\n\ttext-align: center;\n\tline-height: 18px;\n"], ["\n\t", ";\n\ttext-align: center;\n\tline-height: 18px;\n"])), OpensansBoldTundora14px);
styled.a(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n\tcursor: pointer;\n\ttext-decoration: none;\n\t", ";\n\tline-height: 18px;\n\tletter-spacing: 0.014px;\n"], ["\n\tcursor: pointer;\n\ttext-decoration: none;\n\t", ";\n\tline-height: 18px;\n\tletter-spacing: 0.014px;\n"])), OpensansBoldToryBlue14px);
styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tgap: 4px;\n\t", " {\n\t\twidth: 120px;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tgap: 4px;\n\t", " {\n\t\twidth: 120px;\n\t}\n"])), styledBreakpoints.down('lg'));
styled.div(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: flex-start;\n"], ["\n\tdisplay: flex;\n\talign-items: flex-start;\n"])));
styled.div(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n\t", ";\n\tline-height: 16px;\n\tmargin-right: 8px;\n"], ["\n\t", ";\n\tline-height: 16px;\n\tmargin-right: 8px;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n\t", ";\n\tline-height: 20px;\n"], ["\n\t", ";\n\tline-height: 20px;\n"])), OpensansBoldTundora16px);
styled.div(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["\n\t", ";\n\tline-height: 36px;\n"], ["\n\t", ";\n\tline-height: 36px;\n"])), OpensansBoldTundora32px);
styled.div(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject(["\n\t", ";\n\tline-height: 16px;\n"], ["\n\t", ";\n\tline-height: 16px;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"])), styledBreakpoints.down('lg'));
styled.div(templateObject_16$5 || (templateObject_16$5 = __makeTemplateObject(["\n\t", ";\n\ttext-align: right;\n\tline-height: 16px;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"], ["\n\t", ";\n\ttext-align: right;\n\tline-height: 16px;\n\t", " {\n\t\talign-self: stretch;\n\t}\n"])), OpensansNormalTundora12px, styledBreakpoints.down('lg'));
var templateObject_1$7, templateObject_2$6, templateObject_3$4, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$6, templateObject_12$6, templateObject_13$5, templateObject_14$5, templateObject_15$5, templateObject_16$5;

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$1));

moment$1.exports;

styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n\tdisplay: flex;\n\tpadding: 8px 24px;\n\tmargin: 24px -24px;\n\talign-items: flex-start;\n\tgap: 8px;\n\talign-self: stretch;\n\tbackground: var(--hint-of-red);\n"], ["\n\tdisplay: flex;\n\tpadding: 8px 24px;\n\tmargin: 24px -24px;\n\talign-items: flex-start;\n\tgap: 8px;\n\talign-self: stretch;\n\tbackground: var(--hint-of-red);\n"])));
styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n\ttext-align: right;\n\tline-height: 18px; \n\t", ";\n"], ["\n\ttext-align: right;\n\tline-height: 18px; \n\t", ";\n"])), OpensansBoldTundora14px);
var templateObject_1$6, templateObject_2$5;

var spin = We(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n0%  { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n"], ["\n0%  { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n"])));
styled.div.attrs(function (props) { return props; })(templateObject_2$4$1 || (templateObject_2$4$1 = __makeTemplateObject(["\n  border: .25em solid var(--", ");\n  border-top: .25em solid transparent;\n  border-radius: 50%;\n  width: ", "rem;\n  height: ", "rem;\n  animation: ", " 1s linear infinite;\n"], ["\n  border: .25em solid var(--", ");\n  border-top: .25em solid transparent;\n  border-radius: 50%;\n  width: ", "rem;\n  height: ", "rem;\n  animation: ", " 1s linear infinite;\n"])), function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : 'tundora'; }, function (props) { return props.radius; }, function (props) { return props.radius; }, spin);
var templateObject_1$5, templateObject_2$4$1;

var radioButtonStyles = Ae(templateObject_1$4$1 || (templateObject_1$4$1 = __makeTemplateObject(["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 5px;\n  height: 10px;\n  content: \"\";\n  border-width: 0 1.8px 1.8px 0;\n  -webkit-transform: rotate(45deg);\n"], ["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 5px;\n  height: 10px;\n  content: \"\";\n  border-width: 0 1.8px 1.8px 0;\n  -webkit-transform: rotate(45deg);\n"])));
styled.div(templateObject_2$3$1 || (templateObject_2$3$1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
styled.input(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 50%;\n  appearance: none;\n\n  ", "\n\n  ", "\n\n", "\n"], ["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 50%;\n  appearance: none;\n\n  ", "\n\n  ", "\n\n", "\n"])), function (props) { return props.checked ? 'var(--tory-blue)' : 'var(--white)'; }, function (props) { return props.checked ? 'none' : '1px solid var(--gray)'; }, function (props) {
    return !props.disabled && Ae(templateObject_3$3$1 || (templateObject_3$3$1 = __makeTemplateObject(["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "], ["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "])));
}, function (props) {
    return props.checked && (!props.disabled ? Ae(templateObject_4$2$1 || (templateObject_4$2$1 = __makeTemplateObject(["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"], ["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"])), radioButtonStyles) : Ae(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "], ["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "])), radioButtonStyles));
}, function (props) {
    return props.disabled && Ae(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject([" \n      background: var(--cararra);\n    "], [" \n      background: var(--cararra);\n    "])));
});
var templateObject_1$4$1, templateObject_2$3$1, templateObject_3$3$1, templateObject_4$2$1, templateObject_5$2, templateObject_6$2, templateObject_7$2;

$e(templateObject_1$3$1 || (templateObject_1$3$1 = __makeTemplateObject(["\n  .be-ada-global-outline {\n    a:focus,\n    input:focus,\n    button:focus,\n    select:focus,\n    object:focus,\n    [tabindex]:focus {\n      outline: 3px solid var(--bondi-blue);\n      outline-offset: 0;\n    };\n  };\n"], ["\n  .be-ada-global-outline {\n    a:focus,\n    input:focus,\n    button:focus,\n    select:focus,\n    object:focus,\n    [tabindex]:focus {\n      outline: 3px solid var(--bondi-blue);\n      outline-offset: 0;\n    };\n  };\n"])));
var templateObject_1$3$1;

var KEY_CODES;
(function (KEY_CODES) {
    KEY_CODES["Tab"] = "Tab";
})(KEY_CODES || (KEY_CODES = {}));

var _path$h;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgChevronCaretsRigth = function SvgChevronCaretsRigth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 13,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "m12.093 11.03-9.11 9.11c-.44.44-1.152.44-1.591 0L.33 19.078a1.125 1.125 0 0 1-.002-1.59l7.22-7.253L.327 2.98A1.125 1.125 0 0 1 .33 1.392L1.392.33c.44-.44 1.152-.44 1.591 0l9.11 9.11c.44.439.44 1.151 0 1.59Z",
    fill: "#10559A"
  })));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n";
styleInject(css_248z$1);

var css_248z = "@charset 'UTF-8';\n/* Slider */\n.slick-loading .slick-list\n{\n    background: #fff url('./ajax-loader.gif') center center no-repeat;\n}\n\n/* Icons */\n@font-face\n{\n    font-family: 'slick';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('./fonts/slick.eot');\n    src: url('./fonts/slick.eot?#iefix') format('embedded-opentype'), url('./fonts/slick.woff') format('woff'), url('./fonts/slick.ttf') format('truetype'), url('./fonts/slick.svg#slick') format('svg');\n}\n/* Arrows */\n.slick-prev,\n.slick-next\n{\n    font-size: 0;\n    line-height: 0;\n\n    position: absolute;\n    top: 50%;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n\n    cursor: pointer;\n\n    color: transparent;\n    border: none;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover,\n.slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus\n{\n    color: transparent;\n    outline: none;\n    background: transparent;\n}\n.slick-prev:hover:before,\n.slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before\n{\n    opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before\n{\n    opacity: .25;\n}\n\n.slick-prev:before,\n.slick-next:before\n{\n    font-family: 'slick';\n    font-size: 20px;\n    line-height: 1;\n\n    opacity: .75;\n    color: white;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-prev\n{\n    left: -25px;\n}\n[dir='rtl'] .slick-prev\n{\n    right: -25px;\n    left: auto;\n}\n.slick-prev:before\n{\n    content: '←';\n}\n[dir='rtl'] .slick-prev:before\n{\n    content: '→';\n}\n\n.slick-next\n{\n    right: -25px;\n}\n[dir='rtl'] .slick-next\n{\n    right: auto;\n    left: -25px;\n}\n.slick-next:before\n{\n    content: '→';\n}\n[dir='rtl'] .slick-next:before\n{\n    content: '←';\n}\n\n/* Dots */\n.slick-dotted.slick-slider\n{\n    margin-bottom: 30px;\n}\n\n.slick-dots\n{\n    position: absolute;\n    bottom: -25px;\n\n    display: block;\n\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    list-style: none;\n\n    text-align: center;\n}\n.slick-dots li\n{\n    position: relative;\n\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n    padding: 0;\n\n    cursor: pointer;\n}\n.slick-dots li button\n{\n    font-size: 0;\n    line-height: 0;\n\n    display: block;\n\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n\n    cursor: pointer;\n\n    color: transparent;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.slick-dots li button:hover,\n.slick-dots li button:focus\n{\n    outline: none;\n}\n.slick-dots li button:hover:before,\n.slick-dots li button:focus:before\n{\n    opacity: 1;\n}\n.slick-dots li button:before\n{\n    font-family: 'slick';\n    font-size: 6px;\n    line-height: 20px;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 20px;\n    height: 20px;\n\n    content: '•';\n    text-align: center;\n\n    opacity: .25;\n    color: black;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before\n{\n    opacity: .75;\n    color: black;\n}\n";
styleInject(css_248z);

styled(SvgChevronCaretsRigth)(templateObject_1$2$1 || (templateObject_1$2$1 = __makeTemplateObject(["\n    transform: ", ";\n"], ["\n    transform: ", ";\n"])), function (props) { return props.$updateDirection && "rotate(-180deg)"; });
styled.button(templateObject_3$2$1 || (templateObject_3$2$1 = __makeTemplateObject(["\n  &.slick-prev,\n  &.slick-next {\n    position: absolute;\n    display: block;\n    height: 40px;\n    width: 40px;\n    ", "\n    line-height: 0px;\n    font-size: 0px;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    z-index: 100;\n    &:hover,\n    &:focus {\n      background: transparent;\n      color: transparent;\n      &:before {\n        opacity: $slick-opacity-on-hover;\n      }\n    }\n    &.slick-disabled {\n      display: none;\n    }\n    &:before {\n      display: none;\n      font-family: $slick-font-family;\n      font-size: 20px;\n      line-height: 1;\n      color: $slick-arrow-color;\n      opacity: $slick-opacity-default;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }  \n\n  &.slick-prev {\n    left: ", ";\n    ", " {\n      left: ", ";\n    }\n    [dir='rtl'] & {\n      left: auto;\n      right: 16px;\n      ", " {\n        right: 24px;\n      }\n    }\n    &:before {\n    display: none;\n      content: $slick-prev-character;\n      [dir='rtl'] & {\n        content: $slick-next-character;\n      }\n    }\n  }\n\n  &.slick-next {\n    right: ", ";\n    ", " {\n      right: ", ";\n    }\n    [dir='rtl'] & {\n      left: 16px;\n      right: auto;\n      ", " {\n        left: 24px;\n      }\n    }\n    &:before {\n      display: none;\n      content: $slick-next-character;\n      [dir='rtl'] & {\n        content: $slick-prev-character;\n      }\n    }\n  }\n"], ["\n  &.slick-prev,\n  &.slick-next {\n    position: absolute;\n    display: block;\n    height: 40px;\n    width: 40px;\n    ", "\n    line-height: 0px;\n    font-size: 0px;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    z-index: 100;\n    &:hover,\n    &:focus {\n      background: transparent;\n      color: transparent;\n      &:before {\n        opacity: $slick-opacity-on-hover;\n      }\n    }\n    &.slick-disabled {\n      display: none;\n    }\n    &:before {\n      display: none;\n      font-family: $slick-font-family;\n      font-size: 20px;\n      line-height: 1;\n      color: $slick-arrow-color;\n      opacity: $slick-opacity-default;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }  \n\n  &.slick-prev {\n    left: ", ";\n    ", " {\n      left: ", ";\n    }\n    [dir='rtl'] & {\n      left: auto;\n      right: 16px;\n      ", " {\n        right: 24px;\n      }\n    }\n    &:before {\n    display: none;\n      content: $slick-prev-character;\n      [dir='rtl'] & {\n        content: $slick-next-character;\n      }\n    }\n  }\n\n  &.slick-next {\n    right: ", ";\n    ", " {\n      right: ", ";\n    }\n    [dir='rtl'] & {\n      left: 16px;\n      right: auto;\n      ", " {\n        left: 24px;\n      }\n    }\n    &:before {\n      display: none;\n      content: $slick-next-character;\n      [dir='rtl'] & {\n        content: $slick-prev-character;\n      }\n    }\n  }\n"])), function (props) { return props.showCircleChevron
    ? Ae(templateObject_2$2$1 || (templateObject_2$2$1 = __makeTemplateObject(["\n        border-radius: 50%;\n        "], ["\n        border-radius: 50%;\n        "]))) : ''; }, function (props) { return props.mobileMargin; }, styledBreakpoints.up('sm'), function (props) { return props.desktopMargin; }, styledBreakpoints.up('sm'), function (props) { return props.mobileMargin; }, styledBreakpoints.up('sm'), function (props) { return props.desktopMargin; }, styledBreakpoints.up('sm'));
var templateObject_1$2$1, templateObject_2$2$1, templateObject_3$2$1;

var FloatingLabelInputContainer = styled.div(templateObject_1$1$1 || (templateObject_1$1$1 = __makeTemplateObject(["\n  position: relative;\n  font-family: var(--font-family-open_sans);\n  width: 100%;\n"], ["\n  position: relative;\n  font-family: var(--font-family-open_sans);\n  width: 100%;\n"])));
var InvalidState = Ae(templateObject_2$1$1 || (templateObject_2$1$1 = __makeTemplateObject(["\n    ", "}\n"], ["\n    ", "}\n"])), function (_a) {
    var invalid = _a.invalid;
    return invalid && "\n        border-color: var(--error--red);\n        background-color: var(--soft-pink);\n        &:focus + label,\n        &:not(:placeholder-shown) + label{\n            color: var(--error--red);\n        }        \n    ";
});
var Input = styled.input(templateObject_3$1$1 || (templateObject_3$1$1 = __makeTemplateObject(["\n  width: 100%;\n  padding-top: 18px;\n  font-size: var(--font-size-14);\n  font-family: var(--font-family-open_sans);\n  line-height: 18px;\n  font-weight: 600;\n  color: var(--dark-gray);\n  border: 1px solid var(--dim-gray);\n  border-radius: 8px;\n  height: 48px;\n  padding: 25px 8px 5px 8px;\n  outline: none;\n  &:focus {\n    border-color: #000;\n    padding: 25px 8px 5px 8px;\n  }\n  &:focus + label, \n  &:not(:placeholder-shown) + label {\n    top: 5px;\n    left: 8px;\n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: 400;\n    color: var(--sonic-silver);    \n  }\n  &::placeholder{\n    opacity: 0;\n    font-size: var(--font-size-14);\n    font-weight: 400;\n    font-style: normal;\n    line-height: 18px;\n    color: var(--sonic-silver);\n    transition: all 0.2s ease-in-out;\n  }\n  &:focus::placeholder{\n    opacity: 1;\n  }\n  &:disabled{\n    background-color: var(--cararra);\n  }\n  &:disabled + label{\n    color: var(--tundora);\n  }\n  &:invalid{\n    ", "\n  }\n\n  ", "\n"], ["\n  width: 100%;\n  padding-top: 18px;\n  font-size: var(--font-size-14);\n  font-family: var(--font-family-open_sans);\n  line-height: 18px;\n  font-weight: 600;\n  color: var(--dark-gray);\n  border: 1px solid var(--dim-gray);\n  border-radius: 8px;\n  height: 48px;\n  padding: 25px 8px 5px 8px;\n  outline: none;\n  &:focus {\n    border-color: #000;\n    padding: 25px 8px 5px 8px;\n  }\n  &:focus + label, \n  &:not(:placeholder-shown) + label {\n    top: 5px;\n    left: 8px;\n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: 400;\n    color: var(--sonic-silver);    \n  }\n  &::placeholder{\n    opacity: 0;\n    font-size: var(--font-size-14);\n    font-weight: 400;\n    font-style: normal;\n    line-height: 18px;\n    color: var(--sonic-silver);\n    transition: all 0.2s ease-in-out;\n  }\n  &:focus::placeholder{\n    opacity: 1;\n  }\n  &:disabled{\n    background-color: var(--cararra);\n  }\n  &:disabled + label{\n    color: var(--tundora);\n  }\n  &:invalid{\n    ", "\n  }\n\n  ", "\n"])), InvalidState, InvalidState);
var Label = styled.label(templateObject_4$1$1 || (templateObject_4$1$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 15px;\n  left: 8px;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: var(--sonic-silver);\n  transition: all 0.2s ease-in-out;\n  pointer-events: none;\n  ", "}\n"], ["\n  position: absolute;\n  top: 15px;\n  left: 8px;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: var(--sonic-silver);\n  transition: all 0.2s ease-in-out;\n  pointer-events: none;\n  ", "}\n"])), function (_a) {
    var invalid = _a.invalid;
    return invalid && "\n    color: var(--error--red);\n  ";
});
var LabelHidden = styled.label(templateObject_5$1$1 || (templateObject_5$1$1 = __makeTemplateObject(["\n  position: relative;\n  visibility: hidden;\n  display: block;\n  height: 0;\n"], ["\n  position: relative;\n  visibility: hidden;\n  display: block;\n  height: 0;\n"])));
var HelperText = styled.div(templateObject_6$1$1 || (templateObject_6$1$1 = __makeTemplateObject(["\n  padding: 0 8px;\n  color: var(--tundora);\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  margin-top: 4px;\n"], ["\n  padding: 0 8px;\n  color: var(--tundora);\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  margin-top: 4px;\n"])));
var LinkTextContainer = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n    padding: 0 8px;\n    margin-top: 4px;\n    ", "\n"], ["\n    padding: 0 8px;\n    margin-top: 4px;\n    ", "\n"])), function (_a) {
    var textPosition = _a.textPosition;
    return textPosition === 'right' && "\n            text-align: end;\n        ";
});
var LinkText = styled.a(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["  \n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: ", ";\n    color: var(--tory-blue);  \n"], ["  \n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: ", ";\n    color: var(--tory-blue);  \n"])), function (_a) {
    var textPosition = _a.textPosition;
    return textPosition === 'right' ? 700 : 400;
});
var ErrorTextContainer = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n    color: var(--error--red);\n    padding: 0 8px;\n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n"], ["\n    color: var(--error--red);\n    padding: 0 8px;\n    font-size: var(--font-size-12);\n    line-height: 16px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n"])));
var InfoIcon$2 = styled(SvgInfoCircle$1)(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n    height: 16px;\n    margin-right: 4px;\n    min-width: 16px;\n    path{\n        fill: var(--error--red);\n    }\n"], ["\n    height: 16px;\n    margin-right: 4px;\n    min-width: 16px;\n    path{\n        fill: var(--error--red);\n    }\n"])));
var templateObject_1$1$1, templateObject_2$1$1, templateObject_3$1$1, templateObject_4$1$1, templateObject_5$1$1, templateObject_6$1$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1;

var CarnivalInput = forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, placeholder = _a.placeholder, testId = _a.testId, value = _a.value, disabled = _a.disabled, helperText = _a.helperText, linkText = _a.linkText, linkUrl = _a.linkUrl, linkTestId = _a.linkTestId, name = _a.name, _d = _a.linkPosition, linkPosition = _d === void 0 ? 'left' : _d, errorMsg = _a.errorMsg, errorTestId = _a.errorTestId, errorAriaLabel = _a.errorAriaLabel, className = _a.className, maxLength = _a.maxLength, _e = _a.role, role = _e === void 0 ? 'textbox' : _e, _f = _a.id, id = _f === void 0 ? "carnival-input-id" : _f, _g = _a.required, required = _g === void 0 ? false : _g, _h = _a.ariaRequired, ariaRequired = _h === void 0 ? false : _h, ariaLabel = _a.ariaLabel, onChange = _a.onChange, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onLinkClick = _a.onLinkClick;
    var labelId = 'carnival-input-label-id' + (id ? "-".concat(id) : '');
    return (jsxRuntime.exports.jsxs(FloatingLabelInputContainer, __assign({ className: className }, { children: [jsxRuntime.exports.jsx(LabelHidden, __assign({ id: labelId, htmlFor: id, "aria-label": ariaLabel }, { children: label })), jsxRuntime.exports.jsx(Input, __assign({ id: id, name: name, type: type, ref: ref, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : '', "data-testid": testId, value: value, disabled: disabled, invalid: invalid, role: role, onChange: onChange, onBlur: onBlur, onKeyDown: onKeyDown, "aria-describedby": 'carnival-input-helper-text', "aria-labelledby": labelId, maxLength: maxLength, required: required }, (ariaRequired && !required ? { "aria-required": 'true' } : {}))), jsxRuntime.exports.jsx(Label, __assign({ invalid: invalid, "aria-hidden": 'true' }, { children: label })), invalid && jsxRuntime.exports.jsxs(ErrorTextContainer, __assign({ role: 'alert', "data-testid": errorTestId, "aria-label": errorAriaLabel }, { children: [jsxRuntime.exports.jsx(InfoIcon$2, { "aria-hidden": "true" }), errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'Field invalid'] })), helperText && jsxRuntime.exports.jsx(HelperText, __assign({ id: "carnival-input-helper-text" }, { children: helperText })), linkText && (linkUrl || onLinkClick) && jsxRuntime.exports.jsx(LinkTextContainer, __assign({ textPosition: linkPosition }, { children: jsxRuntime.exports.jsx(LinkText, __assign({ href: linkUrl !== null && linkUrl !== void 0 ? linkUrl : '#', "data-testid": linkTestId, textPosition: linkPosition, onClick: onLinkClick }, { children: linkText })) }))] })));
});

//**desktop styles***/
styled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  display: flex;\n  min-width: 343px;\n  min-height: 300px;\n\n  ", " {     \n    min-width: 308px;\n    min-height: 311px;\n  }\n"], ["\n  display: flex;\n  min-width: 343px;\n  min-height: 300px;\n\n  ", " {     \n    min-width: 308px;\n    min-height: 311px;\n  }\n"])), styledBreakpoints.up('md'));
styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n"], ["\n"])));
styled.div(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
styled.img(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n  height: 110px;\n  width: 96px;\n\n  ", " {    \n    height: 138px;\n    width: 119px;\n  }\n"], ["\n  height: 110px;\n  width: 96px;\n\n  ", " {    \n    height: 138px;\n    width: 119px;\n  }\n"])), styledBreakpoints.up('md'));
styled.div(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
styled.div(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-34);\n  font-weight: 900;\n  width: 119px;\n  height: 38px;\n  margin-top: var(--spacing_token_m); \n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"], ["\n  ", "\n  font-size: var(--font-size-34);\n  font-weight: 900;\n  width: 119px;\n  height: 38px;\n  margin-top: var(--spacing_token_m); \n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"])), TempostdHeavycondensedNormalToryBlu);
styled.div(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
styled.p(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n  ", "\n  font-weight: 400;\n  line-height:20px;\n  font-size:16px;\n  width: 343px;\n  min-height: 40px;\n  margin-top: var(--spacing_token_s);\n  letter-spacing: 0;\n  text-align: center;\n\n  ", " {    \n    width: 311px;\n    min-height: 20px;\n  }\n"], ["\n  ", "\n  font-weight: 400;\n  line-height:20px;\n  font-size:16px;\n  width: 343px;\n  min-height: 40px;\n  margin-top: var(--spacing_token_s);\n  letter-spacing: 0;\n  text-align: center;\n\n  ", " {    \n    width: 311px;\n    min-height: 20px;\n  }\n"])), OpensansNormalTundora16px, styledBreakpoints.up('md'));
styled.div(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
styled.div(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n  width: 173px;\n  height: 48px;\n  margin-top: var(--spacing_token_m);\n"], ["\n  width: 173px;\n  height: 48px;\n  margin-top: var(--spacing_token_m);\n"])));
var templateObject_1$z, templateObject_2$v, templateObject_3$q, templateObject_4$o, templateObject_5$i, templateObject_6$h, templateObject_7$f, templateObject_8$c, templateObject_9$b, templateObject_10$9;

/**
 * @param getLocalResources  - function that returns resources for US locality
 * @param getLocalResourcesAU - function that returns resources for AU locality
 * @param shouldFetchRemote - optional function that returns a boolean indicating to fetch/override resources from resources repository (aka sitecore)
 * @returns resources for current locality conditionally fetching from remote repository
 */
function useResources(getLocalResources, getLocalResourcesAU, shouldFetchRemote) {
    var _a = __read(useState$1({}), 2), resources = _a[0], setResources = _a[1];
    var _b = __read(useState$1(false), 2), isInitialized = _b[0], setIsInitialized = _b[1];
    useEffect$1(function () {
        var _a;
        if (!isInitialized) {
            setIsInitialized(true);
            var language = LocalityService.getLocality() === '7' ? 'en-AU' : 'en';
            var resources_1 = language === 'en' ? getLocalResources() : getLocalResourcesAU();
            var retrieveFromSitecore = false;
            if (shouldFetchRemote === undefined) {
                retrieveFromSitecore = (typeof process !== 'undefined' && process !== undefined && process !== null && !process.env.REACT_APP_CYPRESS);
            }
            else {
                retrieveFromSitecore = shouldFetchRemote();
            }
            if (retrieveFromSitecore) {
                var appName = (_a = resources_1.AppName) !== null && _a !== void 0 ? _a : resources_1.ComponentName;
                var url = "/Carnival.ComponentResources.axd?componentNames=".concat(resources_1.ComponentName, "&lang=").concat(language, "&app=").concat(appName, "&propName=").concat(appName, "&format=json");
                fetchApi(url).then(function (result) {
                    var e_1, _a;
                    var _b;
                    var _loop_1 = function (key, value) {
                        var e_2, _f;
                        var fullKeyComponentResource = (_b = Object.keys(result).find(function (x) { return x.includes(key); })) !== null && _b !== void 0 ? _b : '';
                        var currentResources = result[fullKeyComponentResource];
                        if (currentResources) {
                            currentObject = Reflect.get(resources_1, key);
                            try {
                                for (var _g = (e_2 = void 0, __values(Object.keys(value))), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    var key1 = _h.value;
                                    item = currentResources.StringResources[key1];
                                    if (item) {
                                        Reflect.set(currentObject, key1, item);
                                    }
                                    else {
                                        item = currentResources.HtmlFragmentResources[key1];
                                        if (item) {
                                            Reflect.set(currentObject, key1, item);
                                        }
                                        else {
                                            image = currentResources.ImageResources[key1];
                                            if (image) {
                                                Reflect.set(currentObject, key1, image);
                                            }
                                        }
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            Reflect.set(resources_1, key, currentObject);
                        }
                    };
                    var currentObject, item, image;
                    try {
                        for (var _c = __values(Object.entries(resources_1)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                            _loop_1(key, value);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    setResources(__assign({}, resources_1));
                }).catch(function () {
                    setResources(resources_1);
                });
            }
            else {
                setResources(resources_1);
            }
        }
    }, [isInitialized, getLocalResources, getLocalResourcesAU, shouldFetchRemote]);
    return resources;
}

function useProfile() {
    var _a = __read(useState$1(ProfileService.getCclUserFromCookie()), 1), user = _a[0];
    var _b = __read(useState$1(ProfileService.isUserAuthenticated()), 1), authenticated = _b[0];
    return {
        user: user,
        authenticated: authenticated
    };
}

var ResourcesContext = /*#__PURE__*/createContext(null);
var ResourcesProvider = function (_a) {
  var children = _a.children;
  var contextValue = useResources(getLocalResources, getLocalResourcesAU);
  return jsxRuntime$1.exports.jsx(ResourcesContext.Provider, __assign$1({
    value: contextValue
  }, {
    children: children
  }));
};
var useResourcesContext = function () {
  return useContext(ResourcesContext);
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType$f = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType$f(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined$m = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined$m(result) || result === obj
        ? isUndefined$m(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = React__default.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React__default.useContext(HookFormContext);

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
                    _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = React__default.useRef(props);
    _props.current = props;
    React__default.useEffect(() => {
        const tearDown = (subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => tearDown(subscription);
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React__default.useState(control._formState);
    const _localProxyFormState = React__default.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React__default.useRef(name);
    const _mounted = React__default.useRef(true);
    _name.current = name;
    const callback = React__default.useCallback((value) => _mounted.current &&
        shouldSubscribeByName(_name.current, value.name, exact) &&
        shouldRenderFormState(value, _localProxyFormState.current) &&
        updateFormState({
            ...control._formState,
            ...value,
        }), [control, exact]);
    useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state,
    });
    React__default.useEffect(() => {
        _mounted.current = true;
        return () => {
            _mounted.current = false;
        };
    }, []);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

var isString$l = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString$l(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isFunction$e = (value) => typeof value === 'function';

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction$e(data[key])) {
            return true;
        }
    }
    return false;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React__default.useRef(name);
    _name.current = name;
    const callback = React__default.useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue(isUndefined$m(_name.current) ||
                (isObject(fieldValues) && !objectHasFunction(fieldValues))
                ? { ...fieldValues }
                : Array.isArray(fieldValues)
                    ? [...fieldValues]
                    : isUndefined$m(fieldValues)
                        ? defaultValue
                        : fieldValues);
        }
    }, [control, exact, defaultValue]);
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback,
    });
    const [value, updateValue] = React__default.useState(isUndefined$m(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    React__default.useEffect(() => {
        control._removeUnmounted();
    });
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React__default.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    React__default.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: React__default.useCallback((event) => {
                _registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            }, [name]),
            onBlur: React__default.useCallback(() => {
                _registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            }, [name, control]),
            ref: React__default.useCallback((elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            }, [name, control._fields]),
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined$m(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        for (const key in data) {
            if (isFunction$e(data[key])) {
                copy = data;
                break;
            }
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined$m(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => !isUndefined$m(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive$8 = (value) => isNullOrUndefined(value) || !isObjectType$f(value);

function deepEqual(object1, object2) {
    if (isPrimitive$8(object1) || isPrimitive$8(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isBoolean$6 = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioInput = (element) => element.type === 'radio';

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined$m(formValues) ||
                    isPrimitive$8(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined$m(options[0].attributes.value)
                    ? isUndefined$m(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined$m(value)
    ? value
    : valueAsNumber
        ? value === '' || isNullOrUndefined(value)
            ? NaN
            : +value
        : valueAsDate && isString$l(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined$m(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var isRegex = (value) => value instanceof RegExp;

var getRuleValue = (rule) => isUndefined$m(rule)
    ? undefined
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

var isMessage = (value) => isString$l(value) || React__default.isValidElement(value);

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean$6(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean$6(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (required &&
        ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
            (isBoolean$6(inputValue) && !inputValue) ||
            (isCheckBox && !getCheckboxValue(refs).isValid) ||
            (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString$l(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString$l(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && isString$l(inputValue)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString$l(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction$e(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuildInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined$m(value) ? get(_defaultValues, name) : value);
            isUndefined$m(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
            name,
        };
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty =
                isFieldDirty ||
                    isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty =
                isFieldDirty ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isBlurEvent);
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => _options.resolver
        ? await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
        : {};
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuildInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f: fieldReference, ...fieldValue } = field;
                if (fieldReference) {
                    const fieldError = await validateField(field, get(_formValues, fieldReference.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);
                    if (fieldError[fieldReference.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    if (!shouldOnlyCheckValid) {
                        fieldError[fieldReference.name]
                            ? set(_formState.errors, fieldReference.name, fieldError[fieldReference.name])
                            : unset(_formState.errors, fieldReference.name);
                    }
                }
                fieldValue &&
                    (await executeBuildInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = {
            ...(_stateFlags.mount
                ? _formValues
                : isUndefined$m(defaultValue)
                    ? _defaultValues
                    : isString$l(names)
                        ? { [names]: defaultValue }
                        : defaultValue),
        };
        return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive$8(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? +1 : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined$m(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuildInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuildInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString$l(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined$m(fieldNames)
            ? values
            : isString$l(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction$e(name)
        ? _subjects.watch.subscribe({
            next: (info) => name(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean$6(options.disabled);
        set(_fields, name, {
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined$m(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(!!Array.isArray(get(_defaultValues, name))
                                            ? [{}]
                                            : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuildInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _options.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined$m(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined$m(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            try {
                                isHTMLElement(fieldReference) &&
                                    fieldReference.closest('form').reset();
                                break;
                            }
                            catch (_a) { }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to mange the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = React__default.useRef();
    const [formState, updateFormState] = React__default.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._options = props;
    }
    else {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    const callback = React__default.useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
            control._formState = {
                ...control._formState,
                ...value,
            };
            updateFormState({ ...control._formState });
        }
    }, [control]);
    useSubscribe({
        subject: control._subjects.state,
        callback,
    });
    React__default.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}

var _path$1;

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgExclamationPoint2X = function SvgExclamationPoint2X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7.001 7.001 0 1 0 .002 14.002A7.001 7.001 0 0 0 8 1Zm0 12.645A5.642 5.642 0 0 1 2.355 8 5.643 5.643 0 0 1 8 2.355 5.643 5.643 0 0 1 13.645 8 5.642 5.642 0 0 1 8 13.645Zm1.185-2.935c0 .653-.531 1.185-1.185 1.185a1.187 1.187 0 0 1-1.185-1.185c0-.654.531-1.186 1.185-1.186s1.185.532 1.185 1.186ZM6.89 4.743 7.08 8.58c.009.18.157.322.338.322h1.162c.18 0 .33-.141.338-.322l.192-3.838a.339.339 0 0 0-.338-.356H7.227a.339.339 0 0 0-.338.356Z",
    fill: "#DC1125"
  })));
};

var ErrorWrapper = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$1(["\n  margin-top: 16px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  margin-top: 16px;\n  display: flex;\n  align-items: flex-start;\n"])));
var ExclamationIcon = styled(SvgExclamationPoint2X)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject$1(["\n"], ["\n"])));
var ErrorContent = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject$1(["\n  ", "\n  ", "\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 18px;\n  tab-index: 0;\n"], ["\n  ", "\n  ", "\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 18px;\n  tab-index: 0;\n"])), ValignTextMiddle, OpensansBoldCrimson14px);
var ErrorIcon = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject$1(["\n"], ["\n"])));
var templateObject_1$4, templateObject_2$4, templateObject_3$3, templateObject_4$2;

var ForgotVifpError = function (props) {
  return jsxRuntime$1.exports.jsxs(ErrorWrapper, __assign$1({
    "data-testid": "forgotVifpError"
  }, {
    children: [jsxRuntime$1.exports.jsx(ErrorIcon, {
      children: jsxRuntime$1.exports.jsx(ExclamationIcon, {
        "aria-hidden": "true"
      })
    }), jsxRuntime$1.exports.jsx(ErrorContent, __assign$1({
      "data-testid": "forgotVifpErrorMessage",
      role: "alert"
    }, {
      children: props.errorMessage
    }))]
  }));
};

function handleNetworkError() {
    const error = { code: 'NetworkError', message: 'There is a network issue and your request could not be processed.' };
    throw error;
}
function isJSONResponse(response) {
    if (!response) {
        return false;
    }
    return response.headers.has('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1;
}
function handleResponseStatus(response) {
    const isJSON = isJSONResponse(response);
    if (response.ok) {
        return isJSON ? response.json() : response.text();
    }
    if (isJSON) {
        return response.json().then((apiError) => {
            throw apiError;
        });
    }
    const error = { code: 'ServerError', message: 'We couldn\'t process your request. Please try again or call us at 1.800.764.7419.', response: response };
    throw error;
}
function cclFetch(input, init) {
    const credentials = 'include';
    const initWithCredentials = Object.assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then((response) => handleResponseStatus(response));
}

checkBrowserSupport();
function checkBrowserSupport() {
    let supported;
    try {
        supported = window.localStorage !== null;
        if (supported) {
            const key = '__testbrowsersupport';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
        }
        return supported;
    }
    catch (e) {
        supported = false;
    }
    return supported;
}

var LocalityEnum;
(function (LocalityEnum) {
    LocalityEnum["US"] = "1";
    LocalityEnum["UK"] = "3";
    LocalityEnum["AU"] = "7";
})(LocalityEnum || (LocalityEnum = {}));
var CurrencySourceEnum;
(function (CurrencySourceEnum) {
    CurrencySourceEnum["URL"] = "Url";
    CurrencySourceEnum["LOCAL_STORAGE"] = "LocalStorage";
    CurrencySourceEnum["COOKIE"] = "Cookie";
    CurrencySourceEnum["SERVER"] = "Server";
})(CurrencySourceEnum || (CurrencySourceEnum = {}));

String.format = function (s, ...args) {
    if (!s) {
        return '';
    }
    return s.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};

var sugarCore = {exports: {}};

/*
 *  Sugar v2.0.6
 *
 *  Freely distributable and licensed under the MIT-style license.
 *  Copyright (c) Andrew Plummer
 *  https://sugarjs.com/
 *
 * ---------------------------- */

(function (module) {
(function() {

  /***
   * @module Core
   * @description Core functionality including the ability to define methods and
   *              extend onto natives.
   *
   ***/

  // The global to export.
  var Sugar;

  // The name of Sugar in the global namespace.
  var SUGAR_GLOBAL = 'Sugar';

  // Natives available on initialization. Letting Object go first to ensure its
  // global is set by the time the rest are checking for chainable Object methods.
  var NATIVE_NAMES = 'Object Number String Array Date RegExp Function';

  // Static method flag
  var STATIC   = 0x1;

  // Instance method flag
  var INSTANCE = 0x2;

  // IE8 has a broken defineProperty but no defineProperties so this saves a try/catch.
  var PROPERTY_DESCRIPTOR_SUPPORT = !!(Object.defineProperty && Object.defineProperties);

  var globalContext = getGlobal();

  // Whether object instance methods can be mapped to the prototype.
  var allowObjectPrototype = false;

  // A map from Array to SugarArray.
  var namespacesByName = {};

  // A map from [object Object] to namespace.
  var namespacesByClassString = {};

  // Defining properties.
  // istanbul ignore next
  var defineProperty = PROPERTY_DESCRIPTOR_SUPPORT ?  Object.defineProperty : definePropertyShim;

  // A default chainable class for unknown types.
  var DefaultChainable = getNewChainableClass('Chainable');


  // Global methods

  function getGlobal() {
    // Get global context by keyword here to avoid issues with libraries
    // that can potentially alter this script's context object.
    return testGlobal(typeof commonjsGlobal$1 !== 'undefined' && commonjsGlobal$1) ||
           testGlobal(typeof window !== 'undefined' && window);
  }

  function testGlobal(obj) {
    // Note that Rhino uses a different "global" keyword so perform an
    // extra check here to ensure that it's actually the global object.
    return obj && obj.Object === Object ? obj : null;
  }

  function setupGlobal() {
    Sugar = globalContext[SUGAR_GLOBAL];
    // istanbul ignore if
    if (Sugar) {
      // Reuse already defined Sugar global object.
      return;
    }
    Sugar = function(arg) {
      forEachProperty(Sugar, function(sugarNamespace, name) {
        // Although only the only enumerable properties on the global
        // object are Sugar namespaces, environments that can't set
        // non-enumerable properties will step through the utility methods
        // as well here, so use this check to only allow true namespaces.
        if (hasOwn(namespacesByName, name)) {
          sugarNamespace.extend(arg);
        }
      });
      return Sugar;
    };
    // istanbul ignore else
    if (module.exports) {
      // Node or webpack environment
      module.exports = Sugar;
    } else {
      // Unwrapped browser environment
      try {
        globalContext[SUGAR_GLOBAL] = Sugar;
      } catch (e) {
        // Contexts such as QML have a read-only global context.
      }
    }
    forEachProperty(NATIVE_NAMES.split(' '), function(name) {
      createNamespace(name);
    });
    setGlobalProperties();
  }

  /***
   * @method createNamespace(name)
   * @returns SugarNamespace
   * @namespace Sugar
   * @short Creates a new Sugar namespace.
   * @extra This method is for plugin developers who want to define methods to be
   *        used with natives that Sugar does not handle by default. The new
   *        namespace will appear on the `Sugar` global with all the methods of
   *        normal namespaces, including the ability to define new methods. When
   *        extended, any defined methods will be mapped to `name` in the global
   *        context.
   *
   * @example
   *
   *   Sugar.createNamespace('Boolean');
   *
   * @param {string} name - The namespace name.
   *
   ***/
  function createNamespace(name) {

    // Is the current namespace Object?
    var isObject = name === 'Object';

    // A Sugar namespace is also a chainable class: Sugar.Array, etc.
    var sugarNamespace = getNewChainableClass(name);

    /***
     * @method extend([opts])
     * @returns Sugar
     * @namespace Sugar
     * @short Extends Sugar defined methods onto natives.
     * @extra This method can be called on individual namespaces like
     *        `Sugar.Array` or on the `Sugar` global itself, in which case
     *        [opts] will be forwarded to each `extend` call. For more,
     *        see `extending`.
     *
     * @options
     *
     *   methods           An array of method names to explicitly extend.
     *
     *   except            An array of method names or global namespaces (`Array`,
     *                     `String`) to explicitly exclude. Namespaces should be the
     *                     actual global objects, not strings.
     *
     *   namespaces        An array of global namespaces (`Array`, `String`) to
     *                     explicitly extend. Namespaces should be the actual
     *                     global objects, not strings.
     *
     *   enhance           A shortcut to disallow all "enhance" flags at once
     *                     (flags listed below). For more, see `enhanced methods`.
     *                     Default is `true`.
     *
     *   enhanceString     A boolean allowing String enhancements. Default is `true`.
     *
     *   enhanceArray      A boolean allowing Array enhancements. Default is `true`.
     *
     *   objectPrototype   A boolean allowing Sugar to extend Object.prototype
     *                     with instance methods. This option is off by default
     *                     and should generally not be used except with caution.
     *                     For more, see `object methods`.
     *
     * @example
     *
     *   Sugar.Array.extend();
     *   Sugar.extend();
     *
     * @option {Array<string>} [methods]
     * @option {Array<string|NativeConstructor>} [except]
     * @option {Array<NativeConstructor>} [namespaces]
     * @option {boolean} [enhance]
     * @option {boolean} [enhanceString]
     * @option {boolean} [enhanceArray]
     * @option {boolean} [objectPrototype]
     * @param {ExtendOptions} [opts]
     *
     ***
     * @method extend([opts])
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Extends Sugar defined methods for a specific namespace onto natives.
     * @param {ExtendOptions} [opts]
     *
     ***/
    var extend = function (opts) {

      var nativeClass = globalContext[name], nativeProto = nativeClass.prototype;
      var staticMethods = {}, instanceMethods = {}, methodsByName;

      function objectRestricted(name, target) {
        return isObject && target === nativeProto &&
               (!allowObjectPrototype || name === 'get' || name === 'set');
      }

      function arrayOptionExists(field, val) {
        var arr = opts[field];
        if (arr) {
          for (var i = 0, el; el = arr[i]; i++) {
            if (el === val) {
              return true;
            }
          }
        }
        return false;
      }

      function arrayOptionExcludes(field, val) {
        return opts[field] && !arrayOptionExists(field, val);
      }

      function disallowedByFlags(methodName, target, flags) {
        // Disallowing methods by flag currently only applies if methods already
        // exist to avoid enhancing native methods, as aliases should still be
        // extended (i.e. Array#all should still be extended even if Array#every
        // is being disallowed by a flag).
        if (!target[methodName] || !flags) {
          return false;
        }
        for (var i = 0; i < flags.length; i++) {
          if (opts[flags[i]] === false) {
            return true;
          }
        }
      }

      function namespaceIsExcepted() {
        return arrayOptionExists('except', nativeClass) ||
               arrayOptionExcludes('namespaces', nativeClass);
      }

      function methodIsExcepted(methodName) {
        return arrayOptionExists('except', methodName);
      }

      function canExtend(methodName, method, target) {
        return !objectRestricted(methodName, target) &&
               !disallowedByFlags(methodName, target, method.flags) &&
               !methodIsExcepted(methodName);
      }

      opts = opts || {};
      methodsByName = opts.methods;

      if (namespaceIsExcepted()) {
        return;
      } else if (isObject && typeof opts.objectPrototype === 'boolean') {
        // Store "objectPrototype" flag for future reference.
        allowObjectPrototype = opts.objectPrototype;
      }

      forEachProperty(methodsByName || sugarNamespace, function(method, methodName) {
        if (methodsByName) {
          // If we have method names passed in an array,
          // then we need to flip the key and value here
          // and find the method in the Sugar namespace.
          methodName = method;
          method = sugarNamespace[methodName];
        }
        if (hasOwn(method, 'instance') && canExtend(methodName, method, nativeProto)) {
          instanceMethods[methodName] = method.instance;
        }
        if(hasOwn(method, 'static') && canExtend(methodName, method, nativeClass)) {
          staticMethods[methodName] = method;
        }
      });

      // Accessing the extend target each time instead of holding a reference as
      // it may have been overwritten (for example Date by Sinon). Also need to
      // access through the global to allow extension of user-defined namespaces.
      extendNative(nativeClass, staticMethods);
      extendNative(nativeProto, instanceMethods);

      if (!methodsByName) {
        // If there are no method names passed, then
        // all methods in the namespace will be extended
        // to the native. This includes all future defined
        // methods, so add a flag here to check later.
        setProperty(sugarNamespace, 'active', true);
      }
      return sugarNamespace;
    };

    function defineWithOptionCollect(methodName, instance, args) {
      setProperty(sugarNamespace, methodName, function(arg1, arg2, arg3) {
        var opts = collectDefineOptions(arg1, arg2, arg3);
        defineMethods(sugarNamespace, opts.methods, instance, args, opts.last);
        return sugarNamespace;
      });
    }

    /***
     * @method defineStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods on the namespace that can later be extended
     *        onto the native globals.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. If `extend` was previously called
     *        with no arguments, the method will be immediately mapped to its
     *        native when defined.
     *
     * @example
     *
     *   Sugar.Number.defineStatic({
     *     isOdd: function (num) {
     *       return num % 2 === 1;
     *     }
     *   });
     *
     * @signature defineStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStatic', STATIC);

    /***
     * @method defineInstance(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines methods on the namespace that can later be extended as
     *        instance methods onto the native prototype.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. All functions should accept the
     *        native for which they are mapped as their first argument, and should
     *        never refer to `this`. If `extend` was previously called with no
     *        arguments, the method will be immediately mapped to its native when
     *        defined.
     *
     *        Methods cannot accept more than 4 arguments in addition to the
     *        native (5 arguments total). Any additional arguments will not be
     *        mapped. If the method needs to accept unlimited arguments, use
     *        `defineInstanceWithArguments`. Otherwise if more options are
     *        required, use an options object instead.
     *
     * @example
     *
     *   Sugar.Number.defineInstance({
     *     square: function (num) {
     *       return num * num;
     *     }
     *   });
     *
     * @signature defineInstance(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstance', INSTANCE);

    /***
     * @method defineInstanceAndStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short A shortcut to define both static and instance methods on the namespace.
     * @extra This method is intended for use with `Object` instance methods. Sugar
     *        will not map any methods to `Object.prototype` by default, so defining
     *        instance methods as static helps facilitate their proper use.
     *
     * @example
     *
     *   Sugar.Object.defineInstanceAndStatic({
     *     isAwesome: function (obj) {
     *       // check if obj is awesome!
     *     }
     *   });
     *
     * @signature defineInstanceAndStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceAndStatic', INSTANCE | STATIC);


    /***
     * @method defineStaticWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that collect arguments.
     * @extra This method is identical to `defineStatic`, except that when defined
     *        methods are called, they will collect any arguments past `n - 1`,
     *        where `n` is the number of arguments that the method accepts.
     *        Collected arguments will be passed to the method in an array
     *        as the last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineStaticWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineStaticWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStaticWithArguments', STATIC, true);

    /***
     * @method defineInstanceWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that collect arguments.
     * @extra This method is identical to `defineInstance`, except that when
     *        defined methods are called, they will collect any arguments past
     *        `n - 1`, where `n` is the number of arguments that the method
     *        accepts. Collected arguments will be passed to the method as the
     *        last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineInstanceWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineInstanceWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceWithArguments', INSTANCE, true);

    /***
     * @method defineStaticPolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that are mapped onto the native if they do
     *        not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. Note that polyfill methods will
     *        be immediately mapped onto their native prototype regardless of the
     *        use of `extend`.
     *
     * @example
     *
     *   Sugar.Object.defineStaticPolyfill({
     *     keys: function (obj) {
     *       // get keys!
     *     }
     *   });
     *
     * @signature defineStaticPolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineStaticPolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name], opts.methods, true, opts.last);
      return sugarNamespace;
    });

    /***
     * @method defineInstancePolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that are mapped onto the native prototype
     *        if they do not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. This method differs from
     *        `defineInstance` as there is no static signature (as the method
     *        is mapped as-is to the native), so it should refer to its `this`
     *        object. Note that polyfill methods will be immediately mapped onto
     *        their native prototype regardless of the use of `extend`.
     *
     * @example
     *
     *   Sugar.Array.defineInstancePolyfill({
     *     indexOf: function (arr, el) {
     *       // index finding code here!
     *     }
     *   });
     *
     * @signature defineInstancePolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineInstancePolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name].prototype, opts.methods, true, opts.last);
      // Map instance polyfills to chainable as well.
      forEachProperty(opts.methods, function(fn, methodName) {
        defineChainableMethod(sugarNamespace, methodName, fn);
      });
      return sugarNamespace;
    });

    /***
     * @method alias(toName, from)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Aliases one Sugar method to another.
     *
     * @example
     *
     *   Sugar.Array.alias('all', 'every');
     *
     * @signature alias(toName, fn)
     * @param {string} toName - Name for new method.
     * @param {string|Function} from - Method to alias, or string shortcut.
     ***/
    setProperty(sugarNamespace, 'alias', function(name, source) {
      var method = typeof source === 'string' ? sugarNamespace[source] : source;
      setMethod(sugarNamespace, name, method);
      return sugarNamespace;
    });

    // Each namespace can extend only itself through its .extend method.
    setProperty(sugarNamespace, 'extend', extend);

    // Cache the class to namespace relationship for later use.
    namespacesByName[name] = sugarNamespace;
    namespacesByClassString['[object ' + name + ']'] = sugarNamespace;

    mapNativeToChainable(name);
    mapObjectChainablesToNamespace(sugarNamespace);


    // Export
    return Sugar[name] = sugarNamespace;
  }

  function setGlobalProperties() {
    setProperty(Sugar, 'VERSION', '2.0.6');
    setProperty(Sugar, 'extend', Sugar);
    setProperty(Sugar, 'toString', toString);
    setProperty(Sugar, 'createNamespace', createNamespace);

    setProperty(Sugar, 'util', {
      'hasOwn': hasOwn,
      'getOwn': getOwn,
      'setProperty': setProperty,
      'classToString': classToString,
      'defineProperty': defineProperty,
      'forEachProperty': forEachProperty,
      'mapNativeToChainable': mapNativeToChainable
    });
  }

  function toString() {
    return SUGAR_GLOBAL;
  }


  // Defining Methods

  function defineMethods(sugarNamespace, methods, type, args, flags) {
    forEachProperty(methods, function(method, methodName) {
      var instanceMethod, staticMethod = method;
      if (args) {
        staticMethod = wrapMethodWithArguments(method);
      }
      if (flags) {
        staticMethod.flags = flags;
      }

      // A method may define its own custom implementation, so
      // make sure that's not the case before creating one.
      if (type & INSTANCE && !method.instance) {
        instanceMethod = wrapInstanceMethod(method, args);
        setProperty(staticMethod, 'instance', instanceMethod);
      }

      if (type & STATIC) {
        setProperty(staticMethod, 'static', true);
      }

      setMethod(sugarNamespace, methodName, staticMethod);

      if (sugarNamespace.active) {
        // If the namespace has been activated (.extend has been called),
        // then map this method as well.
        sugarNamespace.extend(methodName);
      }
    });
  }

  function collectDefineOptions(arg1, arg2, arg3) {
    var methods, last;
    if (typeof arg1 === 'string') {
      methods = {};
      methods[arg1] = arg2;
      last = arg3;
    } else {
      methods = arg1;
      last = arg2;
    }
    return {
      last: last,
      methods: methods
    };
  }

  function wrapInstanceMethod(fn, args) {
    return args ? wrapMethodWithArguments(fn, true) : wrapInstanceMethodFixed(fn);
  }

  function wrapMethodWithArguments(fn, instance) {
    // Functions accepting enumerated arguments will always have "args" as the
    // last argument, so subtract one from the function length to get the point
    // at which to start collecting arguments. If this is an instance method on
    // a prototype, then "this" will be pushed into the arguments array so start
    // collecting 1 argument earlier.
    var startCollect = fn.length - 1 - (instance ? 1 : 0);
    return function() {
      var args = [], collectedArgs = [], len;
      if (instance) {
        args.push(this);
      }
      len = Math.max(arguments.length, startCollect);
      // Optimized: no leaking arguments
      for (var i = 0; i < len; i++) {
        if (i < startCollect) {
          args.push(arguments[i]);
        } else {
          collectedArgs.push(arguments[i]);
        }
      }
      args.push(collectedArgs);
      return fn.apply(this, args);
    };
  }

  function wrapInstanceMethodFixed(fn) {
    switch(fn.length) {
      // Wrapped instance methods will always be passed the instance
      // as the first argument, but requiring the argument to be defined
      // may cause confusion here, so return the same wrapped function regardless.
      case 0:
      case 1:
        return function() {
          return fn(this);
        };
      case 2:
        return function(a) {
          return fn(this, a);
        };
      case 3:
        return function(a, b) {
          return fn(this, a, b);
        };
      case 4:
        return function(a, b, c) {
          return fn(this, a, b, c);
        };
      case 5:
        return function(a, b, c, d) {
          return fn(this, a, b, c, d);
        };
    }
  }

  // Method helpers

  function extendNative(target, source, polyfill, override) {
    forEachProperty(source, function(method, name) {
      if (polyfill && !override && target[name]) {
        // Method exists, so bail.
        return;
      }
      setProperty(target, name, method);
    });
  }

  function setMethod(sugarNamespace, methodName, method) {
    sugarNamespace[methodName] = method;
    if (method.instance) {
      defineChainableMethod(sugarNamespace, methodName, method.instance);
    }
  }


  // Chainables

  function getNewChainableClass(name) {
    var fn = function SugarChainable(obj, arg) {
      if (!(this instanceof fn)) {
        return new fn(obj, arg);
      }
      if (this.constructor !== fn) {
        // Allow modules to define their own constructors.
        obj = this.constructor.apply(obj, arguments);
      }
      this.raw = obj;
    };
    setProperty(fn, 'toString', function() {
      return SUGAR_GLOBAL + name;
    });
    setProperty(fn.prototype, 'valueOf', function() {
      return this.raw;
    });
    return fn;
  }

  function defineChainableMethod(sugarNamespace, methodName, fn) {
    var wrapped = wrapWithChainableResult(fn), existing, collision, dcp;
    dcp = DefaultChainable.prototype;
    existing = dcp[methodName];

    // If the method was previously defined on the default chainable, then a
    // collision exists, so set the method to a disambiguation function that will
    // lazily evaluate the object and find it's associated chainable. An extra
    // check is required to avoid false positives from Object inherited methods.
    collision = existing && existing !== Object.prototype[methodName];

    // The disambiguation function is only required once.
    if (!existing || !existing.disambiguate) {
      dcp[methodName] = collision ? disambiguateMethod(methodName) : wrapped;
    }

    // The target chainable always receives the wrapped method. Additionally,
    // if the target chainable is Sugar.Object, then map the wrapped method
    // to all other namespaces as well if they do not define their own method
    // of the same name. This way, a Sugar.Number will have methods like
    // isEqual that can be called on any object without having to traverse up
    // the prototype chain and perform disambiguation, which costs cycles.
    // Note that the "if" block below actually does nothing on init as Object
    // goes first and no other namespaces exist yet. However it needs to be
    // here as Object instance methods defined later also need to be mapped
    // back onto existing namespaces.
    sugarNamespace.prototype[methodName] = wrapped;
    if (sugarNamespace === Sugar.Object) {
      mapObjectChainableToAllNamespaces(methodName, wrapped);
    }
  }

  function mapObjectChainablesToNamespace(sugarNamespace) {
    forEachProperty(Sugar.Object && Sugar.Object.prototype, function(val, methodName) {
      if (typeof val === 'function') {
        setObjectChainableOnNamespace(sugarNamespace, methodName, val);
      }
    });
  }

  function mapObjectChainableToAllNamespaces(methodName, fn) {
    forEachProperty(namespacesByName, function(sugarNamespace) {
      setObjectChainableOnNamespace(sugarNamespace, methodName, fn);
    });
  }

  function setObjectChainableOnNamespace(sugarNamespace, methodName, fn) {
    var proto = sugarNamespace.prototype;
    if (!hasOwn(proto, methodName)) {
      proto[methodName] = fn;
    }
  }

  function wrapWithChainableResult(fn) {
    return function() {
      return new DefaultChainable(fn.apply(this.raw, arguments));
    };
  }

  function disambiguateMethod(methodName) {
    var fn = function() {
      var raw = this.raw, sugarNamespace;
      if (raw != null) {
        // Find the Sugar namespace for this unknown.
        sugarNamespace = namespacesByClassString[classToString(raw)];
      }
      if (!sugarNamespace) {
        // If no sugarNamespace can be resolved, then default
        // back to Sugar.Object so that undefined and other
        // non-supported types can still have basic object
        // methods called on them, such as type checks.
        sugarNamespace = Sugar.Object;
      }

      return new sugarNamespace(raw)[methodName].apply(this, arguments);
    };
    fn.disambiguate = true;
    return fn;
  }

  function mapNativeToChainable(name, methodNames) {
    var sugarNamespace = namespacesByName[name],
        nativeProto = globalContext[name].prototype;

    if (!methodNames && ownPropertyNames) {
      methodNames = ownPropertyNames(nativeProto);
    }

    forEachProperty(methodNames, function(methodName) {
      if (nativeMethodProhibited(methodName)) {
        // Sugar chainables have their own constructors as well as "valueOf"
        // methods, so exclude them here. The __proto__ argument should be trapped
        // by the function check below, however simply accessing this property on
        // Object.prototype causes QML to segfault, so pre-emptively excluding it.
        return;
      }
      try {
        var fn = nativeProto[methodName];
        if (typeof fn !== 'function') {
          // Bail on anything not a function.
          return;
        }
      } catch (e) {
        // Function.prototype has properties that
        // will throw errors when accessed.
        return;
      }
      defineChainableMethod(sugarNamespace, methodName, fn);
    });
  }

  function nativeMethodProhibited(methodName) {
    return methodName === 'constructor' ||
           methodName === 'valueOf' ||
           methodName === '__proto__';
  }


  // Util

  // Internal references
  var ownPropertyNames = Object.getOwnPropertyNames,
      internalToString = Object.prototype.toString,
      internalHasOwnProperty = Object.prototype.hasOwnProperty;

  // Defining this as a variable here as the ES5 module
  // overwrites it to patch DONTENUM.
  var forEachProperty = function (obj, fn) {
    for(var key in obj) {
      if (!hasOwn(obj, key)) continue;
      if (fn.call(obj, obj[key], key, obj) === false) break;
    }
  };

  // istanbul ignore next
  function definePropertyShim(obj, prop, descriptor) {
    obj[prop] = descriptor.value;
  }

  function setProperty(target, name, value, enumerable) {
    defineProperty(target, name, {
      value: value,
      enumerable: !!enumerable,
      configurable: true,
      writable: true
    });
  }

  // PERF: Attempts to speed this method up get very Heisenbergy. Quickly
  // returning based on typeof works for primitives, but slows down object
  // types. Even === checks on null and undefined (no typeof) will end up
  // basically breaking even. This seems to be as fast as it can go.
  function classToString(obj) {
    return internalToString.call(obj);
  }

  function hasOwn(obj, prop) {
    return !!obj && internalHasOwnProperty.call(obj, prop);
  }

  function getOwn(obj, prop) {
    if (hasOwn(obj, prop)) {
      return obj[prop];
    }
  }

  setupGlobal();

  // For type checking, etc. Excludes object as this is more nuanced.
  var NATIVE_TYPES = 'Boolean Number String Date RegExp Function Array Error Set Map';

  // Do strings have no keys?
  var NO_KEYS_IN_STRING_OBJECTS = !('0' in Object('a'));

  // WhiteSpace/LineTerminator as defined in ES5.1 plus Unicode characters in the Space, Separator category.
  var TRIM_CHARS = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

  // Common chars
  var HALF_WIDTH_ZERO = 0x30,
      FULL_WIDTH_ZERO = 0xff10,
      HALF_WIDTH_PERIOD   = '.',
      FULL_WIDTH_PERIOD   = '．',
      HALF_WIDTH_COMMA    = ',';

  // Namespace aliases
  var sugarObject   = Sugar.Object,
      sugarArray    = Sugar.Array,
      sugarDate     = Sugar.Date,
      sugarString   = Sugar.String;
      Sugar.Number;
      var sugarFunction = Sugar.Function;
      Sugar.RegExp;

  // Class checks
  var isString,
      isFunction,
      isArray;

  function buildClassChecks() {

    function addCoreTypes() {

      var names = spaceSplit(NATIVE_TYPES);

      buildPrimitiveClassCheck(names[0]);
      buildPrimitiveClassCheck(names[1]);
      isString  = buildPrimitiveClassCheck(names[2]);

      buildClassCheck(names[3]);
      buildClassCheck(names[4]);

      // Wanted to enhance performance here by using simply "typeof"
      // but Firefox has two major issues that make this impossible,
      // one fixed, the other not, so perform a full class check here.
      //
      // 1. Regexes can be typeof "function" in FF < 3
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
      //
      // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
      isFunction = buildClassCheck(names[5]);

      // istanbul ignore next
      isArray = Array.isArray || buildClassCheck(names[6]);
      buildClassCheck(names[7]);

      buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
      buildClassCheck(names[9], typeof Map !== 'undefined' && Map);
      addKnownType(names[0]);
      addKnownType(names[1]);
      addKnownType(names[2]);
      addKnownType(names[3]);
      addKnownType(names[4]);
      addKnownType(names[6]);

    }

    function addArrayTypes() {
      var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
      forEach(spaceSplit(types), function(str) {
      });
    }

    function addKnownType(className) {
    }

    function buildClassCheck(className, globalObject) {
      // istanbul ignore if
      if (globalObject && isClass(new globalObject, 'Object')) {
        return getConstructorClassCheck(globalObject);
      } else {
        return getToStringClassCheck(className);
      }
    }

    // Map and Set may be [object Object] in certain IE environments.
    // In this case we need to perform a check using the constructor
    // instead of Object.prototype.toString.
    // istanbul ignore next
    function getConstructorClassCheck(obj) {
      var ctorStr = String(obj);
      return function(obj) {
        return String(obj.constructor) === ctorStr;
      };
    }

    function getToStringClassCheck(className) {
      return function(obj, str) {
        // perf: Returning up front on instanceof appears to be slower.
        return isClass(obj, className, str);
      };
    }

    function buildPrimitiveClassCheck(className) {
      var type = className.toLowerCase();
      return function(obj) {
        var t = typeof obj;
        return t === type || t === 'object' && isClass(obj, className);
      };
    }

    addCoreTypes();
    addArrayTypes();

  }

  function isClass(obj, className, str) {
    if (!str) {
      str = classToString(obj);
    }
    return str === '[object '+ className +']';
  }

  // Wrapping the core's "define" methods to
  // save a few bytes in the minified script.
  function wrapNamespace(method) {
    return function(sugarNamespace, arg1, arg2) {
      sugarNamespace[method](arg1, arg2);
    };
  }

  // Method define aliases
  var defineStaticPolyfill        = wrapNamespace('defineStaticPolyfill'),
      defineInstancePolyfill      = wrapNamespace('defineInstancePolyfill');

  function assertCallable(obj) {
    if (!isFunction(obj)) {
      throw new TypeError('Function is not callable');
    }
  }


  // General helpers

  function isDefined(o) {
    return o !== undefined;
  }

  function isPrimitive(obj, type) {
    type = type || typeof obj;
    return obj == null || type === 'string' || type === 'number' || type === 'boolean';
  }

  // Make primtives types like strings into objects.
  function coercePrimitiveToObject(obj) {
    if (isPrimitive(obj)) {
      obj = Object(obj);
    }
    // istanbul ignore next
    if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) {
      forceStringCoercion(obj);
    }
    return obj;
  }

  // Force strings to have their indexes set in
  // environments that don't do this automatically.
  // istanbul ignore next
  function forceStringCoercion(obj) {
    var i = 0, chr;
    while (chr = obj.charAt(i)) {
      obj[i++] = chr;
    }
  }


  // Array helpers

  function isArrayIndex(n) {
    return n >>> 0 == n && n != 0xFFFFFFFF;
  }

  function iterateOverSparseArray(arr, fn, fromIndex, loop) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
    for (var i = 0, len = indexes.length; i < len; i++) {
      index = indexes[i];
      fn.call(arr, arr[index], index, arr);
    }
    return arr;
  }

  // It's unclear whether or not sparse arrays qualify as "simple enumerables".
  // If they are not, however, the wrapping function will be deoptimized, so
  // isolate here (also to share between es5 and array modules).
  function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
    var indexes = [], i;
    for (i in arr) {
      // istanbul ignore next
      if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
        indexes.push(+i);
      }
    }
    indexes.sort(function(a, b) {
      var aLoop = a > fromIndex;
      var bLoop = b > fromIndex;
      // This block cannot be reached unless ES5 methods are being shimmed.
      // istanbul ignore if
      if (aLoop !== bLoop) {
        return aLoop ? -1 : 1;
      }
      return a - b;
    });
    return indexes;
  }

  function spaceSplit(str) {
    return str.split(' ');
  }

  function forEach(arr, fn) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (!(i in arr)) {
        return iterateOverSparseArray(arr, fn, i);
      }
      fn(arr[i], i);
    }
  }

  // Number helpers

  // istanbul ignore next
  var trunc = Math.trunc || function(n) {
    if (n === 0 || !isFinite(n)) return n;
    return n < 0 ? ceil(n) : floor(n);
  };

  function padNumber(num, place, sign, base, replacement) {
    var str = abs(num).toString(base || 10);
    str = repeatString(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
    if (sign || num < 0) {
      str = (num < 0 ? '-' : '+') + str;
    }
    return str;
  }

  // Fullwidth number helpers
  var fullWidthNumberMap;

  function buildFullWidthNumber() {
    var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA;
    fullWidthNumberMap = {};
    for (var i = 0, digit; i <= 9; i++) {
      digit = chr(i + FULL_WIDTH_ZERO);
      fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
    }
    fullWidthNumberMap[hwc] = '';
    fullWidthNumberMap[fwp] = hwp;
    // Mapping this to itself to capture it easily
    // in stringToNumber to detect decimals later.
    fullWidthNumberMap[hwp] = hwp;
  }

  // Math aliases
  var abs   = Math.abs,
      ceil  = Math.ceil,
      floor = Math.floor;


  // String helpers

  var chr = String.fromCharCode;

  function repeatString(str, num) {
    var result = '';
    str = str.toString();
    while (num > 0) {
      if (num & 1) {
        result += str;
      }
      if (num >>= 1) {
        str += str;
      }
    }
    return result;
  }

  buildClassChecks();
  buildFullWidthNumber();

  /***
   * @module ES5
   * @description Functions and polyfill methods that fix ES5 functionality. This
   *              module is excluded from default builds, and can be included if
   *              you need legacy browser support (IE8 and below).
   *
   ***/

  // Non-enumerable properties on Object.prototype. In early JScript implementations
  // (< IE9) these will shadow object properties and break for..in loops.
  var DONT_ENUM_PROPS = [
    'valueOf',
    'toString',
    'constructor',
    'isPrototypeOf',
    'hasOwnProperty',
    'toLocaleString',
    'propertyIsEnumerable'
  ];

  /***
   * @fix
   * @short Fixes DontEnum bug for iteration methods in < IE9.
   ***/
  function buildDontEnumFix() {
    if (!({toString:1}).propertyIsEnumerable('toString')) {
      var forEachEnumerableProperty = forEachProperty;
      forEachProperty = function(obj, fn) {
        forEachEnumerableProperty(obj, fn);
        for (var i = 0, key; key = DONT_ENUM_PROPS[i]; i++) {
          if (hasOwn(obj, key)) {
            if(fn.call(obj, obj[key], key, obj) === false) break;
          }
        }
      };
    }
  }

  /***
   * @fix
   * @short Adds native methods to chainables in < IE9.
   ***/
  function buildChainableNativeMethodsFix() {
    if (!Object.getOwnPropertyNames) {
      defineNativeMethodsOnChainable();
    }
  }

  // Polyfilled methods will automatically be added to the chainable prototype.
  // However, Object.getOwnPropertyNames cannot be shimmed for non-enumerable
  // properties, so if it does not exist, then the only way to access native
  // methods previous to ES5 is to provide them as a list of tokens here.
  function defineNativeMethodsOnChainable() {

    var nativeTokens = {
      'Function': 'apply,call',
      'RegExp':   'compile,exec,test',
      'Number':   'toExponential,toFixed,toLocaleString,toPrecision',
      'Object':   'hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString',
      'Array':    'concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift',
      'Date':     'getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString',
      'String':   'anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase'
    };

    var dateTokens = 'FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds'.split(',');

    function addDateTokens(prefix, arr) {
      for (var i = 0; i < dateTokens.length; i++) {
        arr.push(prefix + dateTokens[i]);
      }
    }

    forEachProperty(nativeTokens, function(str, name) {
      var tokens = str.split(',');
      if (name === 'Date') {
        addDateTokens('get', tokens);
        addDateTokens('set', tokens);
        addDateTokens('getUTC', tokens);
        addDateTokens('setUTC', tokens);
      }
      tokens.push('toString');
      mapNativeToChainable(name, tokens);
    });

  }


  buildDontEnumFix();
  buildChainableNativeMethodsFix();


  /*** @namespace Object ***/

  function assertNonNull(obj) {
    if (obj == null) {
      throw new TypeError('Object required');
    }
  }

  defineStaticPolyfill(sugarObject, {

    'keys': function(obj) {
      var keys = [];
      assertNonNull(obj);
      forEachProperty(coercePrimitiveToObject(obj), function(val, key) {
        keys.push(key);
      });
      return keys;
    }

  });


  /*** @namespace Array ***/

  function arrayIndexOf(arr, search, fromIndex, fromRight) {
    var length = arr.length, defaultFromIndex, index, increment;

    increment = fromRight ? -1 : 1;
    defaultFromIndex = fromRight ? length - 1 : 0;
    fromIndex = trunc(fromIndex);
    if (!fromIndex && fromIndex !== 0) {
      fromIndex = defaultFromIndex;
    }
    if (fromIndex < 0) {
      fromIndex = length + fromIndex;
    }
    if ((!fromRight && fromIndex < 0) || (fromRight && fromIndex >= length)) {
      fromIndex = defaultFromIndex;
    }

    index = fromIndex;

    while((fromRight && index >= 0) || (!fromRight && index < length)) {
      if (!(index in arr)) {
        return sparseIndexOf(arr, search, fromIndex, fromRight);
      }
      if (isArrayIndex(index) && arr[index] === search) {
        return index;
      }
      index += increment;
    }
    return -1;
  }

  function sparseIndexOf(arr, search, fromIndex, fromRight) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, false, fromRight), index;
    indexes.sort(function(a, b) {
      return fromRight ? b - a : a - b;
    });
    while ((index = indexes.shift()) !== undefined) {
      if (arr[index] === search) {
        return +index;
      }
    }
    return -1;
  }

  function arrayReduce(arr, fn, initialValue, fromRight) {
    var length = arr.length, count = 0, defined = isDefined(initialValue), result, index;
    assertCallable(fn);
    if (length == 0 && !defined) {
      throw new TypeError('Reduce called on empty array with no initial value');
    } else if (defined) {
      result = initialValue;
    } else {
      result = arr[fromRight ? length - 1 : count];
      count++;
    }
    while(count < length) {
      index = fromRight ? length - count - 1 : count;
      if (index in arr) {
        result = fn(result, arr[index], index, arr);
      }
      count++;
    }
    return result;
  }

  defineStaticPolyfill(sugarArray, {

    /***
     *
     * @method isArray(obj)
     * @returns Boolean
     * @polyfill ES5
     * @static
     * @short Returns true if `obj` is an Array.
     *
     * @example
     *
     *   Array.isArray(3)        -> false
     *   Array.isArray(true)     -> false
     *   Array.isArray('wasabi') -> false
     *   Array.isArray([1,2,3])  -> true
     *
     ***/
    'isArray': function(obj) {
      return isArray(obj);
    }

  });

  defineInstancePolyfill(sugarArray, {

    'every': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && !fn.call(context, this[index], index, this)) {
          return false;
        }
        index++;
      }
      return true;
    },

    'some': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          return true;
        }
        index++;
      }
      return false;
    },

    'map': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = new Array(length);
      assertCallable(fn);
      while(index < length) {
        if (index in this) {
          result[index] = fn.call(context, this[index], index, this);
        }
        index++;
      }
      return result;
    },

    'filter': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = [];
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          result.push(this[index]);
        }
        index++;
      }
      return result;
    },

    /***
     * @method indexOf(search, [fromIndex] = 0)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array and returns the first index where `search` occurs,
     *        or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This
     *        method performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *        For such functionality, use the `findIndex` method instead.
     *
     * @example
     *
     *   [1,2,3].indexOf(3) -> 1
     *   [1,2,3].indexOf(7) -> -1
     *
     ***/
    'indexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.indexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex);
    },

    /***
     * @method lastIndexOf(search, [fromIndex] = array.length - 1)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array from the end and returns the first index where
     *        `search` occurs, or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This method
     *        performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *
     * @example
     *
     *   [1,2,1].lastIndexOf(1) -> 2
     *   [1,2,1].lastIndexOf(7) -> -1
     *
     ***/
    'lastIndexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.lastIndexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex, true);
    },

    /***
     * @method forEach([eachFn], [context])
     * @polyfill ES5
     * @short Iterates over the array, calling [eachFn] on each loop.
     * @extra [context] becomes the `this` object.
     *
     * @callback eachFn
     *
     *   el   The element of the current iteration.
     *   i    The index of the current iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   ['a','b','c'].forEach(function(a) {
     *     // Called 3 times: 'a','b','c'
     *   });
     *
     ***/
    'forEach': function(eachFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(eachFn);
      while(index < length) {
        if (index in this) {
          eachFn.call(context, this[index], index, this);
        }
        index++;
      }
    },

    /***
     * @method reduce(reduceFn, [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Reduces the array to a single result.
     * @extra This operation is sometimes called "accumulation", as it takes the
     *        result of the last iteration of `reduceFn` and passes it as the first
     *        argument to the next iteration, "accumulating" that value as it goes.
     *        The return value of this method will be the return value of the final
     *        iteration of `reduceFn`. If [init] is passed, it will be the initial
     *        "accumulator" (the first argument). If [init] is not passed, then it
     *        will take the first element in the array, and `reduceFn` will not be
     *        called for that element.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator". Either [init], the result of the last iteration
     *        of `reduceFn`, or the first element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 1 - 2 - 3
     *   });
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 100 - 1 - 2 - 3
     *   }, 100);
     *
     ***/
    'reduce': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context);
    },

    /***
     * @method reduceRight([reduceFn], [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Similar to `Array#reduce`, but operates on the elements in reverse.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator", either [init], the result of the last iteration
     *        of `reduceFn`, or the last element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 3 - 2 - 1
     *   });
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 100 - 3 - 2 - 1
     *   }, 100);
     *
     *
     ***/
    'reduceRight': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context, true);
    }

  });


  /*** @namespace String ***/

  var TRIM_REG = RegExp('^[' + TRIM_CHARS + ']+|['+ TRIM_CHARS +']+$', 'g');

  defineInstancePolyfill(sugarString, {
    /***
     * @method trim()
     * @returns String
     * @polyfill ES5
     * @short Removes leading and trailing whitespace from the string.
     * @extra Whitespace is defined as line breaks, tabs, and any character in the
     *        "Space, Separator" Unicode category, conforming to the the ES5 spec.
     *
     * @example
     *
     *   '   wasabi   '.trim()      -> 'wasabi'
     *   '   wasabi   '.trimLeft()  -> 'wasabi   '
     *   '   wasabi   '.trimRight() -> '   wasabi'
     *
     ***/
    'trim': function() {
      return this.toString().replace(TRIM_REG, '');
    }
  });


  /*** @namespace Function ***/

  defineInstancePolyfill(sugarFunction, {

     /***
     * @method bind(context, [arg1], ...)
     * @returns Function
     * @polyfill ES5
     * @short Binds `context` as the `this` object for the function when it is
     *        called. Also allows currying an unlimited number of parameters.
     * @extra "currying" means setting parameters ([arg1], [arg2], etc.) ahead of
     *        time so that they are passed when the function is called later. If
     *        you pass additional parameters when the function is actually called,
     *        they will be added to the end of the curried parameters.
     *
     * @example
     *
     *   logThis.bind('woof')()   -> logs 'woof' as its this object
     *   addArgs.bind(1, 2, 3)()  -> returns 5 with 1 as the this object
     *   addArgs.bind(1)(2, 3, 4) -> returns 9
     *
     ***/
    'bind': function(context) {
      // Optimized: no leaking arguments
      var boundArgs = []; for(var $i = 1, $len = arguments.length; $i < $len; $i++) boundArgs.push(arguments[$i]);
      var fn = this, bound;
      assertCallable(this);
      bound = function() {
        // Optimized: no leaking arguments
        var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
        return fn.apply(fn.prototype && this instanceof fn ? this : context, boundArgs.concat(args));
      };
      bound.prototype = this.prototype;
      return bound;
    }

  });


  /*** @namespace Date ***/

  defineStaticPolyfill(sugarDate, {

     /***
     * @method now()
     * @returns String
     * @polyfill ES5
     * @static
     * @short Returns the current time as a Unix timestamp.
     * @extra The number of milliseconds since January 1st, 1970 00:00:00 (UTC).
     *
     * @example
     *
     *   Date.now() -> ex. 1311938296231
     *
     ***/
    'now': function() {
      return new Date().getTime();
    }

  });

  function hasISOSupport() {
    var d = new Date(Date.UTC(2000, 0));
    return !!d.toISOString && d.toISOString() === '2000-01-01T00:00:00.000Z';
  }

  defineInstancePolyfill(sugarDate, {

     /***
     * @method toISOString()
     * @returns String
     * @polyfill ES5
     * @short Formats the string to ISO8601 format.
     * @extra This will always format as UTC time.
     *
     * @example
     *
     *   Date.create().toISOString() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toISOString': function() {
      return padNumber(this.getUTCFullYear(), 4) + '-' +
             padNumber(this.getUTCMonth() + 1, 2) + '-' +
             padNumber(this.getUTCDate(), 2) + 'T' +
             padNumber(this.getUTCHours(), 2) + ':' +
             padNumber(this.getUTCMinutes(), 2) + ':' +
             padNumber(this.getUTCSeconds(), 2) + '.' +
             padNumber(this.getUTCMilliseconds(), 3) + 'Z';
    },

     /***
     * @method toJSON([key])
     * @returns String
     * @polyfill ES5
     * @short Returns a JSON representation of the date.
     * @extra This is effectively an alias for `toISOString`. Will always return
     *        the date in UTC time. [key] is ignored.
     *
     * @example
     *
     *   Date.create().toJSON() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toJSON': function(key) {
      return this.toISOString(key);
    }

  }, !hasISOSupport());

}).call(commonjsGlobal$1);
}(sugarCore));

function isArrayIndex$2(n) {
  return n >>> 0 == n && n != 0xFFFFFFFF;
}

var isArrayIndex_1 = isArrayIndex$2;

var isArrayIndex$1 = isArrayIndex_1;

function getSparseArrayIndexes$1(arr, fromIndex, loop, fromRight) {
  var indexes = [], i;
  for (i in arr) {
    // istanbul ignore next
    if (isArrayIndex$1(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
      indexes.push(+i);
    }
  }
  indexes.sort(function(a, b) {
    var aLoop = a > fromIndex;
    var bLoop = b > fromIndex;
    // This block cannot be reached unless ES5 methods are being shimmed.
    // istanbul ignore if
    if (aLoop !== bLoop) {
      return aLoop ? -1 : 1;
    }
    return a - b;
  });
  return indexes;
}

var getSparseArrayIndexes_1 = getSparseArrayIndexes$1;

var getSparseArrayIndexes = getSparseArrayIndexes_1;

function iterateOverSparseArray$1(arr, fn, fromIndex, loop) {
  var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
  for (var i = 0, len = indexes.length; i < len; i++) {
    index = indexes[i];
    fn.call(arr, arr[index], index, arr);
  }
  return arr;
}

var iterateOverSparseArray_1 = iterateOverSparseArray$1;

var iterateOverSparseArray = iterateOverSparseArray_1;

function forEach$j(arr, fn) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (!(i in arr)) {
      return iterateOverSparseArray(arr, fn, i);
    }
    fn(arr[i], i);
  }
}

var forEach_1 = forEach$j;

var NATIVE_TYPES$2 = 'Boolean Number String Date RegExp Function Array Error Set Map';

var Sugar$6b = sugarCore.exports;

var coreUtilityAliases$M = {
  hasOwn: Sugar$6b.util.hasOwn,
  getOwn: Sugar$6b.util.getOwn,
  setProperty: Sugar$6b.util.setProperty,
  classToString: Sugar$6b.util.classToString,
  defineProperty: Sugar$6b.util.defineProperty,
  forEachProperty: Sugar$6b.util.forEachProperty,
  mapNativeToChainable: Sugar$6b.util.mapNativeToChainable
};

var coreUtilityAliases$L = coreUtilityAliases$M;

var classToString$5 = coreUtilityAliases$L.classToString;

function isClass$2(obj, className, str) {
  if (!str) {
    str = classToString$5(obj);
  }
  return str === '[object '+ className +']';
}

var isClass_1 = isClass$2;

function spaceSplit$6(str) {
  return str.split(' ');
}

var spaceSplit_1 = spaceSplit$6;

function isObjectType$e(obj, type) {
  return !!obj && (type || typeof obj) === 'object';
}

var isObjectType_1 = isObjectType$e;

var coreUtilityAliases$K = coreUtilityAliases$M;

var hasOwn$c = coreUtilityAliases$K.hasOwn;

function hasOwnEnumeratedProperties$1(obj) {
  // Plain objects are generally defined as having enumerated properties
  // all their own, however in early IE environments without defineProperty,
  // there may also be enumerated methods in the prototype chain, so check
  // for both of these cases.
  var objectProto = Object.prototype;
  for (var key in obj) {
    var val = obj[key];
    if (!hasOwn$c(obj, key) && val !== objectProto[key]) {
      return false;
    }
  }
  return true;
}

var hasOwnEnumeratedProperties_1 = hasOwnEnumeratedProperties$1;

var coreUtilityAliases$J = coreUtilityAliases$M;

var hasOwn$b = coreUtilityAliases$J.hasOwn;

function hasValidPlainObjectPrototype$1(obj) {
  var hasToString = 'toString' in obj;
  var hasConstructor = 'constructor' in obj;
  // An object created with Object.create(null) has no methods in the
  // prototype chain, so check if any are missing. The additional hasToString
  // check is for false positives on some host objects in old IE which have
  // toString but no constructor. If the object has an inherited constructor,
  // then check if it is Object (the "isPrototypeOf" tapdance here is a more
  // robust way of ensuring this if the global has been hijacked). Note that
  // accessing the constructor directly (without "in" or "hasOwnProperty")
  // will throw a permissions error in IE8 on cross-domain windows.
  return (!hasConstructor && !hasToString) ||
          (hasConstructor && !hasOwn$b(obj, 'constructor') &&
           hasOwn$b(obj.constructor.prototype, 'isPrototypeOf'));
}

var hasValidPlainObjectPrototype_1 = hasValidPlainObjectPrototype$1;

var isClass$1 = isClass_1,
    isObjectType$d = isObjectType_1,
    hasOwnEnumeratedProperties = hasOwnEnumeratedProperties_1,
    hasValidPlainObjectPrototype = hasValidPlainObjectPrototype_1;

function isPlainObject$4(obj, className) {
  return isObjectType$d(obj) &&
         isClass$1(obj, 'Object', className) &&
         hasValidPlainObjectPrototype(obj) &&
         hasOwnEnumeratedProperties(obj);
}

var isPlainObject_1 = isPlainObject$4;

var NATIVE_TYPES$1 = NATIVE_TYPES$2,
    forEach$i = forEach_1,
    isClass = isClass_1,
    spaceSplit$5 = spaceSplit_1,
    isPlainObject$3 = isPlainObject_1;

var isSerializable$2,
    isBoolean$5, isNumber$d, isString$k,
    isDate$a, isRegExp$7, isFunction$d,
    isArray$f, isSet$2, isMap$2, isError$2;

function buildClassChecks() {

  var knownTypes = {};

  function addCoreTypes() {

    var names = spaceSplit$5(NATIVE_TYPES$1);

    isBoolean$5 = buildPrimitiveClassCheck(names[0]);
    isNumber$d  = buildPrimitiveClassCheck(names[1]);
    isString$k  = buildPrimitiveClassCheck(names[2]);

    isDate$a   = buildClassCheck(names[3]);
    isRegExp$7 = buildClassCheck(names[4]);

    // Wanted to enhance performance here by using simply "typeof"
    // but Firefox has two major issues that make this impossible,
    // one fixed, the other not, so perform a full class check here.
    //
    // 1. Regexes can be typeof "function" in FF < 3
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
    //
    // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
    isFunction$d = buildClassCheck(names[5]);

    // istanbul ignore next
    isArray$f = Array.isArray || buildClassCheck(names[6]);
    isError$2 = buildClassCheck(names[7]);

    isSet$2 = buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
    isMap$2 = buildClassCheck(names[9], typeof Map !== 'undefined' && Map);

    // Add core types as known so that they can be checked by value below,
    // notably excluding Functions and adding Arguments and Error.
    addKnownType('Arguments');
    addKnownType(names[0]);
    addKnownType(names[1]);
    addKnownType(names[2]);
    addKnownType(names[3]);
    addKnownType(names[4]);
    addKnownType(names[6]);

  }

  function addArrayTypes() {
    var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
    forEach$i(spaceSplit$5(types), function(str) {
      addKnownType(str + 'Array');
    });
  }

  function addKnownType(className) {
    var str = '[object '+ className +']';
    knownTypes[str] = true;
  }

  function isKnownType(className) {
    return knownTypes[className];
  }

  function buildClassCheck(className, globalObject) {
    // istanbul ignore if
    if (globalObject && isClass(new globalObject, 'Object')) {
      return getConstructorClassCheck(globalObject);
    } else {
      return getToStringClassCheck(className);
    }
  }

  // Map and Set may be [object Object] in certain IE environments.
  // In this case we need to perform a check using the constructor
  // instead of Object.prototype.toString.
  // istanbul ignore next
  function getConstructorClassCheck(obj) {
    var ctorStr = String(obj);
    return function(obj) {
      return String(obj.constructor) === ctorStr;
    };
  }

  function getToStringClassCheck(className) {
    return function(obj, str) {
      // perf: Returning up front on instanceof appears to be slower.
      return isClass(obj, className, str);
    };
  }

  function buildPrimitiveClassCheck(className) {
    var type = className.toLowerCase();
    return function(obj) {
      var t = typeof obj;
      return t === type || t === 'object' && isClass(obj, className);
    };
  }

  addCoreTypes();
  addArrayTypes();

  isSerializable$2 = function(obj, className) {
    // Only known objects can be serialized. This notably excludes functions,
    // host objects, Symbols (which are matched by reference), and instances
    // of classes. The latter can arguably be matched by value, but
    // distinguishing between these and host objects -- which should never be
    // compared by value -- is very tricky so not dealing with it here.
    return isKnownType(className) || isPlainObject$3(obj, className);
  };

}

buildClassChecks();

var classChecks$Z = {
  isSerializable: isSerializable$2,
  isBoolean: isBoolean$5,
  isNumber: isNumber$d,
  isString: isString$k,
  isDate: isDate$a,
  isRegExp: isRegExp$7,
  isFunction: isFunction$d,
  isArray: isArray$f,
  isSet: isSet$2,
  isMap: isMap$2,
  isError: isError$2
};

function getNormalizedIndex$2(index, length, loop) {
  if (index && loop) {
    index = index % length;
  }
  if (index < 0) index = length + index;
  return index;
}

var getNormalizedIndex_1 = getNormalizedIndex$2;

var getNormalizedIndex$1 = getNormalizedIndex_1;

function entryAtIndex$1(obj, index, length, loop, isString) {
  index = getNormalizedIndex$1(index, length, loop);
  return isString ? obj.charAt(index) : obj[index];
}

var entryAtIndex_1 = entryAtIndex$1;

var forEach$h = forEach_1,
    classChecks$Y = classChecks$Z,
    entryAtIndex = entryAtIndex_1;

var isArray$e = classChecks$Y.isArray;

function getEntriesForIndexes$2(obj, find, loop, isString) {
  var result, length = obj.length;
  if (!isArray$e(find)) {
    return entryAtIndex(obj, find, length, loop, isString);
  }
  result = new Array(find.length);
  forEach$h(find, function(index, i) {
    result[i] = entryAtIndex(obj, index, length, loop, isString);
  });
  return result;
}

var getEntriesForIndexes_1 = getEntriesForIndexes$2;

var Sugar$6a = sugarCore.exports,
    getEntriesForIndexes$1 = getEntriesForIndexes_1;

Sugar$6a.String.defineInstance({

  'at': function(str, index, loop) {
    return getEntriesForIndexes$1(str, index, loop, true);
  }

});

Sugar$6a.String.at;

var CAMELIZE_REG$1 = /(^|_)([^_]+)/g;

var Inflections$4 = {};

var Inflections$3 = Inflections$4;

function getAcronym$2(str) {
  // istanbul ignore next
  return Inflections$3.acronyms && Inflections$3.acronyms.find(str);
}

var getAcronym_1 = getAcronym$2;

var Inflections$2 = Inflections$4;

function stringUnderscore$4(str) {
  var areg = Inflections$2.acronyms && Inflections$2.acronyms.reg;
  // istanbul ignore if
  if (areg) {
    str = str.replace(areg, function(acronym, index) {
      return (index > 0 ? '_' : '') + acronym.toLowerCase();
    });
  }
  return str
    .replace(/[-\s]+/g, '_')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g,'$1_$2')
    .replace(/([a-z\d])([A-Z])/g,'$1_$2')
    .toLowerCase();
}

var stringUnderscore_1 = stringUnderscore$4;

var CAPITALIZE_REG$1 = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;

function simpleCapitalize$4(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var simpleCapitalize_1 = simpleCapitalize$4;

var CAPITALIZE_REG = CAPITALIZE_REG$1,
    simpleCapitalize$3 = simpleCapitalize_1;

function stringCapitalize$3(str, downcase, all) {
  if (downcase) {
    str = str.toLowerCase();
  }
  return all ? str.replace(CAPITALIZE_REG, simpleCapitalize$3) : simpleCapitalize$3(str);
}

var stringCapitalize_1 = stringCapitalize$3;

var CAMELIZE_REG = CAMELIZE_REG$1,
    getAcronym$1 = getAcronym_1,
    stringUnderscore$3 = stringUnderscore_1,
    stringCapitalize$2 = stringCapitalize_1;

function stringCamelize$1(str, upper) {
  str = stringUnderscore$3(str);
  return str.replace(CAMELIZE_REG, function(match, pre, word, index) {
    var cap = upper !== false || index > 0, acronym;
    acronym = getAcronym$1(word);
    // istanbul ignore if
    if (acronym && cap) {
      return acronym;
    }
    return cap ? stringCapitalize$2(word, true) : word;
  });
}

var stringCamelize_1 = stringCamelize$1;

var Sugar$69 = sugarCore.exports,
    stringCamelize = stringCamelize_1;

Sugar$69.String.defineInstance({

  'camelize': function(str, upper) {
    return stringCamelize(str, upper);
  }

});

Sugar$69.String.camelize;

var Sugar$68 = sugarCore.exports,
    stringCapitalize$1 = stringCapitalize_1;

Sugar$68.String.defineInstance({

  'capitalize': function(str, lower, all) {
    return stringCapitalize$1(str, lower, all);
  }

});

Sugar$68.String.capitalize;

function isDefined$j(o) {
  return o !== undefined;
}

var isDefined_1 = isDefined$j;

var classChecks$X = classChecks$Z;

var isString$j = classChecks$X.isString;

function escapeRegExp$6(str) {
  if (!isString$j(str)) str = String(str);
  return str.replace(/([\\/'*+?|()[\]{}.^$-])/g,'\\$1');
}

var escapeRegExp_1 = escapeRegExp$6;

function getRegExpFlags$6(reg, add) {
  var flags = '';
  add = add || '';
  function checkFlag(prop, flag) {
    if (prop || add.indexOf(flag) > -1) {
      flags += flag;
    }
  }
  checkFlag(reg.global, 'g');
  checkFlag(reg.ignoreCase, 'i');
  checkFlag(reg.multiline, 'm');
  checkFlag(reg.sticky, 'y');
  return flags;
}

var getRegExpFlags_1 = getRegExpFlags$6;

function runGlobalMatch$1(str, reg) {
  var result = [], match, lastLastIndex;
  while ((match = reg.exec(str)) != null) {
    if (reg.lastIndex === lastLastIndex) {
      reg.lastIndex += 1;
    } else {
      result.push(match[0]);
    }
    lastLastIndex = reg.lastIndex;
  }
  return result;
}

var runGlobalMatch_1 = runGlobalMatch$1;

var isDefined$i = isDefined_1,
    classChecks$W = classChecks$Z,
    escapeRegExp$5 = escapeRegExp_1,
    getRegExpFlags$5 = getRegExpFlags_1,
    runGlobalMatch = runGlobalMatch_1;

var isString$i = classChecks$W.isString,
    isRegExp$6 = classChecks$W.isRegExp,
    isFunction$c = classChecks$W.isFunction;

function stringEach$5(str, search, fn) {
  var chunks, chunk, reg, result = [];
  if (isFunction$c(search)) {
    fn = search;
    reg = /[\s\S]/g;
  } else if (!search) {
    reg = /[\s\S]/g;
  } else if (isString$i(search)) {
    reg = RegExp(escapeRegExp$5(search), 'gi');
  } else if (isRegExp$6(search)) {
    reg = RegExp(search.source, getRegExpFlags$5(search, 'g'));
  }
  // Getting the entire array of chunks up front as we need to
  // pass this into the callback function as an argument.
  chunks = runGlobalMatch(str, reg);

  if (chunks) {
    for(var i = 0, len = chunks.length, r; i < len; i++) {
      chunk = chunks[i];
      result[i] = chunk;
      if (fn) {
        r = fn.call(str, chunk, i, chunks);
        if (r === false) {
          break;
        } else if (isDefined$i(r)) {
          result[i] = r;
        }
      }
    }
  }
  return result;
}

var stringEach_1 = stringEach$5;

var Sugar$67 = sugarCore.exports,
    stringEach$4 = stringEach_1;

Sugar$67.String.defineInstance({

  'chars': function(str, search, eachCharFn) {
    return stringEach$4(str, search, eachCharFn);
  }

});

Sugar$67.String.chars;

function stringCodes$2(str, fn) {
  var codes = new Array(str.length), i, len;
  for(i = 0, len = str.length; i < len; i++) {
    var code = str.charCodeAt(i);
    codes[i] = code;
    if (fn) {
      fn.call(str, code, i, str);
    }
  }
  return codes;
}

var stringCodes_1 = stringCodes$2;

var Sugar$66 = sugarCore.exports,
    stringCodes$1 = stringCodes_1;

Sugar$66.String.defineInstance({

  'codes': function(str, eachCodeFn) {
    return stringCodes$1(str, eachCodeFn);
  }

});

Sugar$66.String.codes;

function trim$6(str) {
  return str.trim();
}

var trim_1 = trim$6;

var Sugar$65 = sugarCore.exports,
    trim$5 = trim_1;

Sugar$65.String.defineInstance({

  'compact': function(str) {
    return trim$5(str).replace(/([\r\n\s　])+/g, function(match, whitespace) {
      return whitespace === '　' ? whitespace : ' ';
    });
  }

});

Sugar$65.String.compact;

var Sugar$64 = sugarCore.exports,
    stringUnderscore$2 = stringUnderscore_1;

Sugar$64.String.defineInstance({

  'dasherize': function(str) {
    return stringUnderscore$2(str).replace(/_/g, '-');
  }

});

Sugar$64.String.dasherize;

var chr$6 = String.fromCharCode;

var chr$5 = chr$6;

var encodeBase64$1, decodeBase64$1;

function buildBase64() {
  var encodeAscii, decodeAscii;

  // istanbul ignore next
  function catchEncodingError(fn) {
    return function(str) {
      try {
        return fn(str);
      } catch(e) {
        return '';
      }
    };
  }

  // istanbul ignore if
  if (typeof Buffer !== 'undefined') {
    encodeBase64$1 = function(str) {
      return Buffer.from(str).toString('base64');
    };
    decodeBase64$1 = function(str) {
      return Buffer.from(str, 'base64').toString('utf8');
    };
    return;
  }

  // istanbul ignore if
  if (typeof btoa !== 'undefined') {
    encodeAscii = catchEncodingError(btoa);
    decodeAscii = catchEncodingError(atob);
  } else {
    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var base64reg = /[^A-Za-z0-9\+\/\=]/g;
    encodeAscii = function(str) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      do {
        chr1 = str.charCodeAt(i++);
        chr2 = str.charCodeAt(i++);
        chr3 = str.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output += key.charAt(enc1);
        output += key.charAt(enc2);
        output += key.charAt(enc3);
        output += key.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < str.length);
      return output;
    };
    decodeAscii = function(input) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      if (input.match(base64reg)) {
        return '';
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      do {
        enc1 = key.indexOf(input.charAt(i++));
        enc2 = key.indexOf(input.charAt(i++));
        enc3 = key.indexOf(input.charAt(i++));
        enc4 = key.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + chr$5(chr1);
        if (enc3 != 64) {
          output = output + chr$5(chr2);
        }
        if (enc4 != 64) {
          output = output + chr$5(chr3);
        }
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);
      return output;
    };
  }
  encodeBase64$1 = function(str) {
    return encodeAscii(unescape(encodeURIComponent(str)));
  };
  decodeBase64$1 = function(str) {
    return decodeURIComponent(escape(decodeAscii(str)));
  };
}

buildBase64();

var base64$2 = {
  encodeBase64: encodeBase64$1,
  decodeBase64: decodeBase64$1
};

var Sugar$63 = sugarCore.exports,
    base64$1 = base64$2;

var decodeBase64 = base64$1.decodeBase64;

Sugar$63.String.defineInstance({

  'decodeBase64': function(str) {
    return decodeBase64(str);
  }

});

Sugar$63.String.decodeBase64;

var Sugar$62 = sugarCore.exports,
    base64 = base64$2;

var encodeBase64 = base64.encodeBase64;

Sugar$62.String.defineInstance({

  'encodeBase64': function(str) {
    return encodeBase64(str);
  }

});

Sugar$62.String.encodeBase64;

var HTML_ESCAPE_REG$1 = /[&<>]/g;

var HTMLFromEntityMap$2 = {
  'lt':    '<',
  'gt':    '>',
  'amp':   '&',
  'nbsp':  ' ',
  'quot':  '"',
  'apos':  "'"
};

var HTMLFromEntityMap_1 = HTMLFromEntityMap$2;

var HTMLFromEntityMap$1 = HTMLFromEntityMap_1,
    coreUtilityAliases$I = coreUtilityAliases$M;

var forEachProperty$n = coreUtilityAliases$I.forEachProperty;

var HTMLToEntityMap$1;

function buildEntities() {
  HTMLToEntityMap$1 = {};
  forEachProperty$n(HTMLFromEntityMap$1, function(val, key) {
    HTMLToEntityMap$1[val] = '&' + key + ';';
  });
}

buildEntities();

var HTMLToEntityMap_1 = HTMLToEntityMap$1;

var Sugar$61 = sugarCore.exports,
    HTML_ESCAPE_REG = HTML_ESCAPE_REG$1,
    HTMLToEntityMap = HTMLToEntityMap_1,
    coreUtilityAliases$H = coreUtilityAliases$M;

var getOwn$c = coreUtilityAliases$H.getOwn;

Sugar$61.String.defineInstance({

  'escapeHTML': function(str) {
    return str.replace(HTML_ESCAPE_REG, function(chr) {
      return getOwn$c(HTMLToEntityMap, chr);
    });
  }

});

Sugar$61.String.escapeHTML;

var Sugar$60 = sugarCore.exports;

Sugar$60.String.defineInstance({

  'escapeURL': function(str, param) {
    return param ? encodeURIComponent(str) : encodeURI(str);
  }

});

Sugar$60.String.escapeURL;

function isUndefined$l(o) {
  return o === undefined;
}

var isUndefined_1 = isUndefined$l;

var Sugar$5$ = sugarCore.exports,
    isUndefined$k = isUndefined_1;

Sugar$5$.String.defineInstance({

  'first': function(str, num) {
    if (isUndefined$k(num)) num = 1;
    return str.substr(0, num);
  }

});

Sugar$5$.String.first;

var Sugar$5_ = sugarCore.exports,
    stringEach$3 = stringEach_1;

Sugar$5_.String.defineInstance({

  'forEach': function(str, search, eachFn) {
    return stringEach$3(str, search, eachFn);
  }

});

Sugar$5_.String.forEach;

var PROPERTY_RANGE_REG$1 = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;

var CommonChars$8 = {
  HALF_WIDTH_ZERO: 0x30,
  FULL_WIDTH_ZERO: 0xff10,
  HALF_WIDTH_PERIOD: '.',
  FULL_WIDTH_PERIOD: '．',
  HALF_WIDTH_COMMA: ',',
  OPEN_BRACE: '{',
  CLOSE_BRACE: '}'
};

function map$7(arr, fn) {
  // perf: Not using fixed array len here as it may be sparse.
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr) {
      result.push(fn(arr[i], i));
    }
  }
  return result;
}

var map_1 = map$7;

var CommonChars$7 = CommonChars$8;

var HALF_WIDTH_PERIOD$4 = CommonChars$7.HALF_WIDTH_PERIOD;

function periodSplit$3(str) {
  return str.split(HALF_WIDTH_PERIOD$4);
}

var periodSplit_1 = periodSplit$3;

var classChecks$V = classChecks$Z;

var isArray$d = classChecks$V.isArray;

function assertArray$1(obj) {
  if (!isArray$d(obj)) {
    throw new TypeError('Array required');
  }
}

var assertArray_1 = assertArray$1;

function isPrimitive$7(obj, type) {
  type = type || typeof obj;
  return obj == null || type === 'string' || type === 'number' || type === 'boolean';
}

var isPrimitive_1 = isPrimitive$7;

var isPrimitive$6 = isPrimitive_1;

function assertWritable$1(obj) {
  if (isPrimitive$6(obj)) {
    // If strict mode is active then primitives will throw an
    // error when attempting to write properties. We can't be
    // sure if strict mode is available, so pre-emptively
    // throw an error here to ensure consistent behavior.
    throw new TypeError('Property cannot be written');
  }
}

var assertWritable_1 = assertWritable$1;

var PROPERTY_RANGE_REG = PROPERTY_RANGE_REG$1,
    CommonChars$6 = CommonChars$8,
    map$6 = map_1,
    isDefined$h = isDefined_1,
    classChecks$U = classChecks$Z,
    periodSplit$2 = periodSplit_1,
    assertArray = assertArray_1,
    isObjectType$c = isObjectType_1,
    assertWritable = assertWritable_1,
    coreUtilityAliases$G = coreUtilityAliases$M;

var isString$h = classChecks$U.isString,
    hasOwn$a = coreUtilityAliases$G.hasOwn,
    HALF_WIDTH_PERIOD$3 = CommonChars$6.HALF_WIDTH_PERIOD;

function handleDeepProperty$3(obj, key, any, has, fill, fillLast, val) {
  var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
  ns = obj;
  if (key == null) return;

  if (isObjectType$c(key)) {
    // Allow array and array-like accessors
    bs = [key];
  } else {
    key = String(key);
    if (key.indexOf('..') !== -1) {
      return handleArrayIndexRange(obj, key, any, val);
    }
    bs = key.split('[');
  }

  set = isDefined$h(val);

  for (var i = 0, blen = bs.length; i < blen; i++) {
    ps = bs[i];

    if (isString$h(ps)) {
      ps = periodSplit$2(ps);
    }

    for (var j = 0, plen = ps.length; j < plen; j++) {
      key = ps[j];

      // Is this the last key?
      isLast = i === blen - 1 && j === plen - 1;

      // Index of the closing ]
      cbi = key.indexOf(']');

      // Is the key an array index?
      isIndex = cbi !== -1;

      // Is this array push syntax "[]"?
      isPush = set && cbi === 0;

      // If the bracket split was successful and this is the last element
      // in the dot split, then we know the next key will be an array index.
      nextIsIndex = blen > 1 && j === plen - 1;

      if (isPush) {
        // Set the index to the end of the array
        key = ns.length;
      } else if (isIndex) {
        // Remove the closing ]
        key = key.slice(0, -1);
      }

      // If the array index is less than 0, then
      // add its length to allow negative indexes.
      if (isIndex && key < 0) {
        key = +key + ns.length;
      }

      // Bracket keys may look like users[5] or just [5], so the leading
      // characters are optional. We can enter the namespace if this is the
      // 2nd part, if there is only 1 part, or if there is an explicit key.
      if (i || key || blen === 1) {

        // TODO: need to be sure this check handles ''.length when
        // we refactor.
        exists = any ? key in Object(ns) : hasOwn$a(ns, key);

        // Non-existent namespaces are only filled if they are intermediate
        // (not at the end) or explicitly filling the last.
        if (fill && (!isLast || fillLast) && !exists) {
          // For our purposes, last only needs to be an array.
          ns = ns[key] = nextIsIndex || (fillLast && isLast) ? [] : {};
          continue;
        }

        if (has) {
          if (isLast || !exists) {
            return exists;
          }
        } else if (set && isLast) {
          assertWritable(ns);
          ns[key] = val;
        }

        ns = exists ? ns[key] : undefined;
      }

    }
  }
  return ns;
}

function handleArrayIndexRange(obj, key, any, val) {
  var match, start, end, leading, trailing, arr, set;
  match = key.match(PROPERTY_RANGE_REG);
  if (!match) {
    return;
  }

  set = isDefined$h(val);
  leading = match[1];

  if (leading) {
    arr = handleDeepProperty$3(obj, leading, any, false, set ? true : false, true);
  } else {
    arr = obj;
  }

  assertArray(arr);

  trailing = match[4];
  start    = match[2] ? +match[2] : 0;
  end      = match[3] ? +match[3] : arr.length;

  // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
  // pushes the index from -1 to 0, then set it to the full length of the
  // array, otherwise it will return nothing.
  end = end === -1 ? arr.length : end + 1;

  if (set) {
    for (var i = start; i < end; i++) {
      handleDeepProperty$3(arr, i + trailing, any, false, true, false, val);
    }
  } else {
    arr = arr.slice(start, end);

    // If there are trailing properties, then they need to be mapped for each
    // element in the array.
    if (trailing) {
      if (trailing.charAt(0) === HALF_WIDTH_PERIOD$3) {
        // Need to chomp the period if one is trailing after the range. We
        // can't do this at the regex level because it will be required if
        // we're setting the value as it needs to be concatentated together
        // with the array index to be set.
        trailing = trailing.slice(1);
      }
      return map$6(arr, function(el) {
        return handleDeepProperty$3(el, trailing);
      });
    }
  }
  return arr;
}

var handleDeepProperty_1 = handleDeepProperty$3;

var handleDeepProperty$2 = handleDeepProperty_1;

function deepGetProperty$4(obj, key, any) {
  return handleDeepProperty$2(obj, key, any, false);
}

var deepGetProperty_1 = deepGetProperty$4;

var STRING_FORMAT_REG$1 = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;

var INTERNAL_MEMOIZE_LIMIT$1 = 1000;

var INTERNAL_MEMOIZE_LIMIT = INTERNAL_MEMOIZE_LIMIT$1,
    coreUtilityAliases$F = coreUtilityAliases$M;

var hasOwn$9 = coreUtilityAliases$F.hasOwn;

function memoizeFunction$1(fn) {
  var memo = {}, counter = 0;

  return function(key) {
    if (hasOwn$9(memo, key)) {
      return memo[key];
    }
    // istanbul ignore if
    if (counter === INTERNAL_MEMOIZE_LIMIT) {
      memo = {};
      counter = 0;
    }
    counter++;
    return memo[key] = fn(key);
  };
}

var memoizeFunction_1 = memoizeFunction$1;

var STRING_FORMAT_REG = STRING_FORMAT_REG$1,
    CommonChars$5 = CommonChars$8,
    memoizeFunction = memoizeFunction_1;

var OPEN_BRACE = CommonChars$5.OPEN_BRACE,
    CLOSE_BRACE = CommonChars$5.CLOSE_BRACE;

function createFormatMatcher$2(bracketMatcher, percentMatcher, precheck) {

  var reg = STRING_FORMAT_REG;
  var compileMemoized = memoizeFunction(compile);

  function getToken(format, match) {
    var get, token, literal, fn;
    var bKey = match[2];
    var pLit = match[3];
    var pKey = match[5];
    if (match[4] && percentMatcher) {
      token = pKey;
      get = percentMatcher;
    } else if (bKey) {
      token = bKey;
      get = bracketMatcher;
    } else if (pLit && percentMatcher) {
      literal = pLit;
    } else {
      literal = match[1] || match[0];
    }
    if (get) {
      assertPassesPrecheck(precheck, bKey, pKey);
      fn = function(obj, opt) {
        return get(obj, token, opt);
      };
    }
    format.push(fn || getLiteral(literal));
  }

  function getSubstring(format, str, start, end) {
    if (end > start) {
      var sub = str.slice(start, end);
      assertNoUnmatched(sub, OPEN_BRACE);
      assertNoUnmatched(sub, CLOSE_BRACE);
      format.push(function() {
        return sub;
      });
    }
  }

  function getLiteral(str) {
    return function() {
      return str;
    };
  }

  function assertPassesPrecheck(precheck, bt, pt) {
    if (precheck && !precheck(bt, pt)) {
      throw new TypeError('Invalid token '+ (bt || pt) +' in format string');
    }
  }

  function assertNoUnmatched(str, chr) {
    if (str.indexOf(chr) !== -1) {
      throw new TypeError('Unmatched '+ chr +' in format string');
    }
  }

  function compile(str) {
    var format = [], lastIndex = 0, match;
    reg.lastIndex = 0;
    while(match = reg.exec(str)) {
      getSubstring(format, str, lastIndex, match.index);
      getToken(format, match);
      lastIndex = reg.lastIndex;
    }
    getSubstring(format, str, lastIndex, str.length);
    return format;
  }

  return function(str, obj, opt) {
    var format = compileMemoized(str), result = '';
    for (var i = 0; i < format.length; i++) {
      result += format[i](obj, opt);
    }
    return result;
  };
}

var createFormatMatcher_1 = createFormatMatcher$2;

var deepGetProperty$3 = deepGetProperty_1,
    createFormatMatcher$1 = createFormatMatcher_1;

var stringFormatMatcher$1 = createFormatMatcher$1(deepGetProperty$3);

var Sugar$5Z = sugarCore.exports,
    isObjectType$b = isObjectType_1,
    stringFormatMatcher = stringFormatMatcher$1;

Sugar$5Z.String.defineInstanceWithArguments({

  'format': function(str, args) {
    var arg1 = args[0] && args[0].valueOf();
    // Unwrap if a single object is passed in.
    if (args.length === 1 && isObjectType$b(arg1)) {
      args = arg1;
    }
    return stringFormatMatcher(str, args);
  }

});

Sugar$5Z.String.format;

var classChecks$T = classChecks$Z;

var isString$g = classChecks$T.isString;

function numberOrIndex$2(str, n, from) {
  if (isString$g(n)) {
    n = str.indexOf(n);
    if (n === -1) {
      n = from ? str.length : 0;
    }
  }
  return n;
}

var numberOrIndex_1 = numberOrIndex$2;

var Sugar$5Y = sugarCore.exports,
    numberOrIndex$1 = numberOrIndex_1;

Sugar$5Y.String.defineInstance({

  'from': function(str, from) {
    return str.slice(numberOrIndex$1(str, from, true));
  }

});

Sugar$5Y.String.from;

var ENHANCEMENTS_FLAG$7 = 'enhance';

var STRING_ENHANCEMENTS_FLAG$1 = 'enhanceString';

function fixArgumentLength$9(fn) {
  var staticFn = function(a) {
    var args = arguments;
    return fn(a, args[1], args[2], args.length - 1);
  };
  staticFn.instance = function(b) {
    var args = arguments;
    return fn(this, b, args[1], args.length);
  };
  return staticFn;
}

var fixArgumentLength_1 = fixArgumentLength$9;

var nativeIncludes$1 = String.prototype.includes;

var classChecks$S = classChecks$Z,
    nativeIncludes = nativeIncludes$1;

var isRegExp$5 = classChecks$S.isRegExp;

function callIncludesWithRegexSupport$1(str, search, position) {
  if (!isRegExp$5(search)) {
    return nativeIncludes.call(str, search, position);
  }
  if (position) {
    str = str.slice(position);
  }
  return search.test(str);
}

var callIncludesWithRegexSupport_1 = callIncludesWithRegexSupport$1;

var Sugar$5X = sugarCore.exports,
    ENHANCEMENTS_FLAG$6 = ENHANCEMENTS_FLAG$7,
    STRING_ENHANCEMENTS_FLAG = STRING_ENHANCEMENTS_FLAG$1,
    fixArgumentLength$8 = fixArgumentLength_1,
    callIncludesWithRegexSupport = callIncludesWithRegexSupport_1;

Sugar$5X.String.defineInstance({

  'includes': fixArgumentLength$8(callIncludesWithRegexSupport)

}, [ENHANCEMENTS_FLAG$6, STRING_ENHANCEMENTS_FLAG]);

Sugar$5X.String.includes;

var Sugar$5W = sugarCore.exports,
    isUndefined$j = isUndefined_1;

Sugar$5W.String.defineInstance({

  'insert': function(str, substr, index) {
    index = isUndefined$j(index) ? str.length : index;
    return str.slice(0, index) + substr + str.slice(index);
  }

});

Sugar$5W.String.insert;

var Sugar$5V = sugarCore.exports,
    trim$4 = trim_1;

Sugar$5V.String.defineInstance({

  'isBlank': function(str) {
    return trim$4(str).length === 0;
  }

});

Sugar$5V.String.isBlank;

var Sugar$5U = sugarCore.exports;

Sugar$5U.String.defineInstance({

  'isEmpty': function(str) {
    return str.length === 0;
  }

});

Sugar$5U.String.isEmpty;

var Sugar$5T = sugarCore.exports,
    isUndefined$i = isUndefined_1;

Sugar$5T.String.defineInstance({

  'last': function(str, num) {
    if (isUndefined$i(num)) num = 1;
    var start = str.length - num < 0 ? 0 : str.length - num;
    return str.substr(start);
  }

});

Sugar$5T.String.last;

var Sugar$5S = sugarCore.exports,
    trim$3 = trim_1,
    stringEach$2 = stringEach_1;

Sugar$5S.String.defineInstance({

  'lines': function(str, eachLineFn) {
    return stringEach$2(trim$3(str), /^.*$/gm, eachLineFn);
  }

});

Sugar$5S.String.lines;

function repeatString$3(str, num) {
  var result = '';
  str = str.toString();
  while (num > 0) {
    if (num & 1) {
      result += str;
    }
    if (num >>= 1) {
      str += str;
    }
  }
  return result;
}

var repeatString_1 = repeatString$3;

var isDefined$g = isDefined_1,
    repeatString$2 = repeatString_1;

function padString$3(num, padding) {
  return repeatString$2(isDefined$g(padding) ? padding : ' ', num);
}

var padString_1 = padString$3;

var mathAliases$z = {
  abs: Math.abs,
  pow: Math.pow,
  min: Math.min,
  max: Math.max,
  ceil: Math.ceil,
  floor: Math.floor,
  round: Math.round
};

var mathAliases$y = mathAliases$z;

var ceil$8 = mathAliases$y.ceil,
    floor$5 = mathAliases$y.floor;

var trunc$c = Math.trunc || function(n) {
  if (n === 0 || !isFinite(n)) return n;
  return n < 0 ? ceil$8(n) : floor$5(n);
};

var trunc_1 = trunc$c;

var trunc$b = trunc_1,
    classChecks$R = classChecks$Z;

var isNumber$c = classChecks$R.isNumber;

function coercePositiveInteger$6(n) {
  n = +n || 0;
  if (n < 0 || !isNumber$c(n) || !isFinite(n)) {
    throw new RangeError('Invalid number');
  }
  return trunc$b(n);
}

var coercePositiveInteger_1 = coercePositiveInteger$6;

var Sugar$5R = sugarCore.exports,
    padString$2 = padString_1,
    mathAliases$x = mathAliases$z,
    coercePositiveInteger$5 = coercePositiveInteger_1;

var max$a = mathAliases$x.max,
    ceil$7 = mathAliases$x.ceil,
    floor$4 = mathAliases$x.floor;

Sugar$5R.String.defineInstance({

  'pad': function(str, num, padding) {
    var half, front, back;
    num   = coercePositiveInteger$5(num);
    half  = max$a(0, num - str.length) / 2;
    front = floor$4(half);
    back  = ceil$7(half);
    return padString$2(front, padding) + str + padString$2(back, padding);
  }

});

Sugar$5R.String.pad;

var Sugar$5Q = sugarCore.exports,
    padString$1 = padString_1,
    mathAliases$w = mathAliases$z,
    coercePositiveInteger$4 = coercePositiveInteger_1;

var max$9 = mathAliases$w.max;

Sugar$5Q.String.defineInstance({

  'padLeft': function(str, num, padding) {
    num = coercePositiveInteger$4(num);
    return padString$1(max$9(0, num - str.length), padding) + str;
  }

});

Sugar$5Q.String.padLeft;

var Sugar$5P = sugarCore.exports,
    padString = padString_1,
    mathAliases$v = mathAliases$z,
    coercePositiveInteger$3 = coercePositiveInteger_1;

var max$8 = mathAliases$v.max;

Sugar$5P.String.defineInstance({

  'padRight': function(str, num, padding) {
    num = coercePositiveInteger$3(num);
    return str + padString(max$8(0, num - str.length), padding);
  }

});

Sugar$5P.String.padRight;

var escapeRegExp$4 = escapeRegExp_1;

function stringParameterize$1(str, separator) {
  if (separator === undefined) separator = '-';
  str = str.replace(/[^a-z0-9\-_]+/gi, separator);
  if (separator) {
    var reg = RegExp('^{s}+|{s}+$|({s}){s}+'.split('{s}').join(escapeRegExp$4(separator)), 'g');
    str = str.replace(reg, '$1');
  }
  return encodeURI(str.toLowerCase());
}

var stringParameterize_1 = stringParameterize$1;

var Sugar$5O = sugarCore.exports,
    stringParameterize = stringParameterize_1;

Sugar$5O.String.defineInstance({

  'parameterize': function(str, separator) {
    return stringParameterize(str, separator);
  }

});

Sugar$5O.String.parameterize;

var Sugar$5N = sugarCore.exports;

Sugar$5N.String.defineInstance({

  'remove': function(str, f) {
    return str.replace(f, '');
  }

});

Sugar$5N.String.remove;

var classChecks$Q = classChecks$Z,
    escapeRegExp$3 = escapeRegExp_1,
    getRegExpFlags$4 = getRegExpFlags_1;

var isString$f = classChecks$Q.isString;

function stringReplaceAll$2(str, f, replace) {
  var i = 0, tokens;
  if (isString$f(f)) {
    f = RegExp(escapeRegExp$3(f), 'g');
  } else if (f && !f.global) {
    f = RegExp(f.source, getRegExpFlags$4(f, 'g'));
  }
  if (!replace) {
    replace = '';
  } else {
    tokens = replace;
    replace = function() {
      var t = tokens[i++];
      return t != null ? t : '';
    };
  }
  return str.replace(f, replace);
}

var stringReplaceAll_1 = stringReplaceAll$2;

var Sugar$5M = sugarCore.exports,
    stringReplaceAll$1 = stringReplaceAll_1;

Sugar$5M.String.defineInstance({

  'removeAll': function(str, f) {
    return stringReplaceAll$1(str, f);
  }

});

Sugar$5M.String.removeAll;

var HTML_VOID_ELEMENTS$1 = [
  'area','base','br','col','command','embed','hr','img',
  'input','keygen','link','meta','param','source','track','wbr'
];

var HTML_VOID_ELEMENTS_1 = HTML_VOID_ELEMENTS$1;

function indexOf$3(arr, el) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr && arr[i] === el) return i;
  }
  return -1;
}

var indexOf_1 = indexOf$3;

var HTML_VOID_ELEMENTS = HTML_VOID_ELEMENTS_1,
    indexOf$2 = indexOf_1;

function tagIsVoid$1(tag) {
  return indexOf$2(HTML_VOID_ELEMENTS, tag.toLowerCase()) !== -1;
}

var tagIsVoid_1 = tagIsVoid$1;

var tagIsVoid = tagIsVoid_1,
    classChecks$P = classChecks$Z;

var isString$e = classChecks$P.isString;

function runTagReplacements$1(str, reg, strip, replacement, fullString) {

  var match;
  var result = '';
  var currentIndex = 0;
  var openTagName;
  var openTagAttributes;
  var openTagCount = 0;

  function processTag(index, tagName, attributes, tagLength, isVoid) {
    var content = str.slice(currentIndex, index), s = '', r = '';
    if (isString$e(replacement)) {
      r = replacement;
    } else if (replacement) {
      r = replacement.call(fullString, tagName, content, attributes, fullString) || '';
    }
    if (strip) {
      s = r;
    } else {
      content = r;
    }
    if (content) {
      content = runTagReplacements$1(content, reg, strip, replacement, fullString);
    }
    result += s + content + (isVoid ? '' : s);
    currentIndex = index + (tagLength || 0);
  }

  fullString = fullString || str;
  reg = RegExp(reg.source, 'gi');

  while(match = reg.exec(str)) {

    var tagName         = match[2];
    var attributes      = (match[3]|| '').slice(1);
    var isClosingTag    = !!match[1];
    var isSelfClosing   = !!match[4];
    var tagLength       = match[0].length;
    var isVoid          = tagIsVoid(tagName);
    var isOpeningTag    = !isClosingTag && !isSelfClosing && !isVoid;
    var isSameAsCurrent = tagName === openTagName;

    if (!openTagName) {
      result += str.slice(currentIndex, match.index);
      currentIndex = match.index;
    }

    if (isOpeningTag) {
      if (!openTagName) {
        openTagName = tagName;
        openTagAttributes = attributes;
        openTagCount++;
        currentIndex += tagLength;
      } else if (isSameAsCurrent) {
        openTagCount++;
      }
    } else if (isClosingTag && isSameAsCurrent) {
      openTagCount--;
      if (openTagCount === 0) {
        processTag(match.index, openTagName, openTagAttributes, tagLength, isVoid);
        openTagName       = null;
        openTagAttributes = null;
      }
    } else if (!openTagName) {
      processTag(match.index, tagName, attributes, tagLength, isVoid);
    }
  }
  if (openTagName) {
    processTag(str.length, openTagName, openTagAttributes);
  }
  result += str.slice(currentIndex);
  return result;
}

var runTagReplacements_1 = runTagReplacements$1;

var map$5 = map_1,
    classChecks$O = classChecks$Z,
    escapeRegExp$2 = escapeRegExp_1,
    runTagReplacements = runTagReplacements_1;

var isString$d = classChecks$O.isString;

function replaceTags$2(str, find, replacement, strip) {
  var tags = isString$d(find) ? [find] : find, reg, src;
  tags = map$5(tags || [], function(t) {
    return escapeRegExp$2(t);
  }).join('|');
  src = tags.replace('all', '') || '[^\\s>]+';
  src = '<(\\/)?(' + src + ')(\\s+[^<>]*?)?\\s*(\\/)?>';
  reg = RegExp(src, 'gi');
  return runTagReplacements(str.toString(), reg, strip, replacement);
}

var replaceTags_1 = replaceTags$2;

var Sugar$5L = sugarCore.exports,
    replaceTags$1 = replaceTags_1;

Sugar$5L.String.defineInstance({

  'removeTags': function(str, tag, replace) {
    return replaceTags$1(str, tag, replace, false);
  }

});

Sugar$5L.String.removeTags;

var Sugar$5K = sugarCore.exports,
    stringReplaceAll = stringReplaceAll_1;

Sugar$5K.String.defineInstanceWithArguments({

  'replaceAll': function(str, f, args) {
    return stringReplaceAll(str, f, args);
  }

});

Sugar$5K.String.replaceAll;

function reverseString$2(str) {
  return str.split('').reverse().join('');
}

var reverseString_1 = reverseString$2;

var Sugar$5J = sugarCore.exports,
    reverseString$1 = reverseString_1;

Sugar$5J.String.defineInstance({

  'reverse': function(str) {
    return reverseString$1(str);
  }

});

Sugar$5J.String.reverse;

var Sugar$5I = sugarCore.exports,
    chr$4 = chr$6,
    stringCodes = stringCodes_1;

Sugar$5I.String.defineInstance({

  'shift': function(str, n) {
    var result = '';
    n = n || 0;
    stringCodes(str, function(c) {
      result += chr$4(c + n);
    });
    return result;
  }

});

Sugar$5I.String.shift;

var stringUnderscore$1 = stringUnderscore_1;

function stringSpacify$2(str) {
  return stringUnderscore$1(str).replace(/_/g, ' ');
}

var stringSpacify_1 = stringSpacify$2;

var Sugar$5H = sugarCore.exports,
    stringSpacify$1 = stringSpacify_1;

Sugar$5H.String.defineInstance({

  'spacify': function(str) {
    return stringSpacify$1(str);
  }

});

Sugar$5H.String.spacify;

var Sugar$5G = sugarCore.exports,
    replaceTags = replaceTags_1;

Sugar$5G.String.defineInstance({

  'stripTags': function(str, tag, replace) {
    return replaceTags(str, tag, replace, true);
  }

});

Sugar$5G.String.stripTags;

var DOWNCASED_WORDS$1 = [
  'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at',
  'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over',
  'with', 'for'
];

var DOWNCASED_WORDS_1 = DOWNCASED_WORDS$1;

var trim$2 = trim_1,
    stringEach$1 = stringEach_1;

function eachWord$1(str, fn) {
  return stringEach$1(trim$2(str), /\S+/g, fn);
}

var eachWord_1 = eachWord$1;

var Inflections$1 = Inflections$4;

function getHumanWord$1(str) {
  // istanbul ignore next
  return Inflections$1.human && Inflections$1.human.find(str);
}

var getHumanWord_1 = getHumanWord$1;

var Inflections = Inflections$4;

function runHumanRules$1(str) {
  // istanbul ignore next
  return Inflections.human && Inflections.human.runRules(str) || str;
}

var runHumanRules_1 = runHumanRules$1;

var DOWNCASED_WORDS = DOWNCASED_WORDS_1,
    indexOf$1 = indexOf_1,
    eachWord = eachWord_1,
    getAcronym = getAcronym_1,
    getHumanWord = getHumanWord_1,
    runHumanRules = runHumanRules_1,
    stringSpacify = stringSpacify_1,
    stringCapitalize = stringCapitalize_1;

function stringTitleize$1(str) {
  var fullStopPunctuation = /[.:;!]$/, lastHadPunctuation;
  str = runHumanRules(str);
  str = stringSpacify(str);
  return eachWord(str, function(word, index, words) {
    word = getHumanWord(word) || word;
    word = getAcronym(word) || word;
    var hasPunctuation, isFirstOrLast;
    var first = index == 0, last = index == words.length - 1;
    hasPunctuation = fullStopPunctuation.test(word);
    isFirstOrLast = first || last || hasPunctuation || lastHadPunctuation;
    lastHadPunctuation = hasPunctuation;
    if (isFirstOrLast || indexOf$1(DOWNCASED_WORDS, word) === -1) {
      return stringCapitalize(word, false, true);
    } else {
      return word;
    }
  }).join(' ');
}

var stringTitleize_1 = stringTitleize$1;

var Sugar$5F = sugarCore.exports,
    stringTitleize = stringTitleize_1;

Sugar$5F.String.defineInstance({

  'titleize': function(str) {
    return stringTitleize(str);
  }

});

Sugar$5F.String.titleize;

var Sugar$5E = sugarCore.exports,
    isUndefined$h = isUndefined_1,
    numberOrIndex = numberOrIndex_1;

Sugar$5E.String.defineInstance({

  'to': function(str, to) {
    if (isUndefined$h(to)) to = str.length;
    return str.slice(0, numberOrIndex(str, to));
  }

});

Sugar$5E.String.to;

function allCharsReg$2(src) {
  return RegExp('[' + src + ']', 'g');
}

var allCharsReg_1 = allCharsReg$2;

var CommonChars$4 = CommonChars$8,
    chr$3 = chr$6,
    allCharsReg$1 = allCharsReg_1;

var HALF_WIDTH_ZERO$1 = CommonChars$4.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO$1 = CommonChars$4.FULL_WIDTH_ZERO,
    HALF_WIDTH_PERIOD$2 = CommonChars$4.HALF_WIDTH_PERIOD,
    FULL_WIDTH_PERIOD = CommonChars$4.FULL_WIDTH_PERIOD,
    HALF_WIDTH_COMMA$2 = CommonChars$4.HALF_WIDTH_COMMA;

var fullWidthNumberReg$1, fullWidthNumberMap$2, fullWidthNumbers$1;

function buildFullWidthNumber() {
  var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD$2, hwc = HALF_WIDTH_COMMA$2, fwn = '';
  fullWidthNumberMap$2 = {};
  for (var i = 0, digit; i <= 9; i++) {
    digit = chr$3(i + FULL_WIDTH_ZERO$1);
    fwn += digit;
    fullWidthNumberMap$2[digit] = chr$3(i + HALF_WIDTH_ZERO$1);
  }
  fullWidthNumberMap$2[hwc] = '';
  fullWidthNumberMap$2[fwp] = hwp;
  // Mapping this to itself to capture it easily
  // in stringToNumber to detect decimals later.
  fullWidthNumberMap$2[hwp] = hwp;
  fullWidthNumberReg$1 = allCharsReg$1(fwn + fwp + hwc + hwp);
  fullWidthNumbers$1 = fwn;
}

buildFullWidthNumber();

var fullwidthNumberHelpers$2 = {
  fullWidthNumberReg: fullWidthNumberReg$1,
  fullWidthNumberMap: fullWidthNumberMap$2,
  fullWidthNumbers: fullWidthNumbers$1
};

var CommonChars$3 = CommonChars$8,
    coreUtilityAliases$E = coreUtilityAliases$M,
    fullwidthNumberHelpers$1 = fullwidthNumberHelpers$2;

var fullWidthNumberReg = fullwidthNumberHelpers$1.fullWidthNumberReg,
    fullWidthNumberMap$1 = fullwidthNumberHelpers$1.fullWidthNumberMap,
    getOwn$b = coreUtilityAliases$E.getOwn,
    HALF_WIDTH_PERIOD$1 = CommonChars$3.HALF_WIDTH_PERIOD;

function stringToNumber$2(str, base) {
  var sanitized, isDecimal;
  sanitized = str.replace(fullWidthNumberReg, function(chr) {
    var replacement = getOwn$b(fullWidthNumberMap$1, chr);
    if (replacement === HALF_WIDTH_PERIOD$1) {
      isDecimal = true;
    }
    return replacement;
  });
  return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
}

var stringToNumber_1 = stringToNumber$2;

var Sugar$5D = sugarCore.exports,
    stringToNumber$1 = stringToNumber_1;

Sugar$5D.String.defineInstance({

  'toNumber': function(str, base) {
    return stringToNumber$1(str, base);
  }

});

Sugar$5D.String.toNumber;

var TRIM_CHARS$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

var TRIM_CHARS$2 = TRIM_CHARS$3;

var LEFT_TRIM_REG$1 = RegExp('^['+ TRIM_CHARS$2 +']+');

var Sugar$5C = sugarCore.exports,
    LEFT_TRIM_REG = LEFT_TRIM_REG$1;

Sugar$5C.String.defineInstance({

  'trimLeft': function(str) {
    return str.replace(LEFT_TRIM_REG, '');
  }

});

Sugar$5C.String.trimLeft;

var TRIM_CHARS$1 = TRIM_CHARS$3;

var RIGHT_TRIM_REG$1 = RegExp('['+ TRIM_CHARS$1 +']+$');

var Sugar$5B = sugarCore.exports,
    RIGHT_TRIM_REG = RIGHT_TRIM_REG$1;

Sugar$5B.String.defineInstance({

  'trimRight': function(str) {
    return str.replace(RIGHT_TRIM_REG, '');
  }

});

Sugar$5B.String.trimRight;

var TRIM_CHARS = TRIM_CHARS$3;

var TRUNC_REG$1 = RegExp('(?=[' + TRIM_CHARS + '])');

function filter$3(arr, fn) {
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    var el = arr[i];
    if (i in arr && fn(el, i)) {
      result.push(el);
    }
  }
  return result;
}

var filter_1 = filter$3;

var TRUNC_REG = TRUNC_REG$1,
    filter$2 = filter_1,
    reverseString = reverseString_1;

function truncateOnWord$1(str, limit, fromLeft) {
  if (fromLeft) {
    return reverseString(truncateOnWord$1(reverseString(str), limit));
  }
  var words = str.split(TRUNC_REG);
  var count = 0;
  return filter$2(words, function(word) {
    count += word.length;
    return count <= limit;
  }).join('');
}

var truncateOnWord_1 = truncateOnWord$1;

var isUndefined$g = isUndefined_1,
    mathAliases$u = mathAliases$z,
    truncateOnWord = truncateOnWord_1;

var ceil$6 = mathAliases$u.ceil,
    floor$3 = mathAliases$u.floor;

function truncateString$2(str, length, from, ellipsis, split) {
  var str1, str2, len1, len2;
  if (str.length <= length) {
    return str.toString();
  }
  ellipsis = isUndefined$g(ellipsis) ? '...' : ellipsis;
  switch(from) {
    case 'left':
      str2 = split ? truncateOnWord(str, length, true) : str.slice(str.length - length);
      return ellipsis + str2;
    case 'middle':
      len1 = ceil$6(length / 2);
      len2 = floor$3(length / 2);
      str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
      str2 = split ? truncateOnWord(str, len2, true) : str.slice(str.length - len2);
      return str1 + ellipsis + str2;
    default:
      str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
      return str1 + ellipsis;
  }
}

var truncateString_1 = truncateString$2;

var Sugar$5A = sugarCore.exports,
    truncateString$1 = truncateString_1;

Sugar$5A.String.defineInstance({

  'truncate': function(str, length, from, ellipsis) {
    return truncateString$1(str, length, from, ellipsis);
  }

});

Sugar$5A.String.truncate;

var Sugar$5z = sugarCore.exports,
    truncateString = truncateString_1;

Sugar$5z.String.defineInstance({

  'truncateOnWord': function(str, length, from, ellipsis) {
    return truncateString(str, length, from, ellipsis, true);
  }

});

Sugar$5z.String.truncateOnWord;

var Sugar$5y = sugarCore.exports,
    stringUnderscore = stringUnderscore_1;

Sugar$5y.String.defineInstance({

  'underscore': function(str) {
    return stringUnderscore(str);
  }

});

Sugar$5y.String.underscore;

var HTML_ENTITY_REG$1 = /&#?(x)?([\w\d]{0,5});/gi;

var HTML_ENTITY_REG = HTML_ENTITY_REG$1,
    HTMLFromEntityMap = HTMLFromEntityMap_1,
    chr$2 = chr$6;

function unescapeHTML$1(str) {
  return str.replace(HTML_ENTITY_REG, function(full, hex, code) {
    var special = HTMLFromEntityMap[code];
    return special || chr$2(hex ? parseInt(code, 16) : +code);
  });
}

var unescapeHTML_1 = unescapeHTML$1;

var Sugar$5x = sugarCore.exports,
    unescapeHTML = unescapeHTML_1;

Sugar$5x.String.defineInstance({

  'unescapeHTML': function(str) {
    return unescapeHTML(str);
  }

});

Sugar$5x.String.unescapeHTML;

var Sugar$5w = sugarCore.exports;

Sugar$5w.String.defineInstance({

  'unescapeURL': function(str, param) {
    return param ? decodeURI(str) : decodeURIComponent(str);
  }

});

Sugar$5w.String.unescapeURL;

var Sugar$5v = sugarCore.exports,
    trim$1 = trim_1,
    stringEach = stringEach_1;

Sugar$5v.String.defineInstance({

  'words': function(str, eachWordFn) {
    return stringEach(trim$1(str), /\S+/g, eachWordFn);
  }

});

Sugar$5v.String.words;

var Sugar$5u = sugarCore.exports,
    trunc$a = trunc_1,
    mathAliases$t = mathAliases$z,
    isUndefined$f = isUndefined_1;

var min$6 = mathAliases$t.min,
    max$7 = mathAliases$t.max;

Sugar$5u.Number.defineStatic({

  'random': function(n1, n2) {
    var minNum, maxNum;
    if (arguments.length == 1) n2 = n1, n1 = 0;
    minNum = min$6(n1 || 0, isUndefined$f(n2) ? 1 : n2);
    maxNum = max$7(n1 || 0, isUndefined$f(n2) ? 1 : n2) + 1;
    return trunc$a((Math.random() * (maxNum - minNum)) + minNum);
  }

});

Sugar$5u.Number.random;

var AbbreviationUnits$3 = {
  BASIC_UNITS: '|kmbt',
  MEMORY_UNITS: '|KMGTPE',
  MEMORY_BINARY_UNITS: '|,Ki,Mi,Gi,Ti,Pi,Ei',
  METRIC_UNITS_SHORT: 'nμm|k',
  METRIC_UNITS_FULL: 'yzafpnμm|KMGTPEZY'
};

var CommonChars$2 = CommonChars$8;

var HALF_WIDTH_COMMA$1 = CommonChars$2.HALF_WIDTH_COMMA;

function commaSplit$2(str) {
  return str.split(HALF_WIDTH_COMMA$1);
}

var commaSplit_1 = commaSplit$2;

var mathAliases$s = mathAliases$z;

var abs$9 = mathAliases$s.abs,
    pow$2 = mathAliases$s.pow,
    round$4 = mathAliases$s.round;

function withPrecision$5(val, precision, fn) {
  var multiplier = pow$2(10, abs$9(precision || 0));
  fn = fn || round$4;
  if (precision < 0) multiplier = 1 / multiplier;
  return fn(val * multiplier) / multiplier;
}

var withPrecision_1 = withPrecision$5;

var CommonChars$1 = CommonChars$8;

var HALF_WIDTH_PERIOD = CommonChars$1.HALF_WIDTH_PERIOD,
    HALF_WIDTH_COMMA = CommonChars$1.HALF_WIDTH_COMMA;

var NUMBER_OPTIONS$1 = {
  'decimal': HALF_WIDTH_PERIOD,
  'thousands': HALF_WIDTH_COMMA
};

var NUMBER_OPTIONS_1 = NUMBER_OPTIONS$1;

var Sugar$5t = sugarCore.exports;

var namespaceAliases$e = {
  sugarObject: Sugar$5t.Object,
  sugarArray: Sugar$5t.Array,
  sugarDate: Sugar$5t.Date,
  sugarString: Sugar$5t.String,
  sugarNumber: Sugar$5t.Number,
  sugarFunction: Sugar$5t.Function,
  sugarRegExp: Sugar$5t.RegExp
};

var coreUtilityAliases$D = coreUtilityAliases$M;

var forEachProperty$m = coreUtilityAliases$D.forEachProperty;

function simpleMerge$4(target, source) {
  forEachProperty$m(source, function(val, key) {
    target[key] = val;
  });
  return target;
}

var simpleMerge_1 = simpleMerge$4;

var simpleMerge$3 = simpleMerge_1;

function simpleClone$4(obj) {
  return simpleMerge$3({}, obj);
}

var simpleClone_1 = simpleClone$4;

var coreUtilityAliases$C = coreUtilityAliases$M;

var setProperty$1 = coreUtilityAliases$C.setProperty;

function defineAccessor$1(namespace, name, fn) {
  setProperty$1(namespace, name, fn);
}

var defineAccessor_1 = defineAccessor$1;

var simpleClone$3 = simpleClone_1,
    defineAccessor = defineAccessor_1,
    coreUtilityAliases$B = coreUtilityAliases$M;

var forEachProperty$l = coreUtilityAliases$B.forEachProperty;

function defineOptionsAccessor$3(namespace, defaults) {
  var obj = simpleClone$3(defaults);

  function getOption(name) {
    return obj[name];
  }

  function setOption(arg1, arg2) {
    var options;
    if (arguments.length === 1) {
      options = arg1;
    } else {
      options = {};
      options[arg1] = arg2;
    }
    forEachProperty$l(options, function(val, name) {
      if (val === null) {
        val = defaults[name];
      }
      obj[name] = val;
    });
  }

  defineAccessor(namespace, 'getOption', getOption);
  defineAccessor(namespace, 'setOption', setOption);
  return getOption;
}

var defineOptionsAccessor_1 = defineOptionsAccessor$3;

var NUMBER_OPTIONS = NUMBER_OPTIONS_1,
    namespaceAliases$d = namespaceAliases$e,
    defineOptionsAccessor$2 = defineOptionsAccessor_1;

var sugarNumber$2 = namespaceAliases$d.sugarNumber;

var _numberOptions$1 = defineOptionsAccessor$2(sugarNumber$2, NUMBER_OPTIONS);

var classChecks$N = classChecks$Z,
    mathAliases$r = mathAliases$z,
    periodSplit$1 = periodSplit_1,
    repeatString$1 = repeatString_1,
    withPrecision$4 = withPrecision_1,
    _numberOptions = _numberOptions$1;

var isNumber$b = classChecks$N.isNumber,
    max$6 = mathAliases$r.max;

function numberFormat$2(num, place) {
  var result = '', thousands, decimal, fraction, integer, split, str;

  decimal   = _numberOptions('decimal');
  thousands = _numberOptions('thousands');

  if (isNumber$b(place)) {
    str = withPrecision$4(num, place || 0).toFixed(max$6(place, 0));
  } else {
    str = num.toString();
  }

  str = str.replace(/^-/, '');
  split    = periodSplit$1(str);
  integer  = split[0];
  fraction = split[1];
  if (/e/.test(str)) {
    result = str;
  } else {
    for(var i = integer.length; i > 0; i -= 3) {
      if (i < integer.length) {
        result = thousands + result;
      }
      result = integer.slice(max$6(0, i - 3), i) + result;
    }
  }
  if (fraction) {
    result += decimal + repeatString$1('0', (place || 0) - fraction.length) + fraction;
  }
  return (num < 0 ? '-' : '') + result;
}

var numberFormat_1 = numberFormat$2;

var commaSplit$1 = commaSplit_1,
    mathAliases$q = mathAliases$z,
    numberFormat$1 = numberFormat_1,
    withPrecision$3 = withPrecision_1;

var abs$8 = mathAliases$q.abs,
    pow$1 = mathAliases$q.pow,
    min$5 = mathAliases$q.min,
    max$5 = mathAliases$q.max,
    floor$2 = mathAliases$q.floor;

function abbreviateNumber$3(num, precision, ustr, bytes) {
  var fixed        = num.toFixed(20),
      decimalPlace = fixed.search(/\./),
      numeralPlace = fixed.search(/[1-9]/),
      significant  = decimalPlace - numeralPlace,
      units, unit, mid, i, divisor;
  if (significant > 0) {
    significant -= 1;
  }
  units = commaSplit$1(ustr);
  if (units.length === 1) {
    units = ustr.split('');
  }
  mid = units.indexOf('|');
  if (mid === -1) {
    // Skipping the placeholder means the units should start from zero,
    // otherwise assume they end at zero.
    mid = units[0] === '_' ? 0 : units.length;
  }
  i = max$5(min$5(floor$2(significant / 3), units.length - mid - 1), -mid);
  unit = units[i + mid];
  while (unit === '_') {
    i += i < 0 ? -1 : 1;
    unit = units[i + mid];
  }
  if (unit === '|') {
    unit = '';
  }
  if (significant < -9) {
    precision = abs$8(significant) - 9;
  }
  divisor = bytes ? pow$1(2, 10 * i) : pow$1(10, i * 3);
  return numberFormat$1(withPrecision$3(num / divisor, precision || 0)) + unit;
}

var abbreviateNumber_1 = abbreviateNumber$3;

var Sugar$5s = sugarCore.exports,
    AbbreviationUnits$2 = AbbreviationUnits$3,
    abbreviateNumber$2 = abbreviateNumber_1;

var BASIC_UNITS = AbbreviationUnits$2.BASIC_UNITS;

Sugar$5s.Number.defineInstance({

  'abbr': function(n, precision) {
    return abbreviateNumber$2(n, precision, BASIC_UNITS);
  }

});

Sugar$5s.Number.abbr;

function wrapNamespace$1(method) {
  return function(sugarNamespace, arg1, arg2) {
    sugarNamespace[method](arg1, arg2);
  };
}

var wrapNamespace_1 = wrapNamespace$1;

var wrapNamespace = wrapNamespace_1;

var methodDefineAliases$3 = {
  alias: wrapNamespace('alias'),
  defineStatic: wrapNamespace('defineStatic'),
  defineInstance: wrapNamespace('defineInstance'),
  defineStaticPolyfill: wrapNamespace('defineStaticPolyfill'),
  defineInstancePolyfill: wrapNamespace('defineInstancePolyfill'),
  defineInstanceAndStatic: wrapNamespace('defineInstanceAndStatic'),
  defineInstanceWithArguments: wrapNamespace('defineInstanceWithArguments')
};

var forEach$g = forEach_1,
    spaceSplit$4 = spaceSplit_1,
    classChecks$M = classChecks$Z;

var isString$c = classChecks$M.isString;

function collectSimilarMethods$2(set, fn) {
  var methods = {};
  if (isString$c(set)) {
    set = spaceSplit$4(set);
  }
  forEach$g(set, function(el, i) {
    fn(methods, el, i);
  });
  return methods;
}

var collectSimilarMethods_1 = collectSimilarMethods$2;

var methodDefineAliases$2 = methodDefineAliases$3,
    collectSimilarMethods$1 = collectSimilarMethods_1;

var defineInstance = methodDefineAliases$2.defineInstance;

function defineInstanceSimilar$5(sugarNamespace, set, fn, flags) {
  defineInstance(sugarNamespace, collectSimilarMethods$1(set, fn), flags);
}

var defineInstanceSimilar_1 = defineInstanceSimilar$5;

var namespaceAliases$c = namespaceAliases$e,
    defineInstanceSimilar$4 = defineInstanceSimilar_1;

var sugarNumber$1 = namespaceAliases$c.sugarNumber;

function buildMathAliases$1() {
  defineInstanceSimilar$4(sugarNumber$1, 'abs pow sin asin cos acos tan atan exp pow sqrt', function(methods, name) {
    methods[name] = function(n, arg) {
      // Note that .valueOf() here is only required due to a
      // very strange bug in iOS7 that only occurs occasionally
      // in which Math.abs() called on non-primitive numbers
      // returns a completely different number (Issue #400)
      return Math[name](n.valueOf(), arg);
    };
  });
}

var buildMathAliases_1 = buildMathAliases$1;

var buildMathAliases = buildMathAliases_1;

buildMathAliases();

var Sugar$5r = sugarCore.exports;



Sugar$5r.Number.abs;

var Sugar$5q = sugarCore.exports;



Sugar$5q.Number.acos;

var Sugar$5p = sugarCore.exports;



Sugar$5p.Number.asin;

var Sugar$5o = sugarCore.exports;



Sugar$5o.Number.atan;

var Sugar$5n = sugarCore.exports,
    AbbreviationUnits$1 = AbbreviationUnits$3,
    abbreviateNumber$1 = abbreviateNumber_1;

var MEMORY_UNITS = AbbreviationUnits$1.MEMORY_UNITS,
    MEMORY_BINARY_UNITS = AbbreviationUnits$1.MEMORY_BINARY_UNITS;

Sugar$5n.Number.defineInstance({

  'bytes': function(n, precision, binary, units) {
    if (units === 'binary' || (!units && binary)) {
      units = MEMORY_BINARY_UNITS;
    } else if(units === 'si' || !units) {
      units = MEMORY_UNITS;
    }
    return abbreviateNumber$1(n, precision, units, binary) + 'B';
  }

});

Sugar$5n.Number.bytes;

var withPrecision$2 = withPrecision_1;

function createRoundingFunction$3(fn) {
  return function(n, precision) {
    return precision ? withPrecision$2(n, precision, fn) : fn(n);
  };
}

var createRoundingFunction_1 = createRoundingFunction$3;

var Sugar$5m = sugarCore.exports,
    mathAliases$p = mathAliases$z,
    createRoundingFunction$2 = createRoundingFunction_1;

var ceil$5 = mathAliases$p.ceil;

Sugar$5m.Number.defineInstance({

  'ceil': createRoundingFunction$2(ceil$5)

});

Sugar$5m.Number.ceil;

var Sugar$5l = sugarCore.exports,
    chr$1 = chr$6;

Sugar$5l.Number.defineInstance({

  'chr': function(n) {
    return chr$1(n);
  }

});

Sugar$5l.Number.chr;

var Sugar$5k = sugarCore.exports;



Sugar$5k.Number.cos;

var Sugar$5j = sugarCore.exports;



Sugar$5j.Number.exp;

var Sugar$5i = sugarCore.exports,
    mathAliases$o = mathAliases$z,
    createRoundingFunction$1 = createRoundingFunction_1;

var floor$1 = mathAliases$o.floor;

Sugar$5i.Number.defineInstance({

  'floor': createRoundingFunction$1(floor$1)

});

Sugar$5i.Number.floor;

var Sugar$5h = sugarCore.exports,
    numberFormat = numberFormat_1;

Sugar$5h.Number.defineInstance({

  'format': function(n, place) {
    return numberFormat(n, place);
  }

});

Sugar$5h.Number.format;

var mathAliases$n = mathAliases$z,
    repeatString = repeatString_1;

var abs$7 = mathAliases$n.abs;

function padNumber$5(num, place, sign, base, replacement) {
  var str = abs$7(num).toString(base || 10);
  str = repeatString(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
  if (sign || num < 0) {
    str = (num < 0 ? '-' : '+') + str;
  }
  return str;
}

var padNumber_1 = padNumber$5;

var Sugar$5g = sugarCore.exports,
    padNumber$4 = padNumber_1;

Sugar$5g.Number.defineInstance({

  'hex': function(n, pad) {
    return padNumber$4(n, pad || 1, false, 16);
  }

});

Sugar$5g.Number.hex;

function isMultipleOf$3(n1, n2) {
  return n1 % n2 === 0;
}

var isMultipleOf_1 = isMultipleOf$3;

var Sugar$5f = sugarCore.exports,
    isMultipleOf$2 = isMultipleOf_1;

Sugar$5f.Number.defineInstance({

  'isEven': function(n) {
    return isMultipleOf$2(n, 2);
  }

});

Sugar$5f.Number.isEven;

function isInteger$2(n) {
  return n % 1 === 0;
}

var isInteger_1 = isInteger$2;

var Sugar$5e = sugarCore.exports,
    isInteger$1 = isInteger_1;

Sugar$5e.Number.defineInstance({

  'isInteger': function(n) {
    return isInteger$1(n);
  }

});

Sugar$5e.Number.isInteger;

var Sugar$5d = sugarCore.exports,
    isMultipleOf$1 = isMultipleOf_1;

Sugar$5d.Number.defineInstance({

  'isMultipleOf': function(n, num) {
    return isMultipleOf$1(n, num);
  }

});

Sugar$5d.Number.isMultipleOf;

var Sugar$5c = sugarCore.exports,
    isInteger = isInteger_1,
    isMultipleOf = isMultipleOf_1;

Sugar$5c.Number.defineInstance({

  'isOdd': function(n) {
    return isInteger(n) && !isMultipleOf(n, 2);
  }

});

Sugar$5c.Number.isOdd;

var Sugar$5b = sugarCore.exports;

Sugar$5b.Number.defineInstance({

  'log': function(n, base) {
    return Math.log(n) / (base ? Math.log(base) : 1);
  }

});

Sugar$5b.Number.log;

var Sugar$5a = sugarCore.exports,
    AbbreviationUnits = AbbreviationUnits$3,
    abbreviateNumber = abbreviateNumber_1;

var METRIC_UNITS_SHORT = AbbreviationUnits.METRIC_UNITS_SHORT,
    METRIC_UNITS_FULL = AbbreviationUnits.METRIC_UNITS_FULL;

Sugar$5a.Number.defineInstance({

  'metric': function(n, precision, units) {
    if (units === 'all') {
      units = METRIC_UNITS_FULL;
    } else if (!units) {
      units = METRIC_UNITS_SHORT;
    }
    return abbreviateNumber(n, precision, units);
  }

});

Sugar$5a.Number.metric;

function getOrdinalSuffix$2(num) {
  if (num >= 11 && num <= 13) {
    return 'th';
  } else {
    switch(num % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  }
}

var getOrdinalSuffix_1 = getOrdinalSuffix$2;

var Sugar$59 = sugarCore.exports,
    mathAliases$m = mathAliases$z,
    getOrdinalSuffix$1 = getOrdinalSuffix_1;

var abs$6 = mathAliases$m.abs;

Sugar$59.Number.defineInstance({

  'ordinalize': function(n) {
    var num = abs$6(n), last = +num.toString().slice(-2);
    return n + getOrdinalSuffix$1(last);
  }

});

Sugar$59.Number.ordinalize;

var Sugar$58 = sugarCore.exports,
    padNumber$3 = padNumber_1;

Sugar$58.Number.defineInstance({

  'pad': function(n, place, sign, base) {
    return padNumber$3(n, place, sign, base);
  }

});

Sugar$58.Number.pad;

var Sugar$57 = sugarCore.exports;



Sugar$57.Number.pow;

var Sugar$56 = sugarCore.exports,
    mathAliases$l = mathAliases$z,
    createRoundingFunction = createRoundingFunction_1;

var round$3 = mathAliases$l.round;

Sugar$56.Number.defineInstance({

  'round': createRoundingFunction(round$3)

});

Sugar$56.Number.round;

var Sugar$55 = sugarCore.exports;



Sugar$55.Number.sin;

var Sugar$54 = sugarCore.exports;



Sugar$54.Number.sqrt;

var Sugar$53 = sugarCore.exports;



Sugar$53.Number.tan;

var Sugar$52 = sugarCore.exports,
    isDefined$f = isDefined_1;

Sugar$52.Number.defineInstance({

  'times': function(n, indexMapFn) {
    var arr, result;
    for(var i = 0; i < n; i++) {
      result = indexMapFn.call(n, i);
      if (isDefined$f(result)) {
        if (!arr) {
          arr = [];
        }
        arr.push(result);
      }
    }
    return arr;
  }

});

Sugar$52.Number.times;

var Sugar$51 = sugarCore.exports;

Sugar$51.Number.defineInstance({

  'toNumber': function(n) {
    return n.valueOf();
  }

});

Sugar$51.Number.toNumber;

var Sugar$50 = sugarCore.exports;

Sugar$50.Number.getOption;

var Sugar$4$ = sugarCore.exports;

Sugar$4$.Number.setOption;

var Sugar$4_ = sugarCore.exports,
    coercePositiveInteger$2 = coercePositiveInteger_1;

Sugar$4_.Array.defineStatic({

  'construct': function(n, indexMapFn) {
    n = coercePositiveInteger$2(n);
    return Array.from(new Array(n), function(el, i) {
      return indexMapFn && indexMapFn(i);
    });
  }

});

Sugar$4_.Array.construct;

var forEach$f = forEach_1;

function arrayClone$6(arr) {
  var clone = new Array(arr.length);
  forEach$f(arr, function(el, i) {
    clone[i] = el;
  });
  return clone;
}

var arrayClone_1 = arrayClone$6;

var classChecks$L = classChecks$Z;

var isArray$c = classChecks$L.isArray;

function isArrayOrInherited$1(obj) {
  return obj && obj.constructor && isArray$c(obj.constructor.prototype);
}

var isArrayOrInherited_1 = isArrayOrInherited$1;

var isDefined$e = isDefined_1,
    arrayClone$5 = arrayClone_1,
    classChecks$K = classChecks$Z,
    isObjectType$a = isObjectType_1,
    isArrayOrInherited = isArrayOrInherited_1;

var isString$b = classChecks$K.isString;

function arrayCreate$2(obj, clone) {
  var arr;
  if (isArrayOrInherited(obj)) {
    arr = clone ? arrayClone$5(obj) : obj;
  } else if (isObjectType$a(obj) || isString$b(obj)) {
    arr = Array.from(obj);
  } else if (isDefined$e(obj)) {
    arr = [obj];
  }
  return arr || [];
}

var arrayCreate_1 = arrayCreate$2;

function setChainableConstructor$2(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

var setChainableConstructor_1 = setChainableConstructor$2;

var arrayCreate$1 = arrayCreate_1,
    namespaceAliases$b = namespaceAliases$e,
    setChainableConstructor$1 = setChainableConstructor_1;

var sugarArray$2 = namespaceAliases$b.sugarArray;

function setArrayChainableConstructor$1() {
  setChainableConstructor$1(sugarArray$2, arrayCreate$1);
}

var setArrayChainableConstructor_1 = setArrayChainableConstructor$1;

var setArrayChainableConstructor = setArrayChainableConstructor_1;

setArrayChainableConstructor();

var Sugar$4Z = sugarCore.exports,
    arrayCreate = arrayCreate_1;



Sugar$4Z.Array.defineStatic({

  'create': function(obj, clone) {
    return arrayCreate(obj, clone);
  }

});

Sugar$4Z.Array.create;

var isDefined$d = isDefined_1;

function arrayAppend$2(arr, el, index) {
  var spliceArgs;
  index = +index;
  if (isNaN(index)) {
    index = arr.length;
  }
  spliceArgs = [index, 0];
  if (isDefined$d(el)) {
    spliceArgs = spliceArgs.concat(el);
  }
  arr.splice.apply(arr, spliceArgs);
  return arr;
}

var arrayAppend_1 = arrayAppend$2;

var Sugar$4Y = sugarCore.exports,
    arrayClone$4 = arrayClone_1,
    arrayAppend$1 = arrayAppend_1;

Sugar$4Y.Array.defineInstance({

  'add': function(arr, item, index) {
    return arrayAppend$1(arrayClone$4(arr), item, index);
  }

});

Sugar$4Y.Array.add;

var Sugar$4X = sugarCore.exports,
    arrayAppend = arrayAppend_1;

Sugar$4X.Array.defineInstance({

  'append': function(arr, item, index) {
    return arrayAppend(arr, item, index);
  }

});

Sugar$4X.Array.append;

var Sugar$4W = sugarCore.exports,
    getEntriesForIndexes = getEntriesForIndexes_1;

Sugar$4W.Array.defineInstance({

  'at': function(arr, index, loop) {
    return getEntriesForIndexes(arr, index, loop);
  }

});

Sugar$4W.Array.at;

var Sugar$4V = sugarCore.exports,
    arrayClone$3 = arrayClone_1;

Sugar$4V.Array.defineInstance({

  'clone': function(arr) {
    return arrayClone$3(arr);
  }

});

Sugar$4V.Array.clone;

var filter$1 = filter_1;

function arrayCompact$1(arr, all) {
  return filter$1(arr, function(el) {
    return el || (!all && el != null && el.valueOf() === el.valueOf());
  });
}

var arrayCompact_1 = arrayCompact$1;

var Sugar$4U = sugarCore.exports,
    arrayCompact = arrayCompact_1;

Sugar$4U.Array.defineInstance({

  'compact': function(arr, all) {
    return arrayCompact(arr, all);
  }

});

Sugar$4U.Array.compact;

function dateMatcher$1(d) {
  var ms = d.getTime();
  return function(el) {
    return !!(el && el.getTime) && el.getTime() === ms;
  };
}

var dateMatcher_1 = dateMatcher$1;

function regexMatcher$1(reg) {
  reg = RegExp(reg);
  return function(el) {
    return reg.test(el);
  };
}

var regexMatcher_1 = regexMatcher$1;

function getKeys$6(obj) {
  return Object.keys(obj);
}

var getKeys_1 = getKeys$6;

function setToArray$1(set) {
  var arr = new Array(set.size), i = 0;
  set.forEach(function(val) {
    arr[i++] = val;
  });
  return arr;
}

var setToArray_1 = setToArray$1;

function mapToArray$1(map) {
  var arr = new Array(map.size), i = 0;
  map.forEach(function(val, key) {
    arr[i++] = [key, val];
  });
  return arr;
}

var mapToArray_1 = mapToArray$1;

var getKeys$5 = getKeys_1,
    coreUtilityAliases$A = coreUtilityAliases$M;

var forEachProperty$k = coreUtilityAliases$A.forEachProperty;

function iterateWithCyclicCheck$2(obj, sortedKeys, stack, fn) {

  function next(val, key) {
    var cyc = false;

    // Allowing a step into the structure before triggering this check to save
    // cycles on standard JSON structures and also to try as hard as possible to
    // catch basic properties that may have been modified.
    if (stack.length > 1) {
      var i = stack.length;
      while (i--) {
        if (stack[i] === val) {
          cyc = true;
        }
      }
    }

    stack.push(val);
    fn(key, val, cyc, stack);
    stack.pop();
  }

  function iterateWithSortedKeys() {
    // Sorted keys is required for serialization, where object order
    // does not matter but stringified order does.
    var arr = getKeys$5(obj).sort(), key;
    for (var i = 0; i < arr.length; i++) {
      key = arr[i];
      next(obj[key], arr[i]);
    }
  }

  // This method for checking for cyclic structures was egregiously stolen from
  // the ingenious method by @kitcambridge from the Underscore script:
  // https://github.com/documentcloud/underscore/issues/240
  if (!stack) {
    stack = [];
  }

  if (sortedKeys) {
    iterateWithSortedKeys();
  } else {
    forEachProperty$k(obj, next);
  }
}

var iterateWithCyclicCheck_1 = iterateWithCyclicCheck$2;

var getKeys$4 = getKeys_1,
    setToArray = setToArray_1,
    mapToArray = mapToArray_1,
    classChecks$J = classChecks$Z,
    isObjectType$9 = isObjectType_1,
    coreUtilityAliases$z = coreUtilityAliases$M,
    iterateWithCyclicCheck$1 = iterateWithCyclicCheck_1;

var classToString$4 = coreUtilityAliases$z.classToString,
    isSerializable$1 = classChecks$J.isSerializable,
    isSet$1 = classChecks$J.isSet,
    isMap$1 = classChecks$J.isMap,
    isError$1 = classChecks$J.isError;

function isEqual$4(a, b, stack) {
  var aClass, bClass;
  if (a === b) {
    // Return quickly up front when matched by reference,
    // but be careful about 0 !== -0.
    return a !== 0 || 1 / a === 1 / b;
  }
  aClass = classToString$4(a);
  bClass = classToString$4(b);
  if (aClass !== bClass) {
    return false;
  }

  if (isSerializable$1(a, aClass) && isSerializable$1(b, bClass)) {
    return objectIsEqual(a, b, aClass, stack);
  } else if (isSet$1(a, aClass) && isSet$1(b, bClass)) {
    return a.size === b.size && isEqual$4(setToArray(a), setToArray(b), stack);
  } else if (isMap$1(a, aClass) && isMap$1(b, bClass)) {
    return a.size === b.size && isEqual$4(mapToArray(a), mapToArray(b), stack);
  } else if (isError$1(a, aClass) && isError$1(b, bClass)) {
    return a.toString() === b.toString();
  }

  return false;
}

function objectIsEqual(a, b, aClass, stack) {
  var aType = typeof a, bType = typeof b, propsEqual, count;
  if (aType !== bType) {
    return false;
  }
  if (isObjectType$9(a.valueOf())) {
    if (a.length !== b.length) {
      // perf: Quickly returning up front for arrays.
      return false;
    }
    count = 0;
    propsEqual = true;
    iterateWithCyclicCheck$1(a, false, stack, function(key, val, cyc, stack) {
      if (!cyc && (!(key in b) || !isEqual$4(val, b[key], stack))) {
        propsEqual = false;
      }
      count++;
      return propsEqual;
    });
    if (!propsEqual || count !== getKeys$4(b).length) {
      return false;
    }
  }
  // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
  return a.valueOf().toString() === b.valueOf().toString();
}

var isEqual_1 = isEqual$4;

var isEqual$3 = isEqual_1;

function defaultMatcher$1(f) {
  return function(el) {
    return isEqual$3(el, f);
  };
}

var defaultMatcher_1 = defaultMatcher$1;

function functionMatcher$1(fn) {
  return function(el, i, arr) {
    // Return true up front if match by reference
    return el === fn || fn.call(arr, el, i, arr);
  };
}

var functionMatcher_1 = functionMatcher$1;

var isPrimitive$5 = isPrimitive_1,
    classChecks$I = classChecks$Z,
    dateMatcher = dateMatcher_1,
    regexMatcher = regexMatcher_1,
    isObjectType$8 = isObjectType_1,
    isPlainObject$2 = isPlainObject_1,
    defaultMatcher = defaultMatcher_1,
    functionMatcher = functionMatcher_1,
    coreUtilityAliases$y = coreUtilityAliases$M;

var getOwn$a = coreUtilityAliases$y.getOwn,
    classToString$3 = coreUtilityAliases$y.classToString,
    forEachProperty$j = coreUtilityAliases$y.forEachProperty,
    isDate$9 = classChecks$I.isDate,
    isRegExp$4 = classChecks$I.isRegExp,
    isFunction$b = classChecks$I.isFunction;

function getMatcher$8(f) {
  if (!isPrimitive$5(f)) {
    var className = classToString$3(f);
    if (isRegExp$4(f, className)) {
      return regexMatcher(f);
    } else if (isDate$9(f, className)) {
      return dateMatcher(f);
    } else if (isFunction$b(f, className)) {
      return functionMatcher(f);
    } else if (isPlainObject$2(f, className)) {
      return fuzzyMatcher(f);
    }
  }
  // Default is standard isEqual
  return defaultMatcher(f);
}

function fuzzyMatcher(obj) {
  var matchers = {};
  return function(el, i, arr) {
    var matched = true;
    if (!isObjectType$8(el)) {
      return false;
    }
    forEachProperty$j(obj, function(val, key) {
      matchers[key] = getOwn$a(matchers, key) || getMatcher$8(val);
      if (matchers[key].call(arr, el[key], i, arr) === false) {
        matched = false;
      }
      return matched;
    });
    return matched;
  };
}

var getMatcher_1 = getMatcher$8;

var getMatcher$7 = getMatcher_1;

function arrayExclude$1(arr, f) {
  var result = [], matcher = getMatcher$7(f);
  for (var i = 0; i < arr.length; i++) {
    if (!matcher(arr[i], i, arr)) {
      result.push(arr[i]);
    }
  }
  return result;
}

var arrayExclude_1 = arrayExclude$1;

var Sugar$4T = sugarCore.exports,
    arrayExclude = arrayExclude_1;

Sugar$4T.Array.defineInstance({

  'exclude': function(arr, f) {
    return arrayExclude(arr, f);
  }

});

Sugar$4T.Array.exclude;

var Sugar$4S = sugarCore.exports,
    isUndefined$e = isUndefined_1;

Sugar$4S.Array.defineInstance({

  'first': function(arr, num) {
    if (isUndefined$e(num)) return arr[0];
    if (num < 0) num = 0;
    return arr.slice(0, num);
  }

});

Sugar$4S.Array.first;

var forEach$e = forEach_1,
    classChecks$H = classChecks$Z;

var isArray$b = classChecks$H.isArray;

function arrayFlatten$1(arr, level, current) {
  var result = [];
  level = level || Infinity;
  current = current || 0;
  forEach$e(arr, function(el) {
    if (isArray$b(el) && current < level) {
      result = result.concat(arrayFlatten$1(el, level, current + 1));
    } else {
      result.push(el);
    }
  });
  return result;
}

var arrayFlatten_1 = arrayFlatten$1;

var Sugar$4R = sugarCore.exports,
    arrayFlatten = arrayFlatten_1;

Sugar$4R.Array.defineInstance({

  'flatten': function(arr, limit) {
    return arrayFlatten(arr, limit);
  }

});

Sugar$4R.Array.flatten;

var Sugar$4Q = sugarCore.exports;

Sugar$4Q.Array.defineInstance({

  'from': function(arr, num) {
    return arr.slice(num);
  }

});

Sugar$4Q.Array.from;

var map$4 = map_1,
    classChecks$G = classChecks$Z,
    deepGetProperty$2 = deepGetProperty_1;

var isFunction$a = classChecks$G.isFunction,
    isArray$a = classChecks$G.isArray;

function mapWithShortcuts$6(el, f, context, mapArgs) {
  if (!f) {
    return el;
  } else if (f.apply) {
    return f.apply(context, mapArgs);
  } else if (isArray$a(f)) {
    return map$4(f, function(m) {
      return mapWithShortcuts$6(el, m, context, mapArgs);
    });
  } else if (isFunction$a(el[f])) {
    return el[f].call(el);
  } else {
    return deepGetProperty$2(el, f, true);
  }
}

var mapWithShortcuts_1 = mapWithShortcuts$6;

var forEach$d = forEach_1,
    mapWithShortcuts$5 = mapWithShortcuts_1,
    coreUtilityAliases$x = coreUtilityAliases$M;

var hasOwn$8 = coreUtilityAliases$x.hasOwn,
    forEachProperty$i = coreUtilityAliases$x.forEachProperty;

function arrayGroupBy$1(arr, map, fn) {
  var result = {}, key;
  forEach$d(arr, function(el, i) {
    key = mapWithShortcuts$5(el, map, arr, [el, i, arr]);
    if (!hasOwn$8(result, key)) {
      result[key] = [];
    }
    result[key].push(el);
  });
  if (fn) {
    forEachProperty$i(result, fn);
  }
  return result;
}

var arrayGroupBy_1 = arrayGroupBy$1;

var Sugar$4P = sugarCore.exports,
    arrayGroupBy = arrayGroupBy_1;

Sugar$4P.Array.defineInstance({

  'groupBy': function(arr, map, groupFn) {
    return arrayGroupBy(arr, map, groupFn);
  }

});

Sugar$4P.Array.groupBy;

function simpleRepeat$2(n, fn) {
  for (var i = 0; i < n; i++) {
    fn(i);
  }
}

var simpleRepeat_1 = simpleRepeat$2;

var Sugar$4O = sugarCore.exports,
    isDefined$c = isDefined_1,
    mathAliases$k = mathAliases$z,
    simpleRepeat$1 = simpleRepeat_1;

var ceil$4 = mathAliases$k.ceil;

Sugar$4O.Array.defineInstance({

  'inGroups': function(arr, num, padding) {
    var pad = isDefined$c(padding);
    var result = new Array(num);
    var divisor = ceil$4(arr.length / num);
    simpleRepeat$1(num, function(i) {
      var index = i * divisor;
      var group = arr.slice(index, index + divisor);
      if (pad && group.length < divisor) {
        simpleRepeat$1(divisor - group.length, function() {
          group.push(padding);
        });
      }
      result[i] = group;
    });
    return result;
  }

});

Sugar$4O.Array.inGroups;

var Sugar$4N = sugarCore.exports,
    isUndefined$d = isUndefined_1,
    mathAliases$j = mathAliases$z,
    simpleRepeat = simpleRepeat_1;

var ceil$3 = mathAliases$j.ceil;

Sugar$4N.Array.defineInstance({

  'inGroupsOf': function(arr, num, padding) {
    var result = [], len = arr.length, group;
    if (len === 0 || num === 0) return arr;
    if (isUndefined$d(num)) num = 1;
    if (isUndefined$d(padding)) padding = null;
    simpleRepeat(ceil$3(len / num), function(i) {
      group = arr.slice(num * i, num * i + num);
      while(group.length < num) {
        group.push(padding);
      }
      result.push(group);
    });
    return result;
  }

});

Sugar$4N.Array.inGroupsOf;

function arrayWrap$1(obj) {
  var arr = [];
  arr.push(obj);
  return arr;
}

var arrayWrap_1 = arrayWrap$1;

function isRealNaN$1(obj) {
  // This is only true of NaN
  return obj != null && obj !== obj;
}

var isRealNaN_1 = isRealNaN$1;

var indexOf = indexOf_1,
    isRealNaN = isRealNaN_1,
    isPrimitive$4 = isPrimitive_1,
    classChecks$F = classChecks$Z,
    isObjectType$7 = isObjectType_1,
    coreUtilityAliases$w = coreUtilityAliases$M,
    iterateWithCyclicCheck = iterateWithCyclicCheck_1;

var classToString$2 = coreUtilityAliases$w.classToString,
    isSerializable = classChecks$F.isSerializable;

function serializeInternal$4(obj, refs, stack) {
  var type = typeof obj, sign = '', className, value, ref;

  // Return up front on
  if (1 / obj === -Infinity) {
    sign = '-';
  }

  // Return quickly for primitives to save cycles
  if (isPrimitive$4(obj, type) && !isRealNaN(obj)) {
    return type + sign + obj;
  }

  className = classToString$2(obj);

  if (!isSerializable(obj, className)) {
    ref = indexOf(refs, obj);
    if (ref === -1) {
      ref = refs.length;
      refs.push(obj);
    }
    return ref;
  } else if (isObjectType$7(obj)) {
    value = serializeDeep(obj, refs, stack) + obj.toString();
  } else if (obj.valueOf) {
    value = obj.valueOf();
  }
  return type + className + sign + value;
}

function serializeDeep(obj, refs, stack) {
  var result = '';
  iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
    result += cyc ? 'CYC' : key + serializeInternal$4(val, refs, stack);
  });
  return result;
}

var serializeInternal_1 = serializeInternal$4;

var forEach$c = forEach_1,
    arrayWrap = arrayWrap_1,
    classChecks$E = classChecks$Z,
    serializeInternal$3 = serializeInternal_1,
    coreUtilityAliases$v = coreUtilityAliases$M;

var isArray$9 = classChecks$E.isArray,
    hasOwn$7 = coreUtilityAliases$v.hasOwn;

function arrayIntersectOrSubtract$2(arr1, arr2, subtract) {
  var result = [], obj = {}, refs = [];
  if (!isArray$9(arr2)) {
    arr2 = arrayWrap(arr2);
  }
  forEach$c(arr2, function(el) {
    obj[serializeInternal$3(el, refs)] = true;
  });
  forEach$c(arr1, function(el) {
    var key = serializeInternal$3(el, refs);
    if (hasOwn$7(obj, key) !== subtract) {
      delete obj[key];
      result.push(el);
    }
  });
  return result;
}

var arrayIntersectOrSubtract_1 = arrayIntersectOrSubtract$2;

var Sugar$4M = sugarCore.exports,
    arrayIntersectOrSubtract$1 = arrayIntersectOrSubtract_1;

Sugar$4M.Array.defineInstance({

  'intersect': function(arr1, arr2) {
    return arrayIntersectOrSubtract$1(arr1, arr2, false);
  }

});

Sugar$4M.Array.intersect;

var Sugar$4L = sugarCore.exports;

Sugar$4L.Array.defineInstance({

  'isEmpty': function(arr) {
    return arr.length === 0;
  }

});

Sugar$4L.Array.isEmpty;

var Sugar$4K = sugarCore.exports,
    isEqual$2 = isEqual_1;

Sugar$4K.Array.defineInstance({

  'isEqual': function(a, b) {
    return isEqual$2(a, b);
  }

});

Sugar$4K.Array.isEqual;

var Sugar$4J = sugarCore.exports,
    isUndefined$c = isUndefined_1;

Sugar$4J.Array.defineInstance({

  'last': function(arr, num) {
    if (isUndefined$c(num)) return arr[arr.length - 1];
    var start = arr.length - num < 0 ? 0 : arr.length - num;
    return arr.slice(start);
  }

});

Sugar$4J.Array.last;

var getMatcher$6 = getMatcher_1;

function arrayRemove$1(arr, f) {
  var matcher = getMatcher$6(f), i = 0;
  while(i < arr.length) {
    if (matcher(arr[i], i, arr)) {
      arr.splice(i, 1);
    } else {
      i++;
    }
  }
  return arr;
}

var arrayRemove_1 = arrayRemove$1;

var Sugar$4I = sugarCore.exports,
    arrayRemove = arrayRemove_1;

Sugar$4I.Array.defineInstance({

  'remove': function(arr, f) {
    return arrayRemove(arr, f);
  }

});

Sugar$4I.Array.remove;

var Sugar$4H = sugarCore.exports,
    isUndefined$b = isUndefined_1;

Sugar$4H.Array.defineInstance({

  'removeAt': function(arr, start, end) {
    if (isUndefined$b(start)) return arr;
    if (isUndefined$b(end))   end = start;
    arr.splice(start, end - start + 1);
    return arr;
  }

});

Sugar$4H.Array.removeAt;

var Sugar$4G = sugarCore.exports,
    trunc$9 = trunc_1,
    arrayClone$2 = arrayClone_1,
    classChecks$D = classChecks$Z,
    isUndefined$a = isUndefined_1,
    mathAliases$i = mathAliases$z;

var isBoolean$4 = classChecks$D.isBoolean,
    min$4 = mathAliases$i.min;

Sugar$4G.Array.defineInstance({

  'sample': function(arr, arg1, arg2) {
    var result = [], num, remove, single;
    if (isBoolean$4(arg1)) {
      remove = arg1;
    } else {
      num = arg1;
      remove = arg2;
    }
    if (isUndefined$a(num)) {
      num = 1;
      single = true;
    }
    if (!remove) {
      arr = arrayClone$2(arr);
    }
    num = min$4(num, arr.length);
    for (var i = 0, index; i < num; i++) {
      index = trunc$9(Math.random() * arr.length);
      result.push(arr[index]);
      arr.splice(index, 1);
    }
    return single ? result[0] : result;
  }

});

Sugar$4G.Array.sample;

var arrayClone$1 = arrayClone_1;

function arrayShuffle$1(arr) {
  arr = arrayClone$1(arr);
  var i = arr.length, j, x;
  while(i) {
    j = (Math.random() * i) | 0;
    x = arr[--i];
    arr[i] = arr[j];
    arr[j] = x;
  }
  return arr;
}

var arrayShuffle_1 = arrayShuffle$1;

var Sugar$4F = sugarCore.exports,
    arrayShuffle = arrayShuffle_1;

Sugar$4F.Array.defineInstance({

  'shuffle': function(arr) {
    return arrayShuffle(arr);
  }

});

Sugar$4F.Array.shuffle;

var map$3 = map_1;

function getSortOrder$1() {
  var order = 'AÁÀÂÃĄBCĆČÇDĎÐEÉÈĚÊËĘFGĞHıIÍÌİÎÏJKLŁMNŃŇÑOÓÒÔPQRŘSŚŠŞTŤUÚÙŮÛÜVWXYÝZŹŻŽÞÆŒØÕÅÄÖ';
  return map$3(order.split(''), function(str) {
    return str + str.toLowerCase();
  }).join('');
}

var getSortOrder_1 = getSortOrder$1;

var HALF_WIDTH_NINE$1 = 0x39;

var FULL_WIDTH_NINE$1 = 0xff19;

var HALF_WIDTH_NINE = HALF_WIDTH_NINE$1,
    FULL_WIDTH_NINE = FULL_WIDTH_NINE$1,
    CommonChars = CommonChars$8;

var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO;

function codeIsNumeral$1(code) {
  return (code >= HALF_WIDTH_ZERO && code <= HALF_WIDTH_NINE) ||
         (code >= FULL_WIDTH_ZERO && code <= FULL_WIDTH_NINE);
}

var codeIsNumeral_1 = codeIsNumeral$1;

function getSortOrderIndex$1(chr, sortOrder) {
  if (!chr) {
    return null;
  } else {
    return sortOrder.indexOf(chr);
  }
}

var getSortOrderIndex_1 = getSortOrderIndex$1;

var forEach$b = forEach_1,
    spaceSplit$3 = spaceSplit_1;

function getSortEquivalents$1() {
  var equivalents = {};
  forEach$b(spaceSplit$3('AÁÀÂÃÄ CÇ EÉÈÊË IÍÌİÎÏ OÓÒÔÕÖ Sß UÚÙÛÜ'), function(set) {
    var first = set.charAt(0);
    forEach$b(set.slice(1).split(''), function(chr) {
      equivalents[chr] = first;
      equivalents[chr.toLowerCase()] = first.toLowerCase();
    });
  });
  return equivalents;
}

var getSortEquivalents_1 = getSortEquivalents$1;

var coreUtilityAliases$u = coreUtilityAliases$M;

var getOwn$9 = coreUtilityAliases$u.getOwn;

function getCollationCharacter$1(str, index, sortEquivalents) {
  var chr = str.charAt(index);
  return getOwn$9(sortEquivalents, chr) || chr;
}

var getCollationCharacter_1 = getCollationCharacter$1;

function getCollationReadyString$1(str, sortIgnore, sortIgnoreCase) {
  if (sortIgnoreCase) {
    str = str.toLowerCase();
  }
  if (sortIgnore) {
    str = str.replace(sortIgnore, '');
  }
  return str;
}

var getCollationReadyString_1 = getCollationReadyString$1;

var getSortOrder = getSortOrder_1,
    codeIsNumeral = codeIsNumeral_1,
    stringToNumber = stringToNumber_1,
    namespaceAliases$a = namespaceAliases$e,
    getSortOrderIndex = getSortOrderIndex_1,
    getSortEquivalents = getSortEquivalents_1,
    defineOptionsAccessor$1 = defineOptionsAccessor_1,
    getCollationCharacter = getCollationCharacter_1,
    getCollationReadyString = getCollationReadyString_1;

var sugarArray$1 = namespaceAliases$a.sugarArray;

var ARRAY_OPTIONS$1 = {
  'sortIgnore':      null,
  'sortNatural':     true,
  'sortIgnoreCase':  true,
  'sortOrder':       getSortOrder(),
  'sortCollate':     collateStrings,
  'sortEquivalents': getSortEquivalents()
};

var _arrayOptions$1 = defineOptionsAccessor$1(sugarArray$1, ARRAY_OPTIONS$1);

function collateStrings(a, b) {
  var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;

  var sortOrder       = _arrayOptions$1('sortOrder');
  var sortIgnore      = _arrayOptions$1('sortIgnore');
  var sortNatural     = _arrayOptions$1('sortNatural');
  var sortIgnoreCase  = _arrayOptions$1('sortIgnoreCase');
  var sortEquivalents = _arrayOptions$1('sortEquivalents');

  a = getCollationReadyString(a, sortIgnore, sortIgnoreCase);
  b = getCollationReadyString(b, sortIgnore, sortIgnoreCase);

  do {

    aChar  = getCollationCharacter(a, index, sortEquivalents);
    bChar  = getCollationCharacter(b, index, sortEquivalents);
    aValue = getSortOrderIndex(aChar, sortOrder);
    bValue = getSortOrderIndex(bChar, sortOrder);

    if (aValue === -1 || bValue === -1) {
      aValue = a.charCodeAt(index) || null;
      bValue = b.charCodeAt(index) || null;
      if (sortNatural && codeIsNumeral(aValue) && codeIsNumeral(bValue)) {
        aValue = stringToNumber(a.slice(index));
        bValue = stringToNumber(b.slice(index));
      }
    } else {
      aEquiv = aChar !== a.charAt(index);
      bEquiv = bChar !== b.charAt(index);
      if (aEquiv !== bEquiv && tiebreaker === 0) {
        tiebreaker = aEquiv - bEquiv;
      }
    }
    index += 1;
  } while(aValue != null && bValue != null && aValue === bValue);
  if (aValue === bValue) return tiebreaker;
  return aValue - bValue;
}

var ARRAY_OPTIONS_1 = {
  ARRAY_OPTIONS: ARRAY_OPTIONS$1,
  _arrayOptions: _arrayOptions$1
};

var ARRAY_OPTIONS = ARRAY_OPTIONS_1,
    classChecks$C = classChecks$Z;

var isString$a = classChecks$C.isString,
    isArray$8 = classChecks$C.isArray,
    _arrayOptions = ARRAY_OPTIONS._arrayOptions;

function compareValue$1(aVal, bVal) {
  var cmp, i, collate;
  if (isString$a(aVal) && isString$a(bVal)) {
    collate = _arrayOptions('sortCollate');
    return collate(aVal, bVal);
  } else if (isArray$8(aVal) && isArray$8(bVal)) {
    if (aVal.length < bVal.length) {
      return -1;
    } else if (aVal.length > bVal.length) {
      return 1;
    } else {
      for(i = 0; i < aVal.length; i++) {
        cmp = compareValue$1(aVal[i], bVal[i]);
        if (cmp !== 0) {
          return cmp;
        }
      }
      return 0;
    }
  }
  return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}

var compareValue_1 = compareValue$1;

var Sugar$4E = sugarCore.exports,
    compareValue = compareValue_1,
    mapWithShortcuts$4 = mapWithShortcuts_1;

Sugar$4E.Array.defineInstance({

  'sortBy': function(arr, map, desc) {
    arr.sort(function(a, b) {
      var aProperty = mapWithShortcuts$4(a, map, arr, [a]);
      var bProperty = mapWithShortcuts$4(b, map, arr, [b]);
      return compareValue(aProperty, bProperty) * (desc ? -1 : 1);
    });
    return arr;
  }

});

Sugar$4E.Array.sortBy;

var Sugar$4D = sugarCore.exports,
    arrayIntersectOrSubtract = arrayIntersectOrSubtract_1;

Sugar$4D.Array.defineInstance({

  'subtract': function(arr, item) {
    return arrayIntersectOrSubtract(arr, item, true);
  }

});

Sugar$4D.Array.subtract;

var Sugar$4C = sugarCore.exports,
    isUndefined$9 = isUndefined_1;

Sugar$4C.Array.defineInstance({

  'to': function(arr, num) {
    if (isUndefined$9(num)) num = arr.length;
    return arr.slice(0, num);
  }

});

Sugar$4C.Array.to;

var forEach$a = forEach_1,
    mapWithShortcuts$3 = mapWithShortcuts_1,
    serializeInternal$2 = serializeInternal_1,
    coreUtilityAliases$t = coreUtilityAliases$M;

var hasOwn$6 = coreUtilityAliases$t.hasOwn;

function arrayUnique$2(arr, map) {
  var result = [], obj = {}, refs = [];
  forEach$a(arr, function(el, i) {
    var transformed = map ? mapWithShortcuts$3(el, map, arr, [el, i, arr]) : el;
    var key = serializeInternal$2(transformed, refs);
    if (!hasOwn$6(obj, key)) {
      result.push(el);
      obj[key] = true;
    }
  });
  return result;
}

var arrayUnique_1 = arrayUnique$2;

var HAS_CONCAT_BUG$1 = !('0' in [].concat(undefined).concat());

var forEach$9 = forEach_1,
    arrayClone = arrayClone_1,
    classChecks$B = classChecks$Z;

var isArray$7 = classChecks$B.isArray;

function arraySafeConcat$1(arr, arg) {
  var result = arrayClone(arr), len = result.length, arr2;
  arr2 = isArray$7(arg) ? arg : [arg];
  result.length += arr2.length;
  forEach$9(arr2, function(el, i) {
    result[len + i] = el;
  });
  return result;
}

var arraySafeConcat_1 = arraySafeConcat$1;

var HAS_CONCAT_BUG = HAS_CONCAT_BUG$1,
    arraySafeConcat = arraySafeConcat_1;

function arrayConcat$1(arr1, arr2) {
  // istanbul ignore if
  if (HAS_CONCAT_BUG) {
    return arraySafeConcat(arr1, arr2);
  }
  return arr1.concat(arr2);
}

var arrayConcat_1 = arrayConcat$1;

var Sugar$4B = sugarCore.exports,
    arrayUnique$1 = arrayUnique_1,
    arrayConcat = arrayConcat_1;

Sugar$4B.Array.defineInstance({

  'union': function(arr1, arr2) {
    return arrayUnique$1(arrayConcat(arr1, arr2));
  }

});

Sugar$4B.Array.union;

var Sugar$4A = sugarCore.exports,
    arrayUnique = arrayUnique_1;

Sugar$4A.Array.defineInstance({

  'unique': function(arr, map) {
    return arrayUnique(arr, map);
  }

});

Sugar$4A.Array.unique;

var Sugar$4z = sugarCore.exports,
    map$2 = map_1;

Sugar$4z.Array.defineInstanceWithArguments({

  'zip': function(arr, args) {
    return map$2(arr, function(el, i) {
      return [el].concat(map$2(args, function(k) {
        return (i in k) ? k[i] : null;
      }));
    });
  }

});

Sugar$4z.Array.zip;

var Sugar$4y = sugarCore.exports;

Sugar$4y.Array.alias('insert', 'append');

Sugar$4y.Array.insert;

var Sugar$4x = sugarCore.exports;

Sugar$4x.Array.getOption;

var Sugar$4w = sugarCore.exports;

Sugar$4w.Array.setOption;

var classChecks$A = classChecks$Z,
    isArrayIndex = isArrayIndex_1,
    mapWithShortcuts$2 = mapWithShortcuts_1,
    coreUtilityAliases$s = coreUtilityAliases$M;

var isArray$6 = classChecks$A.isArray,
    forEachProperty$h = coreUtilityAliases$s.forEachProperty;

function enumerateWithMapping$5(obj, map, fn) {
  var arrayIndexes = isArray$6(obj);
  forEachProperty$h(obj, function(val, key) {
    if (arrayIndexes) {
      if (!isArrayIndex(key)) {
        return;
      }
      key = +key;
    }
    var mapped = mapWithShortcuts$2(val, map, obj, [val, key, obj]);
    fn(mapped, key);
  });
}

var enumerateWithMapping_1 = enumerateWithMapping$5;

var enumerateWithMapping$4 = enumerateWithMapping_1;

function average$2(obj, map) {
  var sum = 0, count = 0;
  enumerateWithMapping$4(obj, map, function(val) {
    sum += val;
    count++;
  });
  // Prevent divide by 0
  return sum / (count || 1);
}

var average_1 = average$2;

var Sugar$4v = sugarCore.exports,
    average$1 = average_1;

Sugar$4v.Object.defineInstanceAndStatic({

  'average': function(obj, map) {
    return average$1(obj, map);
  }

});

Sugar$4v.Object.average;

var getMatcher$5 = getMatcher_1,
    coreUtilityAliases$r = coreUtilityAliases$M;

var forEachProperty$g = coreUtilityAliases$r.forEachProperty;

function objectCount$1(obj, f) {
  var matcher = getMatcher$5(f), count = 0;
  forEachProperty$g(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      count++;
    }
  });
  return count;
}

var objectCount_1 = objectCount$1;

var Sugar$4u = sugarCore.exports,
    objectCount = objectCount_1;

Sugar$4u.Object.defineInstanceAndStatic({

  'count': function(obj, f) {
    return objectCount(obj, f);
  }

});

Sugar$4u.Object.count;

var getKeys$3 = getKeys_1,
    getMatcher$4 = getMatcher_1;

function wrapObjectMatcher$1(name) {
  var nativeFn = Array.prototype[name];
  return function(obj, f) {
    var matcher = getMatcher$4(f);
    return nativeFn.call(getKeys$3(obj), function(key) {
      return matcher(obj[key], key, obj);
    });
  };
}

var wrapObjectMatcher_1 = wrapObjectMatcher$1;

var wrapObjectMatcher = wrapObjectMatcher_1;

var objectMatchers$4 = {
  objectSome: wrapObjectMatcher('some'),
  objectFind: wrapObjectMatcher('find'),
  objectEvery: wrapObjectMatcher('every')
};

var Sugar$4t = sugarCore.exports,
    objectMatchers$3 = objectMatchers$4;

var objectEvery = objectMatchers$3.objectEvery;

Sugar$4t.Object.defineInstanceAndStatic({

  'every': objectEvery

});

Sugar$4t.Object.every;

var getMatcher$3 = getMatcher_1,
    coreUtilityAliases$q = coreUtilityAliases$M;

var forEachProperty$f = coreUtilityAliases$q.forEachProperty;

function objectFilter$1(obj, f) {
  var matcher = getMatcher$3(f), result = {};
  forEachProperty$f(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectFilter_1 = objectFilter$1;

var Sugar$4s = sugarCore.exports,
    objectFilter = objectFilter_1;

Sugar$4s.Object.defineInstanceAndStatic({

  'filter': function(obj, f) {
    return objectFilter(obj, f);
  }

});

Sugar$4s.Object.filter;

var Sugar$4r = sugarCore.exports,
    objectMatchers$2 = objectMatchers$4;

var objectFind = objectMatchers$2.objectFind;

Sugar$4r.Object.defineInstanceAndStatic({

  'find': objectFind

});

Sugar$4r.Object.find;

var classChecks$z = classChecks$Z;

var isFunction$9 = classChecks$z.isFunction;

function assertCallable$1(obj) {
  if (!isFunction$9(obj)) {
    throw new TypeError('Function is not callable');
  }
}

var assertCallable_1 = assertCallable$1;

var assertCallable = assertCallable_1,
    coreUtilityAliases$p = coreUtilityAliases$M;

var forEachProperty$e = coreUtilityAliases$p.forEachProperty;

function objectForEach$1(obj, fn) {
  assertCallable(fn);
  forEachProperty$e(obj, function(val, key) {
    fn(val, key, obj);
  });
  return obj;
}

var objectForEach_1 = objectForEach$1;

var Sugar$4q = sugarCore.exports,
    objectForEach = objectForEach_1;

Sugar$4q.Object.defineInstanceAndStatic({

  'forEach': function(obj, eachFn) {
    return objectForEach(obj, eachFn);
  }

});

Sugar$4q.Object.forEach;

function getReducedMinMaxResult$2(result, obj, all, asObject) {
  if (asObject && all) {
    // The method has returned an array of keys so use this array
    // to build up the resulting object in the form we want it in.
    return result.reduce(function(o, key) {
      o[key] = obj[key];
      return o;
    }, {});
  } else if (result && !all) {
    result = result[0];
  }
  return result;
}

var getReducedMinMaxResult_1 = getReducedMinMaxResult$2;

var classChecks$y = classChecks$Z,
    isUndefined$8 = isUndefined_1,
    enumerateWithMapping$3 = enumerateWithMapping_1,
    getReducedMinMaxResult$1 = getReducedMinMaxResult_1;

var isBoolean$3 = classChecks$y.isBoolean;

function getMinOrMax$5(obj, arg1, arg2, max, asObject) {
  var result = [], pushVal, edge, all, map;
  if (isBoolean$3(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$3(obj, map, function(val, key) {
    if (isUndefined$8(val)) {
      throw new TypeError('Cannot compare with undefined');
    }
    pushVal = asObject ? key : obj[key];
    if (val === edge) {
      result.push(pushVal);
    } else if (isUndefined$8(edge) || (max && val > edge) || (!max && val < edge)) {
      result = [pushVal];
      edge = val;
    }
  });
  return getReducedMinMaxResult$1(result, obj, all, asObject);
}

var getMinOrMax_1 = getMinOrMax$5;

var classChecks$x = classChecks$Z,
    getMinOrMax$4 = getMinOrMax_1,
    serializeInternal$1 = serializeInternal_1,
    coreUtilityAliases$o = coreUtilityAliases$M,
    enumerateWithMapping$2 = enumerateWithMapping_1,
    getReducedMinMaxResult = getReducedMinMaxResult_1;

var isBoolean$2 = classChecks$x.isBoolean,
    getOwn$8 = coreUtilityAliases$o.getOwn,
    forEachProperty$d = coreUtilityAliases$o.forEachProperty;

function getLeastOrMost$4(obj, arg1, arg2, most, asObject) {
  var group = {}, refs = [], minMaxResult, result, all, map;
  if (isBoolean$2(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$2(obj, map, function(val, key) {
    var groupKey = serializeInternal$1(val, refs);
    var arr = getOwn$8(group, groupKey) || [];
    arr.push(asObject ? key : obj[key]);
    group[groupKey] = arr;
  });
  minMaxResult = getMinOrMax$4(group, !!all, 'length', most, true);
  if (all) {
    result = [];
    // Flatten result
    forEachProperty$d(minMaxResult, function(val) {
      result = result.concat(val);
    });
  } else {
    result = getOwn$8(group, minMaxResult);
  }
  return getReducedMinMaxResult(result, obj, all, asObject);
}

var getLeastOrMost_1 = getLeastOrMost$4;

var Sugar$4p = sugarCore.exports,
    getLeastOrMost$3 = getLeastOrMost_1;

Sugar$4p.Object.defineInstanceAndStatic({

  'least': function(obj, all, map) {
    return getLeastOrMost$3(obj, all, map, false, true);
  }

});

Sugar$4p.Object.least;

var mapWithShortcuts$1 = mapWithShortcuts_1,
    coreUtilityAliases$n = coreUtilityAliases$M;

var forEachProperty$c = coreUtilityAliases$n.forEachProperty;

function objectMap$1(obj, map) {
  var result = {};
  forEachProperty$c(obj, function(val, key) {
    result[key] = mapWithShortcuts$1(val, map, obj, [val, key, obj]);
  });
  return result;
}

var objectMap_1 = objectMap$1;

var Sugar$4o = sugarCore.exports,
    objectMap = objectMap_1;

Sugar$4o.Object.defineInstanceAndStatic({

  'map': function(obj, map) {
    return objectMap(obj, map);
  }

});

Sugar$4o.Object.map;

var Sugar$4n = sugarCore.exports,
    getMinOrMax$3 = getMinOrMax_1;

Sugar$4n.Object.defineInstanceAndStatic({

  'max': function(obj, all, map) {
    return getMinOrMax$3(obj, all, map, true, true);
  }

});

Sugar$4n.Object.max;

var trunc$8 = trunc_1,
    enumerateWithMapping$1 = enumerateWithMapping_1;

function median$2(obj, map) {
  var result = [], middle, len;
  enumerateWithMapping$1(obj, map, function(val) {
    result.push(val);
  });
  len = result.length;
  if (!len) return 0;
  result.sort(function(a, b) {
    // IE7 will throw errors on non-numbers!
    return (a || 0) - (b || 0);
  });
  middle = trunc$8(len / 2);
  return len % 2 ? result[middle] : (result[middle - 1] + result[middle]) / 2;
}

var median_1 = median$2;

var Sugar$4m = sugarCore.exports,
    median$1 = median_1;

Sugar$4m.Object.defineInstanceAndStatic({

  'median': function(obj, map) {
    return median$1(obj, map);
  }

});

Sugar$4m.Object.median;

var Sugar$4l = sugarCore.exports,
    getMinOrMax$2 = getMinOrMax_1;

Sugar$4l.Object.defineInstanceAndStatic({

  'min': function(obj, all, map) {
    return getMinOrMax$2(obj, all, map, false, true);
  }

});

Sugar$4l.Object.min;

var Sugar$4k = sugarCore.exports,
    getLeastOrMost$2 = getLeastOrMost_1;

Sugar$4k.Object.defineInstanceAndStatic({

  'most': function(obj, all, map) {
    return getLeastOrMost$2(obj, all, map, true, true);
  }

});

Sugar$4k.Object.most;

var objectMatchers$1 = objectMatchers$4;

var objectSome$1 = objectMatchers$1.objectSome;

function objectNone$1(obj, f) {
  return !objectSome$1(obj, f);
}

var objectNone_1 = objectNone$1;

var Sugar$4j = sugarCore.exports,
    objectNone = objectNone_1;

Sugar$4j.Object.defineInstanceAndStatic({

  'none': function(obj, f) {
    return objectNone(obj, f);
  }

});

Sugar$4j.Object.none;

var isDefined$b = isDefined_1,
    coreUtilityAliases$m = coreUtilityAliases$M;

var forEachProperty$b = coreUtilityAliases$m.forEachProperty;

function objectReduce$1(obj, fn, acc) {
  var init = isDefined$b(acc);
  forEachProperty$b(obj, function(val, key) {
    if (!init) {
      acc = val;
      init = true;
      return;
    }
    acc = fn(acc, val, key, obj);
  });
  return acc;
}

var objectReduce_1 = objectReduce$1;

var Sugar$4i = sugarCore.exports,
    objectReduce = objectReduce_1;

Sugar$4i.Object.defineInstanceAndStatic({

  'reduce': function(obj, fn, init) {
    return objectReduce(obj, fn, init);
  }

});

Sugar$4i.Object.reduce;

var Sugar$4h = sugarCore.exports,
    objectMatchers = objectMatchers$4;

var objectSome = objectMatchers.objectSome;

Sugar$4h.Object.defineInstanceAndStatic({

  'some': objectSome

});

Sugar$4h.Object.some;

var enumerateWithMapping = enumerateWithMapping_1;

function sum$2(obj, map) {
  var sum = 0;
  enumerateWithMapping(obj, map, function(val) {
    sum += val;
  });
  return sum;
}

var sum_1 = sum$2;

var Sugar$4g = sugarCore.exports,
    sum$1 = sum_1;

Sugar$4g.Object.defineInstanceAndStatic({

  'sum': function(obj, map) {
    return sum$1(obj, map);
  }

});

Sugar$4g.Object.sum;

var Sugar$4f = sugarCore.exports,
    average = average_1;

Sugar$4f.Array.defineInstance({

  'average': function(arr, map) {
    return average(arr, map);
  }

});

Sugar$4f.Array.average;

var getMatcher$2 = getMatcher_1,
    classChecks$w = classChecks$Z;

var isFunction$8 = classChecks$w.isFunction;

function enhancedMatching$2(f) {
  var matcher;
  if (isFunction$8(f)) {
    return f;
  }
  matcher = getMatcher$2(f);
  return function(el, i, arr) {
    return matcher(el, i, arr);
  };
}

var enhancedMatching_1 = enhancedMatching$2;

function assertArgument$2(exists) {
  if (!exists) {
    throw new TypeError('Argument required');
  }
}

var assertArgument_1 = assertArgument$2;

var assertArgument$1 = assertArgument_1;

function wrapNativeArrayMethod$2(methodName, wrapper) {
  var nativeFn = Array.prototype[methodName];
  return function(arr, f, context, argsLen) {
    var args = new Array(2);
    assertArgument$1(argsLen > 0);
    args[0] = wrapper(f, context);
    args[1] = context;
    return nativeFn.apply(arr, args);
  };
}

var wrapNativeArrayMethod_1 = wrapNativeArrayMethod$2;

var enhancedMatching$1 = enhancedMatching_1,
    wrapNativeArrayMethod$1 = wrapNativeArrayMethod_1;

function buildEnhancedMatching$1(name) {
  return wrapNativeArrayMethod$1(name, enhancedMatching$1);
}

var buildEnhancedMatching_1 = buildEnhancedMatching$1;

var buildEnhancedMatching = buildEnhancedMatching_1;

var enhancedMatcherMethods$7 = {
  enhancedFind: buildEnhancedMatching('find'),
  enhancedSome: buildEnhancedMatching('some'),
  enhancedEvery: buildEnhancedMatching('every'),
  enhancedFilter: buildEnhancedMatching('filter'),
  enhancedFindIndex: buildEnhancedMatching('findIndex')
};

var isUndefined$7 = isUndefined_1,
    enhancedMatcherMethods$6 = enhancedMatcherMethods$7;

var enhancedFilter$1 = enhancedMatcherMethods$6.enhancedFilter;

function arrayCount$1(arr, f) {
  if (isUndefined$7(f)) {
    return arr.length;
  }
  return enhancedFilter$1.apply(this, arguments).length;
}

var arrayCount_1 = arrayCount$1;

var Sugar$4e = sugarCore.exports,
    arrayCount = arrayCount_1,
    fixArgumentLength$7 = fixArgumentLength_1;

Sugar$4e.Array.defineInstance({

  'count': fixArgumentLength$7(arrayCount)

});

Sugar$4e.Array.count;

var ARRAY_ENHANCEMENTS_FLAG$6 = 'enhanceArray';

var Sugar$4d = sugarCore.exports,
    ENHANCEMENTS_FLAG$5 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$5 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$6 = fixArgumentLength_1,
    enhancedMatcherMethods$5 = enhancedMatcherMethods$7;

var enhancedEvery = enhancedMatcherMethods$5.enhancedEvery;

Sugar$4d.Array.defineInstance({

  'every': fixArgumentLength$6(enhancedEvery)

}, [ENHANCEMENTS_FLAG$5, ARRAY_ENHANCEMENTS_FLAG$5]);

Sugar$4d.Array.every;

var classChecks$v = classChecks$Z,
    mapWithShortcuts = mapWithShortcuts_1;

var isFunction$7 = classChecks$v.isFunction;

function enhancedMapping$2(map, context) {
  if (isFunction$7(map)) {
    return map;
  } else if (map) {
    return function(el, i, arr) {
      return mapWithShortcuts(el, map, context, [el, i, arr]);
    };
  }
}

var enhancedMapping_1 = enhancedMapping$2;

var forEach$8 = forEach_1,
    spaceSplit$2 = spaceSplit_1,
    classChecks$u = classChecks$Z,
    mathAliases$h = mathAliases$z,
    assertArgument = assertArgument_1,
    enhancedMapping$1 = enhancedMapping_1,
    namespaceAliases$9 = namespaceAliases$e,
    enhancedMatching = enhancedMatching_1,
    getNormalizedIndex = getNormalizedIndex_1,
    coreUtilityAliases$l = coreUtilityAliases$M,
    methodDefineAliases$1 = methodDefineAliases$3;

var forEachProperty$a = coreUtilityAliases$l.forEachProperty,
    defineInstanceWithArguments = methodDefineAliases$1.defineInstanceWithArguments,
    sugarArray = namespaceAliases$9.sugarArray,
    min$3 = mathAliases$h.min,
    max$4 = mathAliases$h.max,
    isBoolean$1 = classChecks$u.isBoolean;

function buildFromIndexMethods$1() {

  var methods = {
    'forEach': {
      base: forEachAsNative
    },
    'map': {
      wrapper: enhancedMapping$1
    },
    'some every': {
      wrapper: enhancedMatching
    },
    'findIndex': {
      wrapper: enhancedMatching,
      result: indexResult
    },
    'reduce': {
      apply: applyReduce
    },
    'filter find': {
      wrapper: enhancedMatching
    },
    'reduceRight': {
      apply: applyReduce,
      slice: sliceArrayFromRight,
      clamp: clampStartIndexFromRight
    }
  };

  forEachProperty$a(methods, function(opts, key) {
    forEach$8(spaceSplit$2(key), function(baseName) {
      var methodName = baseName + 'FromIndex';
      var fn = createFromIndexWithOptions(baseName, opts);
      defineInstanceWithArguments(sugarArray, methodName, fn);
    });
  });

  function forEachAsNative(fn) {
    forEach$8(this, fn);
  }

  // Methods like filter and find have a direct association between the value
  // returned by the callback and the element of the current iteration. This
  // means that when looping, array elements must match the actual index for
  // which they are being called, so the array must be sliced. This is not the
  // case for methods like forEach and map, which either do not use return
  // values or use them in a way that simply getting the element at a shifted
  // index will not affect the final return value. However, these methods will
  // still fail on sparse arrays, so always slicing them here. For example, if
  // "forEachFromIndex" were to be called on [1,,2] from index 1, although the
  // actual index 1 would itself would be skipped, when the array loops back to
  // index 0, shifting it by adding 1 would result in the element for that
  // iteration being undefined. For shifting to work, all gaps in the array
  // between the actual index and the shifted index would have to be accounted
  // for. This is infeasible and is easily solved by simply slicing the actual
  // array instead so that gaps align. Note also that in the case of forEach,
  // we are using the internal function which handles sparse arrays in a way
  // that does not increment the index, and so is highly optimized compared to
  // the others here, which are simply going through the native implementation.
  function sliceArrayFromLeft(arr, startIndex, loop) {
    var result = arr;
    if (startIndex) {
      result = arr.slice(startIndex);
      if (loop) {
        result = result.concat(arr.slice(0, startIndex));
      }
    }
    return result;
  }

  // When iterating from the right, indexes are effectively shifted by 1.
  // For example, iterating from the right from index 2 in an array of 3
  // should also include the last element in the array. This matches the
  // "lastIndexOf" method which also iterates from the right.
  function sliceArrayFromRight(arr, startIndex, loop) {
    if (!loop) {
      startIndex += 1;
      arr = arr.slice(0, max$4(0, startIndex));
    }
    return arr;
  }

  function clampStartIndex(startIndex, len) {
    return min$3(len, max$4(0, startIndex));
  }

  // As indexes are shifted by 1 when starting from the right, clamping has to
  // go down to -1 to accommodate the full range of the sliced array.
  function clampStartIndexFromRight(startIndex, len) {
    return min$3(len, max$4(-1, startIndex));
  }

  function applyReduce(arr, startIndex, fn, context, len, loop) {
    return function(acc, val, i) {
      i = getNormalizedIndex(i + startIndex, len, loop);
      return fn.call(arr, acc, val, i, arr);
    };
  }

  function applyEach(arr, startIndex, fn, context, len, loop) {
    return function(el, i) {
      i = getNormalizedIndex(i + startIndex, len, loop);
      return fn.call(context, arr[i], i, arr);
    };
  }

  function indexResult(result, startIndex, len) {
    if (result !== -1) {
      result = (result + startIndex) % len;
    }
    return result;
  }

  function createFromIndexWithOptions(methodName, opts) {

    var baseFn = opts.base || Array.prototype[methodName],
        applyCallback = opts.apply || applyEach,
        sliceArray = opts.slice || sliceArrayFromLeft,
        clampIndex = opts.clamp || clampStartIndex,
        getResult = opts.result,
        wrapper = opts.wrapper;

    return function(arr, startIndex, args) {
      var callArgs = [], argIndex = 0, lastArg, result, len, loop, fn;
      len = arr.length;
      if (isBoolean$1(args[0])) {
        loop = args[argIndex++];
      }
      fn = args[argIndex++];
      lastArg = args[argIndex];
      if (startIndex < 0) {
        startIndex += len;
      }
      startIndex = clampIndex(startIndex, len);
      assertArgument(args.length);
      fn = wrapper ? wrapper(fn, lastArg) : fn;
      callArgs.push(applyCallback(arr, startIndex, fn, lastArg, len, loop));
      if (lastArg) {
        callArgs.push(lastArg);
      }
      result = baseFn.apply(sliceArray(arr, startIndex, loop), callArgs);
      if (getResult) {
        result = getResult(result, startIndex, len);
      }
      return result;
    };
  }
}

var buildFromIndexMethods_1 = buildFromIndexMethods$1;

var buildFromIndexMethods = buildFromIndexMethods_1;

buildFromIndexMethods();

var Sugar$4c = sugarCore.exports;



Sugar$4c.Array.everyFromIndex;

var Sugar$4b = sugarCore.exports,
    ENHANCEMENTS_FLAG$4 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$4 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$5 = fixArgumentLength_1,
    enhancedMatcherMethods$4 = enhancedMatcherMethods$7;

var enhancedFilter = enhancedMatcherMethods$4.enhancedFilter;

Sugar$4b.Array.defineInstance({

  'filter': fixArgumentLength$5(enhancedFilter)

}, [ENHANCEMENTS_FLAG$4, ARRAY_ENHANCEMENTS_FLAG$4]);

Sugar$4b.Array.filter;

var Sugar$4a = sugarCore.exports;



Sugar$4a.Array.filterFromIndex;

var Sugar$49 = sugarCore.exports,
    ENHANCEMENTS_FLAG$3 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$3 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$4 = fixArgumentLength_1,
    enhancedMatcherMethods$3 = enhancedMatcherMethods$7;

var enhancedFind = enhancedMatcherMethods$3.enhancedFind;

Sugar$49.Array.defineInstance({

  'find': fixArgumentLength$4(enhancedFind)

}, [ENHANCEMENTS_FLAG$3, ARRAY_ENHANCEMENTS_FLAG$3]);

Sugar$49.Array.find;

var Sugar$48 = sugarCore.exports;



Sugar$48.Array.findFromIndex;

var Sugar$47 = sugarCore.exports,
    ENHANCEMENTS_FLAG$2 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$2 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$3 = fixArgumentLength_1,
    enhancedMatcherMethods$2 = enhancedMatcherMethods$7;

var enhancedFindIndex = enhancedMatcherMethods$2.enhancedFindIndex;

Sugar$47.Array.defineInstance({

  'findIndex': fixArgumentLength$3(enhancedFindIndex)

}, [ENHANCEMENTS_FLAG$2, ARRAY_ENHANCEMENTS_FLAG$2]);

Sugar$47.Array.findIndex;

var Sugar$46 = sugarCore.exports;



Sugar$46.Array.findIndexFromIndex;

var Sugar$45 = sugarCore.exports;



Sugar$45.Array.forEachFromIndex;

var Sugar$44 = sugarCore.exports,
    getLeastOrMost$1 = getLeastOrMost_1;

Sugar$44.Array.defineInstance({

  'least': function(arr, all, map) {
    return getLeastOrMost$1(arr, all, map);
  }

});

Sugar$44.Array.least;

var enhancedMapping = enhancedMapping_1,
    wrapNativeArrayMethod = wrapNativeArrayMethod_1;

function buildEnhancedMapping$1(name) {
  return wrapNativeArrayMethod(name, enhancedMapping);
}

var buildEnhancedMapping_1 = buildEnhancedMapping$1;

var buildEnhancedMapping = buildEnhancedMapping_1;

var enhancedMap$1 = buildEnhancedMapping('map');

var Sugar$43 = sugarCore.exports,
    ENHANCEMENTS_FLAG$1 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$1 = ARRAY_ENHANCEMENTS_FLAG$6,
    enhancedMap = enhancedMap$1,
    fixArgumentLength$2 = fixArgumentLength_1;

Sugar$43.Array.defineInstance({

  'map': fixArgumentLength$2(enhancedMap)

}, [ENHANCEMENTS_FLAG$1, ARRAY_ENHANCEMENTS_FLAG$1]);

Sugar$43.Array.map;

var Sugar$42 = sugarCore.exports;



Sugar$42.Array.mapFromIndex;

var Sugar$41 = sugarCore.exports,
    getMinOrMax$1 = getMinOrMax_1;

Sugar$41.Array.defineInstance({

  'max': function(arr, all, map) {
    return getMinOrMax$1(arr, all, map, true);
  }

});

Sugar$41.Array.max;

var Sugar$40 = sugarCore.exports,
    median = median_1;

Sugar$40.Array.defineInstance({

  'median': function(arr, map) {
    return median(arr, map);
  }

});

Sugar$40.Array.median;

var Sugar$3$ = sugarCore.exports,
    getMinOrMax = getMinOrMax_1;

Sugar$3$.Array.defineInstance({

  'min': function(arr, all, map) {
    return getMinOrMax(arr, all, map);
  }

});

Sugar$3$.Array.min;

var Sugar$3_ = sugarCore.exports,
    getLeastOrMost = getLeastOrMost_1;

Sugar$3_.Array.defineInstance({

  'most': function(arr, all, map) {
    return getLeastOrMost(arr, all, map, true);
  }

});

Sugar$3_.Array.most;

var enhancedMatcherMethods$1 = enhancedMatcherMethods$7;

var enhancedSome$1 = enhancedMatcherMethods$1.enhancedSome;

function arrayNone$1() {
  return !enhancedSome$1.apply(this, arguments);
}

var arrayNone_1 = arrayNone$1;

var Sugar$3Z = sugarCore.exports,
    arrayNone = arrayNone_1,
    fixArgumentLength$1 = fixArgumentLength_1;

Sugar$3Z.Array.defineInstance({

  'none': fixArgumentLength$1(arrayNone)

});

Sugar$3Z.Array.none;

var Sugar$3Y = sugarCore.exports;



Sugar$3Y.Array.reduceFromIndex;

var Sugar$3X = sugarCore.exports;



Sugar$3X.Array.reduceRightFromIndex;

var Sugar$3W = sugarCore.exports,
    ENHANCEMENTS_FLAG = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength = fixArgumentLength_1,
    enhancedMatcherMethods = enhancedMatcherMethods$7;

var enhancedSome = enhancedMatcherMethods.enhancedSome;

Sugar$3W.Array.defineInstance({

  'some': fixArgumentLength(enhancedSome)

}, [ENHANCEMENTS_FLAG, ARRAY_ENHANCEMENTS_FLAG]);

Sugar$3W.Array.some;

var Sugar$3V = sugarCore.exports;



Sugar$3V.Array.someFromIndex;

var Sugar$3U = sugarCore.exports,
    sum = sum_1;

Sugar$3U.Array.defineInstance({

  'sum': function(arr, map) {
    return sum(arr, map);
  }

});

Sugar$3U.Array.sum;

var getOwnPropertyNames$2 = Object.getOwnPropertyNames;

var classChecks$t = classChecks$Z,
    isPrimitive$3 = isPrimitive_1,
    isPlainObject$1 = isPlainObject_1,
    getRegExpFlags$3 = getRegExpFlags_1,
    coreUtilityAliases$k = coreUtilityAliases$M;

var classToString$1 = coreUtilityAliases$k.classToString,
    isDate$8 = classChecks$t.isDate,
    isRegExp$3 = classChecks$t.isRegExp,
    isArray$5 = classChecks$t.isArray;

function getNewObjectForMerge$2(source) {
  var klass = classToString$1(source);
  // Primitive types, dates, and regexes have no "empty" state. If they exist
  // at all, then they have an associated value. As we are only creating new
  // objects when they don't exist in the target, these values can come alone
  // for the ride when created.
  if (isArray$5(source, klass)) {
    return [];
  } else if (isPlainObject$1(source, klass)) {
    return {};
  } else if (isDate$8(source, klass)) {
    return new Date(source.getTime());
  } else if (isRegExp$3(source, klass)) {
    return RegExp(source.source, getRegExpFlags$3(source));
  } else if (isPrimitive$3(source && source.valueOf())) {
    return source;
  }
  // If the object is not of a known type, then simply merging its
  // properties into a plain object will result in something different
  // (it will not respond to instanceof operator etc). Similarly we don't
  // want to call a constructor here as we can't know for sure what the
  // original constructor was called with (Events etc), so throw an
  // error here instead. Non-standard types can be handled if either they
  // already exist and simply have their properties merged, if the merge
  // is not deep so their references will simply be copied over, or if a
  // resolve function is used to assist the merge.
  throw new TypeError('Must be a basic data type');
}

var getNewObjectForMerge_1 = getNewObjectForMerge$2;

var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor$2;

function iterateOverKeys$1(getFn, obj, fn, hidden) {
  var keys = getFn(obj), desc;
  for (var i = 0, key; key = keys[i]; i++) {
    desc = getOwnPropertyDescriptor$1(obj, key);
    if (desc.enumerable || hidden) {
      fn(obj[key], key);
    }
  }
}

var iterateOverKeys_1 = iterateOverKeys$1;

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;

var iterateOverKeys = iterateOverKeys_1,
    coreUtilityAliases$j = coreUtilityAliases$M,
    getOwnPropertyNames$1 = getOwnPropertyNames$2,
    getOwnPropertySymbols = getOwnPropertySymbols$1;

var forEachProperty$9 = coreUtilityAliases$j.forEachProperty;

function iterateOverProperties$1(hidden, obj, fn) {
  if (getOwnPropertyNames$1 && hidden) {
    iterateOverKeys(getOwnPropertyNames$1, obj, fn, hidden);
  } else {
    forEachProperty$9(obj, fn);
  }
  if (getOwnPropertySymbols) {
    iterateOverKeys(getOwnPropertySymbols, obj, fn, hidden);
  }
}

var iterateOverProperties_1 = iterateOverProperties$1;

var NO_KEYS_IN_STRING_OBJECTS$1 = !('0' in Object('a'));

function forceStringCoercion$1(obj) {
  var i = 0, chr;
  while (chr = obj.charAt(i)) {
    obj[i++] = chr;
  }
}

var forceStringCoercion_1 = forceStringCoercion$1;

var NO_KEYS_IN_STRING_OBJECTS = NO_KEYS_IN_STRING_OBJECTS$1,
    isPrimitive$2 = isPrimitive_1,
    classChecks$s = classChecks$Z,
    forceStringCoercion = forceStringCoercion_1;

var isString$9 = classChecks$s.isString;

function coercePrimitiveToObject$3(obj) {
  if (isPrimitive$2(obj)) {
    obj = Object(obj);
  }
  // istanbul ignore next
  if (NO_KEYS_IN_STRING_OBJECTS && isString$9(obj)) {
    forceStringCoercion(obj);
  }
  return obj;
}

var coercePrimitiveToObject_1 = coercePrimitiveToObject$3;

var isDefined$a = isDefined_1,
    coreUtilityAliases$i = coreUtilityAliases$M,
    getOwnPropertyDescriptor = getOwnPropertyDescriptor$2;

var defineProperty = coreUtilityAliases$i.defineProperty;

function mergeByPropertyDescriptor$1(target, source, prop, sourceVal) {
  var descriptor = getOwnPropertyDescriptor(source, prop);
  if (isDefined$a(descriptor.value)) {
    descriptor.value = sourceVal;
  }
  defineProperty(target, prop, descriptor);
}

var mergeByPropertyDescriptor_1 = mergeByPropertyDescriptor$1;

var Sugar$3T = sugarCore.exports,
    isDefined$9 = isDefined_1,
    classChecks$r = classChecks$Z,
    isPrimitive$1 = isPrimitive_1,
    isUndefined$6 = isUndefined_1,
    isObjectType$6 = isObjectType_1,
    coreUtilityAliases$h = coreUtilityAliases$M,
    getOwnPropertyNames = getOwnPropertyNames$2,
    getNewObjectForMerge$1 = getNewObjectForMerge_1,
    iterateOverProperties = iterateOverProperties_1,
    coercePrimitiveToObject$2 = coercePrimitiveToObject_1,
    mergeByPropertyDescriptor = mergeByPropertyDescriptor_1;

var isDate$7 = classChecks$r.isDate,
    isRegExp$2 = classChecks$r.isRegExp,
    isFunction$6 = classChecks$r.isFunction,
    getOwn$7 = coreUtilityAliases$h.getOwn;

function objectMerge$3(target, source, deep, resolve, hidden, descriptor) {
  var resolveByFunction = isFunction$6(resolve), resolveConflicts = resolve !== false;

  if (isUndefined$6(target)) {
    target = getNewObjectForMerge$1(source);
  } else if (resolveConflicts && isDate$7(target) && isDate$7(source)) {
    // A date's timestamp is a property that can only be reached through its
    // methods, so actively set it up front if both are dates.
    target.setTime(source.getTime());
  }

  if (isPrimitive$1(target)) {
    // Will not merge into a primitive type, so simply override.
    return source;
  }

  // If the source object is a primitive
  // type then coerce it into an object.
  if (isPrimitive$1(source)) {
    source = coercePrimitiveToObject$2(source);
  }

  iterateOverProperties(hidden, source, function(val, key) {
    var sourceVal, targetVal, resolved, goDeep, result;

    sourceVal = source[key];

    // We are iterating over properties of the source, so hasOwnProperty on
    // it is guaranteed to always be true. However, the target may happen to
    // have properties in its prototype chain that should not be considered
    // as conflicts.
    targetVal = getOwn$7(target, key);

    if (resolveByFunction) {
      result = resolve(key, targetVal, sourceVal, target, source);
      if (isUndefined$6(result)) {
        // Result is undefined so do not merge this property.
        return;
      } else if (isDefined$9(result) && result !== Sugar$3T) {
        // If the source returns anything except undefined, then the conflict
        // has been resolved, so don't continue traversing into the object. If
        // the returned value is the Sugar global object, then allowing Sugar
        // to resolve the conflict, so continue on.
        sourceVal = result;
        resolved = true;
      }
    } else if (isUndefined$6(sourceVal)) {
      // Will not merge undefined.
      return;
    }

    // Regex properties are read-only, so intentionally disallowing deep
    // merging for now. Instead merge by reference even if deep.
    goDeep = !resolved && deep && isObjectType$6(sourceVal) && !isRegExp$2(sourceVal);

    if (!goDeep && !resolveConflicts && isDefined$9(targetVal)) {
      return;
    }

    if (goDeep) {
      sourceVal = objectMerge$3(targetVal, sourceVal, deep, resolve, hidden, descriptor);
    }

    // getOwnPropertyNames is standing in as
    // a test for property descriptor support
    if (getOwnPropertyNames && descriptor) {
      mergeByPropertyDescriptor(target, source, key, sourceVal);
    } else {
      target[key] = sourceVal;
    }

  });
  return target;
}

var objectMerge_1 = objectMerge$3;

var objectMerge$2 = objectMerge_1,
    getNewObjectForMerge = getNewObjectForMerge_1;

function clone$3(source, deep) {
  var target = getNewObjectForMerge(source);
  return objectMerge$2(target, source, deep, true, true, true);
}

var clone_1 = clone$3;

var objectMerge$1 = objectMerge_1;

function mergeWithOptions$3(target, source, opts) {
  opts = opts || {};
  return objectMerge$1(target, source, opts.deep, opts.resolve, opts.hidden, opts.descriptor);
}

var mergeWithOptions_1 = mergeWithOptions$3;

var Sugar$3S = sugarCore.exports,
    clone$2 = clone_1,
    mergeWithOptions$2 = mergeWithOptions_1;

Sugar$3S.Object.defineInstanceAndStatic({

  'add': function(obj1, obj2, opts) {
    return mergeWithOptions$2(clone$2(obj1), obj2, opts);
  }

});

Sugar$3S.Object.add;

var forEach$7 = forEach_1,
    classChecks$q = classChecks$Z,
    mergeWithOptions$1 = mergeWithOptions_1;

var isArray$4 = classChecks$q.isArray;

function mergeAll$3(target, sources, opts) {
  if (!isArray$4(sources)) {
    sources = [sources];
  }
  forEach$7(sources, function(source) {
    return mergeWithOptions$1(target, source, opts);
  });
  return target;
}

var mergeAll_1 = mergeAll$3;

var Sugar$3R = sugarCore.exports,
    clone$1 = clone_1,
    mergeAll$2 = mergeAll_1;

Sugar$3R.Object.defineInstanceAndStatic({

  'addAll': function(obj, sources, opts) {
    return mergeAll$2(clone$1(obj), sources, opts);
  }

});

Sugar$3R.Object.addAll;

var Sugar$3Q = sugarCore.exports,
    clone = clone_1;

Sugar$3Q.Object.defineInstanceAndStatic({

  'clone': function(obj, deep) {
    return clone(obj, deep);
  }

});

Sugar$3Q.Object.clone;

var mergeAll$1 = mergeAll_1;

function defaults$1(target, sources, opts) {
  opts = opts || {};
  opts.resolve = opts.resolve || false;
  return mergeAll$1(target, sources, opts);
}

var defaults_1 = defaults$1;

var Sugar$3P = sugarCore.exports,
    defaults = defaults_1;

Sugar$3P.Object.defineInstanceAndStatic({

  'defaults': function(target, sources, opts) {
    return defaults(target, sources, opts);
  }

});

Sugar$3P.Object.defaults;

var getMatcher$1 = getMatcher_1,
    coreUtilityAliases$g = coreUtilityAliases$M;

var forEachProperty$8 = coreUtilityAliases$g.forEachProperty;

function objectExclude$1(obj, f) {
  var result = {};
  var matcher = getMatcher$1(f);
  forEachProperty$8(obj, function(val, key) {
    if (!matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectExclude_1 = objectExclude$1;

var Sugar$3O = sugarCore.exports,
    objectExclude = objectExclude_1;

Sugar$3O.Object.defineInstanceAndStatic({

  'exclude': function(obj, f) {
    return objectExclude(obj, f);
  }

});

Sugar$3O.Object.exclude;

var DEEP_QUERY_STRING_REG$1 = /^(.+?)(\[.*\])$/;

var NON_DECIMAL_REG$1 = /[^\d.-]/;

var NON_DECIMAL_REG = NON_DECIMAL_REG$1;

function stringIsDecimal$1(str) {
  return str !== '' && !NON_DECIMAL_REG.test(str);
}

var stringIsDecimal_1 = stringIsDecimal$1;

var classChecks$p = classChecks$Z,
    stringIsDecimal = stringIsDecimal_1,
    coreUtilityAliases$f = coreUtilityAliases$M;

var getOwn$6 = coreUtilityAliases$f.getOwn,
    isArray$3 = classChecks$p.isArray;

function getQueryValueAuto$1(obj, key, val) {
  if (!val) {
    return null;
  } else if (val === 'true') {
    return true;
  } else if (val === 'false') {
    return false;
  }
  var num = +val;
  if (!isNaN(num) && stringIsDecimal(val)) {
    return num;
  }
  var existing = getOwn$6(obj, key);
  if (val && existing) {
    return isArray$3(existing) ? existing.concat(val) : [existing, val];
  }
  return val;
}

var getQueryValueAuto_1 = getQueryValueAuto$1;

var isDefined$8 = isDefined_1,
    getQueryValueAuto = getQueryValueAuto_1;

function setQueryProperty$2(obj, key, val, auto, transform) {
  var fnValue;
  if (transform) {
    fnValue = transform(val, key, obj);
  }
  if (isDefined$8(fnValue)) {
    val = fnValue;
  } else if (auto) {
    val = getQueryValueAuto(obj, key, val);
  }
  obj[key] = val;
}

var setQueryProperty_1 = setQueryProperty$2;

function mapQuerySeparatorToKeys$1(key, separator) {
  var split = key.split(separator), result = split[0];
  for (var i = 1, len = split.length; i < len; i++) {
    result += '[' + split[i] + ']';
  }
  return result;
}

var mapQuerySeparatorToKeys_1 = mapQuerySeparatorToKeys$1;

var forEach$6 = forEach_1,
    setQueryProperty$1 = setQueryProperty_1,
    coreUtilityAliases$e = coreUtilityAliases$M;

var hasOwn$5 = coreUtilityAliases$e.hasOwn,
    getOwn$5 = coreUtilityAliases$e.getOwn;

function parseDeepQueryComponent$1(obj, match, val, deep, auto, separator, transform) {
  var key = match[1];
  var inner = match[2].slice(1, -1).split('][');
  forEach$6(inner, function(k) {
    if (!hasOwn$5(obj, key)) {
      obj[key] = k ? {} : [];
    }
    obj = getOwn$5(obj, key);
    key = k ? k : obj.length.toString();
  });
  setQueryProperty$1(obj, key, val, auto, transform);
}

var parseDeepQueryComponent_1 = parseDeepQueryComponent$1;

var DEEP_QUERY_STRING_REG = DEEP_QUERY_STRING_REG$1,
    setQueryProperty = setQueryProperty_1,
    mapQuerySeparatorToKeys = mapQuerySeparatorToKeys_1,
    parseDeepQueryComponent = parseDeepQueryComponent_1;

function parseQueryComponent$1(obj, key, val, deep, auto, separator, transform) {
  var match;
  if (separator) {
    key = mapQuerySeparatorToKeys(key, separator);
    deep = true;
  }
  if (deep === true && (match = key.match(DEEP_QUERY_STRING_REG))) {
    parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform);
  } else {
    setQueryProperty(obj, key, val, auto, transform);
  }
}

var parseQueryComponent_1 = parseQueryComponent$1;

var forEach$5 = forEach_1,
    parseQueryComponent = parseQueryComponent_1;

function fromQueryStringWithOptions$1(obj, opts) {
  var str = String(obj || '').replace(/^.*?\?/, ''), result = {}, auto;
  opts = opts || {};
  if (str) {
    forEach$5(str.split('&'), function(p) {
      var split = p.split('=');
      var key = decodeURIComponent(split[0]);
      var val = split.length === 2 ? decodeURIComponent(split[1]) : '';
      auto = opts.auto !== false;
      parseQueryComponent(result, key, val, opts.deep, auto, opts.separator, opts.transform);
    });
  }
  return result;
}

var fromQueryStringWithOptions_1 = fromQueryStringWithOptions$1;

var Sugar$3N = sugarCore.exports,
    fromQueryStringWithOptions = fromQueryStringWithOptions_1;

Sugar$3N.Object.defineStatic({

  'fromQueryString': function(obj, options) {
    return fromQueryStringWithOptions(obj, options);
  }

});

Sugar$3N.Object.fromQueryString;

var Sugar$3M = sugarCore.exports,
    deepGetProperty$1 = deepGetProperty_1;

Sugar$3M.Object.defineInstanceAndStatic({

  'get': function(obj, key, any) {
    return deepGetProperty$1(obj, key, any);
  }

});

Sugar$3M.Object.get;

var handleDeepProperty$1 = handleDeepProperty_1;

function deepHasProperty$1(obj, key, any) {
  return handleDeepProperty$1(obj, key, any, true);
}

var deepHasProperty_1 = deepHasProperty$1;

var Sugar$3L = sugarCore.exports,
    deepHasProperty = deepHasProperty_1;

Sugar$3L.Object.defineInstanceAndStatic({

  'has': function(obj, key, any) {
    return deepHasProperty(obj, key, any);
  }

});

Sugar$3L.Object.has;

var isEqual$1 = isEqual_1,
    objectMerge = objectMerge_1,
    isObjectType$5 = isObjectType_1,
    coercePrimitiveToObject$1 = coercePrimitiveToObject_1;

function objectIntersectOrSubtract$2(obj1, obj2, subtract) {
  if (!isObjectType$5(obj1)) {
    return subtract ? obj1 : {};
  }
  obj2 = coercePrimitiveToObject$1(obj2);
  function resolve(key, val, val1) {
    var exists = key in obj2 && isEqual$1(val1, obj2[key]);
    if (exists !== subtract) {
      return val1;
    }
  }
  return objectMerge({}, obj1, false, resolve);
}

var objectIntersectOrSubtract_1 = objectIntersectOrSubtract$2;

var Sugar$3K = sugarCore.exports,
    objectIntersectOrSubtract$1 = objectIntersectOrSubtract_1;

Sugar$3K.Object.defineInstanceAndStatic({

  'intersect': function(obj1, obj2) {
    return objectIntersectOrSubtract$1(obj1, obj2, false);
  }

});

Sugar$3K.Object.intersect;

var Sugar$3J = sugarCore.exports,
    coreUtilityAliases$d = coreUtilityAliases$M;

var hasOwn$4 = coreUtilityAliases$d.hasOwn,
    forEachProperty$7 = coreUtilityAliases$d.forEachProperty;

Sugar$3J.Object.defineInstanceAndStatic({

  'invert': function(obj, multi) {
    var result = {};
    multi = multi === true;
    forEachProperty$7(obj, function(val, key) {
      if (hasOwn$4(result, val) && multi) {
        result[val].push(key);
      } else if (multi) {
        result[val] = [key];
      } else {
        result[val] = key;
      }
    });
    return result;
  }

});

Sugar$3J.Object.invert;

var isPrimitive = isPrimitive_1;

function hasProperty$1(obj, prop) {
  return !isPrimitive(obj) && prop in obj;
}

var hasProperty_1 = hasProperty$1;

var hasProperty = hasProperty_1,
    coreUtilityAliases$c = coreUtilityAliases$M;

var classToString = coreUtilityAliases$c.classToString;

function isArguments$1(obj, className) {
  className = className || classToString(obj);
  // .callee exists on Arguments objects in < IE8
  return hasProperty(obj, 'length') && (className === '[object Arguments]' || !!obj.callee);
}

var isArguments_1 = isArguments$1;

var Sugar$3I = sugarCore.exports,
    isArguments = isArguments_1;

Sugar$3I.Object.defineInstanceAndStatic({

  'isArguments': function(obj) {
    return isArguments(obj);
  }

});

Sugar$3I.Object.isArguments;

var methodDefineAliases = methodDefineAliases$3,
    collectSimilarMethods = collectSimilarMethods_1;

var defineInstanceAndStatic = methodDefineAliases.defineInstanceAndStatic;

function defineInstanceAndStaticSimilar$1(sugarNamespace, set, fn, flags) {
  defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
}

var defineInstanceAndStaticSimilar_1 = defineInstanceAndStaticSimilar$1;

var NATIVE_TYPES = NATIVE_TYPES$2,
    classChecks$o = classChecks$Z,
    namespaceAliases$8 = namespaceAliases$e,
    defineInstanceAndStaticSimilar = defineInstanceAndStaticSimilar_1;

var isBoolean = classChecks$o.isBoolean,
    isNumber$a = classChecks$o.isNumber,
    isString$8 = classChecks$o.isString,
    isDate$6 = classChecks$o.isDate,
    isRegExp$1 = classChecks$o.isRegExp,
    isFunction$5 = classChecks$o.isFunction,
    isArray$2 = classChecks$o.isArray,
    isSet = classChecks$o.isSet,
    isMap = classChecks$o.isMap,
    isError = classChecks$o.isError,
    sugarObject = namespaceAliases$8.sugarObject;

function buildClassCheckMethods$1() {
  var checks = [isBoolean, isNumber$a, isString$8, isDate$6, isRegExp$1, isFunction$5, isArray$2, isError, isSet, isMap];
  defineInstanceAndStaticSimilar(sugarObject, NATIVE_TYPES, function(methods, name, i) {
    methods['is' + name] = checks[i];
  });
}

var buildClassCheckMethods_1 = buildClassCheckMethods$1;

var buildClassCheckMethods = buildClassCheckMethods_1;

buildClassCheckMethods();

var Sugar$3H = sugarCore.exports;



Sugar$3H.Object.isArray;

var Sugar$3G = sugarCore.exports;



Sugar$3G.Object.isBoolean;

var Sugar$3F = sugarCore.exports;



Sugar$3F.Object.isDate;

var getKeys$2 = getKeys_1,
    coercePrimitiveToObject = coercePrimitiveToObject_1;

function getKeysWithObjectCoercion$1(obj) {
  return getKeys$2(coercePrimitiveToObject(obj));
}

var getKeysWithObjectCoercion_1 = getKeysWithObjectCoercion$1;

var getKeysWithObjectCoercion = getKeysWithObjectCoercion_1;

function objectSize$2(obj) {
  return getKeysWithObjectCoercion(obj).length;
}

var objectSize_1 = objectSize$2;

var Sugar$3E = sugarCore.exports,
    objectSize$1 = objectSize_1;

Sugar$3E.Object.defineInstanceAndStatic({

  'isEmpty': function(obj) {
    return objectSize$1(obj) === 0;
  }

});

Sugar$3E.Object.isEmpty;

var Sugar$3D = sugarCore.exports,
    isEqual = isEqual_1;

Sugar$3D.Object.defineInstanceAndStatic({

  'isEqual': function(obj1, obj2) {
    return isEqual(obj1, obj2);
  }

});

Sugar$3D.Object.isEqual;

var Sugar$3C = sugarCore.exports;



Sugar$3C.Object.isError;

var Sugar$3B = sugarCore.exports;



Sugar$3B.Object.isFunction;

var Sugar$3A = sugarCore.exports;



Sugar$3A.Object.isMap;

var Sugar$3z = sugarCore.exports;



Sugar$3z.Object.isNumber;

var Sugar$3y = sugarCore.exports,
    isPlainObject = isPlainObject_1;

Sugar$3y.Object.defineInstanceAndStatic({

  'isObject': function(obj) {
    return isPlainObject(obj);
  }

});

Sugar$3y.Object.isObject;

var Sugar$3x = sugarCore.exports;



Sugar$3x.Object.isRegExp;

var Sugar$3w = sugarCore.exports;



Sugar$3w.Object.isSet;

var Sugar$3v = sugarCore.exports;



Sugar$3v.Object.isString;

var Sugar$3u = sugarCore.exports,
    mergeWithOptions = mergeWithOptions_1;

Sugar$3u.Object.defineInstanceAndStatic({

  'merge': function(target, source, opts) {
    return mergeWithOptions(target, source, opts);
  }

});

Sugar$3u.Object.merge;

var Sugar$3t = sugarCore.exports,
    mergeAll = mergeAll_1;

Sugar$3t.Object.defineInstanceAndStatic({

  'mergeAll': function(target, sources, opts) {
    return mergeAll(target, sources, opts);
  }

});

Sugar$3t.Object.mergeAll;

var classChecks$n = classChecks$Z,
    isObjectType$4 = isObjectType_1;

var isRegExp = classChecks$n.isRegExp;

function matchInObject$1(match, key) {
  if (isRegExp(match)) {
    return match.test(key);
  } else if (isObjectType$4(match)) {
    return key in match;
  } else {
    return key === String(match);
  }
}

var matchInObject_1 = matchInObject$1;

var matchInObject = matchInObject_1,
    coreUtilityAliases$b = coreUtilityAliases$M;

var forEachProperty$6 = coreUtilityAliases$b.forEachProperty;

function selectFromObject$2(obj, f, select) {
  var match, result = {};
  f = [].concat(f);
  forEachProperty$6(obj, function(val, key) {
    match = false;
    for (var i = 0; i < f.length; i++) {
      if (matchInObject(f[i], key)) {
        match = true;
      }
    }
    if (match === select) {
      result[key] = val;
    }
  });
  return result;
}

var selectFromObject_1 = selectFromObject$2;

var selectFromObject$1 = selectFromObject_1;

function objectReject$1(obj, f) {
  return selectFromObject$1(obj, f, false);
}

var objectReject_1 = objectReject$1;

var Sugar$3s = sugarCore.exports,
    objectReject = objectReject_1;

Sugar$3s.Object.defineInstanceAndStatic({

  'reject': function(obj, f) {
    return objectReject(obj, f);
  }

});

Sugar$3s.Object.reject;

var getMatcher = getMatcher_1,
    coreUtilityAliases$a = coreUtilityAliases$M;

var forEachProperty$5 = coreUtilityAliases$a.forEachProperty;

function objectRemove$1(obj, f) {
  var matcher = getMatcher(f);
  forEachProperty$5(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      delete obj[key];
    }
  });
  return obj;
}

var objectRemove_1 = objectRemove$1;

var Sugar$3r = sugarCore.exports,
    objectRemove = objectRemove_1;

Sugar$3r.Object.defineInstanceAndStatic({

  'remove': function(obj, f) {
    return objectRemove(obj, f);
  }

});

Sugar$3r.Object.remove;

var selectFromObject = selectFromObject_1;

function objectSelect$1(obj, f) {
  return selectFromObject(obj, f, true);
}

var objectSelect_1 = objectSelect$1;

var Sugar$3q = sugarCore.exports,
    objectSelect = objectSelect_1;

Sugar$3q.Object.defineInstanceAndStatic({

  'select': function(obj, f) {
    return objectSelect(obj, f);
  }

});

Sugar$3q.Object.select;

var handleDeepProperty = handleDeepProperty_1;

function deepSetProperty$1(obj, key, val) {
  handleDeepProperty(obj, key, false, false, true, false, val);
  return obj;
}

var deepSetProperty_1 = deepSetProperty$1;

var Sugar$3p = sugarCore.exports,
    deepSetProperty = deepSetProperty_1;

Sugar$3p.Object.defineInstanceAndStatic({

  'set': function(obj, key, val) {
    return deepSetProperty(obj, key, val);
  }

});

Sugar$3p.Object.set;

var Sugar$3o = sugarCore.exports,
    objectSize = objectSize_1;

Sugar$3o.Object.defineInstanceAndStatic({

  'size': function(obj) {
    return objectSize(obj);
  }

});

Sugar$3o.Object.size;

var Sugar$3n = sugarCore.exports,
    objectIntersectOrSubtract = objectIntersectOrSubtract_1;

Sugar$3n.Object.defineInstanceAndStatic({

  'subtract': function(obj1, obj2) {
    return objectIntersectOrSubtract(obj1, obj2, true);
  }

});

Sugar$3n.Object.subtract;

var classChecks$m = classChecks$Z;

var isFunction$4 = classChecks$m.isFunction;

function tap$1(obj, arg) {
  var fn = arg;
  if (!isFunction$4(arg)) {
    fn = function() {
      if (arg) obj[arg]();
    };
  }
  fn.call(obj, obj);
  return obj;
}

var tap_1 = tap$1;

var Sugar$3m = sugarCore.exports,
    tap = tap_1;

Sugar$3m.Object.defineInstanceAndStatic({

  'tap': function(obj, arg) {
    return tap(obj, arg);
  }

});

Sugar$3m.Object.tap;

var internalToString$1 = Object.prototype.toString;

function sanitizeURIComponent$2(obj) {
  // undefined, null, and NaN are represented as a blank string,
  // while false and 0 are stringified.
  return !obj && obj !== false && obj !== 0 ? '' : encodeURIComponent(obj);
}

var sanitizeURIComponent_1 = sanitizeURIComponent$2;

var classChecks$l = classChecks$Z,
    sanitizeURIComponent$1 = sanitizeURIComponent_1;

var isDate$5 = classChecks$l.isDate;

function getURIComponentValue$1(obj, prefix, transform) {
  var value;
  if (transform) {
    value = transform(obj, prefix);
  } else if (isDate$5(obj)) {
    value = obj.getTime();
  } else {
    value = obj;
  }
  return sanitizeURIComponent$1(prefix) + '=' + sanitizeURIComponent$1(value);
}

var getURIComponentValue_1 = getURIComponentValue$1;

var classChecks$k = classChecks$Z,
    isObjectType$3 = isObjectType_1,
    internalToString = internalToString$1,
    coreUtilityAliases$9 = coreUtilityAliases$M,
    getURIComponentValue = getURIComponentValue_1,
    sanitizeURIComponent = sanitizeURIComponent_1;

var isArray$1 = classChecks$k.isArray,
    forEachProperty$4 = coreUtilityAliases$9.forEachProperty;

function toQueryString$1(obj, deep, transform, prefix, separator) {
  if (isArray$1(obj)) {
    return collectArrayAsQueryString(obj, deep, transform, prefix, separator);
  } else if (isObjectType$3(obj) && obj.toString === internalToString) {
    return collectObjectAsQueryString(obj, deep, transform, prefix, separator);
  } else if (prefix) {
    return getURIComponentValue(obj, prefix, transform);
  }
  return '';
}

function collectArrayAsQueryString(arr, deep, transform, prefix, separator) {
  var el, qc, key, result = [];
  // Intentionally treating sparse arrays as dense here by avoiding map,
  // otherwise indexes will shift during the process of serialization.
  for (var i = 0, len = arr.length; i < len; i++) {
    el = arr[i];
    key = prefix + (prefix && deep ? '[]' : '');
    if (!key && !isObjectType$3(el)) {
      // If there is no key, then the values of the array should be
      // considered as null keys, so use them instead;
      qc = sanitizeURIComponent(el);
    } else {
      qc = toQueryString$1(el, deep, transform, key, separator);
    }
    result.push(qc);
  }
  return result.join('&');
}

function collectObjectAsQueryString(obj, deep, transform, prefix, separator) {
  var result = [];
  forEachProperty$4(obj, function(val, key) {
    var fullKey;
    if (prefix && deep) {
      fullKey = prefix + '[' + key + ']';
    } else if (prefix) {
      fullKey = prefix + separator + key;
    } else {
      fullKey = key;
    }
    result.push(toQueryString$1(val, deep, transform, fullKey, separator));
  });
  return result.join('&');
}

var toQueryString_1 = toQueryString$1;

var isUndefined$5 = isUndefined_1,
    toQueryString = toQueryString_1;

function toQueryStringWithOptions$1(obj, opts) {
  opts = opts || {};
  if (isUndefined$5(opts.separator)) {
    opts.separator = '_';
  }
  return toQueryString(obj, opts.deep, opts.transform, opts.prefix || '', opts.separator);
}

var toQueryStringWithOptions_1 = toQueryStringWithOptions$1;

var Sugar$3l = sugarCore.exports,
    toQueryStringWithOptions = toQueryStringWithOptions_1;

Sugar$3l.Object.defineInstanceAndStatic({

  'toQueryString': function(obj, options) {
    return toQueryStringWithOptions(obj, options);
  }

});

Sugar$3l.Object.toQueryString;

var coreUtilityAliases$8 = coreUtilityAliases$M;

var forEachProperty$3 = coreUtilityAliases$8.forEachProperty;

function getValues$1(obj) {
  var values = [];
  forEachProperty$3(obj, function(val) {
    values.push(val);
  });
  return values;
}

var getValues_1 = getValues$1;

var Sugar$3k = sugarCore.exports,
    getValues = getValues_1;

Sugar$3k.Object.defineInstanceAndStatic({

  'values': function(obj) {
    return getValues(obj);
  }

});

Sugar$3k.Object.values;

var Sugar$3j = sugarCore.exports,
    getKeys$1 = getKeys_1;

Sugar$3j.Object.defineInstance({

  'keys': function(obj) {
    return getKeys$1(obj);
  }

});

Sugar$3j.Object.keys;

var EnglishLocaleBaseDefinition$1 = {
  'code': 'en',
  'plural': true,
  'timeMarkers': 'at',
  'ampm': 'AM|A.M.|a,PM|P.M.|p',
  'units': 'millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s',
  'months': 'Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|',
  'weekdays': 'Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend',
  'numerals': 'zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th',
  'articles': 'a,an,the',
  'tokens': 'the,st|nd|rd|th,of|in,a|an,on',
  'time': '{H}:{mm}',
  'past': '{num} {unit} {sign}',
  'future': '{num} {unit} {sign}',
  'duration': '{num} {unit}',
  'modifiers': [
    { 'name': 'half',   'src': 'half', 'value': .5 },
    { 'name': 'midday', 'src': 'noon', 'value': 12 },
    { 'name': 'midday', 'src': 'midnight', 'value': 24 },
    { 'name': 'day',    'src': 'yesterday', 'value': -1 },
    { 'name': 'day',    'src': 'today|tonight', 'value': 0 },
    { 'name': 'day',    'src': 'tomorrow', 'value': 1 },
    { 'name': 'sign',   'src': 'ago|before', 'value': -1 },
    { 'name': 'sign',   'src': 'from now|after|from|in|later', 'value': 1 },
    { 'name': 'edge',   'src': 'first day|first|beginning', 'value': -2 },
    { 'name': 'edge',   'src': 'last day', 'value': 1 },
    { 'name': 'edge',   'src': 'end|last', 'value': 2 },
    { 'name': 'shift',  'src': 'last', 'value': -1 },
    { 'name': 'shift',  'src': 'the|this', 'value': 0 },
    { 'name': 'shift',  'src': 'next', 'value': 1 }
  ],
  'parse': [
    '(?:just)? now',
    '{shift} {unit:5-7}',
    '{months?} {year}',
    '{midday} {4?} {day|weekday}',
    '{months},?[-.\\/\\s]?{year?}',
    '{edge} of (?:day)? {day|weekday}',
    '{0} {num}{1?} {weekday} {2} {months},? {year?}',
    '{shift?} {day?} {weekday?} (?:at)? {midday}',
    '{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}',
    '{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}'
  ],
  'timeParse': [
    '{day|weekday}',
    '{shift} {unit:5?} {weekday}',
    '{0?} {date}{1?} {2?} {months?}',
    '{weekday} {2?} {shift} {unit:5}',
    '{0?} {num} {2?} {months}\\.?,? {year?}',
    '{num?} {unit:4-5} {sign} {day|weekday}',
    '{0|months} {date?}{1?} of {shift} {unit:6-7}',
    '{0?} {num}{1?} {weekday} of {shift} {unit:6}',
    '{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}',
    '{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?',
    '{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}',
    '{weekday?}\\.?,? {date} {months} {year}'
  ],
  'timeFrontParse': [
    '{sign} {num} {unit}',
    '{num} {unit} {sign}',
    '{4?} {day|weekday}'
  ]
};

var EnglishLocaleBaseDefinition_1 = EnglishLocaleBaseDefinition$1;

var EnglishLocaleBaseDefinition = EnglishLocaleBaseDefinition_1,
    simpleMerge$2 = simpleMerge_1,
    simpleClone$2 = simpleClone_1;

function getEnglishVariant$3(v) {
  return simpleMerge$2(simpleClone$2(EnglishLocaleBaseDefinition), v);
}

var getEnglishVariant_1 = getEnglishVariant$3;

var getEnglishVariant$2 = getEnglishVariant_1;

var BritishEnglishDefinition$1 = getEnglishVariant$2({
  'short':  '{dd}/{MM}/{yyyy}',
  'medium': '{d} {Month} {yyyy}',
  'long':   '{d} {Month} {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var BritishEnglishDefinition_1 = BritishEnglishDefinition$1;

var getEnglishVariant$1 = getEnglishVariant_1;

var AmericanEnglishDefinition$2 = getEnglishVariant$1({
  'mdy': true,
  'firstDayOfWeek': 0,
  'firstDayOfWeekYear': 1,
  'short':  '{MM}/{dd}/{yyyy}',
  'medium': '{Month} {d}, {yyyy}',
  'long':   '{Month} {d}, {yyyy} {time}',
  'full':   '{Weekday}, {Month} {d}, {yyyy} {time}',
  'stamp':  '{Dow} {Mon} {d} {yyyy} {time}',
  'time':   '{h}:{mm} {TT}'
});

var AmericanEnglishDefinition_1 = AmericanEnglishDefinition$2;

var getEnglishVariant = getEnglishVariant_1;

var CanadianEnglishDefinition$1 = getEnglishVariant({
  'short':  '{yyyy}-{MM}-{dd}',
  'medium': '{d} {Month}, {yyyy}',
  'long':   '{d} {Month}, {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var CanadianEnglishDefinition_1 = CanadianEnglishDefinition$1;

var BritishEnglishDefinition = BritishEnglishDefinition_1,
    AmericanEnglishDefinition$1 = AmericanEnglishDefinition_1,
    CanadianEnglishDefinition = CanadianEnglishDefinition_1;

var LazyLoadedLocales$1 = {
  'en-US': AmericanEnglishDefinition$1,
  'en-GB': BritishEnglishDefinition,
  'en-AU': BritishEnglishDefinition,
  'en-CA': CanadianEnglishDefinition
};

var LazyLoadedLocales_1 = LazyLoadedLocales$1;

var LOCALE_ARRAY_FIELDS$1 = [
  'months', 'weekdays', 'units', 'numerals', 'placeholders',
  'articles', 'tokens', 'timeMarkers', 'ampm', 'timeSuffixes',
  'parse', 'timeParse', 'timeFrontParse', 'modifiers'
];

var LOCALE_ARRAY_FIELDS_1 = LOCALE_ARRAY_FIELDS$1;

var ISODefaults$3 = {
  ISO_FIRST_DAY_OF_WEEK: 1,
  ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};

var CoreParsingTokens$1 = {
  'yyyy': {
    param: 'year',
    src: '[-−+]?\\d{4,6}'
  },
  'yy': {
    param: 'year',
    src: '\\d{2}'
  },
  'y': {
    param: 'year',
    src: '\\d'
  },
  'ayy': {
    param: 'year',
    src: '\'\\d{2}'
  },
  'MM': {
    param: 'month',
    src: '(?:1[012]|0?[1-9])'
  },
  'dd': {
    param: 'date',
    src: '(?:3[01]|[12][0-9]|0?[1-9])'
  },
  'hh': {
    param: 'hour',
    src: '(?:2[0-4]|[01]?[0-9])'
  },
  'mm': {
    param: 'minute',
    src: '[0-5]\\d'
  },
  'ss': {
    param: 'second',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'tzHour': {
    src: '[-−+](?:2[0-4]|[01]?[0-9])'
  },
  'tzMinute': {
    src: '[0-5]\\d'
  },
  'iyyyy': {
    param: 'year',
    src: '(?:[-−+]?\\d{4}|[-−+]\\d{5,6})'
  },
  'ihh': {
    param: 'hour',
    src: '(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?'
  },
  'imm': {
    param: 'minute',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'GMT': {
    param: 'utc',
    src: 'GMT'
  },
  'Z': {
    param: 'utc',
    src: 'Z'
  },
  'timestamp': {
    src: '\\d+'
  }
};

var CoreParsingTokens_1 = CoreParsingTokens$1;

var CoreParsingFormats$1 = [
  {
    // 12-1978
    // 08-1978 (MDY)
    src: '{MM}[-.\\/]{yyyy}'
  },
  {
    // 12/08/1978
    // 08/12/1978 (MDY)
    time: true,
    src: '{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?',
    mdy: '{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?'
  },
  {
    // 12.08.1978
    // 08.12.1978 (MDY)
    time: true,
    src: '{dd}\\.{MM}(?:\\.{yyyy|yy|y})?',
    mdy: '{MM}\\.{dd}(?:\\.{yyyy|yy|y})?',
    localeCheck: function(loc) {
      // Do not allow this format if the locale
      // uses a period as a time separator.
      return loc.timeSeparator !== '.';
    }
  },
  {
    // 1975-08-25
    time: true,
    src: '{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?'
  },
  {
    // .NET JSON
    src: '\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/'
  },
  {
    // ISO-8601
    src: '{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}'
  }
];

var CoreParsingFormats_1 = CoreParsingFormats$1;

var LocalizedParsingTokens$2 = {
  'year': {
    base: 'yyyy|ayy',
    requiresSuffix: true
  },
  'month': {
    base: 'MM',
    requiresSuffix: true
  },
  'date': {
    base: 'dd',
    requiresSuffix: true
  },
  'hour': {
    base: 'hh',
    requiresSuffixOr: ':'
  },
  'minute': {
    base: 'mm'
  },
  'second': {
    base: 'ss'
  },
  'num': {
    src: '\\d+',
    requiresNumerals: true
  }
};

var LocalizedParsingTokens_1 = LocalizedParsingTokens$2;

function getArrayWithOffset$1(arr, n, alternate, offset) {
  var val;
  if (alternate > 1) {
    val = arr[n + (alternate - 1) * offset];
  }
  return val || arr[n];
}

var getArrayWithOffset_1 = getArrayWithOffset$1;

function getRegNonCapturing$2(src, opt) {
  if (src.length > 1) {
    src = '(?:' + src + ')';
  }
  if (opt) {
    src += '?';
  }
  return src;
}

var getRegNonCapturing_1 = getRegNonCapturing$2;

var PRIVATE_PROP_PREFIX$1 = '_sugar_';

var PRIVATE_PROP_PREFIX = PRIVATE_PROP_PREFIX$1,
    coreUtilityAliases$7 = coreUtilityAliases$M;

var setProperty = coreUtilityAliases$7.setProperty;

function privatePropertyAccessor$5(key) {
  var privateKey = PRIVATE_PROP_PREFIX + key;
  return function(obj, val) {
    if (arguments.length > 1) {
      setProperty(obj, privateKey, val);
      return obj;
    }
    return obj[privateKey];
  };
}

var privatePropertyAccessor_1 = privatePropertyAccessor$5;

var privatePropertyAccessor$4 = privatePropertyAccessor_1;

var _utc$8 = privatePropertyAccessor$4('utc');

var _utc$7 = _utc$8;

function callDateGet$a(d, method) {
  return d['get' + (_utc$7(d) ? 'UTC' : '') + method]();
}

var callDateGet_1 = callDateGet$a;

var callDateGet$9 = callDateGet_1;

function getYear$7(d) {
  return callDateGet$9(d, 'FullYear');
}

var getYear_1 = getYear$7;

var callDateGet$8 = callDateGet_1;

function getMonth$7(d) {
  return callDateGet$8(d, 'Month');
}

var getMonth_1 = getMonth$7;

var getYear$6 = getYear_1,
    getMonth$6 = getMonth_1,
    callDateGet$7 = callDateGet_1;

function getDaysInMonth$2(d) {
  return 32 - callDateGet$7(new Date(getYear$6(d), getMonth$6(d), 32), 'Date');
}

var getDaysInMonth_1 = getDaysInMonth$2;

var getDaysInMonth$1 = getDaysInMonth_1;

var DateUnits$7 = [
  {
    name: 'millisecond',
    method: 'Milliseconds',
    multiplier: 1,
    start: 0,
    end: 999
  },
  {
    name: 'second',
    method: 'Seconds',
    multiplier: 1000,
    start: 0,
    end: 59
  },
  {
    name: 'minute',
    method: 'Minutes',
    multiplier: 60 * 1000,
    start: 0,
    end: 59
  },
  {
    name: 'hour',
    method: 'Hours',
    multiplier: 60 * 60 * 1000,
    start: 0,
    end: 23
  },
  {
    name: 'day',
    alias: 'date',
    method: 'Date',
    ambiguous: true,
    multiplier: 24 * 60 * 60 * 1000,
    start: 1,
    end: function(d) {
      return getDaysInMonth$1(d);
    }
  },
  {
    name: 'week',
    method: 'ISOWeek',
    ambiguous: true,
    multiplier: 7 * 24 * 60 * 60 * 1000
  },
  {
    name: 'month',
    method: 'Month',
    ambiguous: true,
    multiplier: 30.4375 * 24 * 60 * 60 * 1000,
    start: 0,
    end: 11
  },
  {
    name: 'year',
    method: 'FullYear',
    ambiguous: true,
    multiplier: 365.25 * 24 * 60 * 60 * 1000,
    start: 0
  }
];

var DateUnits_1 = DateUnits$7;

var DateUnitIndexes$i = {
  HOURS_INDEX: 3,
  DAY_INDEX: 4,
  WEEK_INDEX: 5,
  MONTH_INDEX: 6,
  YEAR_INDEX: 7
};

var DateUnits$6 = DateUnits_1,
    DateUnitIndexes$h = DateUnitIndexes$i,
    isUndefined$4 = isUndefined_1;

var YEAR_INDEX$4 = DateUnitIndexes$h.YEAR_INDEX;

function iterateOverDateUnits$3(fn, startIndex, endIndex) {
  endIndex = endIndex || 0;
  if (isUndefined$4(startIndex)) {
    startIndex = YEAR_INDEX$4;
  }
  for (var index = startIndex; index >= endIndex; index--) {
    if (fn(DateUnits$6[index], index) === false) {
      break;
    }
  }
}

var iterateOverDateUnits_1 = iterateOverDateUnits$3;

var map$1 = map_1,
    escapeRegExp$1 = escapeRegExp_1;

function arrayToRegAlternates$1(arr) {
  var joined = arr.join('');
  if (!arr || !arr.length) {
    return '';
  }
  if (joined.length === arr.length) {
    return '[' + joined + ']';
  }
  // map handles sparse arrays so no need to compact the array here.
  return map$1(arr, escapeRegExp$1).join('|');
}

var arrayToRegAlternates_1 = arrayToRegAlternates$1;

var mathAliases$g = mathAliases$z,
    iterateOverDateUnits$2 = iterateOverDateUnits_1;

var abs$5 = mathAliases$g.abs;

function getAdjustedUnit$2(ms, fn) {
  var unitIndex = 0, value = 0;
  iterateOverDateUnits$2(function(unit, i) {
    value = abs$5(fn(unit));
    if (value >= 1) {
      unitIndex = i;
      return false;
    }
  });
  return [value, unitIndex, ms];
}

var getAdjustedUnit_1 = getAdjustedUnit$2;

var trunc$7 = trunc_1,
    withPrecision$1 = withPrecision_1,
    getAdjustedUnit$1 = getAdjustedUnit_1;

function getAdjustedUnitForNumber$1(ms) {
  return getAdjustedUnit$1(ms, function(unit) {
    return trunc$7(withPrecision$1(ms / unit.multiplier, 1));
  });
}

var getAdjustedUnitForNumber_1 = getAdjustedUnitForNumber$1;

var LocalizedParsingTokens$1 = LocalizedParsingTokens_1,
    getRegNonCapturing$1 = getRegNonCapturing_1;

function getParsingTokenWithSuffix$1(field, src, suffix) {
  var token = LocalizedParsingTokens$1[field];
  if (token.requiresSuffix) {
    src = getRegNonCapturing$1(src + getRegNonCapturing$1(suffix));
  } else if (token.requiresSuffixOr) {
    src += getRegNonCapturing$1(token.requiresSuffixOr + '|' + suffix);
  } else {
    src += getRegNonCapturing$1(suffix, true);
  }
  return src;
}

var getParsingTokenWithSuffix_1 = getParsingTokenWithSuffix$1;

var LOCALE_ARRAY_FIELDS = LOCALE_ARRAY_FIELDS_1,
    ISODefaults$2 = ISODefaults$3,
    CoreParsingTokens = CoreParsingTokens_1,
    CoreParsingFormats = CoreParsingFormats_1,
    LocalizedParsingTokens = LocalizedParsingTokens_1,
    map = map_1,
    filter = filter_1,
    forEach$4 = forEach_1,
    isDefined$7 = isDefined_1,
    commaSplit = commaSplit_1,
    classChecks$j = classChecks$Z,
    mathAliases$f = mathAliases$z,
    isUndefined$3 = isUndefined_1,
    simpleMerge$1 = simpleMerge_1,
    getOrdinalSuffix = getOrdinalSuffix_1,
    getArrayWithOffset = getArrayWithOffset_1,
    getRegNonCapturing = getRegNonCapturing_1,
    coreUtilityAliases$6 = coreUtilityAliases$M,
    iterateOverDateUnits$1 = iterateOverDateUnits_1,
    arrayToRegAlternates = arrayToRegAlternates_1,
    fullwidthNumberHelpers = fullwidthNumberHelpers$2,
    getAdjustedUnitForNumber = getAdjustedUnitForNumber_1,
    getParsingTokenWithSuffix = getParsingTokenWithSuffix_1;

var hasOwn$3 = coreUtilityAliases$6.hasOwn,
    getOwn$4 = coreUtilityAliases$6.getOwn,
    forEachProperty$2 = coreUtilityAliases$6.forEachProperty,
    fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap,
    fullWidthNumbers = fullwidthNumberHelpers.fullWidthNumbers,
    pow = mathAliases$f.pow,
    max$3 = mathAliases$f.max,
    ISO_FIRST_DAY_OF_WEEK$2 = ISODefaults$2.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$2 = ISODefaults$2.ISO_FIRST_DAY_OF_WEEK_YEAR,
    isString$7 = classChecks$j.isString,
    isFunction$3 = classChecks$j.isFunction;

function getNewLocale$1(def) {

  function Locale(def) {
    this.init(def);
  }

  Locale.prototype = {

    getMonthName: function(n, alternate) {
      if (this.monthSuffix) {
        return (n + 1) + this.monthSuffix;
      }
      return getArrayWithOffset(this.months, n, alternate, 12);
    },

    getWeekdayName: function(n, alternate) {
      return getArrayWithOffset(this.weekdays, n, alternate, 7);
    },

    // TODO: rename to parse in next major version
    parseValue: function(str, param) {
      var map = this[param + 'Map'];
      if (hasOwn$3(map, str)) {
        return map[str];
      }
      return this.parseNumber(str, param);
    },

    // TODO: analyze performance of parsing first vs checking
    // numeralMap first.
    parseNumber: function(str, param) {
      var val;

      // Simple numerals such as "one" are mapped directly in
      // the numeral map so catch up front if there is a match.
      if (hasOwn$3(this.numeralMap, str)) {
        val = this.numeralMap[str];
      }

      // TODO: perf test isNaN vs other methods
      if (isNaN(val)) {
        val = this.parseRegularNumerals(str);
      }

      if (isNaN(val)) {
        val = this.parseIrregularNumerals(str);
      }

      if (param === 'month') {
        // Months are the only numeric date field
        // whose value is not the same as its number.
        val -= 1;
      }

      return val;
    },

    // TODO: perf test returning up front if no regular decimals exist
    parseRegularNumerals: function(str) {
      // Allow decimals as commas and the minus-sign as per ISO-8601.
      str = str.replace(/^−/, '-').replace(/,/, '.');

      // The unary plus operator here shows better performance and handles
      // every format that parseFloat does with the exception of trailing
      // characters, which are guaranteed not to be in our string at this point.
      return +str;
    },

    parseIrregularNumerals: function(str) {
      var place = 1, num = 0, lastWasPlace, isPlace, numeral, digit, arr;

      // Note that "numerals" that need to be converted through this method are
      // all considered to be single characters in order to handle CJK. This
      // method is by no means unique to CJK, but the complexity of handling
      // inflections in non-CJK languages adds too much overhead for not enough
      // value, so avoiding for now.
      arr = str.split('');
      for (var i = arr.length - 1; numeral = arr[i]; i--) {
        digit = getOwn$4(this.numeralMap, numeral);
        if (isUndefined$3(digit)) {
          digit = getOwn$4(fullWidthNumberMap, numeral) || 0;
        }
        isPlace = digit > 0 && digit % 10 === 0;
        if (isPlace) {
          if (lastWasPlace) {
            num += place;
          }
          if (i) {
            place = digit;
          } else {
            num += digit;
          }
        } else {
          num += digit * place;
          place *= 10;
        }
        lastWasPlace = isPlace;
      }
      return num;
    },

    getOrdinal: function(n) {
      var suffix = this.ordinalSuffix;
      return suffix || getOrdinalSuffix(n);
    },

    getRelativeFormat: function(adu, type) {
      return this.convertAdjustedToFormat(adu, type);
    },

    getDuration: function(ms) {
      return this.convertAdjustedToFormat(getAdjustedUnitForNumber(max$3(0, ms)), 'duration');
    },

    getFirstDayOfWeek: function() {
      var val = this.firstDayOfWeek;
      return isDefined$7(val) ? val : ISO_FIRST_DAY_OF_WEEK$2;
    },

    getFirstDayOfWeekYear: function() {
      return this.firstDayOfWeekYear || ISO_FIRST_DAY_OF_WEEK_YEAR$2;
    },

    convertAdjustedToFormat: function(adu, type) {
      var sign, unit, mult,
          num    = adu[0],
          u      = adu[1],
          ms     = adu[2],
          format = this[type] || this.relative;
      if (isFunction$3(format)) {
        return format.call(this, num, u, ms, type);
      }
      mult = !this.plural || num === 1 ? 0 : 1;
      unit = this.units[mult * 8 + u] || this.units[u];
      sign = this[ms > 0 ? 'fromNow' : 'ago'];
      return format.replace(/\{(.*?)\}/g, function(full, match) {
        switch(match) {
          case 'num': return num;
          case 'unit': return unit;
          case 'sign': return sign;
        }
      });
    },

    cacheFormat: function(dif, i) {
      this.compiledFormats.splice(i, 1);
      this.compiledFormats.unshift(dif);
    },

    addFormat: function(format) {
      var loc = this, src, to;

      function getTokenSrc(token) {
        var suffix, src, tmp,
            opt   = token.match(/\?$/),
            nc    = token.match(/^(\d+)\??$/),
            slice = token.match(/(\d)(?:-(\d))?/),
            param = token.replace(/[^a-z]+$/i, '');

        // Allowing alias tokens such as {time}
        if (tmp = getOwn$4(loc.parsingAliases, param)) {
          src = formatToSrc(tmp);
          if (opt) {
            src = getRegNonCapturing(src, true);
          }
          return src;
        }

        if (nc) {
          src = loc.tokens[nc[1]];
        } else if (tmp = getOwn$4(CoreParsingTokens, param)) {
          src = tmp.src;
          param = tmp.param || param;
        } else {
          tmp = getOwn$4(loc.parsingTokens, param) || getOwn$4(loc, param);

          // Both the "months" array and the "month" parsing token can be accessed
          // by either {month} or {months}, falling back as necessary, however
          // regardless of whether or not a fallback occurs, the final field to
          // be passed to addRawFormat must be normalized as singular.
          param = param.replace(/s$/, '');

          if (!tmp) {
            tmp = getOwn$4(loc.parsingTokens, param) || getOwn$4(loc, param + 's');
          }

          if (isString$7(tmp)) {
            src = tmp;
            suffix = loc[param + 'Suffix'];
          } else {

            // This is a hack to temporarily disallow parsing of single character
            // weekdays until the format can be changed to allow for this.
            if (param === 'weekday' && loc.code === 'ko') {
              tmp = filter(tmp, function(str) {
                return str.length > 1;
              });
            }

            if (slice) {
              tmp = filter(tmp, function(m, i) {
                var mod = i % (loc.units ? 8 : tmp.length);
                return mod >= slice[1] && mod <= (slice[2] || slice[1]);
              });
            }
            src = arrayToRegAlternates(tmp);
          }
        }
        if (!src) {
          return '';
        }
        if (nc) {
          // Non-capturing tokens like {0}
          src = getRegNonCapturing(src);
        } else {
          // Capturing group and add to parsed tokens
          to.push(param);
          src = '(' + src + ')';
        }
        if (suffix) {
          // Date/time suffixes such as those in CJK
          src = getParsingTokenWithSuffix(param, src, suffix);
        }
        if (opt) {
          src += '?';
        }
        return src;
      }

      function formatToSrc(str) {

        // Make spaces optional
        str = str.replace(/ /g, ' ?');

        str = str.replace(/\{([^,]+?)\}/g, function(match, token) {
          var tokens = token.split('|');
          if (tokens.length > 1) {
            return getRegNonCapturing(map(tokens, getTokenSrc).join('|'));
          } else {
            return getTokenSrc(token);
          }
        });

        return str;
      }

      function parseInputFormat() {
        to = [];
        src = formatToSrc(format);
      }

      parseInputFormat();
      loc.addRawFormat(src, to);
    },

    addRawFormat: function(format, to) {
      this.compiledFormats.unshift({
        reg: RegExp('^ *' + format + ' *$', 'i'),
        to: to
      });
    },

    init: function(def) {
      var loc = this;

      // -- Initialization helpers

      function initFormats() {
        loc.compiledFormats = [];
        loc.parsingAliases = {};
        loc.parsingTokens = {};
      }

      function initDefinition() {
        simpleMerge$1(loc, def);
      }

      function initArrayFields() {
        forEach$4(LOCALE_ARRAY_FIELDS, function(name) {
          var val = loc[name];
          if (isString$7(val)) {
            loc[name] = commaSplit(val);
          } else if (!val) {
            loc[name] = [];
          }
        });
      }

      // -- Value array build helpers

      function buildValueArray(name, mod, map, fn) {
        var field = name, all = [], setMap;
        if (!loc[field]) {
          field += 's';
        }
        if (!map) {
          map = {};
          setMap = true;
        }
        forAllAlternates(field, function(alt, j, i) {
          var idx = j * mod + i, val;
          val = fn ? fn(i) : i;
          map[alt] = val;
          map[alt.toLowerCase()] = val;
          all[idx] = alt;
        });
        loc[field] = all;
        if (setMap) {
          loc[name + 'Map'] = map;
        }
      }

      function forAllAlternates(field, fn) {
        forEach$4(loc[field], function(str, i) {
          forEachAlternate(str, function(alt, j) {
            fn(alt, j, i);
          });
        });
      }

      function forEachAlternate(str, fn) {
        var arr = map(str.split('+'), function(split) {
          return split.replace(/(.+):(.+)$/, function(full, base, suffixes) {
            return map(suffixes.split('|'), function(suffix) {
              return base + suffix;
            }).join('|');
          });
        }).join('|');
        forEach$4(arr.split('|'), fn);
      }

      function buildNumerals() {
        var map = {};
        buildValueArray('numeral', 10, map);
        buildValueArray('article', 1, map, function() {
          return 1;
        });
        buildValueArray('placeholder', 4, map, function(n) {
          return pow(10, n + 1);
        });
        loc.numeralMap = map;
      }

      function buildTimeFormats() {
        loc.parsingAliases['time'] = getTimeFormat();
        loc.parsingAliases['tzOffset'] = getTZOffsetFormat();
      }

      function getTimeFormat(standalone) {
        var src, sep;
        sep = getTimeSeparatorSrc();
        if (loc.ampmFront) {
          // "ampmFront" exists mostly for CJK locales, which also presume that
          // time suffixes exist, allowing this to be a simpler regex.
          src = '{ampm?} {hour} (?:{minute} (?::?{second})?)?';
        } else if(loc.ampm.length) {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})? {ampm?}| {ampm})';
        } else {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})?)';
        }
        return src;
      }

      function getTimeSeparatorSrc() {
        if (loc.timeSeparator) {
          return '[:' + loc.timeSeparator + ']';
        } else {
          return ':';
        }
      }

      function getTZOffsetFormat() {
        return '(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?';
      }

      function buildParsingTokens() {
        forEachProperty$2(LocalizedParsingTokens, function(token, name) {
          var src = token.base ? getCoreTokensForBase(token.base) : token.src, arr;
          if (token.requiresNumerals || loc.numeralUnits) {
            src += getNumeralSrc();
          }
          arr = loc[name + 's'];
          if (arr && arr.length) {
            src += '|' + arrayToRegAlternates(arr);
          }
          loc.parsingTokens[name] = src;
        });
      }

      function getCoreTokensForBase(base) {
        return map(base.split('|'), function(key) {
          return CoreParsingTokens[key].src;
        }).join('|');
      }

      function getNumeralSrc() {
        var all, src = '';
        all = loc.numerals.concat(loc.placeholders).concat(loc.articles);
        if (loc.allowsFullWidth) {
          all = all.concat(fullWidthNumbers.split(''));
        }
        if (all.length) {
          src = '|(?:' + arrayToRegAlternates(all) + ')+';
        }
        return src;
      }

      function buildTimeSuffixes() {
        iterateOverDateUnits$1(function(unit, i) {
          var token = loc.timeSuffixes[i];
          if (token) {
            loc[(unit.alias || unit.name) + 'Suffix'] = token;
          }
        });
      }

      function buildModifiers() {
        forEach$4(loc.modifiers, function(modifier) {
          var name = modifier.name, mapKey = name + 'Map', map;
          map = loc[mapKey] || {};
          forEachAlternate(modifier.src, function(alt, j) {
            var token = getOwn$4(loc.parsingTokens, name), val = modifier.value;
            map[alt] = val;
            loc.parsingTokens[name] = token ? token + '|' + alt : alt;
            if (modifier.name === 'sign' && j === 0) {
              // Hooking in here to set the first "fromNow" or "ago" modifier
              // directly on the locale, so that it can be reused in the
              // relative format.
              loc[val === 1 ? 'fromNow' : 'ago'] = alt;
            }
          });
          loc[mapKey] = map;
        });
      }

      // -- Format adding helpers

      function addCoreFormats() {
        forEach$4(CoreParsingFormats, function(df) {
          var src = df.src;
          if (df.localeCheck && !df.localeCheck(loc)) {
            return;
          }
          if (df.mdy && loc.mdy) {
            // Use the mm/dd/yyyy variant if it
            // exists and the locale requires it
            src = df.mdy;
          }
          if (df.time) {
            // Core formats that allow time require the time
            // reg on both sides, so add both versions here.
            loc.addFormat(getFormatWithTime(src, true));
            loc.addFormat(getFormatWithTime(src));
          } else {
            loc.addFormat(src);
          }
        });
        loc.addFormat('{time}');
      }

      function addLocaleFormats() {
        addFormatSet('parse');
        addFormatSet('timeParse', true);
        addFormatSet('timeFrontParse', true, true);
      }

      function addFormatSet(field, allowTime, timeFront) {
        forEach$4(loc[field], function(format) {
          if (allowTime) {
            format = getFormatWithTime(format, timeFront);
          }
          loc.addFormat(format);
        });
      }

      function getFormatWithTime(baseFormat, timeBefore) {
        if (timeBefore) {
          return getTimeBefore() + baseFormat;
        }
        return baseFormat + getTimeAfter();
      }

      function getTimeBefore() {
        return getRegNonCapturing('{time}[,\\s\\u3000]', true);
      }

      function getTimeAfter() {
        var markers = ',?[\\s\\u3000]', localized;
        localized = arrayToRegAlternates(loc.timeMarkers);
        if (localized) {
          markers += '| (?:' + localized + ') ';
        }
        markers = getRegNonCapturing(markers, loc.timeMarkerOptional);
        return getRegNonCapturing(markers + '{time}{tzOffset}', true);
      }

      initFormats();
      initDefinition();
      initArrayFields();

      buildValueArray('month', 12);
      buildValueArray('weekday', 7);
      buildValueArray('unit', 8);
      buildValueArray('ampm', 2);

      buildNumerals();
      buildTimeFormats();
      buildParsingTokens();
      buildTimeSuffixes();
      buildModifiers();

      // The order of these formats is important. Order is reversed so formats
      // that are initialized later will take precedence. Generally, this means
      // that more specific formats should come later.
      addCoreFormats();
      addLocaleFormats();

    }

  };

  return new Locale(def);
}

var getNewLocale_1 = getNewLocale$1;

var LazyLoadedLocales = LazyLoadedLocales_1,
    AmericanEnglishDefinition = AmericanEnglishDefinition_1,
    getNewLocale = getNewLocale_1;

var English$3, localeManager$f;

function buildLocales() {

  function LocaleManager(loc) {
    this.locales = {};
    this.add(loc);
  }

  LocaleManager.prototype = {

    get: function(code, fallback) {
      var loc = this.locales[code];
      if (!loc && LazyLoadedLocales[code]) {
        loc = this.add(code, LazyLoadedLocales[code]);
      } else if (!loc && code) {
        loc = this.locales[code.slice(0, 2)];
      }
      return loc || fallback === false ? loc : this.current;
    },

    getAll: function() {
      return this.locales;
    },

    set: function(code) {
      var loc = this.get(code, false);
      if (!loc) {
        throw new TypeError('Invalid Locale: ' + code);
      }
      return this.current = loc;
    },

    add: function(code, def) {
      if (!def) {
        def = code;
        code = def.code;
      } else {
        def.code = code;
      }
      var loc = def.compiledFormats ? def : getNewLocale(def);
      this.locales[code] = loc;
      if (!this.current) {
        this.current = loc;
      }
      return loc;
    },

    remove: function(code) {
      if (this.current.code === code) {
        this.current = this.get('en');
      }
      return delete this.locales[code];
    }

  };

  // Sorry about this guys...
  English$3 = getNewLocale(AmericanEnglishDefinition);
  localeManager$f = new LocaleManager(English$3);
}

buildLocales();

var LocaleHelpers$h = {
  English: English$3,
  localeManager: localeManager$f
};

var Sugar$3i = sugarCore.exports,
    LocaleHelpers$g = LocaleHelpers$h;

var localeManager$e = LocaleHelpers$g.localeManager;

Sugar$3i.Date.defineStatic({

  'addLocale': function(code, set) {
    return localeManager$e.add(code, set);
  }

});

Sugar$3i.Date.addLocale;

var MINUTES$2 = 60 * 1000;

var ABBREVIATED_YEAR_REG$1 = /^'?(\d{1,2})$/;

function tzOffset$4(d) {
  return d.getTimezoneOffset();
}

var tzOffset_1 = tzOffset$4;

var _utc$6 = _utc$8,
    callDateGet$6 = callDateGet_1;

function callDateSet$6(d, method, value, safe) {
  // "Safe" denotes not setting the date if the value is the same as what is
  // currently set. In theory this should be a noop, however it will cause
  // timezone shifts when in the middle of a DST fallback. This is unavoidable
  // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
  // November 1st, 2015 in northern hemisphere timezones that follow DST),
  // however when advancing or rewinding dates this can throw off calculations
  // so avoiding this unintentional shifting on an opt-in basis.
  if (safe && value === callDateGet$6(d, method)) {
    return;
  }
  d['set' + (_utc$6(d) ? 'UTC' : '') + method](value);
}

var callDateSet_1 = callDateSet$6;

var DateUnitIndexes$g = DateUnitIndexes$i;

var HOURS_INDEX$2 = DateUnitIndexes$g.HOURS_INDEX,
    DAY_INDEX$9 = DateUnitIndexes$g.DAY_INDEX,
    WEEK_INDEX$4 = DateUnitIndexes$g.WEEK_INDEX,
    MONTH_INDEX$6 = DateUnitIndexes$g.MONTH_INDEX;

function getLowerUnitIndex$5(index) {
  if (index === MONTH_INDEX$6) {
    return DAY_INDEX$9;
  } else if (index === WEEK_INDEX$4) {
    return HOURS_INDEX$2;
  }
  return index - 1;
}

var getLowerUnitIndex_1 = getLowerUnitIndex$5;

var DateUnits$5 = DateUnits_1,
    getLowerUnitIndex$4 = getLowerUnitIndex_1;

function walkUnitDown$2(unitIndex, fn) {
  while (unitIndex >= 0) {
    if (fn(DateUnits$5[unitIndex], unitIndex) === false) {
      break;
    }
    unitIndex = getLowerUnitIndex$4(unitIndex);
  }
}

var walkUnitDown_1 = walkUnitDown$2;

var isDefined$6 = isDefined_1,
    classChecks$i = classChecks$Z,
    callDateSet$5 = callDateSet_1,
    walkUnitDown$1 = walkUnitDown_1;

var isFunction$2 = classChecks$i.isFunction;

function setUnitAndLowerToEdge$6(d, startIndex, stopIndex, end) {
  walkUnitDown$1(startIndex, function(unit, i) {
    var val = end ? unit.end : unit.start;
    if (isFunction$2(val)) {
      val = val(d);
    }
    callDateSet$5(d, unit.method, val);
    return !isDefined$6(stopIndex) || i > stopIndex;
  });
  return d;
}

var setUnitAndLowerToEdge_1 = setUnitAndLowerToEdge$6;

var DateUnitIndexes$f = DateUnitIndexes$i,
    setUnitAndLowerToEdge$5 = setUnitAndLowerToEdge_1;

var HOURS_INDEX$1 = DateUnitIndexes$f.HOURS_INDEX;

function resetTime$2(d) {
  return setUnitAndLowerToEdge$5(d, HOURS_INDEX$1);
}

var resetTime_1 = resetTime$2;

function defaultNewDate$1() {
  return new Date;
}

var defaultNewDate_1 = defaultNewDate$1;

var defaultNewDate = defaultNewDate_1;

var DATE_OPTIONS$1 = {
  'newDateInternal': defaultNewDate
};

var DATE_OPTIONS_1 = DATE_OPTIONS$1;

var DATE_OPTIONS = DATE_OPTIONS_1,
    namespaceAliases$7 = namespaceAliases$e,
    defineOptionsAccessor = defineOptionsAccessor_1;

var sugarDate$6 = namespaceAliases$7.sugarDate;

var _dateOptions$1 = defineOptionsAccessor(sugarDate$6, DATE_OPTIONS);

var _dateOptions = _dateOptions$1;

function getNewDate$5() {
  return _dateOptions('newDateInternal')();
}

var getNewDate_1 = getNewDate$5;

var callDateSet$4 = callDateSet_1;

function setDate$6(d, val) {
  callDateSet$4(d, 'Date', val);
}

var setDate_1 = setDate$6;

var callDateGet$5 = callDateGet_1;

function getDate$6(d) {
  return callDateGet$5(d, 'Date');
}

var getDate_1 = getDate$6;

var callDateGet$4 = callDateGet_1;

function getWeekday$9(d) {
  return callDateGet$4(d, 'Day');
}

var getWeekday_1 = getWeekday$9;

var setDate$5 = setDate_1,
    getDate$5 = getDate_1,
    getWeekday$8 = getWeekday_1,
    classChecks$h = classChecks$Z,
    mathAliases$e = mathAliases$z;

var isNumber$9 = classChecks$h.isNumber,
    abs$4 = mathAliases$e.abs;

function setWeekday$8(d, dow, dir) {
  if (!isNumber$9(dow)) return;
  var currentWeekday = getWeekday$8(d);
  if (dir) {
    // Allow a "direction" parameter to determine whether a weekday can
    // be set beyond the current weekday in either direction.
    var ndir = dir > 0 ? 1 : -1;
    var offset = dow % 7 - currentWeekday;
    if (offset && offset / abs$4(offset) !== ndir) {
      dow += 7 * ndir;
    }
  }
  setDate$5(d, getDate$5(d) + dow - currentWeekday);
  return d.getTime();
}

var setWeekday_1 = setWeekday$8;

var getLowerUnitIndex$3 = getLowerUnitIndex_1,
    setUnitAndLowerToEdge$4 = setUnitAndLowerToEdge_1;

function resetLowerUnits$1(d, unitIndex) {
  return setUnitAndLowerToEdge$4(d, getLowerUnitIndex$3(unitIndex));
}

var resetLowerUnits_1 = resetLowerUnits$1;

var DateUnitIndexes$e = DateUnitIndexes$i;

var DAY_INDEX$8 = DateUnitIndexes$e.DAY_INDEX,
    MONTH_INDEX$5 = DateUnitIndexes$e.MONTH_INDEX;

function getHigherUnitIndex$1(index) {
  return index === DAY_INDEX$8 ? MONTH_INDEX$5 : index + 1;
}

var getHigherUnitIndex_1 = getHigherUnitIndex$1;

var callDateSet$3 = callDateSet_1;

function setYear$1(d, val) {
  callDateSet$3(d, 'FullYear', val);
}

var setYear_1 = setYear$1;

var callDateSet$2 = callDateSet_1;

function setMonth$1(d, val) {
  callDateSet$2(d, 'Month', val);
}

var setMonth_1 = setMonth$1;

var _utc$5 = _utc$8;

function cloneDate$6(d) {
  // Rhino environments have a bug where new Date(d) truncates
  // milliseconds so need to call getTime() here.
  var clone = new Date(d.getTime());
  _utc$5(clone, !!_utc$5(d));
  return clone;
}

var cloneDate_1 = cloneDate$6;

var setWeekday$7 = setWeekday_1,
    getWeekday$7 = getWeekday_1,
    mathAliases$d = mathAliases$z;

var floor = mathAliases$d.floor;

function moveToBeginningOfWeek$3(d, firstDayOfWeek) {
  setWeekday$7(d, floor((getWeekday$7(d) - firstDayOfWeek) / 7) * 7 + firstDayOfWeek);
  return d;
}

var moveToBeginningOfWeek_1 = moveToBeginningOfWeek$3;

var DateUnitIndexes$d = DateUnitIndexes$i,
    setDate$4 = setDate_1,
    setUnitAndLowerToEdge$3 = setUnitAndLowerToEdge_1,
    moveToBeginningOfWeek$2 = moveToBeginningOfWeek_1;

var MONTH_INDEX$4 = DateUnitIndexes$d.MONTH_INDEX;

function moveToFirstDayOfWeekYear$2(d, firstDayOfWeek, firstDayOfWeekYear) {
  setUnitAndLowerToEdge$3(d, MONTH_INDEX$4);
  setDate$4(d, firstDayOfWeekYear);
  moveToBeginningOfWeek$2(d, firstDayOfWeek);
}

var moveToFirstDayOfWeekYear_1 = moveToFirstDayOfWeekYear$2;

var ISODefaults$1 = ISODefaults$3,
    getDate$4 = getDate_1,
    setDate$3 = setDate_1,
    setYear = setYear_1,
    getYear$5 = getYear_1,
    getMonth$5 = getMonth_1,
    setMonth = setMonth_1,
    cloneDate$5 = cloneDate_1,
    getWeekday$6 = getWeekday_1,
    setWeekday$6 = setWeekday_1,
    classChecks$g = classChecks$Z,
    moveToFirstDayOfWeekYear$1 = moveToFirstDayOfWeekYear_1;

var isNumber$8 = classChecks$g.isNumber,
    ISO_FIRST_DAY_OF_WEEK$1 = ISODefaults$1.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$1 = ISODefaults$1.ISO_FIRST_DAY_OF_WEEK_YEAR;

function setISOWeekNumber$2(d, num) {
  if (isNumber$8(num)) {
    // Intentionally avoiding updateDate here to prevent circular dependencies.
    var isoWeek = cloneDate$5(d), dow = getWeekday$6(d);
    moveToFirstDayOfWeekYear$1(isoWeek, ISO_FIRST_DAY_OF_WEEK$1, ISO_FIRST_DAY_OF_WEEK_YEAR$1);
    setDate$3(isoWeek, getDate$4(isoWeek) + 7 * (num - 1));
    setYear(d, getYear$5(isoWeek));
    setMonth(d, getMonth$5(isoWeek));
    setDate$3(d, getDate$4(isoWeek));
    setWeekday$6(d, dow || 7);
  }
  return d.getTime();
}

var setISOWeekNumber_1 = setISOWeekNumber$2;

var callDateSet$1 = callDateSet_1,
    setISOWeekNumber$1 = setISOWeekNumber_1;

function callDateSetWithWeek$1(d, method, value, safe) {
  if (method === 'ISOWeek') {
    setISOWeekNumber$1(d, value);
  } else {
    callDateSet$1(d, method, value, safe);
  }
}

var callDateSetWithWeek_1 = callDateSetWithWeek$1;

var coreUtilityAliases$5 = coreUtilityAliases$M;

var hasOwn$2 = coreUtilityAliases$5.hasOwn;

function getOwnKey$1(obj, key) {
  if (hasOwn$2(obj, key)) {
    return key;
  }
}

var getOwnKey_1 = getOwnKey$1;

var getOwnKey = getOwnKey_1;

function getDateParamKey$2(params, key) {
  return getOwnKey(params, key) ||
         getOwnKey(params, key + 's') ||
         (key === 'day' && getOwnKey(params, 'date'));
}

var getDateParamKey_1 = getDateParamKey$2;

var getDateParamKey$1 = getDateParamKey_1,
    coreUtilityAliases$4 = coreUtilityAliases$M;

var getOwn$3 = coreUtilityAliases$4.getOwn;

function getDateParam$1(params, key) {
  return getOwn$3(params, getDateParamKey$1(params, key));
}

var getDateParam_1 = getDateParam$1;

var DateUnitIndexes$c = DateUnitIndexes$i,
    isDefined$5 = isDefined_1,
    getDateParam = getDateParam_1,
    iterateOverDateUnits = iterateOverDateUnits_1;

var DAY_INDEX$7 = DateUnitIndexes$c.DAY_INDEX;

function iterateOverDateParams$4(params, fn, startIndex, endIndex) {

  function run(name, unit, i) {
    var val = getDateParam(params, name);
    if (isDefined$5(val)) {
      fn(name, val, unit, i);
    }
  }

  iterateOverDateUnits(function (unit, i) {
    var result = run(unit.name, unit, i);
    if (result !== false && i === DAY_INDEX$7) {
      // Check for "weekday", which has a distinct meaning
      // in the context of setting a date, but has the same
      // meaning as "day" as a unit of time.
      result = run('weekday', unit, i);
    }
    return result;
  }, startIndex, endIndex);

}

var iterateOverDateParams_1 = iterateOverDateParams$4;

var DateUnits$4 = DateUnits_1,
    DateUnitIndexes$b = DateUnitIndexes$i,
    trunc$6 = trunc_1,
    setDate$2 = setDate_1,
    getDate$3 = getDate_1,
    getMonth$4 = getMonth_1,
    getNewDate$4 = getNewDate_1,
    setWeekday$5 = setWeekday_1,
    mathAliases$c = mathAliases$z,
    callDateGet$3 = callDateGet_1,
    classChecks$f = classChecks$Z,
    resetLowerUnits = resetLowerUnits_1,
    getLowerUnitIndex$2 = getLowerUnitIndex_1,
    getHigherUnitIndex = getHigherUnitIndex_1,
    callDateSetWithWeek = callDateSetWithWeek_1,
    iterateOverDateParams$3 = iterateOverDateParams_1;

var DAY_INDEX$6 = DateUnitIndexes$b.DAY_INDEX,
    WEEK_INDEX$3 = DateUnitIndexes$b.WEEK_INDEX,
    MONTH_INDEX$3 = DateUnitIndexes$b.MONTH_INDEX,
    YEAR_INDEX$3 = DateUnitIndexes$b.YEAR_INDEX,
    round$2 = mathAliases$c.round,
    isNumber$7 = classChecks$f.isNumber;

function updateDate$4(d, params, reset, advance, prefer, weekdayDir, contextDate) {
  var upperUnitIndex;

  function setUpperUnit(unitName, unitIndex) {
    if (prefer && !upperUnitIndex) {
      if (unitName === 'weekday') {
        upperUnitIndex = WEEK_INDEX$3;
      } else {
        upperUnitIndex = getHigherUnitIndex(unitIndex);
      }
    }
  }

  function setSpecificity(unitIndex) {
    // Other functions may preemptively set the specificity before arriving
    // here so concede to them if they have already set more specific units.
    if (unitIndex > params.specificity) {
      return;
    }
    params.specificity = unitIndex;
  }

  function canDisambiguate() {
    if (!upperUnitIndex || upperUnitIndex > YEAR_INDEX$3) {
      return;
    }

    switch(prefer) {
      case -1: return d >= (contextDate || getNewDate$4());
      case  1: return d <= (contextDate || getNewDate$4());
    }
  }

  function disambiguateHigherUnit() {
    var unit = DateUnits$4[upperUnitIndex];
    advance = prefer;
    setUnit(unit.name, 1, unit, upperUnitIndex);
  }

  function handleFraction(unit, unitIndex, fraction) {
    if (unitIndex) {
      var lowerUnit = DateUnits$4[getLowerUnitIndex$2(unitIndex)];
      var val = round$2(unit.multiplier / lowerUnit.multiplier * fraction);
      params[lowerUnit.name] = val;
    }
  }

  function monthHasShifted(d, targetMonth) {
    if (targetMonth < 0) {
      targetMonth = targetMonth % 12 + 12;
    }
    return targetMonth % 12 !== getMonth$4(d);
  }

  function setUnit(unitName, value, unit, unitIndex) {
    var method = unit.method, checkMonth, fraction;

    setUpperUnit(unitName, unitIndex);
    setSpecificity(unitIndex);

    fraction = value % 1;
    if (fraction) {
      handleFraction(unit, unitIndex, fraction);
      value = trunc$6(value);
    }

    if (unitName === 'weekday') {
      if (!advance) {
        // Weekdays are always considered absolute units so simply set them
        // here even if it is an "advance" operation. This is to help avoid
        // ambiguous meanings in "advance" as well as to neatly allow formats
        // like "Wednesday of next week" without more complex logic.
        setWeekday$5(d, value, weekdayDir);
      }
      return;
    }
    checkMonth = unitIndex === MONTH_INDEX$3 && getDate$3(d) > 28;

    // If we are advancing or rewinding, then we need we need to set the
    // absolute time if the unit is "hours" or less. This is due to the fact
    // that setting by method is ambiguous during DST shifts. For example,
    // 1:00am on November 1st 2015 occurs twice in North American timezones
    // with DST, the second time being after the clocks are rolled back at
    // 2:00am. When springing forward this is automatically handled as there
    // is no 2:00am so the date automatically jumps to 3:00am. However, when
    // rolling back, setHours(2) will always choose the first "2am" even if
    // the date is currently set to the second, causing unintended jumps.
    // This ambiguity is unavoidable when setting dates as the notation is
    // ambiguous. However when advancing, we clearly want the resulting date
    // to be an acutal hour ahead, which can only be accomplished by setting
    // the absolute time. Conversely, any unit higher than "hours" MUST use
    // the internal set methods, as they are ambiguous as absolute units of
    // time. Years may be 365 or 366 days depending on leap years, months are
    // all over the place, and even days may be 23-25 hours depending on DST
    // shifts. Finally, note that the kind of jumping described above will
    // occur when calling ANY "set" method on the date and will occur even if
    // the value being set is identical to the one currently set (i.e.
    // setHours(2) on a date at 2am may not be a noop). This is precarious,
    // so avoiding this situation in callDateSet by checking up front that
    // the value is not the same before setting.
    if (advance && !unit.ambiguous) {
      d.setTime(d.getTime() + (value * advance * unit.multiplier));
      return;
    } else if (advance) {
      if (unitIndex === WEEK_INDEX$3) {
        value *= 7;
        method = DateUnits$4[DAY_INDEX$6].method;
      }
      value = (value * advance) + callDateGet$3(d, method);
    }
    callDateSetWithWeek(d, method, value, advance);
    if (checkMonth && monthHasShifted(d, value)) {
      // As we are setting the units in reverse order, there is a chance that
      // our date may accidentally traverse into a new month, such as setting
      // { month: 1, date 15 } on January 31st. Check for this here and reset
      // the date to the last day of the previous month if this has happened.
      setDate$2(d, 0);
    }
  }

  if (isNumber$7(params) && advance) {
    // If param is a number and advancing, the number is in milliseconds.
    params = { millisecond: params };
  } else if (isNumber$7(params)) {
    // Otherwise just set the timestamp and return.
    d.setTime(params);
    return d;
  }

  iterateOverDateParams$3(params, setUnit);

  if (reset && params.specificity) {
    resetLowerUnits(d, params.specificity);
  }

  // If past or future is preferred, then the process of "disambiguation" will
  // ensure that an ambiguous time/date ("4pm", "thursday", "June", etc.) will
  // be in the past or future. Weeks are only considered ambiguous if there is
  // a weekday, i.e. "thursday" is an ambiguous week, but "the 4th" is an
  // ambiguous month.
  if (canDisambiguate()) {
    disambiguateHigherUnit();
  }
  return d;
}

var updateDate_1 = updateDate$4;

var updateDate$3 = updateDate_1;

function advanceDate$5(d, unit, num, reset) {
  var set = {};
  set[unit] = num;
  return updateDate$3(d, set, reset, 1);
}

var advanceDate_1 = advanceDate$5;

function dateIsValid$5(d) {
  return !isNaN(d.getTime());
}

var dateIsValid_1 = dateIsValid$5;

var setWeekday$4 = setWeekday_1,
    getWeekday$5 = getWeekday_1,
    mathAliases$b = mathAliases$z;

var ceil$2 = mathAliases$b.ceil;

function moveToEndOfWeek$2(d, firstDayOfWeek) {
  var target = firstDayOfWeek - 1;
  setWeekday$4(d, ceil$2((getWeekday$5(d) - target) / 7) * 7 + target);
  return d;
}

var moveToEndOfWeek_1 = moveToEndOfWeek$2;

var LocaleHelpers$f = LocaleHelpers$h,
    DateUnitIndexes$a = DateUnitIndexes$i,
    moveToEndOfWeek$1 = moveToEndOfWeek_1,
    getLowerUnitIndex$1 = getLowerUnitIndex_1,
    setUnitAndLowerToEdge$2 = setUnitAndLowerToEdge_1;

var WEEK_INDEX$2 = DateUnitIndexes$a.WEEK_INDEX,
    localeManager$d = LocaleHelpers$f.localeManager;

function moveToEndOfUnit$4(d, unitIndex, localeCode, stopIndex) {
  if (unitIndex === WEEK_INDEX$2) {
    moveToEndOfWeek$1(d, localeManager$d.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$2(d, getLowerUnitIndex$1(unitIndex), stopIndex, true);
}

var moveToEndOfUnit_1 = moveToEndOfUnit$4;

var getDateParamKey = getDateParamKey_1;

function deleteDateParam$1(params, key) {
  delete params[getDateParamKey(params, key)];
}

var deleteDateParam_1 = deleteDateParam$1;

var LocaleHelpers$e = LocaleHelpers$h,
    DateUnitIndexes$9 = DateUnitIndexes$i,
    getLowerUnitIndex = getLowerUnitIndex_1,
    moveToBeginningOfWeek$1 = moveToBeginningOfWeek_1,
    setUnitAndLowerToEdge$1 = setUnitAndLowerToEdge_1;

var WEEK_INDEX$1 = DateUnitIndexes$9.WEEK_INDEX,
    localeManager$c = LocaleHelpers$e.localeManager;

function moveToBeginningOfUnit$4(d, unitIndex, localeCode) {
  if (unitIndex === WEEK_INDEX$1) {
    moveToBeginningOfWeek$1(d, localeManager$c.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$1(d, getLowerUnitIndex(unitIndex));
}

var moveToBeginningOfUnit_1 = moveToBeginningOfUnit$4;

var getYear$4 = getYear_1,
    mathAliases$a = mathAliases$z;

var abs$3 = mathAliases$a.abs;

function getYearFromAbbreviation$1(str, d, prefer) {
  // Following IETF here, adding 1900 or 2000 depending on the last two digits.
  // Note that this makes no accordance for what should happen after 2050, but
  // intentionally ignoring this for now. https://www.ietf.org/rfc/rfc2822.txt
  var val = +str, delta;
  val += val < 50 ? 2000 : 1900;
  if (prefer) {
    delta = val - getYear$4(d);
    if (delta / abs$3(delta) !== prefer) {
      val += prefer * 100;
    }
  }
  return val;
}

var getYearFromAbbreviation_1 = getYearFromAbbreviation$1;

var DateUnitIndexes$8 = DateUnitIndexes$i,
    iterateOverDateParams$2 = iterateOverDateParams_1;

var DAY_INDEX$5 = DateUnitIndexes$8.DAY_INDEX,
    YEAR_INDEX$2 = DateUnitIndexes$8.YEAR_INDEX;

function iterateOverHigherDateParams$1(params, fn) {
  iterateOverDateParams$2(params, fn, YEAR_INDEX$2, DAY_INDEX$5);
}

var iterateOverHigherDateParams_1 = iterateOverHigherDateParams$1;

var MINUTES$1 = MINUTES$2,
    ABBREVIATED_YEAR_REG = ABBREVIATED_YEAR_REG$1,
    LocaleHelpers$d = LocaleHelpers$h,
    DateUnitIndexes$7 = DateUnitIndexes$i,
    _utc$4 = _utc$8,
    trunc$5 = trunc_1,
    forEach$3 = forEach_1,
    tzOffset$3 = tzOffset_1,
    isDefined$4 = isDefined_1,
    resetTime$1 = resetTime_1,
    getNewDate$3 = getNewDate_1,
    updateDate$2 = updateDate_1,
    setWeekday$3 = setWeekday_1,
    simpleMerge = simpleMerge_1,
    advanceDate$4 = advanceDate_1,
    isUndefined$2 = isUndefined_1,
    classChecks$e = classChecks$Z,
    dateIsValid$4 = dateIsValid_1,
    simpleClone$1 = simpleClone_1,
    isObjectType$2 = isObjectType_1,
    moveToEndOfUnit$3 = moveToEndOfUnit_1,
    deleteDateParam = deleteDateParam_1,
    coreUtilityAliases$3 = coreUtilityAliases$M,
    moveToBeginningOfUnit$3 = moveToBeginningOfUnit_1,
    iterateOverDateParams$1 = iterateOverDateParams_1,
    getYearFromAbbreviation = getYearFromAbbreviation_1,
    iterateOverHigherDateParams = iterateOverHigherDateParams_1;

var isNumber$6 = classChecks$e.isNumber,
    isString$6 = classChecks$e.isString,
    isDate$4 = classChecks$e.isDate,
    getOwn$2 = coreUtilityAliases$3.getOwn,
    English$2 = LocaleHelpers$d.English,
    localeManager$b = LocaleHelpers$d.localeManager,
    DAY_INDEX$4 = DateUnitIndexes$7.DAY_INDEX,
    WEEK_INDEX = DateUnitIndexes$7.WEEK_INDEX,
    MONTH_INDEX$2 = DateUnitIndexes$7.MONTH_INDEX,
    YEAR_INDEX$1 = DateUnitIndexes$7.YEAR_INDEX;

function getExtendedDate$3(contextDate, d, opt, forceClone) {

  // Locals
  var date, set, loc, afterCallbacks, relative, weekdayDir;

  // Options
  var optPrefer, optLocale, optFromUTC, optSetUTC, optParams, optClone;

  afterCallbacks = [];

  setupOptions(opt);

  function setupOptions(opt) {
    opt = isString$6(opt) ? { locale: opt } : opt || {};
    optPrefer  = +!!getOwn$2(opt, 'future') - +!!getOwn$2(opt, 'past');
    optLocale  = getOwn$2(opt, 'locale');
    optFromUTC = getOwn$2(opt, 'fromUTC');
    optSetUTC  = getOwn$2(opt, 'setUTC');
    optParams  = getOwn$2(opt, 'params');
    optClone   = getOwn$2(opt, 'clone');
  }

  function parseFormatValues(match, dif) {
    var set = optParams || {};
    forEach$3(dif.to, function(param, i) {
      var str = match[i + 1], val;
      if (!str) return;

      val = parseIrregular(str, param);

      if (isUndefined$2(val)) {
        val = loc.parseValue(str, param);
      }

      set[param] = val;
    });
    return set;
  }

  function parseIrregular(str, param) {
    if (param === 'utc') {
      return 1;
    } else if (param === 'year') {
      var match = str.match(ABBREVIATED_YEAR_REG);
      if (match) {
        return getYearFromAbbreviation(match[1], date, optPrefer);
      }
    }
  }

  // Force the UTC flags to be true if the source date
  // date is UTC, as they will be overwritten later.
  function cloneDateByFlag(d, clone) {
    if (_utc$4(d) && !isDefined$4(optFromUTC)) {
      optFromUTC = true;
    }
    if (_utc$4(d) && !isDefined$4(optSetUTC)) {
      optSetUTC = true;
    }
    if (clone) {
      d = new Date(d.getTime());
    }
    return d;
  }

  function afterDateSet(fn) {
    afterCallbacks.push(fn);
  }

  function fireCallbacks() {
    forEach$3(afterCallbacks, function(fn) {
      fn.call();
    });
  }

  function parseStringDate(str) {

    str = str.toLowerCase();

    // The act of getting the locale will initialize
    // if it is missing and add the required formats.
    loc = localeManager$b.get(optLocale);

    for (var i = 0, dif, match; dif = loc.compiledFormats[i]; i++) {
      match = str.match(dif.reg);
      if (match) {

        // Note that caching the format will modify the compiledFormats array
        // which is not a good idea to do inside its for loop, however we
        // know at this point that we have a matched format and that we will
        // break out below, so simpler to do it here.
        loc.cacheFormat(dif, i);

        set = parseFormatValues(match, dif);

        if (isDefined$4(set.timestamp)) {
          date.setTime(set.timestamp);
          break;
        }

        if (isDefined$4(set.ampm)) {
          handleAmpm(set.ampm);
        }

        if (set.utc || isDefined$4(set.tzHour)) {
          handleTimezoneOffset(set.tzHour, set.tzMinute);
        }

        if (isDefined$4(set.shift) && isUndefined$2(set.unit)) {
          // "next january", "next monday", etc
          handleUnitlessShift();
        }

        if (isDefined$4(set.num) && isUndefined$2(set.unit)) {
          // "the second of January", etc
          handleUnitlessNum(set.num);
        }

        if (set.midday) {
          // "noon" and "midnight"
          handleMidday(set.midday);
        }

        if (isDefined$4(set.day)) {
          // Relative day localizations such as "today" and "tomorrow".
          handleRelativeDay(set.day);
        }

        if (isDefined$4(set.unit)) {
          // "3 days ago", etc
          handleRelativeUnit(set.unit);
        }

        if (set.edge) {
          // "the end of January", etc
          handleEdge(set.edge, set);
        }

        break;
      }
    }

    if (!set) {
      // TODO: remove in next major version
      // Fall back to native parsing
      date = new Date(str);
      if (optFromUTC && dateIsValid$4(date)) {
        // Falling back to system date here which cannot be parsed as UTC,
        // so if we're forcing UTC then simply add the offset.
        date.setTime(date.getTime() + (tzOffset$3(date) * MINUTES$1));
      }
    } else if (relative) {
      updateDate$2(date, set, false, 1);
    } else {
      updateDate$2(date, set, true, 0, optPrefer, weekdayDir, contextDate);
    }
    fireCallbacks();
    return date;
  }

  function handleAmpm(ampm) {
    if (ampm === 1 && set.hour < 12) {
      // If the time is 1pm-11pm advance the time by 12 hours.
      set.hour += 12;
    } else if (ampm === 0 && set.hour === 12) {
      // If it is 12:00am then set the hour to 0.
      set.hour = 0;
    }
  }

  function handleTimezoneOffset(tzHour, tzMinute) {
    // Adjust for timezone offset
    _utc$4(date, true);

    // Sign is parsed as part of the hour, so flip
    // the minutes if it's negative.

    if (tzHour < 0) {
      tzMinute *= -1;
    }

    var offset = tzHour * 60 + (tzMinute || 0);
    if (offset) {
      set.minute = (set.minute || 0) - offset;
    }
  }

  function handleUnitlessShift() {
    if (isDefined$4(set.month)) {
      // "next January"
      set.unit = YEAR_INDEX$1;
    } else if (isDefined$4(set.weekday)) {
      // "next Monday"
      set.unit = WEEK_INDEX;
    }
  }

  function handleUnitlessNum(num) {
    if (isDefined$4(set.weekday)) {
      // "The second Tuesday of March"
      setOrdinalWeekday(num);
    } else if (isDefined$4(set.month)) {
      // "The second of March"
      set.date = set.num;
    }
  }

  function handleMidday(hour) {
    set.hour = hour % 24;
    if (hour > 23) {
      // If the date has hours past 24, we need to prevent it from traversing
      // into a new day as that would make it being part of a new week in
      // ambiguous dates such as "Monday".
      afterDateSet(function() {
        advanceDate$4(date, 'date', trunc$5(hour / 24));
      });
    }
  }

  function handleRelativeDay() {
    resetTime$1(date);
    if (isUndefined$2(set.unit)) {
      set.unit = DAY_INDEX$4;
      set.num  = set.day;
      delete set.day;
    }
  }

  function handleRelativeUnit(unitIndex) {
    var num;

    if (isDefined$4(set.num)) {
      num = set.num;
    } else if (isDefined$4(set.edge) && isUndefined$2(set.shift)) {
      num = 0;
    } else {
      num = 1;
    }

    // If a weekday is defined, there are 3 possible formats being applied:
    //
    // 1. "the day after monday": unit is days
    // 2. "next monday": short for "next week monday", unit is weeks
    // 3. "the 2nd monday of next month": unit is months
    //
    // In the first case, we need to set the weekday up front, as the day is
    // relative to it. The second case also needs to be handled up front for
    // formats like "next monday at midnight" which will have its weekday reset
    // if not set up front. The last case will set up the params necessary to
    // shift the weekday and allow separateAbsoluteUnits below to handle setting
    // it after the date has been shifted.
    if(isDefined$4(set.weekday)) {
      if(unitIndex === MONTH_INDEX$2) {
        setOrdinalWeekday(num);
        num = 1;
      } else {
        updateDate$2(date, { weekday: set.weekday }, true);
        delete set.weekday;
      }
    }

    if (set.half) {
      // Allow localized "half" as a standalone colloquialism. Purposely avoiding
      // the locale number system to reduce complexity. The units "month" and
      // "week" are purposely excluded in the English date formats below, as
      // "half a week" and "half a month" are meaningless as exact dates.
      num *= set.half;
    }

    if (isDefined$4(set.shift)) {
      // Shift and unit, ie "next month", "last week", etc.
      num *= set.shift;
    } else if (set.sign) {
      // Unit and sign, ie "months ago", "weeks from now", etc.
      num *= set.sign;
    }

    if (isDefined$4(set.day)) {
      // "the day after tomorrow"
      num += set.day;
      delete set.day;
    }

    // Formats like "the 15th of last month" or "6:30pm of next week"
    // contain absolute units in addition to relative ones, so separate
    // them here, remove them from the params, and set up a callback to
    // set them after the relative ones have been set.
    separateAbsoluteUnits(unitIndex);

    // Finally shift the unit.
    set[English$2.units[unitIndex]] = num;
    relative = true;
  }

  function handleEdge(edge, params) {
    var edgeIndex = params.unit, weekdayOfMonth;
    if (!edgeIndex) {
      // If we have "the end of January", then we need to find the unit index.
      iterateOverHigherDateParams(params, function(unitName, val, unit, i) {
        if (unitName === 'weekday' && isDefined$4(params.month)) {
          // If both a month and weekday exist, then we have a format like
          // "the last tuesday in November, 2012", where the "last" is still
          // relative to the end of the month, so prevent the unit "weekday"
          // from taking over.
          return;
        }
        edgeIndex = i;
      });
    }
    if (edgeIndex === MONTH_INDEX$2 && isDefined$4(params.weekday)) {
      // If a weekday in a month exists (as described above),
      // then set it up to be set after the date has been shifted.
      weekdayOfMonth = params.weekday;
      delete params.weekday;
    }
    afterDateSet(function() {
      var stopIndex;
      // "edge" values that are at the very edge are "2" so the beginning of the
      // year is -2 and the end of the year is 2. Conversely, the "last day" is
      // actually 00:00am so it is 1. -1 is reserved but unused for now.
      if (edge < 0) {
        moveToBeginningOfUnit$3(date, edgeIndex, optLocale);
      } else if (edge > 0) {
        if (edge === 1) {
          stopIndex = DAY_INDEX$4;
          moveToBeginningOfUnit$3(date, DAY_INDEX$4);
        }
        moveToEndOfUnit$3(date, edgeIndex, optLocale, stopIndex);
      }
      if (isDefined$4(weekdayOfMonth)) {
        setWeekday$3(date, weekdayOfMonth, -edge);
        resetTime$1(date);
      }
    });
    if (edgeIndex === MONTH_INDEX$2) {
      params.specificity = DAY_INDEX$4;
    } else {
      params.specificity = edgeIndex - 1;
    }
  }

  function setOrdinalWeekday(num) {
    // If we have "the 2nd Tuesday of June", then pass the "weekdayDir"
    // flag along to updateDate so that the date does not accidentally traverse
    // into the previous month. This needs to be independent of the "prefer"
    // flag because we are only ensuring that the weekday is in the future, not
    // the entire date.
    set.weekday = 7 * (num - 1) + set.weekday;
    set.date = 1;
    weekdayDir = 1;
  }

  function separateAbsoluteUnits(unitIndex) {
    var params;

    iterateOverDateParams$1(set, function(name, val, unit, i) {
      // If there is a time unit set that is more specific than
      // the matched unit we have a string like "5:30am in 2 minutes",
      // which is meaningless, so invalidate the date...
      if (i >= unitIndex) {
        date.setTime(NaN);
        return false;
      } else if (i < unitIndex) {
        // ...otherwise set the params to set the absolute date
        // as a callback after the relative date has been set.
        params = params || {};
        params[name] = val;
        deleteDateParam(set, name);
      }
    });
    if (params) {
      afterDateSet(function() {
        updateDate$2(date, params, true, 0, false, weekdayDir);
        if (optParams) {
          simpleMerge(optParams, params);
        }
      });
      if (set.edge) {
        // "the end of March of next year"
        handleEdge(set.edge, params);
        delete set.edge;
      }
    }
  }

  if (contextDate && d) {
    // If a context date is passed ("get" and "unitsFromNow"),
    // then use it as the starting point.
    date = cloneDateByFlag(contextDate, true);
  } else {
    date = getNewDate$3();
  }

  _utc$4(date, optFromUTC);

  if (isString$6(d)) {
    date = parseStringDate(d);
  } else if (isDate$4(d)) {
    date = cloneDateByFlag(d, optClone || forceClone);
  } else if (isObjectType$2(d)) {
    set = simpleClone$1(d);
    updateDate$2(date, set, true);
  } else if (isNumber$6(d) || d === null) {
    date.setTime(d);
  }
  // A date created by parsing a string presumes that the format *itself* is
  // UTC, but not that the date, once created, should be manipulated as such. In
  // other words, if you are creating a date object from a server time
  // "2012-11-15T12:00:00Z", in the majority of cases you are using it to create
  // a date that will, after creation, be manipulated as local, so reset the utc
  // flag here unless "setUTC" is also set.
  _utc$4(date, !!optSetUTC);
  return {
    set: set,
    date: date
  };
}

var getExtendedDate_1 = getExtendedDate$3;

var getExtendedDate$2 = getExtendedDate_1;

function createDate$8(d, options, forceClone) {
  return getExtendedDate$2(null, d, options, forceClone).date;
}

var createDate_1 = createDate$8;

var createDate$7 = createDate_1,
    namespaceAliases$6 = namespaceAliases$e,
    setChainableConstructor = setChainableConstructor_1;

var sugarDate$5 = namespaceAliases$6.sugarDate;

function setDateChainableConstructor$1() {
  setChainableConstructor(sugarDate$5, createDate$7);
}

var setDateChainableConstructor_1 = setDateChainableConstructor$1;

var setDateChainableConstructor = setDateChainableConstructor_1;

setDateChainableConstructor();

var Sugar$3h = sugarCore.exports,
    createDate$6 = createDate_1;



Sugar$3h.Date.defineStatic({

  'create': function(d, options) {
    return createDate$6(d, options);
  }

});

Sugar$3h.Date.create;

var Sugar$3g = sugarCore.exports,
    LocaleHelpers$c = LocaleHelpers$h,
    getKeys = getKeys_1;

var localeManager$a = LocaleHelpers$c.localeManager;

Sugar$3g.Date.defineStatic({

  'getAllLocaleCodes': function() {
    return getKeys(localeManager$a.getAll());
  }

});

Sugar$3g.Date.getAllLocaleCodes;

var Sugar$3f = sugarCore.exports,
    LocaleHelpers$b = LocaleHelpers$h;

var localeManager$9 = LocaleHelpers$b.localeManager;

Sugar$3f.Date.defineStatic({

  'getAllLocales': function() {
    return localeManager$9.getAll();
  }

});

Sugar$3f.Date.getAllLocales;

var Sugar$3e = sugarCore.exports,
    LocaleHelpers$a = LocaleHelpers$h;

var localeManager$8 = LocaleHelpers$a.localeManager;

Sugar$3e.Date.defineStatic({

  'getLocale': function(code) {
    return localeManager$8.get(code, !code);
  }

});

Sugar$3e.Date.getLocale;

var Sugar$3d = sugarCore.exports,
    LocaleHelpers$9 = LocaleHelpers$h;

var localeManager$7 = LocaleHelpers$9.localeManager;

Sugar$3d.Date.defineStatic({

  'removeLocale': function(code) {
    return localeManager$7.remove(code);
  }

});

Sugar$3d.Date.removeLocale;

var Sugar$3c = sugarCore.exports,
    LocaleHelpers$8 = LocaleHelpers$h;

var localeManager$6 = LocaleHelpers$8.localeManager;

Sugar$3c.Date.defineStatic({

  'setLocale': function(code) {
    return localeManager$6.set(code);
  }

});

Sugar$3c.Date.setLocale;

var DateUnits$3 = DateUnits_1,
    createDate$5 = createDate_1,
    mathAliases$9 = mathAliases$z,
    advanceDate$3 = advanceDate_1,
    namespaceAliases$5 = namespaceAliases$e,
    defineInstanceSimilar$3 = defineInstanceSimilar_1;

var sugarNumber = namespaceAliases$5.sugarNumber,
    round$1 = mathAliases$9.round;

function buildNumberUnitMethods$1() {
  defineInstanceSimilar$3(sugarNumber, DateUnits$3, function(methods, unit) {
    var name = unit.name, base, after, before;
    base = function(n) {
      return round$1(n * unit.multiplier);
    };
    after = function(n, d, options) {
      return advanceDate$3(createDate$5(d, options, true), name, n);
    };
    before = function(n, d, options) {
      return advanceDate$3(createDate$5(d, options, true), name, -n);
    };
    methods[name] = base;
    methods[name + 's'] = base;
    methods[name + 'Before'] = before;
    methods[name + 'sBefore'] = before;
    methods[name + 'Ago'] = before;
    methods[name + 'sAgo'] = before;
    methods[name + 'After'] = after;
    methods[name + 'sAfter'] = after;
    methods[name + 'FromNow'] = after;
    methods[name + 'sFromNow'] = after;
  });
}

var buildNumberUnitMethods_1 = buildNumberUnitMethods$1;

var buildNumberUnitMethods = buildNumberUnitMethods_1;

buildNumberUnitMethods();

var Sugar$3b = sugarCore.exports;



Sugar$3b.Number.day;

var Sugar$3a = sugarCore.exports;



Sugar$3a.Number.dayAfter;

var Sugar$39 = sugarCore.exports;



Sugar$39.Number.dayAgo;

var Sugar$38 = sugarCore.exports;



Sugar$38.Number.dayBefore;

var Sugar$37 = sugarCore.exports;



Sugar$37.Number.dayFromNow;

var Sugar$36 = sugarCore.exports;



Sugar$36.Number.days;

var Sugar$35 = sugarCore.exports;



Sugar$35.Number.daysAfter;

var Sugar$34 = sugarCore.exports;



Sugar$34.Number.daysAgo;

var Sugar$33 = sugarCore.exports;



Sugar$33.Number.daysBefore;

var Sugar$32 = sugarCore.exports;



Sugar$32.Number.daysFromNow;

var Sugar$31 = sugarCore.exports,
    LocaleHelpers$7 = LocaleHelpers$h;

var localeManager$5 = LocaleHelpers$7.localeManager;

Sugar$31.Number.defineInstance({

  'duration': function(n, localeCode) {
    return localeManager$5.get(localeCode).getDuration(n);
  }

});

Sugar$31.Number.duration;

var Sugar$30 = sugarCore.exports;



Sugar$30.Number.hour;

var Sugar$2$ = sugarCore.exports;



Sugar$2$.Number.hourAfter;

var Sugar$2_ = sugarCore.exports;



Sugar$2_.Number.hourAgo;

var Sugar$2Z = sugarCore.exports;



Sugar$2Z.Number.hourBefore;

var Sugar$2Y = sugarCore.exports;



Sugar$2Y.Number.hourFromNow;

var Sugar$2X = sugarCore.exports;



Sugar$2X.Number.hours;

var Sugar$2W = sugarCore.exports;



Sugar$2W.Number.hoursAfter;

var Sugar$2V = sugarCore.exports;



Sugar$2V.Number.hoursAgo;

var Sugar$2U = sugarCore.exports;



Sugar$2U.Number.hoursBefore;

var Sugar$2T = sugarCore.exports;



Sugar$2T.Number.hoursFromNow;

var Sugar$2S = sugarCore.exports;



Sugar$2S.Number.millisecond;

var Sugar$2R = sugarCore.exports;



Sugar$2R.Number.millisecondAfter;

var Sugar$2Q = sugarCore.exports;



Sugar$2Q.Number.millisecondAgo;

var Sugar$2P = sugarCore.exports;



Sugar$2P.Number.millisecondBefore;

var Sugar$2O = sugarCore.exports;



Sugar$2O.Number.millisecondFromNow;

var Sugar$2N = sugarCore.exports;



Sugar$2N.Number.milliseconds;

var Sugar$2M = sugarCore.exports;



Sugar$2M.Number.millisecondsAfter;

var Sugar$2L = sugarCore.exports;



Sugar$2L.Number.millisecondsAgo;

var Sugar$2K = sugarCore.exports;



Sugar$2K.Number.millisecondsBefore;

var Sugar$2J = sugarCore.exports;



Sugar$2J.Number.millisecondsFromNow;

var Sugar$2I = sugarCore.exports;



Sugar$2I.Number.minute;

var Sugar$2H = sugarCore.exports;



Sugar$2H.Number.minuteAfter;

var Sugar$2G = sugarCore.exports;



Sugar$2G.Number.minuteAgo;

var Sugar$2F = sugarCore.exports;



Sugar$2F.Number.minuteBefore;

var Sugar$2E = sugarCore.exports;



Sugar$2E.Number.minuteFromNow;

var Sugar$2D = sugarCore.exports;



Sugar$2D.Number.minutes;

var Sugar$2C = sugarCore.exports;



Sugar$2C.Number.minutesAfter;

var Sugar$2B = sugarCore.exports;



Sugar$2B.Number.minutesAgo;

var Sugar$2A = sugarCore.exports;



Sugar$2A.Number.minutesBefore;

var Sugar$2z = sugarCore.exports;



Sugar$2z.Number.minutesFromNow;

var Sugar$2y = sugarCore.exports;



Sugar$2y.Number.month;

var Sugar$2x = sugarCore.exports;



Sugar$2x.Number.monthAfter;

var Sugar$2w = sugarCore.exports;



Sugar$2w.Number.monthAgo;

var Sugar$2v = sugarCore.exports;



Sugar$2v.Number.monthBefore;

var Sugar$2u = sugarCore.exports;



Sugar$2u.Number.monthFromNow;

var Sugar$2t = sugarCore.exports;



Sugar$2t.Number.months;

var Sugar$2s = sugarCore.exports;



Sugar$2s.Number.monthsAfter;

var Sugar$2r = sugarCore.exports;



Sugar$2r.Number.monthsAgo;

var Sugar$2q = sugarCore.exports;



Sugar$2q.Number.monthsBefore;

var Sugar$2p = sugarCore.exports;



Sugar$2p.Number.monthsFromNow;

var Sugar$2o = sugarCore.exports;



Sugar$2o.Number.second;

var Sugar$2n = sugarCore.exports;



Sugar$2n.Number.secondAfter;

var Sugar$2m = sugarCore.exports;



Sugar$2m.Number.secondAgo;

var Sugar$2l = sugarCore.exports;



Sugar$2l.Number.secondBefore;

var Sugar$2k = sugarCore.exports;



Sugar$2k.Number.secondFromNow;

var Sugar$2j = sugarCore.exports;



Sugar$2j.Number.seconds;

var Sugar$2i = sugarCore.exports;



Sugar$2i.Number.secondsAfter;

var Sugar$2h = sugarCore.exports;



Sugar$2h.Number.secondsAgo;

var Sugar$2g = sugarCore.exports;



Sugar$2g.Number.secondsBefore;

var Sugar$2f = sugarCore.exports;



Sugar$2f.Number.secondsFromNow;

var Sugar$2e = sugarCore.exports;



Sugar$2e.Number.week;

var Sugar$2d = sugarCore.exports;



Sugar$2d.Number.weekAfter;

var Sugar$2c = sugarCore.exports;



Sugar$2c.Number.weekAgo;

var Sugar$2b = sugarCore.exports;



Sugar$2b.Number.weekBefore;

var Sugar$2a = sugarCore.exports;



Sugar$2a.Number.weekFromNow;

var Sugar$29 = sugarCore.exports;



Sugar$29.Number.weeks;

var Sugar$28 = sugarCore.exports;



Sugar$28.Number.weeksAfter;

var Sugar$27 = sugarCore.exports;



Sugar$27.Number.weeksAgo;

var Sugar$26 = sugarCore.exports;



Sugar$26.Number.weeksBefore;

var Sugar$25 = sugarCore.exports;



Sugar$25.Number.weeksFromNow;

var Sugar$24 = sugarCore.exports;



Sugar$24.Number.year;

var Sugar$23 = sugarCore.exports;



Sugar$23.Number.yearAfter;

var Sugar$22 = sugarCore.exports;



Sugar$22.Number.yearAgo;

var Sugar$21 = sugarCore.exports;



Sugar$21.Number.yearBefore;

var Sugar$20 = sugarCore.exports;



Sugar$20.Number.yearFromNow;

var Sugar$1$ = sugarCore.exports;



Sugar$1$.Number.years;

var Sugar$1_ = sugarCore.exports;



Sugar$1_.Number.yearsAfter;

var Sugar$1Z = sugarCore.exports;



Sugar$1Z.Number.yearsAgo;

var Sugar$1Y = sugarCore.exports;



Sugar$1Y.Number.yearsBefore;

var Sugar$1X = sugarCore.exports;



Sugar$1X.Number.yearsFromNow;

var MINUTES = MINUTES$2,
    DateUnits$2 = DateUnits_1,
    DateUnitIndexes$6 = DateUnitIndexes$i,
    _utc$3 = _utc$8,
    tzOffset$2 = tzOffset_1,
    cloneDate$4 = cloneDate_1,
    isDefined$3 = isDefined_1,
    advanceDate$2 = advanceDate_1,
    dateIsValid$3 = dateIsValid_1,
    moveToEndOfUnit$2 = moveToEndOfUnit_1,
    getExtendedDate$1 = getExtendedDate_1,
    moveToBeginningOfUnit$2 = moveToBeginningOfUnit_1;

var MONTH_INDEX$1 = DateUnitIndexes$6.MONTH_INDEX;

function compareDate$2(date, d, margin, localeCode, options) {
  var loMargin = 0, hiMargin = 0, timezoneShift, compareEdges, override, min, max, p, t;

  function getTimezoneShift() {
    // If there is any specificity in the date then we're implicitly not
    // checking absolute time, so ignore timezone shifts.
    if (p.set && p.set.specificity) {
      return 0;
    }
    return (tzOffset$2(p.date) - tzOffset$2(date)) * MINUTES;
  }

  function addSpecificUnit() {
    var unit = DateUnits$2[p.set.specificity];
    return advanceDate$2(cloneDate$4(p.date), unit.name, 1).getTime() - 1;
  }

  if (_utc$3(date)) {
    options = options || {};
    options.fromUTC = true;
    options.setUTC = true;
  }

  p = getExtendedDate$1(null, d, options, true);

  if (margin > 0) {
    loMargin = hiMargin = margin;
    override = true;
  }
  if (!dateIsValid$3(p.date)) return false;
  if (p.set && p.set.specificity) {
    if (isDefined$3(p.set.edge) || isDefined$3(p.set.shift)) {
      compareEdges = true;
      moveToBeginningOfUnit$2(p.date, p.set.specificity, localeCode);
    }
    if (compareEdges || p.set.specificity === MONTH_INDEX$1) {
      max = moveToEndOfUnit$2(cloneDate$4(p.date), p.set.specificity, localeCode).getTime();
    } else {
      max = addSpecificUnit();
    }
    if (!override && isDefined$3(p.set.sign) && p.set.specificity) {
      // If the time is relative, there can occasionally be an disparity between
      // the relative date and "now", which it is being compared to, so set an
      // extra margin to account for this.
      loMargin = 50;
      hiMargin = -50;
    }
  }
  t   = date.getTime();
  min = p.date.getTime();
  max = max || min;
  timezoneShift = getTimezoneShift();
  // istanbul ignore if
  if (timezoneShift) {
    min -= timezoneShift;
    max -= timezoneShift;
  }
  return t >= (min - loMargin) && t <= (max + hiMargin);
}

var compareDate_1 = compareDate$2;

var trunc$4 = trunc_1,
    cloneDate$3 = cloneDate_1,
    advanceDate$1 = advanceDate_1;

function getTimeDistanceForUnit$3(d1, d2, unit) {
  var fwd = d2 > d1, num, tmp;
  if (!fwd) {
    tmp = d2;
    d2  = d1;
    d1  = tmp;
  }
  num = d2 - d1;
  if (unit.multiplier > 1) {
    num = trunc$4(num / unit.multiplier);
  }
  // For higher order with potential ambiguity, use the numeric calculation
  // as a starting point, then iterate until we pass the target date. Decrement
  // starting point by 1 to prevent overshooting the date due to inconsistencies
  // in ambiguous units numerically. For example, calculating the number of days
  // from the beginning of the year to August 5th at 11:59:59 by doing a simple
  // d2 - d1 will produce different results depending on whether or not a
  // timezone shift was encountered due to DST, however that should not have an
  // effect on our calculation here, so subtract by 1 to ensure that the
  // starting point has not already overshot our target date.
  if (unit.ambiguous) {
    d1 = cloneDate$3(d1);
    if (num) {
      num -= 1;
      advanceDate$1(d1, unit.name, num);
    }
    while (d1 < d2) {
      advanceDate$1(d1, unit.name, 1);
      if (d1 > d2) {
        break;
      }
      num += 1;
    }
  }
  return fwd ? -num : num;
}

var getTimeDistanceForUnit_1 = getTimeDistanceForUnit$3;

var DateUnits$1 = DateUnits_1,
    DateUnitIndexes$5 = DateUnitIndexes$i,
    forEach$2 = forEach_1,
    createDate$4 = createDate_1,
    compareDate$1 = compareDate_1,
    advanceDate = advanceDate_1,
    moveToEndOfUnit$1 = moveToEndOfUnit_1,
    namespaceAliases$4 = namespaceAliases$e,
    simpleCapitalize$2 = simpleCapitalize_1,
    moveToBeginningOfUnit$1 = moveToBeginningOfUnit_1,
    defineInstanceSimilar$2 = defineInstanceSimilar_1,
    getTimeDistanceForUnit$2 = getTimeDistanceForUnit_1;

var sugarDate$4 = namespaceAliases$4.sugarDate,
    HOURS_INDEX = DateUnitIndexes$5.HOURS_INDEX,
    DAY_INDEX$3 = DateUnitIndexes$5.DAY_INDEX;

function buildDateUnitMethods$1() {

  defineInstanceSimilar$2(sugarDate$4, DateUnits$1, function(methods, unit, index) {
    var name = unit.name, caps = simpleCapitalize$2(name);

    if (index > DAY_INDEX$3) {
      forEach$2(['Last','This','Next'], function(shift) {
        methods['is' + shift + caps] = function(d, localeCode) {
          return compareDate$1(d, shift + ' ' + name, 0, localeCode, { locale: 'en' });
        };
      });
    }
    if (index > HOURS_INDEX) {
      methods['beginningOf' + caps] = function(d, localeCode) {
        return moveToBeginningOfUnit$1(d, index, localeCode);
      };
      methods['endOf' + caps] = function(d, localeCode) {
        return moveToEndOfUnit$1(d, index, localeCode);
      };
    }

    methods['add' + caps + 's'] = function(d, num, reset) {
      return advanceDate(d, name, num, reset);
    };

    var since = function(date, d, options) {
      return getTimeDistanceForUnit$2(date, createDate$4(d, options, true), unit);
    };
    var until = function(date, d, options) {
      return getTimeDistanceForUnit$2(createDate$4(d, options, true), date, unit);
    };

    methods[name + 'sAgo']   = methods[name + 'sUntil']   = until;
    methods[name + 'sSince'] = methods[name + 'sFromNow'] = since;

  });

}

var buildDateUnitMethods_1 = buildDateUnitMethods$1;

var buildDateUnitMethods = buildDateUnitMethods_1;

buildDateUnitMethods();

var Sugar$1W = sugarCore.exports;



Sugar$1W.Date.addDays;

var Sugar$1V = sugarCore.exports;



Sugar$1V.Date.addHours;

var Sugar$1U = sugarCore.exports;



Sugar$1U.Date.addMilliseconds;

var Sugar$1T = sugarCore.exports;



Sugar$1T.Date.addMinutes;

var Sugar$1S = sugarCore.exports;



Sugar$1S.Date.addMonths;

var Sugar$1R = sugarCore.exports;



Sugar$1R.Date.addSeconds;

var Sugar$1Q = sugarCore.exports;



Sugar$1Q.Date.addWeeks;

var Sugar$1P = sugarCore.exports;



Sugar$1P.Date.addYears;

var isUndefined$1 = isUndefined_1;

function getDateParamsFromString$1(str) {
  var match, num, params = {};
  match = str.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i);
  if (match) {
    if (isUndefined$1(num)) {
      num = match[1] ? +match[1] : 1;
    }
    params[match[2].toLowerCase()] = num;
  }
  return params;
}

var getDateParamsFromString_1 = getDateParamsFromString$1;

var DateUnitIndexes$4 = DateUnitIndexes$i,
    isDefined$2 = isDefined_1,
    walkUnitDown = walkUnitDown_1;

var YEAR_INDEX = DateUnitIndexes$4.YEAR_INDEX;

function collectDateParamsFromArguments$1(args) {
  var params = {}, index = 0;
  walkUnitDown(YEAR_INDEX, function(unit) {
    var arg = args[index++];
    if (isDefined$2(arg)) {
      params[unit.name] = arg;
    }
  });
  return params;
}

var collectDateParamsFromArguments_1 = collectDateParamsFromArguments$1;

var classChecks$d = classChecks$Z,
    simpleClone = simpleClone_1,
    isObjectType$1 = isObjectType_1,
    getDateParamsFromString = getDateParamsFromString_1,
    collectDateParamsFromArguments = collectDateParamsFromArguments_1;

var isNumber$5 = classChecks$d.isNumber,
    isString$5 = classChecks$d.isString;

function collectUpdateDateArguments$2(args, allowDuration) {
  var arg1 = args[0], arg2 = args[1], params, reset;
  if (allowDuration && isString$5(arg1)) {
    params = getDateParamsFromString(arg1);
    reset  = arg2;
  } else if (isNumber$5(arg1) && isNumber$5(arg2)) {
    params = collectDateParamsFromArguments(args);
  } else {
    params = isObjectType$1(arg1) ? simpleClone(arg1) : arg1;
    reset  = arg2;
  }
  return [params, reset];
}

var collectUpdateDateArguments_1 = collectUpdateDateArguments$2;

var updateDate$1 = updateDate_1,
    collectUpdateDateArguments$1 = collectUpdateDateArguments_1;

function advanceDateWithArgs$2(d, args, dir) {
  args = collectUpdateDateArguments$1(args, true);
  return updateDate$1(d, args[0], args[1], dir);
}

var advanceDateWithArgs_1 = advanceDateWithArgs$2;

var Sugar$1O = sugarCore.exports,
    advanceDateWithArgs$1 = advanceDateWithArgs_1;

Sugar$1O.Date.defineInstanceWithArguments({

  'advance': function(d, args) {
    return advanceDateWithArgs$1(d, args, 1);
  }

});

Sugar$1O.Date.advance;

var Sugar$1N = sugarCore.exports;



Sugar$1N.Date.beginningOfDay;

var Sugar$1M = sugarCore.exports,
    resetTime = resetTime_1,
    getWeekday$4 = getWeekday_1,
    setWeekday$2 = setWeekday_1;

Sugar$1M.Date.defineInstance({

  'beginningOfISOWeek': function(date) {
    var day = getWeekday$4(date);
    if (day === 0) {
      day = -6;
    } else if (day !== 1) {
      day = 1;
    }
    setWeekday$2(date, day);
    return resetTime(date);
  }

});

Sugar$1M.Date.beginningOfISOWeek;

var Sugar$1L = sugarCore.exports;



Sugar$1L.Date.beginningOfMonth;

var Sugar$1K = sugarCore.exports;



Sugar$1K.Date.beginningOfWeek;

var Sugar$1J = sugarCore.exports;



Sugar$1J.Date.beginningOfYear;

var Sugar$1I = sugarCore.exports,
    cloneDate$2 = cloneDate_1;

Sugar$1I.Date.defineInstance({

  'clone': function(date) {
    return cloneDate$2(date);
  }

});

Sugar$1I.Date.clone;

var Sugar$1H = sugarCore.exports;



Sugar$1H.Date.daysAgo;

var Sugar$1G = sugarCore.exports;



Sugar$1G.Date.daysFromNow;

var Sugar$1F = sugarCore.exports,
    getDaysInMonth = getDaysInMonth_1;

Sugar$1F.Date.defineInstance({

  'daysInMonth': function(date) {
    return getDaysInMonth(date);
  }

});

Sugar$1F.Date.daysInMonth;

var Sugar$1E = sugarCore.exports;



Sugar$1E.Date.daysSince;

var Sugar$1D = sugarCore.exports;



Sugar$1D.Date.daysUntil;

var Sugar$1C = sugarCore.exports;



Sugar$1C.Date.endOfDay;

var Sugar$1B = sugarCore.exports,
    DateUnitIndexes$3 = DateUnitIndexes$i,
    getWeekday$3 = getWeekday_1,
    setWeekday$1 = setWeekday_1,
    moveToEndOfUnit = moveToEndOfUnit_1;

var DAY_INDEX$2 = DateUnitIndexes$3.DAY_INDEX;

Sugar$1B.Date.defineInstance({

  'endOfISOWeek': function(date) {
    if (getWeekday$3(date) !== 0) {
      setWeekday$1(date, 7);
    }
    return moveToEndOfUnit(date, DAY_INDEX$2);
  }

});

Sugar$1B.Date.endOfISOWeek;

var Sugar$1A = sugarCore.exports;



Sugar$1A.Date.endOfMonth;

var Sugar$1z = sugarCore.exports;



Sugar$1z.Date.endOfWeek;

var Sugar$1y = sugarCore.exports;



Sugar$1y.Date.endOfYear;

var CoreOutputFormats$2 = {
  'ISO8601': '{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}',
  'RFC1123': '{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}',
  'RFC1036': '{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}'
};

var CoreOutputFormats_1 = CoreOutputFormats$2;

var TIMEZONE_ABBREVIATION_REG$1 = /\(([-+]\d{2,4}|\w{3,5})\)$/;

var callDateGet$2 = callDateGet_1;

function getHours$2(d) {
  return callDateGet$2(d, 'Hours');
}

var getHours_1 = getHours$2;

var ISODefaults = ISODefaults$3,
    setDate$1 = setDate_1,
    getDate$2 = getDate_1,
    cloneDate$1 = cloneDate_1,
    isUndefined = isUndefined_1,
    moveToEndOfWeek = moveToEndOfWeek_1,
    moveToBeginningOfWeek = moveToBeginningOfWeek_1,
    moveToFirstDayOfWeekYear = moveToFirstDayOfWeekYear_1;

var ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;

function getWeekNumber$3(d, allowPrevious, firstDayOfWeek, firstDayOfWeekYear) {
  var isoWeek, n = 0;
  if (isUndefined(firstDayOfWeek)) {
    firstDayOfWeek = ISO_FIRST_DAY_OF_WEEK;
  }
  if (isUndefined(firstDayOfWeekYear)) {
    firstDayOfWeekYear = ISO_FIRST_DAY_OF_WEEK_YEAR;
  }
  // Moving to the end of the week allows for forward year traversal, ie
  // Dec 29 2014 is actually week 01 of 2015.
  isoWeek = moveToEndOfWeek(cloneDate$1(d), firstDayOfWeek);
  moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  if (allowPrevious && d < isoWeek) {
    // If the date is still before the start of the year, then it should be
    // the last week of the previous year, ie Jan 1 2016 is actually week 53
    // of 2015, so move to the beginning of the week to traverse the year.
    isoWeek = moveToBeginningOfWeek(cloneDate$1(d), firstDayOfWeek);
    moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  }
  while (isoWeek <= d) {
    // Doing a very simple walk to get the week number.
    setDate$1(isoWeek, getDate$2(isoWeek) + 7);
    n++;
  }
  return n;
}

var getWeekNumber_1 = getWeekNumber$3;

var LocaleHelpers$6 = LocaleHelpers$h,
    getYear$3 = getYear_1,
    getMonth$3 = getMonth_1,
    getWeekNumber$2 = getWeekNumber_1;

var localeManager$4 = LocaleHelpers$6.localeManager;

function getWeekYear$1(d, localeCode, iso) {
  var year, month, firstDayOfWeek, firstDayOfWeekYear, week, loc;
  year = getYear$3(d);
  month = getMonth$3(d);
  if (month === 0 || month === 11) {
    if (!iso) {
      loc = localeManager$4.get(localeCode);
      firstDayOfWeek = loc.getFirstDayOfWeek(localeCode);
      firstDayOfWeekYear = loc.getFirstDayOfWeekYear(localeCode);
    }
    week = getWeekNumber$2(d, false, firstDayOfWeek, firstDayOfWeekYear);
    if (month === 0 && week === 0) {
      year -= 1;
    } else if (month === 11 && week === 1) {
      year += 1;
    }
  }
  return year;
}

var getWeekYear_1 = getWeekYear$1;

var _utc$2 = _utc$8,
    trunc$3 = trunc_1,
    tzOffset$1 = tzOffset_1,
    padNumber$2 = padNumber_1,
    mathAliases$8 = mathAliases$z;

var abs$2 = mathAliases$8.abs;

function getUTCOffset$2(d, iso) {
  var offset = _utc$2(d) ? 0 : tzOffset$1(d), hours, mins, colon;
  colon  = iso === true ? ':' : '';
  if (!offset && iso) return 'Z';
  hours = padNumber$2(trunc$3(-offset / 60), 2, true);
  mins = padNumber$2(abs$2(offset % 60), 2);
  return  hours + colon + mins;
}

var getUTCOffset_1 = getUTCOffset$2;

var DateUnits = DateUnits_1,
    DateUnitIndexes$2 = DateUnitIndexes$i,
    getTimeDistanceForUnit$1 = getTimeDistanceForUnit_1;

var DAY_INDEX$1 = DateUnitIndexes$2.DAY_INDEX;

function getDaysSince$1(d1, d2) {
  return getTimeDistanceForUnit$1(d1, d2, DateUnits[DAY_INDEX$1]);
}

var getDaysSince_1 = getDaysSince$1;

var LocaleHelpers$5 = LocaleHelpers$h,
    trunc$2 = trunc_1,
    getHours$1 = getHours_1;

var localeManager$3 = LocaleHelpers$5.localeManager;

function getMeridiemToken$1(d, localeCode) {
  var hours = getHours$1(d);
  return localeManager$3.get(localeCode).ampm[trunc$2(hours / 12)] || '';
}

var getMeridiemToken_1 = getMeridiemToken$1;

var TIMEZONE_ABBREVIATION_REG = TIMEZONE_ABBREVIATION_REG$1,
    LocaleHelpers$4 = LocaleHelpers$h,
    DateUnitIndexes$1 = DateUnitIndexes$i,
    trunc$1 = trunc_1,
    getDate$1 = getDate_1,
    getYear$2 = getYear_1,
    getHours = getHours_1,
    getMonth$2 = getMonth_1,
    cloneDate = cloneDate_1,
    padNumber$1 = padNumber_1,
    getWeekday$2 = getWeekday_1,
    callDateGet$1 = callDateGet_1,
    mathAliases$7 = mathAliases$z,
    getWeekYear = getWeekYear_1,
    getUTCOffset$1 = getUTCOffset_1,
    getDaysSince = getDaysSince_1,
    getWeekNumber$1 = getWeekNumber_1,
    getMeridiemToken = getMeridiemToken_1,
    setUnitAndLowerToEdge = setUnitAndLowerToEdge_1;

var localeManager$2 = LocaleHelpers$4.localeManager,
    MONTH_INDEX = DateUnitIndexes$1.MONTH_INDEX,
    ceil$1 = mathAliases$7.ceil;

var FormatTokensBase$1 = [
  {
    ldml: 'Dow',
    strf: 'a',
    lowerToken: 'dow',
    get: function(d, localeCode) {
      return localeManager$2.get(localeCode).getWeekdayName(getWeekday$2(d), 2);
    }
  },
  {
    ldml: 'Weekday',
    strf: 'A',
    lowerToken: 'weekday',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2.get(localeCode).getWeekdayName(getWeekday$2(d), alternate);
    }
  },
  {
    ldml: 'Mon',
    strf: 'b h',
    lowerToken: 'mon',
    get: function(d, localeCode) {
      return localeManager$2.get(localeCode).getMonthName(getMonth$2(d), 2);
    }
  },
  {
    ldml: 'Month',
    strf: 'B',
    lowerToken: 'month',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2.get(localeCode).getMonthName(getMonth$2(d), alternate);
    }
  },
  {
    strf: 'C',
    get: function(d) {
      return getYear$2(d).toString().slice(0, 2);
    }
  },
  {
    ldml: 'd date day',
    strf: 'd',
    strfPadding: 2,
    ldmlPaddedToken: 'dd',
    ordinalToken: 'do',
    get: function(d) {
      return getDate$1(d);
    }
  },
  {
    strf: 'e',
    get: function(d) {
      return padNumber$1(getDate$1(d), 2, false, 10, ' ');
    }
  },
  {
    ldml: 'H 24hr',
    strf: 'H',
    strfPadding: 2,
    ldmlPaddedToken: 'HH',
    get: function(d) {
      return getHours(d);
    }
  },
  {
    ldml: 'h hours 12hr',
    strf: 'I',
    strfPadding: 2,
    ldmlPaddedToken: 'hh',
    get: function(d) {
      return getHours(d) % 12 || 12;
    }
  },
  {
    ldml: 'D',
    strf: 'j',
    strfPadding: 3,
    ldmlPaddedToken: 'DDD',
    get: function(d) {
      var s = setUnitAndLowerToEdge(cloneDate(d), MONTH_INDEX);
      return getDaysSince(d, s) + 1;
    }
  },
  {
    ldml: 'M',
    strf: 'm',
    strfPadding: 2,
    ordinalToken: 'Mo',
    ldmlPaddedToken: 'MM',
    get: function(d) {
      return getMonth$2(d) + 1;
    }
  },
  {
    ldml: 'm minutes',
    strf: 'M',
    strfPadding: 2,
    ldmlPaddedToken: 'mm',
    get: function(d) {
      return callDateGet$1(d, 'Minutes');
    }
  },
  {
    ldml: 'Q',
    get: function(d) {
      return ceil$1((getMonth$2(d) + 1) / 3);
    }
  },
  {
    ldml: 'TT',
    strf: 'p',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode);
    }
  },
  {
    ldml: 'tt',
    strf: 'P',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode).toLowerCase();
    }
  },
  {
    ldml: 'T',
    lowerToken: 't',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode).charAt(0);
    }
  },
  {
    ldml: 's seconds',
    strf: 'S',
    strfPadding: 2,
    ldmlPaddedToken: 'ss',
    get: function(d) {
      return callDateGet$1(d, 'Seconds');
    }
  },
  {
    ldml: 'S ms',
    strfPadding: 3,
    ldmlPaddedToken: 'SSS',
    get: function(d) {
      return callDateGet$1(d, 'Milliseconds');
    }
  },
  {
    ldml: 'e',
    strf: 'u',
    ordinalToken: 'eo',
    get: function(d) {
      return getWeekday$2(d) || 7;
    }
  },
  {
    strf: 'U',
    strfPadding: 2,
    get: function(d) {
      // Sunday first, 0-53
      return getWeekNumber$1(d, false, 0);
    }
  },
  {
    ldml: 'W',
    strf: 'V',
    strfPadding: 2,
    ordinalToken: 'Wo',
    ldmlPaddedToken: 'WW',
    get: function(d) {
      // Monday first, 1-53 (ISO8601)
      return getWeekNumber$1(d, true);
    }
  },
  {
    strf: 'w',
    get: function(d) {
      return getWeekday$2(d);
    }
  },
  {
    ldml: 'w',
    ordinalToken: 'wo',
    ldmlPaddedToken: 'ww',
    get: function(d, localeCode) {
      // Locale dependent, 1-53
      var loc = localeManager$2.get(localeCode),
          dow = loc.getFirstDayOfWeek(localeCode),
          doy = loc.getFirstDayOfWeekYear(localeCode);
      return getWeekNumber$1(d, true, dow, doy);
    }
  },
  {
    strf: 'W',
    strfPadding: 2,
    get: function(d) {
      // Monday first, 0-53
      return getWeekNumber$1(d, false);
    }
  },
  {
    ldmlPaddedToken: 'gggg',
    ldmlTwoDigitToken: 'gg',
    get: function(d, localeCode) {
      return getWeekYear(d, localeCode);
    }
  },
  {
    strf: 'G',
    strfPadding: 4,
    strfTwoDigitToken: 'g',
    ldmlPaddedToken: 'GGGG',
    ldmlTwoDigitToken: 'GG',
    get: function(d, localeCode) {
      return getWeekYear(d, localeCode, true);
    }
  },
  {
    ldml: 'year',
    ldmlPaddedToken: 'yyyy',
    ldmlTwoDigitToken: 'yy',
    strf: 'Y',
    strfPadding: 4,
    strfTwoDigitToken: 'y',
    get: function(d) {
      return getYear$2(d);
    }
  },
  {
    ldml: 'ZZ',
    strf: 'z',
    get: function(d) {
      return getUTCOffset$1(d);
    }
  },
  {
    ldml: 'X',
    get: function(d) {
      return trunc$1(d.getTime() / 1000);
    }
  },
  {
    ldml: 'x',
    get: function(d) {
      return d.getTime();
    }
  },
  {
    ldml: 'Z',
    get: function(d) {
      return getUTCOffset$1(d, true);
    }
  },
  {
    ldml: 'z',
    strf: 'Z',
    get: function(d) {
      // Note that this is not accurate in all browsing environments!
      // https://github.com/moment/moment/issues/162
      // It will continue to be supported for Node and usage with the
      // understanding that it may be blank.
      var match = d.toString().match(TIMEZONE_ABBREVIATION_REG);
      // istanbul ignore next
      return match ? match[1] : '';
    }
  },
  {
    strf: 'D',
    alias: '%m/%d/%y'
  },
  {
    strf: 'F',
    alias: '%Y-%m-%d'
  },
  {
    strf: 'r',
    alias: '%I:%M:%S %p'
  },
  {
    strf: 'R',
    alias: '%H:%M'
  },
  {
    strf: 'T',
    alias: '%H:%M:%S'
  },
  {
    strf: 'x',
    alias: '{short}'
  },
  {
    strf: 'X',
    alias: '{time}'
  },
  {
    strf: 'c',
    alias: '{stamp}'
  }
];

var FormatTokensBase_1 = FormatTokensBase$1;

var LocaleHelpers$3 = LocaleHelpers$h,
    FormatTokensBase = FormatTokensBase_1,
    CoreOutputFormats$1 = CoreOutputFormats_1,
    forEach$1 = forEach_1,
    padNumber = padNumber_1,
    spaceSplit$1 = spaceSplit_1,
    namespaceAliases$3 = namespaceAliases$e,
    coreUtilityAliases$2 = coreUtilityAliases$M,
    createFormatMatcher = createFormatMatcher_1,
    defineInstanceSimilar$1 = defineInstanceSimilar_1;

var localeManager$1 = LocaleHelpers$3.localeManager,
    hasOwn$1 = coreUtilityAliases$2.hasOwn,
    getOwn$1 = coreUtilityAliases$2.getOwn,
    forEachProperty$1 = coreUtilityAliases$2.forEachProperty,
    sugarDate$3 = namespaceAliases$3.sugarDate;

var ldmlTokens, strfTokens;

function buildDateFormatTokens() {

  function addFormats(target, tokens, fn) {
    if (tokens) {
      forEach$1(spaceSplit$1(tokens), function(token) {
        target[token] = fn;
      });
    }
  }

  function buildLowercase(get) {
    return function(d, localeCode) {
      return get(d, localeCode).toLowerCase();
    };
  }

  function buildOrdinal(get) {
    return function(d, localeCode) {
      var n = get(d, localeCode);
      return n + localeManager$1.get(localeCode).getOrdinal(n);
    };
  }

  function buildPadded(get, padding) {
    return function(d, localeCode) {
      return padNumber(get(d, localeCode), padding);
    };
  }

  function buildTwoDigits(get) {
    return function(d, localeCode) {
      return get(d, localeCode) % 100;
    };
  }

  function buildAlias(alias) {
    return function(d, localeCode) {
      return dateFormatMatcher$1(alias, d, localeCode);
    };
  }

  function buildAlternates(f) {
    for (var n = 1; n <= 5; n++) {
      buildAlternate(f, n);
    }
  }

  function buildAlternate(f, n) {
    var alternate = function(d, localeCode) {
      return f.get(d, localeCode, n);
    };
    addFormats(ldmlTokens, f.ldml + n, alternate);
    if (f.lowerToken) {
      ldmlTokens[f.lowerToken + n] = buildLowercase(alternate);
    }
  }

  function getIdentityFormat(name) {
    return function(d, localeCode) {
      var loc = localeManager$1.get(localeCode);
      return dateFormatMatcher$1(loc[name], d, localeCode);
    };
  }

  ldmlTokens = {};
  strfTokens = {};

  forEach$1(FormatTokensBase, function(f) {
    var get = f.get, getPadded;
    if (f.lowerToken) {
      ldmlTokens[f.lowerToken] = buildLowercase(get);
    }
    if (f.ordinalToken) {
      ldmlTokens[f.ordinalToken] = buildOrdinal(get);
    }
    if (f.ldmlPaddedToken) {
      ldmlTokens[f.ldmlPaddedToken] = buildPadded(get, f.ldmlPaddedToken.length);
    }
    if (f.ldmlTwoDigitToken) {
      ldmlTokens[f.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfTwoDigitToken) {
      strfTokens[f.strfTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfPadding) {
      getPadded = buildPadded(get, f.strfPadding);
    }
    if (f.alias) {
      get = buildAlias(f.alias);
    }
    if (f.allowAlternates) {
      buildAlternates(f);
    }
    addFormats(ldmlTokens, f.ldml, get);
    addFormats(strfTokens, f.strf, getPadded || get);
  });

  forEachProperty$1(CoreOutputFormats$1, function(src, name) {
    addFormats(ldmlTokens, name, buildAlias(src));
  });

  defineInstanceSimilar$1(sugarDate$3, 'short medium long full', function(methods, name) {
    var fn = getIdentityFormat(name);
    addFormats(ldmlTokens, name, fn);
    methods[name] = fn;
  });

  addFormats(ldmlTokens, 'time', getIdentityFormat('time'));
  addFormats(ldmlTokens, 'stamp', getIdentityFormat('stamp'));
}

var dateFormatMatcher$1;

function buildDateFormatMatcher() {

  function getLdml(d, token, localeCode) {
    return getOwn$1(ldmlTokens, token)(d, localeCode);
  }

  function getStrf(d, token, localeCode) {
    return getOwn$1(strfTokens, token)(d, localeCode);
  }

  function checkDateToken(ldml, strf) {
    return hasOwn$1(ldmlTokens, ldml) || hasOwn$1(strfTokens, strf);
  }

  // Format matcher for LDML or STRF tokens.
  dateFormatMatcher$1 = createFormatMatcher(getLdml, getStrf, checkDateToken);
}

buildDateFormatTokens();

buildDateFormatMatcher();

var formattingTokens$1 = {
  ldmlTokens: ldmlTokens,
  strfTokens: strfTokens,
  dateFormatMatcher: dateFormatMatcher$1
};

var dateIsValid$2 = dateIsValid_1;

function assertDateIsValid$2(d) {
  if (!dateIsValid$2(d)) {
    throw new TypeError('Date is not valid');
  }
}

var assertDateIsValid_1 = assertDateIsValid$2;

var CoreOutputFormats = CoreOutputFormats_1,
    formattingTokens = formattingTokens$1,
    assertDateIsValid$1 = assertDateIsValid_1;

var dateFormatMatcher = formattingTokens.dateFormatMatcher;

function dateFormat$2(d, format, localeCode) {
  assertDateIsValid$1(d);
  format = CoreOutputFormats[format] || format || '{long}';
  return dateFormatMatcher(format, d, localeCode);
}

var dateFormat_1 = dateFormat$2;

var Sugar$1x = sugarCore.exports,
    dateFormat$1 = dateFormat_1;

Sugar$1x.Date.defineInstance({

  'format': function(date, f, localeCode) {
    return dateFormat$1(date, f, localeCode);
  }

});

Sugar$1x.Date.format;

var getExtendedDate = getExtendedDate_1;

function createDateWithContext$1(contextDate, d, options, forceClone) {
  return getExtendedDate(contextDate, d, options, forceClone).date;
}

var createDateWithContext_1 = createDateWithContext$1;

var Sugar$1w = sugarCore.exports,
    createDateWithContext = createDateWithContext_1;

Sugar$1w.Date.defineInstance({

  'get': function(date, d, options) {
    return createDateWithContext(date, d, options);
  }

});

Sugar$1w.Date.get;

var Sugar$1v = sugarCore.exports,
    getWeekNumber = getWeekNumber_1;

Sugar$1v.Date.defineInstance({

  'getISOWeek': function(date) {
    return getWeekNumber(date, true);
  }

});

Sugar$1v.Date.getISOWeek;

var Sugar$1u = sugarCore.exports,
    getUTCOffset = getUTCOffset_1;

Sugar$1u.Date.defineInstance({

  'getUTCOffset': function(date, iso) {
    return getUTCOffset(date, iso);
  }

});

Sugar$1u.Date.getUTCOffset;

var Sugar$1t = sugarCore.exports;

Sugar$1t.Date.defineInstance({

  'getUTCWeekday': function(date) {
    return date.getUTCDay();
  }

});

Sugar$1t.Date.getUTCWeekday;

var Sugar$1s = sugarCore.exports,
    getWeekday$1 = getWeekday_1;

Sugar$1s.Date.defineInstance({

  'getWeekday': function(date) {
    return getWeekday$1(date);
  }

});

Sugar$1s.Date.getWeekday;

var Sugar$1r = sugarCore.exports;



Sugar$1r.Date.hoursAgo;

var Sugar$1q = sugarCore.exports;



Sugar$1q.Date.hoursFromNow;

var Sugar$1p = sugarCore.exports;



Sugar$1p.Date.hoursSince;

var Sugar$1o = sugarCore.exports;



Sugar$1o.Date.hoursUntil;

var setDate = setDate_1,
    getDate = getDate_1,
    getYear$1 = getYear_1,
    getMonth$1 = getMonth_1,
    getNewDate$2 = getNewDate_1;

function compareDay$1(d, shift) {
  var comp = getNewDate$2();
  if (shift) {
    setDate(comp, getDate(comp) + shift);
  }
  return getYear$1(d) === getYear$1(comp) &&
         getMonth$1(d) === getMonth$1(comp) &&
         getDate(d) === getDate(comp);
}

var compareDay_1 = compareDay$1;

var LocaleHelpers$2 = LocaleHelpers$h,
    trim = trim_1,
    getMonth = getMonth_1,
    isDefined$1 = isDefined_1,
    getNewDate$1 = getNewDate_1,
    compareDay = compareDay_1,
    getWeekday = getWeekday_1,
    dateIsValid$1 = dateIsValid_1,
    classChecks$c = classChecks$Z,
    compareDate = compareDate_1;

var isString$4 = classChecks$c.isString,
    English$1 = LocaleHelpers$2.English;

function fullCompareDate$2(date, d, margin) {
  var tmp;
  if (!dateIsValid$1(date)) return;
  if (isString$4(d)) {
    d = trim(d).toLowerCase();
    switch(true) {
      case d === 'future':    return date.getTime() > getNewDate$1().getTime();
      case d === 'past':      return date.getTime() < getNewDate$1().getTime();
      case d === 'today':     return compareDay(date);
      case d === 'tomorrow':  return compareDay(date,  1);
      case d === 'yesterday': return compareDay(date, -1);
      case d === 'weekday':   return getWeekday(date) > 0 && getWeekday(date) < 6;
      case d === 'weekend':   return getWeekday(date) === 0 || getWeekday(date) === 6;

      case (isDefined$1(tmp = English$1.weekdayMap[d])):
        return getWeekday(date) === tmp;
      case (isDefined$1(tmp = English$1.monthMap[d])):
        return getMonth(date) === tmp;
    }
  }
  return compareDate(date, d, margin);
}

var fullCompareDate_1 = fullCompareDate$2;

var Sugar$1n = sugarCore.exports,
    fullCompareDate$1 = fullCompareDate_1;

Sugar$1n.Date.defineInstance({

  'is': function(date, d, margin) {
    return fullCompareDate$1(date, d, margin);
  }

});

Sugar$1n.Date.is;

var Sugar$1m = sugarCore.exports,
    createDate$3 = createDate_1;

Sugar$1m.Date.defineInstance({

  'isAfter': function(date, d, margin) {
    return date.getTime() > createDate$3(d).getTime() - (margin || 0);
  }

});

Sugar$1m.Date.isAfter;

var Sugar$1l = sugarCore.exports,
    createDate$2 = createDate_1;

Sugar$1l.Date.defineInstance({

  'isBefore': function(date, d, margin) {
    return date.getTime() < createDate$2(d).getTime() + (margin || 0);
  }

});

Sugar$1l.Date.isBefore;

var Sugar$1k = sugarCore.exports,
    createDate$1 = createDate_1,
    mathAliases$6 = mathAliases$z;

var min$2 = mathAliases$6.min,
    max$2 = mathAliases$6.max;

Sugar$1k.Date.defineInstance({

  'isBetween': function(date, d1, d2, margin) {
    var t  = date.getTime();
    var t1 = createDate$1(d1).getTime();
    var t2 = createDate$1(d2).getTime();
    var lo = min$2(t1, t2);
    var hi = max$2(t1, t2);
    margin = margin || 0;
    return (lo - margin <= t) && (hi + margin >= t);
  }

});

Sugar$1k.Date.isBetween;

var LocaleHelpers$1 = LocaleHelpers$h,
    spaceSplit = spaceSplit_1,
    fullCompareDate = fullCompareDate_1,
    namespaceAliases$2 = namespaceAliases$e,
    defineInstanceSimilar = defineInstanceSimilar_1;

var English = LocaleHelpers$1.English,
    sugarDate$2 = namespaceAliases$2.sugarDate;

function buildRelativeAliases$1() {
  var special  = spaceSplit('Today Yesterday Tomorrow Weekday Weekend Future Past');
  var weekdays = English.weekdays.slice(0, 7);
  var months   = English.months.slice(0, 12);
  var together = special.concat(weekdays).concat(months);
  defineInstanceSimilar(sugarDate$2, together, function(methods, name) {
    methods['is'+ name] = function(d) {
      return fullCompareDate(d, name);
    };
  });
}

var buildRelativeAliases_1 = buildRelativeAliases$1;

var buildRelativeAliases = buildRelativeAliases_1;

buildRelativeAliases();

var Sugar$1j = sugarCore.exports;



Sugar$1j.Date.isFriday;

var Sugar$1i = sugarCore.exports;



Sugar$1i.Date.isFuture;

var Sugar$1h = sugarCore.exports;



Sugar$1h.Date.isLastMonth;

var Sugar$1g = sugarCore.exports;



Sugar$1g.Date.isLastWeek;

var Sugar$1f = sugarCore.exports;



Sugar$1f.Date.isLastYear;

var Sugar$1e = sugarCore.exports,
    getYear = getYear_1;

Sugar$1e.Date.defineInstance({

  'isLeapYear': function(date) {
    var year = getYear(date);
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

});

Sugar$1e.Date.isLeapYear;

var Sugar$1d = sugarCore.exports;



Sugar$1d.Date.isMonday;

var Sugar$1c = sugarCore.exports;



Sugar$1c.Date.isNextMonth;

var Sugar$1b = sugarCore.exports;



Sugar$1b.Date.isNextWeek;

var Sugar$1a = sugarCore.exports;



Sugar$1a.Date.isNextYear;

var Sugar$19 = sugarCore.exports;



Sugar$19.Date.isPast;

var Sugar$18 = sugarCore.exports;



Sugar$18.Date.isSaturday;

var Sugar$17 = sugarCore.exports;



Sugar$17.Date.isSunday;

var Sugar$16 = sugarCore.exports;



Sugar$16.Date.isThisMonth;

var Sugar$15 = sugarCore.exports;



Sugar$15.Date.isThisWeek;

var Sugar$14 = sugarCore.exports;



Sugar$14.Date.isThisYear;

var Sugar$13 = sugarCore.exports;



Sugar$13.Date.isThursday;

var Sugar$12 = sugarCore.exports;



Sugar$12.Date.isToday;

var Sugar$11 = sugarCore.exports;



Sugar$11.Date.isTomorrow;

var Sugar$10 = sugarCore.exports;



Sugar$10.Date.isTuesday;

var _utc$1 = _utc$8,
    tzOffset = tzOffset_1;

function isUTC$1(d) {
  return !!_utc$1(d) || tzOffset(d) === 0;
}

var isUTC_1 = isUTC$1;

var Sugar$$ = sugarCore.exports,
    isUTC = isUTC_1;

Sugar$$.Date.defineInstance({

  'isUTC': function(date) {
    return isUTC(date);
  }

});

Sugar$$.Date.isUTC;

var Sugar$_ = sugarCore.exports,
    dateIsValid = dateIsValid_1;

Sugar$_.Date.defineInstance({

  'isValid': function(date) {
    return dateIsValid(date);
  }

});

Sugar$_.Date.isValid;

var Sugar$Z = sugarCore.exports;



Sugar$Z.Date.isWednesday;

var Sugar$Y = sugarCore.exports;



Sugar$Y.Date.isWeekday;

var Sugar$X = sugarCore.exports;



Sugar$X.Date.isWeekend;

var Sugar$W = sugarCore.exports;



Sugar$W.Date.isYesterday;

var Sugar$V = sugarCore.exports;

Sugar$V.Date.defineInstance({

  'iso': function(date) {
    return date.toISOString();
  }

});

Sugar$V.Date.iso;

var Sugar$U = sugarCore.exports;



Sugar$U.Date.millisecondsAgo;

var Sugar$T = sugarCore.exports;



Sugar$T.Date.millisecondsFromNow;

var Sugar$S = sugarCore.exports;



Sugar$S.Date.millisecondsSince;

var Sugar$R = sugarCore.exports;



Sugar$R.Date.millisecondsUntil;

var Sugar$Q = sugarCore.exports;



Sugar$Q.Date.minutesAgo;

var Sugar$P = sugarCore.exports;



Sugar$P.Date.minutesFromNow;

var Sugar$O = sugarCore.exports;



Sugar$O.Date.minutesSince;

var Sugar$N = sugarCore.exports;



Sugar$N.Date.minutesUntil;

var Sugar$M = sugarCore.exports;



Sugar$M.Date.monthsAgo;

var Sugar$L = sugarCore.exports;



Sugar$L.Date.monthsFromNow;

var Sugar$K = sugarCore.exports;



Sugar$K.Date.monthsSince;

var Sugar$J = sugarCore.exports;



Sugar$J.Date.monthsUntil;

var getNewDate = getNewDate_1,
    mathAliases$5 = mathAliases$z,
    getAdjustedUnit = getAdjustedUnit_1,
    getTimeDistanceForUnit = getTimeDistanceForUnit_1;

var abs$1 = mathAliases$5.abs;

function getAdjustedUnitForDate$1(d, dRelative) {
  var ms;
  if (!dRelative) {
    dRelative = getNewDate();
    if (d > dRelative) {
      // If our date is greater than the one that we got from getNewDate, it
      // means that we are finding the unit for a date that is in the future
      // relative to now. However, often the incoming date was created in
      // the same cycle as our comparison, but our "now" date will have been
      // created an instant after it, creating situations where "5 minutes from
      // now" becomes "4 minutes from now" in the same tick. To prevent this,
      // subtract a buffer of 10ms to compensate.
      dRelative = new Date(dRelative.getTime() - 10);
    }
  }
  ms = d - dRelative;
  return getAdjustedUnit(ms, function(u) {
    return abs$1(getTimeDistanceForUnit(d, dRelative, u));
  });
}

var getAdjustedUnitForDate_1 = getAdjustedUnitForDate$1;

var LocaleHelpers = LocaleHelpers$h,
    dateFormat = dateFormat_1,
    classChecks$b = classChecks$Z,
    assertDateIsValid = assertDateIsValid_1,
    getAdjustedUnitForDate = getAdjustedUnitForDate_1;

var isFunction$1 = classChecks$b.isFunction,
    localeManager = LocaleHelpers.localeManager;

function dateRelative$2(d, dRelative, arg1, arg2) {
  var adu, format, type, localeCode, fn;
  assertDateIsValid(d);
  if (isFunction$1(arg1)) {
    fn = arg1;
  } else {
    localeCode = arg1;
    fn = arg2;
  }
  adu = getAdjustedUnitForDate(d, dRelative);
  if (fn) {
    format = fn.apply(d, adu.concat(localeManager.get(localeCode)));
    if (format) {
      return dateFormat(d, format, localeCode);
    }
  }
  // Adjust up if time is in ms, as this doesn't
  // look very good for a standard relative date.
  if (adu[1] === 0) {
    adu[1] = 1;
    adu[0] = 1;
  }
  if (dRelative) {
    type = 'duration';
  } else if (adu[2] > 0) {
    type = 'future';
  } else {
    type = 'past';
  }
  return localeManager.get(localeCode).getRelativeFormat(adu, type);
}

var dateRelative_1 = dateRelative$2;

var Sugar$I = sugarCore.exports,
    dateRelative$1 = dateRelative_1;

Sugar$I.Date.defineInstance({

  'relative': function(date, localeCode, relativeFn) {
    return dateRelative$1(date, null, localeCode, relativeFn);
  }

});

Sugar$I.Date.relative;

var Sugar$H = sugarCore.exports,
    createDate = createDate_1,
    dateRelative = dateRelative_1;

Sugar$H.Date.defineInstance({

  'relativeTo': function(date, d, localeCode) {
    return dateRelative(date, createDate(d), localeCode);
  }

});

Sugar$H.Date.relativeTo;

var iterateOverDateParams = iterateOverDateParams_1;

function getUnitIndexForParamName$1(name) {
  var params = {}, unitIndex;
  params[name] = 1;
  iterateOverDateParams(params, function(name, val, unit, i) {
    unitIndex = i;
    return false;
  });
  return unitIndex;
}

var getUnitIndexForParamName_1 = getUnitIndexForParamName$1;

var Sugar$G = sugarCore.exports,
    DateUnitIndexes = DateUnitIndexes$i,
    moveToBeginningOfUnit = moveToBeginningOfUnit_1,
    getUnitIndexForParamName = getUnitIndexForParamName_1;

var DAY_INDEX = DateUnitIndexes.DAY_INDEX;

Sugar$G.Date.defineInstance({

  'reset': function(date, unit, localeCode) {
    var unitIndex = unit ? getUnitIndexForParamName(unit) : DAY_INDEX;
    moveToBeginningOfUnit(date, unitIndex, localeCode);
    return date;
  }

});

Sugar$G.Date.reset;

var Sugar$F = sugarCore.exports,
    advanceDateWithArgs = advanceDateWithArgs_1;

Sugar$F.Date.defineInstanceWithArguments({

  'rewind': function(d, args) {
    return advanceDateWithArgs(d, args, -1);
  }

});

Sugar$F.Date.rewind;

var Sugar$E = sugarCore.exports;



Sugar$E.Date.secondsAgo;

var Sugar$D = sugarCore.exports;



Sugar$D.Date.secondsFromNow;

var Sugar$C = sugarCore.exports;



Sugar$C.Date.secondsSince;

var Sugar$B = sugarCore.exports;



Sugar$B.Date.secondsUntil;

var Sugar$A = sugarCore.exports,
    updateDate = updateDate_1,
    collectUpdateDateArguments = collectUpdateDateArguments_1;

Sugar$A.Date.defineInstanceWithArguments({

  'set': function(d, args) {
    args = collectUpdateDateArguments(args);
    return updateDate(d, args[0], args[1]);
  }

});

Sugar$A.Date.set;

var Sugar$z = sugarCore.exports,
    setISOWeekNumber = setISOWeekNumber_1;

Sugar$z.Date.defineInstance({

  'setISOWeek': function(date, num) {
    return setISOWeekNumber(date, num);
  }

});

Sugar$z.Date.setISOWeek;

var Sugar$y = sugarCore.exports,
    _utc = _utc$8;

Sugar$y.Date.defineInstance({

  'setUTC': function(date, on) {
    return _utc(date, on);
  }

});

Sugar$y.Date.setUTC;

var Sugar$x = sugarCore.exports,
    setWeekday = setWeekday_1;

Sugar$x.Date.defineInstance({

  'setWeekday': function(date, dow) {
    return setWeekday(date, dow);
  }

});

Sugar$x.Date.setWeekday;

var Sugar$w = sugarCore.exports;



Sugar$w.Date.weeksAgo;

var Sugar$v = sugarCore.exports;



Sugar$v.Date.weeksFromNow;

var Sugar$u = sugarCore.exports;



Sugar$u.Date.weeksSince;

var Sugar$t = sugarCore.exports;



Sugar$t.Date.weeksUntil;

var Sugar$s = sugarCore.exports;



Sugar$s.Date.yearsAgo;

var Sugar$r = sugarCore.exports;



Sugar$r.Date.yearsFromNow;

var Sugar$q = sugarCore.exports;



Sugar$q.Date.yearsSince;

var Sugar$p = sugarCore.exports;



Sugar$p.Date.yearsUntil;

var Sugar$o = sugarCore.exports;

Sugar$o.Date.getOption;

var Sugar$n = sugarCore.exports;

Sugar$n.Date.setOption;

var classChecks$a = classChecks$Z;

var isDate$3 = classChecks$a.isDate;

function getRangeMemberPrimitiveValue$2(m) {
  if (m == null) return m;
  return isDate$3(m) ? m.getTime() : m.valueOf();
}

var getRangeMemberPrimitiveValue_1 = getRangeMemberPrimitiveValue$2;

var classChecks$9 = classChecks$Z,
    getRangeMemberPrimitiveValue$1 = getRangeMemberPrimitiveValue_1;

var isDate$2 = classChecks$9.isDate;

function cloneRangeMember$2(m) {
  if (isDate$2(m)) {
    return new Date(m.getTime());
  } else {
    return getRangeMemberPrimitiveValue$1(m);
  }
}

var cloneRangeMember_1 = cloneRangeMember$2;

var cloneRangeMember$1 = cloneRangeMember_1;

function Range$h(start, end) {
  this.start = cloneRangeMember$1(start);
  this.end   = cloneRangeMember$1(end);
}

var Range_1 = Range$h;

var classChecks$8 = classChecks$Z,
    namespaceAliases$1 = namespaceAliases$e;

var isDate$1 = classChecks$8.isDate,
    sugarDate$1 = namespaceAliases$1.sugarDate;

function getDateForRange$2(d) {
  if (isDate$1(d)) {
    return d;
  } else if (d == null) {
    return new Date();
  } else if (sugarDate$1.create) {
    return sugarDate$1.create(d);
  }
  return new Date(d);
}

var getDateForRange_1 = getDateForRange$2;

var DURATION_UNITS$3 = 'year|month|week|day|hour|minute|second|millisecond';

var DURATION_UNITS$2 = DURATION_UNITS$3;

var FULL_CAPTURED_DURATION$1 = '((?:\\d+)?\\s*(?:' + DURATION_UNITS$2 + '))s?';

var FULL_CAPTURED_DURATION = FULL_CAPTURED_DURATION$1;

var DurationTextFormats$1 = {
  RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
  RANGE_REG_REAR_DURATION: RegExp('(.+)\\s*for\\s*' + FULL_CAPTURED_DURATION, 'i'),
  RANGE_REG_FRONT_DURATION: RegExp('(?:for)?\\s*'+ FULL_CAPTURED_DURATION +'\\s*(?:starting)?\\s(?:at\\s)?(.+)', 'i')
};

var MULTIPLIERS$2 = {
  'Hours': 60 * 60 * 1000,
  'Minutes': 60 * 1000,
  'Seconds': 1000,
  'Milliseconds': 1
};

var MULTIPLIERS_1 = MULTIPLIERS$2;

var MULTIPLIERS$1 = MULTIPLIERS_1,
    callDateSet = callDateSet_1,
    callDateGet = callDateGet_1;

function incrementDate$2(src, amount, unit) {
  var mult = MULTIPLIERS$1[unit], d;
  if (mult) {
    d = new Date(src.getTime() + (amount * mult));
  } else {
    d = new Date(src);
    callDateSet(d, unit, callDateGet(src, unit) + amount);
  }
  return d;
}

var incrementDate_1 = incrementDate$2;

var DURATION_UNITS$1 = DURATION_UNITS$3;

var DURATION_REG$1 = RegExp('(\\d+)?\\s*('+ DURATION_UNITS$1 +')s?', 'i');

var DURATION_REG = DURATION_REG$1,
    classChecks$7 = classChecks$Z,
    simpleCapitalize$1 = simpleCapitalize_1;

var isNumber$4 = classChecks$7.isNumber;

function getDateIncrementObject$2(amt) {
  var match, val, unit;
  if (isNumber$4(amt)) {
    return [amt, 'Milliseconds'];
  }
  match = amt.match(DURATION_REG);
  val = +match[1] || 1;
  unit = simpleCapitalize$1(match[2].toLowerCase());
  if (unit.match(/hour|minute|second/i)) {
    unit += 's';
  } else if (unit === 'Year') {
    unit = 'FullYear';
  } else if (unit === 'Week') {
    unit = 'Date';
    val *= 7;
  } else if (unit === 'Day') {
    unit = 'Date';
  }
  return [val, unit];
}

var getDateIncrementObject_1 = getDateIncrementObject$2;

var Range$g = Range_1,
    DurationTextFormats = DurationTextFormats$1,
    incrementDate$1 = incrementDate_1,
    getDateForRange$1 = getDateForRange_1,
    namespaceAliases = namespaceAliases$e,
    getDateIncrementObject$1 = getDateIncrementObject_1;

var sugarDate = namespaceAliases.sugarDate,
    RANGE_REG_FROM_TO = DurationTextFormats.RANGE_REG_FROM_TO,
    RANGE_REG_REAR_DURATION = DurationTextFormats.RANGE_REG_REAR_DURATION,
    RANGE_REG_FRONT_DURATION = DurationTextFormats.RANGE_REG_FRONT_DURATION;

function createDateRangeFromString$1(str) {
  var match, datetime, duration, dio, start, end;
  if (sugarDate.get && (match = str.match(RANGE_REG_FROM_TO))) {
    start = getDateForRange$1(match[1].replace('from', 'at'));
    end = sugarDate.get(start, match[2]);
    return new Range$g(start, end);
  }
  if (match = str.match(RANGE_REG_FRONT_DURATION)) {
    duration = match[1];
    datetime = match[2];
  }
  if (match = str.match(RANGE_REG_REAR_DURATION)) {
    datetime = match[1];
    duration = match[2];
  }
  if (datetime && duration) {
    start = getDateForRange$1(datetime);
    dio = getDateIncrementObject$1(duration);
    end = incrementDate$1(start, dio[0], dio[1]);
  } else {
    start = str;
  }
  return new Range$g(getDateForRange$1(start), getDateForRange$1(end));
}

var createDateRangeFromString_1 = createDateRangeFromString$1;

var Range$f = Range_1,
    classChecks$6 = classChecks$Z,
    getDateForRange = getDateForRange_1,
    createDateRangeFromString = createDateRangeFromString_1;

var isString$3 = classChecks$6.isString;

var DateRangeConstructor$1 = function(start, end) {
  if (arguments.length === 1 && isString$3(start)) {
    return createDateRangeFromString(start);
  }
  return new Range$f(getDateForRange(start), getDateForRange(end));
};

var DateRangeConstructor_1 = DateRangeConstructor$1;

var Sugar$m = sugarCore.exports,
    DateRangeConstructor = DateRangeConstructor_1;

Sugar$m.Date.defineStatic({

  'range': DateRangeConstructor

});

Sugar$m.Date.range;

var Range$e = Range_1;

var PrimitiveRangeConstructor$2 = function(start, end) {
  return new Range$e(start, end);
};

var PrimitiveRangeConstructor_1 = PrimitiveRangeConstructor$2;

var Sugar$l = sugarCore.exports,
    PrimitiveRangeConstructor$1 = PrimitiveRangeConstructor_1;

Sugar$l.Number.defineStatic({

  'range': PrimitiveRangeConstructor$1

});

Sugar$l.Number.range;

var Sugar$k = sugarCore.exports,
    PrimitiveRangeConstructor = PrimitiveRangeConstructor_1;

Sugar$k.String.defineStatic({

  'range': PrimitiveRangeConstructor

});

Sugar$k.String.range;

var cloneRangeMember = cloneRangeMember_1;

function rangeClamp$3(range, obj) {
  var clamped,
      start = range.start,
      end = range.end,
      min = end < start ? end : start,
      max = start > end ? start : end;
  if (obj < min) {
    clamped = min;
  } else if (obj > max) {
    clamped = max;
  } else {
    clamped = obj;
  }
  return cloneRangeMember(clamped);
}

var rangeClamp_1 = rangeClamp$3;

var Sugar$j = sugarCore.exports,
    Range$d = Range_1,
    rangeClamp$2 = rangeClamp_1;

Sugar$j.Number.defineInstance({

  'cap': function(n, max) {
    return rangeClamp$2(new Range$d(undefined, max), n);
  }

});

Sugar$j.Number.cap;

var Sugar$i = sugarCore.exports,
    Range$c = Range_1,
    rangeClamp$1 = rangeClamp_1;

Sugar$i.Number.defineInstance({

  'clamp': function(n, start, end) {
    return rangeClamp$1(new Range$c(start, end), n);
  }

});

Sugar$i.Number.clamp;

function valueIsNotInfinite$1(m) {
  return m !== -Infinity && m !== Infinity;
}

var valueIsNotInfinite_1 = valueIsNotInfinite$1;

var valueIsNotInfinite = valueIsNotInfinite_1,
    getRangeMemberPrimitiveValue = getRangeMemberPrimitiveValue_1;

function isValidRangeMember$1(m) {
  var val = getRangeMemberPrimitiveValue(m);
  return (!!val || val === 0) && valueIsNotInfinite(m);
}

var isValidRangeMember_1 = isValidRangeMember$1;

var isValidRangeMember = isValidRangeMember_1;

function rangeIsValid$4(range) {
  return isValidRangeMember(range.start) &&
         isValidRangeMember(range.end) &&
         typeof range.start === typeof range.end;
}

var rangeIsValid_1 = rangeIsValid$4;

var withPrecision = withPrecision_1;

function incrementNumber$1(current, amount, precision) {
  return withPrecision(current + amount, precision);
}

var incrementNumber_1 = incrementNumber$1;

var chr = chr$6;

function incrementString$1(current, amount) {
  return chr(current.charCodeAt(0) + amount);
}

var incrementString_1 = incrementString$1;

var periodSplit = periodSplit_1;

function getPrecision$1(n) {
  var split = periodSplit(n.toString());
  return split[1] ? split[1].length : 0;
}

var getPrecision_1 = getPrecision$1;

var mathAliases$4 = mathAliases$z,
    getPrecision = getPrecision_1;

var max$1 = mathAliases$4.max;

function getGreaterPrecision$1(n1, n2) {
  return max$1(getPrecision(n1), getPrecision(n2));
}

var getGreaterPrecision_1 = getGreaterPrecision$1;

var classChecks$5 = classChecks$Z,
    rangeIsValid$3 = rangeIsValid_1,
    incrementDate = incrementDate_1,
    incrementNumber = incrementNumber_1,
    incrementString = incrementString_1,
    getGreaterPrecision = getGreaterPrecision_1,
    getDateIncrementObject = getDateIncrementObject_1;

var isNumber$3 = classChecks$5.isNumber,
    isString$2 = classChecks$5.isString,
    isDate = classChecks$5.isDate,
    isFunction = classChecks$5.isFunction;

function rangeEvery$4(range, step, countOnly, fn) {
  var increment,
      precision,
      dio,
      unit,
      start   = range.start,
      end     = range.end,
      inverse = end < start,
      current = start,
      index   = 0,
      result  = [];

  if (!rangeIsValid$3(range)) {
    return countOnly ? NaN : [];
  }
  if (isFunction(step)) {
    fn = step;
    step = null;
  }
  step = step || 1;
  if (isNumber$3(start)) {
    precision = getGreaterPrecision(start, step);
    increment = function() {
      return incrementNumber(current, step, precision);
    };
  } else if (isString$2(start)) {
    increment = function() {
      return incrementString(current, step);
    };
  } else if (isDate(start)) {
    dio  = getDateIncrementObject(step);
    step = dio[0];
    unit = dio[1];
    increment = function() {
      return incrementDate(current, step, unit);
    };
  }
  // Avoiding infinite loops
  if (inverse && step > 0) {
    step *= -1;
  }
  while(inverse ? current >= end : current <= end) {
    if (!countOnly) {
      result.push(current);
    }
    if (fn) {
      fn(current, index, range);
    }
    current = increment();
    index++;
  }
  return countOnly ? index - 1 : result;
}

var rangeEvery_1 = rangeEvery$4;

var Sugar$h = sugarCore.exports,
    Range$b = Range_1,
    rangeEvery$3 = rangeEvery_1;

Sugar$h.Number.defineInstance({

  'upto': function(n, num, step, everyFn) {
    return rangeEvery$3(new Range$b(n, num), step, false, everyFn);
  }

});

Sugar$h.Number.upto;

var coreUtilityAliases$1 = coreUtilityAliases$M;

var forEachProperty = coreUtilityAliases$1.forEachProperty;

function defineOnPrototype$b(ctor, methods) {
  var proto = ctor.prototype;
  forEachProperty(methods, function(val, key) {
    proto[key] = val;
  });
}

var defineOnPrototype_1 = defineOnPrototype$b;

var Range$a = Range_1,
    rangeClamp = rangeClamp_1,
    defineOnPrototype$a = defineOnPrototype_1;

defineOnPrototype$a(Range$a, {

  'clamp': function(el) {
    return rangeClamp(this, el);
  }

});

var Range$9 = Range_1,
    defineOnPrototype$9 = defineOnPrototype_1;

defineOnPrototype$9(Range$9, {

  'clone': function() {
    return new Range$9(this.start, this.end);
  }

});

var Range$8 = Range_1,
    defineOnPrototype$8 = defineOnPrototype_1;

defineOnPrototype$8(Range$8, {

  'contains': function(el) {
    if (el == null) return false;
    if (el.start && el.end) {
      return el.start >= this.start && el.start <= this.end &&
             el.end   >= this.start && el.end   <= this.end;
    } else {
      return el >= this.start && el <= this.end;
    }
  }

});

var MULTIPLIERS = MULTIPLIERS_1,
    DURATION_UNITS = DURATION_UNITS$3,
    Range$7 = Range_1,
    trunc = trunc_1,
    forEach = forEach_1,
    rangeEvery$2 = rangeEvery_1,
    simpleCapitalize = simpleCapitalize_1,
    defineOnPrototype$7 = defineOnPrototype_1;

function buildDateRangeUnits$1() {
  var methods = {};
  forEach(DURATION_UNITS.split('|'), function(unit, i) {
    var name = unit + 's', mult, fn;
    if (i < 4) {
      fn = function() {
        return rangeEvery$2(this, unit, true);
      };
    } else {
      mult = MULTIPLIERS[simpleCapitalize(name)];
      fn = function() {
        return trunc((this.end - this.start) / mult);
      };
    }
    methods[name] = fn;
  });
  defineOnPrototype$7(Range$7, methods);
}

var buildDateRangeUnits_1 = buildDateRangeUnits$1;

var buildDateRangeUnits = buildDateRangeUnits_1;

buildDateRangeUnits();

var Range$6 = Range_1,
    rangeEvery$1 = rangeEvery_1,
    defineOnPrototype$6 = defineOnPrototype_1;

defineOnPrototype$6(Range$6, {

  'every': function(amount, everyFn) {
    return rangeEvery$1(this, amount, false, everyFn);
  }

});

var Range$5 = Range_1,
    defineOnPrototype$5 = defineOnPrototype_1;

defineOnPrototype$5(Range$5, {

  'intersect': function(range) {
    if (range.start > this.end || range.end < this.start) {
      return new Range$5(NaN, NaN);
    }
    return new Range$5(
      this.start > range.start ? this.start : range.start,
      this.end   < range.end   ? this.end   : range.end
    );
  }

});

var Range$4 = Range_1,
    rangeIsValid$2 = rangeIsValid_1,
    defineOnPrototype$4 = defineOnPrototype_1;

defineOnPrototype$4(Range$4, {

  'isValid': function() {
    return rangeIsValid$2(this);
  }

});

var classChecks$4 = classChecks$Z;

var isString$1 = classChecks$4.isString;

function getRangeMemberNumericValue$1(m) {
  return isString$1(m) ? m.charCodeAt(0) : m;
}

var getRangeMemberNumericValue_1 = getRangeMemberNumericValue$1;

var Range$3 = Range_1,
    mathAliases$3 = mathAliases$z,
    rangeIsValid$1 = rangeIsValid_1,
    defineOnPrototype$3 = defineOnPrototype_1,
    getRangeMemberNumericValue = getRangeMemberNumericValue_1;

var abs = mathAliases$3.abs;

defineOnPrototype$3(Range$3, {

  'span': function() {
    var n = getRangeMemberNumericValue(this.end) - getRangeMemberNumericValue(this.start);
    return rangeIsValid$1(this) ? abs(n) + 1 : NaN;
  }

});

var Range$2 = Range_1,
    rangeEvery = rangeEvery_1,
    defineOnPrototype$2 = defineOnPrototype_1;

defineOnPrototype$2(Range$2, {

  'toArray': function() {
    return rangeEvery(this);
  }

});

var Range$1 = Range_1,
    rangeIsValid = rangeIsValid_1,
    defineOnPrototype$1 = defineOnPrototype_1;

defineOnPrototype$1(Range$1, {

  'toString': function() {
    return rangeIsValid(this) ? this.start + '..' + this.end : 'Invalid Range';
  }

});

var Range = Range_1,
    defineOnPrototype = defineOnPrototype_1;

defineOnPrototype(Range, {

  'union': function(range) {
    return new Range(
      this.start < range.start ? this.start : range.start,
      this.end   > range.end   ? this.end   : range.end
    );
  }

});

var Sugar$g = sugarCore.exports;

Sugar$g.Number.alias('downto', 'upto');

Sugar$g.Number.downto;

var Sugar$f = sugarCore.exports,
    coercePositiveInteger$1 = coercePositiveInteger_1;

Sugar$f.Function.defineInstance({

  'after': function(fn, num) {
    var count = 0, collectedArgs = [];
    num = coercePositiveInteger$1(num);
    return function() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      collectedArgs.push(args);
      count++;
      if (count >= num) {
        return fn.call(this, collectedArgs);
      }
    };
  }

});

Sugar$f.Function.after;

var privatePropertyAccessor$3 = privatePropertyAccessor_1;

var _timers$2 = privatePropertyAccessor$3('timers');

var privatePropertyAccessor$2 = privatePropertyAccessor_1;

var _canceled$2 = privatePropertyAccessor$2('canceled');

var _timers$1 = _timers$2,
    _canceled$1 = _canceled$2,
    classChecks$3 = classChecks$Z;

var isArray = classChecks$3.isArray;

function cancelFunction$2(fn) {
  var timers = _timers$1(fn), timer;
  if (isArray(timers)) {
    while(timer = timers.shift()) {
      clearTimeout(timer);
    }
  }
  _canceled$1(fn, true);
  return fn;
}

var cancelFunction_1 = cancelFunction$2;

var Sugar$e = sugarCore.exports,
    cancelFunction$1 = cancelFunction_1;

Sugar$e.Function.defineInstance({

  'cancel': function(fn) {
    return cancelFunction$1(fn);
  }

});

Sugar$e.Function.cancel;

var _timers = _timers$2,
    _canceled = _canceled$2,
    coercePositiveInteger = coercePositiveInteger_1;

function setDelay$4(fn, ms, after, scope, args) {
  // Delay of infinity is never called of course...
  ms = coercePositiveInteger(ms || 0);
  if (!_timers(fn)) {
    _timers(fn, []);
  }
  // This is a workaround for <= IE8, which apparently has the
  // ability to call timeouts in the queue on the same tick (ms?)
  // even if functionally they have already been cleared.
  _canceled(fn, false);
  _timers(fn).push(setTimeout(function() {
    if (!_canceled(fn)) {
      after.apply(scope, args || []);
    }
  }, ms));
}

var setDelay_1 = setDelay$4;

var Sugar$d = sugarCore.exports,
    setDelay$3 = setDelay_1,
    cancelFunction = cancelFunction_1;

Sugar$d.Function.defineInstance({

  'debounce': function(fn, ms) {
    function debounced() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      cancelFunction(debounced);
      setDelay$3(debounced, ms, fn, this, args);
    }
    return debounced;
  }

});

Sugar$d.Function.debounce;

var Sugar$c = sugarCore.exports,
    setDelay$2 = setDelay_1;

Sugar$c.Function.defineInstanceWithArguments({

  'delay': function(fn, ms, args) {
    setDelay$2(fn, ms, fn, fn, args);
    return fn;
  }

});

Sugar$c.Function.delay;

var Sugar$b = sugarCore.exports,
    setDelay$1 = setDelay_1;

Sugar$b.Function.defineInstanceWithArguments({

  'every': function(fn, ms, args) {
    function execute () {
      // Set the delay first here, so that cancel
      // can be called within the executing function.
      setDelay$1(fn, ms, execute);
      fn.apply(fn, args);
    }
    setDelay$1(fn, ms, execute);
    return fn;
  }

});

Sugar$b.Function.every;

var setDelay = setDelay_1,
    mathAliases$2 = mathAliases$z;

var max = mathAliases$2.max,
    ceil = mathAliases$2.ceil,
    round = mathAliases$2.round;

function createLazyFunction$2(fn, ms, immediate, limit) {
  var queue = [], locked = false, execute, rounded, perExecution, result;
  ms = ms || 1;
  limit = limit || Infinity;
  rounded = ceil(ms);
  perExecution = round(rounded / ms) || 1;
  execute = function() {
    var queueLength = queue.length, maxPerRound;
    if (queueLength == 0) return;
    // Allow fractions of a millisecond by calling
    // multiple times per actual timeout execution
    maxPerRound = max(queueLength - perExecution, 0);
    while(queueLength > maxPerRound) {
      // Getting uber-meta here...
      result = Function.prototype.apply.apply(fn, queue.shift());
      queueLength--;
    }
    setDelay(lazy, rounded, function() {
      locked = false;
      execute();
    });
  };
  function lazy() {
    // If the execution has locked and it's immediate, then
    // allow 1 less in the queue as 1 call has already taken place.
    if (queue.length < limit - (locked && immediate ? 1 : 0)) {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      queue.push([this, args]);
    }
    if (!locked) {
      locked = true;
      if (immediate) {
        execute();
      } else {
        setDelay(lazy, rounded, execute);
      }
    }
    // Return the memoized result
    return result;
  }
  return lazy;
}

var createLazyFunction_1 = createLazyFunction$2;

var Sugar$a = sugarCore.exports,
    createLazyFunction$1 = createLazyFunction_1;

Sugar$a.Function.defineInstance({

  'lazy': function(fn, ms, immediate, limit) {
    return createLazyFunction$1(fn, ms, immediate, limit);
  }

});

Sugar$a.Function.lazy;

var privatePropertyAccessor$1 = privatePropertyAccessor_1;

var _lock$2 = privatePropertyAccessor$1('lock');

var privatePropertyAccessor = privatePropertyAccessor_1;

var _partial$2 = privatePropertyAccessor('partial');

var Sugar$9 = sugarCore.exports,
    _lock$1 = _lock$2,
    _partial$1 = _partial$2,
    classChecks$2 = classChecks$Z,
    mathAliases$1 = mathAliases$z;

var isNumber$2 = classChecks$2.isNumber,
    min$1 = mathAliases$1.min;

Sugar$9.Function.defineInstance({

  'lock': function(fn, n) {
    var lockedFn;
    if (_partial$1(fn)) {
      _lock$1(fn, isNumber$2(n) ? n : null);
      return fn;
    }
    lockedFn = function() {
      arguments.length = min$1(_lock$1(lockedFn), arguments.length);
      return fn.apply(this, arguments);
    };
    _lock$1(lockedFn, isNumber$2(n) ? n : fn.length);
    return lockedFn;
  }

});

Sugar$9.Function.lock;

function collectArguments$1() {
  var args = arguments, i = args.length, arr = new Array(i);
  while (i--) {
    arr[i] = args[i];
  }
  return arr;
}

var collectArguments_1 = collectArguments$1;

var serializeInternal = serializeInternal_1,
    coreUtilityAliases = coreUtilityAliases$M;

var hasOwn = coreUtilityAliases.hasOwn,
    getOwn = coreUtilityAliases.getOwn;

function createHashedMemoizeFunction$1(fn, hashFn, limit) {
  var map = {}, refs = [], counter = 0;
  return function() {
    var hashObj = hashFn.apply(this, arguments);
    var key = serializeInternal(hashObj, refs);
    if (hasOwn(map, key)) {
      return getOwn(map, key);
    }
    if (counter === limit) {
      map = {};
      refs = [];
      counter = 0;
    }
    counter++;
    return map[key] = fn.apply(this, arguments);
  };
}

var createHashedMemoizeFunction_1 = createHashedMemoizeFunction$1;

var Sugar$8 = sugarCore.exports,
    classChecks$1 = classChecks$Z,
    deepGetProperty = deepGetProperty_1,
    collectArguments = collectArguments_1,
    createHashedMemoizeFunction = createHashedMemoizeFunction_1;

var isNumber$1 = classChecks$1.isNumber,
    isString = classChecks$1.isString;

Sugar$8.Function.defineInstance({

  'memoize': function(fn, arg1, arg2) {
    var hashFn, limit, prop;
    if (isNumber$1(arg1)) {
      limit = arg1;
    } else {
      hashFn = arg1;
      limit  = arg2;
    }
    if (isString(hashFn)) {
      prop = hashFn;
      hashFn = function(obj) {
        return deepGetProperty(obj, prop);
      };
    } else if (!hashFn) {
      hashFn = collectArguments;
    }
    return createHashedMemoizeFunction(fn, hashFn, limit);
  }

});

Sugar$8.Function.memoize;

var Sugar$7 = sugarCore.exports;

Sugar$7.Function.defineInstance({

  'once': function(fn) {
    var called = false, val;
    return function() {
      if (called) {
        return val;
      }
      called = true;
      return val = fn.apply(this, arguments);
    };
  }

});

Sugar$7.Function.once;

var createInstanceFromPrototype$1 = Object.create || function(prototype) {
  var ctor = function() {};
  ctor.prototype = prototype;
  return new ctor;
};

var createInstanceFromPrototype_1 = createInstanceFromPrototype$1;

var Sugar$6 = sugarCore.exports,
    _lock = _lock$2,
    _partial = _partial$2,
    isDefined = isDefined_1,
    classChecks = classChecks$Z,
    mathAliases = mathAliases$z,
    isObjectType = isObjectType_1,
    createInstanceFromPrototype = createInstanceFromPrototype_1;

var isNumber = classChecks.isNumber,
    min = mathAliases.min;

Sugar$6.Function.defineInstanceWithArguments({

  'partial': function(fn, curriedArgs) {
    var curriedLen = curriedArgs.length;
    var partialFn = function() {
      var argIndex = 0, applyArgs = [], self = this, lock = _lock(partialFn), result, i;
      for (i = 0; i < curriedLen; i++) {
        var arg = curriedArgs[i];
        if (isDefined(arg)) {
          applyArgs[i] = arg;
        } else {
          applyArgs[i] = arguments[argIndex++];
        }
      }
      for (i = argIndex; i < arguments.length; i++) {
        applyArgs.push(arguments[i]);
      }
      if (lock === null) {
        lock = curriedLen;
      }
      if (isNumber(lock)) {
        applyArgs.length = min(applyArgs.length, lock);
      }
      // If the bound "this" object is an instance of the partialed
      // function, then "new" was used, so preserve the prototype
      // so that constructor functions can also be partialed.
      if (self instanceof partialFn) {
        self = createInstanceFromPrototype(fn.prototype);
        result = fn.apply(self, applyArgs);
        // An explicit return value is allowed from constructors
        // as long as they are of "object" type, so return the
        // correct result here accordingly.
        return isObjectType(result) ? result : self;
      }
      return fn.apply(self, applyArgs);
    };
    _partial(partialFn, true);
    return partialFn;
  }

});

Sugar$6.Function.partial;

var Sugar$5 = sugarCore.exports,
    createLazyFunction = createLazyFunction_1;

Sugar$5.Function.defineInstance({

  'throttle': function(fn, ms) {
    return createLazyFunction(fn, ms, true, 1);
  }

});

Sugar$5.Function.throttle;

var Sugar$4 = sugarCore.exports,
    escapeRegExp = escapeRegExp_1;

Sugar$4.RegExp.defineStatic({

  'escape': function(str) {
    return escapeRegExp(str);
  }

});

Sugar$4.RegExp.escape;

var Sugar$3 = sugarCore.exports,
    getRegExpFlags$2 = getRegExpFlags_1;

Sugar$3.RegExp.defineInstance({

  'addFlags': function(r, flags) {
    return RegExp(r.source, getRegExpFlags$2(r, flags));
  }

});

Sugar$3.RegExp.addFlags;

var Sugar$2 = sugarCore.exports,
    getRegExpFlags$1 = getRegExpFlags_1;

Sugar$2.RegExp.defineInstance({

  'getFlags': function(r) {
    return getRegExpFlags$1(r);
  }

});

Sugar$2.RegExp.getFlags;

var Sugar$1 = sugarCore.exports,
    allCharsReg = allCharsReg_1,
    getRegExpFlags = getRegExpFlags_1;

Sugar$1.RegExp.defineInstance({

  'removeFlags': function(r, flags) {
    var reg = allCharsReg(flags);
    return RegExp(r.source, getRegExpFlags(r).replace(reg, ''));
  }

});

Sugar$1.RegExp.removeFlags;

var Sugar = sugarCore.exports;

Sugar.RegExp.defineInstance({

  'setFlags': function(r, flags) {
    return RegExp(r.source, flags);
  }

});

Sugar.RegExp.setFlags;

var BASE_API_URL = '/profilemanagement/api/v1.0';
var API_URLS = {
  loyaltyNumberFinder: "".concat(BASE_API_URL, "/profiles/loyaltynumber/finder"),
  Ships: "".concat(BASE_API_URL, "/ships/lookup"),
  States: "".concat(BASE_API_URL, "/states/states")
};
var FOUND = 'Found';
var NOTFOUND = 'NotFound';
var FOUNDMULTIPLE = 'FoundMultiple';
var DOB_DAY = 'dobDay';
var DOB_MONTH = 'dobMonth';
var DOB_YEAR = 'dobYear';
var STATE_RESIDENCE = 'stateResidence';
var SHIP_CODE = 'shipCode';

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal$1));
}(lodash, lodash.exports));

var _ = lodash.exports;

var profileRequestVifpFound = {
  firstName: 'INTEGRATIONTEST',
  lastName: 'INTEGRATIONTEST',
  dobDay: '1',
  dobMonth: '1',
  dobYear: '1930'
};

var profileFinderApiResponseVifpFound = {
  loyaltyNumber: 1111111,
  result: 'Found'
};

function getLoyaltyNumberMock() {
  return new Promise(function (resolve) {
    return resolve(profileFinderApiResponseVifpFound);
  });
}

function getLoyaltyNumber(dtoGuestPastNumber) {
  var opts = {
    method: 'GET',
    headers: new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    })
  };
  var apiUrlAndData = API_URLS.loyaltyNumberFinder + '?' + dtoGuesPastNumberToFormData(dtoGuestPastNumber);
  return _.isEqual(dtoGuestPastNumber, profileRequestVifpFound) ? getLoyaltyNumberMock() : cclFetch(apiUrlAndData, opts);
}

function dtoGuesPastNumberToFormData(dtoGuestPastNumber) {
  var formdata = '';
  Object.entries(dtoGuestPastNumber).forEach(function (prop) {
    var _a;

    var key = prop[0];
    var value = (_a = prop[1]) !== null && _a !== void 0 ? _a : '';
    formdata += key + '=' + value + '&';
  });
  return formdata;
}

var CustomInput = Ae(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$1(["\n    ", "\n    ", "\n    width: ", ";\n    ", ";  \n    border-radius: 4px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\";     \n    padding: var(--spacing_token_s); \n"], ["\n    ", "\n    ", "\n    width: ", ";\n    ", ";  \n    border-radius: 4px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\";     \n    padding: var(--spacing_token_s); \n"])), Border1pxGray, OpensansBoldTundora14px, function (props) {
  return props.$showOnLegacyApps ? '93%' : '100%';
}, function (props) {
  return !props.$showOnLegacyApps && "\n      height: 48px;\n    ";
});
var CustomBorderErrorStyle = Ae(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject$1(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) {
  return props.hasError && "\n    border: solid 1px var(--crimson);\n  ";
});
var CustomColorErrorStyle = Ae(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject$1(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) {
  return props.hasError && "\n    color: var(--crimson);\n  ";
});
var templateObject_1$3, templateObject_2$3, templateObject_3$2;

var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.667c-3.866 0-7 3.13-7 6.99 0 3.86 3.134 6.989 7 6.989s7-3.129 7-6.99c0-3.858-3.134-6.989-7-6.989Zm0 12.626A5.637 5.637 0 1 1 8 3.02a5.638 5.638 0 1 1 0 11.273Zm0-9.526a1.185 1.185 0 1 1 .002 2.37A1.185 1.185 0 0 1 8 4.766Zm1.58 7.159a.338.338 0 0 1-.338.338H6.758a.338.338 0 0 1-.339-.338v-.677c0-.187.152-.338.34-.338h.338V9.107h-.339a.338.338 0 0 1-.339-.338v-.676c0-.187.152-.338.34-.338h1.806c.187 0 .338.15.338.338v2.818h.339c.187 0 .339.152.339.338v.677Z",
    fill: "#10559A"
  })));
};

var Description = styled.p(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$1(["\n  ", "\n  width: 100%;\n  min-height: 36px;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0px;\n"], ["\n  ", "\n  width: 100%;\n  min-height: 36px;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0px;\n"])), OpensansNormalTundora14px);
styled.input(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$1(["\n    ", "\n    ", "\n    ", "   \n"], ["\n    ", "\n    ", "\n    ", "   \n"])), CustomInput, CustomBorderErrorStyle, CustomColorErrorStyle);
styled.input(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject$1(["\n   ", "  \n   ", "\n   ", "\n"], ["\n   ", "  \n   ", "\n   ", "\n"])), CustomInput, CustomBorderErrorStyle, CustomColorErrorStyle);
var DateOfBirth = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject$1(["\n  position: relative;\n  display: grid;\n  width: 100%;\n  grid-auto-flow: column;\n  grid-template-columns: repeat(8, 1fr);\n  grid-row-gap: var(--spacing_token_s);\n  grid-column-gap: var(--spacing_token_xs);\n"], ["\n  position: relative;\n  display: grid;\n  width: 100%;\n  grid-auto-flow: column;\n  grid-template-columns: repeat(8, 1fr);\n  grid-row-gap: var(--spacing_token_s);\n  grid-column-gap: var(--spacing_token_xs);\n"])));
var MonthField = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject$1(["\n  grid-column-start: 1;\n  grid-column-end: span 4;\n  position: relative;\n"], ["\n  grid-column-start: 1;\n  grid-column-end: span 4;\n  position: relative;\n"])));
var DayField = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject$1([" \n  grid-column-end: span 2;\n  position: relative;\n\n  ", " {\n    grid-row-start: 1; \n    grid-column-end: span 3;\n  }\n"], [" \n  grid-column-end: span 2;\n  position: relative;\n\n  ", " {\n    grid-row-start: 1; \n    grid-column-end: span 3;\n  }\n"])), styledBreakpoints.down("md"));
var YearField = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject$1(["  \n  grid-column-end: span 2;\n  position: relative;   \n\n  ", " {\n    grid-row-start: 2;\n    grid-column-start: 1;\n    grid-column-end: span 3;\n  }\n"], ["  \n  grid-column-end: span 2;\n  position: relative;   \n\n  ", " {\n    grid-row-start: 2;\n    grid-column-start: 1;\n    grid-column-end: span 3;\n  }\n"])), styledBreakpoints.down("md"));
var Button = styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject$1(["\n  height: 48px;\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: 295px;\n  background-color: var(--la-palma);\n  border-radius: 4px;\n  border-width: 0px;\n"], ["\n  height: 48px;\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: 295px;\n  background-color: var(--la-palma);\n  border-radius: 4px;\n  border-width: 0px;\n"])));
var Title = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject$1(["\n  ", "\n  min-height: 22px;\n  min-width: 49px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 22px;\n  white-space: nowrap;\n"], ["\n  ", "\n  min-height: 22px;\n  min-width: 49px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 22px;\n  white-space: nowrap;\n"])), TempostdHeavycondensedNormalWhite18);
styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject$1(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
var FormWrapper = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject$1(["\n  width: ", ";\n  padding: var(--spacing_token_m) 0 0;\n  \n  ", " {\n    padding: var(--spacing_token_m) 56px 0;\n  }\n"], ["\n  width: ", ";\n  padding: var(--spacing_token_m) 0 0;\n  \n  ", " {\n    padding: var(--spacing_token_m) 56px 0;\n  }\n"])), function (props) {
  return props.$showOnLegacyApps ? 'auto' : '100%';
}, styledBreakpoints.up("xl"));
var Spacing$1 = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject$1(["\n  padding: var(--spacing_token_s) 0  var(--spacing_token_xs);\n"], ["\n  padding: var(--spacing_token_s) 0  var(--spacing_token_xs);\n"])));
var CreateAccount = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject$1(["\n  max-width: 440px;\n  margin-top: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  min-height: 44px;\n  flex-wrap: wrap;\n"], ["\n  max-width: 440px;\n  margin-top: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  min-height: 44px;\n  flex-wrap: wrap;\n"])));
var FinePrint = styled.p(templateObject_14 || (templateObject_14 = __makeTemplateObject$1(["\n  ", "\n  min-height: 18px;\n  letter-spacing: 0;\n  line-height: 18px;\n  white-space: nowrap;\n  padding-right: var(--spacing_token_xxs);\n  ", " {\n    padding-right: var(--spacing_token_xs);\n  }\n"], ["\n  ", "\n  min-height: 18px;\n  letter-spacing: 0;\n  line-height: 18px;\n  white-space: nowrap;\n  padding-right: var(--spacing_token_xxs);\n  ", " {\n    padding-right: var(--spacing_token_xs);\n  }\n"])), OpensansNormalTundora14px, styledBreakpoints.up("sm"));
var CreateAccountLabel = styled.a(templateObject_15 || (templateObject_15 = __makeTemplateObject$1(["\n  ", "\n  min-height: 18px;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  white-space: nowrap;\n  text-decoration: none;\n\n"], ["\n  ", "\n  min-height: 18px;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  white-space: nowrap;\n  text-decoration: none;\n\n"])), OpensansBoldFunBlue14px);
var ErrorLabel$1 = styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject$1(["\n   color: var(--error--red);\n  padding: 0 8px;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  font-family: var(--font-family-open_sans);\n"], ["\n   color: var(--error--red);\n  padding: 0 8px;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n  font-family: var(--font-family-open_sans);\n"])));
var InfoIcon = styled(SvgInfoCircle)(templateObject_17 || (templateObject_17 = __makeTemplateObject$1(["\n    height: 16px;\n    margin-right: 4px;\n    path{\n        fill: var(--error--red);\n    }\n"], ["\n    height: 16px;\n    margin-right: 4px;\n    path{\n        fill: var(--error--red);\n    }\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

function mapAdditionalDataToOptionsList(ships) {
  if (!ships) return [];
  return ships.map(function (ship) {
    return {
      value: ship.code,
      label: ship.name
    };
  });
}

var cachedResponse;
function getShips() {
  var opts = {
    method: 'GET',
    headers: new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    })
  };

  if (cachedResponse) {
    return cachedResponse;
  }

  cachedResponse = cclFetch(API_URLS.Ships, opts).then(function (res) {
    return res;
  });
  return cachedResponse;
}

var Spacing = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1([" \n  padding: var(--spacing_token_s) 0  var(--spacing_token_xs);\n"], [" \n  padding: var(--spacing_token_s) 0  var(--spacing_token_xs);\n"])));
var OrDivider = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$1(["\n  ", "\n  min-height: 16px;\n  min-width: 61px;\n  letter-spacing: 0;\n  white-space: nowrap;\n  padding: var(--spacing_token_s) 0  var(--spacing_token_xxs);\n"], ["\n  ", "\n  min-height: 16px;\n  min-width: 61px;\n  letter-spacing: 0;\n  white-space: nowrap;\n  padding: var(--spacing_token_s) 0  var(--spacing_token_xxs);\n"])), OpensansNormalTundora16px);
styled.select(templateObject_3 || (templateObject_3 = __makeTemplateObject$1([" \n"], [" \n"])));
styled.select(templateObject_4 || (templateObject_4 = __makeTemplateObject$1([" \n"], [" \n"])));
var ErrorLabel = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject$1(["\n    ", "\n"], ["\n    ", "\n"])), Error$1);
var SelectWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject$1(["\nwidth: 100%;\nposition: relative;\n"], ["\nwidth: 100%;\nposition: relative;\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var AdditionalLookupFields = function (props) {
  var _a, _b, _c;

  var resources = (_a = useResourcesContext()) !== null && _a !== void 0 ? _a : {};
  var fieldsLabelsResources = (_b = resources === null || resources === void 0 ? void 0 : resources.FieldsLabels) !== null && _b !== void 0 ? _b : {};
  var errorResources = (_c = resources === null || resources === void 0 ? void 0 : resources.Error) !== null && _c !== void 0 ? _c : {};

  var _d = __read$1(useState$1(null), 2),
      ships = _d[0],
      setShips = _d[1];

  var _e = __read$1(useState$1(null), 2),
      shipsResponseErrorMessage = _e[0],
      setShipsResponseErrorMessage = _e[1];

  useEffect$1(function () {
    var getAdditionalFieldsData = function () {
      return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator$1(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , getShips().then(function (shipsResponse) {
                setShips(shipsResponse.ships);
              }).catch(function () {
                setShipsResponseErrorMessage(errorResources.UnexpectedError);
              })];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    getAdditionalFieldsData();
  }, [errorResources.UnexpectedError]);

  var validateFields = function () {
    if ((props.watch(SHIP_CODE) === '' || props.watch(SHIP_CODE) === undefined) && (props.watch(STATE_RESIDENCE) === '' || props.watch(STATE_RESIDENCE) === undefined)) {
      return errorResources.ShipOrStateOfResidencyRequired;
    }

    props.clearErrors(SHIP_CODE);
    props.clearErrors(STATE_RESIDENCE);
    return true;
  };

  return jsxRuntime$1.exports.jsxs(jsxRuntime$1.exports.Fragment, {
    children: [jsxRuntime$1.exports.jsx(Spacing, {}), jsxRuntime$1.exports.jsx(SelectWrapper, __assign$1({
      "data-testid": 'stateOfResidence'
    }, {
      children: jsxRuntime$1.exports.jsx(Controller, {
        control: props.control,
        name: STATE_RESIDENCE,
        rules: {
          validate: validateFields
        },
        render: function (_a) {
          var _b;

          var field = _a.field;
          return jsxRuntime$1.exports.jsx(StateSelect, {
            ariaLabel: fieldsLabelsResources.StateOfResidencyAriaLabel,
            hasError: props.errors.stateResidence !== undefined,
            onChange: function (stateResidence) {
              return field.onChange(stateResidence);
            },
            value: field.value,
            errorMessageLabel: errorResources.UnexpectedError,
            errorMsg: "Error: ".concat((_b = props.errors.stateResidence) === null || _b === void 0 ? void 0 : _b.message),
            ref: props.stateOfResidenceRef,
            errorTestId: "StateOfResidencyErrorMessage",
            placeHolderLabel: fieldsLabelsResources.StateOfResidency
          });
        }
      })
    })), jsxRuntime$1.exports.jsx(OrDivider, {
      children: fieldsLabelsResources.OrDividerLabel
    }), jsxRuntime$1.exports.jsx(Spacing, {}), jsxRuntime$1.exports.jsx(SelectWrapper, __assign$1({
      "data-testid": 'shipSailingOn'
    }, {
      children: jsxRuntime$1.exports.jsx(Controller, {
        control: props.control,
        name: SHIP_CODE,
        rules: {
          validate: validateFields
        },
        render: function (_a) {
          var _b;

          var field = _a.field;
          return jsxRuntime$1.exports.jsx(Select, {
            id: "shipSelect",
            testId: "shipSelect",
            ariaLabel: fieldsLabelsResources.ShipAriaLabel,
            hasError: props.errors.shipCode !== undefined,
            optionsList: mapAdditionalDataToOptionsList(ships),
            onChange: function (e) {
              return field.onChange(e.target.value);
            },
            value: field.value,
            placeHolderLabel: fieldsLabelsResources.ShipPlaceholder,
            disabled: ships === null,
            errorMsg: "Error: ".concat((_b = props.errors.shipCode) === null || _b === void 0 ? void 0 : _b.message),
            errorTestId: "ShipErrorMessage"
          });
        }
      })
    })), shipsResponseErrorMessage && jsxRuntime$1.exports.jsxs(ErrorLabel, __assign$1({
      role: "alert",
      "data-testid": 'ShipApiErrorMessage'
    }, {
      children: ["Error: ", errorResources.UnexpectedError]
    }))]
  });
};

var ForgotVifpForm = function (props) {
  var _a, _b, _c, _d;

  var resources = (_a = useResourcesContext()) !== null && _a !== void 0 ? _a : {};
  var fieldsLabelsResources = (_b = resources === null || resources === void 0 ? void 0 : resources.FieldsLabels) !== null && _b !== void 0 ? _b : {};
  var formResources = (_c = resources === null || resources === void 0 ? void 0 : resources.Form) !== null && _c !== void 0 ? _c : {};
  var errorResources = (_d = resources === null || resources === void 0 ? void 0 : resources.Error) !== null && _d !== void 0 ? _d : {};
  var multipleMatcheMessage = errorResources.MultipleMatches;
  var notFoundMessage = errorResources.NotFound;

  var _e = __read$1(useState$1(false), 2),
      showAdditionalFields = _e[0],
      setShowAdditionalFields = _e[1];

  var _f = __read$1(useState$1(null), 2),
      errorMessage = _f[0],
      setErrorMessage = _f[1];

  var _g = useForm(),
      handleSubmit = _g.handleSubmit,
      watch = _g.watch,
      clearErrors = _g.clearErrors,
      control = _g.control,
      errors = _g.formState.errors;

  var yearReceived = watch(DOB_YEAR);
  var monthReceived = watch(DOB_MONTH);

  var _h = useProfile(),
      user = _h.user,
      authenticated = _h.authenticated;

  var showCreateAccountOption = props.showCreateAccountOption && (!user || !authenticated);
  var yearRef = useRef(null);
  var monthRef = useRef(null);
  var dayRef = useRef(null);
  var stateOfResidenceRef = useRef(null);

  var focusFirstDateFieldWithError = function () {
    var _a, _b, _c, _d, _e, _f;

    if (errors.firstName) {
      (_a = document.getElementById('firstNameInput')) === null || _a === void 0 ? void 0 : _a.focus();
      return;
    }

    if (errors.lastName) {
      (_b = document.getElementById('lastNameInput')) === null || _b === void 0 ? void 0 : _b.focus();
      return;
    }

    if (errors.dobMonth) {
      (_c = monthRef.current) === null || _c === void 0 ? void 0 : _c.focus();
    } else if (errors.dobDay) {
      (_d = dayRef.current) === null || _d === void 0 ? void 0 : _d.focus();
    } else if (errors.dobYear) {
      (_e = yearRef.current) === null || _e === void 0 ? void 0 : _e.focus();
    } else if (errors.stateResidence || errors.shipCode) {
      (_f = stateOfResidenceRef.current) === null || _f === void 0 ? void 0 : _f.focus();
    }
  };

  useEffect$1(function () {
    focusFirstDateFieldWithError(); // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [errors]);

  function onSignUpLinkClick(e) {
    e.preventDefault();
    props.onClose();
    initAndOpenLoginSignUpModal("/register");
  }

  var searchLoyaltyNumber = function (guestPastNumberDTO) {
    var onVifpNumberFound = function (loyaltyNumber) {
      if (props.onVifpNumberFound) {
        props.onVifpNumberFound(loyaltyNumber);
        props.onClose();
      }
    };

    getLoyaltyNumber(guestPastNumberDTO).then(function (res) {
      if (res.result === FOUNDMULTIPLE) {
        setShowAdditionalFields(true);
        setErrorMessage(multipleMatcheMessage);
      } else if (res.result === NOTFOUND) {
        setErrorMessage(notFoundMessage);
      } else if (res.result === FOUND && res.loyaltyNumber) {
        setErrorMessage(null);
        onVifpNumberFound(res.loyaltyNumber);
      }
    }).catch(function () {
      setErrorMessage(errorResources.UnexpectedError);
    });
  };

  var onSubmit = function (data) {
    return searchLoyaltyNumber(data);
  };

  var notEmpty = function (fieldError) {
    return fieldError !== undefined;
  };

  var onError = function () {
    focusFirstDateFieldWithError();
  };

  return jsxRuntime$1.exports.jsxs(FormWrapper, __assign$1({
    "$showOnLegacyApps": props.showOnLegacyApps,
    "data-testid": 'vifpForm'
  }, {
    children: [jsxRuntime$1.exports.jsxs("form", __assign$1({
      onSubmit: handleSubmit(onSubmit, onError)
    }, {
      children: [jsxRuntime$1.exports.jsx(Description, {
        children: formResources.Heading
      }), jsxRuntime$1.exports.jsx(Spacing$1, {}), jsxRuntime$1.exports.jsx(Controller, {
        control: control,
        name: "firstName",
        rules: {
          required: errorResources.FirtNameRequired,
          pattern: {
            value: /^[a-zA-Z\-' ]+$/,
            message: errorResources.NamePatternInvalid
          }
        },
        render: function (_a) {
          var field = _a.field;
          return jsxRuntime$1.exports.jsx(CarnivalInput, {
            label: "First Name",
            type: "text",
            testId: "firstName",
            invalid: !!errors.firstName,
            placeholder: fieldsLabelsResources.NamePlaceholder,
            value: field.value,
            onChange: field.onChange,
            onBlur: field.onBlur,
            errorMsg: errors.firstName ? errors.firstName.message : "",
            errorTestId: 'firstNameErrorMessage',
            name: 'firstName',
            id: 'firstNameInput'
          });
        }
      }), jsxRuntime$1.exports.jsx(Spacing$1, {}), jsxRuntime$1.exports.jsx(Controller, {
        control: control,
        name: "lastName",
        rules: {
          required: errorResources.LastNameRequired,
          pattern: {
            value: /^[a-zA-Z\-' ]+$/,
            message: errorResources.NamePatternInvalid
          }
        },
        render: function (_a) {
          var field = _a.field;
          return jsxRuntime$1.exports.jsx(CarnivalInput, {
            label: "Last Name",
            type: "text",
            testId: "lastName",
            invalid: !!errors.lastName,
            placeholder: fieldsLabelsResources.LastNamePlaceholder,
            value: field.value,
            onChange: field.onChange,
            onBlur: field.onBlur,
            errorMsg: errors.lastName && errors.lastName.message,
            errorTestId: 'lastNameErrorMessage',
            name: 'lastName',
            id: 'lastNameInput'
          });
        }
      }), jsxRuntime$1.exports.jsx(Spacing$1, {}), jsxRuntime$1.exports.jsxs(DateOfBirth, {
        children: [jsxRuntime$1.exports.jsx(MonthField, __assign$1({
          "aria-label": fieldsLabelsResources.MonthAriaLabel,
          "data-testid": 'monthPicker'
        }, {
          children: jsxRuntime$1.exports.jsx(Controller, {
            control: control,
            name: DOB_MONTH,
            rules: {
              required: true
            },
            render: function (_a) {
              var field = _a.field;
              return jsxRuntime$1.exports.jsx(MonthSelect, {
                onChange: function (month) {
                  return field.onChange(month);
                },
                year: yearReceived,
                hasError: notEmpty(errors.dobMonth),
                placeHolderLabel: fieldsLabelsResources.Month,
                ariaLabel: errorResources.MonthRequired,
                testId: 'monthSelect',
                useNonZeroIndexMonthValues: true,
                ref: monthRef,
                hideErrorMessage: true
              });
            }
          })
        })), jsxRuntime$1.exports.jsx(DayField, __assign$1({
          "aria-label": fieldsLabelsResources.DayAriaLabel,
          "data-testid": 'dayPicker'
        }, {
          children: jsxRuntime$1.exports.jsx(Controller, {
            control: control,
            name: DOB_DAY,
            rules: {
              required: true
            },
            render: function (_a) {
              var field = _a.field;
              return jsxRuntime$1.exports.jsx(DaySelect, {
                onChange: function (day) {
                  return field.onChange(day);
                },
                year: yearReceived,
                month: monthReceived,
                hasError: notEmpty(errors.dobDay),
                placeHolderLabel: fieldsLabelsResources.Day,
                ariaLabel: errorResources.DayRequired,
                testId: 'daySelect',
                usingNonZeroIndexMonthValues: true,
                ref: dayRef,
                hideErrorMessage: true
              });
            }
          })
        })), jsxRuntime$1.exports.jsx(YearField, __assign$1({
          "aria-label": fieldsLabelsResources.YearAriaLabel,
          "data-testid": 'yearPicker'
        }, {
          children: jsxRuntime$1.exports.jsx(Controller, {
            control: control,
            name: DOB_YEAR,
            rules: {
              required: true
            },
            render: function (_a) {
              var field = _a.field;
              return jsxRuntime$1.exports.jsx(YearSelect, {
                onChange: function (year) {
                  return field.onChange(year);
                },
                start: new Date().getUTCFullYear() - 100,
                reverse: true,
                hasError: notEmpty(errors.dobYear),
                placeHolderLabel: fieldsLabelsResources.Year,
                ariaLabel: errorResources.YearRequired,
                testId: 'yearSelect',
                ref: yearRef,
                hideErrorMessage: true
              });
            }
          })
        }))]
      }), (errors.dobDay || errors.dobYear || errors.dobMonth) && jsxRuntime$1.exports.jsxs(ErrorLabel$1, __assign$1({
        role: "alert",
        "data-testid": 'dboErrorMessage'
      }, {
        children: [jsxRuntime$1.exports.jsx(InfoIcon, {
          "aria-hidden": "true"
        }), errorResources.DateRequired]
      })), errorMessage && jsxRuntime$1.exports.jsx(ForgotVifpError, {
        errorMessage: errorMessage
      }), showAdditionalFields && jsxRuntime$1.exports.jsx(AdditionalLookupFields, {
        stateOfResidenceRef: stateOfResidenceRef,
        errors: errors,
        watch: watch,
        clearErrors: clearErrors,
        control: control
      }), jsxRuntime$1.exports.jsx(Button, __assign$1({
        "data-testid": 'searchButton',
        type: "submit"
      }, {
        children: jsxRuntime$1.exports.jsx(Title, __assign$1({
          className: "title"
        }, {
          children: formResources.Button
        }))
      }))]
    })), showCreateAccountOption && jsxRuntime$1.exports.jsxs(CreateAccount, {
      children: [jsxRuntime$1.exports.jsx(FinePrint, {
        children: formResources.Join
      }), jsxRuntime$1.exports.jsx(CreateAccountLabel, __assign$1({
        "data-testid": "createAccountLink",
        "aria-label": formResources.CreateAccount,
        href: "/profilemanagement/accounts/register",
        onClick: onSignUpLinkClick
      }, {
        children: formResources.CreateAccount
      }))]
    })]
  }));
};

var HorizontalDividerLight = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject$1(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject$1(["\n  width: 100%;\n  padding: var(--spacing_token_m) 0 0;\n  \n  ", " {\n    padding: var(--spacing_token_m) 56px 0;\n  }\n"], ["\n  width: 100%;\n  padding: var(--spacing_token_m) 0 0;\n  \n  ", " {\n    padding: var(--spacing_token_m) 56px 0;\n  }\n"])), styledBreakpoints.up("xl"));
var templateObject_1, templateObject_2;

var ForgotVifpModalContent = function (props) {
  var _a, _b;

  var resources = (_a = useResourcesContext()) !== null && _a !== void 0 ? _a : {};
  var modalResources = (_b = resources === null || resources === void 0 ? void 0 : resources.Modal) !== null && _b !== void 0 ? _b : {};
  var bp = useBreakpoints();
  var otherContents = document.querySelectorAll('body > *:not(.ReactModalPortal)');

  var onAfterOpen = function () {
    document.body.style.overflow = 'hidden';
    otherContents.forEach(function (element) {
      return element.setAttribute('aria-hidden', 'true');
    });
  };

  var onAfterClose = function () {
    document.body.style.overflow = 'unset';
    otherContents.forEach(function (element) {
      return element.setAttribute('aria-hidden', 'false');
    });
  };

  var customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.66)",
      zIndex: 10000,
      position: 'fixed',
      width: 'auto',
      display: 'grid',
      gridTemplateColumns: bp.isMobile ? 'repeat(4,1fr)' : bp.isTablet ? 'repeat(8,1fr)' : bp.isXXl ? '1fr repeat(12, 88px) 1fr' : 'repeat(12,1fr)',
      gridColumnGap: '24px',
      margin: 'auto',
      padding: bp.isMobile ? '0 var(--spacing_token_s)' : '0',
      overflow: 'scroll'
    },
    content: {
      inset: bp.isXs || bp.isSm ? '48px 0 auto' : '100px 0 auto',
      height: 'fit-content',
      padding: bp.isMobile ? 'var(--spacing_token_m)' : 'var(--spacing_token_2xl)',
      boxShadow: '0px 0px 6px #0000002e',
      border: 'none',
      position: 'relative',
      gridColumnStart: bp.isXXl ? '5' : bp.isDesktop ? "4" : bp.isMobile ? "1" : bp.isSm ? "2" : "3",
      gridColumnEnd: bp.isMobile || bp.isMd ? "span 4" : "span 6"
    }
  };
  return jsxRuntime$1.exports.jsxs(SharedModal, __assign$1({
    modalIsOpen: props.isOpen,
    onClose: props.onClose,
    heading: modalResources.Heading,
    closeAriaLabel: modalResources.CloseAriaLabel,
    customStyles: customStyles,
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    testId: props.testId,
    isDefaultModal: true
  }, {
    children: [jsxRuntime$1.exports.jsx(HorizontalDividerLight, {}), jsxRuntime$1.exports.jsx(ForgotVifpForm, {
      showOnLegacyApps: props.showOnLegacyApps,
      onClose: props.onClose,
      onVifpNumberFound: props.onVifpNumberFound,
      showCreateAccountOption: props.showCreateAccountOption
    })]
  }));
};

var ForgotVifpModal = function (props) {
  var _a;

  return jsxRuntime$1.exports.jsx(ResourcesProvider, {
    children: jsxRuntime$1.exports.jsx(ForgotVifpModalContent, {
      isOpen: props.isOpen,
      testId: props.testId,
      onClose: props.onClose,
      onVifpNumberFound: props.onVifpNumberFound,
      showCreateAccountOption: (_a = props.showCreateAccountOption) !== null && _a !== void 0 ? _a : true,
      showOnLegacyApps: props.showOnLegacyApps
    })
  });
};

export { ForgotVifpModal, ResourcesProvider, useResourcesContext };
//# sourceMappingURL=index.js.map
